/* eslint:disable */
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  EmailAddress: { input: any; output: any; }
  EntityNLU: { input: any; output: any; }
  HandlerResponseConditions: { input: any; output: any; }
  IntOrBoolean: { input: any; output: any; }
  IntOrString: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Long: { input: any; output: any; }
  PathConditions: { input: any; output: any; }
  StringMap: { input: any; output: any; }
  URL: { input: any; output: any; }
  URLString: { input: any; output: any; }
  XAPPLead_String_maxLength_150_format_email: { input: any; output: any; }
  awsEventBusArn_String_maxLength_200_pattern_arnawsusgovcneventsaz0909eventbus: { input: any; output: any; }
  bottomRightLat_Float_NotNull_min_dot90_max_90: { input: any; output: any; }
  bottomRightLon_Float_NotNull_min_dot180_max_180: { input: any; output: any; }
  businessDescription_String_maxLength_4000: { input: any; output: any; }
  contactName_String_maxLength_150: { input: any; output: any; }
  contactPhone_String_maxLength_50: { input: any; output: any; }
  contact_String_maxLength_150_format_email: { input: any; output: any; }
  contractDate_String_format_ISO8601: { input: any; output: any; }
  description_String_maxLength_4000: { input: any; output: any; }
  keywords_List_String_NotNull_maxLength_50: { input: any; output: any; }
  name_String_NotNull_maxLength_150: { input: any; output: any; }
  notes_String_maxLength_4000: { input: any; output: any; }
  settlingTimeSeconds_Int_max_5_exclusiveMin_0: { input: any; output: any; }
  templateType_String_maxLength_50: { input: any; output: any; }
  time_String_NotNull_format_date: { input: any; output: any; }
  topLeftLat_Float_NotNull_min_dot90_max_90: { input: any; output: any; }
  topLeftLon_Float_NotNull_min_dot180_max_180: { input: any; output: any; }
};

export type AwsPaymentAccount = {
  /** The usage for the given AWS subscription during the current pay period. */
  currentUsage: OrgUsageStats;
  /** The customerId of the customer that linked the account. */
  customerId?: Maybe<Scalars['String']['output']>;
  /** The date in which the subscription was placed. */
  date?: Maybe<Scalars['String']['output']>;
  /** The product within the product of the subscription. */
  dimension?: Maybe<Scalars['String']['output']>;
  /** The product code of the aws product that is linked to the org. */
  productCode?: Maybe<Scalars['String']['output']>;
};

/** Union of all ActionBar button types */
export type ActionBarButton = ActionBarChatButton | ActionBarEmailButton | ActionBarFormButton | ActionBarHelpButton | ActionBarPaymentButton | ActionBarPhoneButton | ActionBarScheduleButton | ActionBarUrlButton;

/** Base ActionBar button interface */
export type ActionBarButtonBase = {
  /** Icon override */
  icon?: Maybe<ActionBarIconType>;
  /** Custom icon URL */
  iconUrl?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the button */
  id: Scalars['String']['output'];
  /** Button label text */
  label?: Maybe<Scalars['String']['output']>;
  /** Tab index for accessibility */
  tabIndex?: Maybe<Scalars['Int']['output']>;
  /** Button type */
  type: ActionBarButtonType;
  /** Visibility setting */
  visibility?: Maybe<ActionBarButtonVisibility>;
};

/** ActionBar button input - supports all button types */
export type ActionBarButtonInput = {
  /** Enable auto-greeting (for form/schedule buttons) */
  autoGreeting?: InputMaybe<Scalars['Boolean']['input']>;
  /** Email body (for email buttons) */
  body?: InputMaybe<Scalars['String']['input']>;
  /** Email address (required for email buttons) */
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  /** Form configuration (for form/schedule buttons) */
  formConfig?: InputMaybe<ActionBarFormConfigInput>;
  /** Icon override */
  icon?: InputMaybe<ActionBarIconType>;
  /** Custom icon URL */
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier for the button */
  id: Scalars['String']['input'];
  /** Handler intent ID (for form/schedule buttons) */
  intentId?: InputMaybe<Scalars['String']['input']>;
  /** Button label text */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Phone number (required for phone buttons) */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Preselect chip label (for form/schedule buttons) */
  preselectChipLabel?: InputMaybe<Scalars['String']['input']>;
  /** Email subject (for email buttons) */
  subject?: InputMaybe<Scalars['String']['input']>;
  /** Tab index for accessibility */
  tabIndex?: InputMaybe<Scalars['Int']['input']>;
  /** How to open the URL (for url/help/payment buttons) */
  target?: InputMaybe<ActionBarButtonTarget>;
  /** Button type */
  type: ActionBarButtonType;
  /** URL (required for url/help/payment buttons) */
  url?: InputMaybe<Scalars['String']['input']>;
  /** Visibility setting */
  visibility?: InputMaybe<ActionBarButtonVisibility>;
  /** Window options (for url buttons with newWindow target) */
  windowOptions?: InputMaybe<ActionBarWindowOptionsInput>;
};

/** Target options for URL-based buttons */
export enum ActionBarButtonTarget {
  NewTab = 'newTab',
  NewWindow = 'newWindow',
  SameWindow = 'sameWindow'
}

/** ActionBar button types */
export enum ActionBarButtonType {
  Chat = 'chat',
  Email = 'email',
  Form = 'form',
  Help = 'help',
  Payment = 'payment',
  Phone = 'phone',
  Schedule = 'schedule',
  Url = 'url'
}

/** Visibility options for ActionBar buttons */
export enum ActionBarButtonVisibility {
  All = 'all',
  DesktopOnly = 'desktop_only',
  MobileOnly = 'mobile_only'
}

/** Chat button - toggles chat widget */
export type ActionBarChatButton = ActionBarButtonBase & {
  icon?: Maybe<ActionBarIconType>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  tabIndex?: Maybe<Scalars['Int']['output']>;
  type: ActionBarButtonType;
  visibility?: Maybe<ActionBarButtonVisibility>;
};

/** ActionBar configuration for the chat widget */
export type ActionBarConfig = {
  /** List of action buttons */
  buttons: Array<ActionBarButton>;
  /** Whether the ActionBar is enabled */
  enabled: Scalars['Boolean']['output'];
  /** Mobile breakpoint in pixels */
  mobileBreakpoint?: Maybe<Scalars['Int']['output']>;
  /** Position of the ActionBar */
  position?: Maybe<ActionBarPosition>;
};

/** ActionBar configuration input */
export type ActionBarConfigInput = {
  buttons: Array<ActionBarButtonInput>;
  enabled: Scalars['Boolean']['input'];
  mobileBreakpoint?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<ActionBarPosition>;
};

/** Email button - click-to-email */
export type ActionBarEmailButton = ActionBarButtonBase & {
  /** Email body */
  body?: Maybe<Scalars['String']['output']>;
  /** Email address (required) */
  emailAddress: Scalars['String']['output'];
  icon?: Maybe<ActionBarIconType>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  /** Email subject */
  subject?: Maybe<Scalars['String']['output']>;
  tabIndex?: Maybe<Scalars['Int']['output']>;
  type: ActionBarButtonType;
  visibility?: Maybe<ActionBarButtonVisibility>;
};

/** Form button - opens form widget */
export type ActionBarFormButton = ActionBarButtonBase & {
  /** Enable auto-greeting */
  autoGreeting?: Maybe<Scalars['Boolean']['output']>;
  /** Form configuration */
  formConfig?: Maybe<ActionBarFormConfig>;
  icon?: Maybe<ActionBarIconType>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Handler intent ID */
  intentId?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  /** Preselect chip label */
  preselectChipLabel?: Maybe<Scalars['String']['output']>;
  tabIndex?: Maybe<Scalars['Int']['output']>;
  type: ActionBarButtonType;
  visibility?: Maybe<ActionBarButtonVisibility>;
};

/** Form configuration for form/schedule buttons */
export type ActionBarFormConfig = {
  /** Enable auto-greeting */
  autoGreeting?: Maybe<Scalars['Boolean']['output']>;
  /** Form handler intent ID */
  intentId?: Maybe<Scalars['String']['output']>;
  /** Preselect chip label */
  preselectChipLabel?: Maybe<Scalars['String']['output']>;
};

/** ActionBar form configuration input */
export type ActionBarFormConfigInput = {
  autoGreeting?: InputMaybe<Scalars['Boolean']['input']>;
  intentId?: InputMaybe<Scalars['String']['input']>;
  preselectChipLabel?: InputMaybe<Scalars['String']['input']>;
};

/** Help button - links to help documentation */
export type ActionBarHelpButton = ActionBarButtonBase & {
  icon?: Maybe<ActionBarIconType>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  tabIndex?: Maybe<Scalars['Int']['output']>;
  /** How to open the URL */
  target?: Maybe<ActionBarButtonTarget>;
  type: ActionBarButtonType;
  /** Help URL (required) */
  url: Scalars['String']['output'];
  visibility?: Maybe<ActionBarButtonVisibility>;
};

/** Icon types for ActionBar buttons */
export enum ActionBarIconType {
  Calendar = 'calendar',
  Chat = 'chat',
  Custom = 'custom',
  Email = 'email',
  Help = 'help',
  Link = 'link',
  Payment = 'payment',
  Phone = 'phone'
}

/** Payment button - links to payment page */
export type ActionBarPaymentButton = ActionBarButtonBase & {
  icon?: Maybe<ActionBarIconType>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  tabIndex?: Maybe<Scalars['Int']['output']>;
  /** How to open the URL */
  target?: Maybe<ActionBarButtonTarget>;
  type: ActionBarButtonType;
  /** Payment URL (required) */
  url: Scalars['String']['output'];
  visibility?: Maybe<ActionBarButtonVisibility>;
};

/** Phone button - click-to-call */
export type ActionBarPhoneButton = ActionBarButtonBase & {
  icon?: Maybe<ActionBarIconType>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  /** Phone number (required) */
  phoneNumber: Scalars['String']['output'];
  tabIndex?: Maybe<Scalars['Int']['output']>;
  type: ActionBarButtonType;
  visibility?: Maybe<ActionBarButtonVisibility>;
};

/** Position options for the ActionBar */
export enum ActionBarPosition {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}

/** Schedule button - books appointments */
export type ActionBarScheduleButton = ActionBarButtonBase & {
  /** Enable auto-greeting */
  autoGreeting?: Maybe<Scalars['Boolean']['output']>;
  /** Form configuration */
  formConfig?: Maybe<ActionBarFormConfig>;
  icon?: Maybe<ActionBarIconType>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Handler intent ID */
  intentId?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  /** Preselect chip label */
  preselectChipLabel?: Maybe<Scalars['String']['output']>;
  tabIndex?: Maybe<Scalars['Int']['output']>;
  type: ActionBarButtonType;
  visibility?: Maybe<ActionBarButtonVisibility>;
};

/** URL button - navigates to URL */
export type ActionBarUrlButton = ActionBarButtonBase & {
  icon?: Maybe<ActionBarIconType>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  tabIndex?: Maybe<Scalars['Int']['output']>;
  /** How to open the URL */
  target?: Maybe<ActionBarButtonTarget>;
  type: ActionBarButtonType;
  /** URL to navigate to (required) */
  url: Scalars['String']['output'];
  visibility?: Maybe<ActionBarButtonVisibility>;
  /** Window options for newWindow target */
  windowOptions?: Maybe<ActionBarWindowOptions>;
};

/** Window options for new window target */
export type ActionBarWindowOptions = {
  height?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

/** ActionBar window options input */
export type ActionBarWindowOptionsInput = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * ActionsOnGoogleChanelData objects only.
 *
 * Required publishing information questions.
 */
export type ActionsOnGoogleAdditionalInformationQuestions = {
  /**
   * Do your Actions contain alcohol or tobacco-related content?
   *
   * If yes, you must include age veriifcation at the beginning of the conversation.
   * If your Actions mainly sell alcohol or tobacco, you must implement
   * account linking and verify that the user meets legal age requirements.
   */
  alcoholAndTobaccoRelatedContent?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Are childer under the age of 13 one of the intended audienced of your actions?
   *
   * If yes, you must join the Actions for Families program. The Actions for Families
   * program allows develpers to dsignate that their Actions are family-friendly, so parents and kids
   * cand find trusted, high-quality content more easily on teh Google Assistant.
   */
  intendedForUnderThirteen?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * ActionsOnGoogleChanelData objects only.
 *
 * Required publishing information questions.
 */
export type ActionsOnGoogleAdditionalInformationQuestionsInput = {
  /**
   * Do your Actions contain alcohol or tobacco-related content?
   *
   * If yes, you must include age veriifcation at the beginning of the conversation.
   * If your Actions mainly sell alcohol or tobacco, you must implement
   * account linking and verify that the user meets legal age requirements.
   */
  alcoholAndTobaccoRelatedContent?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Are childer under the age of 13 one of the intended audienced of your actions?
   *
   * If yes, you must join the Actions for Families program. The Actions for Families
   * program allows develpers to dsignate that their Actions are family-friendly, so parents and kids
   * cand find trusted, high-quality content more easily on teh Google Assistant.
   */
  intendedForUnderThirteen?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A channel that is specific for apps to run on the Actions On Google. */
export type ActionsOnGoogleAppChannel = BaseAppChannel & {
  /**
   * For "actions-on-google" type channels only.
   *
   * @deprecated: Actions-on-google is no longer supported at all.  It is gone.
   */
  additionalInformationQuestions?: Maybe<ActionsOnGoogleAdditionalInformationQuestions>;
  /** Deprecated: DO NOT USE. IT WILL BE REMOVED */
  credentialsURL?: Maybe<Scalars['String']['output']>;
  /** URL for the directory listing. */
  directoryListing?: Maybe<Scalars['String']['output']>;
  /** URI where the channel can be accessed. */
  endPoint?: Maybe<Scalars['String']['output']>;
  /** Whether or not the credentials for the channel has been uploaded. */
  hasCredentials: Scalars['Boolean']['output'];
  /** The ID of the channel. */
  id: Scalars['String']['output'];
  /** The display name for the channel. */
  name?: Maybe<Scalars['String']['output']>;
  /** The ID of the project on Google */
  projectId: Scalars['ID']['output'];
  /** The lifecycle status of the app. */
  status?: Maybe<AppChannelStatus>;
  /** The type of channel */
  type: Scalars['String']['output'];
  /** Retrieves any events that are related to this specific app */
  usageEvents?: Maybe<TotalUsageEvents>;
  /**
   * ID of the NLU to use within app.nlu[].
   *
   * If it exists, the channel will use the provided NLU at runtime
   * to convert the raw text to an Intent
   *
   * If the value is "*", then it will pick the first available NLU within app.nlu[]
   */
  useNLU?: Maybe<Scalars['String']['output']>;
};


/** A channel that is specific for apps to run on the Actions On Google. */
export type ActionsOnGoogleAppChannelUsageEventsArgs = {
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type ActionsOnGoogleAppChannelInput = {
  /**
   * For "actions-on-google" type channels only.
   *
   * @deprecated: Actions-on-google is no longer supported at all.  It is gone.
   */
  additionalInformationQuestions?: InputMaybe<ActionsOnGoogleAdditionalInformationQuestionsInput>;
  /** URL for the directory listing. */
  directoryListing?: InputMaybe<Scalars['String']['input']>;
  /** URI where the channel can be accessed. */
  endPoint?: InputMaybe<Scalars['String']['input']>;
  /**
   * The ID of the channel.
   *
   * When calling a "CreateChannel" function, then ID will be
   * used to determine if the channel shoudl be inserted or updated.
   *
   * If the ID is provided and already exists, the channel will be
   * updated.  Otherwise the channel will be inserted and an ID will be
   * generated.
   */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The display name for the channel. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The type of channel */
  type: Scalars['String']['input'];
  /**
   * ID of the NLU to use within app.nlu[].
   *
   * If it exists, the channel will use the provided NLU at runtime
   * to convert the raw text to an Intent
   *
   * If the value is "*", then it will pick the first available NLU within app.nlu[]
   */
  useNLU?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Credentials that are provided by Google which will allow Stentor to
 * call the Actions On Google resources on the client's behalf.
 */
export type ActionsOnGoogleCredentials = {
  auth_provider_x509_cert_url?: InputMaybe<Scalars['String']['input']>;
  auth_uri?: InputMaybe<Scalars['String']['input']>;
  client_email: Scalars['String']['input'];
  client_id?: InputMaybe<Scalars['String']['input']>;
  client_x509_cert_url?: InputMaybe<Scalars['String']['input']>;
  private_key: Scalars['String']['input'];
  private_key_id?: InputMaybe<Scalars['String']['input']>;
  project_id: Scalars['String']['input'];
  token_uri?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ActiveWithinHandlerResponseSegment = HandlerResponseSegment & {
  activeWithin: HandlerResponseDuration;
  segment: ResponseOutput;
};

export type AddEntityInput = {
  appId: Scalars['ID']['input'];
  dialogflowId?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  /**
   * A unique identifier for the entity.  If one is not provided then
   * it will be derived from the display name.
   */
  entityId?: InputMaybe<Scalars['ID']['input']>;
  /** Whether or not to exclude the entity from autocomplete suggestions. */
  excludeFromSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
  nlu?: InputMaybe<Scalars['EntityNLU']['input']>;
  type?: InputMaybe<EntityType>;
  values?: InputMaybe<Array<EntityValueInput>>;
};

export type AddFaq = {
  /** The answer to those questions */
  answer: Scalars['String']['input'];
  /** An ID to a Handler that is associated with the FAQ */
  associatedHandlerId?: InputMaybe<Scalars['ID']['input']>;
  /** Set to true if the FAQ should be excluded from the auto-complete search. */
  excludeFromAutoComplete?: InputMaybe<Scalars['Boolean']['input']>;
  /** An ID linked to an external system in which the FAQ was derived from. */
  externalFAQId?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the FAQ */
  name: Scalars['String']['input'];
  /** Questions that the FAQ handles. */
  questions: Array<InputMaybe<Scalars['String']['input']>>;
  /** The raw text */
  raw?: InputMaybe<Scalars['String']['input']>;
  responses?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** The URL that the FAQ could be found on. */
  url?: InputMaybe<Scalars['URL']['input']>;
};

export type AddForwardReturn = {
  /** An intents graph with the updated graph */
  graph: IntentsGraph;
  /** The updated handler */
  handler: Handler;
};


export type AddForwardReturnGraphArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AddHandlerInput = {
  /**
   * Base content map for the handler.
   *
   * All handlers have contextual help and cancel content
   */
  content?: InputMaybe<Array<InputMaybe<InputHandlerContent>>>;
  /**
   * Contexts the must be active to have this handler be weighted more heavily or selected.
   *
   * For Amazon Lex, the contexts are required to be selected.
   *
   * https://docs.aws.amazon.com/lex/latest/dg/API_PutIntent.html#lex-PutIntent-request-inputContexts
   *
   * For Dialogflow ES, these are more heavily weighted towards matching.
   *
   * https://cloud.google.com/dialogflow/es/docs/contexts-input-output#input_contexts}
   * https://cloud.google.com/dialogflow/es/docs/reference/rest/v2/projects.agent.intents#Intent}
   */
  contexts?: InputMaybe<Array<InputMaybe<IntentContextInput>>>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  /**
   * The locale that all the attributes in this intent are used for before
   * they are overridden.
   */
  defaultLocale?: InputMaybe<Scalars['String']['input']>;
  forward?: InputMaybe<Array<InputMaybe<HandlerForwardInput>>>;
  /** The location that the intent was last saved in Stentor's Handler Graph UI. */
  graphCoords?: InputMaybe<GraphCoordsInput>;
  /** The unique identifier of the intent itself. */
  intentId: Scalars['ID']['input'];
  /** The language code that the intent covers. */
  langCode?: InputMaybe<Scalars['String']['input']>;
  /** The human-readable name of the intent. */
  name: Scalars['String']['input'];
  /** The permissions that the intent requires in order to work. */
  permissions?: InputMaybe<Array<InputMaybe<HandlerPermissions>>>;
  redirect?: InputMaybe<Array<InputMaybe<HandlerRedirectInput>>>;
  /** The slots defined within the utterance patterns and their Entity types. */
  slots?: InputMaybe<Array<InputMaybe<InputSlot>>>;
  /** The type of intent that this is. */
  type?: InputMaybe<Scalars['String']['input']>;
  /**
   * An array of utterance patterns.
   *
   * For more information on syntax see https://github.com/alexa-js/alexa-utterances
   */
  utterancePatterns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AddHandlerReturn = {
  /** The updated graph. */
  graph: IntentsGraph;
  /** The handler that was added with the new attributes. */
  handler: Handler;
};


export type AddHandlerReturnGraphArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AddIntentInput = {
  /**
   * Contexts the must be active to have this intent be weighted more heavily or selected.
   *
   * For Amazon Lex, the contexts are required to be selected.
   *
   * https://docs.aws.amazon.com/lex/latest/dg/API_PutIntent.html#lex-PutIntent-request-inputContexts
   *
   * For Dialogflow ES, these are more heavily weighted towards matching.
   *
   * https://cloud.google.com/dialogflow/es/docs/contexts-input-output#input_contexts}
   * https://cloud.google.com/dialogflow/es/docs/reference/rest/v2/projects.agent.intents#Intent}
   */
  contexts?: InputMaybe<Array<InputMaybe<IntentContextInput>>>;
  /**
   * The locale that all the attributes in this intent are used for before
   * they are overridden.
   */
  defaultLocale?: InputMaybe<Scalars['String']['input']>;
  /** The location that the intent was last saved in Stentor's Handler Graph UI. */
  graphCoords?: InputMaybe<GraphCoordsInput>;
  /** The unique identifier of the intent itself. */
  intentId: Scalars['ID']['input'];
  /** The language code that the intent covers. */
  langCode?: InputMaybe<Scalars['String']['input']>;
  /** The human-readable name of the intent. */
  name: Scalars['String']['input'];
  nlu?: InputMaybe<Scalars['JSON']['input']>;
  /** The permissions that the intent requires in order to work. */
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Slot type definition. */
  slotTypes?: InputMaybe<Scalars['JSON']['input']>;
  /** The slots defined within the utterance patterns and their Entity types. */
  slots?: InputMaybe<Array<InputMaybe<InputSlot>>>;
  /** The type of intent that this is. */
  type?: InputMaybe<Scalars['String']['input']>;
  /**
   * An array of utterance patterns.
   *
   * For more information on syntax see https://github.com/alexa-js/alexa-utterances
   */
  utterancePatterns?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AddIntentReturn = {
  /** The updated graph. */
  graph: IntentsGraph;
  /** The intent that was added with the new attributes. */
  intent: Intent;
};


export type AddIntentReturnGraphArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum AddLocaleEnum {
  /** Danish */
  Da = 'da',
  /** German */
  De = 'de',
  /** German German */
  DeDe = 'deDE',
  /** English */
  En = 'en',
  /** English Australian */
  EnAu = 'enAU',
  /** English Canada */
  EnCa = 'enCA',
  /** English Great Britain */
  EnGb = 'enGB',
  /** English India */
  EnIn = 'enIN',
  /** English United States */
  EnUs = 'enUS',
  /** Spanish */
  Es = 'es',
  /** Spanish: Only supported in Google. */
  Es419 = 'es419',
  /** Spanish Spain */
  EsEs = 'esES',
  /** Spanish Mexico */
  EsMx = 'esMX',
  /** French */
  Fr = 'fr',
  /** French Canada */
  FrCa = 'frCA',
  /** French France */
  FrFr = 'frFR',
  /** Italian */
  It = 'it',
  /** Italian Italy */
  ItIt = 'itIT',
  /** Japanese */
  Ja = 'ja',
  /** Japanese Japan */
  JaJp = 'jaJP',
  /** Dutch */
  Nl = 'nl',
  /** Norwegian */
  No = 'no',
  /** Portuguese */
  Pt = 'pt',
  /** Portuguese Brazil */
  PtBr = 'ptBR',
  /** Russian */
  Ru = 'ru',
  /** Swedish */
  Sv = 'sv',
  /** Thai */
  Th = 'th',
  /** Turkish */
  Tr = 'tr',
  /** Ukranian */
  Uk = 'uk',
  /** Chinese */
  Zh = 'zh',
  /** Chinese China */
  ZhCh = 'zhCH',
  /** Chinese Hong Kong */
  ZhHk = 'zhHK',
  /** Chinese Taiwan */
  ZhTw = 'zhTW'
}

export type AddedFaq = {
  _id: Scalars['ID']['output'];
  answer: Scalars['String']['output'];
  associatedHandlerId?: Maybe<Scalars['String']['output']>;
  created: Scalars['String']['output'];
  excludeFromAutoComplete?: Maybe<Scalars['Boolean']['output']>;
  externalFAQId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  questions: Array<Maybe<Scalars['String']['output']>>;
  raw?: Maybe<Scalars['String']['output']>;
  /** If "wasAdded" was false, this provides the reason that the FAQ was not added. */
  reason?: Maybe<FaqNotAddedReason>;
  responses?: Maybe<Array<Maybe<HandlerResponse>>>;
  url?: Maybe<Scalars['String']['output']>;
  /** A boolean saying whether or not the FAQ was added in this operation. */
  wasAdded: Scalars['Boolean']['output'];
};

export type AdminAwsQuery = {
  /** Returns the AWS region that the graphql server is currently querying from. */
  region: Scalars['String']['output'];
};

export type AdminAppMutation = {
  update: AdminUpdateAppMutation;
};


export type AdminAppMutationUpdateArgs = {
  appId: Scalars['ID']['input'];
};

export enum AdminAppProduct {
  StudioComplete = 'STUDIO_COMPLETE',
  StudioGrowth_2026 = 'STUDIO_GROWTH_2026',
  StudioGrowthServiceTitan_2026 = 'STUDIO_GROWTH_SERVICE_TITAN_2026',
  StudioLeads_2024 = 'STUDIO_LEADS_2024',
  StudioLeadsPlus_2024 = 'STUDIO_LEADS_PLUS_2024',
  StudioMax = 'STUDIO_MAX',
  StudioPro_2026 = 'STUDIO_PRO_2026',
  StudioProServiceTitan_2026 = 'STUDIO_PRO_SERVICE_TITAN_2026',
  StudioScheduler = 'STUDIO_SCHEDULER',
  StudioScheduler_2024 = 'STUDIO_SCHEDULER_2024',
  StudioStarter_2026 = 'STUDIO_STARTER_2026',
  StudioStarterServiceTitan_2026 = 'STUDIO_STARTER_SERVICE_TITAN_2026'
}

/** A single status bucket returned by the admin app status counts query. */
export type AdminAppStatusCount = {
  /** The number of apps currently in this status. */
  count: Scalars['Int']['output'];
  /** The status label, e.g. 'Live', 'Incomplete', 'Archived'. */
  status: Scalars['String']['output'];
};

export type AdminChatSuggestion = {
  answer?: Maybe<Scalars['String']['output']>;
  format: Array<Maybe<AdminChatSuggestionFormat>>;
  suggestion: Scalars['String']['output'];
  truncatedAnswer?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
};

export type AdminChatSuggestionFormat = {
  bold?: Maybe<AdminChatSuggestionFormatBold>;
  inputText?: Maybe<AdminChatSuggestionFormatInputText>;
};

export type AdminChatSuggestionFormatBold = {
  end: Scalars['Int']['output'];
  start: Scalars['Int']['output'];
};

export type AdminChatSuggestionFormatInputText = {
  end: Scalars['Int']['output'];
  slotMatch: Scalars['String']['output'];
  start: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export type AdminChatSuggestionReturn = {
  suggestions: Array<Maybe<AdminChatSuggestion>>;
};

export enum AdminChatSuggestionType {
  Faq = 'FAQ',
  Historical = 'HISTORICAL',
  Intent = 'INTENT'
}

/** A collections query which returns a collection of organizations. */
export type AdminEventsQuery = {
  /** Retrieves a list of events that are associated with the app. */
  events: TotalEvents;
};


/** A collections query which returns a collection of organizations. */
export type AdminEventsQueryEventsArgs = {
  appId?: InputMaybe<Scalars['ID']['input']>;
  byChannel?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  byFlag?: InputMaybe<Array<InputMaybe<RawQueryEventFlag>>>;
  byName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  byPlatform?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  byRequestIntentId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  byTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  byType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  newSessionsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  noFlag?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  rawQueryOnly?: InputMaybe<Scalars['Boolean']['input']>;
  rawQueryOrSlotsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  rawQueryText?: InputMaybe<Scalars['String']['input']>;
  responseOutputText?: InputMaybe<Scalars['String']['input']>;
  responseRepromptText?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdminFaqSuggestionInput = {
  answer: Scalars['String']['input'];
  appId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  suggestion: Scalars['String']['input'];
};

export type AdminLaboratory = {
  chatSuggestions: AdminChatSuggestionReturn;
  /** This will return stats on the documents requested. */
  docsKendra?: Maybe<Scalars['JSON']['output']>;
  /** Return entities that would fill a given search string. */
  entitySearch: EntitiesQuery;
  eventsSearch: AdminTotalEvents;
  /** Returns all results from the KNN test database */
  faqSearch: TotalWebFaq;
  /** Returns all results from the KNN test database */
  knnQuestions: KnnSearchOutput;
  /** This uses KNN to search for related questions. */
  knnSearch: KnnSearchQuery;
  /** This uses KNN to search for suggestions to things. */
  knnSuggSearch: KnnSuggSearchQuery;
  /** Execute the multi intent Prompt */
  multiIntent?: Maybe<Scalars['JSON']['output']>;
  /** This attempts to generate a valid answer based on a question for an app. */
  provideAnswer?: Maybe<Scalars['JSON']['output']>;
  /** This queries the Kendra instance available and returns the results. */
  queryKendra?: Maybe<Scalars['JSON']['output']>;
  /** Returns the response from the KNN Endpoint */
  sagemakerKnn: Scalars['JSON']['output'];
  /** Returns a spellcheck of the given sentence. */
  spellCheck: AdminSpellCheckLabResult;
  /** Query comparison vectors databases. */
  vectorsDatabases: VectorDatabaseQuery;
};


export type AdminLaboratoryChatSuggestionsArgs = {
  appId: Scalars['ID']['input'];
  indexVersion?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  queryText: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<InputMaybe<AdminChatSuggestionType>>>;
};


export type AdminLaboratoryDocsKendraArgs = {
  appId: Scalars['ID']['input'];
};


export type AdminLaboratoryEntitySearchArgs = {
  searchQuery: Scalars['String']['input'];
};


export type AdminLaboratoryEventsSearchArgs = {
  from?: InputMaybe<Scalars['Int']['input']>;
  searchRawQueryAutoComplete?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type AdminLaboratoryFaqSearchArgs = {
  answerAutoComplete?: InputMaybe<Scalars['String']['input']>;
  answerSuggestion?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  questionsAutoComplete?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type AdminLaboratoryKnnQuestionsArgs = {
  from?: InputMaybe<Scalars['Int']['input']>;
  inputVectorSlice?: InputMaybe<Scalars['Int']['input']>;
  outputVectorSlice?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type AdminLaboratoryKnnSearchArgs = {
  inputVectorSlice?: InputMaybe<Scalars['Int']['input']>;
  k?: InputMaybe<Scalars['Int']['input']>;
  outputVectorSlice?: InputMaybe<Scalars['Int']['input']>;
  searchString: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type AdminLaboratoryKnnSuggSearchArgs = {
  appId: Scalars['ID']['input'];
  k?: InputMaybe<Scalars['Int']['input']>;
  minScore?: InputMaybe<Scalars['Float']['input']>;
  searchString: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type AdminLaboratoryMultiIntentArgs = {
  max_tokens?: InputMaybe<Scalars['Int']['input']>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
  text: Scalars['String']['input'];
};


export type AdminLaboratoryProvideAnswerArgs = {
  appId: Scalars['ID']['input'];
  max_tokens?: InputMaybe<Scalars['Int']['input']>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
  text: Scalars['String']['input'];
};


export type AdminLaboratoryQueryKendraArgs = {
  appId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};


export type AdminLaboratorySagemakerKnnArgs = {
  text: Scalars['String']['input'];
};


export type AdminLaboratorySpellCheckArgs = {
  sentence: Scalars['String']['input'];
};

export type AdminLeadMutation = {
  /** Placeholder to indicate lead mutations are available */
  _placeholder?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Resend a lead to an integration. This clears the integration sent status
   * and re-emits the lead-analyzed event to EventBridge, which triggers the
   * LeadListenerEnrichedLambda to send the lead to the specified integration.
   */
  resendToIntegration: ResendToIntegrationResult;
};


export type AdminLeadMutationResendToIntegrationArgs = {
  input: ResendToIntegrationInput;
};

export type AdminMutation = {
  app: AdminAppMutation;
  cleanup: CleanupMutation;
  isAdmin: Scalars['Boolean']['output'];
  laboratory: LabMutation;
  /** Lead-related admin mutations */
  lead: AdminLeadMutation;
  /** Payment-related admin mutations for generating checkout links */
  payments: AdminPaymentMutation;
  webCrawler?: Maybe<WebCrawlerSettings>;
};

export type AdminPaymentMutation = {
  /** Placeholder to indicate payment mutations are available */
  _placeholder?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Generate a Stripe Checkout Session URL for a customer.
   * The URL expires after 24 hours. Supports configurable trial days.
   * The customer's subscription will be linked to the app via client_reference_id.
   */
  generateCheckoutSession: GeneratedPaymentUrl;
  /**
   * Generate a persistent Stripe Payment Link for a customer.
   * The link does not expire. Trial days are locked in server-side.
   * The customer's subscription will be linked to the app via client_reference_id query param.
   */
  generatePaymentLink: GeneratedPaymentUrl;
};


export type AdminPaymentMutationGenerateCheckoutSessionArgs = {
  input: GenerateCheckoutSessionInput;
};


export type AdminPaymentMutationGeneratePaymentLinkArgs = {
  input: GeneratePaymentLinkInput;
};

export type AdminPinconeResultTextResult = {
  appId?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  executionId?: Maybe<Scalars['String']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  s3TextUri?: Maybe<Scalars['String']['output']>;
  s3Uri?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  vectorAlgorithm?: Maybe<Scalars['String']['output']>;
};

export type AdminPineconeResult = {
  processedText: Scalars['String']['output'];
  results: Scalars['JSON']['output'];
  text: Scalars['String']['output'];
  textResults: Scalars['JSON']['output'];
  textVectors: Array<Scalars['Float']['output']>;
  xnlu: AdminXnluResult;
};


export type AdminPineconeResultXnluArgs = {
  appId: Scalars['ID']['input'];
  prodAppId: Scalars['ID']['input'];
};

export type AdminQuery = {
  /**
   * Returns aggregated counts of apps grouped by their current status.
   * Only statuses that have at least one app are included.
   * Requires admin access (enforced by the parent AdminQuery resolver).
   */
  appStatusCounts: Array<AdminAppStatusCount>;
  /** Returns AWS server related stats. */
  aws: AdminAwsQuery;
  events: AdminEventsQuery;
  getLimitations: Scalars['JSON']['output'];
  isAdmin: Scalars['Boolean']['output'];
  laboratory: AdminLaboratory;
  webCrawler?: Maybe<WebCrawlerQuery>;
};


export type AdminQueryGetLimitationsArgs = {
  appId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminSpellCheckLabResult = {
  result: Array<Maybe<AdminSpellCheckResult>>;
};

export type AdminSpellCheckResult = {
  isCorrect?: Maybe<Scalars['Boolean']['output']>;
  suggestions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  word?: Maybe<Scalars['String']['output']>;
};

export type AdminTotalEvents = {
  /** The events that are returned in the current query. */
  events?: Maybe<Array<Maybe<Events>>>;
  /** The total number of events that fit the last query. */
  total: Scalars['Int']['output'];
};

export type AdminUpdateAppMutation = {
  /**
   * Adds the product tier to an app without the user requiring to purchase the tier.
   *
   * This *adds* privileges to the app, it does not remove any existing privileges for paid subscription.
   *
   * You can only have one manual product tier at once.
   *
   * So if a user has paid for a "Leads" tier and you add a "Scheduler" tier, the user will have both "Leads" and "Scheduler" privileges applied
   * too the app.
   *
   * WARNING: The automatic scheduling is currently not implemented as this is currently in the demo stage.
   */
  addAppProduct: App;
  /** Adds a notification that users of the app are capable of seeing. */
  addNotification: SystemNotification;
  /**
   * Refreshes place data from Google Places API while preserving user-controlled fields.
   *
   * This mutation fetches fresh data from Google Places API (name, address, phone, website,
   * opening hours, etc.) and updates the place record. It explicitly preserves:
   * - adminVerified: The verification status is NOT changed
   * - bookingOptOut: The booking opt-out preference is NOT changed
   *
   * Use this to sync place data from Google Business Profile without losing verification status.
   */
  refreshPlaceFromGoogle: App;
  /** Removes all notifications associated with an app. */
  removeAllNotifications: Scalars['String']['output'];
  /**
   * Removes the product tier from the app.
   *
   * This removes any privileges that were added to the app by the product tier.
   */
  removeAppProduct: App;
  /** Removes a notification from the app list */
  removeNotification?: Maybe<Array<Maybe<SystemNotification>>>;
  /** Sets the verified status of a Google PlaceId for the app to the specified value. */
  verifyGooglePlacesId: App;
};


export type AdminUpdateAppMutationAddAppProductArgs = {
  durationInDays?: InputMaybe<Scalars['Int']['input']>;
  indefinite?: InputMaybe<Scalars['Boolean']['input']>;
  product: AdminAppProduct;
};


export type AdminUpdateAppMutationAddNotificationArgs = {
  level?: InputMaybe<SystemNotificationLevel>;
  message: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type AdminUpdateAppMutationRefreshPlaceFromGoogleArgs = {
  placeId: Scalars['ID']['input'];
};


export type AdminUpdateAppMutationRemoveNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type AdminUpdateAppMutationVerifyGooglePlacesIdArgs = {
  googlePlacesId: Scalars['ID']['input'];
  verified: Scalars['Boolean']['input'];
};

export type AdminXnluResult = {
  llmResponse: Scalars['JSON']['output'];
  ragResponse: Scalars['JSON']['output'];
};

/** Real-time alert subscription configuration */
export type AlertSubscription = {
  /** Type of alert */
  alertType: AlertType;
  /** App IDs this subscription applies to */
  appIds: Array<Scalars['ID']['output']>;
  /** Notification channel */
  channel: NotificationChannel;
  /** Whether this subscription is enabled */
  enabled: Scalars['Boolean']['output'];
  /** Optional filters to limit which alerts are received */
  filters?: Maybe<UserNotificationFilters>;
  /** Unique identifier for this subscription */
  subscriptionId: Scalars['ID']['output'];
};

/** Types of real-time alert notifications */
export enum AlertType {
  /** Notification when a chat session starts */
  ChatStarted = 'chatStarted',
  /** Notification for lead alerts (opportunity alerts) */
  LeadAlert = 'leadAlert',
  /** Notification when a new lead is captured */
  LeadCaptured = 'leadCaptured'
}

export type AlexaAppChannel = BaseAppChannel & {
  /**
   * Part of the Alexa Skill Manifest.
   *
   * The category communicates what type of functionality the skill performs.
   */
  category?: Maybe<AlexaSkillCategories>;
  /** URL for the directory listing. */
  directoryListing?: Maybe<Scalars['String']['output']>;
  /**
   * Part of the Alexa Skill Manifest publishing information. When isAvailableWorldwide is
   * false, this must be specified.
   *
   * It is an array of ISO 3166-1 alpha-2 format country strings where the skill can be distributed.
   */
  distributionCountries?: Maybe<Array<Maybe<AlexaDistrubutionCountry>>>;
  /** Part of the Alexa Skill manifest Publishing Information. */
  distributionMode?: Maybe<AlexaDistributionMode>;
  /** URI where the channel can be accessed. */
  endPoint?: Maybe<Scalars['String']['output']>;
  /** Whether or not the credentials for the channel has been uploaded. */
  hasCredentials: Scalars['Boolean']['output'];
  /** The ID of the channel. */
  id: Scalars['String']['output'];
  /**
   * The invocation name for the app.
   *
   * If not provided, the application level invocation name will be used.
   */
  invocationName?: Maybe<Scalars['String']['output']>;
  /**
   * Part of the Alexa Skill manifest publishing information.
   *
   * If true, the skill will be distributed in all countries covered by specified locales.
   */
  isAvailableWorldwide?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not the alexa channel is building on Alexa. */
  isBuilding: Scalars['Boolean']['output'];
  /**
   * If useManifest is true, it will use this manifest instead of generating one based on
   * other data about the assistant application
   */
  manifest?: Maybe<AlexaSkill>;
  /** The display name for the channel. */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * A regex to match against possible intent IDs to determine if they will be processed with the NLU.
   *
   * useNLU and nluSlotName must exist or else this is ignored.
   */
  nluIntentRegex?: Maybe<Scalars['String']['output']>;
  /**
   * Query the text from the NLU. The channel must have valid credentials,
   * projectId, and nlu.
   */
  nluQuery: AlexaNluQuery;
  /** Slot name that will exist on the intent that is matched. */
  nluSlotName?: Maybe<Scalars['String']['output']>;
  /** Part of the Alexa Skill manifest. An array of named permissions that the skill can use. */
  permissions?: Maybe<Array<Maybe<AlexaPermissions>>>;
  /** Part of the Alexa Skill Manifest */
  privacyAndCompliance?: Maybe<AlexaPrivacyAndCompliance>;
  /** The skill ID within Alexa */
  skillId?: Maybe<Scalars['String']['output']>;
  /** The lifecycle status of the app. */
  status?: Maybe<AppChannelStatus>;
  /** The type of channel */
  type: Scalars['String']['output'];
  /** Retrieves any events that are related to this specific app */
  usageEvents?: Maybe<TotalUsageEvents>;
  /**
   * If set to true, it will use the manifest property instead of generating one based
   * on other known data.
   */
  useManifest?: Maybe<Scalars['Boolean']['output']>;
  /**
   * ID of the NLU to use within app.nlu[].
   *
   * If it exists, the channel will use the provided NLU at runtime
   * to convert the raw text to an Intent
   *
   * If the value is "*", then it will pick the first available NLU within app.nlu[]
   */
  useNLU?: Maybe<Scalars['String']['output']>;
  /**
   * The vendor ID of the SMAPI vendor that the app is published to.
   * If this is undefined, the vendor on the organization will be used instead.
   */
  vendorId?: Maybe<Scalars['ID']['output']>;
  vendors?: Maybe<Array<Maybe<SmapiVendor>>>;
};


export type AlexaAppChannelNluQueryArgs = {
  text: Scalars['String']['input'];
};


export type AlexaAppChannelUsageEventsArgs = {
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type AlexaAppChannelInput = {
  /**
   * Part of the Alexa Skill Manifest.
   *
   * The category communicates what type of functionality the skill performs.
   */
  category?: InputMaybe<AlexaSkillCategories>;
  /**
   * URL to find the credentials for accessing SMAPI
   *
   * If you are not authorized to access the URL, then it will be "Saved" to indicate
   * that there are credentials uploaded.
   */
  credentialsURL?: InputMaybe<Scalars['String']['input']>;
  /** URL for the directory listing. */
  directoryListing?: InputMaybe<Scalars['String']['input']>;
  /**
   * Part of the Alexa Skill Manifest publishing information. When isAvailableWorldwide is
   * false, this must be specified.
   *
   * It is an array of ISO 3166-1 alpha-2 format country strings where the skill can be distributed.
   */
  distributionCountries?: InputMaybe<Array<InputMaybe<AlexaDistrubutionCountry>>>;
  /** Part of the Alexa Skill manifest Publishing Information. */
  distributionMode?: InputMaybe<AlexaDistributionMode>;
  /** URI where the channel can be accessed. */
  endPoint?: InputMaybe<Scalars['String']['input']>;
  /**
   * The ID of the channel.
   *
   * When calling a "CreateChannel" function, then ID will be
   * used to determine if the channel shoudl be inserted or updated.
   *
   * If the ID is provided and already exists, the channel will be
   * updated.  Otherwise the channel will be inserted and an ID will be
   * generated.
   */
  id?: InputMaybe<Scalars['String']['input']>;
  /**
   * The invocation name for the app.
   *
   * If not provided, the application level invocation name will be used.
   */
  invocationName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Part of the Alexa Skill manifest publishing information.
   *
   * If true, the skill will be distributed in all countries covered by specified locales.
   */
  isAvailableWorldwide?: InputMaybe<Scalars['Boolean']['input']>;
  manifest?: InputMaybe<AlexaSkillInput>;
  /** The display name for the channel. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * A regex to match against possible intent IDs to determine if they will be processed with the NLU.
   *
   * useNLU and nluSlotName must exist or else this is ignored.
   */
  nluIntentRegex?: InputMaybe<Scalars['String']['input']>;
  /** Slot name that will exist on the intent that is matched. */
  nluSlotName?: InputMaybe<Scalars['String']['input']>;
  /** Part of the Alexa Skill manifest. An array of named permissions that the skill can use. */
  permissions?: InputMaybe<Array<InputMaybe<AlexaPermissionsInput>>>;
  /** Part of the Alexa Skill Manifest */
  privacyAndCompliance?: InputMaybe<AlexaPrivacyAndComplianceInput>;
  /** The skill ID within Alexa */
  skillId?: InputMaybe<Scalars['String']['input']>;
  /** The type of channel */
  type: Scalars['String']['input'];
  /**
   * If set to true, it will use the manifest property instead of generating one based
   * on other known data.
   */
  useManifest?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * ID of the NLU to use within app.nlu[].
   *
   * If it exists, the channel will use the provided NLU at runtime
   * to convert the raw text to an Intent
   *
   * If the value is "*", then it will pick the first available NLU within app.nlu[]
   */
  useNLU?: InputMaybe<Scalars['String']['input']>;
  /**
   * The vendor ID of the SMAPI vendor that the app is published to.
   * If this is undefined, the vendor on the organization will be used instead.
   */
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

export enum AlexaChannelPermissionType {
  AddressCountryAndPostalCode = 'ADDRESS_COUNTRY_AND_POSTAL_CODE',
  AddressFull = 'ADDRESS_FULL',
  EmailRead = 'EMAIL_READ',
  GivenNameRead = 'GIVEN_NAME_READ',
  HouseholdListRead = 'HOUSEHOLD_LIST_READ',
  HouseholdListWrite = 'HOUSEHOLD_LIST_WRITE',
  MobileRead = 'MOBILE_READ',
  NameRead = 'NAME_READ',
  NotificationWrite = 'NOTIFICATION_WRITE',
  RemindersReadWrite = 'REMINDERS_READ_WRITE',
  SkillReadWrite = 'SKILL_READ_WRITE'
}

/** Credentials that the Stentor client can use to call SMAPI actions. */
export type AlexaCredentialsInput = {
  access_token: Scalars['String']['input'];
  expires_at: Scalars['String']['input'];
  expires_in: Scalars['Long']['input'];
  refresh_token: Scalars['String']['input'];
  token_type: Scalars['String']['input'];
};

export enum AlexaDistributionMode {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export enum AlexaDistrubutionCountry {
  Ca = 'CA',
  De = 'DE',
  Gb = 'GB',
  In = 'IN',
  Us = 'US'
}

/** Attributes used for alexa publishing. */
export type AlexaIntegration = {
  /** The location of the credentials needed to upload to alexa. */
  credentialsUrl: Scalars['String']['output'];
};

/** Attributes used for alexa publishing. */
export type AlexaIntegrationInput = {
  /** The location of the credentials needed to upload to alexa. */
  credentialsUrl: Scalars['String']['input'];
};

export type AlexaInteractionModel = {
  languageModel?: Maybe<AlexaLanguageModel>;
};

export type AlexaInteractionModelIntent = {
  name: Scalars['String']['output'];
  samples?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  slots?: Maybe<Array<Maybe<AlexaInteractionModelSlot>>>;
};

export type AlexaInteractionModelSlot = {
  name: Scalars['String']['output'];
  samples?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type: Scalars['String']['output'];
};

export type AlexaInteractionModelSlotType = {
  name: Scalars['String']['output'];
  values: Array<Maybe<AlexaInteractionModelSlotTypeValue>>;
};

export type AlexaInteractionModelSlotTypeValue = {
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<AlexaInteractionModelSlotTypeValueName>;
};

export type AlexaInteractionModelSlotTypeValueName = {
  synonyms: Array<Maybe<Scalars['String']['output']>>;
  value: Scalars['String']['output'];
};

export type AlexaLanguageModel = {
  intents: Array<Maybe<AlexaInteractionModelIntent>>;
  invocationName: Scalars['String']['output'];
  types?: Maybe<Array<Maybe<AlexaInteractionModelSlotType>>>;
};

export type AlexaNluQuery = {
  intentId: Scalars['String']['output'];
  slots?: Maybe<Array<Maybe<NluRequestSlot>>>;
  type: Scalars['String']['output'];
};

export type AlexaPermissions = {
  name?: Maybe<AlexaChannelPermissionType>;
};

export type AlexaPermissionsInput = {
  name?: InputMaybe<AlexaChannelPermissionType>;
};

export type AlexaPlatformData = {
  /**
   * The platform that the data is associated with
   * All Platform data has this. It determines the structure of the remaining data.
   */
  platform: Scalars['String']['output'];
  /** Privacy and compliance data required for Alexa publishing */
  privacyAndCompliance: AlexaPrivacyAndCompliance;
};

export type AlexaPlatformDataInput = {
  /**
   * The platform that the data is associated with
   * All Platform data has this. It determines the structure of the remaining data.
   */
  platform: Scalars['String']['input'];
  /** Part of the Alexa Skill Manifest */
  privacyAndCompliance?: InputMaybe<AlexaPrivacyAndComplianceInput>;
};

/** Data that is required to publish to Alexa. It tells Amazon what the app can do. */
export type AlexaPrivacyAndCompliance = {
  /** Does the app allow purchases? */
  allowsPurchases?: Maybe<Scalars['Boolean']['output']>;
  /** Does the app contain ads? */
  containsAds?: Maybe<Scalars['Boolean']['output']>;
  /** Is the app directed at children? */
  isChildDirected?: Maybe<Scalars['Boolean']['output']>;
  /** Can the skill be imported and exported from the United States and all other countries and regions in which XAPP operates? */
  isExportCompliant?: Maybe<Scalars['Boolean']['output']>;
  /** Does the skill collect personal information? */
  usesPersonalInfo?: Maybe<Scalars['Boolean']['output']>;
};

export type AlexaPrivacyAndComplianceInput = {
  allowsPurchases?: InputMaybe<Scalars['Boolean']['input']>;
  containsAds?: InputMaybe<Scalars['Boolean']['input']>;
  isChildDirected?: InputMaybe<Scalars['Boolean']['input']>;
  isExportCompliant?: InputMaybe<Scalars['Boolean']['input']>;
  usesPersonalInfo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AlexaSkill = {
  manifest: AlexaSkillManifest;
};

export enum AlexaSkillCategories {
  AlarmsAndClocks = 'ALARMS_AND_CLOCKS',
  Astrology = 'ASTROLOGY',
  BusinessAndFinance = 'BUSINESS_AND_FINANCE',
  Calculators = 'CALCULATORS',
  CalendarsAndReminders = 'CALENDARS_AND_REMINDERS',
  ChildrensEducationAndReference = 'CHILDRENS_EDUCATION_AND_REFERENCE',
  ChildrensGames = 'CHILDRENS_GAMES',
  ChildrensMusticAndAudio = 'CHILDRENS_MUSTIC_AND_AUDIO',
  ChildrensNoveltyAndHumor = 'CHILDRENS_NOVELTY_AND_HUMOR',
  Communication = 'COMMUNICATION',
  ConnectedCar = 'CONNECTED_CAR',
  CookingAndRecipe = 'COOKING_AND_RECIPE',
  CurrencyGuidesAndConverters = 'CURRENCY_GUIDES_AND_CONVERTERS',
  Dating = 'DATING',
  DeliveryAndTakeout = 'DELIVERY_AND_TAKEOUT',
  DeviceTracking = 'DEVICE_TRACKING',
  EducationAndReference = 'EDUCATION_AND_REFERENCE',
  EventFinders = 'EVENT_FINDERS',
  ExerciseAndWorkout = 'EXERCISE_AND_WORKOUT',
  FashionAndStyle = 'FASHION_AND_STYLE',
  FlightFinders = 'FLIGHT_FINDERS',
  FriendsAndFamily = 'FRIENDS_AND_FAMILY',
  Games = 'GAMES',
  GameInfoAndAccessory = 'GAME_INFO_AND_ACCESSORY',
  HealthAndFitness = 'HEALTH_AND_FITNESS',
  HotelFinders = 'HOTEL_FINDERS',
  KnowledgeAndTrivia = 'KNOWLEDGE_AND_TRIVIA',
  MovieAndTvKnowledgeAndTrivia = 'MOVIE_AND_TV_KNOWLEDGE_AND_TRIVIA',
  MovieInfoAndReviews = 'MOVIE_INFO_AND_REVIEWS',
  MovieShowtimes = 'MOVIE_SHOWTIMES',
  MusicAndAudioAccessories = 'MUSIC_AND_AUDIO_ACCESSORIES',
  MusicAndAudioKnowledgeAndTrivia = 'MUSIC_AND_AUDIO_KNOWLEDGE_AND_TRIVIA',
  MusicInfoReviewsAndRecognitionService = 'MUSIC_INFO_REVIEWS_AND_RECOGNITION_SERVICE',
  News = 'NEWS',
  Novelty = 'NOVELTY',
  NA = 'N_A',
  OrganizersAndAssistants = 'ORGANIZERS_AND_ASSISTANTS',
  PetsAndAnimal = 'PETS_AND_ANIMAL',
  Podcast = 'PODCAST',
  PublicTransportation = 'PUBLIC_TRANSPORTATION',
  ReligionAndSpirituality = 'RELIGION_AND_SPIRITUALITY',
  RestaurantBookingInfoAndReview = 'RESTAURANT_BOOKING_INFO_AND_REVIEW',
  Schools = 'SCHOOLS',
  ScoreKeeping = 'SCORE_KEEPING',
  SelfImprovement = 'SELF_IMPROVEMENT',
  Shopping = 'SHOPPING',
  SmartHome = 'SMART_HOME',
  SocialNetworking = 'SOCIAL_NETWORKING',
  SportsGames = 'SPORTS_GAMES',
  SportsNews = 'SPORTS_NEWS',
  StreamingService = 'STREAMING_SERVICE',
  TaxiAndRidesharing = 'TAXI_AND_RIDESHARING',
  ToDoListsAndNotes = 'TO_DO_LISTS_AND_NOTES',
  Translators = 'TRANSLATORS',
  TvGuides = 'TV_GUIDES',
  UnitConverters = 'UNIT_CONVERTERS',
  Weather = 'WEATHER',
  WineAndBeverage = 'WINE_AND_BEVERAGE',
  ZipCodeLookup = 'ZIP_CODE_LOOKUP'
}

export type AlexaSkillInput = {
  manifest: AlexaSkillManifestInput;
};

export type AlexaSkillManifest = {
  lastUpdateRequest?: Maybe<AlexaSkillManifestLastUpdateRequest>;
  manifestVersion?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Maybe<AlexaPermissions>>>;
  /** Privacy and compliance data required for Alexa publishing */
  privacyAndCompliance: AlexaPrivacyAndCompliance;
  publishingInformation?: Maybe<AlexaSkillmanifestPublishingInformation>;
};

export type AlexaSkillManifestInput = {
  lastUpdateRequest?: InputMaybe<AlexaSkillManifestLastUpdateRequestInput>;
  manifestVersion?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<AlexaPermissionsInput>>>;
  publishingInformation?: InputMaybe<AlexaSkillmanifestPublishingInformationInput>;
};

export type AlexaSkillManifestLastUpdateRequest = {
  status?: Maybe<AlexaSkillManifestRequestStatus>;
};

export type AlexaSkillManifestLastUpdateRequestInput = {
  status?: InputMaybe<AlexaSkillManifestRequestStatus>;
};

export enum AlexaSkillManifestRequestStatus {
  InProgress = 'IN_PROGRESS'
}

export type AlexaSkillmanifestPublishingInformation = {
  category: AlexaSkillCategories;
  distributionCountries?: Maybe<AlexaDistrubutionCountry>;
  distributionMode: AlexaDistributionMode;
  isAvailableWorldwide: Scalars['Boolean']['output'];
  testingInstructions: Scalars['String']['output'];
};

export type AlexaSkillmanifestPublishingInformationInput = {
  category: AlexaSkillCategories;
  distributionCountries?: InputMaybe<AlexaDistrubutionCountry>;
  distributionMode: AlexaDistributionMode;
  isAvailableWorldwide: Scalars['Boolean']['input'];
  testingInstructions: Scalars['String']['input'];
};

export type Analytics = {
  /** An aggregated portion of Intent events. */
  selectedCount?: Maybe<Array<Maybe<SelectedCount>>>;
  /** The total number of handler events that are found. */
  totalCount: Scalars['Int']['output'];
};

export type App = {
  _id: Scalars['ID']['output'];
  /** Information about how people are accessing the app's widgets. */
  access: WidgetChannelAccess;
  /** The type of the account linking. This tells us how to redeem the token for PII. */
  accountLinkType?: Maybe<Scalars['String']['output']>;
  /** The unique ID of the google action that the app is linked to. */
  actionsOnGoogleId?: Maybe<Scalars['String']['output']>;
  /** The category that the app will fall in to when published to Alexa. */
  alexaCategory?: Maybe<Scalars['String']['output']>;
  /** The unique ID of the alexa skill that the app is linked to. */
  alexaSkillId?: Maybe<Scalars['String']['output']>;
  analytics?: Maybe<AppAnalytics>;
  /** Unique identifier of the app in Stentor. */
  appId: Scalars['ID']['output'];
  /** Settings for the availability of the CRM service. */
  availability?: Maybe<CrmServiceAvailabilitySettings>;
  /**
   * URL of the original banner image with aspect ratio of 16:9 and minimum dimensions of 1920x1080.
   *
   * Required by Actions on Google
   */
  banner?: Maybe<Scalars['String']['output']>;
  beta?: Maybe<Scalars['JSON']['output']>;
  /**
   * A description of the business and it's services.
   *
   * This can be used for LLM operations
   */
  businessDescription?: Maybe<Scalars['String']['output']>;
  /**
   * A description of what they consider to be high value leads, prioritized queries that they
   * want to be notified immediately.
   *
   * This can be used for LLM operations
   */
  businessHighValueLeadDescription?: Maybe<Scalars['String']['output']>;
  /** The hours in which the business related to the app is open. */
  businessHours: Array<BusinessHours>;
  /**
   * User-curated business types for this app (e.g., "plumber", "hvac", "electrician").
   * Initially populated from Google Places API types but can be edited by users.
   * Used for analytics and categorization.
   */
  businessTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether or not the app can capture leads. */
  canCaptureLeads: Scalars['Boolean']['output'];
  /**
   * The leads that have been caught recently.
   * @deprecated Use 'leads' field instead. Will be removed in a future version.
   */
  caughtLeads: CaughtLeadsResult;
  /** The opportunity alerts that have been caught recently. */
  caughtOpportunityAlerts: CaughtOpportunityAlertsResult;
  /** Returns an App channel based on the provided ID. */
  channel?: Maybe<BaseAppChannel>;
  /** The Channels that are available to the app. */
  channels?: Maybe<Array<Maybe<BaseAppChannel>>>;
  /**
   * A CMS token is an authorization token that is linked to the app
   * which allows third party services to access certain resources without
   * user intervention.
   */
  cmsTokens: Array<Maybe<CmsToken>>;
  /** Retrieves the attributes used to download web content. */
  content?: Maybe<TotalWebContent>;
  /** Retrieves any errors that may have happened while attempting to download web content. */
  contentErrors?: Maybe<TotalWebContentErrors>;
  /** Retrieves the sources that were used to generate the content. */
  contentSources?: Maybe<TotalWebContentSources>;
  /**
   * The job types known to the app's CRM integration, for the Studio job-type picker.
   * Returns an empty list if the app has no CRM integration.
   */
  crmJobTypes?: Maybe<Array<CrmJobType>>;
  /** Third party analytics platforms. */
  dataStreams?: Maybe<DataStreams>;
  /**
   * This is the locale in which the app is primarily focused on. The app will publish to this locale with the
   * data provided. Items which can be overwritten can be placed in the "locale" section with the local necessary.
   *
   * Default: "en"
   */
  defaultLocale?: Maybe<Scalars['String']['output']>;
  /**
   * The description for the app.
   *
   * The description cannot be more than 4000 characters.
   */
  description?: Maybe<Scalars['String']['output']>;
  /** The URL where the app is served. */
  endPoint?: Maybe<Endpoint>;
  /**
   * The app's engagement/transcript analysis config. Null if the app
   * hasn't configured one yet.
   */
  engagementAnalysisConfig?: Maybe<EngagementAnalysisConfig>;
  /** The entities that are associated with the app. */
  entities?: Maybe<EntitiesQuery>;
  /** Retrieves a list of events that are associated with the app. */
  events?: Maybe<TotalEvents>;
  /**
   * Example phrases the help users know how to use the app.
   *
   * At least three are required for publication.
   */
  examplePhrases?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Contains an externalId that is used by Stentor when assuming roles on client AWS accounts. */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Retrieves the attributes used to download web content. */
  faq?: Maybe<TotalWebFaq>;
  /** Retrieves the attributes used to download web content */
  faqQuery: FaqQueryReturn;
  /** Form Widget conversion analytics, aggregated by distinct session, from the stentor_events index. */
  formAnalytics?: Maybe<FormAnalytics>;
  /** A Map of all the intents and their locations for mapping intents. */
  graph?: Maybe<IntentsGraph>;
  /** The handlers that are associated with the app. */
  handlers?: Maybe<HandlersQuery>;
  /**
   * URL to the original icon file before transformation.
   *
   * Aspect ration must be 1:1 and minimum dimensions are 512x512.
   */
  icon?: Maybe<Scalars['String']['output']>;
  /** Retrieve the data for an integration. */
  integration: Integration;
  /** The intents that are associated with the app. */
  intents?: Maybe<IntentsQuery>;
  /** Allows stentor_admins to view and add notes to apps for internal use. */
  internalNotes?: Maybe<Scalars['String']['output']>;
  /** The phrase a user must speak to wake the app up on a specific platform. */
  invocationName?: Maybe<Scalars['String']['output']>;
  /** Allows app-specific overriding of IPRights. */
  ipRights?: Maybe<IpRights>;
  /** Whether or not the app is copyable to another organization. */
  isCopyable?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Keywords to help when searching directories for the app
   *
   * Max of 30 keywords are allowed.
   */
  keywords?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * Banner that is 1920x1080.
   *
   * Required by Actions on Google
   */
  largeBanner?: Maybe<Scalars['String']['output']>;
  /**
   * A large icon for the app, 512x512 PNG
   *
   * Required for Alexa
   */
  largeIcon?: Maybe<Scalars['String']['output']>;
  /**
   * Email routing configuration for leads.
   * Allows sending leads to different email addresses based on lead properties.
   */
  leadEmailRoutes?: Maybe<Array<LeadEmailRoute>>;
  /** Fetch leads for this app with filtering options. */
  leads?: Maybe<LeadsQuery>;
  /** The Email address to send lead captures to. */
  leadsContact?: Maybe<Scalars['EmailAddress']['output']>;
  /** The phone number of a leads user. */
  leadsContactPhone?: Maybe<Scalars['String']['output']>;
  /**
   * Get metadata about available filter values for leads.
   * Returns unique values for filterable fields to populate UI filter dropdowns.
   */
  leadsFilterMetadata?: Maybe<LeadsFilterMetadata>;
  limitations: AppLimitations;
  /**
   * This is a series of locales that the apps supports.  These can override the
   * items that are in the original App.  The items in the main app are used as defaults if they
   * are not provided by this locale.
   */
  locales?: Maybe<AppLocales>;
  /** Physical location associated with the app. */
  location?: Maybe<Location>;
  /** Manual override available features for the app.  This is set by the administrator.  These are already accounted for in the limitations */
  manualOverrideAvailableFeatures?: Maybe<PartialAppLimitations>;
  /**
   * A medium icon for the app, 192x192 PNG.
   *
   * Required for Actions On Google
   */
  mediumIcon?: Maybe<Scalars['String']['output']>;
  /** The human-readable name of the app. */
  name: Scalars['String']['output'];
  /** The NLUs that are available to the app. */
  nlu?: Maybe<Array<Maybe<AppNlu>>>;
  /** Potential opportunities. */
  opportunityAlerts: Array<BaseOpportunityAlert>;
  /** The organization that owns this app */
  organization?: Maybe<Organization>;
  /** The ID of the organization that the app is linked to. */
  organizationId: Scalars['ID']['output'];
  /** Google PlaceIds that correspond with the business. */
  places?: Maybe<Array<AppPlaceDescription>>;
  /**
   * Platform specific data for the app that does not correspond
   * with other high level data that is shared.
   */
  platformData?: Maybe<PlatformData>;
  /** URL to the privacy policy for the app. */
  privacyPolicyUrl?: Maybe<Scalars['String']['output']>;
  /** A referenceId is an ID of the app in a different service outside this API */
  referenceId?: Maybe<AppReferenceId>;
  /**
   * A referenceId is an ID of the app in a different service outside this API
   *
   * @deprecated Use referenceId instead (typo fix)
   */
  refernceId?: Maybe<AppReferenceId>;
  /** ROI configuration for this app (custom cost per lead overrides) */
  roiConfig?: Maybe<RoiConfig>;
  /**
   * Generate ROI report for a given time period.
   *
   * For predefined periods (DAY, WEEK, MONTH, QUARTER, YEAR), the dates are
   * calculated automatically from the current date.
   *
   * For CUSTOM period, you must provide both startDate and endDate.
   */
  roiReport?: Maybe<RoiReport>;
  /** The status that the app is currently in Stentor. */
  schedules: AppSchedules;
  /** The leads by session id */
  sessionLeads: SessionLeadsResult;
  /**
   * A small icon for the app, 108x108 PNG
   *
   * Required for Alexa
   */
  smallIcon?: Maybe<Scalars['String']['output']>;
  /** The status that the app is currently in Stentor. */
  status?: Maybe<Status>;
  /** The product that is linked to the subscription to this app in Stripe. */
  stripeProductId?: Maybe<Scalars['String']['output']>;
  /** The subscription ID that is linked to this app in Stripe. */
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<SubscriptionDetails>;
  /** The payment status in Stripe. */
  subscriptionPaymentStatus?: Maybe<Scalars['String']['output']>;
  /** Metadata about suggestions in the suggestions index for this app */
  suggestionsInfo: AppSuggestionsInfo;
  /**
   * The summary of the app.
   *
   * Shorter than the description, maximum 160 characters.
   */
  summary?: Maybe<Scalars['String']['output']>;
  /** Retrieves a list of notifications that the user should see related to the app. */
  systemNotifications?: Maybe<Array<Maybe<SystemNotification>>>;
  /** Type of template the app and its intents adhere to. */
  templateType?: Maybe<Scalars['String']['output']>;
  /** URL to the terms of use for the app */
  termsOfUseUrl?: Maybe<Scalars['String']['output']>;
  /** Instructions for platform testers on how to test the app. */
  testingInstructions?: Maybe<Scalars['String']['output']>;
  /** Contains fields related to publishing the app to various platforms such as dialogflow or alexa. */
  thirdPartyDeployments?: Maybe<ThirdPartyDeployments>;
  /** The usage statistics related to the app. */
  usage: AppUsageStats;
  /** Retrieves any events that are related to this specific app */
  usageEvents?: Maybe<TotalUsageEvents>;
  /** Primary website for the company or division of a company that the app is representing. */
  website?: Maybe<Scalars['String']['output']>;
  /** Data related to what was found on the customers website */
  websiteData?: Maybe<AppWebsiteData>;
};


export type AppAccessArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  refererDomain?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type AppCaughtLeadsArgs = {
  agentType?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  canonicalSource?: InputMaybe<Scalars['String']['input']>;
  capturePlatform?: InputMaybe<Scalars['String']['input']>;
  captureSurface?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  contactMethod?: InputMaybe<Scalars['String']['input']>;
  contactType?: InputMaybe<Scalars['String']['input']>;
  contactTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  environment?: InputMaybe<Scalars['String']['input']>;
  highValueLead?: InputMaybe<Scalars['Boolean']['input']>;
  includePartials?: InputMaybe<Scalars['Boolean']['input']>;
  jobType?: InputMaybe<Scalars['String']['input']>;
  jobTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  nextKey?: InputMaybe<Scalars['String']['input']>;
  partialsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  referringSource?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  serviceType?: InputMaybe<Scalars['String']['input']>;
  serviceTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  size?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceSystem?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  urgencies?: InputMaybe<Array<Scalars['String']['input']>>;
  urgency?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
};


export type AppCaughtOpportunityAlertsArgs = {
  nextKey?: InputMaybe<Scalars['String']['input']>;
};


export type AppChannelArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type AppContentArgs = {
  from?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  textHighlight?: InputMaybe<Scalars['String']['input']>;
};


export type AppContentErrorsArgs = {
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type AppContentSourcesArgs = {
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type AppEntitiesArgs = {
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  withDisplayName?: InputMaybe<Scalars['String']['input']>;
  withId?: InputMaybe<Scalars['String']['input']>;
  withIdOrDisplayName?: InputMaybe<Scalars['String']['input']>;
  withSynonym?: InputMaybe<Scalars['String']['input']>;
  withValue?: InputMaybe<Scalars['String']['input']>;
  withValueOrSynonym?: InputMaybe<Scalars['String']['input']>;
};


export type AppEventsArgs = {
  byChannel?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  byEnvironment?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  byFlag?: InputMaybe<Array<InputMaybe<RawQueryEventFlag>>>;
  byMatchConfidenceRange?: InputMaybe<MatchConfidenceRange>;
  byName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  byPlatform?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  byRequestIntentId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  byTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  byType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  messageTextSearch?: InputMaybe<Scalars['String']['input']>;
  newSessionsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  noFlag?: InputMaybe<Scalars['Boolean']['input']>;
  rawQueryOnly?: InputMaybe<Scalars['Boolean']['input']>;
  rawQueryOrSlotsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  rawQueryText?: InputMaybe<Scalars['String']['input']>;
  responseOutputText?: InputMaybe<Scalars['String']['input']>;
  responseRepromptText?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type AppFaqArgs = {
  from?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type AppFaqQueryArgs = {
  from?: InputMaybe<Scalars['Int']['input']>;
  question: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type AppFormAnalyticsArgs = {
  byHost?: InputMaybe<Scalars['Boolean']['input']>;
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};


export type AppGraphArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type AppHandlersArgs = {
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  withId?: InputMaybe<Scalars['String']['input']>;
  withIdOrName?: InputMaybe<Scalars['String']['input']>;
  withName?: InputMaybe<Scalars['String']['input']>;
};


export type AppIntegrationArgs = {
  type: IntegrationType;
};


export type AppIntentsArgs = {
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  withId?: InputMaybe<Scalars['String']['input']>;
  withIdOrName?: InputMaybe<Scalars['String']['input']>;
  withName?: InputMaybe<Scalars['String']['input']>;
};


export type AppLeadsArgs = {
  agentType?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  canonicalSource?: InputMaybe<Scalars['String']['input']>;
  capturePlatform?: InputMaybe<Scalars['String']['input']>;
  captureSurface?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  contactMethod?: InputMaybe<Scalars['String']['input']>;
  contactType?: InputMaybe<Scalars['String']['input']>;
  contactTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  environment?: InputMaybe<Scalars['String']['input']>;
  highValueLead?: InputMaybe<Scalars['Boolean']['input']>;
  includePartials?: InputMaybe<Scalars['Boolean']['input']>;
  jobType?: InputMaybe<Scalars['String']['input']>;
  jobTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  nextKey?: InputMaybe<Scalars['String']['input']>;
  partialsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  referringSource?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  serviceType?: InputMaybe<Scalars['String']['input']>;
  serviceTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  size?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceSystem?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  urgencies?: InputMaybe<Array<Scalars['String']['input']>>;
  urgency?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
};


export type AppRoiReportArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  period: RoiPeriod;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type AppSchedulesArgs = {
  previousKey?: InputMaybe<Scalars['String']['input']>;
};


export type AppSessionLeadsArgs = {
  sessionId?: InputMaybe<Scalars['String']['input']>;
};


export type AppUsageEventsArgs = {
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type AppAnalytics = {
  user: AppUsageStat;
};


export type AppAnalyticsUserArgs = {
  byChannel?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  byEnvironment?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};

export type AppChannel = BaseAppChannel & {
  /** URL for the directory listing. */
  directoryListing?: Maybe<Scalars['String']['output']>;
  /** URI where the channel can be accessed. */
  endPoint?: Maybe<Scalars['String']['output']>;
  /** The ID of the channel. */
  id: Scalars['String']['output'];
  /** The display name for the channel. */
  name?: Maybe<Scalars['String']['output']>;
  /** The lifecycle status of the app. */
  status?: Maybe<AppChannelStatus>;
  /** The type of channel */
  type: Scalars['String']['output'];
  /** Retrieves any events that are related to this specific app */
  usageEvents?: Maybe<TotalUsageEvents>;
  /**
   * ID of the NLU to use within app.nlu[].
   *
   * If it exists, the channel will use the provided NLU at runtime
   * to convert the raw text to an Intent
   *
   * If the value is "*", then it will pick the first available NLU within app.nlu[]
   */
  useNLU?: Maybe<Scalars['String']['output']>;
};


export type AppChannelUsageEventsArgs = {
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type AppChannelInput = {
  /** URL for the directory listing. */
  directoryListing?: InputMaybe<Scalars['String']['input']>;
  /** URI where the channel can be accessed. */
  endPoint?: InputMaybe<Scalars['String']['input']>;
  /**
   * The ID of the channel.
   *
   * When calling a "CreateChannel" function, then ID will be
   * used to determine if the channel shoudl be inserted or updated.
   *
   * If the ID is provided and already exists, the channel will be
   * updated.  Otherwise the channel will be inserted and an ID will be
   * generated.
   */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The display name for the channel. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The type of channel */
  type: Scalars['String']['input'];
  /**
   * ID of the NLU to use within app.nlu[].
   *
   * If it exists, the channel will use the provided NLU at runtime
   * to convert the raw text to an Intent
   *
   * If the value is "*", then it will pick the first available NLU within app.nlu[]
   */
  useNLU?: InputMaybe<Scalars['String']['input']>;
};

export type AppChannelMutation = {
  /**
   * Adds or updates an Actions On Google Channel to the specified app.
   *
   * @return The channel that was just added.
   */
  addActionsOnGoogleChannel: ActionsOnGoogleAppChannel;
  /**
   * Adds or updates an Alexa Channel to the specified app.
   *
   * @return The channel that was just added.
   */
  addAlexaChannel: AlexaAppChannel;
  /**
   * Adds a custom channel to the app.
   *
   * @deprecated Please use the specific channel mutation instead.
   */
  addChannel: AppChannel;
  /**
   * Adds or updates a Chat Widget channel to the specified app.
   *
   * @return The channel that was just added
   */
  addChatWidgetChannel: ChatWidgetAppChannel;
  /**
   * Adds or updates an Dialogflow Channel to the specified app.
   *
   * @return The channel that was just added.
   */
  addDialogflowChannel: DialogflowAppChannel;
  /**
   * Adds or updates the email channel on the app.
   * Auto-assigns captureAddress as {appId}@capture.xapp.ai.
   */
  addEmailChannel: EmailAppChannel;
  /**
   * Adds or updates a Facebook Messenger channel to the specified app.
   *
   * @return The channel that was just added
   */
  addFacebookMessengerChannel: FacebookMessengerAppChannel;
  addFormWidgetChannel: FormWidgetAppChannel;
  /**
   * Adds or updates a Google Business Message channel to the specified app
   *
   * @return The channel that was just added
   */
  addGoogleBusinessMessageChannel: GoogleBusinessMessagesAppChannel;
  /**
   * Adds or updates an Intelligent Search channel to the specified app
   *
   * @return The channel that was just added
   */
  addIntelligentSearchChannel: IntelligentSearchAppChannel;
  /**
   * Adds or updates a Lex channel to the specified app.
   *
   * @return The channel that was just added
   */
  addLexChannel: LexConnectAppChannel;
  /**
   * Adds or updates a Lex V2 channel to the specified app.
   *
   * @return The channel that was just added
   */
  addLexV2Channel: LexV2ConnectAppChannel;
  /**
   * Email channel specific mutations (verification, configuration).
   * Requires the channelId of an existing email channel.
   */
  emailChannel: EmailChannelMutation;
  /** Update operations related to the specific channel. */
  update: UpdateAppChannelMutation;
};


export type AppChannelMutationAddActionsOnGoogleChannelArgs = {
  channel: ActionsOnGoogleAppChannelInput;
};


export type AppChannelMutationAddAlexaChannelArgs = {
  channel: AlexaAppChannelInput;
};


export type AppChannelMutationAddChannelArgs = {
  channel: AppChannelInput;
};


export type AppChannelMutationAddChatWidgetChannelArgs = {
  channel: ChatWidgetAppChannelInput;
};


export type AppChannelMutationAddDialogflowChannelArgs = {
  channel: DialogflowAppChannelInput;
};


export type AppChannelMutationAddEmailChannelArgs = {
  channel: EmailAppChannelInput;
};


export type AppChannelMutationAddFacebookMessengerChannelArgs = {
  channel: FacebookMessengerAppChannelInput;
};


export type AppChannelMutationAddFormWidgetChannelArgs = {
  channel: FormWidgetAppChannelInput;
};


export type AppChannelMutationAddGoogleBusinessMessageChannelArgs = {
  channel: GoogleBusinessMessagesAppChannelInput;
};


export type AppChannelMutationAddIntelligentSearchChannelArgs = {
  channel: IntelligentSearchAppChannelInput;
};


export type AppChannelMutationAddLexChannelArgs = {
  channel: LexConnectAppChannelInput;
};


export type AppChannelMutationAddLexV2ChannelArgs = {
  channel: LexV2ConnectAppChannelInput;
};


export type AppChannelMutationEmailChannelArgs = {
  channelId: Scalars['ID']['input'];
};


export type AppChannelMutationUpdateArgs = {
  channelId?: InputMaybe<Scalars['ID']['input']>;
};

export type AppChannelStatus = {
  /** The email of the user who last changed the status. */
  email: Scalars['String']['output'];
  /** Any notes that was associated with the status change. */
  notes?: Maybe<Scalars['String']['output']>;
  /** A brief history of the status changes. */
  statusHistory?: Maybe<Array<Maybe<AppChannelStatusHistory>>>;
  /**
   * The time the status was last changed.
   *
   * Format: UNIX timestamp
   */
  timestamp: Scalars['Long']['output'];
  /** The status level of the app. */
  type: Scalars['String']['output'];
};

export type AppChannelStatusHistory = {
  /** The email of the user who changed the status. */
  email: Scalars['String']['output'];
  /** Any notes that was associated with the status change. */
  notes?: Maybe<Scalars['String']['output']>;
  /**
   * The time the status was changed.
   *
   * Format: UNIX timestamp
   */
  timestamp: Scalars['Long']['output'];
  /** The status level that the app was. */
  type: Scalars['String']['output'];
};

export type AppInput = {
  /** The type of the account linking. This tells us how to redeem the token for PII. */
  accountLinkType?: InputMaybe<Scalars['String']['input']>;
  /** The unique ID of the google action that the app is linked to. */
  actionsOnGoogleId?: InputMaybe<Scalars['String']['input']>;
  /** The category that the app will fall in to when published to Alexa. */
  alexaCategory?: InputMaybe<Scalars['String']['input']>;
  /** The unique ID of the alexa skill that the app is linked to. */
  alexaSkillId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Unique identifier of the app in Stentor.
   * If not provided then the name will derive the appId.
   */
  appId?: InputMaybe<Scalars['ID']['input']>;
  /** Settings for the availability of the CRM service. */
  availability?: InputMaybe<CrmServiceAvailabilitySettingsInput>;
  /**
   * URL of the original banner image with aspect ratio of 16:9 and minimum dimensions of 1920x1080.
   *
   * Required by Actions on Google
   */
  banner?: InputMaybe<Scalars['String']['input']>;
  beta?: InputMaybe<Scalars['JSON']['input']>;
  /**
   * A description of the business and it's services.
   *
   * This can be used for LLM operations
   */
  businessDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * A description of what they consider to be high value leads, prioritized queries that they
   * want to be notified immediately.
   *
   * This can be used for LLM operations
   */
  businessHighValueLeadDescription?: InputMaybe<Scalars['String']['input']>;
  /** The hours in which the business related to the app is open. */
  businessHours?: InputMaybe<Array<BusinessHoursInput>>;
  /** User-curated business types for this app. */
  businessTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Third party analytics platforms. */
  dataStreams?: InputMaybe<DataStreamsInput>;
  /**
   * The description for the app.
   *
   * The description cannot be more than 4000 characters.
   */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The URL where the app is served. */
  endPoint?: InputMaybe<EndpointInput>;
  /**
   * Example phrases the help users know how to use the app.
   *
   * At least three are required for publication.
   */
  examplePhrases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**
   * URL to the original icon file before transformation.
   *
   * Aspect ration must be 1:1 and minimum dimensions are 512x512.
   */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Allows stentor_admins to view and add notes to apps for internal use. */
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  /** The phrase a user must speak to wake the app up on a specific platform. */
  invocationName?: InputMaybe<Scalars['String']['input']>;
  /** Allows app-specific overriding of IPRights. */
  ipRights?: InputMaybe<IpRightsInput>;
  /**
   * Keywords to help when searching directories for the app
   *
   * Max of 30 keywords are allowed.
   */
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**
   * Banner that is 1920x1080.
   *
   * Required by Actions on Google
   */
  largeBanner?: InputMaybe<Scalars['String']['input']>;
  /**
   * A large icon for the app, 512x512 PNG
   *
   * Required for Alexa
   */
  largeIcon?: InputMaybe<Scalars['String']['input']>;
  /** Email routing configuration for leads. */
  leadEmailRoutes?: InputMaybe<Array<LeadEmailRouteInput>>;
  /** The Email address to send lead captures to. */
  leadsContact?: InputMaybe<Scalars['EmailAddress']['input']>;
  /** The phone number of a leads user. */
  leadsContactPhone?: InputMaybe<Scalars['String']['input']>;
  /** Physical location associated with the app. */
  location?: InputMaybe<LocationInput>;
  /**
   * A medium icon for the app, 192x192 PNG.
   *
   * Required for Actions On Google
   */
  mediumIcon?: InputMaybe<Scalars['String']['input']>;
  /** The human-readable name of the app. */
  name: Scalars['String']['input'];
  /** The ID of the organization that the app is linked to. */
  organizationId: Scalars['ID']['input'];
  /** Google PlaceIds that correspond with the business. */
  places?: InputMaybe<Array<AppPlaceDescriptionInput>>;
  /**
   * Platform specific data for the app that does not correspond
   * with other high level data that is shared.
   */
  platformData?: InputMaybe<PlatformDataInput>;
  /** URL to the privacy policy for the app. */
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  /** A referenceId is an ID of the app in a different service outside this API */
  referenceId?: InputMaybe<AppReferenceIdInput>;
  /**
   * A referenceId is an ID of the app in a different service outside this API
   *
   * @deprecated Use referenceId instead (typo fix)
   */
  refernceId?: InputMaybe<AppReferenceIdInput>;
  /**
   * A small icon for the app, 108x108 PNG
   *
   * Required for Alexa
   */
  smallIcon?: InputMaybe<Scalars['String']['input']>;
  /** The status that the app is currently in Stentor. */
  status?: InputMaybe<StatusInput>;
  /** The product that is linked to the subscription to this app in Stripe. */
  stripeProductId?: InputMaybe<Scalars['String']['input']>;
  /** The subscription ID that is linked to this app in Stripe. */
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  /** The payment status in Stripe. */
  subscriptionPaymentStatus?: InputMaybe<Scalars['String']['input']>;
  /**
   * The summary of the app.
   *
   * Shorter than the description, maximum 160 characters.
   */
  summary?: InputMaybe<Scalars['String']['input']>;
  /** Type of template the app and its intents adhere to. */
  templateType?: InputMaybe<Scalars['String']['input']>;
  /** URL to the terms of use for the app */
  termsOfUseUrl?: InputMaybe<Scalars['String']['input']>;
  /** Instructions for platform testers on how to test the app. */
  testingInstructions?: InputMaybe<Scalars['String']['input']>;
  /** Contains fields related to publishing the app to various platforms such as dialogflow or alexa. */
  thirdPartyDeployments?: InputMaybe<ThirdPartyDeploymentsInput>;
  /** Primary website for the company or division of a company that the app is representing. */
  website?: InputMaybe<Scalars['URLString']['input']>;
  /** Data related to what was found on the customers website */
  websiteData?: InputMaybe<AppWebsiteDataInput>;
};

/**
 * Business location (app) aggregation bucket for leads analytics.
 * Shows performance metrics for each business location within an organization.
 */
export type AppLeadBucket = {
  /** The app ID representing this business location */
  appId: Scalars['ID']['output'];
  /** High-value leads for this location */
  highValueLeadCount: Scalars['Int']['output'];
  /** Total leads for this location */
  leadCount: Scalars['Int']['output'];
  /** Business location name (from app.name) */
  name: Scalars['String']['output'];
  /** The organization ID this app belongs to */
  organizationId?: Maybe<Scalars['ID']['output']>;
  /** The organization name this app belongs to */
  organizationName?: Maybe<Scalars['String']['output']>;
  /** Percentage of total leads */
  percentage?: Maybe<Scalars['Float']['output']>;
  /** Top job types for this location */
  topJobTypes?: Maybe<Array<CategoryBucket>>;
  /** Top lead sources for this location (e.g., chat, form, phone) */
  topSources?: Maybe<Array<CategoryBucket>>;
};

export type AppLimitations = {
  /** Whether the app can use the Action Bar feature in the chat widget. */
  actionBar: Scalars['Boolean']['output'];
  /** Whether the app has access to advanced analytics features. */
  advancedAnalytics: Scalars['Boolean']['output'];
  /** Whether the app can tag leads using AI */
  aiLeadTagging: Scalars['Boolean']['output'];
  /** The integrations that are allowed in the app */
  allowedIntegrations?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether the app can capture leads from the widget */
  captureLead: Scalars['Boolean']['output'];
  /** Integrations that are explicitly excluded (blacklist). */
  excludedIntegrations?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether a business representative can enter a live chat and talk to the client. */
  liveTakeover: Scalars['Boolean']['output'];
  /** The maximum number of entities that can be created in the app */
  maxEntities: Scalars['Int']['output'];
  /** The maximum number of handlers that can be created in the app */
  maxHandlers: Scalars['Int']['output'];
  /** The maximum number of intents that can be created in the app */
  maxIntents: Scalars['Int']['output'];
  /** The maximum number of Kendra documents that can be indexed in the app */
  maxKendraDocs: Scalars['Int']['output'];
  /** Whether the users can set preferred time for the appointment */
  preferredTime: Scalars['Boolean']['output'];
  /** Whether the app can be use the Reserve With Google actions widget. */
  reserveWithGoogle: Scalars['Boolean']['output'];
  /** Whether the app can use the schedule widget */
  schedule: Scalars['Boolean']['output'];
  /** Whether the app can access the chat transcript for a lead */
  transcriptAccess: Scalars['Boolean']['output'];
};

/**
 * A set of keys and attributes which can be overridden based on the locale in which
 * the app is running in.
 *
 * Items which are only two letters will apply to all locales that are associated with that language.
 * Items which contains a region (two letters plus two more) are more specific and will
 *     apply to that region. These items will override the two letter implementations.
 *
 * All attributes specified will override the attributes that are in the default.
 * If the attribute is not specified, then the default is used.
 *
 * Example:
 *
 * {
 *     defaultLocale: "en"
 *     param1: "English",
 *     param2: "English",
 *     param3: "English",
 *     locale: {
 *         "es": {
 *             "param1": "Spanish
 *         },
 *         "esMX": {
 *             "param2": "Spanish-Mexico"
 *         }
 *     }
 * }
 *
 * Result in "es":
 * {
 *     param1: "Spanish",
 *     param2: "English",
 *     param3: "English",
 * }
 *
 * Result in "esMX":
 * {
 *     param1: "Spanish",
 *     param2: "Spanish-Mexico",
 *     param3: "English",
 * }
 */
export type AppLocales = {
  /** Danish */
  da?: Maybe<LocaleApp>;
  /** German */
  de?: Maybe<LocaleApp>;
  /** German German */
  deDE?: Maybe<LocaleApp>;
  /** English */
  en?: Maybe<LocaleApp>;
  /** English Australian */
  enAU?: Maybe<LocaleApp>;
  /** English Canada */
  enCA?: Maybe<LocaleApp>;
  /** English Great Britain */
  enGB?: Maybe<LocaleApp>;
  /** English India */
  enIN?: Maybe<LocaleApp>;
  /** English United States */
  enUS?: Maybe<LocaleApp>;
  /** Spanish */
  es?: Maybe<LocaleApp>;
  /** Spanish: Only supported in Google. */
  es419?: Maybe<LocaleApp>;
  /** Spanish Spain */
  esES?: Maybe<LocaleApp>;
  /** Spanish Mexico */
  esMX?: Maybe<LocaleApp>;
  /** French */
  fr?: Maybe<LocaleApp>;
  /** French Canada */
  frCA?: Maybe<LocaleApp>;
  /** French France */
  frFR?: Maybe<LocaleApp>;
  /** Italian */
  it?: Maybe<LocaleApp>;
  /** Italian Italy */
  itIT?: Maybe<LocaleApp>;
  /** Japanese */
  ja?: Maybe<LocaleApp>;
  /** Japanese Japan */
  jaJP?: Maybe<LocaleApp>;
  /** Dutch */
  nl?: Maybe<LocaleApp>;
  /** Norwegian */
  no?: Maybe<LocaleApp>;
  /** Portuguese */
  pt?: Maybe<LocaleApp>;
  /** Portuguese Brazil */
  ptBR?: Maybe<LocaleApp>;
  /** Russian */
  ru?: Maybe<LocaleApp>;
  /** Swedish */
  sv?: Maybe<LocaleApp>;
  /** Thai */
  th?: Maybe<LocaleApp>;
  /** Turkish */
  tr?: Maybe<LocaleApp>;
  /** Ukranian */
  uk?: Maybe<LocaleApp>;
  /** Chinese */
  zh?: Maybe<LocaleApp>;
  /** Chinese China */
  zhCH?: Maybe<LocaleApp>;
  /** Chinese Hong Kong */
  zhHK?: Maybe<LocaleApp>;
  /** Chinese Taiwan */
  zhTW?: Maybe<LocaleApp>;
};

/**
 * A set of keys and attributes which can be overridden based on the locale in which
 * the app is running in.
 *
 * Items which are only two letters will apply to all locales that are associated with that language.
 * Items which contains a region (two letters plus two more) are more specific and will
 *     apply to that region. These items will override the two letter implementations.
 *
 * All attributes specified will override the attributes that are in the default.
 * If the attribute is not specified, then the default is used.
 *
 * Example:
 *
 * {
 *     defaultLocale: "en"
 *     param1: "English",
 *     param2: "English",
 *     param3: "English",
 *     locale: {
 *         "es": {
 *             "param1": "Spanish
 *         },
 *         "esMX": {
 *             "param2": "Spanish-Mexico"
 *         }
 *     }
 * }
 *
 * Result in "es":
 * {
 *     param1: "Spanish",
 *     param2: "English",
 *     param3: "English",
 * }
 *
 * Result in "esMX":
 * {
 *     param1: "Spanish",
 *     param2: "Spanish-Mexico",
 *     param3: "English",
 * }
 */
export type AppLocalesInput = {
  /** Danish */
  da?: InputMaybe<LocaleAppInput>;
  /** German */
  de?: InputMaybe<LocaleAppInput>;
  /** German German */
  deDE?: InputMaybe<LocaleAppInput>;
  /** English */
  en?: InputMaybe<LocaleAppInput>;
  /** English Australian */
  enAU?: InputMaybe<LocaleAppInput>;
  /** English Canada */
  enCA?: InputMaybe<LocaleAppInput>;
  /** English Great Britain */
  enGB?: InputMaybe<LocaleAppInput>;
  /** English India */
  enIN?: InputMaybe<LocaleAppInput>;
  /** English United States */
  enUS?: InputMaybe<LocaleAppInput>;
  /** Spanish */
  es?: InputMaybe<LocaleAppInput>;
  /** Spanish: Only supported in Google. */
  es419?: InputMaybe<LocaleAppInput>;
  /** Spanish Spain */
  esES?: InputMaybe<LocaleAppInput>;
  /** Spanish Mexico */
  esMX?: InputMaybe<LocaleAppInput>;
  /** French */
  fr?: InputMaybe<LocaleAppInput>;
  /** French Canada */
  frCA?: InputMaybe<LocaleAppInput>;
  /** French France */
  frFR?: InputMaybe<LocaleAppInput>;
  /** Italian */
  it?: InputMaybe<LocaleAppInput>;
  /** Italian Italy */
  itIT?: InputMaybe<LocaleAppInput>;
  /** Japanese */
  ja?: InputMaybe<LocaleAppInput>;
  /** Japanese Japan */
  jaJP?: InputMaybe<LocaleAppInput>;
  /** Dutch */
  nl?: InputMaybe<LocaleAppInput>;
  /** Norwegian */
  no?: InputMaybe<LocaleAppInput>;
  /** Portuguese */
  pt?: InputMaybe<LocaleAppInput>;
  /** Portuguese Brazil */
  ptBR?: InputMaybe<LocaleAppInput>;
  /** Russian */
  ru?: InputMaybe<LocaleAppInput>;
  /** Swedish */
  sv?: InputMaybe<LocaleAppInput>;
  /** Thai */
  th?: InputMaybe<LocaleAppInput>;
  /** Turkish */
  tr?: InputMaybe<LocaleAppInput>;
  /** Ukranian */
  uk?: InputMaybe<LocaleAppInput>;
  /** Chinese */
  zh?: InputMaybe<LocaleAppInput>;
  /** Chinese China */
  zhCH?: InputMaybe<LocaleAppInput>;
  /** Chinese Hong Kong */
  zhHK?: InputMaybe<LocaleAppInput>;
  /** Chinese Taiwan */
  zhTW?: InputMaybe<LocaleAppInput>;
};

export type AppMutation = {
  /**
   * Allows one to add a new app to Stentor.
   *
   * The appId must be unique to Stentor.  If it is not, a new one will be generated which
   * is unique based on the appId provided.
   */
  addApp?: Maybe<App>;
  /** Import an app template in to the system. */
  importApp: App;
  /** Operations that are related to updating a particular app */
  update: UpdateAppMutation;
};


export type AppMutationAddAppArgs = {
  app?: InputMaybe<AppInput>;
};


export type AppMutationImportAppArgs = {
  appId?: InputMaybe<Scalars['ID']['input']>;
  modelOnly?: InputMaybe<Scalars['Boolean']['input']>;
  overwrite?: InputMaybe<Scalars['Boolean']['input']>;
  url: Scalars['URL']['input'];
};


export type AppMutationUpdateArgs = {
  appId: Scalars['ID']['input'];
};

export type AppNlu = BaseAppNlu & {
  /** The reference ID for the NLU */
  id?: Maybe<Scalars['String']['output']>;
  /** The type of NLU. */
  type: Scalars['String']['output'];
};

export type AppNluInput = {
  /** The reference ID for the NLU */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The type of NLU. */
  type: Scalars['String']['input'];
};

export type AppPlaceDescription = {
  /** Legacy: Use formattedAddress */
  address?: Maybe<Scalars['String']['output']>;
  addressComponents?: Maybe<Array<AppPlaceDescriptionAddressComponent>>;
  /** Whether or not this business has been verified to be the owner of the Google PlaceId. */
  adminVerified?: Maybe<Scalars['Boolean']['output']>;
  /** Allows the business to opt-out of having a book online button on their profile. */
  bookingOptOut?: Maybe<Scalars['Boolean']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  /**
   * Timestamp of when this place's data was last refreshed from Google Places API.
   * This is updated by the refreshPlaceFromGoogle mutation.
   */
  lastRefreshedFromGoogle?: Maybe<Scalars['DateTime']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /**
   * Opening hours from Google Business Profile.
   * Used as the primary source for business hours in analytics.
   */
  openingHours?: Maybe<PlaceOpeningHours>;
  /**
   * Partner identifier for this specific location.
   * Allows location-specific external IDs for integrations.
   */
  partnerId?: Maybe<AppReferenceId>;
  phone?: Maybe<Scalars['String']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
  /**
   * Business types from Google Places API (readonly).
   * Examples: "plumber", "electrician", "hvac_contractor", "general_contractor".
   */
  placeTypes?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Human-readable display name for the primary business type from Google.
   * Example: "Plumber" for type "plumber".
   */
  primaryTypeDisplayName?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['URLString']['output']>;
};

export type AppPlaceDescriptionAddressComponent = {
  /** The full text description or name of the address component as returned by the Google Places API Geocoder. */
  longName?: Maybe<Scalars['String']['output']>;
  /**
   * An abbreviated textual name for the address component, if available.
   * For example, an address component for the state of Alaska may have a longName of
   * "Alaska" and a short_name of "AK" using the 2-letter postal abbreviation.
   */
  shortName?: Maybe<Scalars['String']['output']>;
  /** An array of strings denoting the type of this address component. */
  types?: Maybe<Array<Scalars['String']['output']>>;
};

export type AppPlaceDescriptionAddressComponentInput = {
  /** The full text description or name of the address component as returned by the Google Places API Geocoder. */
  longName?: InputMaybe<Scalars['String']['input']>;
  /**
   * An abbreviated textual name for the address component, if available.
   * For example, an address component for the state of Alaska may have a longName of
   * "Alaska" and a short_name of "AK" using the 2-letter postal abbreviation.
   */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** An array of strings denoting the type of this address component. */
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AppPlaceDescriptionInput = {
  addressComponents?: InputMaybe<Array<AppPlaceDescriptionAddressComponentInput>>;
  /**
   * Allows the business to opt-out of having a book online button on their profile.
   *
   * This may take 24 hours to fully take effect.
   */
  bookingOptOut?: InputMaybe<Scalars['Boolean']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  formattedAddress?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp of when this place's data was last refreshed from Google Places API. */
  lastRefreshedFromGoogle?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Opening hours from Google Business Profile. */
  openingHours?: InputMaybe<PlaceOpeningHoursInput>;
  /** Partner identifier for this specific location. */
  partnerId?: InputMaybe<AppReferenceIdInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  /** Business types from Google Places API (populated by enrichment, typically readonly). */
  placeTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Human-readable display name for the primary business type from Google. */
  primaryTypeDisplayName?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['URLString']['input']>;
};

export type AppReferenceId = {
  /** The ID of as it is in the service. */
  id: Scalars['ID']['output'];
  /** The service that the ID is referencing to. */
  service: Scalars['String']['output'];
};

export type AppReferenceIdInput = {
  /** The ID of as it is in the service. */
  id: Scalars['ID']['input'];
  /** The service that the ID is referencing to. */
  service: Scalars['String']['input'];
};

export type AppSchedules = {
  /** The key to include in the next query of schedules. */
  nextKey?: Maybe<Scalars['String']['output']>;
  /** The schedules that were found */
  schedules: Array<Maybe<WebCrawlSchedule>>;
};

export type AppSubscriptionMutation = {
  update: UpdateAppSubscriptionMutation;
};

export type AppSuggestionsInfo = {
  /** Unique ID for the query type */
  _id: Scalars['ID']['output'];
  /** Total number of FAQ-type suggestions */
  faq: Scalars['Int']['output'];
  /** Total number of HISTORICAL-type suggestions */
  historical: Scalars['Int']['output'];
  /** Total number of INTENT-type suggestions */
  intent: Scalars['Int']['output'];
  /** Additional metadata about suggestion generation */
  metadata?: Maybe<SuggestionsMetadata>;
  /** Total number of all suggestions across all types */
  total: Scalars['Int']['output'];
};

export type AppTemplateInput = {
  /** The type of the account linking. This tells us how to redeem the token for PII. */
  accountLinkType?: InputMaybe<Scalars['String']['input']>;
  /** The unique ID of the google action that the app is linked to. */
  actionsOnGoogleId?: InputMaybe<Scalars['String']['input']>;
  /** The category that the app will fall in to when published to Alexa. */
  alexaCategory?: InputMaybe<Scalars['String']['input']>;
  /** The unique ID of the alexa skill that the app is linked to. */
  alexaSkillId?: InputMaybe<Scalars['String']['input']>;
  /**
   * URL of the original banner image with aspect ratio of 16:9 and minimum dimensions of 1920x1080.
   *
   * Required by Actions on Google
   */
  banner?: InputMaybe<Scalars['String']['input']>;
  /** The location of the collaboration agreement between the app and XAPP. */
  collaborationAgreementUrl?: InputMaybe<Scalars['String']['input']>;
  /**
   * The description for the app.
   *
   * The description cannot be more than 4000 characters.
   */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Example phrases the help users know how to use the app.
   *
   * At least three are required for publication.
   */
  examplePhrases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**
   * URL to the original icon file before transformation.
   *
   * Aspect ration must be 1:1 and minimum dimensions are 512x512.
   */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Allows stentor_admins to view and add notes to apps for internal use. */
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  /** The phrase a user must speak to wake the app up on a specific platform. */
  invocationName?: InputMaybe<Scalars['String']['input']>;
  /** Allows app-specific overriding of IPRights. */
  ipRights?: InputMaybe<IpRightsInput>;
  /**
   * Keywords to help when searching directories for the app
   *
   * Max of 30 keywords are allowed.
   */
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**
   * Banner that is 1920x1080.
   *
   * Required by Actions on Google
   */
  largeBanner?: InputMaybe<Scalars['String']['input']>;
  /**
   * A large icon for the app, 512x512 PNG
   *
   * Required for Alexa
   */
  largeIcon?: InputMaybe<Scalars['String']['input']>;
  /**
   * A medium icon for the app, 192x192 PNG.
   *
   * Required for Actions On Google
   */
  mediumIcon?: InputMaybe<Scalars['String']['input']>;
  /** The human-readable name of the app. */
  name: Scalars['String']['input'];
  /** URL to the privacy policy for the app. */
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  /**
   * A small icon for the app, 108x108 PNG
   *
   * Required for Alexa
   */
  smallIcon?: InputMaybe<Scalars['String']['input']>;
  stripeProductId?: InputMaybe<Scalars['String']['input']>;
  /** The subscription ID that is linked to this app in Stripe. */
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The summary of the app.
   *
   * Shorter than the description, maximum 160 characters.
   */
  summary?: InputMaybe<Scalars['String']['input']>;
  /** The type of template that the app is to build from. */
  templateType: AppTemplateType;
  /** URL to the terms of use for the app */
  termsOfUseUrl?: InputMaybe<Scalars['String']['input']>;
  /** Instructions for platform testers on how to test the app. */
  testingInstructions?: InputMaybe<Scalars['String']['input']>;
  /** Contains fields related to publishing the app to various platforms such as dialogflow or alexa. */
  thirdPartyDeployments?: InputMaybe<ThirdPartyDeploymentsInput>;
};

export enum AppTemplateType {
  OcStudioStarterTemplate = 'OC_STUDIO_STARTER_TEMPLATE',
  PodcastTemplate = 'PODCAST_TEMPLATE',
  RadioTemplate = 'RADIO_TEMPLATE'
}

/** Remote tests that can be executed for the app. */
export type AppTest = {
  /** The unique identifier of the app that the test is linked to. */
  appId: Scalars['ID']['output'];
  /** COnfigurations for executing the test. */
  config?: Maybe<TestConfig>;
  /** The time that the test was created.  Format: ISO 8601 */
  createdOn: Scalars['String']['output'];
  /** Utterance Test Only: The expected result of the utterance test. */
  expectedResult?: Maybe<ExpectedUtteranceTestResult>;
  /** A list of the test history. */
  history?: Maybe<Array<Maybe<TestHistory>>>;
  /** Utterance Tests Only: The platform that the test should run on.  If not present, it will run on all platforms. */
  platform?: Maybe<Scalars['String']['output']>;
  /** Do Nothing Tests Only: The result of the test. */
  result?: Maybe<Scalars['String']['output']>;
  /** The state that the test is currently in. If there is no state, then the test was never executed. */
  state?: Maybe<TestState>;
  /** The unique identifier for the test. */
  testId: Scalars['ID']['output'];
  /** The type of tests that this is. */
  testType: Scalars['String']['output'];
  /** Utterance Tests Only: The utterance that the test is executing for. */
  utterance?: Maybe<Scalars['String']['output']>;
};

export enum AppUsageInterval {
  Day = 'day',
  Hour = 'hour',
  Month = 'month',
  Week = 'week',
  Year = 'year'
}

export type AppUsageStat = {
  /** ID of the organization that contains the app */
  appId: Scalars['ID']['output'];
  /** A CSV formatted output of the stats found. */
  csv: UsageStatCsvReturn;
  intervals: Array<Maybe<UsageStat>>;
  newUsers: Scalars['Int']['output'];
  returningUsers: Scalars['Int']['output'];
  totalSessions: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
};

export type AppUsageStats = {
  /** The kendra documents that are currently downloaded to the app. */
  kendraDocs: MeteredStat;
};

export type AppWebsiteData = {
  /**
   * Calls to action such as "Free Quote", "Schedule Consultation".
   *
   * These can be used as suggestion chips.
   */
  callsToAction?: Maybe<Array<Scalars['String']['output']>>;
  /** The detected Content Management System (CMS) of the website. */
  cms?: Maybe<Scalars['String']['output']>;
  /** The last time that the crawl was completed that gathered this data. */
  crawlDate?: Maybe<Scalars['DateTime']['output']>;
  /** The executionId of the last crawl that collected this data. */
  crawlExecutionId?: Maybe<Scalars['String']['output']>;
  /** Primary theme color, hex value, based on an image of the website. */
  primaryColor?: Maybe<Scalars['String']['output']>;
  /** Secondary color, hex value, that complements the primary color on the website. */
  secondaryColor?: Maybe<Scalars['String']['output']>;
};

export type AppWebsiteDataInput = {
  /**
   * Calls to action such as "Free Quote", "Schedule Consultation".
   *
   * These can be used as suggestion chips.
   */
  callsToAction?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The detected Content Management System (CMS) of the website. */
  cms?: InputMaybe<Scalars['String']['input']>;
  /** The last time that the crawl was completed that gathered this data. */
  crawlDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The executionId of the last crawl that collected this data. */
  crawlExecutionId?: InputMaybe<Scalars['String']['input']>;
  /** Primary theme color, hex value, based on an image of the website. */
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  /** Secondary color, hex value, that complements the primary color on the website. */
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Metadata about available filter values for the apps list.
 * Contains unique values with counts for each filterable field to populate UI dropdowns.
 */
export type AppsFilterMetadata = {
  /**
   * Unique organization types with counts (if applicable).
   * Not yet implemented — always returns an empty array.
   */
  organizationTypes: Array<FilterBucket>;
  /** Unique status types with counts, sorted by count descending. */
  statusTypes: Array<FilterBucket>;
};

/** A collections query which returns a collection of apps */
export type AppsQuery = {
  /** A subset of apps that were viewed. */
  apps?: Maybe<Array<Maybe<SearchedApp>>>;
  /** The total number of apps that were found in the query */
  total: Scalars['Int']['output'];
};

export type AuditEntryDetail = {
  /** Duration in milliseconds */
  durationMs: Scalars['Int']['output'];
  /** Error message */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Integration ID */
  integrationId: Scalars['String']['output'];
  /** HTTP method or protocol */
  method: Scalars['String']['output'];
  /** Request body (truncated to 50KB) */
  requestBody?: Maybe<Scalars['String']['output']>;
  /** Request headers (auth tokens redacted) */
  requestHeaders?: Maybe<Scalars['JSON']['output']>;
  /** Response body (truncated to 50KB) */
  responseBody?: Maybe<Scalars['String']['output']>;
  /** Response headers */
  responseHeaders?: Maybe<Scalars['JSON']['output']>;
  /** Order within the chain */
  sequence: Scalars['Int']['output'];
  /** HTTP status code */
  statusCode: Scalars['Int']['output'];
  /** Human-readable step description */
  stepDescription?: Maybe<Scalars['String']['output']>;
  /** ISO 8601 timestamp */
  timestamp: Scalars['DateTime']['output'];
  /** Endpoint URL */
  url: Scalars['String']['output'];
  /** Whether this call resulted in an error */
  wasError: Scalars['Boolean']['output'];
};

export type AuditEntrySummary = {
  /** Duration of the call in milliseconds */
  durationMs: Scalars['Int']['output'];
  /** Truncated error message */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** HTTP method or protocol (e.g., POST, GET, SES) */
  method: Scalars['String']['output'];
  /** HTTP status code */
  statusCode: Scalars['Int']['output'];
  /** ISO 8601 timestamp */
  timestamp: Scalars['DateTime']['output'];
  /** Endpoint URL (sensitive params stripped) */
  url: Scalars['String']['output'];
  /** Whether this call resulted in an error */
  wasError: Scalars['Boolean']['output'];
};

export enum AuthOrigin {
  /** Auth0's third-party authentication platform. */
  Auth0 = 'auth0',
  /** Amazon's Cognito authentication platform. */
  Cognito = 'cognito'
}

export enum AuthVerifyOrigin {
  Cognito = 'COGNITO'
}

export type BaseAppChannel = {
  /** URL for the directory listing. */
  directoryListing?: Maybe<Scalars['String']['output']>;
  /** URI where the channel can be accessed. */
  endPoint?: Maybe<Scalars['String']['output']>;
  /** The ID of the channel. */
  id: Scalars['String']['output'];
  /** The display name for the channel. */
  name?: Maybe<Scalars['String']['output']>;
  /** The lifecycle status of the app. */
  status?: Maybe<AppChannelStatus>;
  /** The type of channel */
  type: Scalars['String']['output'];
  /** Retrieves any events that are related to this specific app */
  usageEvents?: Maybe<TotalUsageEvents>;
  /**
   * ID of the NLU to use within app.nlu[].
   *
   * If it exists, the channel will use the provided NLU at runtime
   * to convert the raw text to an Intent
   *
   * If the value is "*", then it will pick the first available NLU within app.nlu[]
   */
  useNLU?: Maybe<Scalars['String']['output']>;
};


export type BaseAppChannelUsageEventsArgs = {
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAppNlu = {
  /** The reference ID for the NLU */
  id?: Maybe<Scalars['String']['output']>;
  /** The type of NLU. */
  type: Scalars['String']['output'];
};

export type BaseDisplay = {
  payload?: Maybe<Scalars['JSON']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type BaseHandlerPath = {
  actions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Conditions to be met. */
  conditions?: Maybe<Scalars['PathConditions']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  /**
   * Optional platform filter for the path.
   *
   * If set, the path will only apply to the specified platform.
   */
  platform?: Maybe<Scalars['String']['output']>;
};

export type BaseOpportunityAlert = {
  /** Registered alerts */
  alerts: Array<OpportunityAlertDetail>;
  /** Temporarily disable the alert */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** The Google PlaceID for the location */
  placeId?: Maybe<Scalars['String']['output']>;
};

export type BaseStudioTierPaymentAccount = {
  tier?: Maybe<StudioTierType>;
};

export type BaseSystemNotification = {
  /** A time when the notification was received */
  created: Scalars['DateTime']['output'];
  /** A unique identifier for the notification */
  id: Scalars['ID']['output'];
  /** The custom level that the notification should be at. */
  level: SystemNotificationLevel;
  /** A details description of the notification */
  message: Scalars['String']['output'];
  /** A title or name of the notification */
  name: Scalars['String']['output'];
};

export type BaseWebContent = {
  /** Unique ID for the web content */
  _id: Scalars['String']['output'];
  /** The meta description from the page */
  description?: Maybe<Scalars['String']['output']>;
  /** The domain without www prefix (e.g., 'example.com') */
  domain?: Maybe<Scalars['String']['output']>;
  /** The last time the website was updated. */
  lastUpdated: Scalars['DateTime']['output'];
  /** The name of the content (page title) */
  name: Scalars['String']['output'];
  /** The original text length before truncation */
  originalTextLength?: Maybe<Scalars['Int']['output']>;
  /** The URL path (e.g., '/about/team') */
  path?: Maybe<Scalars['String']['output']>;
  /**
   * The raw-text of the content.
   *
   * For websites, this will be the text of the website with the HTML removed.
   */
  text: Scalars['String']['output'];
  /** The type of content that was parsed. */
  type: WebContentType;
  /** The full URL of the web content */
  url: Scalars['String']['output'];
};

export type BespokenDataStream = {
  token: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type BespokenDataStreamInput = {
  token: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type BillingContact = {
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type BillingContactInput = {
  /**
   * The email of the contact.
   *
   * Required
   */
  email: Scalars['String']['input'];
  /** The name of the contact */
  name: Scalars['String']['input'];
  /**
   * The phone number of the contact.
   *
   * Optional
   */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type BlacklistedWebsite = {
  /** The user that blacklisted the website. */
  blacklistedBy?: Maybe<Scalars['String']['output']>;
  /** The date which the website was blacklisted */
  createdOn: Scalars['DateTime']['output'];
  /** URL of the blacklisted website. */
  url: Scalars['String']['output'];
};

export type BrandContact = {
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type BrandContactInput = {
  /**
   * The email of the contact.
   *
   * Required
   */
  email: Scalars['String']['input'];
  /** The name of the contact */
  name: Scalars['String']['input'];
  /**
   * The phone number of the contact.
   *
   * Optional
   */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum BusinessDayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type BusinessHourPeriod = {
  open: BusinessHourPeriodDetail;
};

export type BusinessHourPeriodDetail = {
  day: BusinessDayOfWeek;
  time: Scalars['DateTime']['output'];
};

export type BusinessHourPeriodDetailInput = {
  /** The day that the period relates to. */
  day: BusinessDayOfWeek;
  time: Scalars['time_String_NotNull_format_date']['input'];
};

export type BusinessHourPeriodInput = {
  open: BusinessHourPeriodDetailInput;
};

export type BusinessHours = {
  periods: Array<BusinessHourPeriod>;
};

export type BusinessHoursInput = {
  /** Each day that the busines is open. */
  periods: Array<BusinessHourPeriodInput>;
};

/**
 * Source of business hours definition used for analytics calculations.
 *
 * DEFAULT (Monday-Friday 9 AM - 5 PM, local time) is the standard used across the
 * fleet and is what's applied when no source is specified. PLACE and APP are explicit
 * overrides; AUTO reproduces the legacy "best available source" detection.
 *
 * Note: businesses that report 24/7 hours (e.g. for after-hours answering services)
 * would have every lead counted as "inside hours" under PLACE — DEFAULT avoids that so
 * after-hours leads are still surfaced.
 */
export enum BusinessHoursSource {
  /**
   * Using hours configured at the app level (businessHours field).
   * These are manually configured business hours in the app settings.
   */
  App = 'APP',
  /**
   * Auto-detect the best available source (PLACE > APP > DEFAULT).
   * Falls back to DEFAULT (Mon-Fri 9-5) when no PLACE or APP hours are configured.
   */
  Auto = 'AUTO',
  /**
   * Using default standard business hours (Monday-Friday 9 AM - 5 PM, local time).
   * This is the fleet-wide standard and the default when no source is specified.
   */
  Default = 'DEFAULT',
  /**
   * Using hours from Google Business Profile (place/GBP hours).
   * These are the actual hours the business has set in their GBP listing.
   */
  Place = 'PLACE'
}

/**
 * A business location marker for the map view.
 * Represents a single app/business location with its geographic position.
 */
export type BusinessLocationMarker = {
  /** The formatted address of the business (if available) */
  address?: Maybe<Scalars['String']['output']>;
  /** The app ID for this business location */
  appId: Scalars['ID']['output'];
  /** The city of the business (if available) */
  city?: Maybe<Scalars['String']['output']>;
  /** Number of high-value leads for this location */
  highValueLeadCount: Scalars['Int']['output'];
  /** Total number of leads for this business location (within the filtered date range) */
  leadCount: Scalars['Int']['output'];
  /** Sample of individual leads at this location for hover tooltips. */
  leads: Array<MapLead>;
  /** The geographic coordinates of the business */
  location: GeoPoint;
  /** The name of the business */
  name: Scalars['String']['output'];
  /** The state/province of the business (if available) */
  state?: Maybe<Scalars['String']['output']>;
  /** The zip/postal code of the business (if available) */
  zipCode?: Maybe<Scalars['String']['output']>;
};


/**
 * A business location marker for the map view.
 * Represents a single app/business location with its geographic position.
 */
export type BusinessLocationMarkerLeadsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type CmsMutation = {
  create: CreateCmsReturn;
  /** Update operations for CMS tokens related to the app. */
  update: CmsUpdateMutation;
};


export type CmsMutationUpdateArgs = {
  tokenId: Scalars['ID']['input'];
};

export type CmsToken = {
  /** The appId of the app that the token is associated with. */
  appId?: Maybe<Scalars['ID']['output']>;
  /** The day the token was created. */
  created: Scalars['DateTime']['output'];
  /** The last time the token was used. */
  lastUsed?: Maybe<Scalars['DateTime']['output']>;
  /** A partial human-readable portion of the token */
  mask: Scalars['String']['output'];
  /** The organizationId of the organization that the token is associated with. */
  organizationId?: Maybe<Scalars['ID']['output']>;
  /** The permissions that the token grants. */
  scope: Array<Maybe<Scalars['String']['output']>>;
  /** The ID of the token that was created */
  tokenId: Scalars['ID']['output'];
};

export type CmsUpdateMutation = {
  /** Removes the CMS token provided. */
  delete: Scalars['String']['output'];
};

export type CrmAvailabilityClass = {
  /**
   * Maximum number of appointments that can be scheduled per day for this type.
   *
   * If not provided, it is assumed to be unlimited.
   */
  appointmentsPerDay?: Maybe<Scalars['Int']['output']>;
  /** Make the current day available until a specific time (e.g. "16:00") for this availability class specifically. */
  currentDayAvailableUntil?: Maybe<Scalars['String']['output']>;
  /** ID for the availability class, typically the slugged name. */
  id: Scalars['String']['output'];
  /** If true, this availability class is only for leads and not for appointments as they typically require more information and followup. */
  leadOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Human readable name of the availability class */
  name: Scalars['String']['output'];
  /**
   * Minimum number of days out that can be scheduled for this type.
   *
   * This is independent of if the day is available or not.
   *
   * Value of 0 is the default if not provided, meaning same day could be available.
   */
  numberOfDaysOut?: Maybe<Scalars['Int']['output']>;
  /** Summary of the availability class.  This is used to describe the availability class so the AI can match it to user input.  It contains high level description as well as examples of input that would match to this class. */
  summary: Scalars['String']['output'];
};

export type CrmAvailabilityClassInput = {
  /**
   * Maximum number of appointments that can be scheduled per day for this type.
   *
   * If not provided, it is assumed to be unlimited.
   */
  appointmentsPerDay?: InputMaybe<Scalars['Int']['input']>;
  /** Make the current day available until a specific time (e.g. "16:00") for this availability class specifically. */
  currentDayAvailableUntil?: InputMaybe<Scalars['String']['input']>;
  /** ID for the availability class, typically the slugged name. */
  id: Scalars['String']['input'];
  /** If true, this availability class is only for leads and not for appointments as they typically require more information and followup. */
  leadOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Human readable name of the availability class */
  name: Scalars['String']['input'];
  /**
   * Minimum number of days out that can be scheduled for this type.
   *
   * This is independent of if the day is available or not.
   *
   * Value of 0 is the default if not provided, meaning same day could be available.
   */
  numberOfDaysOut?: InputMaybe<Scalars['Int']['input']>;
  /** Summary of the availability class.  This is used to describe the availability class so the AI can match it to user input.  It contains high level description as well as examples of input that would match to this class. */
  summary: Scalars['String']['input'];
};

export type CrmDateTime = {
  /** ISO-8601 for the date, in the format YYYY-MM-dd */
  date?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 for time, in the format HH:mm:ss */
  time?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 timezone offset string in the format -05:00 or Z */
  tz?: Maybe<Scalars['String']['output']>;
};

export type CrmDateTimeInput = {
  /** ISO-8601 for the date, in the format YYYY-MM-dd */
  date?: InputMaybe<Scalars['String']['input']>;
  /** ISO-8601 for time, in the format HH:mm:ss */
  time?: InputMaybe<Scalars['String']['input']>;
  /** ISO-8601 timezone offset string in the format -05:00 or Z */
  tz?: InputMaybe<Scalars['String']['input']>;
};

export enum CrmDayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

/** A job type as known by the app's CRM integration, for the Studio job-type picker. */
export type CrmJobType = {
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** Maps a single job type to the availability class that governs its scheduling. */
export type CrmJobTypeAvailabilityClass = {
  /** The ID of the availability class this job type is mapped to. */
  classId: Scalars['String']['output'];
  /** The ID of the job type, as known by the CRM integration. */
  jobTypeId: Scalars['String']['output'];
  /** Human readable name of the job type, if known. */
  jobTypeName?: Maybe<Scalars['String']['output']>;
  /** Where this mapping came from - the AI suggester, or a user's explicit choice. */
  source?: Maybe<Scalars['String']['output']>;
};

export type CrmJobTypeAvailabilityClassInput = {
  classId: Scalars['String']['input'];
  jobTypeId: Scalars['String']['input'];
  jobTypeName?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type CrmServiceAvailabilityBusyDayDescription = {
  /** The days of the week they are available to schedule appointments through the scheduler. */
  availableDays?: Maybe<Array<Maybe<CrmDayOfWeek>>>;
  /** Block the current day */
  blockCurrentDay?: Maybe<Scalars['Boolean']['output']>;
  /** Block the next business days */
  blockNextBusinessDays?: Maybe<Scalars['Int']['output']>;
  /** Block both Saturday & Sunday */
  blockWeekends?: Maybe<Scalars['Boolean']['output']>;
  /** Make the current day available until a specific time */
  currentDayAvailableUntil?: Maybe<Scalars['String']['output']>;
};

export type CrmServiceAvailabilityBusyDayDescriptionInput = {
  /** The days of the week they are available to schedule appointments through the scheduler. */
  availableDays?: InputMaybe<Array<InputMaybe<CrmDayOfWeek>>>;
  /** Block the current day */
  blockCurrentDay?: InputMaybe<Scalars['Boolean']['input']>;
  /** Block the next business days */
  blockNextBusinessDays?: InputMaybe<Scalars['Int']['input']>;
  /** Block both Saturday & Sunday */
  blockWeekends?: InputMaybe<Scalars['Boolean']['input']>;
  /** Make the current day available until a specific time */
  currentDayAvailableUntil?: InputMaybe<Scalars['String']['input']>;
};

export type CrmServiceAvailabilitySettings = {
  /** The customer specific "availability classes" that describes the scheduling strategy for job types. */
  availabilityClasses?: Maybe<Array<Maybe<CrmAvailabilityClass>>>;
  /** The days of the week they are available to schedule appointments through the scheduler. */
  availableDays?: Maybe<Array<Maybe<CrmDayOfWeek>>>;
  /** These are holidays or any other days specific to the business that they are not available for appointments. */
  blockedDays?: Maybe<Array<Maybe<CrmDateTime>>>;
  /** The default availability class (when the AI cannot figure it out) */
  defaultAvailabilityClass?: Maybe<Scalars['String']['output']>;
  /** The default busy days for the business. */
  defaultBusyDays?: Maybe<CrmServiceAvailabilityBusyDayDescription>;
  /** Job types, where we only schedule a few days (3) ahead */
  delayedJobTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * Forces every request to use this availability class, ignoring job type matching entirely.
   * Used by per-widget overrides (e.g. a campaign widget dedicated to one job type/class).
   */
  forceAvailabilityClass?: Maybe<Scalars['String']['output']>;
  /**
   * A deterministic job type -> availability class map, so the same job type always resolves
   * to the same class instead of relying on the AI to figure it out every time.
   */
  jobTypeClasses?: Maybe<Array<Maybe<CrmJobTypeAvailabilityClass>>>;
  /** Maximum total number of appointments a day that can be scheduled through the scheduler. */
  maxTotalDailyAppointments?: Maybe<Scalars['Int']['output']>;
};

export type CrmServiceAvailabilitySettingsInput = {
  /** The customer specific "availability classes" that describes the scheduling strategy for job types. */
  availabilityClasses?: InputMaybe<Array<InputMaybe<CrmAvailabilityClassInput>>>;
  /** The days of the week they are available to schedule appointments through the scheduler. */
  availableDays?: InputMaybe<Array<InputMaybe<CrmDayOfWeek>>>;
  /** These are holidays or any other days specific to the business that they are not available for appointments. */
  blockedDays?: InputMaybe<Array<InputMaybe<CrmDateTimeInput>>>;
  /** The default availability class (when the AI cannot figure it out) */
  defaultAvailabilityClass?: InputMaybe<Scalars['String']['input']>;
  /** The default busy days for the business. */
  defaultBusyDays?: InputMaybe<CrmServiceAvailabilityBusyDayDescriptionInput>;
  /** Job types, where we only schedule a few days (3) ahead */
  delayedJobTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**
   * Forces every request to use this availability class, ignoring job type matching entirely.
   * Used by per-widget overrides (e.g. a campaign widget dedicated to one job type/class).
   */
  forceAvailabilityClass?: InputMaybe<Scalars['String']['input']>;
  /**
   * A deterministic job type -> availability class map, so the same job type always resolves
   * to the same class instead of relying on the AI to figure it out every time.
   */
  jobTypeClasses?: InputMaybe<Array<InputMaybe<CrmJobTypeAvailabilityClassInput>>>;
  /** Maximum total number of appointments a day that can be scheduled through the scheduler. */
  maxTotalDailyAppointments?: InputMaybe<Scalars['Int']['input']>;
};

export enum CtaAnimation {
  Bounce = 'bounce',
  Pulse = 'pulse',
  Wiggle = 'wiggle'
}

/** The cadence details of a schedule, describing when it runs. */
export type Cadence = {
  /** The day of the month to run (1-28). Only set for monthly schedules. */
  dayOfMonth?: Maybe<Scalars['Int']['output']>;
  /** The days of the week to run. Only set for weekly schedules. */
  daysOfWeek?: Maybe<Array<Maybe<ScheduleDaysOfWeek>>>;
  /** The type of cadence: daily, weekly, or monthly. */
  type: ScheduleCadenceType;
};

export enum CadenceType {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

/**
 * A Campaign is a thin record layered over an existing form-widget channel and its
 * ContactCapture handler: an offer-specific booking link with its own canonical
 * attribution label.
 */
export type Campaign = {
  /** The app that this campaign belongs to. */
  appId: Scalars['ID']['output'];
  /** The booking link for this campaign (book.xapp.ai?key=<AppLink.key>). */
  bookingUrl?: Maybe<Scalars['String']['output']>;
  /** The stable, system-assigned primary key. This is the attribution/billing key. */
  campaignId: Scalars['ID']['output'];
  /**
   * The single, stable attribution label for this campaign. This — not the raw
   * utm_campaign off the URL — is the grouping key stamped onto bookings made
   * through this campaign's link.
   */
  canonicalSource: Scalars['String']['output'];
  /** The id of the form-widget channel that was minted for this campaign. */
  channelId: Scalars['ID']['output'];
  /** When the campaign was created. */
  createdAt: Scalars['DateTime']['output'];
  /** When the campaign offer stops being valid. */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** The id of the ContactCapture handler that was seeded for this campaign. */
  intentId: Scalars['ID']['output'];
  /**
   * When set, pins every booking through this campaign to a single job type by
   * forcing the handler's availability class, ignoring job-type matching entirely.
   */
  jobTypePin?: Maybe<Scalars['String']['output']>;
  /** The display name of the campaign, e.g. 'Drains Special'. */
  name: Scalars['String']['output'];
  /** The fine print / terms of the offer. */
  offerTerms?: Maybe<Scalars['String']['output']>;
  /** The offer's headline, e.g. '$50 Off Drain Cleaning'. */
  offerTitle?: Maybe<Scalars['String']['output']>;
  /** When the campaign offer starts being valid. */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** The lifecycle status of the campaign. */
  status: CampaignStatus;
  /** When the campaign was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The lifecycle status of a Campaign. */
export enum CampaignStatus {
  Archived = 'archived',
  Draft = 'draft',
  Ended = 'ended',
  Live = 'live'
}

export type CardDisplay = BaseDisplay & {
  accessibilityText?: Maybe<Scalars['String']['output']>;
  buttons?: Maybe<Array<Maybe<CardDisplayButton>>>;
  content?: Maybe<Scalars['String']['output']>;
  /** When present, if the image is clicked the provided website will open. */
  imageActionUrl?: Maybe<Scalars['String']['output']>;
  largeImageUrl?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<Scalars['JSON']['output']>;
  smallImageUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type CardDisplayButton = {
  openUrlAction: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CardDisplayButtonInput = {
  openUrlAction: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CardDisplayInput = {
  accessibilityText?: InputMaybe<Scalars['String']['input']>;
  buttons?: InputMaybe<Array<InputMaybe<CardDisplayButtonInput>>>;
  content?: InputMaybe<Scalars['String']['input']>;
  largeImageUrl?: InputMaybe<Scalars['String']['input']>;
  smallImageUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

/** Categorical aggregation bucket */
export type CategoryBucket = {
  /** Number of items in this category */
  count: Scalars['Int']['output'];
  /** The category key (e.g., source name, urgency level) */
  key: Scalars['String']['output'];
  /** Percentage of total items */
  percentage?: Maybe<Scalars['Float']['output']>;
  /** Number of unique appIds that contributed to this category */
  uniqueAppIds?: Maybe<Scalars['Int']['output']>;
};

/** @deprecated Use Lead type instead. */
export type CaughtLead = {
  /** Who/what handled the interaction: ai, human, self_serve, unknown. */
  agentType?: Maybe<Scalars['String']['output']>;
  /** An analysis of how the LLM came to its conclusion. */
  analysis?: Maybe<Scalars['String']['output']>;
  /** The ID of the app that this lead belongs to. */
  appId?: Maybe<Scalars['String']['output']>;
  /** The name of the app/business location that this lead belongs to. */
  appName?: Maybe<Scalars['String']['output']>;
  /**
   * Source used for insideBusinessHours calculation.
   * 'PLACE' = GBP hours, 'DEFAULT' = M-F 9am-5pm
   */
  businessHoursSource?: Maybe<Scalars['String']['output']>;
  /**
   * The local day of week when the lead was captured in the business's timezone.
   * 0=Sunday, 1=Monday, ..., 6=Saturday.
   */
  businessLocalDayOfWeek?: Maybe<Scalars['Int']['output']>;
  /**
   * The stable, system-assigned Campaign attribution key, resolved server-side from
   * the AppLink the booking came through. Undefined when not booked through a Campaign link.
   */
  campaignId?: Maybe<Scalars['String']['output']>;
  /** The Campaign's canonical attribution label — the actual grouping key for reporting. */
  canonicalSource?: Maybe<Scalars['String']['output']>;
  /** Vendor/tech that captured the raw interaction (e.g. xapp-ai, avoca, servicetitan). */
  capturePlatform?: Maybe<Scalars['String']['output']>;
  /** Product/surface used to capture it (e.g. form-widget, servicetitan-scheduler, mcp). */
  captureSurface?: Maybe<Scalars['String']['output']>;
  /** The transport mechanism through which the lead was captured. */
  channel?: Maybe<Scalars['String']['output']>;
  /** The company related to the lead. */
  company?: Maybe<Scalars['String']['output']>;
  /** A concise summary of the captured lead. */
  conciseSummary?: Maybe<Scalars['String']['output']>;
  /** How the customer engaged: phone, form, chat, email, sms, in_person. */
  contactMethod?: Maybe<Scalars['String']['output']>;
  /** The type of contact (SPAM, QUESTION, COMPLAINT, COMPLIMENT, SERVICE_REQUEST, EMPLOYMENT_INQUIRY, QUOTE_REQUEST). */
  contactType?: Maybe<Scalars['String']['output']>;
  /** Whether this lead has been converted to a paying customer. */
  converted?: Maybe<Scalars['Boolean']['output']>;
  /** When the lead was marked as converted (ISO 8601 timestamp). */
  convertedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Email of the user who marked this lead as converted. */
  convertedBy?: Maybe<Scalars['String']['output']>;
  /** The date that the lead was sent. */
  date: Scalars['DateTime']['output'];
  /** The environment that the lead was captured in. */
  environment?: Maybe<Scalars['String']['output']>;
  /** The type of form help requested. */
  formHelpType?: Maybe<Scalars['String']['output']>;
  /** The message from the form. */
  formMessage?: Maybe<Scalars['String']['output']>;
  /** Whether the lead is considered high value. */
  highValueLead?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Unique identifier for the lead from OpenSearch.
   * Only available when querying via caughtLeads or lead query.
   */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   * Whether the lead was captured during the business's actual operating hours.
   * Uses GBP hours when available, otherwise falls back to default hours.
   */
  insideBusinessHours?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether the lead was captured during default business hours (Monday-Friday 9am-5pm)
   * in the business's local timezone.
   */
  insideBusinessHoursDefault?: Maybe<Scalars['Boolean']['output']>;
  /** The integrations that the lead was successfully sent to. */
  integrationSent?: Maybe<Array<LeadSentToIntegration>>;
  /** The type of job requested (e.g., hvac, plumbing, electrical). */
  jobType?: Maybe<Scalars['String']['output']>;
  /** The lead data that was sent to the app. */
  lead?: Maybe<LeadData>;
  /**
   * The customer's preferred day of week for service.
   * 0=Sunday, 1=Monday, ..., 6=Saturday.
   * Calculated from the preferredDay field if it's a valid ISO date.
   */
  preferredDayOfWeek?: Maybe<Scalars['Int']['output']>;
  /** Capture / landing URL. */
  referral?: Maybe<Scalars['String']['output']>;
  /** The referring source of the lead (e.g., reserve_with_google, facebook, website). */
  referringSource?: Maybe<Scalars['String']['output']>;
  /** The type of service requested (INSTALLATION, REPAIR, MAINTENANCE, OTHER). */
  serviceType?: Maybe<Scalars['String']['output']>;
  /** The session that the lead is related to. */
  sessionId?: Maybe<Scalars['ID']['output']>;
  /** The origin platform of the lead (e.g., chat-widget, form-widget, email, jobber) */
  source?: Maybe<Scalars['String']['output']>;
  /** Vendor / system of record that delivered the lead (e.g. servicetitan, jobber, xapp-ai). */
  sourceSystem?: Maybe<Scalars['String']['output']>;
  /** A summary of the captured lead. */
  summary?: Maybe<Scalars['String']['output']>;
  /** The urgency of the message (LOW, MEDIUM, HIGH, URGENT, NOT_SPECIFIED). */
  urgency?: Maybe<Scalars['String']['output']>;
  /** The user that the lead is related to. */
  userId?: Maybe<Scalars['ID']['output']>;
  /** Marketing campaign (utm_campaign). Kept as a raw reference field only — not the attribution grouping key. */
  utmCampaign?: Maybe<Scalars['String']['output']>;
  /** Marketing medium (utm_medium): social, cpc, organic, referral, email, offline. */
  utmMedium?: Maybe<Scalars['String']['output']>;
  /** Marketing traffic source (utm_source). */
  utmSource?: Maybe<Scalars['String']['output']>;
};

/** @deprecated Use LeadsQuery type instead. */
export type CaughtLeadsResult = {
  /** The leads that were found. */
  leads: Array<CaughtLead>;
  /** The key to retrieve more leads or null if there are none left. */
  nextKey?: Maybe<Scalars['String']['output']>;
  /** The total number of leads that are available. */
  total: Scalars['Int']['output'];
};

export type CaughtOpportunityAlert = {
  /** The type of opportunity alert that was found. */
  oppAlertType: Scalars['String']['output'];
  /** The sessionId of the chat session that threw the opportunity alert. */
  sessionId: Scalars['String']['output'];
};

export type CaughtOpportunityAlertsResult = {
  /** The key to retrieve more opportunity alerts or null if there are none left. */
  nextKey?: Maybe<Scalars['String']['output']>;
  /** The opportunity alerts that were found. */
  oppAlerts: Array<CaughtOpportunityAlert>;
};

export type ChargeSummary = {
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  date: Scalars['String']['output'];
  paid: Scalars['Boolean']['output'];
};

/** A channel that is specific for apps to run on the Actions On Google. */
export type ChatWidgetAppChannel = BaseAppChannel & {
  /** Optional key used for basic authentication */
  accountKey?: Maybe<Scalars['String']['output']>;
  /** ActionBar configuration */
  actionBar?: Maybe<ActionBarConfig>;
  /** Auto-open widget based on URL patterns */
  autoOpenOnPattern?: Maybe<WidgetAutoOpenOnPattern>;
  /** Auto-open widget when viewport reaches this width */
  autoOpenOnWidth?: Maybe<Scalars['String']['output']>;
  /** URL for autocomplete suggestions */
  autocompleteSuggestionsUrl?: Maybe<Scalars['URLString']['output']>;
  /** The web location for the avatar */
  avatarUrl?: Maybe<Scalars['URL']['output']>;
  /** Display name for the bot */
  botName?: Maybe<Scalars['String']['output']>;
  /** Chat button configuration */
  chatButton?: Maybe<ChatWidgetChatButtonConfig>;
  /** Configurable messages settings */
  configurableMessages?: Maybe<WidgetConfigurableMessagesConfig>;
  /** Server connection configuration */
  connection?: Maybe<ChatWidgetServerConfig>;
  /** Call-to-action configuration */
  cta?: Maybe<CtaConfig>;
  /** Whether the widget is in direct mode */
  direct?: Maybe<Scalars['Boolean']['output']>;
  /** URL for the directory listing. */
  directoryListing?: Maybe<Scalars['String']['output']>;
  /** Widget is disabled */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** URI where the channel can be accessed. */
  endPoint?: Maybe<Scalars['String']['output']>;
  /** Footer configuration */
  footer?: Maybe<ChatWidgetFooterConfig>;
  /** Optional key linking to a form widget. When set, the chat widget can launch the linked form widget. */
  formWidgetKey?: Maybe<Scalars['String']['output']>;
  /** Header configuration */
  header?: Maybe<ChatWidgetHeaderConfig>;
  /** The ID of the channel. */
  id: Scalars['String']['output'];
  /** Input field configuration */
  input?: Maybe<ChatWidgetInputConfig>;
  /** The key that goes in the url when retrieving the chat widget to apply custom themes. */
  key?: Maybe<Scalars['String']['output']>;
  /** Menu configuration */
  menu?: Maybe<ChatWidgetMenuConfig>;
  /** Middleware URL for processing requests */
  middlewareUrl?: Maybe<Scalars['String']['output']>;
  /** The display name for the channel. */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * The backend for the URL
   * @deprecated Use connection
   */
  serverUrl?: Maybe<Scalars['URLString']['output']>;
  /** Session expiration time */
  sessionExpiration?: Maybe<Scalars['String']['output']>;
  /** The lifecycle status of the app. */
  status?: Maybe<AppChannelStatus>;
  /** Theme for the widget */
  theme?: Maybe<ChatWidgetTheme>;
  /** The type of channel */
  type: Scalars['String']['output'];
  /** Typing status configuration */
  typingStatus?: Maybe<ChatWidgetTypingStatusConfig>;
  /** URL handling configuration */
  urls?: Maybe<ChatWidgetAppChannelUrlsConfig>;
  /** Retrieves any events that are related to this specific app */
  usageEvents?: Maybe<TotalUsageEvents>;
  /**
   * ID of the NLU to use within app.nlu[].
   *
   * If it exists, the channel will use the provided NLU at runtime
   * to convert the raw text to an Intent
   *
   * If the value is "*", then it will pick the first available NLU within app.nlu[]
   */
  useNLU?: Maybe<Scalars['String']['output']>;
};


/** A channel that is specific for apps to run on the Actions On Google. */
export type ChatWidgetAppChannelUsageEventsArgs = {
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type ChatWidgetAppChannelInput = {
  /** Optional key used for basic authentication */
  accountKey?: InputMaybe<Scalars['String']['input']>;
  /** ActionBar configuration */
  actionBar?: InputMaybe<ActionBarConfigInput>;
  autoOpenOnPattern?: InputMaybe<WidgetAutoOpenOnPatternInput>;
  autoOpenOnWidth?: InputMaybe<Scalars['String']['input']>;
  autocompleteSuggestionsUrl?: InputMaybe<Scalars['URLString']['input']>;
  /** The web location for the avatar */
  avatarUrl?: InputMaybe<Scalars['URL']['input']>;
  botName?: InputMaybe<Scalars['String']['input']>;
  chatButton?: InputMaybe<ChatWidgetChatButtonConfigInput>;
  configurableMessages?: InputMaybe<WidgetConfigurableMessagesConfigInput>;
  connection?: InputMaybe<ChatWidgetServerConfigInput>;
  cta?: InputMaybe<CtaConfigInput>;
  direct?: InputMaybe<Scalars['Boolean']['input']>;
  /** URL for the directory listing. */
  directoryListing?: InputMaybe<Scalars['String']['input']>;
  /** Widget is disabled */
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** URI where the channel can be accessed. */
  endPoint?: InputMaybe<Scalars['String']['input']>;
  footer?: InputMaybe<ChatWidgetFooterConfigInput>;
  /** Optional key linking to a form widget. When set, the chat widget can launch the linked form widget. */
  formWidgetKey?: InputMaybe<Scalars['String']['input']>;
  header?: InputMaybe<ChatWidgetHeaderConfigInput>;
  /**
   * The ID of the channel.
   *
   * When calling a "CreateChannel" function, then ID will be
   * used to determine if the channel should be inserted or updated.
   *
   * If the ID is provided and already exists, the channel will be
   * updated.  Otherwise the channel will be inserted and an ID will be
   * generated.
   */
  id?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<ChatWidgetInputConfigInput>;
  menu?: InputMaybe<ChatWidgetMenuConfigInput>;
  middlewareUrl?: InputMaybe<Scalars['URLString']['input']>;
  /** The display name for the channel. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * The backend for the URL
   *
   * @deprecated use connection
   */
  serverUrl?: InputMaybe<Scalars['URLString']['input']>;
  sessionExpiration?: InputMaybe<Scalars['String']['input']>;
  /** Theme for the widget */
  theme?: InputMaybe<ChatWidgetThemeInput>;
  /** The type of channel */
  type: Scalars['String']['input'];
  typingStatus?: InputMaybe<ChatWidgetTypingStatusConfigInput>;
  urls?: InputMaybe<ChatWidgetAppChannelUrlsConfigInput>;
  /**
   * ID of the NLU to use within app.nlu[].
   *
   * If it exists, the channel will use the provided NLU at runtime
   * to convert the raw text to an Intent
   *
   * If the value is "*", then it will pick the first available NLU within app.nlu[]
   */
  useNLU?: InputMaybe<Scalars['String']['input']>;
};

export type ChatWidgetAppChannelUrlBehaviorBase = {
  type: ChatWidgetAppChannelWidgetUrlBehaviorType;
};

export type ChatWidgetAppChannelUrlBehaviorInput = {
  height?: InputMaybe<Scalars['Int']['input']>;
  type: ChatWidgetAppChannelWidgetUrlBehaviorType;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type ChatWidgetAppChannelUrlBehaviorNewTab = ChatWidgetAppChannelUrlBehaviorBase & {
  type: ChatWidgetAppChannelWidgetUrlBehaviorType;
};

export type ChatWidgetAppChannelUrlBehaviorNewWindow = ChatWidgetAppChannelUrlBehaviorBase & {
  height?: Maybe<Scalars['Int']['output']>;
  type: ChatWidgetAppChannelWidgetUrlBehaviorType;
  width?: Maybe<Scalars['Int']['output']>;
};

/** @deprecated(reason: "Use ChatWidgetAppChannelUrlBehaviorInput") */
export type ChatWidgetAppChannelUrlBehaviorNewWindowWinowInput = {
  height?: InputMaybe<Scalars['Int']['input']>;
  type: ChatWidgetAppChannelWidgetUrlBehaviorType;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type ChatWidgetAppChannelUrlBehaviorSameWindow = ChatWidgetAppChannelUrlBehaviorBase & {
  type: ChatWidgetAppChannelWidgetUrlBehaviorType;
};

export type ChatWidgetAppChannelUrlPolicy = {
  behavior: ChatWidgetAppChannelUrlBehaviorBase;
  pattern: Scalars['String']['output'];
};

export type ChatWidgetAppChannelUrlPolicyInput = {
  behavior: ChatWidgetAppChannelUrlBehaviorInput;
  pattern: Scalars['String']['input'];
};

export type ChatWidgetAppChannelUrlsConfig = {
  defaultBehavior: ChatWidgetAppChannelUrlBehaviorBase;
  policies: Array<Maybe<ChatWidgetAppChannelUrlPolicy>>;
};

export type ChatWidgetAppChannelUrlsConfigInput = {
  defaultBehavior: ChatWidgetAppChannelUrlBehaviorInput;
  policies: Array<InputMaybe<ChatWidgetAppChannelUrlPolicyInput>>;
};

export enum ChatWidgetAppChannelWidgetUrlBehaviorType {
  NewTab = 'newTab',
  NewWindow = 'newWindow',
  SameWindow = 'sameWindow'
}

export type ChatWidgetBorderTheme = {
  /** Border color */
  color?: Maybe<Scalars['String']['output']>;
  /** Border radius for rounded corners */
  radius?: Maybe<Scalars['String']['output']>;
  /** Border width */
  width?: Maybe<Scalars['String']['output']>;
};

export type ChatWidgetBorderThemeInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  radius?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['String']['input']>;
};

export type ChatWidgetBrandingConfig = {
  /** Whether branding is enabled */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Branding text to display */
  text?: Maybe<Scalars['String']['output']>;
};

export type ChatWidgetBrandingConfigInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ChatWidgetBrandingTheme = {
  /** Text styling for branding elements */
  text?: Maybe<ChatWidgetTextTheme>;
};

export type ChatWidgetBrandingThemeInput = {
  text?: InputMaybe<ChatWidgetTextThemeInput>;
};

export type ChatWidgetButtonAnimationTheme = {
  /** Opacity level for button animations */
  opacity?: Maybe<Scalars['Float']['output']>;
  /** Primary color for button animations */
  primaryColor?: Maybe<Scalars['String']['output']>;
  /** Secondary color for button animations */
  secondaryColor?: Maybe<Scalars['String']['output']>;
};

export type ChatWidgetButtonAnimationThemeInput = {
  opacity?: InputMaybe<Scalars['Float']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
};

export type ChatWidgetButtonTheme = {
  /** Background color of the button */
  background?: Maybe<Scalars['String']['output']>;
  /** Text color for the button */
  color?: Maybe<Scalars['String']['output']>;
  /** Background color when hovering over the button */
  hoverBackground?: Maybe<Scalars['String']['output']>;
  /** Width of the button */
  width?: Maybe<Scalars['String']['output']>;
};

export type ChatWidgetButtonThemeInput = {
  background?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  hoverBackground?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['String']['input']>;
};

export type ChatWidgetCarouselTheme = {
  /** Button styling for carousel items */
  button?: Maybe<ChatWidgetButtonTheme>;
  /** Text styling for carousel subtitles */
  subtitle?: Maybe<ChatWidgetTextTheme>;
  /** Text styling for carousel titles */
  title?: Maybe<ChatWidgetTextTheme>;
};

export type ChatWidgetCarouselThemeInput = {
  button?: InputMaybe<ChatWidgetButtonThemeInput>;
  subtitle?: InputMaybe<ChatWidgetTextThemeInput>;
  title?: InputMaybe<ChatWidgetTextThemeInput>;
};

export type ChatWidgetChatButtonConfig = {
  /** URL to an image for the button. Recommended to be 24x24 in size. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  tabIndex?: Maybe<Scalars['String']['output']>;
};

export type ChatWidgetChatButtonConfigInput = {
  /** URL to an image for the button. Recommended to be 24x24 in size. */
  imageUrl?: InputMaybe<Scalars['URLString']['input']>;
  tabIndex?: InputMaybe<Scalars['String']['input']>;
};

export type ChatWidgetChatButtonTheme = {
  /** Animation configuration for the chat button */
  animation?: Maybe<ChatWidgetButtonAnimationTheme>;
  /** Widget chat button color */
  background?: Maybe<Scalars['String']['output']>;
  border?: Maybe<ChatWidgetBorderTheme>;
  /** Size configuration for the chat button image */
  imageSize?: Maybe<ChatWidgetSizeTheme>;
  /** Widget margin */
  margin?: Maybe<ChatWidgetMarginsTheme>;
};

export type ChatWidgetChatButtonThemeInput = {
  animation?: InputMaybe<ChatWidgetButtonAnimationThemeInput>;
  /** Widget chat button color */
  background?: InputMaybe<Scalars['String']['input']>;
  border?: InputMaybe<ChatWidgetBorderThemeInput>;
  imageSize?: InputMaybe<ChatWidgetSizeThemeInput>;
  /** Widget margin */
  margin?: InputMaybe<ChatWidgetMarginsThemeInput>;
};

export type ChatWidgetClearButtonConfig = {
  /** Tab index for the clear button */
  tabIndex?: Maybe<Scalars['String']['output']>;
};

export type ChatWidgetClearButtonConfigInput = {
  tabIndex?: InputMaybe<Scalars['String']['input']>;
};

export type ChatWidgetContentTheme = {
  /** Background color of the content area */
  background?: Maybe<Scalars['String']['output']>;
};

export type ChatWidgetContentThemeInput = {
  background?: InputMaybe<Scalars['String']['input']>;
};

export type ChatWidgetCtaTheme = {
  /** Background color for call-to-action elements */
  background?: Maybe<Scalars['String']['output']>;
  /** Border styling for CTA elements */
  border?: Maybe<ChatWidgetBorderTheme>;
  /** Text styling for CTA text */
  text?: Maybe<ChatWidgetTextTheme>;
};

export type ChatWidgetCtaThemeInput = {
  background?: InputMaybe<Scalars['String']['input']>;
  border?: InputMaybe<ChatWidgetBorderThemeInput>;
  text?: InputMaybe<ChatWidgetTextThemeInput>;
};

export type ChatWidgetFooterConfig = {
  /** Branding configuration for the footer */
  branding?: Maybe<ChatWidgetBrandingConfig>;
  /** Clear button configuration */
  clearButton?: Maybe<ChatWidgetClearButtonConfig>;
  /** Send button configuration */
  sendButton?: Maybe<ChatWidgetSendButtonConfig>;
};

export type ChatWidgetFooterConfigInput = {
  branding?: InputMaybe<ChatWidgetBrandingConfigInput>;
  clearButton?: InputMaybe<ChatWidgetClearButtonConfigInput>;
  sendButton?: InputMaybe<ChatWidgetSendButtonConfigInput>;
};

export type ChatWidgetFooterTheme = {
  /** Background color of the footer */
  background?: Maybe<Scalars['String']['output']>;
  /** Border styling for the footer */
  border?: Maybe<ChatWidgetBorderTheme>;
  /** Branding theme configuration */
  branding?: Maybe<ChatWidgetBrandingTheme>;
};

export type ChatWidgetFooterThemeInput = {
  background?: InputMaybe<Scalars['String']['input']>;
  border?: InputMaybe<ChatWidgetBorderThemeInput>;
  branding?: InputMaybe<ChatWidgetBrandingThemeInput>;
};

export type ChatWidgetHeaderActionsConfig = {
  /** Whether to show the cancel button */
  cancel?: Maybe<Scalars['Boolean']['output']>;
  /** Tab index for the cancel button */
  cancelTabIndex?: Maybe<Scalars['String']['output']>;
  /** Whether to show the minimize button */
  minimize?: Maybe<Scalars['Boolean']['output']>;
  /** Tab index for the minimize button */
  minimizeTabIndex?: Maybe<Scalars['String']['output']>;
  /** Whether to show the refresh button */
  refresh?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to show confirmation dialog when refreshing */
  refreshShowConfirmation?: Maybe<Scalars['Boolean']['output']>;
  /** Tab index for the refresh button */
  refreshTabIndex?: Maybe<Scalars['String']['output']>;
};

export type ChatWidgetHeaderConfig = {
  /** Action buttons configuration for the header */
  actions?: Maybe<ChatWidgetHeaderActionsConfig>;
  /** Whether to center-align the header text */
  alignTextCenter?: Maybe<Scalars['Boolean']['output']>;
  /** Status configuration for the header */
  status?: Maybe<ChatWidgetHeaderStatusConfig>;
  /** Subtitle configuration for the header */
  subtitle?: Maybe<ChatWidgetHeaderSubtitleConfig>;
};

export type ChatWidgetHeaderConfigActionsInput = {
  cancel?: InputMaybe<Scalars['Boolean']['input']>;
  cancelTabIndex?: InputMaybe<Scalars['String']['input']>;
  minimize?: InputMaybe<Scalars['Boolean']['input']>;
  minimizeTabIndex?: InputMaybe<Scalars['String']['input']>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  refreshShowConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  refreshTabIndex?: InputMaybe<Scalars['String']['input']>;
};

export type ChatWidgetHeaderConfigInput = {
  actions?: InputMaybe<ChatWidgetHeaderConfigActionsInput>;
  alignTextCenter?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ChatWidgetHeaderStatusConfigInput>;
  subtitle?: InputMaybe<ChatWidgetHeaderSubtitleConfigInput>;
};

export type ChatWidgetHeaderStatusConfig = {
  /** Text to display when status is away */
  away?: Maybe<Scalars['String']['output']>;
  /** Text to display when connecting */
  connecting?: Maybe<Scalars['String']['output']>;
  /** Text to display when status is offline */
  offline?: Maybe<Scalars['String']['output']>;
  /** Text to display when status is online */
  online?: Maybe<Scalars['String']['output']>;
};

export type ChatWidgetHeaderStatusConfigInput = {
  away?: InputMaybe<Scalars['String']['input']>;
  connecting?: InputMaybe<Scalars['String']['input']>;
  offline?: InputMaybe<Scalars['String']['input']>;
  online?: InputMaybe<Scalars['String']['input']>;
};

export type ChatWidgetHeaderSubtitleConfig = {
  /** Whether the subtitle is enabled */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The subtitle text to display */
  text?: Maybe<Scalars['String']['output']>;
};

export type ChatWidgetHeaderSubtitleConfigInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ChatWidgetHeaderTheme = {
  /** Background color for the avatar */
  avatarBackground?: Maybe<Scalars['String']['output']>;
  /** Background color of the header */
  background?: Maybe<Scalars['String']['output']>;
  /** Border styling for the header */
  border?: Maybe<ChatWidgetBorderTheme>;
  /** Padding configuration for the header */
  padding?: Maybe<ChatWidgetPaddingTheme>;
  /** Text styling for header subtitle */
  subtitle?: Maybe<ChatWidgetTextTheme>;
  /** Text styling for header text */
  text?: Maybe<ChatWidgetTextTheme>;
};

export type ChatWidgetHeaderThemeInput = {
  avatarBackground?: InputMaybe<Scalars['String']['input']>;
  background?: InputMaybe<Scalars['String']['input']>;
  border?: InputMaybe<ChatWidgetBorderThemeInput>;
  padding?: InputMaybe<ChatWidgetPaddingThemeInput>;
  subtitle?: InputMaybe<ChatWidgetTextThemeInput>;
  text?: InputMaybe<ChatWidgetTextThemeInput>;
};

export type ChatWidgetInputConfig = {
  /** Placeholder text for the input field */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** Tab index for the input field */
  tabIndex?: Maybe<Scalars['String']['output']>;
};

export type ChatWidgetInputConfigInput = {
  placeholder?: InputMaybe<Scalars['String']['input']>;
  tabIndex?: InputMaybe<Scalars['String']['input']>;
};

export type ChatWidgetInputTheme = {
  /** Background color of the input field */
  background?: Maybe<Scalars['String']['output']>;
  /** Border styling for the input field */
  border?: Maybe<ChatWidgetBorderTheme>;
  /** Text styling for placeholder text */
  placeholder?: Maybe<ChatWidgetTextTheme>;
  /** Text styling for input text */
  text?: Maybe<ChatWidgetTextTheme>;
};

export type ChatWidgetInputThemeInput = {
  background?: InputMaybe<Scalars['String']['input']>;
  border?: InputMaybe<ChatWidgetBorderThemeInput>;
  placeholder?: InputMaybe<ChatWidgetTextThemeInput>;
  text?: InputMaybe<ChatWidgetTextThemeInput>;
};

export type ChatWidgetMarginsTheme = {
  /** Bottom margin */
  bottom?: Maybe<Scalars['String']['output']>;
  /** Left margin */
  left?: Maybe<Scalars['String']['output']>;
  /** Right margin */
  right?: Maybe<Scalars['String']['output']>;
  /** Top margin */
  top?: Maybe<Scalars['String']['output']>;
};

export type ChatWidgetMarginsThemeInput = {
  bottom?: InputMaybe<Scalars['String']['input']>;
  left?: InputMaybe<Scalars['String']['input']>;
  right?: InputMaybe<Scalars['String']['input']>;
  top?: InputMaybe<Scalars['String']['input']>;
};

export type ChatWidgetMenuButtonConfig = {
  /** Tab index for the menu button */
  tabIndex?: Maybe<Scalars['String']['output']>;
};

export type ChatWidgetMenuButtonConfigInput = {
  tabIndex?: InputMaybe<Scalars['String']['input']>;
};

export enum ChatWidgetMenuButtonLocation {
  Footer = 'FOOTER',
  HeaderLeft = 'HEADER_LEFT',
  HeaderRight = 'HEADER_RIGHT'
}

export type ChatWidgetMenuConfig = {
  /** Menu button configuration */
  button?: Maybe<ChatWidgetMenuButtonConfig>;
  /** List of menu items */
  items?: Maybe<Array<Maybe<ChatWidgetMenuItems>>>;
  /** Tab index for menu items */
  itemsTabIndex?: Maybe<Scalars['String']['output']>;
  /** Location where the menu button should be displayed */
  menuButtonLocation?: Maybe<ChatWidgetMenuButtonLocation>;
};

export type ChatWidgetMenuConfigInput = {
  button?: InputMaybe<ChatWidgetMenuButtonConfigInput>;
  items?: InputMaybe<Array<InputMaybe<ChatWidgetMenuItemConfigInput>>>;
  itemsTabIndex?: InputMaybe<Scalars['String']['input']>;
  menuButtonLocation?: InputMaybe<ChatWidgetMenuButtonLocation>;
};

export type ChatWidgetMenuItemConfig = {
  /** Display label for the menu item */
  label?: Maybe<Scalars['String']['output']>;
  /** Subtitle text for the menu item */
  subtitle?: Maybe<Scalars['String']['output']>;
};

export type ChatWidgetMenuItemConfigInput = {
  behavior?: InputMaybe<ChatWidgetAppChannelUrlBehaviorInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ChatWidgetMenuItemOpenUrl = {
  /** How the URL opens, defaults to defined behavior on URL opening config. */
  behavior?: Maybe<ChatWidgetAppChannelUrlBehaviorBase>;
  /** Display label for the URL */
  text: Scalars['String']['output'];
  /** URL to be opened */
  url: Scalars['String']['output'];
};

export type ChatWidgetMenuItemStaticImage = {
  /** URL for the static image */
  imageUrl?: Maybe<Scalars['String']['output']>;
};

export type ChatWidgetMenuItemStaticText = {
  /** Body text content */
  body?: Maybe<Scalars['String']['output']>;
  /** Title for the static text item */
  title?: Maybe<Scalars['String']['output']>;
};

export type ChatWidgetMenuItemTheme = {
  /** Background color for menu items */
  background?: Maybe<Scalars['String']['output']>;
  /** Border styling for menu items */
  border?: Maybe<ChatWidgetBorderTheme>;
  /** Height of menu items */
  height?: Maybe<Scalars['String']['output']>;
  /** Text styling for menu item subtitles */
  subtitle?: Maybe<ChatWidgetTextTheme>;
  /** Text styling for menu items */
  text?: Maybe<ChatWidgetTextTheme>;
};

export type ChatWidgetMenuItemThemeInput = {
  background?: InputMaybe<Scalars['String']['input']>;
  border?: InputMaybe<ChatWidgetBorderThemeInput>;
  height?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<ChatWidgetTextThemeInput>;
  text?: InputMaybe<ChatWidgetTextThemeInput>;
};

export type ChatWidgetMenuItems = ChatWidgetMenuItemConfig | ChatWidgetMenuItemOpenUrl | ChatWidgetMenuItemStaticImage | ChatWidgetMenuItemStaticText;

export type ChatWidgetMenuTheme = {
  /** Theme configuration for menu items */
  item?: Maybe<ChatWidgetMenuItemTheme>;
};

export type ChatWidgetMenuThemeInput = {
  item?: InputMaybe<ChatWidgetMenuItemThemeInput>;
};

export type ChatWidgetMessageTheme = {
  /** Message bubble color */
  bubbleColor?: Maybe<Scalars['String']['output']>;
  /** Message text color */
  text?: Maybe<ChatWidgetTextTheme>;
};

export type ChatWidgetMessageThemeInput = {
  /** Message bubble color */
  bubbleColor?: InputMaybe<Scalars['String']['input']>;
  /** Message text color */
  text?: InputMaybe<ChatWidgetTextThemeInput>;
};

export type ChatWidgetMessagesTheme = {
  /** Maximum width for messages */
  maxWidth?: Maybe<Scalars['String']['output']>;
  /** Theme for messages sent by the current user */
  mine?: Maybe<ChatWidgetMessageTheme>;
  /** Theme for messages sent by other users */
  others?: Maybe<ChatWidgetMessageTheme>;
  /** Padding configuration for message area */
  padding?: Maybe<ChatWidgetPaddingTheme>;
};

export type ChatWidgetMessagesThemeInput = {
  maxWidth?: InputMaybe<Scalars['String']['input']>;
  mine?: InputMaybe<ChatWidgetMessageThemeInput>;
  others?: InputMaybe<ChatWidgetMessageThemeInput>;
  padding?: InputMaybe<ChatWidgetPaddingThemeInput>;
};

export type ChatWidgetPaddingTheme = {
  /** Bottom padding */
  bottom?: Maybe<Scalars['String']['output']>;
  /** Left padding */
  left?: Maybe<Scalars['String']['output']>;
  /** Right padding */
  right?: Maybe<Scalars['String']['output']>;
  /** Top padding */
  top?: Maybe<Scalars['String']['output']>;
};

export type ChatWidgetPaddingThemeInput = {
  bottom?: InputMaybe<Scalars['String']['input']>;
  left?: InputMaybe<Scalars['String']['input']>;
  right?: InputMaybe<Scalars['String']['input']>;
  top?: InputMaybe<Scalars['String']['input']>;
};

export type ChatWidgetSendButtonConfig = {
  /** Icon to display on the send button */
  icon?: Maybe<Scalars['String']['output']>;
  /** Icon to display when disabled */
  iconDisabled?: Maybe<Scalars['String']['output']>;
  /** Icon to display on hover */
  iconHover?: Maybe<Scalars['String']['output']>;
  /** Tab index for the send button */
  tabIndex?: Maybe<Scalars['String']['output']>;
};

export type ChatWidgetSendButtonConfigInput = {
  icon?: InputMaybe<Scalars['String']['input']>;
  iconDisabled?: InputMaybe<Scalars['String']['input']>;
  iconHover?: InputMaybe<Scalars['String']['input']>;
  tabIndex?: InputMaybe<Scalars['String']['input']>;
};

export type ChatWidgetServerConfig = {
  /** Account key for authentication */
  accountKey?: Maybe<Scalars['String']['output']>;
  /** Backend server URL */
  serverUrl?: Maybe<Scalars['URLString']['output']>;
  /** Connection timeout in milliseconds */
  timeout?: Maybe<Scalars['Int']['output']>;
  /** Server connection type */
  type?: Maybe<ChatWidgetServerType>;
};

export type ChatWidgetServerConfigInput = {
  accountKey?: InputMaybe<Scalars['String']['input']>;
  serverUrl?: InputMaybe<Scalars['URLString']['input']>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ChatWidgetServerType>;
};

/** The server connection type for the chat widget. */
export enum ChatWidgetServerType {
  /** POST-based direct connection to backend */
  Direct = 'direct',
  /** Local/mock connection for testing */
  Local = 'local',
  /** MCP (Model Context Protocol) SSE streaming connection */
  Mcp = 'mcp',
  /** WebSocket connection (legacy) */
  Websocket = 'websocket',
  /** WebSocket connection via chat router */
  Websocketraw = 'websocketraw'
}

export type ChatWidgetSizeTheme = {
  /** Height of the widget */
  height?: Maybe<Scalars['String']['output']>;
  /** Width of the widget */
  width?: Maybe<Scalars['String']['output']>;
};

export type ChatWidgetSizeThemeInput = {
  height?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['String']['input']>;
};

export type ChatWidgetTextTheme = {
  /** Text color */
  color?: Maybe<Scalars['String']['output']>;
  /** Font family name */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** Font size */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** Font style (e.g., italic, normal) */
  fontStyle?: Maybe<Scalars['String']['output']>;
  /** Font weight (e.g., bold, normal) */
  fontWeight?: Maybe<Scalars['String']['output']>;
};

export type ChatWidgetTextThemeInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  fontSize?: InputMaybe<Scalars['String']['input']>;
  fontStyle?: InputMaybe<Scalars['String']['input']>;
  fontWeight?: InputMaybe<Scalars['String']['input']>;
};

export type ChatWidgetTextTypingStatusTheme = {
  /** Text styling for typing status indicators */
  text?: Maybe<ChatWidgetTextTheme>;
};

export type ChatWidgetTextTypingStatusThemeInput = {
  text?: InputMaybe<ChatWidgetTextThemeInput>;
};

export type ChatWidgetTheme = {
  /** ChatWidget border styling */
  border?: Maybe<ChatWidgetBorderTheme>;
  /** ChatWidget cancelButton styling */
  cancelButton?: Maybe<ChatWidgetButtonTheme>;
  /** ChatWidget carousel styling */
  carousel?: Maybe<ChatWidgetCarouselTheme>;
  /** Widget chat button style */
  chatButton?: Maybe<ChatWidgetChatButtonTheme>;
  /** ChatWidget content styling */
  content?: Maybe<ChatWidgetContentTheme>;
  /** ChatWidget call-to-action styling */
  cta?: Maybe<ChatWidgetCtaTheme>;
  /** ChatWidget footer styling */
  footer?: Maybe<ChatWidgetFooterTheme>;
  /** ChatWidget header styling */
  header?: Maybe<ChatWidgetHeaderTheme>;
  /** ChatWidget input styling */
  input?: Maybe<ChatWidgetInputTheme>;
  /** Widget margin */
  margin?: Maybe<ChatWidgetMarginsTheme>;
  /** Menu theme configuration */
  menu?: Maybe<ChatWidgetMenuTheme>;
  /** ChatWidget menuButton styling */
  menuButton?: Maybe<ChatWidgetButtonTheme>;
  /** ChatWidget messages styling */
  messages?: Maybe<ChatWidgetMessagesTheme>;
  /** ChatWidget minimizeButton styling */
  minimizeButton?: Maybe<ChatWidgetButtonTheme>;
  /** Primary color of ChatWidget */
  primaryColor?: Maybe<Scalars['String']['output']>;
  /** ChatWidget refreshButton styling */
  refreshButton?: Maybe<ChatWidgetButtonTheme>;
  /** ChatWidget sendButton styling */
  sendButton?: Maybe<ChatWidgetButtonTheme>;
  /** Session expiration time */
  sessionExpiration?: Maybe<Scalars['String']['output']>;
  /** Widget size */
  size?: Maybe<ChatWidgetSizeTheme>;
  /** Theme for typing status text */
  textTypingStatus?: Maybe<ChatWidgetTextTypingStatusTheme>;
  /** Widget z-index */
  zIndex?: Maybe<Scalars['String']['output']>;
};

export type ChatWidgetThemeInput = {
  /** ChatWidget border styling */
  border?: InputMaybe<ChatWidgetBorderThemeInput>;
  /** ChatWidget cancelButton styling */
  cancelButton?: InputMaybe<ChatWidgetButtonThemeInput>;
  /** ChatWidget carousel styling */
  carousel?: InputMaybe<ChatWidgetCarouselThemeInput>;
  /** Widget chat button style */
  chatButton?: InputMaybe<ChatWidgetChatButtonThemeInput>;
  /** ChatWidget content styling */
  content?: InputMaybe<ChatWidgetContentThemeInput>;
  /** ChatWidget call-to-action styling */
  cta?: InputMaybe<ChatWidgetCtaThemeInput>;
  /** ChatWidget footer styling */
  footer?: InputMaybe<ChatWidgetFooterThemeInput>;
  /** ChatWidget header styling */
  header?: InputMaybe<ChatWidgetHeaderThemeInput>;
  /** ChatWidget input styling */
  input?: InputMaybe<ChatWidgetInputThemeInput>;
  /** Widget margin */
  margin?: InputMaybe<ChatWidgetMarginsThemeInput>;
  /** ChatWidget menu styling */
  menu?: InputMaybe<ChatWidgetMenuThemeInput>;
  /** ChatWidget menuButton styling */
  menuButton?: InputMaybe<ChatWidgetButtonThemeInput>;
  /** ChatWidget messages styling */
  messages?: InputMaybe<ChatWidgetMessagesThemeInput>;
  /** ChatWidget minimizeButton styling */
  minimizeButton?: InputMaybe<ChatWidgetButtonThemeInput>;
  /** Primary color of ChatWidget */
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  /** ChatWidget menuButton Styling */
  refreshButton?: InputMaybe<ChatWidgetButtonThemeInput>;
  /** ChatWidget sendButton styling */
  sendButton?: InputMaybe<ChatWidgetButtonThemeInput>;
  sessionExpiration?: InputMaybe<Scalars['String']['input']>;
  /** Widget size */
  size?: InputMaybe<ChatWidgetSizeThemeInput>;
  textTypingStatus?: InputMaybe<ChatWidgetTextTypingStatusThemeInput>;
  /** Widget z-index */
  zIndex?: InputMaybe<Scalars['String']['input']>;
};

export type ChatWidgetTypingStatusConfig = {
  /** Whether typing status indicators are enabled */
  textTypingStatusEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type ChatWidgetTypingStatusConfigInput = {
  textTypingStatusEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatbaseDataStream = {
  type: Scalars['String']['output'];
};

export type ChatbaseDataStreamInput = {
  type: Scalars['String']['input'];
};

export type CleanupKnowledgeBaseContentResult = {
  /** Number of documents deleted from faq_content index */
  deleted: Scalars['Int']['output'];
  /** Whether the operation is still in progress (async delete) */
  inProgress: Scalars['Boolean']['output'];
  /** Task ID if the operation is async (use to check status) */
  taskId?: Maybe<Scalars['String']['output']>;
};

export type CleanupMutation = {
  /**
   * Deletes all faq_content documents for a given appId.
   * This removes both website content and FAQ data from the OpenSearch index.
   * Use this for manual cleanup without waiting for the 45-day automatic process.
   */
  cleanupKnowledgeBaseContent: CleanupKnowledgeBaseContentResult;
};


export type CleanupMutationCleanupKnowledgeBaseContentArgs = {
  appId: Scalars['ID']['input'];
  waitForCompletion?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClearFaqReturn = {
  /** The task ID of the faq clear which can be queried to check if it's done. */
  taskId: Scalars['ID']['output'];
};

/** A key/count breakdown of lead data within a cluster or location. */
export type ClusterBreakdown = {
  /** Number of leads with this value */
  count: Scalars['Int']['output'];
  /** The value of the field (e.g. "Plumbing", "Phone") */
  key: Scalars['String']['output'];
};

export type CodeChallenge = {
  codeChallenge: Scalars['String']['output'];
  codeChallengeMethod: Scalars['String']['output'];
  codeVerifier: Scalars['String']['output'];
};

export type CompilableHandlerPath = HistoricalHandlerPath | PreviousHandlerPath;

/** Conversion metrics for leads */
export type ConversionMetrics = {
  /** Conversion rate as percentage */
  conversionRate: Scalars['Float']['output'];
  /** Number of converted leads */
  convertedLeads: Scalars['Int']['output'];
  /** Total number of leads in the period */
  totalLeads: Scalars['Int']['output'];
};

/** Attributes that can be overriden in the copyApp when creating the new app */
export type CopyAppOverrideAttributes = {
  businessDescription?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Cost per lead configuration by job type (in USD) */
export type CostPerLeadConfig = {
  appliance_repair?: Maybe<Scalars['Float']['output']>;
  carpentry?: Maybe<Scalars['Float']['output']>;
  cleaning?: Maybe<Scalars['Float']['output']>;
  construction?: Maybe<Scalars['Float']['output']>;
  drywall?: Maybe<Scalars['Float']['output']>;
  electrical?: Maybe<Scalars['Float']['output']>;
  fencing?: Maybe<Scalars['Float']['output']>;
  hvac?: Maybe<Scalars['Float']['output']>;
  landscaping?: Maybe<Scalars['Float']['output']>;
  legal_services?: Maybe<Scalars['Float']['output']>;
  moving?: Maybe<Scalars['Float']['output']>;
  other?: Maybe<Scalars['Float']['output']>;
  painting?: Maybe<Scalars['Float']['output']>;
  pest_control?: Maybe<Scalars['Float']['output']>;
  plumbing?: Maybe<Scalars['Float']['output']>;
  remodeling?: Maybe<Scalars['Float']['output']>;
  roofing?: Maybe<Scalars['Float']['output']>;
  window_cleaning?: Maybe<Scalars['Float']['output']>;
};

/** Input for cost per lead configuration by job type (in USD) */
export type CostPerLeadInput = {
  appliance_repair?: InputMaybe<Scalars['Float']['input']>;
  carpentry?: InputMaybe<Scalars['Float']['input']>;
  cleaning?: InputMaybe<Scalars['Float']['input']>;
  construction?: InputMaybe<Scalars['Float']['input']>;
  drywall?: InputMaybe<Scalars['Float']['input']>;
  electrical?: InputMaybe<Scalars['Float']['input']>;
  fencing?: InputMaybe<Scalars['Float']['input']>;
  hvac?: InputMaybe<Scalars['Float']['input']>;
  landscaping?: InputMaybe<Scalars['Float']['input']>;
  legal_services?: InputMaybe<Scalars['Float']['input']>;
  moving?: InputMaybe<Scalars['Float']['input']>;
  other?: InputMaybe<Scalars['Float']['input']>;
  painting?: InputMaybe<Scalars['Float']['input']>;
  pest_control?: InputMaybe<Scalars['Float']['input']>;
  plumbing?: InputMaybe<Scalars['Float']['input']>;
  remodeling?: InputMaybe<Scalars['Float']['input']>;
  roofing?: InputMaybe<Scalars['Float']['input']>;
  window_cleaning?: InputMaybe<Scalars['Float']['input']>;
};

/** Cost per lead with metadata about whether it's a custom override */
export type CostPerLeadWithMeta = {
  /** The cost per lead in USD */
  cost: Scalars['Float']['output'];
  /** Whether this is a custom override (true) or the default value (false) */
  isCustom: Scalars['Boolean']['output'];
  /** The job type */
  jobType: Scalars['String']['output'];
};

/** Input for creating an alert subscription */
export type CreateAlertSubscriptionInput = {
  /** Type of alert to subscribe to */
  alertType: AlertType;
  /** App IDs to subscribe to */
  appIds: Array<Scalars['ID']['input']>;
  /** Notification channel (defaults to email) */
  channel?: InputMaybe<NotificationChannel>;
  /** Optional filters to limit which alerts are received */
  filters?: InputMaybe<UserNotificationFiltersInput>;
};

export type CreateCmsReturn = {
  /** The appId of the app that the token is associated with. */
  appId?: Maybe<Scalars['ID']['output']>;
  /** The day the token was created. */
  created: Scalars['DateTime']['output'];
  /** The last time the token was used. */
  lastUsed?: Maybe<Scalars['DateTime']['output']>;
  /** A partial human-readable portion of the token */
  mask: Scalars['String']['output'];
  /** The organizationId of the organization that the token is associated with. */
  organizationId?: Maybe<Scalars['ID']['output']>;
  /** The permissions that the token grants. */
  scope: Array<Maybe<Scalars['String']['output']>>;
  /** The authorization token that was generated for this app. */
  token: Scalars['String']['output'];
  /** The ID of the token that was created */
  tokenId: Scalars['ID']['output'];
};

export type CreateCampaignInput = {
  /** The app this campaign's booking link and handler should be created on. */
  appId: Scalars['ID']['input'];
  /**
   * The attribution label stamped onto bookings made through this campaign.
   * Defaults to a slug of 'name' when not provided.
   */
  canonicalSource?: InputMaybe<Scalars['String']['input']>;
  /** When the campaign offer stops being valid. */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * When set, pins every booking through this campaign to a single job type by
   * forcing the handler's availability class.
   */
  jobTypePin?: InputMaybe<Scalars['String']['input']>;
  /** The display name of the campaign, e.g. 'Drains Special'. */
  name: Scalars['String']['input'];
  /** The fine print / terms of the offer. */
  offerTerms?: InputMaybe<Scalars['String']['input']>;
  /** The offer's headline, e.g. '$50 Off Drain Cleaning'. */
  offerTitle?: InputMaybe<Scalars['String']['input']>;
  /** When the campaign offer starts being valid. */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateInteractionModelReturn = {
  /** The model that was created. */
  interactionModel: AlexaInteractionModel;
  /** The locale that the interaction model is for. */
  locale: Scalars['String']['output'];
};

export type CreateOrgCreateAppInput = {
  /** The new app that will be created upon org creation. */
  app: CreateOrganizationAppInput;
  /** Entities that are to be added to the app. */
  entities?: InputMaybe<Array<UpdateEntityInput>>;
  /** Handlers that are to be added to the app. */
  handlers?: InputMaybe<Array<AddHandlerInput>>;
  /** Intents that are to be added to the app. */
  intents?: InputMaybe<Array<AddIntentInput>>;
};

export type CreateOrgReturn = {
  /** The returned app after app creation. */
  app?: Maybe<App>;
  org: Organization;
};

/** Attributes that are linked to an app when creating one. */
export type CreateOrganizationAppInput = {
  /** URL of the original banner image with aspect ratio of 16:9 and minimum dimensions of 1920x1080. */
  banner?: InputMaybe<Scalars['URL']['input']>;
  /** A description of the business and it's services. */
  businessDescription?: InputMaybe<Scalars['businessDescription_String_maxLength_4000']['input']>;
  /**
   * The description for the app.
   *
   * The description cannot be more than 4000 characters.
   */
  description?: InputMaybe<Scalars['description_String_maxLength_4000']['input']>;
  /**
   * URL to the original icon file before transformation.
   *
   * Aspect ration must be 1:1 and minimum dimensions are 512x512.
   */
  icon?: InputMaybe<Scalars['URL']['input']>;
  /**
   * Keywords to help when searching directories for the app
   *
   * Max of 30 keywords are allowed.
   */
  keywords?: InputMaybe<Array<Scalars['keywords_List_String_NotNull_maxLength_50']['input']>>;
  /** The human-readable name of the app. */
  name: Scalars['name_String_NotNull_maxLength_150']['input'];
  /** Type of template the app and its intents adhere to. */
  templateType?: InputMaybe<Scalars['templateType_String_maxLength_50']['input']>;
  /** Primary website for the company or division of a company that the app is representing. */
  website?: InputMaybe<Scalars['URL']['input']>;
};

export type CreateOrganizationInput = {
  /** The email XAPPineer that is in charge of handling the organization's account */
  XAPPLead?: InputMaybe<Scalars['XAPPLead_String_maxLength_150_format_email']['input']>;
  /** An event bus that is attatched to the organization to receive specific events related to the organization such as App status changes. */
  awsEventBusArn?: InputMaybe<Scalars['awsEventBusArn_String_maxLength_200_pattern_arnawsusgovcneventsaz0909eventbus']['input']>;
  /**
   * The email address of a user who can be contacted about issues
   * related to the organization.
   */
  contact?: InputMaybe<Scalars['contact_String_maxLength_150_format_email']['input']>;
  /** The organization contact's name. */
  contactName?: InputMaybe<Scalars['contactName_String_maxLength_150']['input']>;
  /** The organization contact's phone number. */
  contactPhone?: InputMaybe<Scalars['contactPhone_String_maxLength_50']['input']>;
  /**
   * Date in which the organization signed a contract to publish
   * apps.
   *
   * Format: ISO-8601 date format
   */
  contractDate?: InputMaybe<Scalars['contractDate_String_format_ISO8601']['input']>;
  /** The human-readable description of the organization. */
  description?: InputMaybe<Scalars['description_String_maxLength_4000']['input']>;
  /**
   * Organization's IP rights which were loaded that give permissions to
   * publish apps on their behalf.
   */
  ipRights?: InputMaybe<IPrightsInput>;
  /** URL for the organization's logo. */
  logoUrl?: InputMaybe<Scalars['URL']['input']>;
  /** The human-readable name of the organization. */
  name: Scalars['name_String_NotNull_maxLength_150']['input'];
  /** Any notes that are related to the organization. */
  notes?: InputMaybe<Scalars['notes_String_maxLength_4000']['input']>;
  /**
   * A unique ID for the organization. If one is not provided then the ID will
   * be based off the name.
   */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** Payment account information */
  paymentAccounts?: InputMaybe<PaymentAccountsInput>;
  /**
   * Third party publishing account information such as Amazon SMAPI's
   * service or Google's Dialogflow.
   */
  publishingAccounts?: InputMaybe<PublishingAccountsInput>;
  /** A URL to the organization's website. */
  website?: InputMaybe<Scalars['URL']['input']>;
};

/** Input for creating a summary subscription */
export type CreateSummarySubscriptionInput = {
  /** App IDs to include in the summary */
  appIds: Array<Scalars['ID']['input']>;
  /** Notification channel (defaults to email) */
  channel?: InputMaybe<NotificationChannel>;
  /** How often the summary should be sent */
  frequency: SummaryFrequency;
  /** How to group multiple apps (defaults to combined) */
  grouping?: InputMaybe<ReportGrouping>;
};

export type CtaConfig = {
  /** Animation to perform on the button after the delay */
  animation?: Maybe<CtaAnimation>;
  /**
   * The delay, in milliseconds, to wait until the animation starts.
   * If not provided, falls back to the delay property for backwards compatibility.
   */
  animationDelay?: Maybe<Scalars['Int']['output']>;
  /** How long to keep the animation going, in milliseconds.  If an animation exists */
  animationTimeout?: Maybe<Scalars['Int']['output']>;
  /** The delay, in milliseconds, to wait until the message is displayed */
  delay?: Maybe<Scalars['Int']['output']>;
  /** Whether the CTA bubble can be dismissed with an X button */
  dismissible?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Message to display in the chat bubble.
   *
   * An empty message will not display the chat bubble.
   */
  message?: Maybe<Scalars['String']['output']>;
  /** CTA Config that is used when mobile devices load it. */
  mobile?: Maybe<MobileCtaConfig>;
  /** How long, in milliseconds, to display the message */
  timeout?: Maybe<Scalars['Int']['output']>;
};

export type CtaConfigInput = {
  animation?: InputMaybe<CtaAnimation>;
  animationDelay?: InputMaybe<Scalars['Int']['input']>;
  animationTimeout?: InputMaybe<Scalars['Int']['input']>;
  delay?: InputMaybe<Scalars['Int']['input']>;
  dismissible?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<MobileCtaConfigInput>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
};

export enum CurrentTestState {
  /** Assigned to  the test state if the test is currently executing. */
  Running = 'RUNNING',
  /** Assigned to the test state if the test is no longer executing. */
  Stopped = 'STOPPED'
}

/** Generic dashboard data that can contain different types of analytics */
export type DashboardData = {
  /**
   * Leads dashboard data (if requested).
   *
   * The businessHoursSource parameter controls which hours definition is used
   * for all time-of-day calculations (leadsByDayOfWeek, outsideBusinessHoursPercentage):
   * - DEFAULT: Standard fleet-wide Mon-Fri 9-5 (local time). Used when omitted.
   * - PLACE: Hours from Google Business Profile (falls back to DEFAULT if not configured)
   * - APP: Hours configured at the app level (falls back to DEFAULT if not configured)
   * - AUTO: Auto-detects the best available source (PLACE > APP > DEFAULT)
   *
   * The returned businessHoursSource field reflects the actual source used after detection or fallback.
   */
  leads?: Maybe<LeadsDashboardData>;
  /**
   * Map dashboard data for visualizing business and lead locations.
   * Provides geographic data for rendering markers on a map view.
   */
  map: MapDashboardData;
};


/** Generic dashboard data that can contain different types of analytics */
export type DashboardDataLeadsArgs = {
  businessHoursSource?: InputMaybe<BusinessHoursSource>;
};

/**
 * Predefined time period for filtering dashboard data.
 * These periods use calendar boundaries (not rolling windows).
 */
export enum DashboardPeriod {
  /** Current calendar month (from 1st of month to now in UTC) */
  Month = 'MONTH',
  /** Current calendar day (from midnight to now in UTC) */
  Today = 'TODAY',
  /** Current calendar week (from Sunday midnight to now in UTC) */
  Week = 'WEEK'
}

/** Sort field options for dashboard aggregations (leadsByApp, leadsByOrganization, topEngagementsByZip) */
export enum DashboardSortField {
  /** Sort by high value lead count */
  HighValueCount = 'HIGH_VALUE_COUNT',
  /** Sort by total lead count */
  LeadCount = 'LEAD_COUNT'
}

export type DashbotDataStream = {
  type: Scalars['String']['output'];
};

export type DashbotDataStreamInput = {
  type: Scalars['String']['input'];
};

/** Third party analytics integrations. */
export type DataStreams = {
  /** Tokens for integrating with the bespoken platform. */
  bespoken?: Maybe<BespokenDataStream>;
  /** Tokens for integrating with Chatbase. */
  chatbase?: Maybe<ChatbaseDataStream>;
  /** Tokens for integrating with dashbot. */
  dashbot?: Maybe<DashbotDataStream>;
  /** Tokens for integrating with Google Analytics. */
  googleAnalytics?: Maybe<GoogleAnalyticsDataStream>;
};

/** Third party analytics integrations. */
export type DataStreamsInput = {
  /** Tokens for integrating with the bespoken platform. */
  bespoken?: InputMaybe<BespokenDataStreamInput>;
  /** Tokens for integrating with Chatbase. */
  chatbase?: InputMaybe<ChatbaseDataStreamInput>;
  /** Tokens for integrating with dashbot. */
  dashbot?: InputMaybe<DashbotDataStreamInput>;
  /** Tokens for integrating with Google Analytics. */
  googleAnalytics?: InputMaybe<GoogleAnalyticsDataStreamInput>;
};

/** Day of week aggregation bucket for leads distribution */
export type DayOfWeekBucket = {
  /**
   * Leads that occurred during standard business hours (Mon-Fri 9 AM - 5 PM in business local time)
   * Note: Uses standard business hours definition, not app-specific businessHours configuration.
   * Falls back to UTC time when business timezone is not available.
   */
  businessHoursCount: Scalars['Int']['output'];
  /** Human-readable day name (Sunday, Monday, Tuesday, etc.) */
  dayName: Scalars['String']['output'];
  /**
   * Day of week (0=Sunday, 1=Monday, ..., 6=Saturday)
   * Note: Matches BusinessDayOfWeek enum where Sunday=0
   */
  dayOfWeek: Scalars['Int']['output'];
  /** Leads that occurred outside standard business hours */
  nonBusinessHoursCount: Scalars['Int']['output'];
  /** Percentage of total leads */
  percentage?: Maybe<Scalars['Float']['output']>;
  /** Total leads on this day of week */
  totalCount: Scalars['Int']['output'];
};

export type DeleteHandlerReturn = {
  /** The updated graph. */
  graph: IntentsGraph;
  /** The handlers that were updated in the operation */
  handlers: Array<Maybe<DeleteIntentIdKey>>;
};


export type DeleteHandlerReturnGraphArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeleteIntentIdKey = {
  /** The appId that was deleted during a delete operation. */
  appId: Scalars['String']['output'];
  /** The intentId that was updated during a delete operation. */
  intentId: Scalars['String']['output'];
};

export type DeleteIntentReturn = {
  /** The updated graph. */
  graph: IntentsGraph;
  /** The intents that were updated in the operation */
  intents: Array<Maybe<DeleteIntentIdKey>>;
};


export type DeleteIntentReturnGraphArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/**
 * DialogflowAppChannel objects only.
 *
 * Required publishing information questions.
 */
export type DialogflowAdditionalInformationQuestions = {
  /**
   * Do your Actions contain alcohol or tobacco-related content?
   *
   * If yes, you must include age verification at the beginning of the conversation.
   * If your Actions mainly sell alcohol or tobacco, you must implement
   * account linking and verify that the user meets legal age requirements.
   */
  alcoholAndTobaccoRelatedContent?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Are children under the age of 13 one of the intended audience of your actions?
   *
   * If yes, you must join the Actions for Families program. The Actions for Families
   * program allows developers to designate that their Actions are family-friendly, so parents and kids
   * can find trusted, high-quality content more easily on teh Google Assistant.
   */
  intendedForUnderThirteen?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * DialogflowChanelData objects only.
 *
 * Required publishing information questions.
 */
export type DialogflowAdditionalInformationQuestionsInput = {
  /**
   * Do your Actions contain alcohol or tobacco-related content?
   *
   * If yes, you must include age veriifcation at the beginning of the conversation.
   * If your Actions mainly sell alcohol or tobacco, you must implement
   * account linking and verify that the user meets legal age requirements.
   */
  alcoholAndTobaccoRelatedContent?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Are childer under the age of 13 one of the intended audienced of your actions?
   *
   * If yes, you must join the Actions for Families program. The Actions for Families
   * program allows develpers to dsignate that their Actions are family-friendly, so parents and kids
   * cand find trusted, high-quality content more easily on teh Google Assistant.
   */
  intendedForUnderThirteen?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A channel that is specific for apps to run on the Dialogflow. */
export type DialogflowAppChannel = BaseAppChannel & {
  /** For "dialogflow" type channels only. */
  additionalInformationQuestions?: Maybe<DialogflowAdditionalInformationQuestions>;
  /** URL for the directory listing. */
  directoryListing?: Maybe<Scalars['String']['output']>;
  /** URI where the channel can be accessed. */
  endPoint?: Maybe<Scalars['String']['output']>;
  /** Whether or not the credentials for the channel has been uploaded. */
  hasCredentials: Scalars['Boolean']['output'];
  /** The ID of the channel. */
  id: Scalars['String']['output'];
  /**
   * Boolean used to determine if the channel is currently being build on
   * dialogflow.
   */
  isBuilding: Scalars['Boolean']['output'];
  modelManagementMode?: Maybe<Scalars['Boolean']['output']>;
  /** The display name for the channel. */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * Query the text from the NLU. The channel must have valid credentials,
   * projectId, and nlu.
   */
  nluQuery: DialogflowNluQuery;
  /** The ID of the project on Dialogflow */
  projectId: Scalars['ID']['output'];
  /** The lifecycle status of the app. */
  status?: Maybe<AppChannelStatus>;
  /** The type of channel */
  type: Scalars['String']['output'];
  /** Retrieves any events that are related to this specific app */
  usageEvents?: Maybe<TotalUsageEvents>;
  /**
   * ID of the NLU to use within app.nlu[].
   *
   * If it exists, the channel will use the provided NLU at runtime
   * to convert the raw text to an Intent
   *
   * If the value is "*", then it will pick the first available NLU within app.nlu[]
   */
  useNLU?: Maybe<Scalars['String']['output']>;
};


/** A channel that is specific for apps to run on the Dialogflow. */
export type DialogflowAppChannelNluQueryArgs = {
  text: Scalars['String']['input'];
};


/** A channel that is specific for apps to run on the Dialogflow. */
export type DialogflowAppChannelUsageEventsArgs = {
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type DialogflowAppChannelInput = {
  /**
   * For "actions-on-google" type channels only.
   *
   * @deprecated: Actions-on-google is no longer supported at all.  It is gone.
   */
  additionalInformationQuestions?: InputMaybe<DialogflowAdditionalInformationQuestionsInput>;
  /** URL to find the credentials for accessing Google Cloud Services */
  dialogflowCredentials?: InputMaybe<DialogflowCredentialsInput>;
  /** URL for the directory listing. */
  directoryListing?: InputMaybe<Scalars['String']['input']>;
  /** URI where the channel can be accessed. */
  endPoint?: InputMaybe<Scalars['String']['input']>;
  /**
   * The ID of the channel.
   *
   * When calling a "CreateChannel" function, then ID will be
   * used to determine if the channel shoudl be inserted or updated.
   *
   * If the ID is provided and already exists, the channel will be
   * updated.  Otherwise the channel will be inserted and an ID will be
   * generated.
   */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The display name for the channel. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The type of channel */
  type: Scalars['String']['input'];
  /**
   * ID of the NLU to use within app.nlu[].
   *
   * If it exists, the channel will use the provided NLU at runtime
   * to convert the raw text to an Intent
   *
   * If the value is "*", then it will pick the first available NLU within app.nlu[]
   */
  useNLU?: InputMaybe<Scalars['String']['input']>;
};

export type DialogflowAppNlu = BaseAppNlu & {
  /**
   * The URL of the JSON style credentials that provided
   * access to performing queries against the Dialogflow API
   */
  credentialsURL?: Maybe<Scalars['String']['output']>;
  /** The reference ID for the NLU */
  id?: Maybe<Scalars['String']['output']>;
  /**
   * Query the text from the NLU. The channel must have valid credentials,
   * projectId, and nlu.
   */
  nluQuery: DialogflowNluQuery;
  /** The project ID of the Dialogflow agent */
  projectId?: Maybe<Scalars['String']['output']>;
  /** The type of NLU. */
  type: Scalars['String']['output'];
};


export type DialogflowAppNluNluQueryArgs = {
  text: Scalars['String']['input'];
};

export type DialogflowAppNluInput = {
  /**
   * The dialogflow credentials associated with the input.
   *
   * This will be stored and returned with the "credentialsURL" in the Dialogflow NLU.
   */
  dialogflowCredentials?: InputMaybe<DialogflowCredentialsInput>;
  /** The reference ID for the NLU */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The project ID of the Dialogflow agent */
  projectId?: InputMaybe<Scalars['String']['input']>;
  /** The type of NLU. */
  type: Scalars['String']['input'];
};

export type DialogflowCredentialsInput = {
  auth_provider_x509_cert_url?: InputMaybe<Scalars['String']['input']>;
  auth_uri?: InputMaybe<Scalars['String']['input']>;
  client_email: Scalars['String']['input'];
  client_id?: InputMaybe<Scalars['String']['input']>;
  client_x509_cert_url?: InputMaybe<Scalars['String']['input']>;
  private_key: Scalars['String']['input'];
  private_key_id?: InputMaybe<Scalars['String']['input']>;
  project_id: Scalars['String']['input'];
  token_uri?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Attributes used for dialogflow publishing. */
export type DialogflowIntegration = {
  /** The location of the credentials needed to upload to dialogflow. */
  credentialsUrl: Scalars['String']['output'];
};

/** Attributes used for dialogflow publishing. */
export type DialogflowIntegrationInput = {
  /** The location of the credentials needed to upload to dialogflow. */
  credentialsUrl: Scalars['String']['input'];
};

export type DialogflowNluQuery = {
  intentId: Scalars['String']['output'];
  knowledgeAnswer?: Maybe<DialogflowNluQueryKnowledgeAnswer>;
  slots?: Maybe<Array<Maybe<NluRequestSlot>>>;
  type: Scalars['String']['output'];
};

export type DialogflowNluQueryKnowledgeAnswer = {
  /** Raw answer */
  answer: Scalars['String']['output'];
  /** Raw question */
  faqQuestion: Scalars['String']['output'];
  /** Confidence 0-1 */
  matchConfidence: Scalars['Int']['output'];
  /** Which knowledge base (optional) */
  source?: Maybe<Scalars['String']['output']>;
};

export type DisplayImage = {
  contentDescription?: Maybe<Scalars['String']['output']>;
  sources: Array<Maybe<DisplayImageSpecification>>;
};

export type DisplayImageInput = {
  contentDescription?: InputMaybe<Scalars['String']['input']>;
  sources: Array<InputMaybe<DisplayImageSpecificationInput>>;
};

export type DisplayImageSpecification = {
  height: Scalars['Int']['output'];
  imageUrl: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type DisplayImageSpecificationInput = {
  height: Scalars['Int']['input'];
  imageUrl: Scalars['String']['input'];
  width: Scalars['Int']['input'];
};

export type DisplayListButton = {
  title?: Maybe<Scalars['String']['output']>;
};

export type DisplayListButtonInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type DisplayListItem = {
  buttons?: Maybe<Array<Maybe<DisplayListButton>>>;
  description: Scalars['String']['output'];
  image: DisplayImage;
  synonyms?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title: Scalars['String']['output'];
  token?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type DisplayListItemInput = {
  buttons?: InputMaybe<Array<InputMaybe<DisplayListButtonInput>>>;
  description: Scalars['String']['input'];
  image: DisplayImageInput;
  synonyms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type DisplayTextContent = {
  primaryText?: Maybe<Scalars['String']['output']>;
  secondaryText?: Maybe<Scalars['String']['output']>;
  tertiaryText?: Maybe<Scalars['String']['output']>;
};

export type DisplayTextContentInput = {
  primaryText?: InputMaybe<Scalars['String']['input']>;
  secondaryText?: InputMaybe<Scalars['String']['input']>;
  tertiaryText?: InputMaybe<Scalars['String']['input']>;
};

/** DNS record for domain verification */
export type DnsRecord = {
  /** DNS record name (e.g., _amazonses.partner.com) */
  name: Scalars['String']['output'];
  /** Record type: TXT or CNAME */
  type: Scalars['String']['output'];
  /** DNS record value */
  value: Scalars['String']['output'];
};

/** Domain verification state for partner custom domain */
export type DomainVerificationState = {
  /** DNS records that need to be added (only present when status is pending) */
  dnsRecords?: Maybe<Array<DnsRecord>>;
  /** The domain being verified */
  domain: Scalars['String']['output'];
  /** ISO date when verification was requested */
  requestedAt: Scalars['DateTime']['output'];
  /** Current verification status: pending, verified, or failed */
  status: Scalars['String']['output'];
  /** ISO date when verification completed (if verified) */
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EmailAppChannel = BaseAppChannel & {
  /** Whether the agent-server responses are sent automatically */
  autoRespond?: Maybe<Scalars['Boolean']['output']>;
  /** The capture email address for inbound emails (e.g., {appId}@capture.xapp.ai) */
  captureAddress?: Maybe<Scalars['String']['output']>;
  /** URL for the directory listing. */
  directoryListing?: Maybe<Scalars['String']['output']>;
  /** Whether the email channel is enabled */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** URI where the channel can be accessed. */
  endPoint?: Maybe<Scalars['String']['output']>;
  /** The ID of the channel. */
  id: Scalars['String']['output'];
  /** The display name for the channel. */
  name?: Maybe<Scalars['String']['output']>;
  /** Reply routing configuration */
  replyRouting?: Maybe<EmailReplyRouting>;
  /** Sender identity configuration */
  sendFrom?: Maybe<EmailSendFrom>;
  /** The lifecycle status of the app. */
  status?: Maybe<AppChannelStatus>;
  /** The type of channel */
  type: Scalars['String']['output'];
  /** Retrieves any events that are related to this specific app */
  usageEvents?: Maybe<TotalUsageEvents>;
  /**
   * ID of the NLU to use within app.nlu[].
   *
   * If it exists, the channel will use the provided NLU at runtime
   * to convert the raw text to an Intent
   *
   * If the value is "*", then it will pick the first available NLU within app.nlu[]
   */
  useNLU?: Maybe<Scalars['String']['output']>;
  /** Domain verification status */
  verification?: Maybe<EmailVerification>;
};


export type EmailAppChannelUsageEventsArgs = {
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type EmailAppChannelInput = {
  /** Whether the agent-server responses are sent automatically */
  autoRespond?: InputMaybe<Scalars['Boolean']['input']>;
  /** URL for the directory listing. */
  directoryListing?: InputMaybe<Scalars['String']['input']>;
  /** Whether the email channel is enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** URI where the channel can be accessed. */
  endPoint?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the channel. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The display name for the channel. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Reply routing configuration */
  replyRouting?: InputMaybe<EmailReplyRoutingInput>;
  /** Sender identity configuration */
  sendFrom?: InputMaybe<EmailSendFromInput>;
  /** The type of channel */
  type: Scalars['String']['input'];
  /** ID of the NLU to use within app.nlu[]. */
  useNLU?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Email-specific branding overrides.
 * Extends base overrides with email-only fields.
 */
export type EmailBrandingOverrides = {
  /** Hex color code for body background (e.g., #FBFAFE) */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** Partner company name for footer (e.g., Acme Corporation) */
  companyName?: Maybe<Scalars['String']['output']>;
  /** URL to partner's logo image (recommended: 100px width) */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** Hex color code for header/footer background (e.g., #071837) */
  primaryColor?: Maybe<Scalars['String']['output']>;
  /** Custom verified sender email for this channel (e.g., no-reply@acme.com). Requires SES verification. */
  senderEmail?: Maybe<Scalars['String']['output']>;
  /** Partner website URL for footer link (e.g., https://acme.com) */
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

/**
 * Input for email-specific branding overrides.
 * Extends base overrides with email-only fields.
 */
export type EmailBrandingOverridesInput = {
  /** Hex color code for body background (e.g., #FBFAFE) */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Partner company name for footer (e.g., Acme Corporation) */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** URL to partner's logo image (recommended: 100px width) */
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** Hex color code for header/footer background (e.g., #071837) */
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  /** Custom verified sender email for this channel (e.g., no-reply@acme.com). Requires SES verification. */
  senderEmail?: InputMaybe<Scalars['String']['input']>;
  /** Partner website URL for footer link (e.g., https://acme.com) */
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type EmailChannelConfigureInput = {
  /** Whether the agent-server auto-responds to emails */
  autoRespond?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reply routing mode */
  replyRouting?: InputMaybe<EmailReplyRoutingInput>;
  /** Sender identity configuration */
  sendFrom?: InputMaybe<EmailSendFromInput>;
};

export type EmailChannelMutation = {
  /** Check reply domain verification status (creates SES receipt rule on verification) */
  checkReplyVerification: EmailVerification;
  /** Check current verification status (auto-updates channel on completion) */
  checkVerification: EmailVerification;
  /** Update email channel settings (sendFrom, replyRouting, autoRespond) */
  configure: EmailAppChannel;
  /** Reset reply domain verification and remove SES receipt rule */
  resetReplyVerification: Scalars['Boolean']['output'];
  /** Reset sending domain verification and clear verification state */
  resetVerification: Scalars['Boolean']['output'];
  /** Enable or disable the email channel */
  setEnabled: EmailAppChannel;
  /** Start reply domain verification for delegated mode — returns DNS records (MX, DKIM, SPF) */
  verifyReplyDomain: EmailVerification;
  /** Start sending domain verification — returns DNS records to add */
  verifySendingDomain: EmailVerification;
};


export type EmailChannelMutationConfigureArgs = {
  input: EmailChannelConfigureInput;
};


export type EmailChannelMutationSetEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type EmailChannelMutationVerifyReplyDomainArgs = {
  domain: Scalars['String']['input'];
};


export type EmailChannelMutationVerifySendingDomainArgs = {
  domain: Scalars['String']['input'];
};

export type EmailDnsRecord = {
  /** DNS record name */
  name: Scalars['String']['output'];
  /** DNS record priority (for MX records) */
  priority?: Maybe<Scalars['Int']['output']>;
  /** DNS record type (TXT, CNAME, MX) */
  type: Scalars['String']['output'];
  /** DNS record value */
  value: Scalars['String']['output'];
};

/** Opportunity alert that sends the message to the user via email. */
export type EmailOpportunityAlert = BaseOpportunityAlert & {
  alerts: Array<OpportunityAlertDetail>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** Email of the user to receive the alert. */
  email: Scalars['EmailAddress']['output'];
  placeId?: Maybe<Scalars['String']['output']>;
};

export type EmailOpportunityAlertInput = {
  /** Registered alerts */
  alerts: Array<OpportunityAlertDetailInput>;
  /** Temporarily disable the alert */
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Email of the user to receive the alert. */
  email: Scalars['EmailAddress']['input'];
  /** The Google PlaceID for the location */
  placeId?: InputMaybe<Scalars['String']['input']>;
};

export enum EmailReplyMode {
  /** Replies route through a customer-delegated subdomain via MX delegation */
  Delegated = 'DELEGATED',
  /** Replies route through a platform-managed domain (e.g., sche.dule.pro) */
  Managed = 'MANAGED'
}

export type EmailReplyRouting = {
  /** Customer subdomain for delegated mode (e.g., reply.customer.com) */
  domain?: Maybe<Scalars['String']['output']>;
  /** How replies are routed back to the system */
  mode: EmailReplyMode;
};

export type EmailReplyRoutingInput = {
  /** Customer subdomain for delegated mode (e.g., reply.customer.com) */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** How replies are routed back to the system */
  mode: EmailReplyMode;
};

export type EmailSendFrom = {
  /** The email address to send from (e.g., hello@customer.com or slug@sche.dule.pro) */
  email: Scalars['String']['output'];
  /** Display name shown in the From header (e.g., Acme Plumbing) */
  name?: Maybe<Scalars['String']['output']>;
};

export type EmailSendFromInput = {
  /** The email address to send from */
  email: Scalars['String']['input'];
  /** Display name shown in the From header */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EmailThread = {
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  firstMessageAt?: Maybe<Scalars['DateTime']['output']>;
  lastMessageAt?: Maybe<Scalars['DateTime']['output']>;
  messageCount?: Maybe<Scalars['Int']['output']>;
  messages: Array<EmailThreadMessage>;
  status?: Maybe<Scalars['String']['output']>;
  threadId: Scalars['String']['output'];
};

/** A single lead entity. */
export type EmailThreadMessage = {
  content: Scalars['String']['output'];
  id: Scalars['String']['output'];
  role: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type EmailVerification = {
  /** DNS records for sending domain verification (DKIM CNAMEs) */
  dnsRecords?: Maybe<Array<Maybe<EmailDnsRecord>>>;
  /** DNS records for reply domain (MX, DKIM, SPF) */
  replyDnsRecords?: Maybe<Array<Maybe<EmailDnsRecord>>>;
  /** Domain verified for receiving replies (delegated mode only) */
  replyDomain?: Maybe<Scalars['String']['output']>;
  /** Verification status for the reply domain */
  replyStatus?: Maybe<EmailVerificationStatus>;
  /** Domain being verified for sending */
  sendingDomain?: Maybe<Scalars['String']['output']>;
  /** Verification status for the sending domain */
  sendingStatus: EmailVerificationStatus;
};

/** Email verification state for partner sender email */
export type EmailVerificationState = {
  /** The email address being verified */
  email: Scalars['String']['output'];
  /** ISO date when verification was requested */
  requestedAt: Scalars['DateTime']['output'];
  /** Current verification status: pending, verified, or failed */
  status: Scalars['String']['output'];
  /** ISO date when verification completed (if verified) */
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum EmailVerificationStatus {
  Failed = 'FAILED',
  None = 'NONE',
  Pending = 'PENDING',
  Verified = 'VERIFIED'
}

/** URLs for each platform to call for utterance resolution. Each key corresponds to the specific platform. */
export type Endpoint = {
  actionsOnGoogle?: Maybe<Url>;
  alexa?: Maybe<Url>;
  dialogFlow?: Maybe<Url>;
  google?: Maybe<Url>;
};

/** URLs for each platform to call for utterance resolution. Each key corresponds to the specific platform. */
export type EndpointInput = {
  actionsOnGoogle?: InputMaybe<UrlInput>;
  alexa?: InputMaybe<UrlInput>;
  dialogFlow?: InputMaybe<UrlInput>;
  google?: InputMaybe<UrlInput>;
};

/** Per-app config that tunes the engagement/transcript analysis pipeline. */
export type EngagementAnalysisConfig = {
  /** The app this config belongs to. */
  appId: Scalars['ID']['output'];
  /** Free-form business context fed to the transcript analyzer prompt. */
  businessContext?: Maybe<Scalars['String']['output']>;
  /** The categories the transcript analyzer should tag engagements with. */
  categories: Array<Scalars['String']['output']>;
  /** When this config was last updated (ISO-8601 timestamp). */
  updatedAt: Scalars['String']['output'];
};

export type EngagementAnalysisConfigInput = {
  /**
   * Free-form business context fed to the transcript analyzer prompt.
   * Omit to leave the existing business context untouched.
   */
  businessContext?: InputMaybe<Scalars['String']['input']>;
  /**
   * The categories the transcript analyzer should tag engagements with.
   * Omit to leave the existing categories untouched.
   */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EntitiesQuery = {
  _id: Scalars['ID']['output'];
  /** A subset of entities that are found in the query. */
  entities?: Maybe<Array<Maybe<GetEntitiesListEntity>>>;
  /** The total number of entities that were found. */
  total: Scalars['Int']['output'];
};

export type Entity = {
  _id: Scalars['ID']['output'];
  /** The appId of the app that the slot is associated with. */
  appId: Scalars['ID']['output'];
  /** The date at which the entity was created. */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Optional ID if the slot type has a representation in Dialogflow. */
  dialogflowId?: Maybe<Scalars['String']['output']>;
  /** The name of the slot as it is to the user. */
  displayName: Scalars['String']['output'];
  /** The unique identification as it is in the database. */
  entityId: Scalars['ID']['output'];
  /** Whether or not to exclude the entity from autocomplete suggestions. */
  excludeFromSuggestions: Scalars['Boolean']['output'];
  intents: EntityIntentsSearchResult;
  /**
   * NLU specific metadata used when translating to the NLU entity.
   *
   * Use it to override the entity type for a specific NLU
   */
  nlu?: Maybe<Scalars['EntityNLU']['output']>;
  /**
   * The type of entity.
   * If not set, the default is 'VALUE_SYNONYMS' which uses a set of values
   * and corresponding synonyms for the value.
   *
   * REGEX is when the values are expecting to be a regular expression.  This is not
   * supported by all NLU.
   */
  type?: Maybe<EntityType>;
  /** The date at which the entity was last updated. */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** A query for any errors that may be in the Entity. */
  validation: EntityValidation;
  /** The values that the slot can be. */
  values?: Maybe<Array<EntityValue>>;
};


export type EntityIntentsArgs = {
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type EntityErrorSystemNotification = BaseSystemNotification & {
  /** A time when the notification was received */
  created: Scalars['DateTime']['output'];
  /** A unique identifier for the notification */
  id: Scalars['ID']['output'];
  /** The custom level that the notification should be at. */
  level: SystemNotificationLevel;
  /** A details description of the notification */
  message: Scalars['String']['output'];
  /**
   * Meta data that is associated with the system notification.
   *
   * The meta data returned is dependent on the type of notification.
   */
  meta?: Maybe<EntityErrorSystemNotificationMeta>;
  /** A title or name of the notification */
  name: Scalars['String']['output'];
};

export type EntityErrorSystemNotificationMeta = {
  /** The ID of the app that owns the handler */
  appId: Scalars['ID']['output'];
  /** The ID of the entity that contains the error. */
  entityId: Scalars['ID']['output'];
};

export type EntityIntentsSearchResult = {
  intents?: Maybe<Array<Maybe<Intent>>>;
  total: Scalars['Int']['output'];
};

export type EntitySuggestion = {
  /** The ending location of the word in the provided sentence. */
  end: Scalars['Int']['output'];
  /**
   * The Stentor entityId that the word can map to.
   *
   * If this is blank then there is no entity that matches the word.
   */
  entityId: Scalars['String']['output'];
  /** A parsed suggestion for the word. */
  ner: Scalars['String']['output'];
  /** The original word */
  rawValue: Scalars['String']['output'];
  /** The starting location of the word in the provided sentence. */
  start: Scalars['Int']['output'];
  /** The value of the entity. */
  value: Scalars['String']['output'];
};

export enum EntityType {
  Regex = 'REGEX',
  ValueSynonyms = 'VALUE_SYNONYMS'
}

export type EntityValidation = {
  /** Any errors that may be associated with the object. */
  errors: Array<Maybe<EntityValidationError>>;
  /** Whether or not the full entity is valid. */
  isValid: Scalars['Boolean']['output'];
};

export type EntityValidationError = {
  /** A description of the error message */
  errorMessage: Scalars['String']['output'];
  /** The property that is in error. */
  propertyName?: Maybe<Scalars['String']['output']>;
};

export type EntityValue = {
  /** Used by Alexa.  This value is returned as a reference, such as "LAX" */
  canonicalId?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the entity.
   * For example, for an entity called cities, a value would
   * be "Los Angeles".
   */
  name: Scalars['String']['output'];
  /**
   * List of potential synonyms for the entity.
   *
   * For example, "L.A."" & "City of Angels"
   */
  synonyms?: Maybe<Array<Scalars['String']['output']>>;
};

export type EntityValueInput = {
  /** Used by Alexa.  This value is returned as a reference, such as "LAX" */
  canonicalId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The name of the entity.
   * For example, for an entity called cities, a value would
   * be "Los Angeles".
   */
  name: Scalars['String']['input'];
  /**
   * List of potential synonyms for the entity.
   *
   * For example, "L.A."" & "City of Angels"
   */
  synonyms?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EventAgentResponse = {
  /** The display text of the agent response. */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Knowledge base sources referenced in the response. */
  sources?: Maybe<Array<Maybe<EventSource>>>;
  /** SSML markup of the response. */
  ssml?: Maybe<Scalars['String']['output']>;
  /** Suggested follow-up actions. */
  suggestions?: Maybe<Array<Maybe<EventResponseSuggestion>>>;
};

export type EventFlag = {
  /** The flag that was set. */
  flag: RawQueryEventFlag;
  /** The date at which it was flagged. In ISO 8601 standard. */
  flaggedOn: Scalars['String']['output'];
  /** A not set by the user who flagged it. */
  note?: Maybe<Scalars['String']['output']>;
  /** The user who flagged the event. */
  userEmail: Scalars['String']['output'];
};

export type EventResolutionInput = {
  /** A note that the user may want to add to the resolution for clarity. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** The Stentor event that this resolution is linked to. */
  stentorEventId: Scalars['ID']['input'];
  /**
   * The style of resolution that this is.
   *
   * Default: FIXED
   */
  type?: InputMaybe<EventResolutionType>;
};

export enum EventResolutionType {
  /** The noted problem with the event can not be fixed. */
  CanNotFix = 'CAN_NOT_FIX',
  /** The problem with the event has been resolved. */
  Fixed = 'FIXED',
  /** The noted problem with the event will not be fixed. */
  WillNotFix = 'WILL_NOT_FIX'
}

export type EventResponse = {
  displays?: Maybe<Scalars['JSON']['output']>;
  outputSpeech?: Maybe<EventResponseObject>;
  reprompt?: Maybe<EventResponseObject>;
};

export type EventResponseObject = {
  displayText?: Maybe<Scalars['String']['output']>;
  ssml?: Maybe<Scalars['String']['output']>;
  suggestions?: Maybe<Array<Maybe<EventResponseSuggestion>>>;
};

export type EventResponseSuggestion = {
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/**
 * The slots that were resolved when a user makes a request.
 *
 * The value of the slot can be a variety of different types.  The type
 * is associated with it's '___Value' parameter.
 */
export type EventSlots = {
  /** The value of the slot if it is a boolean. */
  booleanValue?: Maybe<Scalars['Boolean']['output']>;
  /** The iso 8601 value of the date value. */
  dateValue?: Maybe<Scalars['String']['output']>;
  /** The iso 8601 value of the end date value. */
  endDateValue?: Maybe<Scalars['String']['output']>;
  /** The ID of the slot. */
  id?: Maybe<Scalars['String']['output']>;
  /** The value of a slot if it is an integer. */
  integerValue?: Maybe<Scalars['Int']['output']>;
  /** The name of the slot. */
  name?: Maybe<Scalars['String']['output']>;
  rawValue?: Maybe<Scalars['String']['output']>;
  /** A stringified value of the slot. This is used if the type could not be determined or is not supported yet. */
  slotValue?: Maybe<Scalars['String']['output']>;
  /** The iso 8601 value of the start date value. */
  startDateValue?: Maybe<Scalars['String']['output']>;
  /** String values of a slot array. */
  stringArrayValue?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The value of the slot if it is a string. */
  stringValue?: Maybe<Scalars['String']['output']>;
  successfulMatch?: Maybe<Scalars['Boolean']['output']>;
};

export type EventSource = {
  /** Document identifier. */
  document?: Maybe<Scalars['String']['output']>;
  /** Relevant snippet from the source. */
  snippet?: Maybe<Scalars['String']['output']>;
  /** Title of the source document. */
  title?: Maybe<Scalars['String']['output']>;
  /** URL of the source. */
  url?: Maybe<Scalars['String']['output']>;
};

export type EventStentorRequest = {
  anonymous?: Maybe<Scalars['Boolean']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  intentId?: Maybe<Scalars['String']['output']>;
  isHealthCheck?: Maybe<Scalars['Boolean']['output']>;
  isNewSession?: Maybe<Scalars['Boolean']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  matchConfidence?: Maybe<Scalars['Float']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  rawQuery?: Maybe<Scalars['String']['output']>;
  sessionAttributes?: Maybe<EventStentorRequestsSessionAttributes>;
  sessionId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type EventStentorRequestsSessionAttributes = {
  channel?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type EventToolCall = {
  /** Human-readable display name for the tool. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Duration of the tool call in milliseconds. */
  durationMs?: Maybe<Scalars['Float']['output']>;
  /** Whether the tool call resulted in an error. */
  isError?: Maybe<Scalars['Boolean']['output']>;
  /** Input parameters passed to the tool. */
  toolInput?: Maybe<Scalars['JSON']['output']>;
  /** Name of the tool that was called. */
  toolName?: Maybe<Scalars['String']['output']>;
  /** Result returned by the tool. */
  toolResult?: Maybe<Scalars['JSON']['output']>;
};

/** Execution events that were captured by Stentor. */
export type Events = {
  /** Structured agent response with display text, suggestions, and sources. */
  agentResponse?: Maybe<EventAgentResponse>;
  /** The channel ID that threw the event. */
  channel?: Maybe<Scalars['String']['output']>;
  /** For intent request events, the handler that was currently fullfilling the request. */
  currentHandler?: Maybe<Scalars['String']['output']>;
  /** The Stentor environment that it was running (dev, stage, prod, etc.) */
  environment?: Maybe<Scalars['String']['output']>;
  /** For error events, the error code that was sent with the error if there was one. */
  errorCode?: Maybe<Scalars['Int']['output']>;
  /** For error events, the message that was sent with the error. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The ID of the event that. */
  eventId: Scalars['String']['output'];
  /**
   * The index that the event is a part of.
   *
   * @deprecated The index is now part of the eventId.
   */
  eventIndex: Scalars['String']['output'];
  /** A more specific description of the event.  Can be thought of as a sub-section of eventType. */
  eventName?: Maybe<Scalars['String']['output']>;
  /** The time that the event was sent. */
  eventTime?: Maybe<Scalars['String']['output']>;
  /** The type of event that was thrown. */
  eventType?: Maybe<Scalars['String']['output']>;
  /** Flag history for the event.  Most recent at top. */
  flags?: Maybe<Array<Maybe<EventFlag>>>;
  /** Number of input tokens consumed. */
  inputTokens?: Maybe<Scalars['Int']['output']>;
  /** Whether or not the event was a health check. */
  isHealthCheck?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not the event is the first in its session. */
  isNewSession?: Maybe<Scalars['Boolean']['output']>;
  /** End-to-end latency in milliseconds for the agent response. */
  latencyMs?: Maybe<Scalars['Float']['output']>;
  /** Unique message identifier for conversation events. */
  messageId?: Maybe<Scalars['String']['output']>;
  /** The text content of the message (conversation events). */
  messageText?: Maybe<Scalars['String']['output']>;
  /** The model identifier used for generation. */
  modelId?: Maybe<Scalars['String']['output']>;
  /** Number of output tokens generated. */
  outputTokens?: Maybe<Scalars['Int']['output']>;
  /** The messageId of the user message that triggered this agent response. */
  parentMessageId?: Maybe<Scalars['String']['output']>;
  /** A string or JSON parselable string of the payload of the event. */
  payload?: Maybe<Scalars['String']['output']>;
  /** The platform that the event was runnign on. */
  platform?: Maybe<Scalars['String']['output']>;
  /** The captured action before it was interpreted by the platform.  Only for INTENT_REQUEST events on platforms that support it. */
  rawQuery?: Maybe<Scalars['String']['output']>;
  /** For intent requests, the intentId of the request. */
  request?: Maybe<Scalars['String']['output']>;
  /** For completed intent requests, the response that was found. */
  response?: Maybe<EventResponse>;
  /** Role of the message sender: user, assistant, or system. */
  role?: Maybe<Scalars['String']['output']>;
  /** For intent request events, the handler that was chosen to fulfill the next request. */
  selectedHandler?: Maybe<Scalars['String']['output']>;
  /** The ID of a specific session that is associated with the event. */
  sessionId?: Maybe<Scalars['String']['output']>;
  /** For intent requests, the slots that were resolved in teh request. */
  slots?: Maybe<Array<Maybe<EventSlots>>>;
  /** The request that was pulled out of the event. */
  stentorRequest?: Maybe<EventStentorRequest>;
  /** The tag that is related to the query. */
  tag?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Number of tool calls made in this response. */
  toolCallCount?: Maybe<Scalars['Int']['output']>;
  /** Tool calls made during agent response generation. */
  toolCalls?: Maybe<Array<Maybe<EventToolCall>>>;
  /** Number of tool-use rounds in the agent response. */
  toolRounds?: Maybe<Scalars['Int']['output']>;
  /** Turn identifier linking a user message to its agent response. */
  turnId?: Maybe<Scalars['String']['output']>;
  /** Zero-based index of this turn within the conversation session. */
  turnIndex?: Maybe<Scalars['Int']['output']>;
  /** The ID of the user which was making the request. */
  userId?: Maybe<Scalars['String']['output']>;
};

export type ExecutableHandlerPath = BaseHandlerPath & {
  actions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Conditions to be met. */
  conditions?: Maybe<Scalars['PathConditions']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  /** The ID of the handler to forward or redirect the request to */
  intentId: Scalars['String']['output'];
  /**
   * Optional platform filter for the path.
   *
   * If set, the path will only apply to the specified platform.
   */
  platform?: Maybe<Scalars['String']['output']>;
  /**
   * Optional, if redirecting or forwarding to a handler that is expecting slots,
   * set these to pre-populate them on the request.
   */
  slots?: Maybe<Scalars['JSON']['output']>;
  /**
   * Type of path.
   *
   * Setting type to START changes the request so that
   * handler.start() is called.
   *
   * Not setting the type passes the request straight
   * through, requiring the new handler to handle the
   * request as is.
   */
  type?: Maybe<Scalars['String']['output']>;
};

export type ExpectedSlot = {
  /** The value of the slot if it is a boolean. */
  booleanValue?: Maybe<Scalars['Boolean']['output']>;
  /** The iso 8601 value of the date value. */
  dateValue?: Maybe<Scalars['String']['output']>;
  /** The iso 8601 value of the end date value. */
  endDateValue?: Maybe<Scalars['String']['output']>;
  /** The value of a slot if it is a float. Integer values will also be included. */
  floatValue?: Maybe<Scalars['Float']['output']>;
  /** The value of a slot if it is an integer. */
  integerValue?: Maybe<Scalars['Int']['output']>;
  /** The name of the expected slot. */
  name: Scalars['String']['output'];
  /** The iso 8601 value of the start date value. */
  startDateValue?: Maybe<Scalars['String']['output']>;
  /** String values of a slot array. */
  stringArrayValue?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The value of the slot if it is a string. */
  stringValue?: Maybe<Scalars['String']['output']>;
};

export type ExpectedUtteranceTestResult = {
  /** The intentId that is expected to be returned when the utterance is found. */
  intentId: Scalars['String']['output'];
  /** The slots that are expected to be returned. */
  matchedSlots?: Maybe<Array<Maybe<ExpectedSlot>>>;
  /** The request type expected. */
  type?: Maybe<Scalars['String']['output']>;
};

/** Comparison results for an experiment. */
export type ExperimentComparison = {
  /** Confidence level (0-100) */
  confidenceLevel?: Maybe<Scalars['Float']['output']>;
  /** The experiment ID */
  experimentId: Scalars['ID']['output'];
  /** Whether the results are statistically significant */
  statisticallySignificant?: Maybe<Scalars['Boolean']['output']>;
  /** Metrics for each variant */
  variants: Array<VariantMetrics>;
  /** The variant with the highest conversion rate */
  winner?: Maybe<VariantMetrics>;
};

/** Overall experiment metrics including all variants. */
export type ExperimentMetrics = {
  /** End date of the analysis period */
  endDate?: Maybe<Scalars['String']['output']>;
  /** The experiment ID */
  experimentId: Scalars['ID']['output'];
  /** The experiment name */
  experimentName?: Maybe<Scalars['String']['output']>;
  /** Start date of the analysis period */
  startDate?: Maybe<Scalars['String']['output']>;
  /** Metrics for each variant */
  variants: Array<VariantMetrics>;
};

export type ExportAppMutationResponse = {
  url: Scalars['URL']['output'];
};

export type ExportToCsvReturn = {
  url: Scalars['URL']['output'];
};

export type FaqMutation = {
  /** Adds FAQs to the database. */
  addFAQs: Array<Maybe<AddedFaq>>;
  /** Clears all FAQs from the app. */
  clear: ClearFaqReturn;
  exportToCSV: ExportToCsvReturn;
  /** Update operations on FAQs */
  update: UpdateFaqMutation;
  /**
   * Uploads a CSV file of the FAQs to the database.
   *
   * Row 1: Question
   * Row 2: Answer
   * Row 3: URL of the origin (optional)
   * Row 4: External ID to an FAQ
   */
  uploadCSV: UploadFaqReturn;
};


export type FaqMutationAddFaQsArgs = {
  faqs: Array<InputMaybe<AddFaq>>;
  resolution?: InputMaybe<EventResolutionInput>;
};


export type FaqMutationExportToCsvArgs = {
  includeTitle?: InputMaybe<Scalars['Boolean']['input']>;
  includeUrl?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FaqMutationUpdateArgs = {
  id: Scalars['ID']['input'];
};


export type FaqMutationUploadCsvArgs = {
  file: Scalars['URL']['input'];
  hasTitle?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum FaqNotAddedReason {
  AlreadyExists = 'ALREADY_EXISTS',
  Unknown = 'UNKNOWN'
}

export type FaqQuestionSuggestion = {
  /** The possible question */
  question: Scalars['String']['output'];
};

export type FaqQuestionSuggestions = {
  suggestions: Array<FaqQuestionSuggestion>;
};

export type FaqSuggestionReturn = {
  failedPutRequests: Scalars['Int']['output'];
  responses: Scalars['JSON']['output'];
};

export type FacebookMessengerAppChannel = BaseAppChannel & {
  /** Human readable name for the avatar. */
  avatarName?: Maybe<Scalars['String']['output']>;
  /** URL to the facebook page's avatar. */
  avatarUrl?: Maybe<Scalars['URL']['output']>;
  /** URL for the directory listing. */
  directoryListing?: Maybe<Scalars['String']['output']>;
  /** URI where the channel can be accessed. */
  endPoint?: Maybe<Scalars['String']['output']>;
  /** AppId of the app that it's linked to. */
  facebookAppId?: Maybe<Scalars['String']['output']>;
  /** Human readable name for the Facebook app. */
  facebookAppName?: Maybe<Scalars['String']['output']>;
  facebookAppSecret?: Maybe<Scalars['String']['output']>;
  /** The ID of the channel. */
  id: Scalars['String']['output'];
  /** The display name for the channel. */
  name?: Maybe<Scalars['String']['output']>;
  /** The pages that are linked to the channel. */
  pages?: Maybe<Array<Maybe<FacebookPage>>>;
  /** The lifecycle status of the app. */
  status?: Maybe<AppChannelStatus>;
  /** The type of channel */
  type: Scalars['String']['output'];
  /** Retrieves any events that are related to this specific app */
  usageEvents?: Maybe<TotalUsageEvents>;
  /**
   * ID of the NLU to use within app.nlu[].
   *
   * If it exists, the channel will use the provided NLU at runtime
   * to convert the raw text to an Intent
   *
   * If the value is "*", then it will pick the first available NLU within app.nlu[]
   */
  useNLU?: Maybe<Scalars['String']['output']>;
};


export type FacebookMessengerAppChannelUsageEventsArgs = {
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type FacebookMessengerAppChannelInput = {
  /** Human readable name for the avatar. */
  avatarName?: InputMaybe<Scalars['String']['input']>;
  /** URL to the facebook page's avatar. */
  avatarUrl?: InputMaybe<Scalars['URL']['input']>;
  /** URL for the directory listing. */
  directoryListing?: InputMaybe<Scalars['String']['input']>;
  /** URI where the channel can be accessed. */
  endPoint?: InputMaybe<Scalars['String']['input']>;
  /** AppId of the app that it's linked to. */
  facebookAppId?: InputMaybe<Scalars['String']['input']>;
  /** Human readable name for the Facebook app. */
  facebookAppName?: InputMaybe<Scalars['String']['input']>;
  facebookAppSecret?: InputMaybe<Scalars['String']['input']>;
  /**
   * The ID of the channel.
   *
   * When calling a "CreateChannel" function, then ID will be
   * used to determine if the channel shoudl be inserted or updated.
   *
   * If the ID is provided and already exists, the channel will be
   * updated.  Otherwise the channel will be inserted and an ID will be
   * generated.
   */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The display name for the channel. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The pages that are linked to the channel. */
  pages?: InputMaybe<Array<InputMaybe<FacebookPageInput>>>;
  /** The type of channel */
  type: Scalars['String']['input'];
  /**
   * ID of the NLU to use within app.nlu[].
   *
   * If it exists, the channel will use the provided NLU at runtime
   * to convert the raw text to an Intent
   *
   * If the value is "*", then it will pick the first available NLU within app.nlu[]
   */
  useNLU?: InputMaybe<Scalars['String']['input']>;
};

export type FacebookPage = {
  pageId: Scalars['ID']['output'];
  pageName?: Maybe<Scalars['String']['output']>;
  pageToken?: Maybe<Scalars['String']['output']>;
};

export type FacebookPageInput = {
  pageId: Scalars['ID']['input'];
  pageName?: InputMaybe<Scalars['String']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FaqQueryReturn = {
  faq: Array<Maybe<ScoredWebFaq>>;
  total: Scalars['Int']['output'];
};

/** A bucket with a value and count for use in filter dropdowns. */
export type FilterBucket = {
  /** The number of items with this value. */
  count: Scalars['Int']['output'];
  /** The filter value. */
  value: Scalars['String']['output'];
};

export type FirstTimeHandlerResponseSegment = HandlerResponseSegment & {
  fistTime: Scalars['Boolean']['output'];
  segment: ResponseOutput;
};

export type FlagEventReturn = {
  message?: Maybe<Scalars['String']['output']>;
};

/** Statistics on the flagged events */
export type FlagTotals = {
  CONFIRMED_CORRECT: Scalars['Int']['output'];
  CORRECT: Scalars['Int']['output'];
  FLAGGED: Scalars['Int']['output'];
  HELPFUL: Scalars['Int']['output'];
  INCORRECT: Scalars['Int']['output'];
  INCORRECT_RESOLVED: Scalars['Int']['output'];
  NEEDS_HUMAN: Scalars['Int']['output'];
  OPTIMAL: Scalars['Int']['output'];
};

/** Number of distinct sessions that abandoned the form for a given reason. */
export type FormAbandonReason = {
  reason: Scalars['String']['output'];
  sessions: Scalars['Int']['output'];
};

export type FormAnalytics = {
  abandonReasons: Array<FormAbandonReason>;
  byHost?: Maybe<Array<FormHostSegment>>;
  overall: FormFunnel;
  stepDropoff: Array<FormStepDrop>;
};

/** An A/B testing experiment for form widgets. */
export type FormExperiment = {
  /** Whether the experiment is currently running */
  active: Scalars['Boolean']['output'];
  /** ISO date string for when the experiment ends */
  endDate?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the experiment (e.g., 'exp_abc123') */
  id: Scalars['ID']['output'];
  /** Human-readable name for the experiment */
  name: Scalars['String']['output'];
  /** ISO date string for when the experiment started */
  startDate?: Maybe<Scalars['String']['output']>;
  /** The variants being tested */
  variants: Array<FormVariant>;
};

export type FormExperimentInput = {
  /** Whether the experiment is currently running */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** ISO date string for when the experiment ends */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** Human-readable name for the experiment */
  name: Scalars['String']['input'];
  /** ISO date string for when the experiment started */
  startDate?: InputMaybe<Scalars['String']['input']>;
  /** The variants being tested */
  variants: Array<FormVariantInput>;
};

export type FormExperimentMutation = {
  /** Creates a new form experiment for the handler. */
  createExperiment: FormExperiment;
  /** Deletes a form experiment. */
  deleteExperiment: Scalars['Boolean']['output'];
  /** Toggles the active state of a form experiment. */
  toggleExperiment: FormExperiment;
  /** Updates an existing form experiment. */
  updateExperiment: FormExperiment;
};


export type FormExperimentMutationCreateExperimentArgs = {
  experiment: FormExperimentInput;
};


export type FormExperimentMutationDeleteExperimentArgs = {
  experimentId: Scalars['ID']['input'];
};


export type FormExperimentMutationToggleExperimentArgs = {
  active: Scalars['Boolean']['input'];
  experimentId: Scalars['ID']['input'];
};


export type FormExperimentMutationUpdateExperimentArgs = {
  experiment: FormExperimentInput;
  experimentId: Scalars['ID']['input'];
};

/** Session-based conversion funnel metrics for the Form Widget. */
export type FormFunnel = {
  /** 1 - engagedSessions / openSessions */
  bounceRate: Scalars['Float']['output'];
  /** submitSessions / engagedSessions */
  completionRate: Scalars['Float']['output'];
  /** submitSessions / openSessions */
  conversionRate: Scalars['Float']['output'];
  /** Distinct sessions that progressed past the first step (WIDGET_FORM_STEP, a later captureStepIndex, or WIDGET_FORM_SUBMIT). */
  engagedSessions: Scalars['Int']['output'];
  /** Distinct sessions where the form was opened (WIDGET_FORM_OPEN). */
  openSessions: Scalars['Int']['output'];
  /** Distinct sessions that submitted the form (WIDGET_FORM_SUBMIT). */
  submitSessions: Scalars['Int']['output'];
};

/** Funnel metrics segmented by page host. */
export type FormHostSegment = {
  funnel: FormFunnel;
  /** Either booking or customer_site. */
  segment: Scalars['String']['output'];
};

/** Number of distinct sessions that abandoned the form at a given step index. */
export type FormStepDrop = {
  sessions: Scalars['Int']['output'];
  stepIndex: Scalars['Int']['output'];
};

/** A variant in a form A/B testing experiment. */
export type FormVariant = {
  /** Reference to forms[].name in the handler data */
  formName: Scalars['String']['output'];
  /** Unique identifier for this variant (e.g., 'control', 'variant_a') */
  id: Scalars['ID']['output'];
  /** Human-readable name for the variant */
  name: Scalars['String']['output'];
  /** Traffic weight 0-100, all variants must sum to 100 */
  weight: Scalars['Int']['output'];
};

export type FormVariantInput = {
  /** Reference to forms[].name in the handler data */
  formName: Scalars['String']['input'];
  /** Unique identifier for this variant (e.g., 'control', 'variant_a') */
  id: Scalars['ID']['input'];
  /** Human-readable name for the variant */
  name: Scalars['String']['input'];
  /** Traffic weight 0-100, all variants must sum to 100 */
  weight: Scalars['Int']['input'];
};

export type FormWidgetAppChannel = BaseAppChannel & {
  /** Extra custom values */
  attributes?: Maybe<Scalars['StringMap']['output']>;
  /** The auto-greeting string (intent we start the widget with) */
  autoGreeting?: Maybe<Scalars['String']['output']>;
  /** Configure auto-open settings */
  autoOpen?: Maybe<FormWidgetAutoOpen>;
  /** Used for autocomplete suggestions. */
  autocompleteSuggestionsUrl?: Maybe<Scalars['URLString']['output']>;
  /** When provided, when on stand-along pages, it will display the business address */
  businessAddress?: Maybe<Scalars['String']['output']>;
  /** When provided, when on stand-along pages, it will display the business logo */
  businessLogoUrl?: Maybe<Scalars['String']['output']>;
  /** When provided, when on stand-along pages, it will display the business name */
  businessName?: Maybe<Scalars['String']['output']>;
  /** When provided, when on stand-along pages, it will display the business website */
  businessWebsite?: Maybe<Scalars['String']['output']>;
  /** When provided, for stand-alone pages, it will display the chat widget */
  chatWidgetKey?: Maybe<Scalars['String']['output']>;
  connection?: Maybe<FormWidgetConnectionConfig>;
  /** URL for the directory listing. */
  directoryListing?: Maybe<Scalars['String']['output']>;
  /** Form Widget is disabled and will not appear on the website */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** URI where the channel can be accessed. */
  endPoint?: Maybe<Scalars['String']['output']>;
  /** The ID of the channel. */
  id: Scalars['String']['output'];
  /**
   * The ID of the intent (thus the handler) that has the content for the form.
   *
   * If this is provided, autoGreeting will be ignored.
   *
   * This is the preferred method as it doesn't require an NLU at all and is more performant.
   */
  intentId?: Maybe<Scalars['ID']['output']>;
  /** The key that goes in the url when retrieving the form widget to apply custom themes. */
  key?: Maybe<Scalars['String']['output']>;
  /**
   * Meta (Facebook) Pixel ID for PageView and Lead conversion tracking on stand-alone pages.
   * Numeric string, typically 15–16 digits (e.g. "4092252157584843").
   */
  metaPixelId?: Maybe<Scalars['String']['output']>;
  /** The display name for the channel. */
  name?: Maybe<Scalars['String']['output']>;
  sideButtonLabel?: Maybe<Scalars['String']['output']>;
  /** The lifecycle status of the app. */
  status?: Maybe<AppChannelStatus>;
  /** Theme for the Form Widget */
  theme?: Maybe<FormWidgetTheme>;
  /** TrustedForm lead certification configuration */
  trustedForm?: Maybe<TrustedFormConfig>;
  /** The type of channel */
  type: Scalars['String']['output'];
  /** Retrieves any events that are related to this specific app */
  usageEvents?: Maybe<TotalUsageEvents>;
  /**
   * ID of the NLU to use within app.nlu[].
   *
   * If it exists, the channel will use the provided NLU at runtime
   * to convert the raw text to an Intent
   *
   * If the value is "*", then it will pick the first available NLU within app.nlu[]
   */
  useNLU?: Maybe<Scalars['String']['output']>;
};


export type FormWidgetAppChannelUsageEventsArgs = {
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type FormWidgetAppChannelInput = {
  /** Extra custom values */
  attributes?: InputMaybe<Scalars['StringMap']['input']>;
  /** The auto-greeting string (intent we start the widget with) */
  autoGreeting?: InputMaybe<Scalars['String']['input']>;
  /** Configure auto-open settings */
  autoOpen?: InputMaybe<FormWidgetAutoOpenInput>;
  /** Used for autocomplete suggestions. */
  autocompleteSuggestionsUrl?: InputMaybe<Scalars['URLString']['input']>;
  /** When provided, when on stand-along pages, it will display the business address */
  businessAddress?: InputMaybe<Scalars['String']['input']>;
  /** When provided, when on stand-along pages, it will display the business logo */
  businessLogoUrl?: InputMaybe<Scalars['String']['input']>;
  /** When provided, when on stand-along pages, it will display the business name */
  businessName?: InputMaybe<Scalars['String']['input']>;
  /** When provided, when on stand-along pages, it will display the business website */
  businessWebsite?: InputMaybe<Scalars['String']['input']>;
  /** When provided, for stand-alone pages, it will display the chat widget */
  chatWidgetKey?: InputMaybe<Scalars['String']['input']>;
  connection?: InputMaybe<FormWidgetConnectionConfigInput>;
  /** URL for the directory listing. */
  directoryListing?: InputMaybe<Scalars['String']['input']>;
  /** Form Widget is disabled and will not appear on the website */
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** URI where the channel can be accessed. */
  endPoint?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the channel. */
  id?: InputMaybe<Scalars['String']['input']>;
  /**
   * The ID of the intent (thus the handler) that has the content for the form.
   *
   * If this is provided, autoGreeting will be ignored.
   *
   * This is the preferred method as it doesn't require an NLU at all and is more performant.
   */
  intentId?: InputMaybe<Scalars['ID']['input']>;
  /** Meta (Facebook) Pixel ID for PageView and Lead conversion tracking on stand-alone pages. */
  metaPixelId?: InputMaybe<Scalars['String']['input']>;
  /** The display name for the channel. */
  name?: InputMaybe<Scalars['String']['input']>;
  sideButtonLabel?: InputMaybe<Scalars['String']['input']>;
  /** Theme for the search bar. */
  theme?: InputMaybe<FormWidgetThemeInput>;
  /** TrustedForm lead certification configuration */
  trustedForm?: InputMaybe<TrustedFormConfigInput>;
  /** The type of channel */
  type: Scalars['String']['input'];
  /**
   * ID of the NLU to use within app.nlu[].
   *
   * If it exists, the channel will use the provided NLU at runtime
   * to convert the raw text to an Intent
   *
   * If the value is "*", then it will pick the first available NLU within app.nlu[]
   */
  useNLU?: InputMaybe<Scalars['String']['input']>;
};

export type FormWidgetAutoOpen = {
  /** If true, it will automatically open the form widget, remove the ability to close it, remove the shadow boxing effect. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Minimum viewport width in pixels */
  minimumWidth?: Maybe<Scalars['Int']['output']>;
  /** Trigger combination mode: 'any' (OR) or 'all' (AND) */
  mode?: Maybe<Scalars['String']['output']>;
  /** URL patterns to match (e.g., ["/landing", "/promo"]) */
  patterns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** sessionStorage key for tracking dismissed state */
  sessionKey?: Maybe<Scalars['String']['output']>;
  /** Trigger configuration for auto-opening the form widget */
  triggers?: Maybe<FormWidgetAutoOpenTriggers>;
};

export type FormWidgetAutoOpenInput = {
  /** If true, it will automatically open the form widget, remove the ability to close it, remove the shadow boxing effect. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Minimum viewport width in pixels */
  minimumWidth?: InputMaybe<Scalars['Int']['input']>;
  /** Trigger combination mode: 'any' (OR) or 'all' (AND) */
  mode?: InputMaybe<Scalars['String']['input']>;
  /** URL patterns to match (e.g., ["/landing", "/promo"]) */
  patterns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** sessionStorage key for tracking dismissed state */
  sessionKey?: InputMaybe<Scalars['String']['input']>;
  /** Trigger configuration for auto-opening the form widget */
  triggers?: InputMaybe<FormWidgetAutoOpenTriggersInput>;
};

export type FormWidgetAutoOpenTriggers = {
  /** Delay in milliseconds before showing the form widget (0-300000) */
  delay?: Maybe<Scalars['Int']['output']>;
  /** Show form widget when mouse leaves viewport (exit intent) */
  exitIntent?: Maybe<Scalars['Boolean']['output']>;
  /** Pixels from top of viewport for exit intent trigger (default: 50) */
  exitIntentThreshold?: Maybe<Scalars['Int']['output']>;
  /** Milliseconds of user inactivity before showing (0-300000) */
  inactivity?: Maybe<Scalars['Int']['output']>;
  /** Scroll percentage threshold (0-100) - show when user scrolls past this point */
  scrollPercent?: Maybe<Scalars['Int']['output']>;
};

export type FormWidgetAutoOpenTriggersInput = {
  /** Delay in milliseconds before showing the form widget (0-300000) */
  delay?: InputMaybe<Scalars['Int']['input']>;
  /** Show form widget when mouse leaves viewport (exit intent) */
  exitIntent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Pixels from top of viewport for exit intent trigger (default: 50) */
  exitIntentThreshold?: InputMaybe<Scalars['Int']['input']>;
  /** Milliseconds of user inactivity before showing (0-300000) */
  inactivity?: InputMaybe<Scalars['Int']['input']>;
  /** Scroll percentage threshold (0-100) - show when user scrolls past this point */
  scrollPercent?: InputMaybe<Scalars['Int']['input']>;
};

export type FormWidgetCardTheme = {
  /** Background color of form cards */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** Text color of form cards */
  color?: Maybe<Scalars['String']['output']>;
  /** Font family of form card text */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** Font size of form card text */
  fontSize?: Maybe<Scalars['String']['output']>;
};

export type FormWidgetCardThemeInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  fontSize?: InputMaybe<Scalars['String']['input']>;
};

export type FormWidgetCheckboxTheme = {
  /** Background color of checkboxes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** Text color of checkbox labels */
  color?: Maybe<Scalars['String']['output']>;
  /** Font family of checkbox labels */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** Font size of checkbox labels */
  fontSize?: Maybe<Scalars['String']['output']>;
};

export type FormWidgetCheckboxThemeInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  fontSize?: InputMaybe<Scalars['String']['input']>;
};

export type FormWidgetChipsTheme = {
  /** Background color of chips */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** Background color when chip is selected */
  backgroundColorSelected?: Maybe<Scalars['String']['output']>;
  /** Text color of chips */
  color?: Maybe<Scalars['String']['output']>;
  /** Text color when chip is selected */
  colorSelected?: Maybe<Scalars['String']['output']>;
  /** Font family of chip text */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** Font size of chip text */
  fontSize?: Maybe<Scalars['String']['output']>;
};

export type FormWidgetChipsThemeInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColorSelected?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  colorSelected?: InputMaybe<Scalars['String']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  fontSize?: InputMaybe<Scalars['String']['input']>;
};

export type FormWidgetConnectionConfig = {
  /** Key used for basic authentication. */
  accountKey?: Maybe<Scalars['String']['output']>;
  /** Backend URL */
  serverUrl?: Maybe<Scalars['URLString']['output']>;
};

export type FormWidgetConnectionConfigInput = {
  /** Key used for basic authentication. */
  accountKey?: InputMaybe<Scalars['String']['input']>;
  /** Backend URL */
  serverUrl?: InputMaybe<Scalars['URLString']['input']>;
};

export type FormWidgetDateTheme = {
  /** Background color of date inputs */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** Background color when date is selected */
  backgroundColorSelected?: Maybe<Scalars['String']['output']>;
  /** Text color of date inputs */
  color?: Maybe<Scalars['String']['output']>;
  /** Font family of date input text */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** Font size of date input text */
  fontSize?: Maybe<Scalars['String']['output']>;
};

export type FormWidgetDateThemeInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColorSelected?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  fontSize?: InputMaybe<Scalars['String']['input']>;
};

export type FormWidgetDropdownTheme = {
  /** Background color of dropdown menus */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** Text color of dropdown options */
  color?: Maybe<Scalars['String']['output']>;
  /** Font family of dropdown text */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** Font size of dropdown text */
  fontSize?: Maybe<Scalars['String']['output']>;
};

export type FormWidgetDropdownThemeInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  fontSize?: InputMaybe<Scalars['String']['input']>;
};

export type FormWidgetFontTheme = {
  /** Font family name to use */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** URL link to load the font from (e.g., Google Fonts) */
  link?: Maybe<Scalars['String']['output']>;
};

export type FormWidgetFontThemeInput = {
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type FormWidgetSideButtonTheme = {
  /** Background color of the side button */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** Text color of the side button */
  color?: Maybe<Scalars['String']['output']>;
  /** Font family of the side button text */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** Font size of the side button text */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** Minimum length of the side button */
  minLength?: Maybe<Scalars['String']['output']>;
  /** CSS position of the side button */
  position?: Maybe<Scalars['String']['output']>;
  /** Top offset position of the side button */
  top?: Maybe<Scalars['String']['output']>;
};

export type FormWidgetSideButtonThemeInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  fontSize?: InputMaybe<Scalars['String']['input']>;
  minLength?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  top?: InputMaybe<Scalars['String']['input']>;
};

export type FormWidgetStandAloneTheme = {
  /** Background color of the page */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** Header Theme that displays the logo and business name */
  header?: Maybe<FormWidgetTextTheme>;
};

export type FormWidgetStandAloneThemeInput = {
  /** Background color of the page */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Header Theme that displays the logo and business name */
  header?: InputMaybe<FormWidgetTextThemeInput>;
};

export type FormWidgetTextTheme = {
  /** Background color of text inputs */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** Text color of text inputs */
  color?: Maybe<Scalars['String']['output']>;
  /** Font family of text input text */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** Font size of text input text */
  fontSize?: Maybe<Scalars['String']['output']>;
};

export type FormWidgetTextThemeInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  fontSize?: InputMaybe<Scalars['String']['input']>;
};

export type FormWidgetTheme = {
  /** Primary accent color used throughout the widget */
  accentColor?: Maybe<Scalars['String']['output']>;
  /** Background color of the widget */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** Card theme configuration */
  card?: Maybe<FormWidgetCardTheme>;
  /** Checkbox theme configuration */
  checkbox?: Maybe<FormWidgetCheckboxTheme>;
  /** Chips theme configuration */
  chips?: Maybe<FormWidgetChipsTheme>;
  /**
   * Debug console that will allow people to attach and retrieve any data they want in the form widget.
   *
   * @deprecated This is a temporary solution and will be removed in the future. Please use attributes instead.
   */
  data?: Maybe<Scalars['JSON']['output']>;
  /** Date input theme configuration */
  date?: Maybe<FormWidgetDateTheme>;
  /** Dropdown theme configuration */
  dropdown?: Maybe<FormWidgetDropdownTheme>;
  /** Font theme configuration */
  font?: Maybe<FormWidgetFontTheme>;
  /** Background color of the header section */
  headerBackgroundColor?: Maybe<Scalars['String']['output']>;
  /** Text color in the header section */
  headerTextColor?: Maybe<Scalars['String']['output']>;
  /** Background color of primary buttons */
  primaryButtonColor?: Maybe<Scalars['String']['output']>;
  /** Text color of primary buttons */
  primaryButtonTextColor?: Maybe<Scalars['String']['output']>;
  /** Background color of secondary buttons */
  secondaryButtonColor?: Maybe<Scalars['String']['output']>;
  /** Text color of secondary buttons */
  secondaryButtonTextColor?: Maybe<Scalars['String']['output']>;
  /** Side button theme configuration */
  sideButton?: Maybe<FormWidgetSideButtonTheme>;
  /** Stand-alone page theme configuration */
  standAlone?: Maybe<FormWidgetStandAloneTheme>;
  /** Text input theme configuration */
  text?: Maybe<FormWidgetTextTheme>;
};

export type FormWidgetThemeInput = {
  accentColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  card?: InputMaybe<FormWidgetCardThemeInput>;
  checkbox?: InputMaybe<FormWidgetCheckboxThemeInput>;
  chips?: InputMaybe<FormWidgetChipsThemeInput>;
  date?: InputMaybe<FormWidgetDateThemeInput>;
  dropdown?: InputMaybe<FormWidgetDropdownThemeInput>;
  font?: InputMaybe<FormWidgetFontThemeInput>;
  headerBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  headerTextColor?: InputMaybe<Scalars['String']['input']>;
  primaryButtonColor?: InputMaybe<Scalars['String']['input']>;
  primaryButtonTextColor?: InputMaybe<Scalars['String']['input']>;
  secondaryButtonColor?: InputMaybe<Scalars['String']['input']>;
  secondaryButtonTextColor?: InputMaybe<Scalars['String']['input']>;
  sideButton?: InputMaybe<FormWidgetSideButtonThemeInput>;
  standAlone?: InputMaybe<FormWidgetStandAloneThemeInput>;
  text?: InputMaybe<FormWidgetTextThemeInput>;
};

export type ForwardInput = {
  paths: Array<InputMaybe<Scalars['JSON']['input']>>;
};

export type GenerateCheckoutSessionInput = {
  /** The appId to associate with the subscription */
  appId: Scalars['String']['input'];
  /** Optional Stripe coupon ID to apply */
  couponId?: InputMaybe<Scalars['String']['input']>;
  /** The organizationId that owns the app */
  organizationId: Scalars['String']['input'];
  /** The Stripe product ID (e.g., prod_UgEc1b0knbSMjR) */
  prodId: Scalars['String']['input'];
  /** Number of free trial days. Omit or 0 for no trial. */
  trialDays?: InputMaybe<Scalars['Int']['input']>;
};

export type GeneratePaymentLinkInput = {
  /** The appId to associate with the subscription */
  appId: Scalars['String']['input'];
  /** The organizationId that owns the app */
  organizationId: Scalars['String']['input'];
  /** The Stripe product ID (e.g., prod_UgEc1b0knbSMjR) */
  prodId: Scalars['String']['input'];
  /** Number of free trial days. Omit or 0 for no trial. */
  trialDays?: InputMaybe<Scalars['Int']['input']>;
};

export type GeneratedPaymentUrl = {
  /** The URL to send to the customer */
  url: Scalars['String']['output'];
};

/** Geographic bounding box for map viewport calculations. */
export type GeoBounds = {
  /** Bottom-right corner of the bounding box */
  bottomRight: GeoPoint;
  /** Top-left corner of the bounding box */
  topLeft: GeoPoint;
};

/** Input type for geographic bounding box filters. */
export type GeoBoundsInput = {
  /** Bottom-right corner latitude (-90 to 90) */
  bottomRightLat: Scalars['bottomRightLat_Float_NotNull_min_dot90_max_90']['input'];
  /** Bottom-right corner longitude (-180 to 180) */
  bottomRightLon: Scalars['bottomRightLon_Float_NotNull_min_dot180_max_180']['input'];
  /** Top-left corner latitude (-90 to 90) */
  topLeftLat: Scalars['topLeftLat_Float_NotNull_min_dot90_max_90']['input'];
  /** Top-left corner longitude (-180 to 180) */
  topLeftLon: Scalars['topLeftLon_Float_NotNull_min_dot180_max_180']['input'];
};

/** Geographic aggregation for items by location */
export type GeoBucket = {
  /** Number of items from this location */
  count: Scalars['Int']['output'];
  /** Latitude coordinate (if available) */
  lat?: Maybe<Scalars['Float']['output']>;
  /** Geographic identifier (city, state, or coordinates) */
  location: Scalars['String']['output'];
  /** Longitude coordinate (if available) */
  lon?: Maybe<Scalars['Float']['output']>;
};

/** A geographic point with latitude and longitude coordinates. */
export type GeoPoint = {
  /** Latitude coordinate (-90 to 90) */
  lat: Scalars['Float']['output'];
  /** Longitude coordinate (-180 to 180) */
  lon: Scalars['Float']['output'];
};

export type Geocode = {
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

export type GeocodeInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

/** The available app attributes that are from a Organization Get Apps query. */
export type GetAppsListApp = {
  _id: Scalars['ID']['output'];
  /** The unique ID of the google action that the app is linked to. */
  actionsOnGoogleId?: Maybe<Scalars['String']['output']>;
  /** The category that the app will fall in to when published to Alexa. */
  alexaCategory?: Maybe<Scalars['String']['output']>;
  /** The unique ID of the alexa skill that the app is linked to. */
  alexaSkillId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the app in Stentor. */
  appId: Scalars['String']['output'];
  /**
   * The description for the app.
   *
   * The description cannot be more than 4000 characters.
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Example phrases the help users know how to use the app.
   *
   * At least three are required for publication.
   */
  examplePhrases?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The phrase a user must speak to wake the app up on a specific platform. */
  invocationName?: Maybe<Scalars['String']['output']>;
  /**
   * Keywords to help when searching directories for the app
   *
   * Max of 30 keywords are allowed.
   */
  keywords?: Maybe<Scalars['String']['output']>;
  /**
   * A large icon for the app, 512x512 PNG
   *
   * Required for Alexa
   */
  largeIcon?: Maybe<Scalars['String']['output']>;
  /** The human-readable name of the app. */
  name: Scalars['String']['output'];
  /** The ID of the organization that the app is linked to. */
  organizationId: Scalars['String']['output'];
  /**
   * A small icon for the app, 108x108 PNG
   *
   * Required for Alexa
   */
  smallIcon?: Maybe<Scalars['String']['output']>;
  /** The status that the app is currently in Stentor. */
  status?: Maybe<GetAppsListStatus>;
  /**
   * The summary of the app.
   *
   * Shorter than the description, maximum 160 characters.
   */
  summary?: Maybe<Scalars['String']['output']>;
  /** The website associated with the app. */
  website?: Maybe<Scalars['String']['output']>;
};

export type GetAppsListStatus = {
  /** The email of the user who last changed the status. */
  email?: Maybe<Scalars['String']['output']>;
  /** Any notes that was associated with the status change. */
  notes?: Maybe<Scalars['String']['output']>;
  /**
   * The time the status was last changed.
   *
   * Format: ISO 8601 timestamp. Null if timestamp is invalid or missing.
   */
  timestamp?: Maybe<Scalars['String']['output']>;
  /** The status level of the app. */
  type: Scalars['String']['output'];
};

export type GetAppsQuery = {
  _id: Scalars['ID']['output'];
  /** The apps that were discovered in the query. */
  apps: Array<Maybe<GetAppsListApp>>;
  /** The total number of apps that were found in the query */
  total: Scalars['Int']['output'];
};

export type GetEntitiesListEntity = {
  _id: Scalars['ID']['output'];
  /** The appId of the app that the slot is associated with. */
  appId: Scalars['ID']['output'];
  /** Optional ID if the slot type has a representation in Dialogflow. */
  dialogflowId?: Maybe<Scalars['String']['output']>;
  /** The name of the slot as it is to the user. */
  displayName: Scalars['String']['output'];
  /** The unique identification as it is in the database. */
  entityId: Scalars['ID']['output'];
  /**
   * The type of entity.
   * If not set, the default is 'VALUE_SYNONYMS' which uses a set of values
   * and corresponding synonyms for the value.
   *
   * REGEX is when the values are expecting to be a regular expression.  This is not
   * supported by all NLU.
   */
  type?: Maybe<EntityType>;
  /** The values that the slot can be. */
  values?: Maybe<Array<Maybe<EntityValue>>>;
};

export type GetHandlersListHandler = {
  _id: Scalars['ID']['output'];
  /** The ID of the app that the handler is linked to. */
  appId: Scalars['String']['output'];
  /** The location that the intent was last saved in Stentor's Handler Graph UI. */
  graphCoords?: Maybe<GraphCoords>;
  /** The unique identifier of the handler itself. */
  intentId: Scalars['String']['output'];
  /** The language code that the handler covers. */
  langCode?: Maybe<Scalars['String']['output']>;
  /** The human-readable name of the handler. */
  name?: Maybe<Scalars['String']['output']>;
  /** The ID of the organization that the handler is linked to. */
  organizationId: Scalars['String']['output'];
  /** The type of handler that this is. */
  type: Scalars['String']['output'];
};

export type GetIntentsListIntent = {
  _id: Scalars['ID']['output'];
  /** The ID of the app that the intent is linked to. */
  appId: Scalars['String']['output'];
  /** The location that the intent was last saved in Stentor's Handler Graph UI. */
  graphCoords?: Maybe<GraphCoords>;
  /** The unique identifier of the intent itself. */
  intentId: Scalars['String']['output'];
  /** The language code that the intent covers. */
  langCode?: Maybe<Scalars['String']['output']>;
  /** The human-readable name of the intent. */
  name: Scalars['String']['output'];
  /** The ID of the organization that the intent is linked to. */
  organizationId: Scalars['String']['output'];
  /** The slots of the intent. */
  slots?: Maybe<Array<Maybe<Slot>>>;
  /**
   * An array of utterance patterns.
   *
   * For more information on syntax see https://github.com/alexa-js/alexa-utterances
   */
  utterancePatterns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GoogleAnalyticsDataStream = {
  type: Scalars['String']['output'];
};

export type GoogleAnalyticsDataStreamInput = {
  type: Scalars['String']['input'];
};

export type GoogleBusinessMessagesAppChannel = BaseAppChannel & {
  /** URL for the directory listing. */
  directoryListing?: Maybe<Scalars['String']['output']>;
  /** URI where the channel can be accessed. */
  endPoint?: Maybe<Scalars['String']['output']>;
  /** The ID of the channel. */
  id: Scalars['String']['output'];
  /** The display name for the channel. */
  name?: Maybe<Scalars['String']['output']>;
  /** The lifecycle status of the app. */
  status?: Maybe<AppChannelStatus>;
  /** The type of channel */
  type: Scalars['String']['output'];
  /** Retrieves any events that are related to this specific app */
  usageEvents?: Maybe<TotalUsageEvents>;
  /**
   * ID of the NLU to use within app.nlu[].
   *
   * If it exists, the channel will use the provided NLU at runtime
   * to convert the raw text to an Intent
   *
   * If the value is "*", then it will pick the first available NLU within app.nlu[]
   */
  useNLU?: Maybe<Scalars['String']['output']>;
};


export type GoogleBusinessMessagesAppChannelUsageEventsArgs = {
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type GoogleBusinessMessagesAppChannelInput = {
  /** URL for the directory listing. */
  directoryListing?: InputMaybe<Scalars['String']['input']>;
  /** URI where the channel can be accessed. */
  endPoint?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the channel. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The display name for the channel. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The type of channel */
  type: Scalars['String']['input'];
  /**
   * ID of the NLU to use within app.nlu[].
   *
   * If it exists, the channel will use the provided NLU at runtime
   * to convert the raw text to an Intent
   *
   * If the value is "*", then it will pick the first available NLU within app.nlu[]
   */
  useNLU?: InputMaybe<Scalars['String']['input']>;
};

export type GooglePlatformAdditionalInformationQuestions = {
  /** Does the app contain content related to alcohol or tobacco? */
  alcoholAndTobaccoRelatedContent: Scalars['Boolean']['output'];
};

export type GooglePlatformAdditionalInformationQuestionsInput = {
  /** Does the app contain content related to alcohol or tobacco? */
  alcoholAndTobaccoRelatedContent: Scalars['Boolean']['input'];
};

export type GooglePlatformData = {
  /** Imformation about the app that Google needs to know before publishing. */
  additionalInformationQuestions?: Maybe<GooglePlatformAdditionalInformationQuestions>;
  /**
   * The platform that the data is associated with
   * All Platform data has this. It determines the structure of the remaining data.
   */
  platform: Scalars['String']['output'];
};

export type GooglePlatformDataInput = {
  /** Imformation about the app that Google needs to know before publishing. */
  additionalInformationQuestions?: InputMaybe<GooglePlatformAdditionalInformationQuestionsInput>;
  /**
   * The platform that the data is associated with
   * All Platform data has this. It determines the structure of the remaining data.
   */
  platform: Scalars['String']['input'];
};

export type GraphConnectionKeyDescription = {
  /** If true, the key will match for every string. */
  catchAll?: Maybe<Scalars['Boolean']['output']>;
  /**
   * If it exists, it is an array of possible strings
   * that will be omitted in the case of a catch all key.
   *
   * Note, this must be used in conjunction with catchAll = true.
   */
  excludedIntentIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** If it exists, it is an array of possible strings that will match for the key. */
  includedIntentIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The key cannot be described with the current methods of description. */
  indescribable?: Maybe<Scalars['Boolean']['output']>;
  /** If intentId exists, it is the only string that will match the key. */
  intentId?: Maybe<Scalars['String']['output']>;
};

/** A connection is a link between one node to another. */
export type GraphConnections = {
  /** A detailed description of what this connection entails. */
  description?: Maybe<GraphConnectionKeyDescription>;
  /** The name of the node that this connection is coming from. */
  from: Scalars['String']['output'];
  /** The nid of the node that this connection is coming from. */
  from_node: Scalars['Float']['output'];
  /** Unique identifier of the connection. */
  id: Scalars['String']['output'];
  /** The total number of times the handler was used to transfer to the other node. */
  selectedCount: Scalars['Int']['output'];
  /** The name of the node that this connection is going to. */
  to: Scalars['String']['output'];
  /** The nid of the node that this connection is going to. */
  to_node: Scalars['Float']['output'];
};

/** Used by Stentor's UI component to graph the intents/handlers of an app. */
export type GraphCoords = {
  x?: Maybe<Scalars['Float']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
};

/** Used by Stentor's UI component to graph the intents/handlers of an app. */
export type GraphCoordsInput = {
  x?: InputMaybe<Scalars['Float']['input']>;
  y?: InputMaybe<Scalars['Float']['input']>;
};

export type GraphNode = {
  /** The titles that appear on the left (in) and right (out) side of a node. */
  fields: GraphNodeFields;
  /** The handler that is associated with this node. */
  handler: Handler;
  /** The unique identifier of the intent/handler that the node represents. */
  id: Scalars['String']['output'];
  /** The unique identifier of the node. */
  nid: Scalars['Float']['output'];
  /** The total number of time this handler was called. */
  totalCount: Scalars['Int']['output'];
  /** A descriptor of what kind of node this is supposed to represent. */
  type: Scalars['String']['output'];
  /** Position on the x axis of a graph.  The top-left of the node. */
  x: Scalars['Float']['output'];
  /** Position on the y axis of a graph.  The top-left of the node. */
  y: Scalars['Float']['output'];
};

export type GraphNodeField = {
  /** The field names of the nodes. */
  name: Scalars['String']['output'];
};

export type GraphNodeFields = {
  /** Titles for the 'in' parameter of the node. */
  in: Array<Maybe<GraphNodeField>>;
  /** Titles for the 'out' parameter of the node. */
  out: Array<Maybe<GraphNodeField>>;
};

/**
 * A Stentor representation of an utterance resolver.
 * These are translated to their platform specific counterparts when publishing.
 */
export type Handler = {
  /** The ID of the app that the Handler is linked to. */
  appId: Scalars['ID']['output'];
  /**
   * Base content map for the handler.
   *
   * All handlers have contextual help and cancel content
   */
  content?: Maybe<Array<Maybe<HandlerContent>>>;
  /**
   * Contexts the must be active to have this intent be weighted more heavily or selected.
   *
   * For Amazon Lex, the contexts are required to be selected.
   *
   * https://docs.aws.amazon.com/lex/latest/dg/API_PutIntent.html#lex-PutIntent-request-inputContexts
   *
   * For Dialogflow ES, these are more heavily weighted towards matching.
   *
   * https://cloud.google.com/dialogflow/es/docs/contexts-input-output#input_contexts}
   * https://cloud.google.com/dialogflow/es/docs/reference/rest/v2/projects.agent.intents#Intent}
   */
  contexts?: Maybe<Array<Maybe<IntentContext>>>;
  /**
   * The date in which the Handler was created.
   *
   * Format: ISO 8601 date format.
   */
  createdAt?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  /**
   * The locale that all the attributes in this intent are used for before
   * they are overridden.
   */
  defaultLocale?: Maybe<Scalars['String']['output']>;
  /** The unique ID of the intent in Dialogflow. */
  dialogflowId?: Maybe<Scalars['ID']['output']>;
  /** Experiment comparison with statistical significance. */
  experimentComparison?: Maybe<ExperimentComparison>;
  /** Experiment metrics for this handler's active experiment. */
  experimentMetrics?: Maybe<ExperimentMetrics>;
  /** The active form A/B testing experiment, if any */
  formExperiment?: Maybe<FormExperiment>;
  forward?: Maybe<Array<Maybe<HandlerForward>>>;
  /** The location that the intent was last saved in Stentor's Handler Graph UI. */
  graphCoords?: Maybe<GraphCoords>;
  /** The unique identifier of the Handler itself. */
  intentId: Scalars['ID']['output'];
  /** The language code that the intent covers. */
  langCode?: Maybe<Scalars['String']['output']>;
  /** The human-readable name of the intent. */
  name: Scalars['String']['output'];
  /** The ID of the organization that the Handler is linked to. */
  organizationId: Scalars['ID']['output'];
  /** The permissions that the intent requires in order to work. */
  permissions?: Maybe<Array<Maybe<HandlerPermissions>>>;
  redirect?: Maybe<Array<Maybe<HandlerRedirect>>>;
  /** The slots defined within the utterance patterns and their Entity types. */
  slots?: Maybe<Array<Maybe<Slot>>>;
  /**
   * Number of suggestions in the suggestions index for this specific handler/intent.
   * Only counts INTENT-type suggestions that have this intentId.
   */
  suggestionsCount: Scalars['Int']['output'];
  /** The type of Handler that this is. */
  type: Scalars['String']['output'];
  /**
   * The date at which the Handler was last updated.
   *
   * Format: ISO 8601 date format.
   */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /**
   * An array of utterance patterns.
   *
   * For more information on syntax see https://github.com/alexa-js/alexa-utterances
   */
  utterancePatterns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** A query for any errors that may be in the handler. */
  validation: HandlerValidation;
};


/**
 * A Stentor representation of an utterance resolver.
 * These are translated to their platform specific counterparts when publishing.
 */
export type HandlerExperimentComparisonArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A Stentor representation of an utterance resolver.
 * These are translated to their platform specific counterparts when publishing.
 */
export type HandlerExperimentMetricsArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type HandlerContent = {
  handlerResponse: Array<Maybe<HandlerResponse>>;
  key: Scalars['String']['output'];
};

export type HandlerErrorSystemNotification = BaseSystemNotification & {
  /** A time when the notification was received */
  created: Scalars['DateTime']['output'];
  /** A unique identifier for the notification */
  id: Scalars['ID']['output'];
  /** The custom level that the notification should be at. */
  level: SystemNotificationLevel;
  /** A details description of the notification */
  message: Scalars['String']['output'];
  /**
   * Meta data that is associated with the system notification.
   *
   * The meta data returned is dependent on the type of notification.
   */
  meta?: Maybe<HandlerErrorSystemNotificationMeta>;
  /** A title or name of the notification */
  name: Scalars['String']['output'];
};

export type HandlerErrorSystemNotificationMeta = {
  /** The ID of the app that owns the handler */
  appId: Scalars['ID']['output'];
  /** The ID of the handler that contains the error. */
  intentId: Scalars['ID']['output'];
};

export type HandlerForward = {
  key: Scalars['String']['output'];
  paths: Array<Maybe<BaseHandlerPath>>;
};

export type HandlerForwardInput = {
  key: Scalars['String']['input'];
  paths: Array<InputMaybe<Scalars['JSON']['input']>>;
};

export type HandlerMutation = {
  /**
   * Adds an handler to the given app.
   *
   * The created handler is returned.
   */
  add: AddHandlerReturn;
  update: UpdateHandlerMutationType;
};


export type HandlerMutationAddArgs = {
  handler: AddHandlerInput;
};


export type HandlerMutationUpdateArgs = {
  handlerId: Scalars['ID']['input'];
};

export type HandlerPath = BaseHandlerPath & {
  actions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Conditions to be met. */
  conditions?: Maybe<Scalars['PathConditions']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  /**
   * Optional platform filter for the path.
   *
   * If set, the path will only apply to the specified platform.
   */
  platform?: Maybe<Scalars['String']['output']>;
};

export type HandlerPathInput = {
  actions?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** Conditions to be met. */
  conditions?: InputMaybe<Scalars['PathConditions']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  /**
   * Optional platform filter for the path.
   *
   * If set, the path will only apply to the specified platform.
   */
  platform?: InputMaybe<Scalars['String']['input']>;
};

export enum HandlerPermissions {
  DeviceCoarseLocation = 'DEVICE_COARSE_LOCATION',
  DevicePreciseLocation = 'DEVICE_PRECISE_LOCATION',
  Email = 'EMAIL',
  List = 'LIST',
  Name = 'NAME',
  PhoneNumber = 'PHONE_NUMBER'
}

export type HandlerRedirect = {
  key: Scalars['String']['output'];
  paths: Array<Maybe<BaseHandlerPath>>;
};

export type HandlerRedirectInput = {
  key: Scalars['String']['input'];
  paths: Array<InputMaybe<Scalars['JSON']['input']>>;
};

export type HandlerResponse = {
  /** Description of the channel that will be */
  channel?: Maybe<HandlerResponseChannel>;
  /** Conditions to be met. */
  conditions?: Maybe<Scalars['HandlerResponseConditions']['output']>;
  /**
   * Optional active contexts which help influence the NLU.
   * https://cloud.google.com/dialogflow/es/docs/contexts-input-output
   * https://docs.aws.amazon.com/lex/latest/dg/context-mgmt-active-context.html
   */
  context?: Maybe<HandlerResponseContext>;
  data?: Maybe<Scalars['JSON']['output']>;
  displays?: Maybe<Array<Maybe<BaseDisplay>>>;
  /**
   * Name of the response
   *
   * Used to help differentiate multiple responses.
   */
  name?: Maybe<Scalars['String']['output']>;
  /** What the assistant will say first as part of the response. */
  outputSpeech?: Maybe<ResponseOutput>;
  /**
   * If provided, the output speech was most likely a question and requires a response from the user.
   * The reprompt is given if the user doesn't say anything or the assistant can't recognize the response.
   */
  reprompt?: Maybe<ResponseOutput>;
  segments?: Maybe<Array<Maybe<HandlerResponseSegmentItem>>>;
  /** System responses to perform account links, control media, surface changes, and permission requests. */
  system?: Maybe<HandlerResponseSystem>;
  /**
   * Used for tracking the response in third party analytics.
   *
   * @deprecated(reason: Tags can be arrays now. Use tags instead)
   */
  tag?: Maybe<Scalars['String']['output']>;
  /** Used for tracking the response in third party analytics. */
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type HandlerResponseActiveContext = {
  /** Name of the context */
  name: Scalars['String']['output'];
  /** Parameters passed around with the context */
  parameters?: Maybe<Scalars['StringMap']['output']>;
  timeToLive?: Maybe<HandlerResponseActiveContextTtl>;
};

export type HandlerResponseActiveContextTtl = {
  /** Not supported in Dialogflow */
  timeToLiveInSeconds?: Maybe<Scalars['Int']['output']>;
  turnsToLive?: Maybe<Scalars['Int']['output']>;
};

export type HandlerResponseChannel = {
  /**
   * String to match with the name of the channel that will match.  It can either be the exact name of the
   * channel or a regex string to match multiple.
   */
  name?: Maybe<Scalars['String']['output']>;
};

export type HandlerResponseContext = {
  /** Matches to outputContexts on Dialogflow & activeContexts */
  active?: Maybe<Array<Maybe<HandlerResponseActiveContext>>>;
};

export type HandlerResponseDuration = {
  amount?: Maybe<Scalars['Float']['output']>;
  format?: Maybe<HandlerResponseDurationFormat>;
};

export enum HandlerResponseDurationFormat {
  D = 'd',
  Day = 'day',
  Days = 'days',
  H = 'h',
  Hour = 'hour',
  Hours = 'hours',
  M = 'm',
  Millisecond = 'millisecond',
  Milliseconds = 'milliseconds',
  Minute = 'minute',
  Minutes = 'minutes',
  Month = 'month',
  Months = 'months',
  Ms = 'ms',
  Quarter = 'quarter',
  Quarters = 'quarters',
  S = 's',
  Second = 'second',
  Seconds = 'seconds',
  W = 'w',
  Week = 'week',
  Weeks = 'weeks',
  Y = 'y',
  Year = 'year',
  Years = 'years'
}

export type HandlerResponseDurationInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  format?: InputMaybe<HandlerResponseDurationFormat>;
};

export type HandlerResponseSchedule = {
  duration?: Maybe<HandlerResponseDuration>;
  start?: Maybe<ScheduleStart>;
};

export type HandlerResponseScheduleInput = {
  duration?: InputMaybe<HandlerResponseDurationInput>;
  start?: InputMaybe<ScheduleStartInput>;
};

export type HandlerResponseSegment = {
  segment: ResponseOutput;
};

export type HandlerResponseSegmentInput = {
  activeWithin?: InputMaybe<HandlerResponseDurationInput>;
  firstTime?: InputMaybe<Scalars['Boolean']['input']>;
  haveNotSeenWithin?: InputMaybe<HandlerResponseDurationInput>;
  requestMatch?: InputMaybe<Scalars['JSON']['input']>;
  schedule?: InputMaybe<HandlerResponseScheduleInput>;
  segment: ResponseOutputInput;
  slotMatch?: InputMaybe<Scalars['JSON']['input']>;
  storageMatch?: InputMaybe<Scalars['JSON']['input']>;
};

export type HandlerResponseSegmentItem = {
  key: Scalars['String']['output'];
  segments: Array<Maybe<HandlerResponseSegment>>;
};

export enum HandlerResponseSystem {
  AccountLink = 'ACCOUNT_LINK',
  MediaEnqueue = 'MEDIA_ENQUEUE',
  MediaStop = 'MEDIA_STOP',
  PermissionEmail = 'PERMISSION_EMAIL',
  PermissionList = 'PERMISSION_LIST',
  PermissionLocationCoarse = 'PERMISSION_LOCATION_COARSE',
  PermissionLocationPrecise = 'PERMISSION_LOCATION_PRECISE',
  PermissionNotification = 'PERMISSION_NOTIFICATION',
  PermissionPhoneNumber = 'PERMISSION_PHONE_NUMBER',
  SurfaceChange = 'SURFACE_CHANGE'
}

export type HandlerValidation = {
  /** Any errors that may be associated with the object. */
  errors: Array<Maybe<HandlerValidationError>>;
  /** Whether or not the full handler is valid. */
  isValid: Scalars['Boolean']['output'];
};

export type HandlerValidationError = {
  /** A description of the error message */
  errorMessage: Scalars['String']['output'];
  /** The property that is in error. */
  propertyName?: Maybe<Scalars['String']['output']>;
};

export type HandlersQuery = {
  /** Unique ID for the query type */
  _id: Scalars['ID']['output'];
  /** A subset of handlers that are found in the query. */
  handlers?: Maybe<Array<Maybe<GetHandlersListHandler>>>;
  /** The total number of handlers that were found. */
  total: Scalars['Int']['output'];
};

export type HaveNotSeenWithinHandlerResponseSegment = HandlerResponseSegment & {
  haveNotSeenWithin: HandlerResponseDuration;
  segment: ResponseOutput;
};

export type HistoricalHandlerPath = BaseHandlerPath & {
  actions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Conditions to be met. */
  conditions?: Maybe<Scalars['PathConditions']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  /**
   * The number of handlers to go back into the history of.
   *
   * This is typically just one and can be no more than 10.
   */
  historicalIndex: Scalars['Int']['output'];
  /**
   * Optional platform filter for the path.
   *
   * If set, the path will only apply to the specified platform.
   */
  platform?: Maybe<Scalars['String']['output']>;
};

/** Contains urls for IP rights contracts related to the app. */
export type IpRights = {
  /** URL to the IP rights that are on Alexa. */
  alexa?: Maybe<Scalars['String']['output']>;
};

/** Contains urls for IP rights contracts related to the app. */
export type IpRightsInput = {
  /** URL to the IP rights that are on Alexa. */
  alexa?: InputMaybe<Scalars['String']['input']>;
};

export type IPrights = {
  /** The URL which can be used to download the Alexa IP rights document. */
  alexa?: Maybe<Scalars['String']['output']>;
};

export type IPrightsInput = {
  /** The URL which can be used to download the Alexa IP rights document. */
  alexa?: InputMaybe<Scalars['String']['input']>;
};

export type InputHandlerContent = {
  handlerResponse: Array<InputMaybe<Scalars['JSON']['input']>>;
  key: Scalars['String']['input'];
};

export type InputSlot = {
  /**
   * Human readable description of what kind of information
   * the slot is expecting.  The text should be very brief.  For example:
   *
   * "zip"
   * "zip code"
   * "city"
   * "state"
   * "street"
   */
  inputText?: InputMaybe<Scalars['String']['input']>;
  /**
   * Is the slot a list of values.
   * Supported natively by Dialogflow and shims for Alexa.
   * Can be a boolean or number.  When a number is used, it provides guidance to the Alexa shim on the max amount of expected
   * items in the list.  Minimum value is 2.  Value defaults to 6 when set to true.
   * * NOTE: Only one isList slot is supported per utterance pattern.
   */
  isList?: InputMaybe<Scalars['IntOrBoolean']['input']>;
  /**
   * The name of the slot, corresponds to how it is displayed in the
   * sample utterance.
   *
   * For example: "Play {Podcast}" where Podcast is the name.
   */
  name: Scalars['String']['input'];
  nlu?: InputMaybe<Scalars['JSON']['input']>;
  /**
   * The slot will be obfuscated either fully or partially.
   *
   *     Full obfuscation, the slot is replaced with the slot name.  "my name is ${first_name}"
   *     Partial obfuscation will only display a subset of characters, enough to protect the full value but enough for someone that is debugging to recognize the value.
   *
   * For some NLU, such as Amazon Lex, any setting on this value will be interpretted as obfuscated, for more information see [Amazon Lex Slot Obfuscation](https://docs.aws.amazon.com/lex/latest/dg/how-obfuscate.html)
   */
  obfuscateValue?: InputMaybe<SlotObfuscation>;
  /**
   * The type of entity for the slot.
   *
   * This corresponds to an Entity, specifically the entityId key.
   *
   * For legacy applications, SlotType is used.
   */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type Integration = {
  /**
   * For webhook integrations, returns the configured field mapping if one is set.
   * Returns null for non-webhook integrations or if no field mapping is configured.
   */
  fieldMapping?: Maybe<WebhookFieldMappingType>;
  /** Determines if the app integration is currently working. */
  isActive: Scalars['Boolean']['output'];
  /** Determines if the user is allowed to integrate with a given service based on their subscription level. */
  isAllowed: Scalars['Boolean']['output'];
  /** Determines if the app is currently linked to the integration. */
  isLinked: Scalars['Boolean']['output'];
  /**
   * For webhook integrations, returns the configured service name if one is set.
   * This service name is used to match against the app's referenceId.service
   * to determine if referenceId should be included in the webhook payload.
   * Returns null for non-webhook integrations or if no service is configured.
   */
  service?: Maybe<Scalars['String']['output']>;
  /** The integration parameters */
  token?: Maybe<Scalars['JSON']['output']>;
};

export enum IntegrationType {
  Boberdoo = 'boberdoo',
  ContractorAppointments = 'contractor_appointments',
  FacebookCapi = 'facebook_capi',
  Fieldpulse = 'fieldpulse',
  Fieldroutes = 'fieldroutes',
  Housecallpro = 'housecallpro',
  Jobber = 'jobber',
  Lacrm = 'lacrm',
  Servicefusion = 'servicefusion',
  Serviceminder = 'serviceminder',
  Servicetitan = 'servicetitan',
  Surefire = 'surefire',
  TestCognito = 'test_cognito',
  Webhook = 'webhook',
  Zapier = 'zapier'
}

export type IntegrationsMutation = {
  /**
   * Adds a Boberdoo lead distribution integration for the given app.
   * Sends leads to boberdoo's lead portal API in their expected format.
   */
  addBoberdooIntegration: Integration;
  addContractorAppointmentsIntegration: Integration;
  /**
   * Adds the Facebook (Meta) Conversions API integration for the given app.
   * Sends server-side Lead events to Meta for both form-widget and chat-widget
   * leads. The pixel ID is non-secret and is stored as the access token record's
   * accountId; the access token is the encrypted secret.
   */
  addFacebookCapiIntegration: Integration;
  addFieldPulseIntegration: Integration;
  addFieldRoutesIntegration: Integration;
  addHouseCallProIntegration: Integration;
  addServiceMinderIntegration: Integration;
  /**
   * Adds a new Service Titan Integration to the app.
   *
   * These attributes are to be generated on Service Titan's website and added here.
   */
  addServiceTitanIntegration: Integration;
  /** Adds a Surefire integration for the given app. */
  addSurefireIntegration: Integration;
  /**
   * Adds a generic webhook integration for the given app.
   * This can be used with Zapier Catch Hooks, Make.com, or any other webhook endpoint.
   */
  addWebhookIntegration: Integration;
  /**
   * Disconnects the integration from the app.
   *
   * The user will not be able to retrieve leads through this integration anymore after this.
   */
  disconnect: Integration;
};


export type IntegrationsMutationAddBoberdooIntegrationArgs = {
  apiAction?: InputMaybe<Scalars['String']['input']>;
  apiKey: Scalars['String']['input'];
  defaultLandingPage?: InputMaybe<Scalars['String']['input']>;
  defaultProject?: InputMaybe<Scalars['String']['input']>;
  endpoint: Scalars['URLString']['input'];
  leadType: Scalars['String']['input'];
  mode?: InputMaybe<Scalars['String']['input']>;
  omitAppointmentInComments?: InputMaybe<Scalars['Boolean']['input']>;
  source: Scalars['String']['input'];
  uniqueIdentifier?: InputMaybe<Scalars['String']['input']>;
};


export type IntegrationsMutationAddContractorAppointmentsIntegrationArgs = {
  campaignId: Scalars['String']['input'];
  campaignKey: Scalars['String']['input'];
  defaultTrade?: InputMaybe<Scalars['String']['input']>;
};


export type IntegrationsMutationAddFacebookCapiIntegrationArgs = {
  accessToken: Scalars['String']['input'];
  pixelId: Scalars['String']['input'];
  testEventCode?: InputMaybe<Scalars['String']['input']>;
};


export type IntegrationsMutationAddFieldPulseIntegrationArgs = {
  defaultJobTypeId: Scalars['String']['input'];
  lookAheadDays: Scalars['Int']['input'];
  maxJobsPerDay: Scalars['Int']['input'];
  token: Scalars['String']['input'];
};


export type IntegrationsMutationAddFieldRoutesIntegrationArgs = {
  authenticationKey: Scalars['String']['input'];
  authenticationToken: Scalars['String']['input'];
  defaultAppointmentType?: InputMaybe<Scalars['String']['input']>;
  sourceID?: InputMaybe<Scalars['String']['input']>;
  subdomain: Scalars['String']['input'];
};


export type IntegrationsMutationAddHouseCallProIntegrationArgs = {
  token: Scalars['String']['input'];
};


export type IntegrationsMutationAddServiceMinderIntegrationArgs = {
  apiKey: Scalars['String']['input'];
  defaultJobTypeId?: InputMaybe<Scalars['String']['input']>;
};


export type IntegrationsMutationAddServiceTitanIntegrationArgs = {
  apiEndpoint: Scalars['String']['input'];
  authEndpoint: Scalars['String']['input'];
  bookingProviderId: Scalars['ID']['input'];
  clientId: Scalars['ID']['input'];
  clientSecret: Scalars['String']['input'];
  defaultBusinessUnitId: Scalars['Int']['input'];
  defaultCampaignId: Scalars['Int']['input'];
  defaultJobTypeId: Scalars['Int']['input'];
  serviceTitanAppId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
};


export type IntegrationsMutationAddSurefireIntegrationArgs = {
  dataMap: Scalars['String']['input'];
  endpoint: Scalars['URLString']['input'];
  token: Scalars['String']['input'];
};


export type IntegrationsMutationAddWebhookIntegrationArgs = {
  endpoint: Scalars['URLString']['input'];
  fieldMapping?: InputMaybe<WebhookFieldMappingInput>;
  httpHeaders?: InputMaybe<Scalars['JSON']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
};


export type IntegrationsMutationDisconnectArgs = {
  type: IntegrationType;
};

export type IntelligentSearchAppChannel = BaseAppChannel & {
  autocompleteSuggestionsUrl?: Maybe<Scalars['URLString']['output']>;
  connection?: Maybe<IntelligentSearchConnectionConfig>;
  /** URL for the directory listing. */
  directoryListing?: Maybe<Scalars['String']['output']>;
  /** URI where the channel can be accessed. */
  endPoint?: Maybe<Scalars['String']['output']>;
  /** The ID of the channel. */
  id: Scalars['String']['output'];
  /** The key that goes in the url when retrieving the chat widget to apply custom themes. */
  key?: Maybe<Scalars['String']['output']>;
  /** The display name for the channel. */
  name?: Maybe<Scalars['String']['output']>;
  /** The lifecycle status of the app. */
  status?: Maybe<AppChannelStatus>;
  theme?: Maybe<IntelligentSearchWidgetTheme>;
  /** The type of channel */
  type: Scalars['String']['output'];
  /** Retrieves any events that are related to this specific app */
  usageEvents?: Maybe<TotalUsageEvents>;
  /**
   * ID of the NLU to use within app.nlu[].
   *
   * If it exists, the channel will use the provided NLU at runtime
   * to convert the raw text to an Intent
   *
   * If the value is "*", then it will pick the first available NLU within app.nlu[]
   */
  useNLU?: Maybe<Scalars['String']['output']>;
};


export type IntelligentSearchAppChannelUsageEventsArgs = {
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type IntelligentSearchAppChannelInput = {
  autocompleteSuggestionsUrl?: InputMaybe<Scalars['URLString']['input']>;
  connection?: InputMaybe<IntelligentSearchConnectionConfigInput>;
  /** URL for the directory listing. */
  directoryListing?: InputMaybe<Scalars['String']['input']>;
  /** URI where the channel can be accessed. */
  endPoint?: InputMaybe<Scalars['String']['input']>;
  /**
   * The ID of the channel.
   *
   * When calling a "CreateChannel" function, then ID will be
   * used to determine if the channel shoudl be inserted or updated.
   *
   * If the ID is provided and already exists, the channel will be
   * updated.  Otherwise the channel will be inserted and an ID will be
   * generated.
   */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The key that goes in the url when retrieving the chat widget to apply custom themes. */
  key?: InputMaybe<Scalars['String']['input']>;
  /** The display name for the channel. */
  name?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<IntelligentSearchWidgetThemeInput>;
  /** The type of channel */
  type: Scalars['String']['input'];
  /**
   * ID of the NLU to use within app.nlu[].
   *
   * If it exists, the channel will use the provided NLU at runtime
   * to convert the raw text to an Intent
   *
   * If the value is "*", then it will pick the first available NLU within app.nlu[]
   */
  useNLU?: InputMaybe<Scalars['String']['input']>;
};

export type IntelligentSearchConnectionConfig = {
  /** Optional key used for basic authentication. */
  accountKey?: Maybe<Scalars['String']['output']>;
  /** Backend URL */
  serverUrl?: Maybe<Scalars['URLString']['output']>;
};

export type IntelligentSearchConnectionConfigInput = {
  /** Optional key used for basic authentication. */
  accountKey?: InputMaybe<Scalars['String']['input']>;
  /** Backend URL */
  serverUrl?: InputMaybe<Scalars['URLString']['input']>;
};

export enum IntelligentSearchWidgetBorderStyle {
  Dashed = 'dashed',
  None = 'none',
  Solid = 'solid'
}

export type IntelligentSearchWidgetBorderTheme = {
  color?: Maybe<Scalars['String']['output']>;
  radius?: Maybe<Scalars['String']['output']>;
  style?: Maybe<IntelligentSearchWidgetBorderStyle>;
  width?: Maybe<Scalars['String']['output']>;
};

export type IntelligentSearchWidgetBorderThemeInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  radius?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<IntelligentSearchWidgetBorderStyle>;
  width?: InputMaybe<Scalars['String']['input']>;
};

export type IntelligentSearchWidgetBubbleTheme = {
  background?: Maybe<Scalars['String']['output']>;
};

export type IntelligentSearchWidgetBubbleThemeInput = {
  background?: InputMaybe<Scalars['String']['input']>;
};

export type IntelligentSearchWidgetCardTheme = {
  background?: Maybe<Scalars['String']['output']>;
  border?: Maybe<IntelligentWidgetBorderTheme>;
  description?: Maybe<IntelligentSearchWidgetTextBlockTheme>;
  link?: Maybe<IntelligentSearchWidgetLinkBlockTheme>;
  margin?: Maybe<IntelligentSearchWidgetMarginTheme>;
  padding?: Maybe<IntelligentSearchWidgetPaddingTheme>;
  title?: Maybe<IntelligentSearchWidgetTextBlockTheme>;
};

export type IntelligentSearchWidgetCardThemeInput = {
  background?: InputMaybe<Scalars['String']['input']>;
  border?: InputMaybe<IntelligentWidgetBorderThemeInput>;
  description?: InputMaybe<IntelligentSearchWidgetTextBlockThemeInput>;
  link?: InputMaybe<IntelligentSearchWidgetLinkBlockThemeInput>;
  margin?: InputMaybe<IntelligentSearchWidgetMarginThemeInput>;
  padding?: InputMaybe<IntelligentSearchWidgetPaddingThemeInput>;
  title?: InputMaybe<IntelligentSearchWidgetTextBlockThemeInput>;
};

export type IntelligentSearchWidgetCarouselTheme = {
  card?: Maybe<IntelligentSearchWidgetCardTheme>;
};

export type IntelligentSearchWidgetCarouselThemeInput = {
  card?: InputMaybe<IntelligentSearchWidgetCardThemeInput>;
};

export type IntelligentSearchWidgetLinkBlockTheme = {
  margin?: Maybe<IntelligentSearchWidgetMarginTheme>;
  padding?: Maybe<IntelligentSearchWidgetPaddingTheme>;
  text?: Maybe<IntelligentSearchWidgetLinkTheme>;
};

export type IntelligentSearchWidgetLinkBlockThemeInput = {
  margin?: InputMaybe<IntelligentSearchWidgetMarginThemeInput>;
  padding?: InputMaybe<IntelligentSearchWidgetPaddingThemeInput>;
  text?: InputMaybe<IntelligentSearchWidgetLinkThemeInput>;
};

export type IntelligentSearchWidgetLinkTheme = {
  default?: Maybe<IntelligentSearchWidgetTextTheme>;
};

export type IntelligentSearchWidgetLinkThemeInput = {
  default?: InputMaybe<IntelligentSearchWidgetTextThemeInput>;
};

export type IntelligentSearchWidgetListTheme = {
  card?: Maybe<IntelligentSearchWidgetCardTheme>;
};

export type IntelligentSearchWidgetListThemeInput = {
  card?: InputMaybe<IntelligentSearchWidgetCardThemeInput>;
};

export type IntelligentSearchWidgetMarginTheme = {
  bottom?: Maybe<Scalars['String']['output']>;
  left?: Maybe<Scalars['String']['output']>;
  right?: Maybe<Scalars['String']['output']>;
  top?: Maybe<Scalars['String']['output']>;
};

export type IntelligentSearchWidgetMarginThemeInput = {
  bottom?: InputMaybe<Scalars['String']['input']>;
  left?: InputMaybe<Scalars['String']['input']>;
  right?: InputMaybe<Scalars['String']['input']>;
  top?: InputMaybe<Scalars['String']['input']>;
};

export type IntelligentSearchWidgetMessageTheme = {
  bubble?: Maybe<IntelligentSearchWidgetBubbleTheme>;
  text?: Maybe<IntelligentSearchWidgetTextTheme>;
};

export type IntelligentSearchWidgetMessageThemeInput = {
  bubble?: InputMaybe<IntelligentSearchWidgetBubbleThemeInput>;
  text?: InputMaybe<IntelligentSearchWidgetTextThemeInput>;
};

export type IntelligentSearchWidgetMessagesTheme = {
  others?: Maybe<IntelligentSearchWidgetMessageTheme>;
};

export type IntelligentSearchWidgetMessagesThemeInput = {
  others?: InputMaybe<IntelligentSearchWidgetMessageThemeInput>;
};

export type IntelligentSearchWidgetPaddingTheme = {
  bottom?: Maybe<Scalars['String']['output']>;
  left?: Maybe<Scalars['String']['output']>;
  right?: Maybe<Scalars['String']['output']>;
  top?: Maybe<Scalars['String']['output']>;
};

export type IntelligentSearchWidgetPaddingThemeInput = {
  bottom?: InputMaybe<Scalars['String']['input']>;
  left?: InputMaybe<Scalars['String']['input']>;
  right?: InputMaybe<Scalars['String']['input']>;
  top?: InputMaybe<Scalars['String']['input']>;
};

export type IntelligentSearchWidgetTextBlockTheme = {
  margin?: Maybe<IntelligentSearchWidgetMarginTheme>;
  padding?: Maybe<IntelligentSearchWidgetPaddingTheme>;
  text?: Maybe<IntelligentSearchWidgetTextTheme>;
};

export type IntelligentSearchWidgetTextBlockThemeInput = {
  margin?: InputMaybe<IntelligentSearchWidgetMarginThemeInput>;
  padding?: InputMaybe<IntelligentSearchWidgetPaddingThemeInput>;
  text?: InputMaybe<IntelligentSearchWidgetTextThemeInput>;
};

export type IntelligentSearchWidgetTextTheme = {
  color?: Maybe<Scalars['String']['output']>;
  fontFamily?: Maybe<Scalars['String']['output']>;
  fontSize?: Maybe<Scalars['String']['output']>;
  fontStyle?: Maybe<Scalars['String']['output']>;
  fontWeight?: Maybe<Scalars['String']['output']>;
  lineHeight?: Maybe<Scalars['IntOrString']['output']>;
};

export type IntelligentSearchWidgetTextThemeInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  fontSize?: InputMaybe<Scalars['String']['input']>;
  fontStyle?: InputMaybe<Scalars['String']['input']>;
  fontWeight?: InputMaybe<Scalars['String']['input']>;
  lineHeight?: InputMaybe<Scalars['String']['input']>;
};

export type IntelligentSearchWidgetTheme = {
  accentColor?: Maybe<Scalars['String']['output']>;
  border?: Maybe<IntelligentWidgetBorderTheme>;
  card?: Maybe<IntelligentSearchWidgetCardTheme>;
  carousel?: Maybe<IntelligentSearchWidgetCarouselTheme>;
  list?: Maybe<IntelligentSearchWidgetListTheme>;
  messages?: Maybe<IntelligentSearchWidgetMessagesTheme>;
};

export type IntelligentSearchWidgetThemeInput = {
  accentColor?: InputMaybe<Scalars['String']['input']>;
  border?: InputMaybe<IntelligentSearchWidgetBorderThemeInput>;
  card?: InputMaybe<IntelligentSearchWidgetCardThemeInput>;
  carousel?: InputMaybe<IntelligentSearchWidgetCarouselThemeInput>;
  list?: InputMaybe<IntelligentSearchWidgetListThemeInput>;
  messages?: InputMaybe<IntelligentSearchWidgetMessagesThemeInput>;
};

export type IntelligentWidgetBorderTheme = {
  color?: Maybe<Scalars['String']['output']>;
  radius?: Maybe<Scalars['String']['output']>;
  style?: Maybe<IntelligentSearchWidgetBorderStyle>;
  width?: Maybe<Scalars['String']['output']>;
};

export type IntelligentWidgetBorderThemeInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  radius?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<IntelligentSearchWidgetBorderStyle>;
  width?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A Stentor representation of an utterance resolver. Intents
 * tell applications how they will respond to specific voice queries.
 * These are translated to their platform specific counterparts when publishing.
 */
export type Intent = {
  _id: Scalars['String']['output'];
  /** Retrieve the analytics aggregations of the intent. */
  analytics?: Maybe<Analytics>;
  /** The ID of the app that the intent is linked to. */
  appId: Scalars['ID']['output'];
  /**
   * Contexts the must be active to have this intent be weighted more heavily or selected.
   *
   * For Amazon Lex, the contexts are required to be selected.
   *
   * https://docs.aws.amazon.com/lex/latest/dg/API_PutIntent.html#lex-PutIntent-request-inputContexts
   *
   * For Dialogflow ES, these are more heavily weighted towards matching.
   *
   * https://cloud.google.com/dialogflow/es/docs/contexts-input-output#input_contexts}
   * https://cloud.google.com/dialogflow/es/docs/reference/rest/v2/projects.agent.intents#Intent}
   */
  contexts?: Maybe<Array<Maybe<IntentContext>>>;
  /**
   * The date in which the intent was created.
   *
   * Format: ISO 8601 date format.
   */
  createdAt?: Maybe<Scalars['String']['output']>;
  /**
   * The locale that all the attributes in this intent are used for before
   * they are overridden.
   */
  defaultLocale?: Maybe<Scalars['String']['output']>;
  /** The unique ID of the intent in Dialogflow. */
  dialogflowId?: Maybe<Scalars['ID']['output']>;
  /** The location that the intent was last saved in Stentor's Handler Graph UI. */
  graphCoords?: Maybe<GraphCoords>;
  /** The unique identifier of the intent itself. */
  intentId: Scalars['ID']['output'];
  /** The language code that the intent covers. */
  langCode?: Maybe<Scalars['String']['output']>;
  /** The human-readable name of the intent. */
  name: Scalars['String']['output'];
  nlu?: Maybe<Scalars['JSON']['output']>;
  /** The ID of the organization that the intent is linked to. */
  organizationId: Scalars['ID']['output'];
  /** The permissions that the intent requires in order to work. */
  permissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Slot type definition. */
  slotTypes?: Maybe<Scalars['JSON']['output']>;
  /** The slots defined within the utterance patterns and their Entity types. */
  slots?: Maybe<Array<Maybe<Slot>>>;
  /**
   * Number of suggestions in the suggestions index for this specific intent.
   * Only counts INTENT-type suggestions that have this intentId.
   */
  suggestionsCount: Scalars['Int']['output'];
  /**
   * The date at which the Intent was last updated.
   *
   * Format: ISO 8601 date format.
   */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /**
   * An array of utterance patterns.
   *
   * For more information on syntax see https://github.com/alexa-js/alexa-utterances
   */
  utterancePatterns?: Maybe<Array<Scalars['String']['output']>>;
  /** Retrieves suggestions of new possible utterances similar to the ones the intent already has. */
  utteranceSuggestions: UtteranceSuggestions;
  /** A query for any errors that may be in the Intent. */
  validation: IntentValidation;
};


/**
 * A Stentor representation of an utterance resolver. Intents
 * tell applications how they will respond to specific voice queries.
 * These are translated to their platform specific counterparts when publishing.
 */
export type IntentAnalyticsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type IntentContext = {
  name?: Maybe<Scalars['String']['output']>;
};

export type IntentContextInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type IntentErrorSystemNotification = BaseSystemNotification & {
  /** A time when the notification was received */
  created: Scalars['DateTime']['output'];
  /** A unique identifier for the notification */
  id: Scalars['ID']['output'];
  /** The custom level that the notification should be at. */
  level: SystemNotificationLevel;
  /** A details description of the notification */
  message: Scalars['String']['output'];
  /**
   * Meta data that is associated with the system notification.
   *
   * The meta data returned is dependent on the type of notification.
   */
  meta?: Maybe<IntentErrorSystemNotificationMeta>;
  /** A title or name of the notification */
  name: Scalars['String']['output'];
};

export type IntentErrorSystemNotificationMeta = {
  /** The ID of the app that owns the handler */
  appId: Scalars['ID']['output'];
  /** The ID of the handler that contains the error. */
  intentId: Scalars['ID']['output'];
};

export type IntentMutation = {
  add: AddIntentReturn;
  update: UpdateIntentMutationType;
};


export type IntentMutationAddArgs = {
  intent: AddIntentInput;
};


export type IntentMutationUpdateArgs = {
  intentId: Scalars['ID']['input'];
};

export type IntentToHandlerPropsInput = {
  /** The type that the handler should be. */
  type: Scalars['String']['input'];
};

export type IntentValidation = {
  /** Any errors that may be associated with the object. */
  errors: Array<Maybe<IntentValidationError>>;
  /** Whether or not the full intent is valid. */
  isValid: Scalars['Boolean']['output'];
};

export type IntentValidationError = {
  /** A description of the error message */
  errorMessage: Scalars['String']['output'];
  /** The property that is in error. */
  propertyName?: Maybe<Scalars['String']['output']>;
};

export type IntentsGraph = {
  /** The links between the handlers. */
  connections?: Maybe<Array<Maybe<GraphConnections>>>;
  /** Points on the graph that represent a handler. */
  nodes?: Maybe<Array<Maybe<GraphNode>>>;
};

export type IntentsQuery = {
  /** Unique ID for the query type */
  _id: Scalars['ID']['output'];
  /** A subset of intents that are found in the query. */
  intents?: Maybe<Array<Maybe<GetIntentsListIntent>>>;
  /** The total number of intents that were found. */
  total: Scalars['Int']['output'];
};

export type JsonDependableHandlerResponse = HandlerResponse & {
  /**
   * Match data for the JSON path.
   *
   * 'name' on Match is the JSON path
   */
  JSONPathMatch?: Maybe<Scalars['JSON']['output']>;
  /** Description of the channel that will be */
  channel?: Maybe<HandlerResponseChannel>;
  /** Conditions to be met. */
  conditions?: Maybe<Scalars['HandlerResponseConditions']['output']>;
  context?: Maybe<HandlerResponseContext>;
  data?: Maybe<Scalars['JSON']['output']>;
  displays?: Maybe<Array<Maybe<BaseDisplay>>>;
  /** The name of the intent that the response is linked to. */
  intent: Scalars['String']['output'];
  /**
   * Name of the response
   *
   * Used to help differentiate multiple responses.
   */
  name?: Maybe<Scalars['String']['output']>;
  /** What the assistant will say first as part of the response. */
  outputSpeech?: Maybe<ResponseOutput>;
  /**
   * If provided, the output speech was most likely a question and requires a response from the user.
   * The reprompt is given if the user doesn't say anything or the assistant can't recognize the response.
   */
  reprompt?: Maybe<ResponseOutput>;
  segments?: Maybe<Array<Maybe<HandlerResponseSegmentItem>>>;
  /** System responses to perform account links, control media, surface changes, and permission requests. */
  system?: Maybe<HandlerResponseSystem>;
  /**
   * Used for tracking the response in third party analytics.
   *
   * @deprecated(reason: Tags can be arrays now. Use tags instead.  This one will only return the top tag if it's an array.)
   */
  tag?: Maybe<Scalars['String']['output']>;
  /** Used for tracking the response in third party analytics. */
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type JsonDependentExecutableHandlerPath = BaseHandlerPath & {
  /**
   * Match data for the JSON path.
   *
   * 'name' on Match is the JSON path
   */
  JSONPathMatch?: Maybe<Scalars['JSON']['output']>;
  actions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Conditions to be met. */
  conditions?: Maybe<Scalars['PathConditions']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  /** The ID of the handler to forward or redirect the request to */
  intentId: Scalars['String']['output'];
  /**
   * Optional platform filter for the path.
   *
   * If set, the path will only apply to the specified platform.
   */
  platform?: Maybe<Scalars['String']['output']>;
  /**
   * Optional, if redirecting or forwarding to a handler that is expecting slots,
   * set these to pre-populate them on the request.
   */
  slots?: Maybe<Scalars['JSON']['output']>;
  /**
   * Type of path.
   *
   * Setting type to START changes the request so that
   * handler.start() is called.
   *
   * Not setting the type passes the request straight
   * through, requiring the new handler to handle the
   * request as is.
   */
  type?: Maybe<Scalars['String']['output']>;
};

/**
 * Path based on evaluating a JSON path to determine the value
 * that will be matched.
 *
 * For example:
 * name: $.request.slots.slot2.value will evaluate the slot with name slot2
 * name: $.context.storage.key1 will evaluate key1 on the user's storage
 */
export type JsonDependentHandlerPath = JsonDependentExecutableHandlerPath | JsonDependentHistoricalHandlerPath | JsonDependentPreviousHandlerPath;

export type JsonDependentHistoricalHandlerPath = BaseHandlerPath & {
  /**
   * Match data for the JSON path.
   *
   * 'name' on Match is the JSON path
   */
  JSONPathMatch?: Maybe<Scalars['JSON']['output']>;
  actions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Conditions to be met. */
  conditions?: Maybe<Scalars['PathConditions']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  /**
   * The number of handlers to go back into the history of.
   *
   * This is typically just one and can be no more than 10.
   */
  historicalIndex: Scalars['Int']['output'];
  /**
   * Optional platform filter for the path.
   *
   * If set, the path will only apply to the specified platform.
   */
  platform?: Maybe<Scalars['String']['output']>;
  /**
   * Optional, if redirecting or forwarding to a handler that is expecting slots,
   * set these to pre-populate them on the request.
   */
  slots?: Maybe<Scalars['JSON']['output']>;
};

export type JsonDependentPreviousHandlerPath = BaseHandlerPath & {
  /**
   * Match data for the JSON path.
   *
   * 'name' on Match is the JSON path
   */
  JSONPathMatch?: Maybe<Scalars['JSON']['output']>;
  actions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Conditions to be met. */
  conditions?: Maybe<Scalars['PathConditions']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  /**
   * Optional platform filter for the path.
   *
   * If set, the path will only apply to the specified platform.
   */
  platform?: Maybe<Scalars['String']['output']>;
  /** Set to true to request the previous handler paths. */
  previousHandler: Scalars['Boolean']['output'];
};

export type KnnMutation = {
  addQuestion: KnnSearchHit;
};


export type KnnMutationAddQuestionArgs = {
  answer: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type KnnSearchHit = {
  _score: Scalars['Float']['output'];
  answer: Scalars['String']['output'];
  answerVector: Array<Maybe<Scalars['Float']['output']>>;
  question: Scalars['String']['output'];
  questionVector: Array<Maybe<Scalars['Float']['output']>>;
};

export type KnnSearchInput = {
  sentence: Scalars['String']['output'];
  vectors: Array<Maybe<Scalars['Float']['output']>>;
};

export type KnnSearchOutput = {
  hits: Array<Maybe<KnnSearchHit>>;
  total: Scalars['Int']['output'];
};

export type KnnSearchQuery = {
  input: KnnSearchInput;
  output: KnnSearchOutput;
};

export type KnnSuggSearchHit = {
  _score: Scalars['Float']['output'];
  suggVector: Array<Maybe<Scalars['Float']['output']>>;
  suggestion: Scalars['String']['output'];
};

export type KnnSuggSearchOutput = {
  aggs: Scalars['JSON']['output'];
  hits: Array<Maybe<KnnSuggSearchHit>>;
  total: Scalars['Int']['output'];
};

export type KnnSuggSearchQuery = {
  input: KnnSearchInput;
  output: KnnSuggSearchOutput;
};

export type KendraInstance = {
  faqs: KendraInstanceFaqList;
};


export type KendraInstanceFaqsArgs = {
  nextToken?: InputMaybe<Scalars['String']['input']>;
};

export type KendraInstanceFaq = {
  /** The date and time that the FAQ was created */
  createdAt: Scalars['DateTime']['output'];
  /** The file type used to create the FAQ */
  fileFormat: Scalars['String']['output'];
  /** The ID of the kendra FAQ */
  id: Scalars['String']['output'];
  /** The code for the language the FAQ is written in. */
  languageCode: Scalars['String']['output'];
  /** The name of the kendra FAQ */
  name: Scalars['String']['output'];
  /** Current status of the FAQ */
  status: KendraInstanceFaqStatus;
  /** The date and time that the FAQ was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

export type KendraInstanceFaqList = {
  /** The faqs current synced to the Kendra instance */
  faqs: Array<Maybe<KendraInstanceFaq>>;
  /** The token to pass in to retrieve another page of FAQs. */
  nextToken?: Maybe<Scalars['String']['output']>;
};

export enum KendraInstanceFaqStatus {
  Active = 'ACTIVE',
  Creating = 'CREATING',
  Deleting = 'DELETING',
  Failed = 'FAILED',
  Updating = 'UPDATING'
}

export enum KendraInstanceFileFormat {
  Csv = 'CSV',
  CsvWithHeader = 'CSV_WITH_HEADER',
  Json = 'JSON'
}

export type LabMutation = {
  knn: KnnMutation;
  suggestions: SuggestionsMutation;
};

export type LastActiveActiveWithinHandlerResponse = HandlerResponse & {
  activeWithin?: Maybe<HandlerResponseDuration>;
  /** Description of the channel that will be */
  channel?: Maybe<HandlerResponseChannel>;
  /** Conditions to be met. */
  conditions?: Maybe<Scalars['HandlerResponseConditions']['output']>;
  context?: Maybe<HandlerResponseContext>;
  data?: Maybe<Scalars['JSON']['output']>;
  displays?: Maybe<Array<Maybe<BaseDisplay>>>;
  /** The name of the intent that the response is linked to. */
  intent: Scalars['String']['output'];
  /**
   * Name of the response
   *
   * Used to help differentiate multiple responses.
   */
  name?: Maybe<Scalars['String']['output']>;
  /** What the assistant will say first as part of the response. */
  outputSpeech?: Maybe<ResponseOutput>;
  /**
   * If provided, the output speech was most likely a question and requires a response from the user.
   * The reprompt is given if the user doesn't say anything or the assistant can't recognize the response.
   */
  reprompt?: Maybe<ResponseOutput>;
  segments?: Maybe<Array<Maybe<HandlerResponseSegmentItem>>>;
  /** System responses to perform account links, control media, surface changes, and permission requests. */
  system?: Maybe<HandlerResponseSystem>;
  /**
   * Used for tracking the response in third party analytics.
   *
   * @deprecated(reason: Tags can be arrays now. Use tags instead.  This one will only return the top tag if it's an array.)
   */
  tag?: Maybe<Scalars['String']['output']>;
  /** Used for tracking the response in third party analytics. */
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type LastActiveFirstTimeHandlerResponse = HandlerResponse & {
  /** Description of the channel that will be */
  channel?: Maybe<HandlerResponseChannel>;
  /** Conditions to be met. */
  conditions?: Maybe<Scalars['HandlerResponseConditions']['output']>;
  context?: Maybe<HandlerResponseContext>;
  data?: Maybe<Scalars['JSON']['output']>;
  displays?: Maybe<Array<Maybe<BaseDisplay>>>;
  firstTime: Scalars['Boolean']['output'];
  /** The name of the intent that the response is linked to. */
  intent: Scalars['String']['output'];
  /**
   * Name of the response
   *
   * Used to help differentiate multiple responses.
   */
  name?: Maybe<Scalars['String']['output']>;
  /** What the assistant will say first as part of the response. */
  outputSpeech?: Maybe<ResponseOutput>;
  /**
   * If provided, the output speech was most likely a question and requires a response from the user.
   * The reprompt is given if the user doesn't say anything or the assistant can't recognize the response.
   */
  reprompt?: Maybe<ResponseOutput>;
  segments?: Maybe<Array<Maybe<HandlerResponseSegmentItem>>>;
  /** System responses to perform account links, control media, surface changes, and permission requests. */
  system?: Maybe<HandlerResponseSystem>;
  /**
   * Used for tracking the response in third party analytics.
   *
   * @deprecated(reason: Tags can be arrays now. Use tags instead.  This one will only return the top tag if it's an array.)
   */
  tag?: Maybe<Scalars['String']['output']>;
  /** Used for tracking the response in third party analytics. */
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type LastActiveHandlerResponse = LastActiveActiveWithinHandlerResponse | LastActiveFirstTimeHandlerResponse | LastActiveHaveNotSeenWithinHandlerResponse;

export type LastActiveHandlerResponseSegment = ActiveWithinHandlerResponseSegment | FirstTimeHandlerResponseSegment | HaveNotSeenWithinHandlerResponseSegment;

export type LastActiveHaveNotSeenWithinHandlerResponse = HandlerResponse & {
  /** Description of the channel that will be */
  channel?: Maybe<HandlerResponseChannel>;
  /** Conditions to be met. */
  conditions?: Maybe<Scalars['HandlerResponseConditions']['output']>;
  context?: Maybe<HandlerResponseContext>;
  data?: Maybe<Scalars['JSON']['output']>;
  displays?: Maybe<Array<Maybe<BaseDisplay>>>;
  haveNotSeenWithin?: Maybe<HandlerResponseDuration>;
  /** The name of the intent that the response is linked to. */
  intent: Scalars['String']['output'];
  /**
   * Name of the response
   *
   * Used to help differentiate multiple responses.
   */
  name?: Maybe<Scalars['String']['output']>;
  /** What the assistant will say first as part of the response. */
  outputSpeech?: Maybe<ResponseOutput>;
  /**
   * If provided, the output speech was most likely a question and requires a response from the user.
   * The reprompt is given if the user doesn't say anything or the assistant can't recognize the response.
   */
  reprompt?: Maybe<ResponseOutput>;
  segments?: Maybe<Array<Maybe<HandlerResponseSegmentItem>>>;
  /** System responses to perform account links, control media, surface changes, and permission requests. */
  system?: Maybe<HandlerResponseSystem>;
  /**
   * Used for tracking the response in third party analytics.
   *
   * @deprecated(reason: Tags can be arrays now. Use tags instead.  This one will only return the top tag if it's an array.)
   */
  tag?: Maybe<Scalars['String']['output']>;
  /** Used for tracking the response in third party analytics. */
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type Lead = {
  /** Who/what handled the interaction: ai, human, self_serve, unknown. */
  agentType?: Maybe<Scalars['String']['output']>;
  /** An analysis of how the LLM came to its conclusion. */
  analysis?: Maybe<Scalars['String']['output']>;
  /** The ID of the app that this lead belongs to. */
  appId?: Maybe<Scalars['String']['output']>;
  /** The name of the app/business location that this lead belongs to. */
  appName?: Maybe<Scalars['String']['output']>;
  /**
   * Source used for insideBusinessHours calculation.
   * 'PLACE' = GBP hours, 'DEFAULT' = M-F 9am-5pm
   */
  businessHoursSource?: Maybe<Scalars['String']['output']>;
  /**
   * The local day of week when the lead was captured in the business's timezone.
   * 0=Sunday, 1=Monday, ..., 6=Saturday.
   */
  businessLocalDayOfWeek?: Maybe<Scalars['Int']['output']>;
  /**
   * The stable, system-assigned Campaign attribution key, resolved server-side from
   * the AppLink the booking came through. Undefined when not booked through a Campaign link.
   */
  campaignId?: Maybe<Scalars['String']['output']>;
  /** The Campaign's canonical attribution label — the actual grouping key for reporting. */
  canonicalSource?: Maybe<Scalars['String']['output']>;
  /** Vendor/tech that captured the raw interaction (e.g. xapp-ai, avoca, servicetitan). */
  capturePlatform?: Maybe<Scalars['String']['output']>;
  /** Product/surface used to capture it (e.g. form-widget, servicetitan-scheduler, mcp). */
  captureSurface?: Maybe<Scalars['String']['output']>;
  /**
   * The transport mechanism through which the lead was captured (e.g., chat, form, email, sms, voice, mcp).
   * Distinct from source: a WordPress form captured via email has source='form-widget', channel='email'.
   */
  channel?: Maybe<Scalars['String']['output']>;
  /** The company related to the lead. */
  company?: Maybe<Scalars['String']['output']>;
  /** A concise summary of the captured lead. */
  conciseSummary?: Maybe<Scalars['String']['output']>;
  /** How the customer engaged: phone, form, chat, email, sms, in_person. */
  contactMethod?: Maybe<Scalars['String']['output']>;
  /** The type of contact (SPAM, QUESTION, COMPLAINT, COMPLIMENT, SERVICE_REQUEST, EMPLOYMENT_INQUIRY, QUOTE_REQUEST). */
  contactType?: Maybe<Scalars['String']['output']>;
  /** Whether this lead has been converted to a paying customer. */
  converted?: Maybe<Scalars['Boolean']['output']>;
  /** When the lead was marked as converted (ISO 8601 timestamp). */
  convertedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Email of the user who marked this lead as converted. */
  convertedBy?: Maybe<Scalars['String']['output']>;
  /** The date that the lead was sent. */
  date: Scalars['DateTime']['output'];
  /**
   * The email thread associated with this lead (only for email-channel leads).
   * Fetched from agent-server using the lead's sessionId as threadId.
   */
  emailThread?: Maybe<EmailThread>;
  /** The environment that the lead was captured in. */
  environment?: Maybe<Scalars['String']['output']>;
  /** The type of form help requested. */
  formHelpType?: Maybe<Scalars['String']['output']>;
  /** The message from the form. */
  formMessage?: Maybe<Scalars['String']['output']>;
  /** Whether the lead is considered high value. */
  highValueLead?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Unique identifier for the lead from OpenSearch.
   * Only available when querying via leads or lead query.
   */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   * Whether the lead was captured during the business's actual operating hours.
   * Uses GBP hours when available, otherwise falls back to default hours.
   */
  insideBusinessHours?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether the lead was captured during default business hours (Monday-Friday 9am-5pm)
   * in the business's local timezone.
   */
  insideBusinessHoursDefault?: Maybe<Scalars['Boolean']['output']>;
  /** The integrations that the lead was successfully sent to. */
  integrationSent?: Maybe<Array<LeadSentToIntegration>>;
  /** The type of job requested (e.g., hvac, plumbing, electrical). */
  jobType?: Maybe<Scalars['String']['output']>;
  /** The lead data that was sent to the app. */
  lead?: Maybe<LeadData>;
  /**
   * The customer's preferred day of week for service.
   * 0=Sunday, 1=Monday, ..., 6=Saturday.
   * Calculated from the preferredDay field if it's a valid ISO date.
   */
  preferredDayOfWeek?: Maybe<Scalars['Int']['output']>;
  /** Capture / landing URL. */
  referral?: Maybe<Scalars['String']['output']>;
  /** The referring source of the lead (e.g., reserve_with_google, facebook, website). */
  referringSource?: Maybe<Scalars['String']['output']>;
  /** The type of service requested (INSTALLATION, REPAIR, MAINTENANCE, OTHER). */
  serviceType?: Maybe<Scalars['String']['output']>;
  /** The session that the lead is related to. */
  sessionId?: Maybe<Scalars['ID']['output']>;
  /** The origin platform of the lead (e.g., chat-widget, form-widget, email, jobber) */
  source?: Maybe<Scalars['String']['output']>;
  /** Vendor / system of record that delivered the lead (e.g. servicetitan, jobber, xapp-ai). */
  sourceSystem?: Maybe<Scalars['String']['output']>;
  /** A summary of the captured lead. */
  summary?: Maybe<Scalars['String']['output']>;
  /** The urgency of the message (LOW, MEDIUM, HIGH, URGENT, NOT_SPECIFIED). */
  urgency?: Maybe<Scalars['String']['output']>;
  /** The user that the lead is related to. */
  userId?: Maybe<Scalars['ID']['output']>;
  /** Marketing campaign (utm_campaign). Kept as a raw reference field only — not the attribution grouping key. */
  utmCampaign?: Maybe<Scalars['String']['output']>;
  /** Marketing medium (utm_medium): social, cpc, organic, referral, email, offline. */
  utmMedium?: Maybe<Scalars['String']['output']>;
  /** Marketing traffic source (utm_source). */
  utmSource?: Maybe<Scalars['String']['output']>;
};

export type LeadAuditTrail = {
  /** Full details from S3 (lazy-loaded on demand) */
  details?: Maybe<Array<AuditEntryDetail>>;
  /** Compact summaries from DynamoDB (fast, always available) */
  summary: Array<AuditEntrySummary>;
};

/**
 * A geographic cluster of leads aggregated by geohash.
 * Used for zoomed-out map views where individual leads would overlap.
 */
export type LeadCluster = {
  /** Bounding box of the cluster (for zoom-to-fit) */
  bounds?: Maybe<GeoBounds>;
  /**
   * Breakdown of leads by contact type.
   * Only populated when leadClusters is queried with includeBreakdowns: true.
   */
  contactTypeBreakdown?: Maybe<Array<ClusterBreakdown>>;
  /** Total number of leads in this cluster */
  count: Scalars['Int']['output'];
  /** The geohash key for this cluster */
  geohash: Scalars['String']['output'];
  /** Number of high-value leads in this cluster */
  highValueCount: Scalars['Int']['output'];
  /**
   * Breakdown of leads by job type.
   * Only populated when leadClusters is queried with includeBreakdowns: true.
   */
  jobTypeBreakdown?: Maybe<Array<ClusterBreakdown>>;
  /**
   * Sample of individual leads within this cluster for hover tooltips.
   * Only populated when leadClusters is queried with includeBreakdowns: true.
   * Server fetches at most 5 leads per cluster regardless of limit.
   */
  leads?: Maybe<Array<MapLead>>;
  /** Center point of the cluster (approximate centroid of the geohash cell) */
  location: GeoPoint;
  /**
   * Breakdown of leads by geolocation precision level.
   * Only populated when leadClusters is queried with includeBreakdowns: true.
   */
  precisionBreakdown?: Maybe<PrecisionBreakdown>;
  /**
   * Breakdown of leads by referring source.
   * Only populated when leadClusters is queried with includeBreakdowns: true.
   */
  referringSourceBreakdown?: Maybe<Array<ClusterBreakdown>>;
  /**
   * Breakdown of leads by service type.
   * Only populated when leadClusters is queried with includeBreakdowns: true.
   */
  serviceTypeBreakdown?: Maybe<Array<ClusterBreakdown>>;
  /**
   * Breakdown of leads by source channel.
   * Only populated when leadClusters is queried with includeBreakdowns: true.
   */
  sourceBreakdown?: Maybe<Array<ClusterBreakdown>>;
  /**
   * Breakdown of leads by urgency level.
   * Only populated when leadClusters is queried with includeBreakdowns: true.
   */
  urgencyBreakdown?: Maybe<Array<ClusterBreakdown>>;
};


/**
 * A geographic cluster of leads aggregated by geohash.
 * Used for zoomed-out map views where individual leads would overlap.
 */
export type LeadClusterLeadsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Lead data containing fields and transcript. */
export type LeadData = {
  /** Fields that are important to the lead. */
  fields: Array<LeadField>;
  transcript?: Maybe<Array<LeadTranscript>>;
};

/** Configuration for routing a lead to specific email address(es). */
export type LeadEmailRoute = {
  /** Whether to continue evaluating other routes after this one matches (default: false) */
  continueOnMatch?: Maybe<Scalars['Boolean']['output']>;
  /** Email address(es) to send matching leads to */
  emails: Array<Scalars['EmailAddress']['output']>;
  /** Filter conditions - all must match if provided */
  filters?: Maybe<LeadEmailRouteFilters>;
  /** Unique identifier for the route */
  id: Scalars['ID']['output'];
  /** Human-readable name for the route */
  name: Scalars['String']['output'];
  /** Priority for evaluation order (lower number = higher priority, default: 999) */
  priority?: Maybe<Scalars['Int']['output']>;
};

/**
 * Filter conditions for routing leads to specific email addresses.
 * All specified filters must match for the route to be selected.
 */
export type LeadEmailRouteFilters = {
  /** Contact type filter (e.g., QUOTE_REQUEST, CONTACT_REQUEST, COMPLAINT, COMPLIMENT) */
  contactType?: Maybe<Array<Scalars['String']['output']>>;
  /** High-value lead filter */
  highValueLead?: Maybe<Scalars['Boolean']['output']>;
  /** Job type filter */
  jobType?: Maybe<Array<Scalars['String']['output']>>;
  /** Service type filter */
  serviceType?: Maybe<Array<Scalars['String']['output']>>;
  /** Urgency filter (e.g., HIGH, URGENT, NORMAL, LOW) */
  urgency?: Maybe<Array<Scalars['String']['output']>>;
};

/** Filter conditions for routing leads to specific email addresses. */
export type LeadEmailRouteFiltersInput = {
  /** Contact type filter */
  contactType?: InputMaybe<Array<Scalars['String']['input']>>;
  /** High-value lead filter */
  highValueLead?: InputMaybe<Scalars['Boolean']['input']>;
  /** Job type filter */
  jobType?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Service type filter */
  serviceType?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Urgency filter */
  urgency?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Configuration for routing a lead to specific email address(es). */
export type LeadEmailRouteInput = {
  /** Whether to continue evaluating other routes after this one matches (default: false) */
  continueOnMatch?: InputMaybe<Scalars['Boolean']['input']>;
  /** Email address(es) to send matching leads to */
  emails: Array<Scalars['EmailAddress']['input']>;
  /** Filter conditions */
  filters?: InputMaybe<LeadEmailRouteFiltersInput>;
  /** Unique identifier for the route (optional for new routes) */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Human-readable name for the route */
  name: Scalars['String']['input'];
  /** Priority for evaluation order (default: 999) */
  priority?: InputMaybe<Scalars['Int']['input']>;
};

export type LeadField = {
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/**
 * A lead location marker for the map view.
 * Represents either a single lead or a cluster of leads at a geographic location.
 */
export type LeadLocationMarker = {
  /** Number of leads at this location (1 for single leads, >1 for clusters) */
  count: Scalars['Int']['output'];
  /** Geohash key for this location (useful for clustering) */
  geohash?: Maybe<Scalars['String']['output']>;
  /** Number of high-value leads in this cluster */
  highValueCount?: Maybe<Scalars['Int']['output']>;
  /** Representative lead ID (for single leads only, null for clusters) */
  leadId?: Maybe<Scalars['ID']['output']>;
  /** The geographic coordinates of the lead or cluster center */
  location: GeoPoint;
};

export type LeadSentToIntegration = {
  /**
   * Audit trail of HTTP calls made during this integration send.
   * Summary is always available; details are lazy-loaded from S3.
   */
  auditTrail?: Maybe<LeadAuditTrail>;
  /** The date that the integration was sent. */
  date: Scalars['DateTime']['output'];
  /**
   * The error message detailing what happened.
   *
   * If the last attempt was successful, this will be null.
   */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the error that occurred.
   *
   * If the last attempt was successful, this will be null.
   */
  errorName?: Maybe<Scalars['String']['output']>;
  /**
   * The integration that the lead was sent to.
   *
   * @see IntegrationType
   */
  integrationId: Scalars['String']['output'];
  /** Third reference ID (the internal object id in the integration) */
  refId?: Maybe<Scalars['String']['output']>;
  /**
   * Whether the last attempt was an error.
   *
   * If the last attempt was successful, this will be false.
   */
  wasError: Scalars['Boolean']['output'];
};

export type LeadTranscript = {
  /** The time the message was created */
  createdTime: Scalars['String']['output'];
  /** Who the message is from */
  from?: Maybe<LeadTranscriptUserProfile>;
  /** A simple version of the message.  It will not include displays or SSML if the original message includes it. */
  message: Scalars['String']['output'];
  /** Who the message is two, it can be to multiple recipients. */
  to?: Maybe<Array<LeadTranscriptUserProfile>>;
};

export type LeadTranscriptUserProfile = {
  /** The email of the user. */
  email?: Maybe<Scalars['String']['output']>;
  /** Unique userId */
  id: Scalars['String']['output'];
  /** The first name, or given name, of the user. */
  name?: Maybe<Scalars['String']['output']>;
};

/** Lead count and value breakdown by job type */
export type LeadValueByJobType = {
  /** Number of converted leads for this job type */
  convertedCount: Scalars['Int']['output'];
  /** Cost per lead used (override or default) */
  costPerLead: Scalars['Float']['output'];
  /** Number of leads for this job type */
  count: Scalars['Int']['output'];
  /** Whether using custom override or default */
  isCustom: Scalars['Boolean']['output'];
  /** The job type */
  jobType: Scalars['String']['output'];
  /** Total value for this job type (count * costPerLead) */
  totalValue: Scalars['Float']['output'];
};

/** Dashboard aggregations for leads analytics */
export type LeadsDashboardData = {
  /**
   * The business hours source actually used for outsideBusinessHoursPercentage
   * and leadsByDayOfWeek, after applying the requested source and any fallback:
   * - PLACE: Hours from Google Business Profile (place/GBP hours)
   * - APP: Hours configured at the app level (businessHours field)
   * - DEFAULT: Standard Mon-Fri 9 AM - 5 PM (the fleet-wide standard / default)
   *
   * This reflects the leads(businessHoursSource: ...) argument. With AUTO it is the
   * detected source (PLACE > APP > DEFAULT); with DEFAULT it is always DEFAULT.
   */
  businessHoursSource: BusinessHoursSource;
  /**
   * Human-readable business hours summary for each day of the week.
   * Returns an array of strings like ["Monday: 9:00 AM – 5:00 PM", "Tuesday: 9:00 AM – 5:00 PM", ...].
   *
   * The hours are pulled from the same source as businessHoursSource:
   * - PLACE: Uses weekdayText from Google Business Profile opening hours
   * - APP: Formats the app's businessHours configuration
   * - DEFAULT: Returns standard Mon-Fri 9:00 AM – 5:00 PM hours
   *
   * Returns null if hours cannot be determined.
   */
  businessHoursSummary?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * The IANA timezone used to interpret lead capture times for the business-hours
   * calculations (e.g. "America/New_York"), resolved from the app's primary location.
   *
   * Leads are primarily classified using each lead's pre-computed business-local hour
   * and day; this location-derived timezone is what's applied to interpret times for
   * leads that predate per-lead local times being recorded.
   *
   * Returns null when no single timezone applies (e.g. organization-wide queries
   * spanning multiple locations) or the location's timezone cannot be determined.
   */
  businessHoursTimezone?: Maybe<Scalars['String']['output']>;
  /** High value leads percentage */
  highValueLeadsPercentage: Scalars['Float']['output'];
  /**
   * Leads aggregated by business location (app).
   * For multi-location organizations, shows which locations generated the most leads.
   * Each app represents one business location/store/branch.
   */
  leadsByApp: Array<AppLeadBucket>;
  /** Leads grouped by contact type */
  leadsByContactType: Array<CategoryBucket>;
  /**
   * Leads aggregated by day of week (Monday-Sunday).
   *
   * Business hours source is inherited from the leads() field argument.
   * You can override it here for this specific field if needed.
   */
  leadsByDayOfWeek: Array<DayOfWeekBucket>;
  /** Leads grouped by job type */
  leadsByJobType: Array<CategoryBucket>;
  /** Geographic distribution of leads */
  leadsByLocation: Array<GeoBucket>;
  /**
   * Leads aggregated by organization.
   * Useful for global dashboards showing metrics across all organizations a user has access to.
   * Returns empty array when a single organizationId filter is applied, since cross-org
   * aggregation is not meaningful in that context.
   */
  leadsByOrganization: Array<OrganizationLeadBucket>;
  /** Leads grouped by referring source (marketing attribution) */
  leadsByReferringSource: Array<CategoryBucket>;
  /** Leads grouped by service type */
  leadsByServiceType: Array<CategoryBucket>;
  /** Leads grouped by source (chat, form, phone, etc.) */
  leadsBySource: Array<CategoryBucket>;
  /** Leads grouped by urgency level */
  leadsByUrgency: Array<CategoryBucket>;
  /** Leads aggregated by time intervals (day, week, month) */
  leadsOverTime: Array<TimeBucket>;
  /**
   * Percentage of leads occurring outside business hours.
   *
   * Business hours source is inherited from the leads() field argument.
   * You can override it here for this specific field if needed.
   * Falls back to UTC time when business timezone is not available.
   */
  outsideBusinessHoursPercentage: Scalars['Float']['output'];
  /**
   * Top engagement zip codes ranked by lead volume.
   * Shows which service areas generate the most leads.
   */
  topEngagementsByZip: Array<ZipEngagementBucket>;
  /** Top terms/keywords from lead content */
  topTerms: Array<TermBucket>;
  /** Total count of leads matching filters */
  totalLeads: Scalars['Int']['output'];
};


/** Dashboard aggregations for leads analytics */
export type LeadsDashboardDataLeadsByAppArgs = {
  includeTopJobTypes?: InputMaybe<Scalars['Boolean']['input']>;
  includeTopSources?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<DashboardSortField>;
  sortOrder?: InputMaybe<SortOrder>;
};


/** Dashboard aggregations for leads analytics */
export type LeadsDashboardDataLeadsByDayOfWeekArgs = {
  businessHoursSource?: InputMaybe<BusinessHoursSource>;
};


/** Dashboard aggregations for leads analytics */
export type LeadsDashboardDataLeadsByOrganizationArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<DashboardSortField>;
  sortOrder?: InputMaybe<SortOrder>;
};


/** Dashboard aggregations for leads analytics */
export type LeadsDashboardDataLeadsOverTimeArgs = {
  interval: TimeInterval;
};


/** Dashboard aggregations for leads analytics */
export type LeadsDashboardDataOutsideBusinessHoursPercentageArgs = {
  businessHoursSource?: InputMaybe<BusinessHoursSource>;
};


/** Dashboard aggregations for leads analytics */
export type LeadsDashboardDataTopEngagementsByZipArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<DashboardSortField>;
  sortOrder?: InputMaybe<SortOrder>;
};


/** Dashboard aggregations for leads analytics */
export type LeadsDashboardDataTopTermsArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Metadata about available filter values for leads.
 * Contains unique values for each filterable field to populate UI dropdowns.
 */
export type LeadsFilterMetadata = {
  /** Unique values for the contactType field. */
  contactTypes: Array<Scalars['String']['output']>;
  /** Unique values for the jobType field. */
  jobTypes: Array<Scalars['String']['output']>;
  /** Unique values for the referringSource field (e.g., reserve_with_google, facebook, website). */
  referringSources: Array<Scalars['String']['output']>;
  /** Unique values for the serviceType field. */
  serviceTypes: Array<Scalars['String']['output']>;
  /** Unique values for the urgency field (e.g., LOW, MEDIUM, HIGH, URGENT, NOT_SPECIFIED). */
  urgencies: Array<Scalars['String']['output']>;
};

/** Response wrapper for leads list query. */
export type LeadsQuery = {
  /** The leads that were found. */
  leads: Array<Lead>;
  /** The key to retrieve more leads or null if there are none left. */
  nextKey?: Maybe<Scalars['String']['output']>;
  /** The total number of leads that are available. */
  total: Scalars['Int']['output'];
};

/** A channel that is specific for apps to run on the Dialogflow. */
export type LexConnectAppChannel = BaseAppChannel & {
  /** The name of the lex bot. */
  botName?: Maybe<Scalars['String']['output']>;
  /** The region that the bot is contained in. */
  botRegion?: Maybe<Scalars['String']['output']>;
  /** A description of the bot */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * If true, user utterances are sent to Amazon Comprehend for
   * sentiment analysis.
   */
  detectSentiment?: Maybe<Scalars['Boolean']['output']>;
  /** URL for the directory listing. */
  directoryListing?: Maybe<Scalars['String']['output']>;
  /** Set to true to enable natural language understanding improvements. */
  enableModelImprovements?: Maybe<Scalars['Boolean']['output']>;
  /** URI where the channel can be accessed. */
  endPoint?: Maybe<Scalars['String']['output']>;
  /** The ID of the channel. */
  id: Scalars['String']['output'];
  /**
   * The maximum time in seconds that Amazon Lex retains data
   * gathered in the conversation.
   *
   * Defaults to 300 seconds (5 minutes), minimum value of 60 and
   * maximum value of 86400
   */
  idleSessionTTLInSeconds?: Maybe<Scalars['Int']['output']>;
  /** Used to determine if there is a kendra instance linked to this bot. */
  isLinkedToKendra: Scalars['Boolean']['output'];
  /**
   * Items related to the kendra instance that is linked to this channel.
   * Returns null if there is no kendra instance linked to this channel.
   */
  kendraInstance?: Maybe<KendraInstance>;
  /** The ARN of the Lambda that acts as fulfillment for all the intents. */
  lexFulfillmentLambdaARN?: Maybe<Scalars['String']['output']>;
  /** The URL to the lex post text deployment. */
  lexPostTextUrl?: Maybe<Scalars['String']['output']>;
  /** The role that is used to manage Lex on alternate accounts. */
  managementRole?: Maybe<Scalars['String']['output']>;
  /** The external ID if applicable that allows external accounts to assume the role. */
  managementRoleExternalId?: Maybe<Scalars['String']['output']>;
  /** The display name for the channel. */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * Match score must be higher than the set threshold otherwise it will fallback to the unknown inputs.
   * Defaults to 0.4
   */
  nluIntentConfidenceThreshold?: Maybe<Scalars['Float']['output']>;
  /**
   * Query the text from the NLU. The channel must have valid credentials,
   * projectId, and nlu.
   */
  nluQuery: LexNluQuery;
  /** The lifecycle status of the app. */
  status?: Maybe<AppChannelStatus>;
  /** The type of channel */
  type: Scalars['String']['output'];
  /** Retrieves any events that are related to this specific app */
  usageEvents?: Maybe<TotalUsageEvents>;
  /**
   * ID of the NLU to use within app.nlu[].
   *
   * If it exists, the channel will use the provided NLU at runtime
   * to convert the raw text to an Intent
   *
   * If the value is "*", then it will pick the first available NLU within app.nlu[]
   */
  useNLU?: Maybe<Scalars['String']['output']>;
  /** The Amazon Polly voice ID that you want Polly to use. */
  voiceId?: Maybe<Scalars['String']['output']>;
};


/** A channel that is specific for apps to run on the Dialogflow. */
export type LexConnectAppChannelNluQueryArgs = {
  text: Scalars['String']['input'];
};


/** A channel that is specific for apps to run on the Dialogflow. */
export type LexConnectAppChannelUsageEventsArgs = {
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type LexConnectAppChannelInput = {
  /** The name of the lex bot. */
  botName?: InputMaybe<Scalars['String']['input']>;
  /** The region that the bot is contained in. */
  botRegion?: InputMaybe<Scalars['String']['input']>;
  /**
   * If true, user utterances are sent to Amazon Comprehend for
   * sentiment analysis.
   */
  detectSentiment?: InputMaybe<Scalars['Boolean']['input']>;
  /** URL for the directory listing. */
  directoryListing?: InputMaybe<Scalars['String']['input']>;
  /** Set to true to enable natural language understanding improvements. */
  enableModelImprovements?: InputMaybe<Scalars['Boolean']['input']>;
  /** URI where the channel can be accessed. */
  endPoint?: InputMaybe<Scalars['String']['input']>;
  /**
   * The ID of the channel.
   *
   * When calling a "CreateChannel" function, then ID will be
   * used to determine if the channel shoudl be inserted or updated.
   *
   * If the ID is provided and already exists, the channel will be
   * updated.  Otherwise the channel will be inserted and an ID will be
   * generated.
   */
  id?: InputMaybe<Scalars['String']['input']>;
  /**
   * The maximum time in seconds that Amazon Lex retains data
   * gathered in the conversation.
   *
   * Defaults to 300 seconds (5 minutes), minimum value of 60 and
   * maximum value of 86400
   */
  idleSessionTTLInSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** The ARN of the Lambda that acts as fulfillment for all the intents. */
  lexFulfillmentLambdaARN?: InputMaybe<Scalars['String']['input']>;
  /** The role that is used to manage Lex on alternate accounts. */
  managementRole?: InputMaybe<Scalars['String']['input']>;
  /** The external ID if applicable that allows external accounts to assume the role. */
  managementRoleExternalId?: InputMaybe<Scalars['String']['input']>;
  /** The display name for the channel. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Match score must be higher than the set threshold otherwise it will fallback to the unknown inputs.
   * Defaults to 0.4
   */
  nluIntentConfidenceThreshold?: InputMaybe<Scalars['Float']['input']>;
  /** The type of channel */
  type: Scalars['String']['input'];
  /**
   * ID of the NLU to use within app.nlu[].
   *
   * If it exists, the channel will use the provided NLU at runtime
   * to convert the raw text to an Intent
   *
   * If the value is "*", then it will pick the first available NLU within app.nlu[]
   */
  useNLU?: InputMaybe<Scalars['String']['input']>;
  /** The Amazon Polly voice ID that you want Polly to use. */
  voiceId?: InputMaybe<Scalars['String']['input']>;
};

export type LexNluQuery = {
  /** The intentId of the intent that is linked to this lex ID. */
  intentId: Scalars['String']['output'];
  knowledgeAnswer?: Maybe<LexNluQueryKnowledgeAnswer>;
  /** The intentId of the intent that is in the LexBot. */
  lexIntentId: Scalars['String']['output'];
  slots?: Maybe<Array<Maybe<NluRequestSlot>>>;
  type: Scalars['String']['output'];
};

export type LexNluQueryKnowledgeAnswer = {
  /** Raw answer */
  answer: Scalars['String']['output'];
  /** Raw question */
  faqQuestion: Scalars['String']['output'];
  /** Confidence 0-1 */
  matchConfidence: Scalars['Float']['output'];
  /** Which knowledge base (optional) */
  source?: Maybe<Scalars['String']['output']>;
};

/** A channel that is specific for apps to run on the Dialogflow. */
export type LexV2ConnectAppChannel = BaseAppChannel & {
  /** The ID to the lex bot */
  botId?: Maybe<Scalars['String']['output']>;
  /** The name of the lex bot. */
  botName?: Maybe<Scalars['String']['output']>;
  /** The region that the bot is contained in. */
  botRegion?: Maybe<Scalars['String']['output']>;
  /** A description of the bot */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * If true, user utterances are sent to Amazon Comprehend for
   * sentiment analysis.
   */
  detectSentiment?: Maybe<Scalars['Boolean']['output']>;
  /** URL for the directory listing. */
  directoryListing?: Maybe<Scalars['String']['output']>;
  /** Set to true to enable natural language understanding improvements. */
  enableModelImprovements?: Maybe<Scalars['Boolean']['output']>;
  /** URI where the channel can be accessed. */
  endPoint?: Maybe<Scalars['String']['output']>;
  /** The ID of the channel. */
  id: Scalars['String']['output'];
  /**
   * The maximum time in seconds that Amazon Lex retains data
   * gathered in the conversation.
   *
   * Defaults to 300 seconds (5 minutes), minimum value of 60 and
   * maximum value of 86400
   */
  idleSessionTTLInSeconds?: Maybe<Scalars['Int']['output']>;
  /** Used to determine if there is a kendra instance linked to this bot. */
  isLinkedToKendra: Scalars['Boolean']['output'];
  /** The ARN of the Lambda that acts as fulfillment for all the intents. */
  lexFulfillmentLambdaARN?: Maybe<Scalars['String']['output']>;
  /** The URL to the lex post text deployment. */
  lexPostTextUrl?: Maybe<Scalars['String']['output']>;
  /** The role that is used to manage Lex on alternate accounts. */
  managementRole?: Maybe<Scalars['String']['output']>;
  /** The external ID if applicable that allows external accounts to assume the role. */
  managementRoleExternalId?: Maybe<Scalars['String']['output']>;
  /** The display name for the channel. */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * Query the text from the NLU. The channel must have valid credentials,
   * projectId, and nlu.
   */
  nluQuery: LexV2NluQuery;
  /** The lifecycle status of the app. */
  status?: Maybe<AppChannelStatus>;
  /** The type of channel */
  type: Scalars['String']['output'];
  /** Retrieves any events that are related to this specific app */
  usageEvents?: Maybe<TotalUsageEvents>;
  /**
   * ID of the NLU to use within app.nlu[].
   *
   * If it exists, the channel will use the provided NLU at runtime
   * to convert the raw text to an Intent
   *
   * If the value is "*", then it will pick the first available NLU within app.nlu[]
   */
  useNLU?: Maybe<Scalars['String']['output']>;
  /** The Amazon Polly voice ID that you want Polly to use. */
  voiceId?: Maybe<Scalars['String']['output']>;
};


/** A channel that is specific for apps to run on the Dialogflow. */
export type LexV2ConnectAppChannelNluQueryArgs = {
  text: Scalars['String']['input'];
};


/** A channel that is specific for apps to run on the Dialogflow. */
export type LexV2ConnectAppChannelUsageEventsArgs = {
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type LexV2ConnectAppChannelInput = {
  /** The ID to the lex bot */
  botId?: InputMaybe<Scalars['String']['input']>;
  /** The name of the lex bot. */
  botName?: InputMaybe<Scalars['String']['input']>;
  /** The region that the bot is contained in. */
  botRegion?: InputMaybe<Scalars['String']['input']>;
  /**
   * If true, user utterances are sent to Amazon Comprehend for
   * sentiment analysis.
   */
  detectSentiment?: InputMaybe<Scalars['Boolean']['input']>;
  /** URL for the directory listing. */
  directoryListing?: InputMaybe<Scalars['String']['input']>;
  /** Set to true to enable natural language understanding improvements. */
  enableModelImprovements?: InputMaybe<Scalars['Boolean']['input']>;
  /** URI where the channel can be accessed. */
  endPoint?: InputMaybe<Scalars['String']['input']>;
  /**
   * The ID of the channel.
   *
   * When calling a "CreateChannel" function, then ID will be
   * used to determine if the channel shoudl be inserted or updated.
   *
   * If the ID is provided and already exists, the channel will be
   * updated.  Otherwise the channel will be inserted and an ID will be
   * generated.
   */
  id?: InputMaybe<Scalars['String']['input']>;
  /**
   * The maximum time in seconds that Amazon Lex retains data
   * gathered in the conversation.
   *
   * Defaults to 300 seconds (5 minutes), minimum value of 60 and
   * maximum value of 86400
   */
  idleSessionTTLInSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** The ARN of the Lambda that acts as fulfillment for all the intents. */
  lexFulfillmentLambdaARN?: InputMaybe<Scalars['String']['input']>;
  /** The role that is used to manage Lex on alternate accounts. */
  managementRole?: InputMaybe<Scalars['String']['input']>;
  /** The display name for the channel. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The type of channel */
  type: Scalars['String']['input'];
  /**
   * ID of the NLU to use within app.nlu[].
   *
   * If it exists, the channel will use the provided NLU at runtime
   * to convert the raw text to an Intent
   *
   * If the value is "*", then it will pick the first available NLU within app.nlu[]
   */
  useNLU?: InputMaybe<Scalars['String']['input']>;
  /** The Amazon Polly voice ID that you want Polly to use. */
  voiceId?: InputMaybe<Scalars['String']['input']>;
};

export type LexV2NluQuery = {
  /** The intentId of the intent that is linked to this lex ID. */
  intentId: Scalars['String']['output'];
  knowledgeAnswer?: Maybe<LexV2NluQueryKnowledgeAnswer>;
  /** The intentId of the intent that is in the LexBot. */
  lexIntentId: Scalars['String']['output'];
  slots?: Maybe<Array<Maybe<NluRequestSlot>>>;
  type: Scalars['String']['output'];
};

export type LexV2NluQueryKnowledgeAnswer = {
  /** Raw answer */
  answer: Scalars['String']['output'];
  /** Raw question */
  faqQuestion: Scalars['String']['output'];
  /** Confidence 0-1 */
  matchConfidence: Scalars['Float']['output'];
  /** Which knowledge base (optional) */
  source?: Maybe<Scalars['String']['output']>;
};

export type LinkOutSuggestion = {
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ListDisplay = BaseDisplay & {
  items?: Maybe<Array<Maybe<ListDisplayItem>>>;
  /** Used with itemsObject, it is then used to reference the current item in the list within the template. */
  itemsName?: Maybe<Scalars['String']['output']>;
  /**
   * Used when templating the list for automatic generation.
   *
   * When using itemsObject, the first item in the list is the template
   * and all other items in the list will be ignored.
   */
  itemsObject?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<Scalars['JSON']['output']>;
  /**
   * When itemsObject is provided, this is the amount of list items to display
   * along with the offset within the list.
   */
  range?: Maybe<ListDisplayRange>;
  title?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ListDisplayButton = {
  /** Text to be displayed, also needs to be included in the interaction model */
  title: Scalars['String']['output'];
};

export type ListDisplayImage = {
  /** Describes the image for screen readers, referred to as ContentDescription in Alexa */
  accessibilityText?: Maybe<Scalars['String']['output']>;
  /** The height of the image */
  height?: Maybe<Scalars['Int']['output']>;
  /** When present, if the image is clicked the provided website will open. */
  imageActionUrl?: Maybe<Scalars['String']['output']>;
  /** The location of the image, publicly accessible */
  url: Scalars['String']['output'];
  /** THe location of the smaller version of the image, publicly accessible */
  urlIcon?: Maybe<Scalars['URL']['output']>;
  /** The width of the image */
  width?: Maybe<Scalars['Int']['output']>;
};

export type ListDisplayImageInput = {
  /** Describes the image for screen readers, referred to as ContentDescription in Alexa */
  accessibilityText?: InputMaybe<Scalars['String']['input']>;
  /** The height of the image */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** The location of the image, publicly accessible */
  url: Scalars['String']['input'];
  /** THe location of the smaller version of the image, publicly accessible */
  urlIcon?: InputMaybe<Scalars['URL']['input']>;
  /** The width of the image */
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type ListDisplayInput = {
  items?: InputMaybe<Array<InputMaybe<ListDisplayItemInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type ListDisplayItem = {
  buttons?: Maybe<Array<Maybe<ListDisplayButton>>>;
  description?: Maybe<Scalars['String']['output']>;
  /** When true, hides the URL text and external link icon while keeping the item clickable. */
  hideUrl?: Maybe<Scalars['Boolean']['output']>;
  image?: Maybe<ListDisplayImage>;
  synonyms?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title: Scalars['String']['output'];
  token?: Maybe<Scalars['String']['output']>;
  /**
   * URL to open when the list item is selected.
   *
   * Not applicable to list type CAROUSEL or available on channels without a web browser available.
   */
  url?: Maybe<Scalars['String']['output']>;
};

export type ListDisplayItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** When true, hides the URL text and external link icon while keeping the item clickable. */
  hideUrl?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<ListDisplayImageInput>;
  synonyms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
  /**
   * URL to open when the list item is selected.
   *
   * Not applicable to list type CAROUSEL or available on channels without a web browser available.
   */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ListDisplayRange = {
  from: Scalars['Int']['output'];
  length: Scalars['Int']['output'];
};

/** The attributes that override the App attributes by locale. See the documentation in the app for description on each. */
export type LocaleApp = {
  accountLinkType?: Maybe<Scalars['String']['output']>;
  actionsOnGoogleId?: Maybe<Scalars['String']['output']>;
  alexaCategory?: Maybe<Scalars['String']['output']>;
  alexaSkillId?: Maybe<Scalars['String']['output']>;
  dataStreams?: Maybe<DataStreams>;
  description?: Maybe<Scalars['String']['output']>;
  dialogflowClientToken?: Maybe<Scalars['String']['output']>;
  dialogflowCrednetialsUrl?: Maybe<Scalars['String']['output']>;
  dialogflowDeveloperToken?: Maybe<Scalars['String']['output']>;
  endPoint?: Maybe<Endpoint>;
  examplePhrases?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  icon?: Maybe<Scalars['String']['output']>;
  internalNotes?: Maybe<Scalars['String']['output']>;
  invocationName?: Maybe<Scalars['String']['output']>;
  ipRights?: Maybe<Scalars['String']['output']>;
  keywords?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  largeBanner?: Maybe<Scalars['String']['output']>;
  largeIcon?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  mediumIcon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  platformData?: Maybe<PlatformData>;
  privacyPolicyUrl?: Maybe<Scalars['String']['output']>;
  smallIcon?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Status>;
  stripeProductId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionPaymentStatus?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  templateType?: Maybe<Scalars['String']['output']>;
  termsOfUseUrl?: Maybe<Scalars['String']['output']>;
  testingInstructions?: Maybe<Scalars['String']['output']>;
};

/** The attributes that override the App attributes by locale. See the documentation in the app for description on each. */
export type LocaleAppInput = {
  accountLinkType?: InputMaybe<Scalars['String']['input']>;
  actionsOnGoogleId?: InputMaybe<Scalars['String']['input']>;
  alexaCategory?: InputMaybe<Scalars['String']['input']>;
  alexaSkillId?: InputMaybe<Scalars['String']['input']>;
  dataStreams?: InputMaybe<DataStreamsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  dialogflowClientToken?: InputMaybe<Scalars['String']['input']>;
  dialogflowCrednetialsUrl?: InputMaybe<Scalars['String']['input']>;
  dialogflowDeveloperToken?: InputMaybe<Scalars['String']['input']>;
  endPoint?: InputMaybe<EndpointInput>;
  examplePhrases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  invocationName?: InputMaybe<Scalars['String']['input']>;
  ipRights?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  largeBanner?: InputMaybe<Scalars['String']['input']>;
  largeIcon?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<LocationInput>;
  mediumIcon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platformData?: InputMaybe<PlatformDataInput>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  smallIcon?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusInput>;
  stripeProductId?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  subscriptionPaymentStatus?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  templateType?: InputMaybe<Scalars['String']['input']>;
  termsOfUseUrl?: InputMaybe<Scalars['String']['input']>;
  testingInstructions?: InputMaybe<Scalars['String']['input']>;
};

export type LocaleResponseOutput = {
  displayText?: Maybe<Scalars['String']['output']>;
  ssm?: Maybe<Scalars['String']['output']>;
  suggestions?: Maybe<Array<Maybe<SuggestionType>>>;
  textToSpeech?: Maybe<Scalars['String']['output']>;
};

export type LocaleResponseOutputInput = {
  displayText?: InputMaybe<Scalars['String']['input']>;
  ssm?: InputMaybe<Scalars['String']['input']>;
  suggestions?: InputMaybe<Array<InputMaybe<SuggestionTypeInput>>>;
  textToSpeech?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The phsysical real-world location to associate the app with.
 *
 * This is helpful when serving local based content.
 */
export type Location = {
  geocode?: Maybe<Geocode>;
  streetAddress?: Maybe<Scalars['String']['output']>;
};

/**
 * The phsysical real-world location to associate the app with.
 *
 * This is helpful when serving local based content.
 */
export type LocationInput = {
  geocode?: InputMaybe<GeocodeInput>;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
};

/** Precision level of a lead's geolocation data. */
export enum LocationPrecision {
  /** Coordinates from geocoded street address */
  High = 'HIGH',
  /** Coordinates estimated from IP address */
  Low = 'LOW',
  /** Coordinates from ZIP/postal code or city centroid */
  Medium = 'MEDIUM',
  /** Precision not tracked or unavailable */
  Unknown = 'UNKNOWN'
}

/** Source used to determine a lead's geolocation coordinates. */
export enum LocationSource {
  /** Customer provided a street address that was geocoded */
  Address = 'ADDRESS',
  /** Coordinates derived from city centroid */
  City = 'CITY',
  /** Coordinates estimated from IP address geolocation */
  IpAddress = 'IP_ADDRESS',
  /** Source not tracked or unavailable */
  Unknown = 'UNKNOWN',
  /** Coordinates derived from ZIP/postal code centroid */
  ZipCode = 'ZIP_CODE'
}

/** Dashboard map data for visualizing business and lead locations. */
export type MapDashboardData = {
  /**
   * Business location markers (apps with their places lat/long).
   * Returns all business locations that match the filters.
   * For organization view, returns all apps in the organization.
   * For app view, returns just that single app.
   */
  businessLocations: Array<BusinessLocationMarker>;
  /**
   * Individual leads within a specific geohash cluster for drill-down views.
   * Use this when a user clicks on a cluster to see the individual leads within it.
   * Uses the geohash bounding box to filter leads, so results are spatially accurate.
   * Only returns leads that have serviceLocationGeo data.
   */
  clusterLeads: Array<MapLead>;
  /**
   * Lead location clusters aggregated by geohash.
   * Use this for zoomed-out map views to avoid overlapping markers.
   */
  leadClusters: Array<LeadCluster>;
  /**
   * Individual lead location markers.
   * Use this for zoomed-in map views where you want to show each lead.
   * Only returns leads that have serviceLocationGeo data.
   */
  leadLocations: Array<LeadLocationMarker>;
  /**
   * Individual leads with full metadata for map pins and hover tooltips.
   * Use this for the all-leads view mode where each lead is rendered as its own pin.
   * Only returns leads that have serviceLocationGeo data.
   */
  leads: Array<MapLead>;
  /** Summary statistics for the map */
  summary: MapSummary;
};


/** Dashboard map data for visualizing business and lead locations. */
export type MapDashboardDataBusinessLocationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** Dashboard map data for visualizing business and lead locations. */
export type MapDashboardDataClusterLeadsArgs = {
  geohash: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** Dashboard map data for visualizing business and lead locations. */
export type MapDashboardDataLeadClustersArgs = {
  includeBreakdowns?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  precision?: InputMaybe<Scalars['Int']['input']>;
};


/** Dashboard map data for visualizing business and lead locations. */
export type MapDashboardDataLeadLocationsArgs = {
  bounds?: InputMaybe<GeoBoundsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** Dashboard map data for visualizing business and lead locations. */
export type MapDashboardDataLeadsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** An individual lead with location and metadata, used for map pins and hover tooltips. */
export type MapLead = {
  /** The app ID this lead belongs to */
  appId?: Maybe<Scalars['ID']['output']>;
  /** The contact type (e.g. Phone, Form, Chat) */
  contactType?: Maybe<Scalars['String']['output']>;
  /** When the lead was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether this is a high-value lead */
  highValueLead?: Maybe<Scalars['Boolean']['output']>;
  /** The unique identifier of the lead */
  id: Scalars['ID']['output'];
  /** The job type (e.g. Plumbing, HVAC) */
  jobType?: Maybe<Scalars['String']['output']>;
  /** The geographic coordinates of the lead's service location */
  location: GeoPoint;
  /** Precision level of this lead's geolocation */
  locationPrecision?: Maybe<LocationPrecision>;
  /** Source used to determine this lead's location coordinates */
  locationSource?: Maybe<LocationSource>;
  /** The referring source (e.g. Google, Direct) */
  referringSource?: Maybe<Scalars['String']['output']>;
  /** The service type (e.g. Service Request, Estimate) */
  serviceType?: Maybe<Scalars['String']['output']>;
  /** The source channel for this lead (e.g. web, phone) */
  source?: Maybe<Scalars['String']['output']>;
  /** Concise AI-generated summary of the lead (if available) */
  summary?: Maybe<Scalars['String']['output']>;
  /** The urgency level of the lead */
  urgency?: Maybe<Scalars['String']['output']>;
};

/** Summary statistics for the map view. */
export type MapSummary = {
  /** Bounding box containing all data points (for initial map viewport) */
  bounds?: Maybe<GeoBounds>;
  /** Percentage of leads that have location data */
  leadsWithLocationPercentage: Scalars['Float']['output'];
  /** Total number of business locations shown */
  totalBusinessLocations: Scalars['Int']['output'];
  /** Total number of leads (with and without location) */
  totalLeads: Scalars['Int']['output'];
  /** Total number of leads with location data */
  totalLeadsWithLocation: Scalars['Int']['output'];
};

/** A Range system to */
export type MatchConfidenceRange = {
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Float']['input']>;
  lessThan?: InputMaybe<Scalars['Float']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Float']['input']>;
};

export type MeteredStat = {
  /** The current number consumed. */
  current: Scalars['Int']['output'];
  /** Whether or not the current meter has reached its limit. */
  isAllowed: Scalars['Boolean']['output'];
  /**
   * The maximum limit that is allowed.
   *
   * A negative number means there is no limit.
   */
  limit: Scalars['Int']['output'];
  /**
   * The remaining number.
   *
   * A negative number means there is  no limit hence all remaining.
   */
  remaining: Scalars['Int']['output'];
};

export type MobileCtaConfig = {
  /** Animation to perform on the button after the delay */
  animation?: Maybe<CtaAnimation>;
  /**
   * The delay, in milliseconds, to wait until the animation starts.
   * If not provided, falls back to the delay property for backwards compatibility.
   */
  animationDelay?: Maybe<Scalars['Int']['output']>;
  /** How long to keep the animation going, in milliseconds.  If an animation exists */
  animationTimeout?: Maybe<Scalars['Int']['output']>;
  /** Apply this config when */
  applyAtLessThanWidth?: Maybe<Scalars['String']['output']>;
  /** The delay, in milliseconds, to wait until the message is displayed */
  delay?: Maybe<Scalars['Int']['output']>;
  /** Whether the CTA bubble can be dismissed with an X button */
  dismissible?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Message to display in the chat bubble.
   *
   * An empty message will not display the chat bubble.
   */
  message?: Maybe<Scalars['String']['output']>;
  /** How long, in milliseconds, to display the message */
  timeout?: Maybe<Scalars['Int']['output']>;
};

export type MobileCtaConfigInput = {
  animation?: InputMaybe<CtaAnimation>;
  animationDelay?: InputMaybe<Scalars['Int']['input']>;
  animationTimeout?: InputMaybe<Scalars['Int']['input']>;
  applyAtLessThanWidth?: InputMaybe<Scalars['String']['input']>;
  delay?: InputMaybe<Scalars['Int']['input']>;
  dismissible?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
};

export type Mutation = {
  /**
   * Adds or updates an Actions On Google Channel to the specified app.
   *
   * @return The channel that was just added.
   * @deprecated
   */
  addActionsOnGoogleChannel: ActionsOnGoogleAppChannel;
  /**
   * Adds or updates an Alexa Channel to the specified app.
   *
   * @return The channel that was just added.
   * @deprecated
   */
  addAlexaChannel: AlexaAppChannel;
  /**
   * Adds alexa credentials to the Alexa Channel via creds object.
   *
   * The alexa channel must already be included for this to work. It will
   * replace the credentials that are currently in place.
   */
  addAlexaCredentials?: Maybe<App>;
  /**
   * Adds alexa credentials to the Alexa channel via login code.
   *
   * The alexa channel must already be included for this to work.  It will
   * replace the credentials that are currently in place.
   *
   *   https://developer.amazon.com/docs/login-with-amazon/obtain-customer-profile.html
   *   https://developer.amazon.com/docs/login-with-amazon/authorization-code-grant.html
   */
  addAlexaCredentialsByCode?: Maybe<App>;
  /**
   * Allows one to add a new app to Stentor.
   *
   * The appId must be unique to Stentor.  If it is not, a new one will be generated which
   * is unique based on the appId provided.
   *
   * @deprecated Use AppMutation.addApp instead
   */
  addApp?: Maybe<App>;
  addAppLocale: App;
  /**
   * Adds a custom channel to the app.
   * @deprecated
   */
  addChannel: AppChannel;
  /**
   * Adds or updates a Chat Widget channel to the specified app.
   *
   * @return The channel that was just added
   * @deprecated
   */
  addChatWidgetChannel: ChatWidgetAppChannel;
  /**
   * Adds or updates an Dialogflow Channel to the specified app.
   *
   * @return The channel that was just added.
   * @deprecated
   */
  addDialogflowChannel: DialogflowAppChannel;
  /**
   * Adds dialogflow credentials to the Dialogflow Channel via creds object.
   *
   * The dialogflow channel must already be included for this to work. It
   * will replace the credentials that are currently in place.
   */
  addDialogflowCredentials?: Maybe<App>;
  /** Adds or updates a single Dialogflow NLU. */
  addDialogflowNlus?: Maybe<DialogflowAppNlu>;
  /** Adds an entity to the database. */
  addEntity: Entity;
  /**
   * Adds or updates a Facebook Messenger channel to the specified app.
   *
   * @return The channel that was just added
   * @deprecated
   */
  addFacebookMessengerChannel: FacebookMessengerAppChannel;
  /**
   * Adds an handler to the given app.
   *
   * The created handler is returned.
   */
  addHandler: Handler;
  /**
   * Adds an intent to the given app.
   *
   * The created intent is returned.
   *
   * @deprecated
   */
  addIntent: Intent;
  /**
   * Adds or updates a Lex channel to the specified app.
   *
   * @return The channel that was just added
   * @deprecated
   */
  addLexChannel: LexConnectAppChannel;
  /** Adds an utterance test build from a specific event. */
  addUtteranceTestByEvent?: Maybe<AppTest>;
  /**
   * Adds an utterance test for the specific appId.  An utterance test can be in the following formats:
   *
   * k q e d | StationOnlyIntent | station="k,q,e,d"
   * <utterance> | <intentId> // The test "<utterance>" expects to return the intent <intentId>
   * <utterance | <intentId> | // The test "<utterance>" expects to return the intent <intentId> with no matching slots
   * <utterance> | <intentId> | <slot>=<value> // The test "<utterance>" expects to return the intent <intentId> with a slot <slot> and value <value>
   *
   * Multiple slots can be combined by separating them by comman (i.e. <slot1>=<value2>,<slot2>=<value2>,<slot3>=<value3>)
   *
   * Multiple tests can be added by combining with a newline.
   *
   * Returns all the tests that were added.
   */
  addUtteranceTestByString?: Maybe<Array<Maybe<AppTest>>>;
  admin?: Maybe<AdminMutation>;
  /** Mutations involving apps. */
  app: AppMutation;
  /**
   * Archives a Campaign by setting its status to "archived". Does not touch the
   * underlying channel or handler.
   */
  archiveCampaign: Campaign;
  /**
   * Attaches a SMAPI vendorID to an associated Organization.
   *
   * *When replacing the vendorId*
   * An error will be throw if any channel in the organization has an alexa channel with a skillId but no vendorId.
   * In order to update the vendorId of the organization, either add a vendorId to each alexa Channel with a skillid or
   * remove the skillId from those channels.
   */
  attachSmapiVendor: Organization;
  /**
   * Attaches a SMAPI vendorID to an associated channel.
   * This will override the vendor that is attached to an organization.
   *
   * Warning: The vendor of a channel can not be updated if the channel already
   * has an alexaSkillId.  To update it, remove the alexaSkillId and update the vendorId.
   */
  attachSmapiVendorToChannel?: Maybe<AlexaAppChannel>;
  blowUpTheServers?: Maybe<Scalars['String']['output']>;
  /**
   * Changes an intent to a handler.
   *
   * @deprecated Use "changeIntentToHandler" under the UpdateHandlerMutationType
   */
  changeIntentToHandler: Handler;
  /**
   * Changes an orgs subscription if the user has one available.
   * @deprecated Use the OrgsMutation instead
   */
  changeOrgSubscription?: Maybe<Scalars['String']['output']>;
  codeChallenge?: Maybe<CodeChallenge>;
  confirmSignUp: Scalars['String']['output'];
  /**
   * Copies an app from one organization to another organization, or within the same organization.
   * This includes intents and entities.
   *
   * Only non-unique attributes of the app will be copied.  Unique attributes such as invocation name and icon
   * will have to be added later.
   *
   * It returns the app that was copied
   */
  copyApp: App;
  /** Create a new alert subscription for the current user */
  createAlertSubscription: AlertSubscription;
  /** Creates an app from a lex zip file. */
  createAppFromLexFile: UploadedLexApp;
  /**
   * Creates a Campaign: a form-widget channel (with its booking AppLink), a
   * ContactCapture handler wired to that channel, and the Campaign record
   * that references both.
   */
  createCampaign: Campaign;
  /**
   * Creates or updates the interaction model for the provided app.
   *
   * Before using this, an Alexa channel in the app must have credentials uploaded and a skill ID attached.
   */
  createInteractionModel: Array<Maybe<CreateInteractionModelReturn>>;
  /**
   * Add an organization.  An organization is used to maintain
   * apps. The user who creates the organization will be the owner and
   * be able to create applications and invite users to view/edit those applications.
   *
   * @deprecated(reason: "Use the OrgsMutation instead")
   */
  createOrg?: Maybe<CreateOrgReturn>;
  /**
   * Updates an Alexa skill from the provided app.
   *
   * Before using this, an Alexa channel in the app must have credentials uploaded. The channel must ot
   * have an alexaSkillId.
   */
  createSkill: AlexaAppChannel;
  /** Create a new summary subscription for the current user */
  createSummarySubscription: SummarySubscription;
  /** Delete an alert subscription */
  deleteAlertSubscription: Scalars['Boolean']['output'];
  /** Deletes a channel from the specified app. */
  deleteChannel: Scalars['String']['output'];
  /**
   * Delete the entity.
   *
   * Returns "Success" on successful delete.
   */
  deleteEntity: Scalars['String']['output'];
  /**
   * Removes an handler.
   *
   * This will also remove all the references to the handler in other handlers (i.e. in the forward and content attributes).
   *
   * Returns the keys for the handlers which were updated during the deletion process.
   *
   * These can be retrieved by the client to keep an updated record.
   */
  deleteHandler: Array<Maybe<DeleteIntentIdKey>>;
  /**
   * Removes an intent.
   *
   * This will also remove all the references to the intent in other intents (i.e. in the forward and content attributes).
   *
   * Returns the keys for the intents which were updated during the deletion process.
   *
   * These can be retrieved by the client to keep an updated record.
   */
  deleteIntent: Array<Maybe<DeleteIntentIdKey>>;
  /** Deletes a nlu from the specified app. */
  deleteNlu: Scalars['String']['output'];
  /** Delete a summary subscription */
  deleteSummarySubscription: Scalars['Boolean']['output'];
  /** Will delete a test. */
  deleteTest: Scalars['String']['output'];
  /**
   * Will delete all tests for a specific app.
   *
   * This is an asynchronous process.  The actual deletion may take a couple minutes depending on
   * the amount of tests that needs to be deleted.
   */
  deleteTestsOfApp: Scalars['String']['output'];
  /**
   * Flags a single specified event.
   *
   * @deprecated  Use the flagEvent method in the UpdateAppMutation
   */
  flagEvent: Events;
  /**
   * Creates a signed upload URL that allows clients to upload a lex zip file.
   *
   * Once complete, you can use the returned URL for 'createAppFromLexFile' and 'updateAppFromLexFile'.
   */
  generateLexFileUploadUrl: Scalars['String']['output'];
  /**
   * Mark a lead as converted (became a paying customer).
   * Returns the updated lead or null if not found.
   */
  markLeadConverted?: Maybe<Lead>;
  onboarding: OnboardingMutation;
  /** Mutations that are related to Organizations */
  org: OrgsMutation;
  /**
   * Provisions Lex
   *
   * Before using this, a Lex channel in the app must already exist.
   */
  pushLex: Scalars['String']['output'];
  resendConfirmationCode: Scalars['String']['output'];
  /**
   * Sets whether the app can be copyable from one organization to another.
   *
   * Returns the updated app.
   */
  setAppCopyable: App;
  /** Will start executing the tests. This is an asynchronous operation. Returns "Success" if the tests have begun. */
  startTests: Scalars['String']['output'];
  /**
   * Crawls a website and retrieves the FAQs found on the website. It saves the FAQs to a database, and downloads the items to S3.
   *
   * @deprecated(reason: "All app-specific mutations are migrating to the UpdateAppMutation type. Please refer to the corresponding mutation there.")
   */
  startWebsiteCrawling: Scalars['String']['output'];
  /**
   * Submits an app for alexa certification.
   *
   * Before using this, an Alexa channel in the app must have credentials uploaded and attached to a vendor.
   *
   * This mutation also updates the status of the channel. The updated channel is returned.
   */
  submitForAlexaCert: AlexaAppChannel;
  /**
   * Trains the dialogflow agent.
   *
   * The channel requested must have a projectId associated with it.
   */
  trainDialogflowAgent: Scalars['String']['output'];
  /**
   * Unmark a lead as converted (remove conversion status).
   * Returns the updated lead or null if not found.
   */
  unmarkLeadConverted?: Maybe<Lead>;
  /** Update an existing alert subscription */
  updateAlertSubscription: AlertSubscription;
  /**
   * Update an existing app.  Only the attributes included will be updated.
   *
   * This app can include an appId and organization for a drop-in replacement. These attributes will
   * be ignored as they are to remain constant.
   *
   * @deprecated Use UpdateAppMutation.addApp instead
   */
  updateApp?: Maybe<App>;
  /**
   * Updates a Campaign record's own attributes. Does not touch the underlying
   * channel or handler.
   */
  updateCampaign: Campaign;
  /**
   * Updates the dialogflow agent for the provided app.
   *
   * Unfortunately, Dialogflow does not allow agents to be created programmatically. Dialogflow agents must be created
   * manually and attached to the channel of the app.  After this is created,
   * it can be updated using this.
   */
  updateDialogflowAgent: Scalars['String']['output'];
  /** Create or update an app's engagement/transcript analysis config. */
  updateEngagementAnalysisConfig: EngagementAnalysisConfig;
  /**
   * Updates the attributes of the entity.
   *
   * Returns the updated entity.
   */
  updateEntity: Entity;
  /**
   * Updates an handler with the given attributes,
   *
   * The updated handler is returned.
   */
  updateHandler: Handler;
  /**
   * Updates an intent with the given attributes,
   *
   * The updated intent is returned.
   *
   * @deprecated
   */
  updateIntent: Intent;
  /** Update the user's phone number for SMS notifications */
  updateNotificationPhone: UserNotificationPreferences;
  /**
   * Updates the attributes of the organization.
   * @deprecated Use the OrgsMutation instead
   */
  updateOrg?: Maybe<Organization>;
  /**
   * Updates an Alexa skill from the provided app.
   *
   * Before using this, an Alexa channel in the app must have credentials uploaded. The channel must also
   * have an alexaSkillId.
   */
  updateSkill: AlexaAppChannel;
  /** Update an existing summary subscription */
  updateSummarySubscription: SummarySubscription;
  /**
   * Will update the attributes of an Utterance test.
   *
   * Only the attributes provided will be updated.  All other attributes will
   * remain the same.
   * In order to remove attributes from the test, then assign those attributes as "undefined" or "null".
   */
  updateUtteranceTest: UtteranceTest;
  uploadAppTemplate: App;
  /**
   * Withdraws an app from alexa certification
   *
   * Before using this, an Alexa channel in the app must have credentials uploaded and attached to a vendor.
   *
   * This mutation also updates the status of the channel. The updated channel is returned.
   */
  withdrawFromAlexaCert: AlexaAppChannel;
};


export type MutationAddActionsOnGoogleChannelArgs = {
  appId: Scalars['ID']['input'];
  channel: ActionsOnGoogleAppChannelInput;
};


export type MutationAddAlexaChannelArgs = {
  appId: Scalars['ID']['input'];
  channel: AlexaAppChannelInput;
};


export type MutationAddAlexaCredentialsArgs = {
  appId: Scalars['ID']['input'];
  channelId?: InputMaybe<Scalars['ID']['input']>;
  credentials: AlexaCredentialsInput;
};


export type MutationAddAlexaCredentialsByCodeArgs = {
  appId: Scalars['ID']['input'];
  channelId?: InputMaybe<Scalars['ID']['input']>;
  code: Scalars['String']['input'];
  redirectUri?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddAppArgs = {
  app?: InputMaybe<AppInput>;
};


export type MutationAddAppLocaleArgs = {
  appId: Scalars['ID']['input'];
  locale: AddLocaleEnum;
  localeObj: LocaleAppInput;
};


export type MutationAddChannelArgs = {
  appId: Scalars['ID']['input'];
  channel: AppChannelInput;
};


export type MutationAddChatWidgetChannelArgs = {
  appId: Scalars['ID']['input'];
  channel: ChatWidgetAppChannelInput;
};


export type MutationAddDialogflowChannelArgs = {
  appId: Scalars['ID']['input'];
  channel: DialogflowAppChannelInput;
};


export type MutationAddDialogflowCredentialsArgs = {
  appId: Scalars['ID']['input'];
  channelId?: InputMaybe<Scalars['ID']['input']>;
  credentials: DialogflowCredentialsInput;
};


export type MutationAddDialogflowNlusArgs = {
  appId: Scalars['ID']['input'];
  nlu: DialogflowAppNluInput;
};


export type MutationAddEntityArgs = {
  entity: AddEntityInput;
};


export type MutationAddFacebookMessengerChannelArgs = {
  appId: Scalars['ID']['input'];
  channel: FacebookMessengerAppChannelInput;
};


export type MutationAddHandlerArgs = {
  appId: Scalars['ID']['input'];
  handler: AddHandlerInput;
};


export type MutationAddIntentArgs = {
  appId: Scalars['ID']['input'];
  intent: AddIntentInput;
};


export type MutationAddLexChannelArgs = {
  appId: Scalars['ID']['input'];
  channel: LexConnectAppChannelInput;
};


export type MutationAddUtteranceTestByEventArgs = {
  eventId: Scalars['String']['input'];
  eventIndex: Scalars['String']['input'];
  platform?: InputMaybe<TestPlatform>;
};


export type MutationAddUtteranceTestByStringArgs = {
  appId: Scalars['ID']['input'];
  platform?: InputMaybe<TestPlatform>;
  testString: Scalars['String']['input'];
};


export type MutationAppArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationArchiveCampaignArgs = {
  campaignId: Scalars['ID']['input'];
};


export type MutationAttachSmapiVendorArgs = {
  orgId: Scalars['ID']['input'];
  vendorId: Scalars['ID']['input'];
};


export type MutationAttachSmapiVendorToChannelArgs = {
  appId: Scalars['ID']['input'];
  channelId?: InputMaybe<Scalars['ID']['input']>;
  vendorId: Scalars['ID']['input'];
};


export type MutationChangeIntentToHandlerArgs = {
  appId: Scalars['ID']['input'];
  handlerProps: IntentToHandlerPropsInput;
  intentId: Scalars['ID']['input'];
};


export type MutationChangeOrgSubscriptionArgs = {
  organizationId: Scalars['ID']['input'];
  type: SubscriptionType;
};


export type MutationConfirmSignUpArgs = {
  clientId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
  origin?: InputMaybe<AuthVerifyOrigin>;
  userName: Scalars['String']['input'];
};


export type MutationCopyAppArgs = {
  appId: Scalars['ID']['input'];
  overrideApp?: InputMaybe<CopyAppOverrideAttributes>;
  toOrg?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateAlertSubscriptionArgs = {
  input: CreateAlertSubscriptionInput;
};


export type MutationCreateAppFromLexFileArgs = {
  fileUrl: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationCreateCampaignArgs = {
  campaign: CreateCampaignInput;
};


export type MutationCreateInteractionModelArgs = {
  appId: Scalars['ID']['input'];
  channelId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateOrgArgs = {
  appTemplate?: InputMaybe<AppTemplateInput>;
  org: CreateOrganizationInput;
};


export type MutationCreateSkillArgs = {
  appId: Scalars['ID']['input'];
  channelId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateSummarySubscriptionArgs = {
  input: CreateSummarySubscriptionInput;
};


export type MutationDeleteAlertSubscriptionArgs = {
  subscriptionId: Scalars['ID']['input'];
};


export type MutationDeleteChannelArgs = {
  appId: Scalars['ID']['input'];
  channelId?: InputMaybe<Scalars['ID']['input']>;
  channelType: Scalars['String']['input'];
};


export type MutationDeleteEntityArgs = {
  appId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
};


export type MutationDeleteHandlerArgs = {
  appId: Scalars['ID']['input'];
  handlerId: Scalars['ID']['input'];
};


export type MutationDeleteIntentArgs = {
  appId: Scalars['ID']['input'];
  intentId: Scalars['ID']['input'];
};


export type MutationDeleteNluArgs = {
  appId: Scalars['ID']['input'];
  nluId?: InputMaybe<Scalars['ID']['input']>;
  nluType: Scalars['String']['input'];
};


export type MutationDeleteSummarySubscriptionArgs = {
  subscriptionId: Scalars['ID']['input'];
};


export type MutationDeleteTestArgs = {
  createdOn: Scalars['String']['input'];
  testId: Scalars['ID']['input'];
};


export type MutationDeleteTestsOfAppArgs = {
  appId: Scalars['ID']['input'];
};


export type MutationFlagEventArgs = {
  eventId: Scalars['ID']['input'];
  eventIndex?: InputMaybe<Scalars['String']['input']>;
  flag: NewRawQueryFlag;
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateLexFileUploadUrlArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationMarkLeadConvertedArgs = {
  appId: Scalars['ID']['input'];
  leadId: Scalars['ID']['input'];
};


export type MutationPushLexArgs = {
  appId: Scalars['ID']['input'];
  channelId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationResendConfirmationCodeArgs = {
  clientId: Scalars['ID']['input'];
  origin?: InputMaybe<AuthVerifyOrigin>;
  userName: Scalars['String']['input'];
};


export type MutationSetAppCopyableArgs = {
  appId: Scalars['ID']['input'];
  isCopyable: Scalars['Boolean']['input'];
};


export type MutationStartTestsArgs = {
  appId: Scalars['ID']['input'];
  channelIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  testType: Scalars['String']['input'];
};


export type MutationStartWebsiteCrawlingArgs = {
  appId: Scalars['ID']['input'];
  channelId: Scalars['String']['input'];
  documentTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includeDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  kendra?: InputMaybe<WebCrawlKendraInput>;
  s3RegionalDomain?: InputMaybe<Scalars['String']['input']>;
  settlingTimeSeconds?: InputMaybe<Scalars['settlingTimeSeconds_Int_max_5_exclusiveMin_0']['input']>;
  stealth?: InputMaybe<Scalars['Boolean']['input']>;
  webUrl: Scalars['URL']['input'];
  webUrlPatterns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationSubmitForAlexaCertArgs = {
  appId: Scalars['ID']['input'];
  channelId?: InputMaybe<Scalars['ID']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationTrainDialogflowAgentArgs = {
  appId: Scalars['ID']['input'];
  channelId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUnmarkLeadConvertedArgs = {
  appId: Scalars['ID']['input'];
  leadId: Scalars['ID']['input'];
};


export type MutationUpdateAlertSubscriptionArgs = {
  input: UpdateAlertSubscriptionInput;
  subscriptionId: Scalars['ID']['input'];
};


export type MutationUpdateAppArgs = {
  app: UpdateAppInput;
  appId: Scalars['ID']['input'];
};


export type MutationUpdateCampaignArgs = {
  campaign: UpdateCampaignInput;
  campaignId: Scalars['ID']['input'];
};


export type MutationUpdateDialogflowAgentArgs = {
  appId: Scalars['ID']['input'];
  channelId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateEngagementAnalysisConfigArgs = {
  appId: Scalars['ID']['input'];
  input: EngagementAnalysisConfigInput;
};


export type MutationUpdateEntityArgs = {
  appId: Scalars['ID']['input'];
  entity: UpdateEntityInput;
  entityId: Scalars['ID']['input'];
};


export type MutationUpdateHandlerArgs = {
  appId: Scalars['ID']['input'];
  handler: UpdateHandlerInput;
  handlerId: Scalars['ID']['input'];
};


export type MutationUpdateIntentArgs = {
  appId: Scalars['ID']['input'];
  intent: UpdateIntentInput;
  intentId: Scalars['ID']['input'];
};


export type MutationUpdateNotificationPhoneArgs = {
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateOrgArgs = {
  org: UpdateOrganizationInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationUpdateSkillArgs = {
  appId: Scalars['ID']['input'];
  channelId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateSummarySubscriptionArgs = {
  input: UpdateSummarySubscriptionInput;
  subscriptionId: Scalars['ID']['input'];
};


export type MutationUpdateUtteranceTestArgs = {
  createdOn: Scalars['String']['input'];
  testId: Scalars['ID']['input'];
  update: UtteranceTestUpdate;
};


export type MutationUploadAppTemplateArgs = {
  appId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  template: AppTemplateInput;
};


export type MutationWithdrawFromAlexaCertArgs = {
  appId: Scalars['ID']['input'];
  channelId?: InputMaybe<Scalars['ID']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<WithdrawFromAlexaCertReasons>;
};

export enum NewRawQueryFlag {
  /**
   * For utterance events. It means the recognition was good. No issues.
   * If it was already confirmed and a new user confirms,
   * the event will be set to CONFIRMED_CORRECT.
   */
  Correct = 'CORRECT',
  /** For utterance events. The raw query needs attention. */
  Flagged = 'FLAGGED',
  /**
   * For response events, indicates that the response was good, but could
   * be better.
   */
  Helpful = 'HELPFUL',
  /** For utterance events. It means it was determined that the recognition was bad. Tuning is needed. */
  Incorrect = 'INCORRECT',
  /** For utterance events. It means it was determined that the recognition was bad, but there has been a resolution. */
  IncorrectResolved = 'INCORRECT_RESOLVED',
  /**
   * For response events, indicates the response will always need to go
   * to a live human agent.
   */
  NeedsHuman = 'NEEDS_HUMAN',
  /**
   * For response events, indicates that this is the best
   * response available.
   */
  Optimal = 'OPTIMAL'
}

export type NluRequestSlot = {
  /**
   * ID of the slot, if applicable.
   *
   * For example, "UVA"
   */
  id?: Maybe<Scalars['String']['output']>;
  /** Confidence on the slot match.  Range is between 0 - 1 where 1 is the highest confidence. */
  matchConfidence?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  /**
   * The raw spoken value.
   *
   * For example, "cavaliers" or "red"
   */
  rawValue?: Maybe<Scalars['String']['output']>;
  /** If the entity resolution was successful or not. */
  successfulMatch?: Maybe<Scalars['Boolean']['output']>;
};

/** Notification delivery channels */
export enum NotificationChannel {
  Email = 'email',
  Sms = 'sms'
}

export type OnboardingMutation = {
  /**
   * Downloads a website and retrieves specific details outlining the websites details like icon, primary/secondary colors,
   * and what technologies that the website uses.
   */
  startRetrieveWebsiteDetails: StartRetreiveWebsiteDetailsResult;
};


export type OnboardingMutationStartRetrieveWebsiteDetailsArgs = {
  webUrl: Scalars['URL']['input'];
};

export type OnboardingQuery = {
  /** Returns the execution data for gathering website details. */
  webDetailsExecution: WebDetailsExecution;
};


export type OnboardingQueryWebDetailsExecutionArgs = {
  executionId: Scalars['ID']['input'];
};

export type OpportunityAlertDetail = {
  /** Whether or not to receive the messages during the business hours */
  duringBusinessHours?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to receive the messages outside the business hours */
  outsideBusinessHours?: Maybe<Scalars['Boolean']['output']>;
  /** Type of alert that it is. */
  type: OpportunityAlertDetailType;
};

export type OpportunityAlertDetailInput = {
  /** Whether or not to receive the messages during the business hours */
  duringBusinessHours?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether or not to receive the messages outside the business hours */
  outsideBusinessHours?: InputMaybe<Scalars['Boolean']['input']>;
  /** Type of alert that it is. */
  type: OpportunityAlertDetailType;
};

export enum OpportunityAlertDetailType {
  AgentRequested = 'AGENT_REQUESTED',
  BuyingIntent = 'BUYING_INTENT',
  ChatStarted = 'CHAT_STARTED',
  NewSession = 'NEW_SESSION',
  UnansweredQuestion = 'UNANSWERED_QUESTION'
}

export type OrgAcceptToSReturn = {
  updatedOrg: Organization;
};

export type OrgAcceptedTermsOfService = {
  /** The ISO date in which the user accepted the terms. */
  acceptedOn: Scalars['DateTime']['output'];
  /** The email address of the user that accepted the terms */
  email: Scalars['String']['output'];
  /** The URL of the terms sheet that was accepted. */
  url: Scalars['URL']['output'];
  /** The user that accepted the terms of service */
  userId: Scalars['String']['output'];
};

export type OrgAnalytics = {
  user: OrgUsageStat;
};


export type OrgAnalyticsUserArgs = {
  byChannel?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  byEnvironment?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};

export type OrgAppQuerySortByParameters = {
  /** The order in which to sort by. */
  order?: InputMaybe<OrgAppQuerySortByParametersOrder>;
  /** The attribute to sort by. */
  sortBy: SortableAppAttributes;
};

export enum OrgAppQuerySortByParametersOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type OrgLimitations = {
  /** The channels that are allowed for the organization */
  allowedChannels?: Maybe<Array<Scalars['String']['output']>>;
  /** The maximum number of document crawls */
  maxDocumentCrawls: Scalars['Int']['output'];
  /** The maximum number of tests executed per month */
  maxTestsExecutedPerMonth: Scalars['Int']['output'];
  /** The maximum number of unique sessions per month */
  maxUniqueSessionsPerMonth: Scalars['Int']['output'];
};

export type OrgMember = {
  email: Scalars['String']['output'];
  policy: OrgPolicy;
  userId: Scalars['ID']['output'];
};

export type OrgMembers = {
  members: Array<Maybe<OrgMember>>;
  pending: Array<Maybe<PendingOrgMember>>;
};

export type OrgMembersMutation = {
  /**
   * Invites a user to the organization.
   *
   * If the user already has an account, the user will be added to the organization immediately.
   *
   * If the user does not have an account, an invitation will be sent to the user and they must accept, create an account
   * and then they will be added on first login.
   *
   * It's possible that users have multiple accounts with the same email. All of those accounts will be added to the organization.
   * An array of each user which was added will be returned.
   *
   * If the user was invited, only a single pending user object will be returned but it will still be an array because Graphql does not
   * like such complexity (for valid reasons).
   *
   * If the user is already a member of the organization, the user will be promoted to the role that is provided.
   */
  invite: Array<Maybe<PendingOrOrgMember>>;
  /** Removes a user from the organization. */
  remove: Scalars['String']['output'];
  /** Removes the invitation for a user. */
  removeInvite: Scalars['String']['output'];
  /**
   * Sets the app-level access restriction for a pending invitation within this organization.
   *
   * Pass an empty list to remove all app-level restrictions (restoring full org access when the invite is accepted).
   * Pass a list of app IDs to restrict the user to only those apps once they accept the invite.
   */
  setInviteAppAccess: PendingOrgMember;
  /**
   * Sets the app-level access restriction for a user within this organization.
   *
   * Pass an empty list to remove all app-level restrictions (restoring full org access).
   * Pass a list of app IDs to restrict the user to only those apps.
   */
  setUserAppAccess: OrgMember;
};


export type OrgMembersMutationInviteArgs = {
  appIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  email: Scalars['String']['input'];
  roles: Array<InputMaybe<Scalars['String']['input']>>;
};


export type OrgMembersMutationRemoveArgs = {
  userId: Scalars['ID']['input'];
};


export type OrgMembersMutationRemoveInviteArgs = {
  email: Scalars['String']['input'];
  invitationId: Scalars['ID']['input'];
};


export type OrgMembersMutationSetInviteAppAccessArgs = {
  appIds: Array<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  invitationId: Scalars['ID']['input'];
};


export type OrgMembersMutationSetUserAppAccessArgs = {
  appIds: Array<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

/** The time frame in which the items were metered. */
export enum OrgMeteredTimeFrame {
  /** All usage stats since the beginning of the day */
  Day = 'DAY',
  /** All stats since the bottom of the hour. */
  Hour = 'HOUR',
  /** All usage stats since the beginning of the month */
  Month = 'MONTH',
  /** All usage stats since the beginning of the week (Sunday) */
  Week = 'WEEK'
}

export type OrgMutation = {
  /** Notifies us that the user has accepted the Terms of Service. */
  acceptTos: OrgAcceptToSReturn;
  cms: CmsMutation;
  /** Deletes the attributes of the organization. */
  delete: Scalars['String']['output'];
  /**
   * Links an organization to an AWS subscription if one is available.
   *
   * Setting the subscription type to "FREE" will unlink the organization and
   * free up the subscription for another organization.
   */
  linkToAWSSub: Scalars['String']['output'];
  /** Mutations related to the members of an organization. */
  members: OrgMembersMutation;
  /** Partner verification operations for custom sender email/domain. */
  partnerVerification: PartnerVerificationMutation;
  /** Updates the attributes of the organization. */
  update: Organization;
  /** Updates the billing contact of an org. */
  updateBillingContact: Organization;
  /** Updates the brand contact of an org. */
  updateBrandContact: Organization;
  /**
   * Updates the tier of an organization without linking it to a third party.
   *
   * If tier is TRIAL, the trial will end 30 days from the moment it is called.
   *
   * Note: If the organization is linked to a payed subscription such as AWS marketplace, then
   * the payed subscription will take precedence. Unlink the organization from those subscriptions
   * for this tier to take effect.
   *
   * Returns the updated organization.
   */
  updateTier: Scalars['String']['output'];
};


export type OrgMutationLinkToAwsSubArgs = {
  type: SubscriptionType;
};


export type OrgMutationUpdateArgs = {
  org: UpdateOrganizationInput;
};


export type OrgMutationUpdateBillingContactArgs = {
  contact: BillingContactInput;
};


export type OrgMutationUpdateBrandContactArgs = {
  contact: BrandContactInput;
};


export type OrgMutationUpdateTierArgs = {
  type: SubscriptionType;
};

export type OrgPolicy = {
  /**
   * Optional list of app IDs the user is restricted to within this organization.
   * When null/absent, the user has access to all apps in the organization.
   */
  appIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  permissions: Array<Maybe<Scalars['String']['output']>>;
  roles: Array<Maybe<Scalars['String']['output']>>;
};

export type OrgUsageStat = {
  /** A CSV formatted output of the stats found. */
  csv: UsageStatCsvReturn;
  intervals: Array<Maybe<UsageStat>>;
  newUsers: Scalars['Int']['output'];
  /** ID of the organization that contains the app */
  organizationId: Scalars['ID']['output'];
  returningUsers: Scalars['Int']['output'];
  totalSessions: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
};

export type OrgUsageStats = {
  docsCrawled: Scalars['Int']['output'];
  entities: Scalars['Int']['output'];
  handlers: Scalars['Int']['output'];
  intents: Scalars['Int']['output'];
  testsExecuted: Scalars['Int']['output'];
  totalDocs: Scalars['Int']['output'];
  uniqueSessions: Scalars['Int']['output'];
};

/**
 * An organization is a group which contains and manages specific apps.
 * Each organization is a representation of a company which publishes
 * apps in the Stentor platform.
 */
export type Organization = {
  /** The email XAPPineer that is in charge of handling the organization's account */
  XAPPLead?: Maybe<Scalars['String']['output']>;
  _id: Scalars['ID']['output'];
  /** Returns true if the org has accepted the latest version of the terms of service. */
  acceptedLatestTermsOfService: Scalars['Boolean']['output'];
  acceptedTermsOfService: Array<OrgAcceptedTermsOfService>;
  analytics?: Maybe<OrgAnalytics>;
  /** The apps that the organization contains. */
  apps?: Maybe<GetAppsQuery>;
  /** Deprecated: The Auth0 Group that the organization is linked to. */
  auth0GroupId?: Maybe<Scalars['ID']['output']>;
  /** An event bus that is attatched to the organization to receive specific events related to the organization such as App status changes. */
  awsEventBusArn?: Maybe<Scalars['String']['output']>;
  /** An object of feature flags */
  beta?: Maybe<Scalars['JSON']['output']>;
  billingContact?: Maybe<BillingContact>;
  brandContact?: Maybe<BrandContact>;
  /**
   * A CMS token is an authorization token that is linked to the app
   * which allows third party services to access certain resources without
   * user intervention.
   */
  cmsTokens: Array<Maybe<CmsToken>>;
  /**
   * The email address of a user who can be contacted about issues
   * related to the organization.
   */
  contact?: Maybe<Scalars['String']['output']>;
  /** The organization contact's name. */
  contactName?: Maybe<Scalars['String']['output']>;
  /** The organization contact's phone number. */
  contactPhone?: Maybe<Scalars['String']['output']>;
  /**
   * Date in which the organization signed a contract to publish
   * apps.
   *
   * Format: ISO-8601 date format
   */
  contractDate?: Maybe<Scalars['String']['output']>;
  /** The date at which the organization was created */
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  /** The human-readable description of the organization. */
  description: Scalars['String']['output'];
  /**
   * Organization's IP rights which were loaded that give permissions to
   * publish apps on their behalf.
   */
  ipRights?: Maybe<IPrights>;
  limitations: OrgLimitations;
  /** URL for the organization's logo. */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** Manual override available features for the organization. This is set by the administrator. These are already accounted for in the limitations */
  manualOverrideAvailableFeatures?: Maybe<PartialOrgLimitations>;
  /** The members statics for the given time frame. */
  members: OrgMembers;
  /** The human-readable name of the organization. */
  name: Scalars['String']['output'];
  /** Any notes that are related to the organization. */
  notes?: Maybe<Scalars['String']['output']>;
  /** A unique ID to identify a specific organization. */
  organizationId: Scalars['ID']['output'];
  /** Partner branding configuration for customizing email appearance */
  partnerBranding?: Maybe<PartnerBranding>;
  /** Payment account information */
  paymentAccounts?: Maybe<PaymentAccounts>;
  /**
   * Third party publishing account information such as Amazon SMAPI's
   * service or Google's Dialogflow.
   */
  publishingAccounts?: Maybe<PublishingAccounts>;
  /** The type of subscription that the organization currently is under. */
  type: SubscriptionType;
  /** The usage statics for the given time frame. */
  usage: OrgUsageStats;
  /** A URL to the organization's website. */
  website?: Maybe<Scalars['String']['output']>;
};


/**
 * An organization is a group which contains and manages specific apps.
 * Each organization is a representation of a company which publishes
 * apps in the Stentor platform.
 */
export type OrganizationAppsArgs = {
  byName?: InputMaybe<Scalars['String']['input']>;
  byStatusType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  from?: InputMaybe<Scalars['Int']['input']>;
  nuSortBy?: InputMaybe<Array<InputMaybe<OrgAppQuerySortByParameters>>>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * An organization is a group which contains and manages specific apps.
 * Each organization is a representation of a company which publishes
 * apps in the Stentor platform.
 */
export type OrganizationUsageArgs = {
  timeFrame?: InputMaybe<OrgMeteredTimeFrame>;
};

/**
 * Organization aggregation bucket for cross-org leads analytics.
 * Shows performance metrics for each organization a user has access to.
 */
export type OrganizationLeadBucket = {
  /** High-value leads for this organization */
  highValueLeadCount: Scalars['Int']['output'];
  /** Total leads for this organization */
  leadCount: Scalars['Int']['output'];
  /** Organization name */
  name: Scalars['String']['output'];
  /** The organization ID */
  organizationId: Scalars['ID']['output'];
};

export type OrgsMutation = {
  add: CreateOrgReturn;
  org: OrgMutation;
};


export type OrgsMutationAddArgs = {
  app?: InputMaybe<CreateOrgCreateAppInput>;
  appTemplate?: InputMaybe<AppTemplateInput>;
  org: CreateOrganizationInput;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type OrgsMutationOrgArgs = {
  organizationId: Scalars['ID']['input'];
};

/** A collections query which returns a collection of organizations. */
export type OrgsQuery = {
  /** A subset of organizations that are viewed. */
  orgs?: Maybe<Array<Maybe<SearchedOrg>>>;
  /** The total number of organizations that were found in the query. */
  total: Scalars['Int']['output'];
};

export type PartialAppLimitations = {
  /** Whether the app can use the Action Bar feature in the chat widget. */
  actionBar?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the app has access to advanced analytics features. */
  advancedAnalytics?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the app can tag leads using AI */
  aiLeadTagging?: Maybe<Scalars['Boolean']['output']>;
  /** The integrations that are allowed in the app */
  allowedIntegrations?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether the app can capture leads from the widget */
  captureLead?: Maybe<Scalars['Boolean']['output']>;
  /** Integrations that are explicitly excluded (blacklist). */
  excludedIntegrations?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether a business representative can enter a live chat and talk to the client. */
  liveTakeover?: Maybe<Scalars['Boolean']['output']>;
  /** The maximum number of entities that can be created in the app */
  maxEntities?: Maybe<Scalars['Int']['output']>;
  /** The maximum number of handlers that can be created in the app */
  maxHandlers?: Maybe<Scalars['Int']['output']>;
  /** The maximum number of intents that can be created in the app */
  maxIntents?: Maybe<Scalars['Int']['output']>;
  /** The maximum number of Kendra documents that can be indexed in the app */
  maxKendraDocs?: Maybe<Scalars['Int']['output']>;
  /** Whether the users can set preferred time for the appointment */
  preferredTime?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the app can be use the Reserve With Google actions widget. */
  reserveWithGoogle?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the app can use the schedule widget */
  schedule?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the app can access the chat transcript for a lead */
  transcriptAccess?: Maybe<Scalars['Boolean']['output']>;
};

export type PartialOrgLimitations = {
  /** The channels that are allowed for the organization */
  allowedChannels?: Maybe<Array<Scalars['String']['output']>>;
  /** The maximum number of document crawls */
  maxDocumentCrawls?: Maybe<Scalars['Int']['output']>;
  /** The maximum number of tests executed per month */
  maxTestsExecutedPerMonth?: Maybe<Scalars['Int']['output']>;
  /** The maximum number of unique sessions per month */
  maxUniqueSessionsPerMonth?: Maybe<Scalars['Int']['output']>;
};

export type PartnerBranding = {
  /** Hex color code for body background (e.g., #FBFAFE) */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** Partner company name for footer (e.g., Acme Corporation) */
  companyName?: Maybe<Scalars['String']['output']>;
  /** Domain verification state (read-only, managed by verification mutations) */
  domainVerification?: Maybe<DomainVerificationState>;
  /** Channel-specific overrides for email templates. Properties here override base branding for lead notification emails. */
  emailOverrides?: Maybe<EmailBrandingOverrides>;
  /** Email verification state (read-only, managed by verification mutations) */
  emailVerification?: Maybe<EmailVerificationState>;
  /** Whether partner branding is enabled for this organization */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** URL to partner's logo image (recommended: 100px width) */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** Short partner code used in booking URLs (e.g., sfl, td, ca). Used for Reserve with Google and other integrations. */
  partnerCode?: Maybe<Scalars['String']['output']>;
  /** Hex color code for header/footer background (e.g., #071837) */
  primaryColor?: Maybe<Scalars['String']['output']>;
  /** Channel-specific overrides for Reserve with Google. Properties here override base branding for RWG booking pages. */
  reserveWithGoogleOverrides?: Maybe<PartnerBrandingOverrides>;
  /** Optional: Custom verified sender email (e.g., no-reply@acme.com). Requires SES verification. */
  senderEmail?: Maybe<Scalars['String']['output']>;
  /** Partner website URL for footer link (e.g., https://acme.com) */
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type PartnerBrandingInput = {
  /** Hex color code for body background (e.g., #FBFAFE) */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Partner company name for footer (e.g., Acme Corporation) */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** Channel-specific overrides for email templates. Properties here override base branding for lead notification emails. */
  emailOverrides?: InputMaybe<EmailBrandingOverridesInput>;
  /** Whether partner branding is enabled for this organization */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** URL to partner's logo image (recommended: 100px width) */
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** Short partner code used in booking URLs (e.g., sfl, td, ca). Used for Reserve with Google and other integrations. */
  partnerCode?: InputMaybe<Scalars['String']['input']>;
  /** Hex color code for header/footer background (e.g., #071837) */
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  /** Channel-specific overrides for Reserve with Google. Properties here override base branding for RWG booking pages. */
  reserveWithGoogleOverrides?: InputMaybe<PartnerBrandingOverridesInput>;
  /** Optional: Custom verified sender email (e.g., no-reply@acme.com). Requires SES verification. */
  senderEmail?: InputMaybe<Scalars['String']['input']>;
  /** Partner website URL for footer link (e.g., https://acme.com) */
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Channel-specific branding overrides.
 * Properties here override base PartnerBranding for specific channels.
 */
export type PartnerBrandingOverrides = {
  /** Hex color code for body background (e.g., #FBFAFE) */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** Partner company name for footer (e.g., Acme Corporation) */
  companyName?: Maybe<Scalars['String']['output']>;
  /** URL to partner's logo image (recommended: 100px width) */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** Hex color code for header/footer background (e.g., #071837) */
  primaryColor?: Maybe<Scalars['String']['output']>;
  /** Partner website URL for footer link (e.g., https://acme.com) */
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

/**
 * Input for channel-specific branding overrides.
 * Properties here override base PartnerBranding for specific channels.
 */
export type PartnerBrandingOverridesInput = {
  /** Hex color code for body background (e.g., #FBFAFE) */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Partner company name for footer (e.g., Acme Corporation) */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** URL to partner's logo image (recommended: 100px width) */
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** Hex color code for header/footer background (e.g., #071837) */
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  /** Partner website URL for footer link (e.g., https://acme.com) */
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerVerificationDomainResult = {
  /** DNS records that need to be added to complete verification */
  dnsRecords?: Maybe<Array<DnsRecord>>;
  /** The domain being verified */
  domain: Scalars['String']['output'];
  /** ISO date when verification was requested */
  requestedAt: Scalars['DateTime']['output'];
  /** Current verification status */
  status: Scalars['String']['output'];
  /** ISO date when verification completed (if verified) */
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PartnerVerificationEmailResult = {
  /** The email address being verified */
  email: Scalars['String']['output'];
  /** ISO date when verification was requested */
  requestedAt: Scalars['DateTime']['output'];
  /** Current verification status */
  status: Scalars['String']['output'];
  /** ISO date when verification completed (if verified) */
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PartnerVerificationMutation = {
  /**
   * Checks current verification status for both email and domain.
   * If verification has completed, auto-updates the organization record.
   */
  checkVerificationStatus: PartnerVerificationStatusResult;
  /** Resets domain verification. Removes from SES and clears organization record. */
  resetDomainVerification: Scalars['Boolean']['output'];
  /**
   * Resets email verification. Removes from SES and clears organization record.
   * Also clears senderEmail if it matches the verified email.
   */
  resetEmailVerification: Scalars['Boolean']['output'];
  /**
   * Initiates email verification. AWS SES sends a verification email to the address.
   * The recipient must click the link in the email to complete verification.
   */
  sendEmailVerification: PartnerVerificationEmailResult;
  /**
   * Initiates domain verification. Returns DNS records that must be added to the domain.
   * Once DNS records are added and propagated, use checkVerificationStatus to verify.
   */
  startDomainVerification: PartnerVerificationDomainResult;
};


export type PartnerVerificationMutationSendEmailVerificationArgs = {
  email: Scalars['String']['input'];
};


export type PartnerVerificationMutationStartDomainVerificationArgs = {
  domain: Scalars['String']['input'];
};

export type PartnerVerificationStatusResult = {
  /** Domain verification status (null if not started) */
  domain?: Maybe<PartnerVerificationDomainResult>;
  /** Email verification status (null if not started) */
  email?: Maybe<PartnerVerificationEmailResult>;
};

export type PaymentAccounts = {
  _id: Scalars['ID']['output'];
  /** Account information related to the AWS Marketplace payment platform. */
  aws?: Maybe<AwsPaymentAccount>;
  /**
   * Service Order information. This will be in place if the organization
   * has a contract placed outside of Stentor. The organization will
   * be given a set number of apps of a specific type that they are allowed
   * to publish. They will be required to submit payment if they reached
   * the limit of their service order.
   */
  so?: Maybe<ServiceOrderAccount>;
  /**
   * Account information related to the Stripe payment platform.
   * This will be used to charge an organization when they submit new apps.
   */
  stripe?: Maybe<StripePaymentAccount>;
};

export type PaymentAccountsInput = {
  /**
   * Service Order information. This will be in place if the organization
   * has a contract placed outside of Stentor. The organization will
   * be given a set number of apps of a specific type that they are allowed
   * to publish. They will be required to submit payment if they reached
   * the limit of their service order.
   */
  so?: InputMaybe<ServiceOrderAccountInput>;
  /**
   * Account information related to the Stripe payment platform.
   * This will be used to charge an organization when they submit new apps.
   */
  stripe?: InputMaybe<StripePaymentAccountInput>;
};

export type PendingOrOrgMember = OrgMember | PendingOrgMember;

export type PendingOrgMember = {
  email: Scalars['String']['output'];
  invitationId: Scalars['ID']['output'];
  policy: OrgPolicy;
};

/** Opening hours information from Google Business Profile. */
export type PlaceOpeningHours = {
  /**
   * Whether the place is currently open.
   * Note: This is a snapshot from when the data was fetched.
   */
  openNow?: Maybe<Scalars['Boolean']['output']>;
  /** Periods of opening hours for each day of the week. */
  periods?: Maybe<Array<PlaceOpeningHoursPeriod>>;
  /**
   * Human-readable opening hours for each day of the week.
   * Example: ["Monday: 9:00 AM – 5:00 PM", "Tuesday: 9:00 AM – 5:00 PM", ...]
   */
  weekdayText?: Maybe<Array<Scalars['String']['output']>>;
};

export type PlaceOpeningHoursInput = {
  openNow?: InputMaybe<Scalars['Boolean']['input']>;
  periods?: InputMaybe<Array<PlaceOpeningHoursPeriodInput>>;
  weekdayText?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A period of opening hours (open and close times). */
export type PlaceOpeningHoursPeriod = {
  /** When the place closes. May be null for 24-hour places. */
  close?: Maybe<PlaceOpeningHoursTime>;
  /** When the place opens. */
  open: PlaceOpeningHoursTime;
};

export type PlaceOpeningHoursPeriodInput = {
  close?: InputMaybe<PlaceOpeningHoursTimeInput>;
  open: PlaceOpeningHoursTimeInput;
};

/** Time component for opening hours (from Google Places API). */
export type PlaceOpeningHoursTime = {
  /**
   * Day of the week (0=Sunday, 1=Monday, ..., 6=Saturday).
   * Matches BusinessDayOfWeek enum values.
   */
  day: Scalars['Int']['output'];
  /** Time in 24-hour HHMM format (e.g., "0900" for 9:00 AM, "1730" for 5:30 PM). */
  time: Scalars['String']['output'];
};

export type PlaceOpeningHoursTimeInput = {
  /** Day of the week (0=Sunday, 1=Monday, ..., 6=Saturday). */
  day: Scalars['Int']['input'];
  /** Time in 24-hour HHMM format (e.g., "0900" for 9:00 AM). */
  time: Scalars['String']['input'];
};

/**
 * Platform specific data for the app that does not correspond
 * with other high level data that is shared.
 */
export type PlatformData = {
  alexa?: Maybe<AlexaPlatformData>;
  google?: Maybe<GooglePlatformData>;
};

/**
 * Platform specific data for the app that does not correspond
 * with other high level data that is shared.
 */
export type PlatformDataInput = {
  alexa?: InputMaybe<AlexaPlatformDataInput>;
  google?: InputMaybe<GooglePlatformDataInput>;
};

/** Breakdown of leads by geolocation precision level within a cluster. */
export type PrecisionBreakdown = {
  /** Number of leads with high precision (geocoded address) */
  high: Scalars['Int']['output'];
  /** Number of leads with low precision (IP address) */
  low: Scalars['Int']['output'];
  /** Number of leads with medium precision (ZIP or city centroid) */
  medium: Scalars['Int']['output'];
  /** Number of leads with unknown precision */
  unknown: Scalars['Int']['output'];
};

export type PreviousHandlerPath = BaseHandlerPath & {
  actions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Conditions to be met. */
  conditions?: Maybe<Scalars['PathConditions']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  /**
   * Optional platform filter for the path.
   *
   * If set, the path will only apply to the specified platform.
   */
  platform?: Maybe<Scalars['String']['output']>;
  /** Set to true to request the previous handler paths. */
  previousHandler: Scalars['Boolean']['output'];
};

/**
 * A business record from the prospector database, projected for
 * pre-filling onboarding. All fields beyond businessId/name are
 * best-effort and may be absent depending on enrichment coverage.
 */
export type ProspectorBusiness = {
  bookOnlineProvider?: Maybe<Scalars['String']['output']>;
  bookOnlineUrl?: Maybe<Scalars['String']['output']>;
  bookingLinkProvider?: Maybe<Scalars['String']['output']>;
  bookingLinkUrl?: Maybe<Scalars['String']['output']>;
  bookingUrl?: Maybe<Scalars['String']['output']>;
  businessHours?: Maybe<Scalars['JSON']['output']>;
  businessId: Scalars['ID']['output'];
  callsToAction?: Maybe<Array<ProspectorCallToAction>>;
  chatProvider?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  claimedProfile?: Maybe<Scalars['Boolean']['output']>;
  cms?: Maybe<Scalars['String']['output']>;
  contacts?: Maybe<Array<ProspectorContact>>;
  country?: Maybe<Scalars['String']['output']>;
  darkVibrantColor?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  detectedTechnologies?: Maybe<Array<Scalars['String']['output']>>;
  email?: Maybe<Scalars['String']['output']>;
  enrichmentStatus?: Maybe<Scalars['String']['output']>;
  facebookUrl?: Maybe<Scalars['String']['output']>;
  fsmProvider?: Maybe<Scalars['String']['output']>;
  gbpType?: Maybe<Scalars['String']['output']>;
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  licenses?: Maybe<Array<ProspectorLicense>>;
  linkedinUrl?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  placesTypes?: Maybe<Array<Scalars['String']['output']>>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  privacyPolicyUrl?: Maybe<Scalars['String']['output']>;
  profileLinks?: Maybe<Array<ProspectorProfileLink>>;
  reviewCount?: Maybe<Scalars['Int']['output']>;
  reviewRating?: Maybe<Scalars['Float']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  termsOfServiceUrl?: Maybe<Scalars['String']['output']>;
  twitterUrl?: Maybe<Scalars['String']['output']>;
  vertical?: Maybe<Scalars['String']['output']>;
  vibrantColor?: Maybe<Scalars['String']['output']>;
  websiteCategory?: Maybe<Scalars['String']['output']>;
  websiteCheckedAt?: Maybe<Scalars['String']['output']>;
  websiteLive?: Maybe<Scalars['Boolean']['output']>;
  websiteServices?: Maybe<Array<Scalars['String']['output']>>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

/**
 * A prospector business lookup result: the matched business plus the
 * surrounding market-intelligence layer (similar peers and nearby
 * competitors).
 */
export type ProspectorBusinessResult = {
  business: ProspectorBusiness;
  competitors: Array<ProspectorCompetitor>;
  peers?: Maybe<ProspectorPeerStats>;
  similarity?: Maybe<ProspectorSimilarity>;
};

export type ProspectorCallToAction = {
  callToAction: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ProspectorCompetitor = {
  bookOnlineProvider?: Maybe<Scalars['String']['output']>;
  businessId: Scalars['ID']['output'];
  chatProvider?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  distanceIsEstimated: Scalars['Boolean']['output'];
  distanceMiles: Scalars['Float']['output'];
  fsmProvider?: Maybe<Scalars['String']['output']>;
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  hasBookOnline: Scalars['Boolean']['output'];
  hasChat: Scalars['Boolean']['output'];
  hasFsm: Scalars['Boolean']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  primaryColor?: Maybe<Scalars['String']['output']>;
  reviewCount?: Maybe<Scalars['Int']['output']>;
  reviewRating?: Maybe<Scalars['Float']['output']>;
  score: Scalars['Float']['output'];
  state?: Maybe<Scalars['String']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type ProspectorContact = {
  contactId: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ProspectorLicense = {
  fullText?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ProspectorPeerStats = {
  city: ProspectorPeerStatsRow;
  national: ProspectorPeerStatsRow;
  state: ProspectorPeerStatsRow;
  topBookOnlineProviders: Array<ProspectorProviderShare>;
  topFsmProviders: Array<ProspectorProviderShare>;
};

/**
 * Aggregate stats for one peer scope. Rates are 0..1; averages are
 * null when count is 0.
 */
export type ProspectorPeerStatsRow = {
  avgReviewCount?: Maybe<Scalars['Float']['output']>;
  avgReviewRating?: Maybe<Scalars['Float']['output']>;
  bookOnlineRate: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  hasChatRate: Scalars['Float']['output'];
  hasFsmRate: Scalars['Float']['output'];
  licensedRate: Scalars['Float']['output'];
  parkedDomainRate: Scalars['Float']['output'];
};

export type ProspectorProfileLink = {
  displayName: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ProspectorProviderShare = {
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  share: Scalars['Float']['output'];
};

/**
 * What the subject business was matched against to derive peers and
 * competitors.
 */
export type ProspectorSimilarity = {
  strategy: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type PublicApp = {
  /** The unique identifier for the app. */
  appId: Scalars['ID']['output'];
  /** A description of the business. */
  businessDescription?: Maybe<Scalars['String']['output']>;
  /** A description of what constitutes a high-value lead for this business. */
  businessHighValueLeadDescription?: Maybe<Scalars['String']['output']>;
  /**
   * Retrieve documents/content for this app from the knowledge base.
   * When a query is provided, performs a full-text search and returns results ranked by relevance.
   * When no query is provided, returns all content paginated by last updated date.
   */
  content?: Maybe<PublicContentResult>;
  /**
   * Query FAQs for this app.
   * Returns the same results as /cms/faq endpoint.
   */
  faq?: Maybe<PublicFaqResult>;
  /**
   * Get a specific handler by its intentId.
   * This is useful for retrieving details about a specific handler.
   */
  handler?: Maybe<PublicHandler>;
  /**
   * Query handlers with pagination.
   * This returns a list of handlers for determining what data to collect from customers.
   */
  handlers?: Maybe<PublicHandlersQuery>;
  /** The name of the app/business. */
  name?: Maybe<Scalars['String']['output']>;
  /** The organization that owns this app. */
  organization?: Maybe<PublicOrganization>;
  /** The physical locations associated with this business. */
  places?: Maybe<Array<Maybe<PublicPlace>>>;
  /**
   * Search web content for this app.
   * Returns the same results as /cms/search endpoint.
   */
  search?: Maybe<PublicSearchResult>;
  /** The business website. */
  website?: Maybe<Scalars['String']['output']>;
};


export type PublicAppContentArgs = {
  from?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type PublicAppFaqArgs = {
  from?: InputMaybe<Scalars['Int']['input']>;
  question: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type PublicAppHandlerArgs = {
  intentId: Scalars['ID']['input'];
};


export type PublicAppHandlersArgs = {
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type PublicAppSearchArgs = {
  boostUrlPatterns?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeUrlPatterns?: InputMaybe<Array<Scalars['String']['input']>>;
  from?: InputMaybe<Scalars['Int']['input']>;
  includeUrlPatterns?: InputMaybe<Array<Scalars['String']['input']>>;
  query: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type PublicCardDisplay = {
  accessibilityText?: Maybe<Scalars['String']['output']>;
  buttons?: Maybe<Array<Maybe<PublicCardDisplayButton>>>;
  /** Body text for the card. */
  content?: Maybe<Scalars['String']['output']>;
  /** When present, opens this URL when the image is tapped. */
  imageActionUrl?: Maybe<Scalars['String']['output']>;
  largeImageUrl?: Maybe<Scalars['String']['output']>;
  smallImageUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** Display type — always "CARD". */
  type: Scalars['String']['output'];
};

export type PublicCardDisplayButton = {
  openUrlAction: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type PublicContentHighlight = {
  /** The text that is highlighted from the match. */
  text?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PublicContentItem = {
  /** Unique ID for the content. */
  _id: Scalars['String']['output'];
  /** The relevance score of this result. Present when a search query is provided. */
  _score?: Maybe<Scalars['Float']['output']>;
  /** The highlights found in the match query. Present when a search query is provided. */
  highlight?: Maybe<PublicContentHighlight>;
  /** The name of the content. */
  name: Scalars['String']['output'];
  /** The raw text of the content. */
  text?: Maybe<Scalars['String']['output']>;
  /** The type of content (e.g., "website"). */
  type?: Maybe<Scalars['String']['output']>;
  /** The full URL of the content. */
  url: Scalars['String']['output'];
};

export type PublicContentResult = {
  /** The content items. */
  content: Array<Maybe<PublicContentItem>>;
  /** The total number of content items found. */
  total: Scalars['Int']['output'];
};

/** A display element — either a card or a list/carousel. */
export type PublicDisplay = PublicCardDisplay | PublicListDisplay;

export type PublicFaq = {
  /** ID of the FAQ. */
  _id: Scalars['ID']['output'];
  /** The relevance score based on the query. */
  _score: Scalars['Float']['output'];
  /** The answer to the FAQ questions. */
  answer: Scalars['String']['output'];
  /** The name assigned to the question-answer page. */
  name: Scalars['String']['output'];
  /** Questions that are linked to the answer. */
  questions: Array<Maybe<Scalars['String']['output']>>;
  /** The URL that the FAQ came from. */
  url?: Maybe<Scalars['String']['output']>;
};

export type PublicFaqResult = {
  /** The list of FAQs. */
  faq: Array<Maybe<PublicFaq>>;
  /** The total number of FAQs found. */
  total: Scalars['Int']['output'];
};

export type PublicHandler = {
  /**
   * The raw handler configuration data (JSON).
   * Contains handler-specific settings such as capture slot configuration for lead generation.
   */
  data?: Maybe<Scalars['JSON']['output']>;
  /** The unique identifier of the handler. */
  intentId: Scalars['ID']['output'];
  /** The human-readable name of the handler. */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * The response templates for this handler.
   * Returns the first response from each content key, including displays and suggestions.
   */
  responses?: Maybe<Array<Maybe<PublicHandlerResponse>>>;
  /** The slots that this handler collects from the user. */
  slots?: Maybe<Array<Maybe<PublicHandlerSlot>>>;
  /** The type of handler (e.g., InputUnknownHandler, IntentHandler, etc.). */
  type?: Maybe<Scalars['String']['output']>;
};

export type PublicHandlerResponse = {
  /** The display text for this response (for chat/text channels). */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Display elements (cards, lists) to render in UI surfaces. */
  displays?: Maybe<Array<Maybe<PublicDisplay>>>;
  /** The content key (e.g., the intent this response is for). */
  key: Scalars['String']['output'];
  /** The full output speech, including suggestion chips. */
  outputSpeech?: Maybe<PublicResponseOutput>;
  /** Reprompt used when no user response is received. */
  reprompt?: Maybe<PublicResponseOutput>;
  /** Named response segment variations (e.g., greeting phrase alternatives). */
  segments?: Maybe<Array<Maybe<PublicHandlerResponseSegmentItem>>>;
  /** The SSML for this response (for voice channels). */
  ssml?: Maybe<Scalars['String']['output']>;
  /**
   * Tag identifying the response variant (e.g., "WELCOME_NEW_USER").
   * Consumers can use this to select the response appropriate for new vs. returning users.
   */
  tag?: Maybe<Scalars['String']['output']>;
};

export type PublicHandlerResponseSegment = {
  /** Display text for this segment variation. */
  displayText?: Maybe<Scalars['String']['output']>;
  /** SSML for this segment variation. */
  ssml?: Maybe<Scalars['String']['output']>;
};

export type PublicHandlerResponseSegmentItem = {
  /** The key identifying this segment group (e.g., "GREETING"). */
  key: Scalars['String']['output'];
  /** The variations for this segment. */
  segments?: Maybe<Array<Maybe<PublicHandlerResponseSegment>>>;
};

export type PublicHandlerSlot = {
  /** The name of the slot. */
  name: Scalars['String']['output'];
  /** Whether this slot is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The type of the slot (e.g., STENTOR_FIRST_NAME, STENTOR_EMAIL, etc.). */
  type?: Maybe<Scalars['String']['output']>;
};

export type PublicHandlersQuery = {
  /** The list of handlers. */
  handlers?: Maybe<Array<Maybe<PublicHandler>>>;
  /** The total number of handlers found. */
  total: Scalars['Int']['output'];
};

export type PublicListDisplay = {
  items?: Maybe<Array<Maybe<PublicListDisplayItem>>>;
  title?: Maybe<Scalars['String']['output']>;
  /** Display type — "LIST" or "CAROUSEL". */
  type: Scalars['String']['output'];
};

export type PublicListDisplayButton = {
  title: Scalars['String']['output'];
};

export type PublicListDisplayImage = {
  accessibilityText?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type PublicListDisplayItem = {
  buttons?: Maybe<Array<Maybe<PublicListDisplayButton>>>;
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<PublicListDisplayImage>;
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type PublicOrganization = {
  /** The name of the organization. */
  name?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the organization. */
  organizationId: Scalars['ID']['output'];
};

/**
 * Public partner branding information for use on booking pages and widgets.
 * Only includes non-sensitive styling and company information.
 */
export type PublicPartnerBranding = {
  /** Hex color code for body background */
  backgroundColor: Scalars['String']['output'];
  /** Partner company name */
  companyName: Scalars['String']['output'];
  /** Partner website URL */
  companyWebsite: Scalars['String']['output'];
  /** URL to partner's logo image */
  logoUrl: Scalars['String']['output'];
  /** Short partner code (e.g., sfl, td, ca) */
  partnerCode: Scalars['String']['output'];
  /** Hex color code for header/footer background */
  primaryColor: Scalars['String']['output'];
};

export type PublicPlace = {
  /** The formatted address of the place. */
  formattedAddress?: Maybe<Scalars['String']['output']>;
  /** The latitude coordinate of the place. */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** The longitude coordinate of the place. */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The Google Place ID. */
  placeId: Scalars['ID']['output'];
  /** The website associated with this place. */
  website?: Maybe<Scalars['String']['output']>;
};

export type PublicQuery = {
  /**
   * Retrieve public information about an app.
   * This query does not require authentication.
   */
  app?: Maybe<PublicApp>;
  /**
   * Look up a business in the prospector database by Google Place ID
   * OR by prospector businessId. Exactly one of the two arguments
   * must be provided.
   *
   * Used by onboarding to pre-fill business details. Returns null
   * when no matching business exists, so callers should fall back to
   * an empty form.
   *
   * This query does not require authentication. Rate limiting should
   * be enforced at the API Gateway level.
   */
  business?: Maybe<ProspectorBusinessResult>;
  /**
   * Retrieve partner branding by partner code.
   * This query does not require authentication.
   * Used by booking pages and widgets to apply partner-specific branding.
   *
   * @param partnerCode - Required partner code (e.g., "sfl", "lwn")
   * @param channel - Optional channel for channel-specific branding overrides.
   *                  Valid values: "email", "reserve-with-google"
   *                  If omitted, returns base branding.
   *                  If specified, returns base branding merged with channel overrides.
   */
  partnerBranding?: Maybe<PublicPartnerBranding>;
};


export type PublicQueryAppArgs = {
  appId: Scalars['ID']['input'];
};


export type PublicQueryBusinessArgs = {
  businessId?: InputMaybe<Scalars['ID']['input']>;
  placeId?: InputMaybe<Scalars['ID']['input']>;
};


export type PublicQueryPartnerBrandingArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  partnerCode: Scalars['String']['input'];
};

export type PublicResponseOutput = {
  /** Text for display/chat channels. */
  displayText?: Maybe<Scalars['String']['output']>;
  /** SSML for voice channels. */
  ssml?: Maybe<Scalars['String']['output']>;
  /** Suggestion chips shown to the user. */
  suggestions?: Maybe<Array<Maybe<PublicSuggestion>>>;
};

export type PublicSearchResult = {
  /** The search results. */
  content: Array<Maybe<PublicWebContent>>;
  /** The total number of results found. */
  total: Scalars['Int']['output'];
};

export type PublicSuggestion = {
  /** The text shown on the suggestion chip. */
  title: Scalars['String']['output'];
  /**
   * If present, this is a link-out suggestion.
   * The URL to open when tapped (may be a tel: URI or https: URL).
   */
  url?: Maybe<Scalars['String']['output']>;
};

export type PublicWebContent = {
  /** Unique ID for the web content. */
  _id: Scalars['String']['output'];
  /** The relevance score of this result. */
  _score?: Maybe<Scalars['Float']['output']>;
  /** The meta description from the page. */
  description?: Maybe<Scalars['String']['output']>;
  /** The domain without www prefix (e.g., "example.com"). */
  domain?: Maybe<Scalars['String']['output']>;
  /** The highlights found in the match query. */
  highlight?: Maybe<PublicWebContentHighlight>;
  /** The name of the content (page title). */
  name: Scalars['String']['output'];
  /** The original text length before truncation. */
  originalTextLength?: Maybe<Scalars['Int']['output']>;
  /** The URL path (e.g., "/about/team"). */
  path?: Maybe<Scalars['String']['output']>;
  /** The raw-text of the content. */
  text: Scalars['String']['output'];
  /** The full URL of the web content. */
  url: Scalars['String']['output'];
};

export type PublicWebContentHighlight = {
  /** The text that is highlighted from the match. */
  text?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PublishingAccounts = {
  _id: Scalars['ID']['output'];
  /** Account information for a linked amazon SMAPI developer account. */
  smapi?: Maybe<SmapiAccount>;
};

export type PublishingAccountsInput = {
  /** Account information for a linked amazon SMAPI developer account. */
  smapi?: InputMaybe<SmapiAccountInput>;
};

/** Top level query for Stentor. */
export type Query = {
  admin: AdminQuery;
  /** The version that the API is currently in. */
  apiVersion: Scalars['String']['output'];
  /** Fetches a single app */
  app?: Maybe<App>;
  /** Fetches a list of apps */
  apps?: Maybe<AppsQuery>;
  /**
   * Get metadata about available filter values for the apps list.
   * Returns unique status type values with counts to populate UI filter dropdowns.
   * Requires admin access.
   */
  appsFilterMetadata?: Maybe<AppsFilterMetadata>;
  /** These are the test types that are currently available to search and execute. */
  availableTestTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves a single campaign by its campaignId. */
  campaign?: Maybe<Campaign>;
  /** Retrieves all campaigns for the given app. */
  campaigns: Array<Campaign>;
  /**
   * Get aggregated dashboard data.
   * Currently supports leads analytics with plans to expand to other data types.
   *
   * Time filtering supports two modes:
   * 1. Use 'period' for predefined calendar periods (TODAY, WEEK, MONTH)
   * 2. Use 'startDate' and 'endDate' for custom date ranges
   *
   * If 'period' is provided, it takes precedence over startDate/endDate.
   */
  dashboard?: Maybe<DashboardData>;
  entity?: Maybe<Entity>;
  /** Retrieve a batch of entities for the given word. */
  entitySuggestions?: Maybe<Suggestion>;
  /** Retrieve a specific Handler */
  handler?: Maybe<Handler>;
  /** Retrieve a specific intent */
  intent?: Maybe<Intent>;
  /**
   * Get a single lead by its unique ID.
   * Since lead IDs are globally unique, appId is optional.
   * When appId is not provided, authorization verifies the user has access to the organization that owns the lead.
   */
  lead?: Maybe<Lead>;
  /**
   * Fetch leads across all apps that the user has access to.
   * Access is determined by the user's organizationId memberships.
   */
  leads?: Maybe<LeadsQuery>;
  /**
   * Get the current user's notification preferences.
   * Returns null if the user has no preferences configured.
   */
  myNotificationPreferences?: Maybe<UserNotificationPreferences>;
  onboarding: OnboardingQuery;
  /** Fetches a single organization */
  org?: Maybe<Organization>;
  /** Fetches a list of organizations */
  orgs?: Maybe<OrgsQuery>;
  /** Retrieve a User profile of a user */
  profile?: Maybe<UserProfile>;
  /** Public namespace for unauthenticated queries. */
  public: PublicQuery;
  /**
   * Get apps the current user can subscribe to.
   * Returns apps from organizations the user belongs to.
   */
  subscribableApps: Array<App>;
  tests?: Maybe<TotalQueryAppTests>;
  utils: Utils;
};


/** Top level query for Stentor. */
export type QueryAppArgs = {
  appId: Scalars['ID']['input'];
};


/** Top level query for Stentor. */
export type QueryAppsArgs = {
  byStatusType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  from?: InputMaybe<Scalars['Int']['input']>;
  needsPlaces?: InputMaybe<Scalars['Boolean']['input']>;
  needsVerification?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Array<InputMaybe<OrgAppQuerySortByParameters>>>;
  withIdOrName?: InputMaybe<Scalars['String']['input']>;
};


/** Top level query for Stentor. */
export type QueryCampaignArgs = {
  campaignId: Scalars['ID']['input'];
};


/** Top level query for Stentor. */
export type QueryCampaignsArgs = {
  appId: Scalars['ID']['input'];
};


/** Top level query for Stentor. */
export type QueryDashboardArgs = {
  appId?: InputMaybe<Scalars['ID']['input']>;
  contactType?: InputMaybe<Scalars['String']['input']>;
  contactTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  environment?: InputMaybe<Scalars['String']['input']>;
  highValueLead?: InputMaybe<Scalars['Boolean']['input']>;
  jobType?: InputMaybe<Scalars['String']['input']>;
  jobTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  period?: InputMaybe<DashboardPeriod>;
  referringSource?: InputMaybe<Scalars['String']['input']>;
  serviceType?: InputMaybe<Scalars['String']['input']>;
  serviceTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  source?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  urgencies?: InputMaybe<Array<Scalars['String']['input']>>;
  urgency?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
  zipCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Top level query for Stentor. */
export type QueryEntityArgs = {
  appId: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
};


/** Top level query for Stentor. */
export type QueryEntitySuggestionsArgs = {
  appId: Scalars['String']['input'];
  text: Scalars['String']['input'];
};


/** Top level query for Stentor. */
export type QueryHandlerArgs = {
  appId: Scalars['ID']['input'];
  intentId: Scalars['ID']['input'];
};


/** Top level query for Stentor. */
export type QueryIntentArgs = {
  appId: Scalars['ID']['input'];
  intentId: Scalars['ID']['input'];
};


/** Top level query for Stentor. */
export type QueryLeadArgs = {
  appId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


/** Top level query for Stentor. */
export type QueryLeadsArgs = {
  agentType?: InputMaybe<Scalars['String']['input']>;
  appId?: InputMaybe<Scalars['ID']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  canonicalSource?: InputMaybe<Scalars['String']['input']>;
  capturePlatform?: InputMaybe<Scalars['String']['input']>;
  captureSurface?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  contactMethod?: InputMaybe<Scalars['String']['input']>;
  contactType?: InputMaybe<Scalars['String']['input']>;
  contactTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  environment?: InputMaybe<Scalars['String']['input']>;
  highValueLead?: InputMaybe<Scalars['Boolean']['input']>;
  includePartials?: InputMaybe<Scalars['Boolean']['input']>;
  jobType?: InputMaybe<Scalars['String']['input']>;
  jobTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  nextKey?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  partialsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  partnerId?: InputMaybe<Scalars['ID']['input']>;
  referringSource?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  serviceType?: InputMaybe<Scalars['String']['input']>;
  serviceTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  size?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceSystem?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  urgencies?: InputMaybe<Array<Scalars['String']['input']>>;
  urgency?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
};


/** Top level query for Stentor. */
export type QueryOrgArgs = {
  organizationId: Scalars['ID']['input'];
};


/** Top level query for Stentor. */
export type QueryOrgsArgs = {
  byType?: InputMaybe<SubscriptionType>;
  from?: InputMaybe<Scalars['Int']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  withIdOrName?: InputMaybe<Scalars['String']['input']>;
};


/** Top level query for Stentor. */
export type QueryProfileArgs = {
  jwt?: InputMaybe<Scalars['String']['input']>;
};


/** Top level query for Stentor. */
export type QueryTestsArgs = {
  appId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  testType?: InputMaybe<Scalars['String']['input']>;
};

/** ROI configuration for an app */
export type RoiConfig = {
  /** All cost per lead values (custom + defaults) with metadata */
  allCostsPerLead: Array<CostPerLeadWithMeta>;
  /**
   * Custom cost per lead overrides by job type (in USD).
   * Only includes job types that have custom overrides.
   */
  costPerLead?: Maybe<CostPerLeadConfig>;
  /**
   * Monthly subscription cost override in USD.
   * If set, this takes priority over Stripe and default values.
   */
  monthlySubscriptionCost?: Maybe<Scalars['Float']['output']>;
};

/** Input for ROI configuration */
export type RoiConfigInput = {
  /**
   * Cost per lead overrides by job type.
   * Only include job types you want to override.
   * Set a value to null to remove the override and use the default.
   */
  costPerLead?: InputMaybe<CostPerLeadInput>;
  /**
   * Monthly subscription cost override in USD.
   * Set to null to remove the override and use Stripe/default values.
   */
  monthlySubscriptionCost?: InputMaybe<Scalars['Float']['input']>;
};

/** Time period for ROI reports */
export enum RoiPeriod {
  Custom = 'CUSTOM',
  Day = 'DAY',
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Week = 'WEEK',
  Year = 'YEAR'
}

/** ROI calculation result */
export type RoiReport = {
  /** Conversion metrics */
  conversionMetrics: ConversionMetrics;
  /** End date of the reporting period */
  endDate: Scalars['DateTime']['output'];
  /** Breakdown of lead value by job type, sorted by totalValue descending */
  leadValueByJobType: Array<LeadValueByJobType>;
  /** Calculated ROI: (totalLeadValue - subscriptionCost) / subscriptionCost */
  roi: Scalars['Float']['output'];
  /** ROI as a percentage */
  roiPercentage: Scalars['Float']['output'];
  /** Start date of the reporting period */
  startDate: Scalars['DateTime']['output'];
  /** Subscription cost details */
  subscriptionCost: SubscriptionCost;
  /** Total value of all leads in USD */
  totalLeadValue: Scalars['Float']['output'];
};

/** Flags for events of raw queries. */
export enum RawQueryEventFlag {
  /** For utterance events. A second user confirmed the recognition. 'Correct' must be set before this is. */
  ConfirmedCorrect = 'CONFIRMED_CORRECT',
  /** For utterance events. It means the recognition was good. No issues. */
  Correct = 'CORRECT',
  /** For utterance events. The raw query needs attention. */
  Flagged = 'FLAGGED',
  /**
   * For response events, indicates that the response was good, but could
   * be better.
   */
  Helpful = 'HELPFUL',
  /** For utterance events. It means it was determined that the recognition was bad. Tuning is needed. */
  Incorrect = 'INCORRECT',
  /** For utterance events. It means it was determined that the recognition was bad, but there has been a resolution. */
  IncorrectResolved = 'INCORRECT_RESOLVED',
  /**
   * For response events, indicates the response will always need to go
   * to a live human agent.
   */
  NeedsHuman = 'NEEDS_HUMAN',
  /**
   * For response events, indicates that this is the best
   * response available.
   */
  Optimal = 'OPTIMAL'
}

export type RegenerateFaqSuggestionsReturn = {
  /** Number of failed put requests to Firehose */
  failedPutRequests: Scalars['Int']['output'];
  /** Number of FAQs processed */
  faqsProcessed: Scalars['Int']['output'];
  /** Number of suggestions generated */
  suggestionsGenerated: Scalars['Int']['output'];
  /**
   * Total number of FAQs in the app. If this exceeds faqsProcessed,
   * not all FAQs were regenerated due to the 10000 limit.
   */
  totalFAQs: Scalars['Int']['output'];
  /** Warning message if not all FAQs could be processed */
  warning?: Maybe<Scalars['String']['output']>;
};

export type RegenerateUtteranceSuggestionsReturn = {
  /** IDs of the intents that were processed */
  intentIds: Array<Scalars['ID']['output']>;
  /** Number of intents that had suggestion generation triggered */
  intentsProcessed: Scalars['Int']['output'];
};

/** How multiple apps should be grouped in summary emails */
export enum ReportGrouping {
  /** Send one combined email for all apps */
  Combined = 'combined',
  /** Send one email per app */
  Individual = 'individual'
}

export type RequestDependentExecutableHandlerPath = BaseHandlerPath & {
  actions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Conditions to be met. */
  conditions?: Maybe<Scalars['PathConditions']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  /** The ID of the handler to forward or redirect the request to */
  intentId: Scalars['String']['output'];
  /**
   * Optional platform filter for the path.
   *
   * If set, the path will only apply to the specified platform.
   */
  platform?: Maybe<Scalars['String']['output']>;
  /**
   * Match data for the JSON path.
   *
   * 'name' on Match is the JSON path
   */
  requestMatch?: Maybe<Scalars['JSON']['output']>;
  /**
   * Optional, if redirecting or forwarding to a handler that is expecting slots,
   * set these to pre-populate them on the request.
   */
  slots?: Maybe<Scalars['JSON']['output']>;
  /**
   * Type of path.
   *
   * Setting type to START changes the request so that
   * handler.start() is called.
   *
   * Not setting the type passes the request straight
   * through, requiring the new handler to handle the
   * request as is.
   */
  type?: Maybe<Scalars['String']['output']>;
};

export type RequestDependentHandlerPath = RequestDependentExecutableHandlerPath | RequestDependentHistoricalHandlerPath | RequestDependentPreviousHandlerPath;

export type RequestDependentHandlerResponse = HandlerResponse & {
  /** Description of the channel that will be */
  channel?: Maybe<HandlerResponseChannel>;
  /** Conditions to be met. */
  conditions?: Maybe<Scalars['HandlerResponseConditions']['output']>;
  context?: Maybe<HandlerResponseContext>;
  data?: Maybe<Scalars['JSON']['output']>;
  displays?: Maybe<Array<Maybe<BaseDisplay>>>;
  /** The name of the intent that the response is linked to. */
  intent: Scalars['String']['output'];
  /**
   * Name of the response
   *
   * Used to help differentiate multiple responses.
   */
  name?: Maybe<Scalars['String']['output']>;
  /** What the assistant will say first as part of the response. */
  outputSpeech?: Maybe<ResponseOutput>;
  /**
   * If provided, the output speech was most likely a question and requires a response from the user.
   * The reprompt is given if the user doesn't say anything or the assistant can't recognize the response.
   */
  reprompt?: Maybe<ResponseOutput>;
  /**
   * Match data for the JSON path.
   *
   * 'name' on Match is the JSON path
   */
  requestMatch?: Maybe<Scalars['JSON']['output']>;
  segments?: Maybe<Array<Maybe<HandlerResponseSegmentItem>>>;
  /** System responses to perform account links, control media, surface changes, and permission requests. */
  system?: Maybe<HandlerResponseSystem>;
  /**
   * Used for tracking the response in third party analytics.
   *
   * @deprecated(reason: Tags can be arrays now. Use tags instead.  This one will only return the top tag if it's an array.)
   */
  tag?: Maybe<Scalars['String']['output']>;
  /** Used for tracking the response in third party analytics. */
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type RequestDependentHandlerResponseSegment = HandlerResponseSegment & {
  requestMatch: Scalars['JSON']['output'];
  segment: ResponseOutput;
};

export type RequestDependentHistoricalHandlerPath = BaseHandlerPath & {
  actions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Conditions to be met. */
  conditions?: Maybe<Scalars['PathConditions']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  /**
   * The number of handlers to go back into the history of.
   *
   * This is typically just one and can be no more than 10.
   */
  historicalIndex: Scalars['Int']['output'];
  /**
   * Optional platform filter for the path.
   *
   * If set, the path will only apply to the specified platform.
   */
  platform?: Maybe<Scalars['String']['output']>;
  /**
   * Match data for the JSON path.
   *
   * 'name' on Match is the JSON path
   */
  requestMatch?: Maybe<Scalars['JSON']['output']>;
  /**
   * Optional, if redirecting or forwarding to a handler that is expecting slots,
   * set these to pre-populate them on the request.
   */
  slots?: Maybe<Scalars['JSON']['output']>;
};

export type RequestDependentPreviousHandlerPath = BaseHandlerPath & {
  actions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Conditions to be met. */
  conditions?: Maybe<Scalars['PathConditions']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  /**
   * Optional platform filter for the path.
   *
   * If set, the path will only apply to the specified platform.
   */
  platform?: Maybe<Scalars['String']['output']>;
  /** Set to true to request the previous handler paths. */
  previousHandler: Scalars['Boolean']['output'];
  /**
   * Match data for the JSON path.
   *
   * 'name' on Match is the JSON path
   */
  requestMatch?: Maybe<Scalars['JSON']['output']>;
};

export type ResendToIntegrationInput = {
  /** The appId of the lead to resend */
  appId: Scalars['ID']['input'];
  /** The ISO date string of the lead (e.g., "2026-02-17T19:07:05.839Z") */
  date: Scalars['String']['input'];
  /** The integration ID to resend to (default: "webhook") */
  integrationId?: InputMaybe<Scalars['String']['input']>;
};

export type ResendToIntegrationResult = {
  /** The EventBridge event ID for tracking */
  eventId?: Maybe<Scalars['String']['output']>;
  /** A message describing the result */
  message?: Maybe<Scalars['String']['output']>;
  /** Whether the resend was successful */
  success: Scalars['Boolean']['output'];
};

export type ResponseOutput = {
  defaultLocale?: Maybe<Scalars['String']['output']>;
  displayText?: Maybe<Scalars['String']['output']>;
  locales?: Maybe<ResponseOutputLocales>;
  ssml?: Maybe<Scalars['String']['output']>;
  suggestions?: Maybe<Array<Maybe<SuggestionType>>>;
  textToSpeech?: Maybe<Scalars['String']['output']>;
};

export type ResponseOutputInput = {
  defaultLocale?: InputMaybe<Scalars['String']['input']>;
  displayText?: InputMaybe<Scalars['String']['input']>;
  locales?: InputMaybe<ResponseOutputLocalesInput>;
  ssml?: InputMaybe<Scalars['String']['input']>;
  suggestions?: InputMaybe<Array<InputMaybe<SuggestionTypeInput>>>;
  textToSpeech?: InputMaybe<Scalars['String']['input']>;
};

export type ResponseOutputLocales = {
  /** Danish */
  da?: Maybe<LocaleResponseOutput>;
  /** German */
  de?: Maybe<LocaleResponseOutput>;
  /** German German */
  deDE?: Maybe<LocaleResponseOutput>;
  /** English */
  en?: Maybe<LocaleResponseOutput>;
  /** English Australian */
  enAU?: Maybe<LocaleResponseOutput>;
  /** English Canada */
  enCA?: Maybe<LocaleResponseOutput>;
  /** English Great Britain */
  enGB?: Maybe<LocaleResponseOutput>;
  /** English India */
  enIN?: Maybe<LocaleResponseOutput>;
  /** English United States */
  enUS?: Maybe<LocaleResponseOutput>;
  /** Spanish */
  es?: Maybe<LocaleResponseOutput>;
  /** Spanish: Only supported in Google. */
  es419?: Maybe<LocaleResponseOutput>;
  /** Spanish Spain */
  esES?: Maybe<LocaleResponseOutput>;
  /** Spanish Mexico */
  esMX?: Maybe<LocaleResponseOutput>;
  /** French */
  fr?: Maybe<LocaleResponseOutput>;
  /** French Canada */
  frCA?: Maybe<LocaleResponseOutput>;
  /** French France */
  frFR?: Maybe<LocaleResponseOutput>;
  /** Italian */
  it?: Maybe<LocaleResponseOutput>;
  /** Italian Italy */
  itIT?: Maybe<LocaleResponseOutput>;
  /** Japanese */
  ja?: Maybe<LocaleResponseOutput>;
  /** Japanese Japan */
  jaJP?: Maybe<LocaleResponseOutput>;
  /** Dutch */
  nl?: Maybe<LocaleResponseOutput>;
  /** Norwegian */
  no?: Maybe<LocaleResponseOutput>;
  /** Portuguese */
  pt?: Maybe<LocaleResponseOutput>;
  /** Portuguese Brazil */
  ptBR?: Maybe<LocaleResponseOutput>;
  /** Russian */
  ru?: Maybe<LocaleResponseOutput>;
  /** Swedish */
  sv?: Maybe<LocaleResponseOutput>;
  /** Thai */
  th?: Maybe<LocaleResponseOutput>;
  /** Turkish */
  tr?: Maybe<LocaleResponseOutput>;
  /** Ukranian */
  uk?: Maybe<LocaleResponseOutput>;
  /** Chinese */
  zh?: Maybe<LocaleResponseOutput>;
  /** Chinese China */
  zhCH?: Maybe<LocaleResponseOutput>;
  /** Chinese Hong Kong */
  zhHK?: Maybe<LocaleResponseOutput>;
  /** Chinese Taiwan */
  zhTW?: Maybe<LocaleResponseOutput>;
};

export type ResponseOutputLocalesInput = {
  /** Danish */
  da?: InputMaybe<LocaleResponseOutputInput>;
  /** German */
  de?: InputMaybe<LocaleResponseOutputInput>;
  /** German German */
  deDE?: InputMaybe<LocaleResponseOutputInput>;
  /** English */
  en?: InputMaybe<LocaleResponseOutputInput>;
  /** English Australian */
  enAU?: InputMaybe<LocaleResponseOutputInput>;
  /** English Canada */
  enCA?: InputMaybe<LocaleResponseOutputInput>;
  /** English Great Britain */
  enGB?: InputMaybe<LocaleResponseOutputInput>;
  /** English India */
  enIN?: InputMaybe<LocaleResponseOutputInput>;
  /** English United States */
  enUS?: InputMaybe<LocaleResponseOutputInput>;
  /** Spanish */
  es?: InputMaybe<LocaleResponseOutputInput>;
  /** Spanish: Only supported in Google. */
  es419?: InputMaybe<LocaleResponseOutputInput>;
  /** Spanish Spain */
  esES?: InputMaybe<LocaleResponseOutputInput>;
  /** Spanish Mexico */
  esMX?: InputMaybe<LocaleResponseOutputInput>;
  /** French */
  fr?: InputMaybe<LocaleResponseOutputInput>;
  /** French Canada */
  frCA?: InputMaybe<LocaleResponseOutputInput>;
  /** French France */
  frFR?: InputMaybe<LocaleResponseOutputInput>;
  /** Italian */
  it?: InputMaybe<LocaleResponseOutputInput>;
  /** Italian Italy */
  itIT?: InputMaybe<LocaleResponseOutputInput>;
  /** Japanese */
  ja?: InputMaybe<LocaleResponseOutputInput>;
  /** Japanese Japan */
  jaJP?: InputMaybe<LocaleResponseOutputInput>;
  /** Dutch */
  nl?: InputMaybe<LocaleResponseOutputInput>;
  /** Norwegian */
  no?: InputMaybe<LocaleResponseOutputInput>;
  /** Portuguese */
  pt?: InputMaybe<LocaleResponseOutputInput>;
  /** Portuguese Brazil */
  ptBR?: InputMaybe<LocaleResponseOutputInput>;
  /** Russian */
  ru?: InputMaybe<LocaleResponseOutputInput>;
  /** Swedish */
  sv?: InputMaybe<LocaleResponseOutputInput>;
  /** Thai */
  th?: InputMaybe<LocaleResponseOutputInput>;
  /** Turkish */
  tr?: InputMaybe<LocaleResponseOutputInput>;
  /** Ukranian */
  uk?: InputMaybe<LocaleResponseOutputInput>;
  /** Chinese */
  zh?: InputMaybe<LocaleResponseOutputInput>;
  /** Chinese China */
  zhCH?: InputMaybe<LocaleResponseOutputInput>;
  /** Chinese Hong Kong */
  zhHK?: InputMaybe<LocaleResponseOutputInput>;
  /** Chinese Taiwan */
  zhTW?: InputMaybe<LocaleResponseOutputInput>;
};

export type ResponseTypeCode = {
  /** The code of returned by the auth server. */
  code?: InputMaybe<Scalars['String']['input']>;
  /** The origin of the code. */
  origin?: InputMaybe<AuthOrigin>;
};

export type SchedulableDependentHandlerResponse = HandlerResponse & {
  /** Description of the channel that will be */
  channel?: Maybe<HandlerResponseChannel>;
  /** Conditions to be met. */
  conditions?: Maybe<Scalars['HandlerResponseConditions']['output']>;
  context?: Maybe<HandlerResponseContext>;
  data?: Maybe<Scalars['JSON']['output']>;
  displays?: Maybe<Array<Maybe<BaseDisplay>>>;
  /** The name of the intent that the response is linked to. */
  intent: Scalars['String']['output'];
  /**
   * Name of the response
   *
   * Used to help differentiate multiple responses.
   */
  name?: Maybe<Scalars['String']['output']>;
  /** What the assistant will say first as part of the response. */
  outputSpeech?: Maybe<ResponseOutput>;
  /**
   * If provided, the output speech was most likely a question and requires a response from the user.
   * The reprompt is given if the user doesn't say anything or the assistant can't recognize the response.
   */
  reprompt?: Maybe<ResponseOutput>;
  /**
   * Match data for the JSON path.
   *
   * 'name' on Match is the JSON path
   */
  schedule?: Maybe<HandlerResponseSchedule>;
  segments?: Maybe<Array<Maybe<HandlerResponseSegmentItem>>>;
  /** System responses to perform account links, control media, surface changes, and permission requests. */
  system?: Maybe<HandlerResponseSystem>;
  /**
   * Used for tracking the response in third party analytics.
   *
   * @deprecated(reason: Tags can be arrays now. Use tags instead.  This one will only return the top tag if it's an array.)
   */
  tag?: Maybe<Scalars['String']['output']>;
  /** Used for tracking the response in third party analytics. */
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export enum ScheduleCadenceType {
  Daily = 'daily',
  Monthly = 'monthly',
  Weekly = 'weekly'
}

export enum ScheduleDaysOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type ScheduleHandlerResponseSegment = HandlerResponseSegment & {
  schedule: HandlerResponseSchedule;
  segment: ResponseOutput;
};

export type ScheduleStart = {
  dayOfWeek?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  time: Scalars['String']['output'];
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type ScheduleStartInput = {
  dayOfWeek?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  time: Scalars['String']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduleWebCrawlInput = {
  /** The cadence at which the crawl should be scheduled. */
  cadence: WebCrawlCadence;
  /** Uses the stealth plugin from puppeteer-extra to attempt to crawl sites that block puppeteer. */
  stealth?: InputMaybe<Scalars['Boolean']['input']>;
  /** The root URL which is the starting point for the crawl. */
  webUrl: Scalars['URL']['input'];
  /** The URL patterns which are to match pages. */
  webUrlPatterns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum SchedulerDaysOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type ScoredWebFaq = {
  /** ID of the webFAQ */
  _id: Scalars['ID']['output'];
  /** The score received based on the query presented. */
  _score: Scalars['Float']['output'];
  /** The answer of the FAQ questions */
  answer: Scalars['String']['output'];
  associatedHandlerId?: Maybe<Scalars['String']['output']>;
  /** The time it was created. */
  created: Scalars['String']['output'];
  /** The name assigned to the question-answer page */
  name: Scalars['String']['output'];
  /** Questions that are linked to the answer */
  questions: Array<Maybe<Scalars['String']['output']>>;
  /** The raw text of the FAQ page */
  raw?: Maybe<Scalars['String']['output']>;
  /** The URL that the FAQ came from */
  url?: Maybe<Scalars['String']['output']>;
  /** A query for any errors that may be in the ScoredWebFAQ */
  validation: WebFaqValidation;
};

/** Organization that is returned from a Search query. */
export type SearchedApp = {
  /** The unique ID of the google action that the app is linked to. */
  actionsOnGoogleId?: Maybe<Scalars['String']['output']>;
  /** The category that the app will fall in to when published to Alexa. */
  alexaCategory?: Maybe<Scalars['String']['output']>;
  /** The unique ID of the alexa skill that the app is linked to. */
  alexaSkillId?: Maybe<Scalars['String']['output']>;
  /** Whether all places are verified */
  allPlacesVerified?: Maybe<Scalars['Boolean']['output']>;
  /** The unique identifier for the app. */
  appId: Scalars['String']['output'];
  /**
   * The description for the app.
   *
   * The description cannot be more than 4000 characters.
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Example phrases the help users know how to use the app.
   *
   * At least three are required for publication.
   */
  examplePhrases?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Whether the app has any places needing verification */
  hasUnverifiedPlaceNotOptedOut?: Maybe<Scalars['Boolean']['output']>;
  /** The phrase a user must speak to wake the app up on a specific platform. */
  invocationName?: Maybe<Scalars['String']['output']>;
  /**
   * Keywords to help when searching directories for the app
   *
   * Max of 30 keywords are allowed.
   */
  keywords?: Maybe<Scalars['String']['output']>;
  /**
   * A large icon for the app, 512x512 PNG
   *
   * Required for Alexa
   */
  largeIcon?: Maybe<Scalars['String']['output']>;
  /** The name of the app. */
  name: Scalars['String']['output'];
  /** The unique identifier for the organization that the app is a part of. */
  organizationId: Scalars['String']['output'];
  /** Total number of places */
  placeCount?: Maybe<Scalars['Int']['output']>;
  /** Number of places needing verification (unverified AND not opted out) */
  placesNeedingVerificationCount?: Maybe<Scalars['Int']['output']>;
  /**
   * A small icon for the app, 108x108 PNG
   *
   * Required for Alexa
   */
  smallIcon?: Maybe<Scalars['String']['output']>;
  /** The status that the app is currently in Stentor. */
  status?: Maybe<SearchedAppStatus>;
  /** A short description of what the app does. */
  summary?: Maybe<Scalars['String']['output']>;
  /** Number of places that have been admin verified */
  verifiedPlaceCount?: Maybe<Scalars['Int']['output']>;
};

export type SearchedAppStatus = {
  /** The email of the user who last changed the status. */
  email: Scalars['String']['output'];
  /** Any notes that was associated with the status change. */
  notes?: Maybe<Scalars['String']['output']>;
  /**
   * The time the status was last changed.
   *
   * Format: ISO 8601
   */
  timestamp: Scalars['String']['output'];
  /** The status level of the app. */
  type: Scalars['String']['output'];
};

/** Organization that is returned from a Search query. */
export type SearchedOrg = {
  /** The email of the XAPP employee which is the main contact for the organization. */
  XAPPLead?: Maybe<Scalars['String']['output']>;
  /** The contact email of the organization. */
  contact?: Maybe<Scalars['String']['output']>;
  /** The name of the contact. */
  contactName?: Maybe<Scalars['String']['output']>;
  /** A human-readable description of the organization. */
  description?: Maybe<Scalars['String']['output']>;
  /** URL for the organization's logo. */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** The name of the organization. */
  name: Scalars['String']['output'];
  /** Internal notes on the organization. */
  notes?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the organization. */
  organizationId: Scalars['String']['output'];
  /** Payment account information */
  paymentAccounts?: Maybe<PaymentAccounts>;
  /** The type of subscription that the organization currently is under. */
  type: SubscriptionType;
};

export type SelectedCount = {
  /** The number of times the 'selectedHandler' was selected from the current intent. */
  count: Scalars['Int']['output'];
  /** The handler/intent ID that was selected during execution. */
  selectedHandler: Scalars['String']['output'];
};

export type Sentences = {
  /** The ending position of the sentence in the phrase. */
  end: Scalars['Int']['output'];
  /** The starting position of the sentence in the phrase. */
  start: Scalars['Int']['output'];
};

export type ServiceOrderAccount = {
  /**
   * The date which the service order was created.
   *
   * Format: ISO 8601 date.
   */
  date?: Maybe<Scalars['String']['output']>;
  /** The number of apps that the organization is allowed to publish. */
  numberOfApps?: Maybe<Scalars['Int']['output']>;
  /** The type of payment that the organization uses (check, card, etc.) */
  paymentType?: Maybe<Scalars['String']['output']>;
};

export type ServiceOrderAccountInput = {
  /**
   * The date which the service order was created.
   *
   * Format: ISO 8601 date.
   */
  date?: InputMaybe<Scalars['String']['input']>;
  /** The number of apps that the organization is allowed to publish. */
  numberOfApps?: InputMaybe<Scalars['Int']['input']>;
  /** The type of payment that the organization uses (check, card, etc.) */
  paymentType?: InputMaybe<Scalars['String']['input']>;
};

export type SessionLeadsResult = {
  /** The leads that were found. */
  leads: Array<Lead>;
  /** The key to retrieve more leads or null if there are none left. */
  nextKey?: Maybe<Scalars['String']['output']>;
};

export type SimpleDisplay = BaseDisplay & {
  backButtonVisible?: Maybe<Scalars['Boolean']['output']>;
  backgroundImage?: Maybe<DisplayImage>;
  image?: Maybe<DisplayImage>;
  items?: Maybe<Array<Maybe<DisplayListItem>>>;
  listItems?: Maybe<Array<Maybe<DisplayListItem>>>;
  payload?: Maybe<Scalars['JSON']['output']>;
  textContent?: Maybe<DisplayTextContent>;
  title?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type SimpleDisplayInput = {
  backButtonVisible?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<DisplayImageInput>;
  image?: InputMaybe<DisplayImageInput>;
  listItems?: InputMaybe<Array<InputMaybe<DisplayListItemInput>>>;
  textContent?: InputMaybe<DisplayTextContentInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type SimpleHandlerResponse = HandlerResponse & {
  /** Description of the channel that will be */
  channel?: Maybe<HandlerResponseChannel>;
  /** Conditions to be met. */
  conditions?: Maybe<Scalars['HandlerResponseConditions']['output']>;
  context?: Maybe<HandlerResponseContext>;
  data?: Maybe<Scalars['JSON']['output']>;
  displays?: Maybe<Array<Maybe<BaseDisplay>>>;
  /** The name of the intent that the response is linked to. */
  intent: Scalars['String']['output'];
  /**
   * Name of the response
   *
   * Used to help differentiate multiple responses.
   */
  name?: Maybe<Scalars['String']['output']>;
  /** What the assistant will say first as part of the response. */
  outputSpeech?: Maybe<ResponseOutput>;
  /**
   * If provided, the output speech was most likely a question and requires a response from the user.
   * The reprompt is given if the user doesn't say anything or the assistant can't recognize the response.
   */
  reprompt?: Maybe<ResponseOutput>;
  segments?: Maybe<Array<Maybe<HandlerResponseSegmentItem>>>;
  /** System responses to perform account links, control media, surface changes, and permission requests. */
  system?: Maybe<HandlerResponseSystem>;
  /**
   * Used for tracking the response in third party analytics.
   *
   * @deprecated(reason: Tags can be arrays now. Use tags instead.  This one will only return the top tag if it's an array.)
   */
  tag?: Maybe<Scalars['String']['output']>;
  /** Used for tracking the response in third party analytics. */
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type SimpleHandlerResponseSegment = HandlerResponseSegment & {
  segment: ResponseOutput;
};

export type Slot = {
  _id: Scalars['String']['output'];
  /**
   * Human readable description of what kind of information
   * the slot is expecting.  The text should be very brief.  For example:
   *
   * "zip"
   * "zip code"
   * "city"
   * "state"
   * "street"
   */
  inputText?: Maybe<Scalars['String']['output']>;
  /**
   * Is the slot a list of values.
   * Supported natively by Dialogflow and shims for Alexa.
   * Can be a boolean or number.  When a number is used, it provides guidance to the Alexa shim on the max amount of expected
   * items in the list.  Minimum value is 2.  Value defaults to 6 when set to true.
   * * NOTE: Only one isList slot is supported per utterance pattern.
   */
  isList?: Maybe<Scalars['IntOrBoolean']['output']>;
  /**
   * The name of the slot, corresponds to how it is displayed in the
   * sample utterance.
   *
   * For example: "Play {Podcast}" where Podcast is the name.
   */
  name: Scalars['String']['output'];
  nlu?: Maybe<Scalars['JSON']['output']>;
  /**
   * The slot will be obfuscated either fully or partially.
   *
   *     Full obfuscation, the slot is replaced with the slot name.  "my name is ${first_name}"
   *     Partial obfuscation will only display a subset of characters, enough to protect the full value but enough for someone that is debugging to recognize the value.
   *
   * For some NLU, such as Amazon Lex, any setting on this value will be interpretted as obfuscated, for more information see [Amazon Lex Slot Obfuscation](https://docs.aws.amazon.com/lex/latest/dg/how-obfuscate.html)
   */
  obfuscateValue?: Maybe<SlotObfuscation>;
  /**
   * The type of entity for the slot.
   *
   * This corresponds to an Entity, specifically the entityId key.
   *
   * For legacy applications, SlotType is used.
   */
  type?: Maybe<Scalars['String']['output']>;
};

export type SlotDependentExecutableHandlerPath = BaseHandlerPath & {
  actions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Conditions to be met. */
  conditions?: Maybe<Scalars['PathConditions']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  /** The ID of the handler to forward or redirect the request to */
  intentId: Scalars['String']['output'];
  /**
   * Optional platform filter for the path.
   *
   * If set, the path will only apply to the specified platform.
   */
  platform?: Maybe<Scalars['String']['output']>;
  /**
   * Match data for the JSON path.
   *
   * 'name' on Match is the JSON path
   */
  slotMatch?: Maybe<Scalars['JSON']['output']>;
  /**
   * Optional, if redirecting or forwarding to a handler that is expecting slots,
   * set these to pre-populate them on the request.
   */
  slots?: Maybe<Scalars['JSON']['output']>;
  /**
   * Type of path.
   *
   * Setting type to START changes the request so that
   * handler.start() is called.
   *
   * Not setting the type passes the request straight
   * through, requiring the new handler to handle the
   * request as is.
   */
  type?: Maybe<Scalars['String']['output']>;
};

export type SlotDependentHandlerPath = SlotDependentExecutableHandlerPath | SlotDependentHistoricalHandlerPath | SlotDependentPreviousHandlerPath;

export type SlotDependentHandlerResponse = HandlerResponse & {
  /** Description of the channel that will be */
  channel?: Maybe<HandlerResponseChannel>;
  /** Conditions to be met. */
  conditions?: Maybe<Scalars['HandlerResponseConditions']['output']>;
  context?: Maybe<HandlerResponseContext>;
  data?: Maybe<Scalars['JSON']['output']>;
  displays?: Maybe<Array<Maybe<BaseDisplay>>>;
  /** The name of the intent that the response is linked to. */
  intent: Scalars['String']['output'];
  /**
   * Name of the response
   *
   * Used to help differentiate multiple responses.
   */
  name?: Maybe<Scalars['String']['output']>;
  /** What the assistant will say first as part of the response. */
  outputSpeech?: Maybe<ResponseOutput>;
  /**
   * If provided, the output speech was most likely a question and requires a response from the user.
   * The reprompt is given if the user doesn't say anything or the assistant can't recognize the response.
   */
  reprompt?: Maybe<ResponseOutput>;
  segments?: Maybe<Array<Maybe<HandlerResponseSegmentItem>>>;
  /**
   * Match data for the JSON path.
   *
   * 'name' on Match is the JSON path
   */
  slotMatch?: Maybe<Scalars['JSON']['output']>;
  /** System responses to perform account links, control media, surface changes, and permission requests. */
  system?: Maybe<HandlerResponseSystem>;
  /**
   * Used for tracking the response in third party analytics.
   *
   * @deprecated(reason: Tags can be arrays now. Use tags instead.  This one will only return the top tag if it's an array.)
   */
  tag?: Maybe<Scalars['String']['output']>;
  /** Used for tracking the response in third party analytics. */
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type SlotDependentHandlerResponseSegment = HandlerResponseSegment & {
  segment: ResponseOutput;
  slotMatch: Scalars['JSON']['output'];
};

export type SlotDependentHistoricalHandlerPath = BaseHandlerPath & {
  actions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Conditions to be met. */
  conditions?: Maybe<Scalars['PathConditions']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  /**
   * The number of handlers to go back into the history of.
   *
   * This is typically just one and can be no more than 10.
   */
  historicalIndex: Scalars['Int']['output'];
  /**
   * Optional platform filter for the path.
   *
   * If set, the path will only apply to the specified platform.
   */
  platform?: Maybe<Scalars['String']['output']>;
  /**
   * Match data for the JSON path.
   *
   * 'name' on Match is the JSON path
   */
  slotMatch?: Maybe<Scalars['JSON']['output']>;
  /**
   * Optional, if redirecting or forwarding to a handler that is expecting slots,
   * set these to pre-populate them on the request.
   */
  slots?: Maybe<Scalars['JSON']['output']>;
};

export type SlotDependentPreviousHandlerPath = BaseHandlerPath & {
  actions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Conditions to be met. */
  conditions?: Maybe<Scalars['PathConditions']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  /**
   * Optional platform filter for the path.
   *
   * If set, the path will only apply to the specified platform.
   */
  platform?: Maybe<Scalars['String']['output']>;
  /** Set to true to request the previous handler paths. */
  previousHandler: Scalars['Boolean']['output'];
  /**
   * Match data for the JSON path.
   *
   * 'name' on Match is the JSON path
   */
  slotMatch?: Maybe<Scalars['JSON']['output']>;
};

export enum SlotObfuscation {
  Full = 'FULL',
  Partial = 'PARTIAL'
}

export type SmapiAccount = {
  /** The ID for the linked SMAPI developer account. */
  vendorId: Scalars['ID']['output'];
};

export type SmapiAccountInput = {
  /** The ID for the linked SMAPI developer account. */
  vendorId: Scalars['ID']['input'];
};

export type SmapiVendor = {
  /** The vendorId of the smapi vendor. */
  id: Scalars['ID']['output'];
  /** The human readable name for the vendor. */
  name: Scalars['String']['output'];
  /** The permissions that the user has in the vendor. */
  roles: Array<Maybe<Scalars['String']['output']>>;
};

/** Sort order options */
export enum SortOrder {
  /** Ascending order */
  Asc = 'ASC',
  /** Descending order */
  Desc = 'DESC'
}

/** These are the attributes that are available for sorting when querying apps of an organization. */
export enum SortableAppAttributes {
  /** Sort alphabetically by appId */
  AppId = 'APP_ID',
  /** Sort by most recent status time */
  StatusTime = 'STATUS_TIME'
}

export type StartRetreiveWebsiteDetailsResult = {
  /** The execution ID of the website to crawl. */
  executionId: Scalars['ID']['output'];
};

export type StartRetreiveWebsiteDetailsSyncResult = {
  /**
   * The website details downloaded.
   *
   * null on error
   */
  result?: Maybe<WebsiteData>;
};

export type Status = {
  /** The email of the user who last changed the status. */
  email: Scalars['String']['output'];
  /** Any notes that was associated with the status change. */
  notes?: Maybe<Scalars['String']['output']>;
  /** A brief history of the status changes. */
  statusHistory?: Maybe<Array<Maybe<StatusHistory>>>;
  /**
   * The time the status was last changed.
   *
   * Format: UNIX timestamp
   */
  timestamp: Scalars['Long']['output'];
  /** The status level of the app. */
  type: Scalars['String']['output'];
};

export type StatusHistory = {
  /** The email of the user who changed the status. */
  email: Scalars['String']['output'];
  /** Any notes that was associated with the status change. */
  notes?: Maybe<Scalars['String']['output']>;
  /**
   * The time the status was changed.
   *
   * Format: UNIX timestamp
   */
  timestamp: Scalars['Long']['output'];
  /** The status level that the app was. */
  type: Scalars['String']['output'];
};

export type StatusHistoryInput = {
  /** The email of the user who changed the status. */
  email: Scalars['String']['input'];
  /** Any notes that was associated with the status change. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /**
   * The time the status was changed.
   *
   * Format: UNIX timestamp
   */
  timestamp: Scalars['Long']['input'];
  /** The status level that the app was. */
  type: Scalars['String']['input'];
};

export type StatusInput = {
  /** The email of the user who last changed the status. */
  email: Scalars['String']['input'];
  /** Any notes that was associated with the status change. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** A brief history of the status changes. */
  statusHistory?: InputMaybe<Array<InputMaybe<StatusHistoryInput>>>;
  /**
   * The time the status was last changed.
   *
   * Format: UNIX timestamp
   */
  timestamp: Scalars['Long']['input'];
  /** The status level of the app. */
  type: Scalars['String']['input'];
};

/** Step-level dropoff metrics for a variant. */
export type StepDropoff = {
  /** Percentage of sessions that dropped off at this step */
  dropoffRate: Scalars['Float']['output'];
  /** Number of sessions that entered this step */
  entered: Scalars['Int']['output'];
  /** Number of sessions that exited from this step (did not continue) */
  exited: Scalars['Int']['output'];
  /** Index of the step (0-based) */
  stepIndex: Scalars['Int']['output'];
  /** Name of the step */
  stepName: Scalars['String']['output'];
};

export type StorageDependentExecutableHandlerPath = BaseHandlerPath & {
  actions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Conditions to be met. */
  conditions?: Maybe<Scalars['PathConditions']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  /** The ID of the handler to forward or redirect the request to */
  intentId: Scalars['String']['output'];
  /**
   * Optional platform filter for the path.
   *
   * If set, the path will only apply to the specified platform.
   */
  platform?: Maybe<Scalars['String']['output']>;
  /**
   * Optional, if redirecting or forwarding to a handler that is expecting slots,
   * set these to pre-populate them on the request.
   */
  slots?: Maybe<Scalars['JSON']['output']>;
  /**
   * Match data for the JSON path.
   *
   * 'name' on Match is the JSON path
   */
  storageMatch?: Maybe<Scalars['JSON']['output']>;
  /**
   * Type of path.
   *
   * Setting type to START changes the request so that
   * handler.start() is called.
   *
   * Not setting the type passes the request straight
   * through, requiring the new handler to handle the
   * request as is.
   */
  type?: Maybe<Scalars['String']['output']>;
};

export type StorageDependentHandlerPath = StorageDependentExecutableHandlerPath | StorageDependentHistoricalHandlerPath | StorageDependentPreviousHandlerPath;

export type StorageDependentHandlerResponse = HandlerResponse & {
  /** Description of the channel that will be */
  channel?: Maybe<HandlerResponseChannel>;
  /** Conditions to be met. */
  conditions?: Maybe<Scalars['HandlerResponseConditions']['output']>;
  context?: Maybe<HandlerResponseContext>;
  data?: Maybe<Scalars['JSON']['output']>;
  displays?: Maybe<Array<Maybe<BaseDisplay>>>;
  /** The name of the intent that the response is linked to. */
  intent: Scalars['String']['output'];
  /**
   * Name of the response
   *
   * Used to help differentiate multiple responses.
   */
  name?: Maybe<Scalars['String']['output']>;
  /** What the assistant will say first as part of the response. */
  outputSpeech?: Maybe<ResponseOutput>;
  /**
   * If provided, the output speech was most likely a question and requires a response from the user.
   * The reprompt is given if the user doesn't say anything or the assistant can't recognize the response.
   */
  reprompt?: Maybe<ResponseOutput>;
  segments?: Maybe<Array<Maybe<HandlerResponseSegmentItem>>>;
  /**
   * Match data for the JSON path.
   *
   * 'name' on Match is the JSON path
   */
  storageMatch?: Maybe<Scalars['JSON']['output']>;
  /** System responses to perform account links, control media, surface changes, and permission requests. */
  system?: Maybe<HandlerResponseSystem>;
  /**
   * Used for tracking the response in third party analytics.
   *
   * @deprecated(reason: Tags can be arrays now. Use tags instead.  This one will only return the top tag if it's an array.)
   */
  tag?: Maybe<Scalars['String']['output']>;
  /** Used for tracking the response in third party analytics. */
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type StorageDependentHandlerResponseSegment = HandlerResponseSegment & {
  segment: ResponseOutput;
  storageMatch?: Maybe<Scalars['JSON']['output']>;
};

export type StorageDependentHistoricalHandlerPath = BaseHandlerPath & {
  actions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Conditions to be met. */
  conditions?: Maybe<Scalars['PathConditions']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  /**
   * The number of handlers to go back into the history of.
   *
   * This is typically just one and can be no more than 10.
   */
  historicalIndex: Scalars['Int']['output'];
  /**
   * Optional platform filter for the path.
   *
   * If set, the path will only apply to the specified platform.
   */
  platform?: Maybe<Scalars['String']['output']>;
  /**
   * Optional, if redirecting or forwarding to a handler that is expecting slots,
   * set these to pre-populate them on the request.
   */
  slots?: Maybe<Scalars['JSON']['output']>;
  /**
   * Match data for the JSON path.
   *
   * 'name' on Match is the JSON path
   */
  storageMatch?: Maybe<Scalars['JSON']['output']>;
};

export type StorageDependentPreviousHandlerPath = BaseHandlerPath & {
  actions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Conditions to be met. */
  conditions?: Maybe<Scalars['PathConditions']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  /**
   * Optional platform filter for the path.
   *
   * If set, the path will only apply to the specified platform.
   */
  platform?: Maybe<Scalars['String']['output']>;
  /** Set to true to request the previous handler paths. */
  previousHandler: Scalars['Boolean']['output'];
  /**
   * Match data for the JSON path.
   *
   * 'name' on Match is the JSON path
   */
  storageMatch?: Maybe<Scalars['JSON']['output']>;
};

export type StripePaymentAccount = {
  /** The Stripe customer ID linked to the organization. */
  customerId: Scalars['ID']['output'];
};

export type StripePaymentAccountInput = {
  /** The Stripe customer ID linked to the organization. */
  customerId: Scalars['ID']['input'];
};

export type StudioTierPaymentAccount = BaseStudioTierPaymentAccount & {
  tier?: Maybe<StudioTierType>;
};

export enum StudioTierType {
  Free = 'FREE',
  Pro = 'PRO',
  Standard = 'STANDARD',
  TrialStandard = 'TRIAL_STANDARD'
}

/** Subscription cost details */
export type SubscriptionCost = {
  /** Monthly equivalent cost in USD */
  monthlyEquivalent: Scalars['Float']['output'];
  /** Source of cost data (stripe, manual, default) */
  source: Scalars['String']['output'];
  /** Total subscription cost for the period in USD */
  totalCost: Scalars['Float']['output'];
};

export type SubscriptionDetails = {
  summary?: Maybe<SubscriptionSummary>;
};

export type SubscriptionSummary = {
  /** Subscription is cancelled */
  isCancelled: Scalars['Boolean']['output'];
  /** When we last charged them and what amount */
  lastCharge?: Maybe<ChargeSummary>;
  /** When is the next bill and what that amount will be */
  nextCharge?: Maybe<UpcomingInvoice>;
  /** Subscription status(stripe) */
  status: Scalars['String']['output'];
  /** When their trial runs out  (The ISO formatted date) */
  trialEndDate?: Maybe<Scalars['String']['output']>;
};

export enum SubscriptionType {
  /** Refers to subscription associated with APP */
  AppSub = 'APP_SUB',
  /** OCS Bronze tier */
  Bronze = 'BRONZE',
  /** OCS Bronze Light tier */
  BronzeLite = 'BRONZE_LITE',
  /** The Apps under this organization are frozen. */
  Free = 'FREE',
  /** OCS Gold Tier */
  Gold = 'GOLD',
  /** Partner tier */
  Partner = 'PARTNER',
  /** OCS Platinum tier */
  Platinum = 'PLATINUM',
  /** A top-tier privileged organization */
  Pro = 'PRO',
  /** OCS Silver tier */
  Silver = 'SILVER',
  /** A very limited privileged organization */
  Standard = 'STANDARD',
  /** A temporary period for the organization which gives them "STANDARD" privileges */
  Trial = 'TRIAL'
}

export type Suggestion = {
  entities: Array<Maybe<EntitySuggestion>>;
  /** Intents that are possible in the given text.  Ordered in the number of overlapping entities. */
  intents: Array<Maybe<SuggestionIntent>>;
  sentences: Array<Maybe<Sentences>>;
  /** The original phrase that was entered. */
  text: Scalars['String']['output'];
  tokens: Array<Maybe<Tokens>>;
};

export type SuggestionIntent = {
  /** The ID of the app that the intent is linked to. */
  appId: Scalars['ID']['output'];
  /** The entity IDs of the entities in this suggestion that use this intent. */
  entities: Array<Maybe<Scalars['String']['output']>>;
  /** The unique identifier of the intent itself. */
  intentId: Scalars['ID']['output'];
  /** The human-readable name of the intent. */
  name: Scalars['String']['output'];
  /** The ID of the organization that the intent is linked to. */
  organizationId: Scalars['ID']['output'];
  /** The slots defined within the utterance patterns and their Entity types. */
  slots?: Maybe<Array<Maybe<Slot>>>;
};

export type SuggestionObject = {
  title: Scalars['String']['output'];
};

export type SuggestionType = LinkOutSuggestion | SuggestionObject;

export type SuggestionTypeInput = {
  title: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type SuggestionsMetadata = {
  /** Number of FAQ suggestions that have excludeFromAutoComplete = true */
  excludedFAQCount?: Maybe<Scalars['Int']['output']>;
  /** Number of historical suggestions that have excludeFromAutoComplete = true */
  excludedHistoricalCount?: Maybe<Scalars['Int']['output']>;
  /** Number of intent suggestions that have excludeFromAutoComplete = true */
  excludedIntentCount?: Maybe<Scalars['Int']['output']>;
};

export type SuggestionsMutation = {
  addFAQSuggestion: FaqSuggestionReturn;
  /** Regenerates FAQ suggestions by fetching all FAQs for an app and generating suggestions from them. */
  regenerateFAQSuggestions: RegenerateFaqSuggestionsReturn;
  /**
   * Regenerates utterance suggestions for intents. If intentIds are provided, only those intents are processed.
   * Otherwise, all intents for the given appId are processed.
   */
  regenerateUtteranceSuggestions: RegenerateUtteranceSuggestionsReturn;
};


export type SuggestionsMutationAddFaqSuggestionArgs = {
  countToGenerate: Scalars['Int']['input'];
  suggestion?: InputMaybe<AdminFaqSuggestionInput>;
};


export type SuggestionsMutationRegenerateFaqSuggestionsArgs = {
  appId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type SuggestionsMutationRegenerateUtteranceSuggestionsArgs = {
  appId: Scalars['ID']['input'];
  intentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Frequency for summary/digest notifications */
export enum SummaryFrequency {
  Monthly = 'monthly',
  Weekly = 'weekly'
}

/** Summary/digest subscription configuration */
export type SummarySubscription = {
  /** App IDs to include in the summary */
  appIds: Array<Scalars['ID']['output']>;
  /** Notification channel */
  channel: NotificationChannel;
  /** Whether this subscription is enabled */
  enabled: Scalars['Boolean']['output'];
  /** How often the summary should be sent */
  frequency: SummaryFrequency;
  /** How to group multiple apps */
  grouping: ReportGrouping;
  /** When the last summary was sent */
  lastSent?: Maybe<Scalars['String']['output']>;
  /** When the next summary is scheduled */
  nextScheduled?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this subscription */
  subscriptionId: Scalars['ID']['output'];
};

export type SyncFaqToKendraReturn = {
  executionId: Scalars['String']['output'];
};

export enum SystemConditionType {
  AccountLinked = 'ACCOUNT_LINKED',
  BargeIn = 'BARGE_IN',
  HealthCheck = 'HEALTH_CHECK',
  NotificationPermissionGranted = 'NOTIFICATION_PERMISSION_GRANTED',
  NotAccountLinked = 'NOT_ACCOUNT_LINKED',
  NotBargeIn = 'NOT_BARGE_IN',
  NotHealthCheck = 'NOT_HEALTH_CHECK',
  NotNotificationPermissionGranted = 'NOT_NOTIFICATION_PERMISSION_GRANTED',
  NotOptionSelect = 'NOT_OPTION_SELECT',
  NotPermissionGranted = 'NOT_PERMISSION_GRANTED',
  NotSurfaceChanged = 'NOT_SURFACE_CHANGED',
  OptionSelect = 'OPTION_SELECT',
  PermissionGranted = 'PERMISSION_GRANTED',
  SurfaceChanged = 'SURFACE_CHANGED'
}

export type SystemDependentExecutableHandlerPath = BaseHandlerPath & {
  actions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Conditions to be met. */
  conditions?: Maybe<Scalars['PathConditions']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  /** The ID of the handler to forward or redirect the request to */
  intentId: Scalars['String']['output'];
  /**
   * Optional platform filter for the path.
   *
   * If set, the path will only apply to the specified platform.
   */
  platform?: Maybe<Scalars['String']['output']>;
  /**
   * Optional, if redirecting or forwarding to a handler that is expecting slots,
   * set these to pre-populate them on the request.
   */
  slots?: Maybe<Scalars['JSON']['output']>;
  systemCondition?: Maybe<SystemConditionType>;
  /**
   * Type of path.
   *
   * Setting type to START changes the request so that
   * handler.start() is called.
   *
   * Not setting the type passes the request straight
   * through, requiring the new handler to handle the
   * request as is.
   */
  type?: Maybe<Scalars['String']['output']>;
};

export type SystemDependentHandlerPath = SystemDependentExecutableHandlerPath | SystemDependentHistoricalHandlerPath | SystemDependentPreviousHandlerPath;

export type SystemDependentHandlerResponse = HandlerResponse & {
  /** Description of the channel that will be */
  channel?: Maybe<HandlerResponseChannel>;
  /** Conditions to be met. */
  conditions?: Maybe<Scalars['HandlerResponseConditions']['output']>;
  context?: Maybe<HandlerResponseContext>;
  data?: Maybe<Scalars['JSON']['output']>;
  displays?: Maybe<Array<Maybe<BaseDisplay>>>;
  /** The name of the intent that the response is linked to. */
  intent: Scalars['String']['output'];
  /**
   * Name of the response
   *
   * Used to help differentiate multiple responses.
   */
  name?: Maybe<Scalars['String']['output']>;
  /** What the assistant will say first as part of the response. */
  outputSpeech?: Maybe<ResponseOutput>;
  /**
   * If provided, the output speech was most likely a question and requires a response from the user.
   * The reprompt is given if the user doesn't say anything or the assistant can't recognize the response.
   */
  reprompt?: Maybe<ResponseOutput>;
  segments?: Maybe<Array<Maybe<HandlerResponseSegmentItem>>>;
  /** System responses to perform account links, control media, surface changes, and permission requests. */
  system?: Maybe<HandlerResponseSystem>;
  systemCondition?: Maybe<SystemConditionType>;
  /**
   * Used for tracking the response in third party analytics.
   *
   * @deprecated(reason: Tags can be arrays now. Use tags instead.  This one will only return the top tag if it's an array.)
   */
  tag?: Maybe<Scalars['String']['output']>;
  /** Used for tracking the response in third party analytics. */
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type SystemDependentHistoricalHandlerPath = BaseHandlerPath & {
  actions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Conditions to be met. */
  conditions?: Maybe<Scalars['PathConditions']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  /**
   * The number of handlers to go back into the history of.
   *
   * This is typically just one and can be no more than 10.
   */
  historicalIndex: Scalars['Int']['output'];
  /**
   * Optional platform filter for the path.
   *
   * If set, the path will only apply to the specified platform.
   */
  platform?: Maybe<Scalars['String']['output']>;
  /**
   * Optional, if redirecting or forwarding to a handler that is expecting slots,
   * set these to pre-populate them on the request.
   */
  slots?: Maybe<Scalars['JSON']['output']>;
  systemCondition?: Maybe<SystemConditionType>;
};

export type SystemDependentPreviousHandlerPath = BaseHandlerPath & {
  actions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Conditions to be met. */
  conditions?: Maybe<Scalars['PathConditions']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  /**
   * Optional platform filter for the path.
   *
   * If set, the path will only apply to the specified platform.
   */
  platform?: Maybe<Scalars['String']['output']>;
  /** Set to true to request the previous handler paths. */
  previousHandler: Scalars['Boolean']['output'];
  systemCondition?: Maybe<SystemConditionType>;
};

export type SystemNotification = BaseSystemNotification & {
  /** A time when the notification was received */
  created: Scalars['DateTime']['output'];
  /** A unique identifier for the notification */
  id: Scalars['ID']['output'];
  /** The custom level that the notification should be at. */
  level: SystemNotificationLevel;
  /** A details description of the notification */
  message: Scalars['String']['output'];
  /**
   * Meta data that is associated with the system notification.
   *
   * The meta data returned is dependent on the type of notification.
   */
  meta?: Maybe<Scalars['JSON']['output']>;
  /** A title or name of the notification */
  name: Scalars['String']['output'];
};

export enum SystemNotificationLevel {
  Error = 'ERROR',
  Info = 'INFO',
  Warn = 'WARN'
}

export type TaskResult = {
  completed: Scalars['Boolean']['output'];
};

/** Keyword/term aggregation from content */
export type TermBucket = {
  /** Frequency of this term */
  count: Scalars['Int']['output'];
  /** Relevance score */
  score?: Maybe<Scalars['Float']['output']>;
  /** The term/keyword */
  term: Scalars['String']['output'];
};

export type TestConfig = {
  /**
   * The duration after a test executes that the runner should wait.
   *
   * Note: The test runner runs batches of tests in parallel. This will
   * slow down execution of the current batch but some tests will
   * still execute while this one is waiting.
   */
  delayAfter?: Maybe<Scalars['Int']['output']>;
  /**
   * The duration before a test executes that the runner should wait.
   *
   * Note: The test runner runs batches of tests in parallel. This will
   * slow down execution of the current batch but some tests will
   * still execute while this one is waiting.
   */
  delayBefore?: Maybe<Scalars['Int']['output']>;
};

export type TestFailureReason = {
  /** A more detailed description of the failure. */
  details: Scalars['String']['output'];
  /** The reason the test failed. */
  reason: Scalars['String']['output'];
};

export type TestHistory = {
  /** The time that the test was executed. Format: ISO 8601 */
  executed: Scalars['String']['output'];
  /** The result of the test during this execution. */
  results: TestPlatformResultByPlatform;
};

/** The various platforms that are currently supported for testing. */
export enum TestPlatform {
  /** Platform for Amazon's Alexa device. */
  Alexa = 'ALEXA',
  /** Platform for Google's Home device (which uses Dialogflow as its backend). */
  Dialogflow = 'DIALOGFLOW'
}

export type TestPlatformResult = {
  /** The reasons that a test failed or was not executed. */
  failureReasons?: Maybe<Array<Maybe<TestFailureReason>>>;
  /** The overall result of the test. */
  result: TestResult;
};

export type TestPlatformResultByPlatform = {
  /** The result for a test that was run on Alexa environment */
  alexa: TestPlatformResult;
  /** The result for a test that was run on Dialogflow environment */
  dialogflow: TestPlatformResult;
};

export enum TestResult {
  /** The result of a test that did not meet expectations. */
  Fail = 'FAIL',
  /** The result of a test that did not execute for various reasons.  It does not necessarily indicate a failure. */
  NotRun = 'NOT_RUN',
  /** The result of a test that met expectations. */
  Pass = 'PASS'
}

/** The state that the test is currently in. */
export type TestState = {
  /** The last time that the test was executed. Format: ISO 8601. */
  executionStart: Scalars['String']['output'];
  /** The time that the ended. Format: ISO 8601 */
  executionStop?: Maybe<Scalars['String']['output']>;
  /** The current state of the test. */
  state: CurrentTestState;
};

/** Opportunity alert that sends the message to the user via text message. */
export type TextOpportunityAlert = BaseOpportunityAlert & {
  alerts: Array<OpportunityAlertDetail>;
  /**
   * Did the user consent to receiving messages.
   *
   * Keeping track of this for compliance purposes.
   */
  consented: Scalars['Boolean']['output'];
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Phone number of the user to receive the alert.
   *
   * It is assumed that this number belongs to a mobile device with web browsing capabilities.
   */
  phoneNumber: Scalars['String']['output'];
  placeId?: Maybe<Scalars['String']['output']>;
};

export type TextOpportunityAlertInput = {
  /** Registered alerts */
  alerts: Array<OpportunityAlertDetailInput>;
  /**
   * Did the user consent to receiving messages.
   *
   * Keeping track of this for compliance purposes.
   */
  consented: Scalars['Boolean']['input'];
  /** Temporarily disable the alert */
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Phone number of the user to receive the alert.
   *
   * It is assumed that this number belongs to a mobile device with web browsing capabilities.
   */
  phoneNumber: Scalars['String']['input'];
  /** The Google PlaceID for the location */
  placeId?: InputMaybe<Scalars['String']['input']>;
};

/** Information needed to publish to specific platforms. */
export type ThirdPartyDeployments = {
  alexa?: Maybe<AlexaIntegration>;
  dialogflow?: Maybe<DialogflowIntegration>;
};

/** Information needed to publish to specific platforms. */
export type ThirdPartyDeploymentsInput = {
  alexa?: InputMaybe<AlexaIntegrationInput>;
  dialogflow?: InputMaybe<DialogflowIntegrationInput>;
};

/** Time-based aggregation bucket for data over time */
export type TimeBucket = {
  /** Number of items in this time bucket */
  count: Scalars['Int']['output'];
  /** Percentage of total items */
  percentage?: Maybe<Scalars['Float']['output']>;
  /** The timestamp for this bucket (ISO 8601) */
  timestamp: Scalars['DateTime']['output'];
};

/** Time interval for aggregating data */
export enum TimeInterval {
  Day = 'DAY',
  Hour = 'HOUR',
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type Tokens = {
  dep: Scalars['String']['output'];
  end: Scalars['Int']['output'];
  head: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  pos: Scalars['String']['output'];
  start: Scalars['Int']['output'];
  tag: Scalars['String']['output'];
};

export type TotalEvents = {
  /** The events that are returned in the current query. */
  events?: Maybe<Array<Maybe<Events>>>;
  /** Statistics on the number of flags in a given query */
  flagTotals: FlagTotals;
  /** The total number of events that fit the last query. */
  total: Scalars['Int']['output'];
};

export type TotalQueryAppTests = {
  /** The tests that were found in this query. */
  tests?: Maybe<Array<Maybe<AppTest>>>;
  /** The total number of app tests that fit the last query. */
  total: Scalars['Int']['output'];
};

export type TotalUsageEvents = {
  /** The total number of events available */
  total: Scalars['Int']['output'];
  /** The usage events retrieved in this query. */
  usageEvents?: Maybe<Array<Maybe<UsageEvents>>>;
};

export type TotalWebContent = {
  /** The content that was downloaded for the app */
  content: Array<Maybe<WebContentWithHighlights>>;
  /** The total number of web content found. */
  total: Scalars['Int']['output'];
};

export type TotalWebContentErrors = {
  /** Any errors that may have happened during content attempts */
  errors: Array<Maybe<WebContentErrors>>;
  /** The total number of web content found. */
  total: Scalars['Int']['output'];
};

export type TotalWebContentSources = {
  /** Stats for the last generated web crawl. Will be undefined if there was no crawl yet. */
  lastCrawl?: Maybe<TotalWebContentSourcesLastCrawl>;
  /** The crawl sources that downloaded the content */
  sources: Array<Maybe<WebContentSources>>;
  /** The total number of web content found. */
  total: Scalars['Int']['output'];
};

export type TotalWebContentSourcesLastCrawl = {
  documents: Array<Maybe<WebContent>>;
  ended: Scalars['DateTime']['output'];
  errors: Array<Maybe<WebContentErrors>>;
  started: Scalars['DateTime']['output'];
};

export type TotalWebFaq = {
  faq: Array<Maybe<WebFaq>>;
  /** The total number of web content found. */
  total: Scalars['Int']['output'];
};

export type TrialTierPaymentAccount = BaseStudioTierPaymentAccount & {
  /** The duration that the trial will last. */
  durationMs: Scalars['Long']['output'];
  /** The end date that the trial will end */
  endDate: Scalars['DateTime']['output'];
  /** The time that the trial started. */
  startDate: Scalars['DateTime']['output'];
  tier: StudioTierType;
};

export type TrustedFormConfig = {
  /** The TrustedForm script URL from the customer's ActiveProspect account */
  scriptUrl: Scalars['String']['output'];
};

export type TrustedFormConfigInput = {
  scriptUrl: Scalars['String']['input'];
};

/** A currently unsupported opportunity alert. */
export type UnknownOpportunityAlert = BaseOpportunityAlert & {
  alerts: Array<OpportunityAlertDetail>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
};

export type UpcomingInvoice = {
  amountDue: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  date: Scalars['String']['output'];
};

/** Input for updating an alert subscription */
export type UpdateAlertSubscriptionInput = {
  /** App IDs to subscribe to */
  appIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Whether this subscription is enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional filters to limit which alerts are received */
  filters?: InputMaybe<UserNotificationFiltersInput>;
};

export type UpdateAppChannelMutation = {
  deleteScheduledEvent: Scalars['String']['output'];
  scheduleWebCrawl: WebCrawlSchedule;
  /** @deprecated Use scheduleWebCrawl instead */
  scheduleWeeklyWebCrawls: WebCrawlSchedule;
  syncFAQToKendra: SyncFaqToKendraReturn;
};


export type UpdateAppChannelMutationDeleteScheduledEventArgs = {
  scheduleId: Scalars['ID']['input'];
};


export type UpdateAppChannelMutationScheduleWebCrawlArgs = {
  input: ScheduleWebCrawlInput;
};


export type UpdateAppChannelMutationScheduleWeeklyWebCrawlsArgs = {
  daysOfWeek: Array<InputMaybe<SchedulerDaysOfWeek>>;
  stealth?: InputMaybe<Scalars['Boolean']['input']>;
  webUrl: Scalars['URL']['input'];
  webUrlPatterns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateAppInput = {
  /** The type of the account linking. This tells us how to redeem the token for PII. */
  accountLinkType?: InputMaybe<Scalars['String']['input']>;
  /** The unique ID of the google action that the app is linked to. */
  actionsOnGoogleId?: InputMaybe<Scalars['String']['input']>;
  /** The category that the app will fall in to when published to Alexa. */
  alexaCategory?: InputMaybe<Scalars['String']['input']>;
  /** The unique ID of the alexa skill that the app is linked to. */
  alexaSkillId?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier of the app in Stentor. This attribute will not be updated on an update request. */
  appId?: InputMaybe<Scalars['ID']['input']>;
  /** Settings for the availability of the CRM service. */
  availability?: InputMaybe<CrmServiceAvailabilitySettingsInput>;
  /**
   * URL of the original banner image with aspect ratio of 16:9 and minimum dimensions of 1920x1080.
   *
   * Required by Actions on Google
   */
  banner?: InputMaybe<Scalars['String']['input']>;
  beta?: InputMaybe<Scalars['JSON']['input']>;
  /**
   * A description of the business and it's services.
   *
   * This can be used for LLM operations
   */
  businessDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * A description of what they consider to be high value leads, prioritized queries that they
   * want to be notified immediately.
   *
   * This can be used for LLM operations
   */
  businessHighValueLeadDescription?: InputMaybe<Scalars['String']['input']>;
  /** The hours in which the business related to the app is open. */
  businessHours?: InputMaybe<Array<BusinessHoursInput>>;
  /** User-curated business types for this app. */
  businessTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * The description for the app.
   *
   * The description cannot be more than 4000 characters.
   */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Example phrases the help users know how to use the app.
   *
   * At least three are required for publication.
   */
  examplePhrases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**
   * URL to the original icon file before transformation.
   *
   * Aspect ration must be 1:1 and minimum dimensions are 512x512.
   */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Allows stentor_admins to view and add notes to apps for internal use. */
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  /** The phrase a user must speak to wake the app up on a specific platform. */
  invocationName?: InputMaybe<Scalars['String']['input']>;
  /** Allows app-specific overriding of IPRights. */
  ipRights?: InputMaybe<IpRightsInput>;
  /**
   * Keywords to help when searching directories for the app
   *
   * Max of 30 keywords are allowed.
   */
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**
   * Banner that is 1920x1080.
   *
   * Required by Actions on Google
   */
  largeBanner?: InputMaybe<Scalars['String']['input']>;
  /**
   * A large icon for the app, 512x512 PNG
   *
   * Required for Alexa
   */
  largeIcon?: InputMaybe<Scalars['String']['input']>;
  /** Email routing configuration for leads. */
  leadEmailRoutes?: InputMaybe<Array<LeadEmailRouteInput>>;
  /** The Email address to send lead captures to. */
  leadsContact?: InputMaybe<Scalars['EmailAddress']['input']>;
  /** The phone number of a leads user. */
  leadsContactPhone?: InputMaybe<Scalars['String']['input']>;
  /** Physical location associated with the app. */
  location?: InputMaybe<LocationInput>;
  /**
   * A medium icon for the app, 192x192 PNG.
   *
   * Required for Actions On Google
   */
  mediumIcon?: InputMaybe<Scalars['String']['input']>;
  /** The human-readable name of the app. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the organization that the app is linked to. This attribute will not be updated on an update request. */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** Google PlaceIds that correspond with the business. */
  places?: InputMaybe<Array<AppPlaceDescriptionInput>>;
  /**
   * Platform specific data for the app that does not correspond
   * with other high level data that is shared.
   */
  platformData?: InputMaybe<PlatformDataInput>;
  /** URL to the privacy policy for the app. */
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  /** A referenceId is an ID of the app in a different service outside this API */
  referenceId?: InputMaybe<AppReferenceIdInput>;
  /**
   * A referenceId is an ID of the app in a different service outside this API
   *
   * @deprecated Use referenceId instead (typo fix)
   */
  refernceId?: InputMaybe<AppReferenceIdInput>;
  /**
   * A small icon for the app, 108x108 PNG
   *
   * Required for Alexa
   */
  smallIcon?: InputMaybe<Scalars['String']['input']>;
  /** The product that is linked to the subscription to this app in Stripe. */
  stripeProductId?: InputMaybe<Scalars['String']['input']>;
  /** The subscription ID that is linked to this app in Stripe. */
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  /** The payment status in Stripe. */
  subscriptionPaymentStatus?: InputMaybe<Scalars['String']['input']>;
  /**
   * The summary of the app.
   *
   * Shorter than the description, maximum 160 characters.
   */
  summary?: InputMaybe<Scalars['String']['input']>;
  /** Type of template the app and its intents adhere to. */
  templateType?: InputMaybe<Scalars['String']['input']>;
  /** URL to the terms of use for the app */
  termsOfUseUrl?: InputMaybe<Scalars['String']['input']>;
  /** Instructions for platform testers on how to test the app. */
  testingInstructions?: InputMaybe<Scalars['String']['input']>;
  /** Contains fields related to publishing the app to various platforms such as dialogflow or alexa. */
  thirdPartyDeployments?: InputMaybe<ThirdPartyDeploymentsInput>;
  /** Primary website for the company or division of a company that the app is representing. */
  website?: InputMaybe<Scalars['URLString']['input']>;
  /** Data related to what was found on the customers website */
  websiteData?: InputMaybe<AppWebsiteDataInput>;
};

export type UpdateAppMutation = {
  /**
   * Takes a document at a given URL and uploads it to the backed knowledgebase.
   *
   * Supported file formats include:
   * - PDF (application/pdf)
   * - Word Documents (.doc, .docx)
   * - Excel Spreadsheets (.xls, .xlsx)
   * - PowerPoint Presentations (.ppt, .pptx)
   * - HTML, XML, JSON, CSV, Markdown, RTF
   *
   * Three-step workflow for uploading files:
   * 1. Get a pre-signed upload URL using utils.uploadURL query
   * 2. Upload the file to that URL via HTTP PUT (client-side)
   * 3. Call this mutation with the uploaded file's URL to add it to the knowledgebase
   */
  addDocumentToKnowledgebase: Scalars['String']['output'];
  addEmailOpportunityAlert: App;
  addTextOpportunityAlert: App;
  /** Updates the status of the app. */
  changeStatus: App;
  /** Mutations related to the app channel */
  channel: AppChannelMutation;
  cms: CmsMutation;
  /** Deletes the app. */
  deleteApp: Scalars['String']['output'];
  deleteScheduledEvent: Scalars['String']['output'];
  /** Exports the app to a file. Returns the URL of the file to download. */
  exportApp: ExportAppMutationResponse;
  faq: FaqMutation;
  /** This method will flag all events that are equal to the event specified. */
  flagEvent: FlagEventReturn;
  /** Operations that are related to updating handlers */
  handler: HandlerMutation;
  integration: IntegrationsMutation;
  /** Operations that are related to updating intents */
  intent: IntentMutation;
  /**
   * Refreshes place data from Google Places API while preserving user-controlled fields.
   *
   * This mutation fetches fresh data from Google Places API (name, address, phone, website,
   * opening hours, etc.) and updates the place record. It explicitly preserves:
   * - adminVerified: The verification status is NOT changed
   * - bookingOptOut: The booking opt-out preference is NOT changed
   *
   * Use this to sync place data from Google Business Profile without losing verification status.
   */
  refreshPlaceFromGoogle: App;
  /**
   * Regenerates FAQ suggestions by fetching all FAQs for the app and generating suggestions from them.
   *
   * This is useful after importing an app or bulk-updating FAQs.
   *
   * Note: Limited to 10000 FAQs per request. Check the warning field in the response
   * if your app has more FAQs.
   *
   * Note: Authorization is handled by the parent UpdateAppMutation resolver (AppMutation.update),
   * which validates user access via isAllowedToWriteApp before this resolver is called.
   */
  regenerateFAQSuggestions: RegenerateFaqSuggestionsReturn;
  /**
   * Regenerates utterance suggestions for intents. If intentIds are provided, only those intents are processed.
   * Otherwise, all intents for the app are processed.
   *
   * This is useful after importing an app, as the import process does not automatically
   * trigger suggestion generation.
   *
   * Note: Authorization is handled by the parent UpdateAppMutation resolver (AppMutation.update),
   * which validates user access via isAllowedToWriteApp before this resolver is called.
   */
  regenerateUtteranceSuggestions: RegenerateUtteranceSuggestionsReturn;
  /** Clears all notifications from the app. */
  removeAllNotifications: Scalars['String']['output'];
  /** Removes a notification from the app.  Returns a list of notifications that remain. */
  removeNotification: Array<Maybe<SystemNotification>>;
  /** Reset ROI configuration to defaults (removes all custom overrides). */
  resetROIConfig: App;
  scheduleWebCrawl: WebCrawlSchedule;
  /** @deprecated Use scheduleWebCrawl instead */
  scheduleWeeklyWebCrawls: WebCrawlSchedule;
  /** Crawls a website and retrieves the FAQs found on the website. It saves the FAQs to a database, and downloads the items to S3. */
  startWebsiteCrawling: Scalars['String']['output'];
  subscriptions: AppSubscriptionMutation;
  /**
   * Suggests a job type -> availability class mapping using the app's CRM integration.
   * Persists nothing - the caller is expected to review/edit the suggestion and save it via
   * updateAvailability. Returns an empty list if the app has no CRM integration, the
   * integration doesn't support suggestions, or the suggestion times out.
   */
  suggestJobTypeClasses: Array<CrmJobTypeAvailabilityClass>;
  /**
   * Update an existing app.  Only the attributes included will be updated.
   *
   * This app can include an appId and organization for a drop-in replacement. These attributes will
   * be ignored as they are to remain constant.
   */
  updateApp: App;
  /**
   * Deep-merges the given availability settings in to the app's existing availability, rather
   * than replacing it wholesale like updateApp(app: { availability: ... }) does.
   */
  updateAvailability?: Maybe<App>;
  /**
   * Update ROI configuration for the app.
   * This sets custom cost per lead values that override the defaults.
   */
  updateROIConfig: App;
  /**
   * Initiates a document upload to the knowledgebase.
   * Returns a pre-signed URL for uploading the file.
   * After upload, the document is automatically indexed in Kendra.
   *
   * Supported file formats:
   * - PDF (application/pdf)
   * - Word Documents (.doc: application/msword, .docx: application/vnd.openxmlformats-officedocument.wordprocessingml.document)
   * - Excel Spreadsheets (.xls, .xlsx)
   * - PowerPoint Presentations (.ppt, .pptx)
   * - HTML, XML, JSON, CSV, Markdown, RTF
   *
   * Two-step workflow:
   * 1. Call this mutation to get a pre-signed upload URL
   * 2. Upload the file to uploadUrl via HTTP PUT (client-side)
   * The document will be automatically indexed in Kendra after upload.
   */
  uploadDocumentToKnowledgebase: UploadDocumentResult;
};


export type UpdateAppMutationAddDocumentToKnowledgebaseArgs = {
  locationId?: InputMaybe<Scalars['String']['input']>;
  makePublic?: InputMaybe<Scalars['Boolean']['input']>;
  url: Scalars['URL']['input'];
};


export type UpdateAppMutationAddEmailOpportunityAlertArgs = {
  alert: EmailOpportunityAlertInput;
};


export type UpdateAppMutationAddTextOpportunityAlertArgs = {
  alert: TextOpportunityAlertInput;
};


export type UpdateAppMutationChangeStatusArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};


export type UpdateAppMutationDeleteScheduledEventArgs = {
  scheduleId: Scalars['ID']['input'];
};


export type UpdateAppMutationFlagEventArgs = {
  eventId: Scalars['ID']['input'];
  flag: NewRawQueryFlag;
  note?: InputMaybe<Scalars['String']['input']>;
};


export type UpdateAppMutationRefreshPlaceFromGoogleArgs = {
  placeId: Scalars['ID']['input'];
};


export type UpdateAppMutationRegenerateUtteranceSuggestionsArgs = {
  intentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type UpdateAppMutationRemoveNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type UpdateAppMutationScheduleWebCrawlArgs = {
  input: ScheduleWebCrawlInput;
};


export type UpdateAppMutationScheduleWeeklyWebCrawlsArgs = {
  daysOfWeek: Array<InputMaybe<SchedulerDaysOfWeek>>;
  webUrl: Scalars['URL']['input'];
  webUrlPatterns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UpdateAppMutationStartWebsiteCrawlingArgs = {
  channelId: Scalars['String']['input'];
  documentTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includeDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  kendra?: InputMaybe<WebCrawlKendraInput>;
  s3RegionalDomain?: InputMaybe<Scalars['String']['input']>;
  settlingTimeSeconds?: InputMaybe<Scalars['settlingTimeSeconds_Int_max_5_exclusiveMin_0']['input']>;
  stealth?: InputMaybe<Scalars['Boolean']['input']>;
  webUrl: Scalars['URL']['input'];
  webUrlPatterns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UpdateAppMutationSuggestJobTypeClassesArgs = {
  availabilityClasses?: InputMaybe<Array<CrmAvailabilityClassInput>>;
};


export type UpdateAppMutationUpdateAppArgs = {
  app: UpdateAppInput;
};


export type UpdateAppMutationUpdateAvailabilityArgs = {
  availability: CrmServiceAvailabilitySettingsInput;
};


export type UpdateAppMutationUpdateRoiConfigArgs = {
  config: RoiConfigInput;
};


export type UpdateAppMutationUploadDocumentToKnowledgebaseArgs = {
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  makePublic?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAppSubscriptionMutation = {
  cancel: App;
  uncancel: App;
};

export type UpdateCampaignInput = {
  /** The attribution label stamped onto bookings made through this campaign. */
  canonicalSource?: InputMaybe<Scalars['String']['input']>;
  /** When the campaign offer stops being valid. */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Pins every booking through this campaign to a single job type. */
  jobTypePin?: InputMaybe<Scalars['String']['input']>;
  /** The display name of the campaign. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The fine print / terms of the offer. */
  offerTerms?: InputMaybe<Scalars['String']['input']>;
  /** The offer's headline. */
  offerTitle?: InputMaybe<Scalars['String']['input']>;
  /** When the campaign offer starts being valid. */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The lifecycle status of the campaign. */
  status?: InputMaybe<CampaignStatus>;
};

export type UpdateEntityInput = {
  dialogflowId?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  /**
   * A unique identifier for the entity.  If one is not provided then
   * it will be derived from the display name.
   */
  entityId?: InputMaybe<Scalars['ID']['input']>;
  /** Whether or not to exclude the entity from autocomplete suggestions. */
  excludeFromSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
  nlu?: InputMaybe<Scalars['EntityNLU']['input']>;
  type?: InputMaybe<EntityType>;
  values?: InputMaybe<Array<EntityValueInput>>;
};

export type UpdateFaq = {
  /** The answer for the questions. */
  answer?: InputMaybe<Scalars['String']['input']>;
  /** An ID to a Handler that is associated with the FAQ */
  associatedHandlerId?: InputMaybe<Scalars['ID']['input']>;
  /** Set to true if the FAQ should be excluded from the auto-complete search. */
  excludeFromAutoComplete?: InputMaybe<Scalars['Boolean']['input']>;
  /** An ID linked to an external system in which the FAQ was derived from. */
  externalFAQId?: InputMaybe<Scalars['ID']['input']>;
  /** Questions associated with the FAQ */
  questions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The raw text */
  raw?: InputMaybe<Scalars['String']['input']>;
  responses?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** The URL where the FAQ can be found. */
  url?: InputMaybe<Scalars['URL']['input']>;
};

export type UpdateFaqMutation = {
  /** Permanently deletes the FAQ. */
  deleteFAQ: Scalars['String']['output'];
  /** Update attributes of the particular FAQ */
  updateFAQ: WebFaq;
};


export type UpdateFaqMutationUpdateFaqArgs = {
  faq: UpdateFaq;
  resolution?: InputMaybe<EventResolutionInput>;
};

export type UpdateHandlerInput = {
  /**
   * Base content map for the handler.
   *
   * All handlers have contextual help and cancel content
   */
  content?: InputMaybe<Array<InputMaybe<InputHandlerContent>>>;
  /**
   * Contexts the must be active to have this handler be weighted more heavily or selected.
   *
   * For Amazon Lex, the contexts are required to be selected.
   *
   * https://docs.aws.amazon.com/lex/latest/dg/API_PutIntent.html#lex-PutIntent-request-inputContexts
   *
   * For Dialogflow ES, these are more heavily weighted towards matching.
   *
   * https://cloud.google.com/dialogflow/es/docs/contexts-input-output#input_contexts}
   * https://cloud.google.com/dialogflow/es/docs/reference/rest/v2/projects.agent.intents#Intent}
   */
  contexts?: InputMaybe<Array<InputMaybe<IntentContextInput>>>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  /**
   * The locale that all the attributes in this intent are used for before
   * they are overridden.
   */
  defaultLocale?: InputMaybe<Scalars['String']['input']>;
  forward?: InputMaybe<Array<InputMaybe<HandlerForwardInput>>>;
  /** The location that the intent was last saved in Stentor's Handler Graph UI. */
  graphCoords?: InputMaybe<GraphCoordsInput>;
  /** The language code that the intent covers. */
  langCode?: InputMaybe<Scalars['String']['input']>;
  /** The human-readable name of the intent. */
  name: Scalars['String']['input'];
  /** The permissions that the intent requires in order to work. */
  permissions?: InputMaybe<Array<InputMaybe<HandlerPermissions>>>;
  redirect?: InputMaybe<Array<InputMaybe<HandlerRedirectInput>>>;
  /** The slots defined within the utterance patterns and their Entity types. */
  slots?: InputMaybe<Array<InputMaybe<InputSlot>>>;
  /** The type of intent that this is. */
  type?: InputMaybe<Scalars['String']['input']>;
  /**
   * An array of utterance patterns.
   *
   * For more information on syntax see https://github.com/alexa-js/alexa-utterances
   */
  utterancePatterns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateHandlerMutationType = {
  addForward: AddForwardReturn;
  /** Changes an intent to a handler. */
  changeIntentToHandler: Handler;
  /**
   * Removes an handler.
   *
   * This will also remove all the references to the handler in other handlers (i.e. in the forward and content attributes).
   *
   * Returns the keys for the handlers which were updated during the deletion process.
   *
   * These can be retrieved by the client to keep an updated record.
   */
  delete: DeleteHandlerReturn;
  /** Operations related to form A/B testing experiments */
  formExperiment: FormExperimentMutation;
  /**
   * Updates an handler with the given attributes,
   *
   * The updated handler is returned.
   */
  update: UpdateHandlerReturn;
};


export type UpdateHandlerMutationTypeAddForwardArgs = {
  forward: ForwardInput;
  key: Scalars['ID']['input'];
};


export type UpdateHandlerMutationTypeChangeIntentToHandlerArgs = {
  handlerProps: IntentToHandlerPropsInput;
};


export type UpdateHandlerMutationTypeUpdateArgs = {
  handler: UpdateHandlerInput;
};

export type UpdateHandlerReturn = {
  /** The updated graph. */
  graph: IntentsGraph;
  /** The handler that was updated with the new attributes. */
  handler: Handler;
};


export type UpdateHandlerReturnGraphArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateIntentInput = {
  /**
   * Contexts the must be active to have this intent be weighted more heavily or selected.
   *
   * For Amazon Lex, the contexts are required to be selected.
   *
   * https://docs.aws.amazon.com/lex/latest/dg/API_PutIntent.html#lex-PutIntent-request-inputContexts
   *
   * For Dialogflow ES, these are more heavily weighted towards matching.
   *
   * https://cloud.google.com/dialogflow/es/docs/contexts-input-output#input_contexts}
   * https://cloud.google.com/dialogflow/es/docs/reference/rest/v2/projects.agent.intents#Intent}
   */
  contexts?: InputMaybe<Array<InputMaybe<IntentContextInput>>>;
  /**
   * The locale that all the attributes in this intent are used for before
   * they are overridden.
   */
  defaultLocale?: InputMaybe<Scalars['String']['input']>;
  /** deprecated: No longer used. */
  dialogflowId?: InputMaybe<Scalars['String']['input']>;
  /** The location that the intent was last saved in Stentor's Handler Graph UI. */
  graphCoords?: InputMaybe<GraphCoordsInput>;
  /** The language code that the intent covers. */
  langCode?: InputMaybe<Scalars['String']['input']>;
  /** The name of the intent */
  name?: InputMaybe<Scalars['String']['input']>;
  nlu?: InputMaybe<Scalars['JSON']['input']>;
  /** The permissions that the intent requires in order to work. */
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Slot type definition. */
  slotTypes?: InputMaybe<Scalars['JSON']['input']>;
  /**
   * The slots defined within the utterance patterns and their Entity types.
   *
   * This will replace the slots that are current in the intent.  Use
   * "addSlot" or "updateSlot" to update slots within an intent.
   */
  slots?: InputMaybe<Array<InputMaybe<InputSlot>>>;
  /** The type of intent that this is. */
  type?: InputMaybe<Scalars['String']['input']>;
  /**
   * An array of utterance patterns.
   *
   * For more information on syntax see https://github.com/alexa-js/alexa-utterances
   */
  utterancePatterns?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateIntentMutationType = {
  /** Changes a handler to an intent. */
  changeHandlerToIntent: Intent;
  delete: DeleteIntentReturn;
  update: UpdateIntentReturn;
};


export type UpdateIntentMutationTypeUpdateArgs = {
  intent: UpdateIntentInput;
};

export type UpdateIntentReturn = {
  /** The updated graph. */
  graph: IntentsGraph;
  /** The intent that was updated with the new attributes. */
  intent: Intent;
};


export type UpdateIntentReturnGraphArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateOrganizationInput = {
  /** The email XAPPineer that is in charge of handling the organization's account */
  XAPPLead?: InputMaybe<Scalars['String']['input']>;
  /** An event bus that is attatched to the organization to receive specific events related to the organization such as App status changes. */
  awsEventBusArn?: InputMaybe<Scalars['String']['input']>;
  /** An object of feature flags */
  beta?: InputMaybe<Scalars['JSON']['input']>;
  billingContact?: InputMaybe<BillingContactInput>;
  brandContact?: InputMaybe<BrandContactInput>;
  /**
   * The email address of a user who can be contacted about issues
   * related to the organization.
   */
  contact?: InputMaybe<Scalars['String']['input']>;
  /** The organization contact's name. */
  contactName?: InputMaybe<Scalars['String']['input']>;
  /** The organization contact's phone number. */
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  /**
   * Date in which the organization signed a contract to publish
   * apps.
   *
   * Format: ISO-8601 date format
   */
  contractDate?: InputMaybe<Scalars['String']['input']>;
  /** The human-readable description of the organization. */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Organization's IP rights which were loaded that give permissions to
   * publish apps on their behalf.
   */
  ipRights?: InputMaybe<IPrightsInput>;
  /** URL for the organization's logo. */
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** The human-readable name of the organization. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Any notes that are related to the organization. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Partner branding configuration for customizing email appearance */
  partnerBranding?: InputMaybe<PartnerBrandingInput>;
  /** Payment account information */
  paymentAccounts?: InputMaybe<PaymentAccountsInput>;
  /**
   * Third party publishing account information such as Amazon SMAPI's
   * service or Google's Dialogflow.
   */
  publishingAccounts?: InputMaybe<PublishingAccountsInput>;
  /** A URL to the organization's website. */
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a summary subscription */
export type UpdateSummarySubscriptionInput = {
  /** App IDs to include in the summary */
  appIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Whether this subscription is enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** How often the summary should be sent */
  frequency?: InputMaybe<SummaryFrequency>;
  /** How to group multiple apps */
  grouping?: InputMaybe<ReportGrouping>;
};

export type UploadDocumentResult = {
  /** The document ID that will be created in Kendra after upload */
  documentId: Scalars['String']['output'];
  /** The S3 key where the file will be stored */
  s3Key: Scalars['String']['output'];
  /** Pre-signed URL where the client should upload the file via PUT request */
  uploadUrl: Scalars['URL']['output'];
};

export type UploadFaqReturn = {
  faqsAdded: Scalars['Int']['output'];
};

export type UploadUrlResult = {
  /**
   * The URL that files can be uploaded to.
   *
   * Pass this URL to other endpoints once the file has been uploaded to use it.
   */
  url: Scalars['URL']['output'];
};

export type UploadedLexApp = {
  app?: Maybe<App>;
  entities?: Maybe<Array<Maybe<Entity>>>;
  handlers?: Maybe<Array<Maybe<Handler>>>;
  intents?: Maybe<Array<Maybe<Intent>>>;
};

export type Url = {
  /** The actual URL that serves the app. */
  url: Scalars['String']['output'];
};

export type UrlInput = {
  /** The actual URL that serves the app. */
  url: Scalars['String']['input'];
};

/** Events that have occurred in the platform. */
export type UsageEvents = {
  /** The appId of the app that the event is related to if applicable. */
  appId?: Maybe<Scalars['ID']['output']>;
  /** The channelId of the channel that the event is related to if applicable */
  channelId?: Maybe<Scalars['ID']['output']>;
  /** A detailed description of the event. */
  description: Scalars['String']['output'];
  /** The time and date in which the event occurred. */
  eventTime: Scalars['DateTime']['output'];
  /** A human-readable name for the event. */
  name: Scalars['String']['output'];
  /** The organizationId of the organization that the event is related to if applicable. */
  organizationId?: Maybe<Scalars['ID']['output']>;
  /** Any payload that is connected to the event. */
  payload?: Maybe<Scalars['JSON']['output']>;
  /** The permission level of users who can see the event. */
  permissionLevel?: Maybe<Scalars['String']['output']>;
  /** The type of event that it is */
  type: Scalars['String']['output'];
  /** The email of the user which caused the event if applicable */
  userEmail?: Maybe<Scalars['String']['output']>;
  /** The userId of the user which caused the event if applicable. */
  userId?: Maybe<Scalars['ID']['output']>;
};

export type UsageStat = {
  interval: AppUsageInterval;
  /** The ISO formatted date that the stats covers. */
  isoDate: Scalars['String']['output'];
  newUsers: Scalars['Int']['output'];
  returningUsers: Scalars['Int']['output'];
  totalSessions: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
};

export type UsageStatCsvReturn = {
  /** The CSV formatted data */
  csv: Scalars['String']['output'];
  /** The file location of the CSV data */
  file: Scalars['URL']['output'];
};

export type UserEntitlements = {
  /** Specifies the number of pro tier entitlements that the user has available */
  availablePro: Scalars['Int']['output'];
  /** Specifies the number of standard tier entitlements that the user has available */
  availableStandard: Scalars['Int']['output'];
  /** Specifies the number of trial tier entitlements that the user has available */
  availableTrial: Scalars['Int']['output'];
  /** Specifies the number of pro tier entitlements the user currently has */
  pro: Scalars['Int']['output'];
  /** Specifies the number of standard tier entitlements the user currently has */
  standard: Scalars['Int']['output'];
  /** Specifies the number of trial tier entitlements the user currently has */
  trial: Scalars['Int']['output'];
};

/**
 * Filter conditions for alert subscriptions.
 * All specified filters must match (AND logic).
 */
export type UserNotificationFilters = {
  /** Contact type filter - matches if lead's contactType is in this array */
  contactType?: Maybe<Array<Scalars['String']['output']>>;
  /** High-value lead filter - matches if lead's highValueLead equals this value */
  highValueLead?: Maybe<Scalars['Boolean']['output']>;
  /** Job type filter - matches if lead's jobType is in this array */
  jobType?: Maybe<Array<Scalars['String']['output']>>;
  /** Service type filter - matches if lead's serviceType is in this array */
  serviceType?: Maybe<Array<Scalars['String']['output']>>;
  /** Urgency filter - matches if lead's urgency is in this array */
  urgency?: Maybe<Array<Scalars['String']['output']>>;
};

/** Input for filter conditions */
export type UserNotificationFiltersInput = {
  contactType?: InputMaybe<Array<Scalars['String']['input']>>;
  highValueLead?: InputMaybe<Scalars['Boolean']['input']>;
  jobType?: InputMaybe<Array<Scalars['String']['input']>>;
  serviceType?: InputMaybe<Array<Scalars['String']['input']>>;
  urgency?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** User's notification preferences */
export type UserNotificationPreferences = {
  /** Real-time alert subscriptions */
  alertSubscriptions: Array<AlertSubscription>;
  /** When this record was created */
  createdAt: Scalars['String']['output'];
  /** User's email address */
  email: Scalars['String']['output'];
  /** User's phone number (for SMS notifications) */
  phone?: Maybe<Scalars['String']['output']>;
  /** Summary/digest subscriptions */
  summarySubscriptions: Array<SummarySubscription>;
  /** When this record was last updated */
  updatedAt: Scalars['String']['output'];
  /** User ID */
  userId: Scalars['ID']['output'];
};

/** The User Profile of a Stentor User */
export type UserProfile = {
  _id: Scalars['ID']['output'];
  /** Email address of the user */
  email: Scalars['String']['output'];
  /** Determines whether or not the user's email address has been verified. */
  emailVerified: Scalars['Boolean']['output'];
  /**
   * Requests the number of entitlements or subscriptions that the user
   * has available.
   */
  entitlements?: Maybe<UserEntitlements>;
  /**
   * The first name for the user
   *
   * This is an optional parameter. It may not exist.
   */
  firstName?: Maybe<Scalars['String']['output']>;
  /**
   * The full name of the user that includes first, middle, and last name.
   *
   * This is an optional parameter. It may not exist.
   */
  fullName?: Maybe<Scalars['String']['output']>;
  /** Icon URL to the profile picture. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Identities of linked accounts. */
  identities: Array<Maybe<UserProfileIdentity>>;
  /** Determines whether or not the user is an admin of Stentor */
  isAdmin: Scalars['Boolean']['output'];
  /**
   * The last name for the user.
   *
   * This is an optional parameter. It may not exist.
   */
  lastName?: Maybe<Scalars['String']['output']>;
  /**
   * The middle name for the user
   *
   * This is an optional parameter. It may not exist.
   */
  middleName?: Maybe<Scalars['String']['output']>;
  /** The authentication origin */
  origin: AuthOrigin;
  /** The user permissions that the user is allowed to perform in Stentor. */
  roles: Array<Maybe<UserProfileRole>>;
  /** User ID of the user in the system */
  userId: Scalars['String']['output'];
};

export type UserProfileIdentity = {
  provider: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type UserProfileRole = {
  /** The organization ID of the organization that the user has the roles applied to. */
  organizationId: Scalars['String']['output'];
  /** The user's roles that they are allowed to use on the organization. */
  roles: Array<Maybe<Scalars['String']['output']>>;
};

export type Utils = {
  /**
   * Randomly generates an external ID that can be used by third party IAM roles so
   * stentor can securely assume it.
   */
  generateExternalID: Scalars['String']['output'];
  /** Returns the result of a task */
  task: TaskResult;
  /** Retrieve a URL that files can be uploaded to. */
  uploadURL: UploadUrlResult;
};


export type UtilsTaskArgs = {
  taskId: Scalars['ID']['input'];
};


export type UtilsUploadUrlArgs = {
  contentType: Scalars['String']['input'];
};

export type UtteranceSuggestion = {
  /** The possible utterance */
  utterance: Scalars['String']['output'];
};

export type UtteranceSuggestions = {
  suggestions: Array<UtteranceSuggestion>;
};

export type UtteranceTest = {
  /** The unique identifier of the app that the test is linked to. */
  appId: Scalars['ID']['output'];
  /** The time that the test was created.  Format: ISO 8601 */
  createdOn: Scalars['String']['output'];
  /** The expected result of the utterance test. */
  expectedResult?: Maybe<ExpectedUtteranceTestResult>;
  /** A list of the test history. */
  history?: Maybe<Array<Maybe<TestHistory>>>;
  /** The platform that the test should run on.  If not present, it will run on all platforms. */
  platform?: Maybe<Scalars['String']['output']>;
  /** The state that the test is currently in. If there is no state, then the test was never executed. */
  state?: Maybe<TestState>;
  /** The unique identifier for the test. */
  testId: Scalars['ID']['output'];
  /** The type of tests that this is. */
  testType: Scalars['String']['output'];
  /** The utterance that the test is executing for. */
  utterance?: Maybe<Scalars['String']['output']>;
};

export type UtteranceTestUpdate = {
  /** Test configurations */
  config?: InputMaybe<UtteranceTestUpdateConfig>;
  /** The expected result from the NLU. */
  expectedResult?: InputMaybe<UtteranceTestUpdateExpectedResult>;
  /** The specific platform that the test is intended for. Removing the platform will perform the test on all available platforms. */
  platform?: InputMaybe<Scalars['String']['input']>;
  /** The utterance that the test should execute for. */
  utterance?: InputMaybe<Scalars['String']['input']>;
};

export type UtteranceTestUpdateConfig = {
  /** The number of seconds after a test is executed to wait before continuing. */
  delayAfter?: InputMaybe<Scalars['Int']['input']>;
  /** The number of seconds before a test is executed to wait to execute */
  delayBefore?: InputMaybe<Scalars['Int']['input']>;
};

export type UtteranceTestUpdateExpectedResult = {
  /** The intentId of the intent that is expected to be returned. */
  intentId?: InputMaybe<Scalars['String']['input']>;
  /** The slots that are expected to be returned. */
  matchedSlots?: InputMaybe<Array<InputMaybe<UtteranceTestUpdateMatchedSlot>>>;
  /** The expected request type. */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UtteranceTestUpdateMatchedSlot = {
  /** The value of the slot if it is a boolean. */
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  /** The iso 8601 value of the date value. */
  dateValue?: InputMaybe<Scalars['String']['input']>;
  /** The iso 8601 value of the end date value. */
  endDateValue?: InputMaybe<Scalars['String']['input']>;
  /** The value of a slot if it is a float. Integer values will also be included. */
  floatValue?: InputMaybe<Scalars['Float']['input']>;
  /** The value of a slot if it is an integer. */
  integerValue?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the expected slot. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The iso 8601 value of the start date value. */
  startDateValue?: InputMaybe<Scalars['String']['input']>;
  /** String values of a slot array. */
  stringArrayValue?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The value of the slot if it is a string. */
  stringValue?: InputMaybe<Scalars['String']['input']>;
};

/** Metrics for a single variant in an experiment. */
export type VariantMetrics = {
  /** Abandonment rate (abandonments / (submissions + abandonments)) */
  abandonmentRate: Scalars['Float']['output'];
  /** Number of abandoned forms */
  abandonments: Scalars['Int']['output'];
  /** Average number of steps completed before abandonment */
  averageStepsCompleted?: Maybe<Scalars['Float']['output']>;
  /** Conversion rate (submissions / impressions) */
  conversionRate: Scalars['Float']['output'];
  /** Number of form opens (impressions) */
  impressions: Scalars['Int']['output'];
  /** Step-by-step dropoff analysis */
  stepDropoff?: Maybe<Array<StepDropoff>>;
  /** Number of successful form submissions */
  submissions: Scalars['Int']['output'];
  /** Number of unique sessions */
  uniqueUsers: Scalars['Int']['output'];
  /** The variant ID */
  variantId: Scalars['ID']['output'];
  /** The variant name */
  variantName: Scalars['String']['output'];
};

export type VectorDatabaseQuery = {
  pinecone: AdminPineconeResult;
};


export type VectorDatabaseQueryPineconeArgs = {
  appId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
  topK?: InputMaybe<Scalars['Int']['input']>;
};

export type WebContent = BaseWebContent & {
  /** Unique ID for the web content */
  _id: Scalars['String']['output'];
  /** The meta description from the page */
  description?: Maybe<Scalars['String']['output']>;
  /** The domain without www prefix (e.g., 'example.com') */
  domain?: Maybe<Scalars['String']['output']>;
  /** The last time the website was updated. */
  lastUpdated: Scalars['DateTime']['output'];
  /** The name of the content (page title) */
  name: Scalars['String']['output'];
  /** The original text length before truncation */
  originalTextLength?: Maybe<Scalars['Int']['output']>;
  /** The URL path (e.g., '/about/team') */
  path?: Maybe<Scalars['String']['output']>;
  /**
   * The raw-text of the content.
   *
   * For websites, this will be the text of the website with the HTML removed.
   */
  text: Scalars['String']['output'];
  /** The type of content that was parsed. */
  type: WebContentType;
  /** The full URL of the web content */
  url: Scalars['String']['output'];
};

export type WebContentErrors = {
  /** The time at which this was thrown. */
  date: Scalars['DateTime']['output'];
  /** The details for the error. */
  detail: Scalars['String']['output'];
  /**
   * The execution ID of the scrape execution that threw the error. It's possible
   * that this does not exist.
   */
  executionId?: Maybe<Scalars['String']['output']>;
  /** The name of the error. */
  name: Scalars['String']['output'];
  /**
   * The url that was linked to the error. This could be missing depending on
   * the type of error caught (for example if the execution started without one).
   */
  url?: Maybe<Scalars['String']['output']>;
};

export type WebContentHighlight = {
  /** The text that is highlighted from the match. */
  text?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type WebContentSources = {
  /** The starting URL for the crawl */
  webUrl: Scalars['String']['output'];
  /** The patterns that were used to during the crawl */
  webUrlPatterns: Array<Maybe<Scalars['String']['output']>>;
};

export enum WebContentType {
  Website = 'WEBSITE'
}

export type WebContentWithHighlights = BaseWebContent & {
  /** Unique ID for the web content */
  _id: Scalars['String']['output'];
  /** The meta description from the page */
  description?: Maybe<Scalars['String']['output']>;
  /** The domain without www prefix (e.g., 'example.com') */
  domain?: Maybe<Scalars['String']['output']>;
  /** The highlights found in the match query. */
  highlight?: Maybe<WebContentHighlight>;
  /** The last time the website was updated. */
  lastUpdated: Scalars['DateTime']['output'];
  /** The name of the content (page title) */
  name: Scalars['String']['output'];
  /** The original text length before truncation */
  originalTextLength?: Maybe<Scalars['Int']['output']>;
  /** The URL path (e.g., '/about/team') */
  path?: Maybe<Scalars['String']['output']>;
  /**
   * The raw-text of the content.
   *
   * For websites, this will be the text of the website with the HTML removed.
   */
  text: Scalars['String']['output'];
  /** The type of content that was parsed. */
  type: WebContentType;
  /** The full URL of the web content */
  url: Scalars['String']['output'];
};

export type WebCrawlCadence = {
  /** For MONTHLY cadence: which day of the month (1-28) the crawl should run. */
  dayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  /** For WEEKLY cadence: the days of the week on which the crawl should run. */
  daysOfWeek?: InputMaybe<Array<InputMaybe<SchedulerDaysOfWeek>>>;
  /** The type of cadence (DAILY, WEEKLY, MONTHLY). */
  type: CadenceType;
};

export type WebCrawlDailySchedule = WebCrawlSchedule & {
  /** The cadence details for this schedule (when it runs). */
  cadence: Cadence;
  /** ISO timestamp of when this schedule was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The userId or "SYSTEM" that created this schedule. */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** The event that is to be performed on the schedule. */
  event: Scalars['String']['output'];
  /** The parameters that the schedule holds. */
  parameters: Scalars['JSON']['output'];
  /** The ID of the schedule. */
  scheduleId: Scalars['ID']['output'];
  /** The type of schedule that this is. ("weekly", "monthly", or "daily") */
  type: Scalars['String']['output'];
  /** ISO timestamp of when this schedule was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The userId or "SYSTEM" that last updated this schedule. */
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type WebCrawlKendraInput = {
  /**
   * The account role that is allowed to listen to Kendra if the Kendra
   * instance is on another account.
   */
  accountRole?: InputMaybe<Scalars['String']['input']>;
  /** The ARN of the kendra data source. */
  kendraDataSourceArn: Scalars['String']['input'];
};

export type WebCrawlMonthlySchedule = WebCrawlSchedule & {
  /** The cadence details for this schedule (when it runs). */
  cadence: Cadence;
  /** ISO timestamp of when this schedule was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The userId or "SYSTEM" that created this schedule. */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** The day of the month that the schedule is scheduled to run */
  dayOfMonth: Scalars['Int']['output'];
  /** The event that is to be performed on the schedule. */
  event: Scalars['String']['output'];
  /** The parameters that the schedule holds. */
  parameters: Scalars['JSON']['output'];
  /** The ID of the schedule. */
  scheduleId: Scalars['ID']['output'];
  /** The type of schedule that this is. ("weekly", "monthly", or "daily") */
  type: Scalars['String']['output'];
  /** ISO timestamp of when this schedule was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The userId or "SYSTEM" that last updated this schedule. */
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type WebCrawlSchedule = {
  /** The cadence details for this schedule (when it runs). */
  cadence: Cadence;
  /** ISO timestamp of when this schedule was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The userId or "SYSTEM" that created this schedule. */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** The event that is to be performed on the schedule. */
  event: Scalars['String']['output'];
  /** The parameters that the schedule holds. */
  parameters: Scalars['JSON']['output'];
  /** The ID of the schedule. */
  scheduleId: Scalars['ID']['output'];
  /** The type of schedule that this is. ("weekly", "monthly", or "daily") */
  type: Scalars['String']['output'];
  /** ISO timestamp of when this schedule was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The userId or "SYSTEM" that last updated this schedule. */
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type WebCrawlWeeklySchedule = WebCrawlSchedule & {
  /** The cadence details for this schedule (when it runs). */
  cadence: Cadence;
  /** ISO timestamp of when this schedule was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The userId or "SYSTEM" that created this schedule. */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** The days of the week that the crawler is scheduled for. */
  daysOfWeek: Array<Maybe<ScheduleDaysOfWeek>>;
  /** The event that is to be performed on the schedule. */
  event: Scalars['String']['output'];
  /** The parameters that the schedule holds. */
  parameters: Scalars['JSON']['output'];
  /** The ID of the schedule. */
  scheduleId: Scalars['ID']['output'];
  /** The type of schedule that this is. ("weekly", "monthly", or "daily") */
  type: Scalars['String']['output'];
  /** ISO timestamp of when this schedule was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The userId or "SYSTEM" that last updated this schedule. */
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type WebCrawlerQuery = {
  /**
   * Retrieve stats for a blacklisted website.  Returns null
   * if the website is not blacklisted.
   */
  blacklistedWebsite?: Maybe<BlacklistedWebsite>;
};


export type WebCrawlerQueryBlacklistedWebsiteArgs = {
  website: Scalars['URL']['input'];
};

export type WebCrawlerSettings = {
  addBlacklistedWebsite: Scalars['String']['output'];
  /**
   * Allows blacklist of websites with wildcards.
   *
   * Blacklisting websites including subdomains:
   * *.mainDomain.topLevelDomain
   *
   * Blacklisting websites with extension:
   * *.jpg
   */
  addBlacklistedWebsitePath: Scalars['String']['output'];
  removeBlacklistedWebsite?: Maybe<Scalars['String']['output']>;
};


export type WebCrawlerSettingsAddBlacklistedWebsiteArgs = {
  website: Scalars['URL']['input'];
};


export type WebCrawlerSettingsAddBlacklistedWebsitePathArgs = {
  website: Scalars['String']['input'];
};


export type WebCrawlerSettingsRemoveBlacklistedWebsiteArgs = {
  website: Scalars['URL']['input'];
};

export type WebDetailsExecution = {
  /** Whether or not the execution details are still being gathered. */
  completed: Scalars['Boolean']['output'];
  /** The data that has been gathered so far. */
  data: WebsiteData;
  /** The executionId of the crawl */
  excutionId: Scalars['String']['output'];
  /** The date and time that the crawl was last updated. */
  lastUpdated: Scalars['DateTime']['output'];
  /** The website that is being crawled. */
  siteCrawled: Scalars['URL']['output'];
};

export type WebFaq = {
  /** ID of the webFAQ */
  _id: Scalars['ID']['output'];
  /** The answer of the FAQ questions */
  answer: Scalars['String']['output'];
  /** An ID to a Handler that is associated with the FAQ */
  associatedHandlerId?: Maybe<Scalars['String']['output']>;
  /** The time it was created. */
  created: Scalars['String']['output'];
  /** Set to true if the FAQ should be excluded from the auto-complete search. */
  excludeFromAutoComplete?: Maybe<Scalars['Boolean']['output']>;
  /** An ID linked to an external system in which the FAQ was derived from. */
  externalFAQId?: Maybe<Scalars['ID']['output']>;
  /** Returns suggestions for further questions that answer the FAQ. */
  faqQuestionsSuggestions: FaqQuestionSuggestions;
  /** The name assigned to the question-answer page */
  name: Scalars['String']['output'];
  /** Questions that are linked to the answer */
  questions: Array<Maybe<Scalars['String']['output']>>;
  /** The raw text of the FAQ page */
  raw?: Maybe<Scalars['String']['output']>;
  responses?: Maybe<Array<Maybe<HandlerResponse>>>;
  /** The URL that the FAQ came from */
  url?: Maybe<Scalars['String']['output']>;
  /** A query for any errors that may be in the WebFAQ */
  validation: WebFaqValidation;
};

export type WebFaqValidation = {
  /** Any errors that may be associated with the object. */
  errors: Array<Maybe<WebFaqValidationError>>;
  /** Whether or not the full FAQ is valid. */
  isValid: Scalars['Boolean']['output'];
};

export type WebFaqValidationError = {
  /** A description of the error message */
  errorMessage: Scalars['String']['output'];
  /** The property that is in error. */
  propertyName?: Maybe<Scalars['String']['output']>;
};

export type WebhookFieldMappingInput = {
  /** JSON template string with {{expression}} placeholders for the entire body */
  bodyTemplate?: InputMaybe<Scalars['String']['input']>;
  /** If true, only mapped and static fields are sent (no default payload) */
  exclusiveMapping?: InputMaybe<Scalars['Boolean']['input']>;
  /** Maps destination field names to source expressions (e.g. First_Name -> lead.fields.firstName) */
  fieldMappings?: InputMaybe<Scalars['JSON']['input']>;
  /** Static key-value pairs to include in every payload (e.g. api_key, source) */
  staticFields?: InputMaybe<Scalars['JSON']['input']>;
};

export type WebhookFieldMappingType = {
  /** JSON template string with {{expression}} placeholders for the entire body */
  bodyTemplate?: Maybe<Scalars['String']['output']>;
  /** If true, only mapped and static fields are sent (no default payload) */
  exclusiveMapping?: Maybe<Scalars['Boolean']['output']>;
  /** Maps destination field names to source expressions */
  fieldMappings?: Maybe<Scalars['JSON']['output']>;
  /** Static key-value pairs included in every payload */
  staticFields?: Maybe<Scalars['JSON']['output']>;
};

export type WebsiteData = {
  business?: Maybe<WebsiteDataBusinessData>;
  detectedTechnologies: Array<WebsiteDataDetectedTechnology>;
  schema: Scalars['JSON']['output'];
  site?: Maybe<WebsiteDataDescriptiveData>;
};

export type WebsiteDataBusinessData = {
  address?: Maybe<WebsiteDataBusinessDataAddress>;
  /** Category related to the business of the website. */
  category?: Maybe<Scalars['String']['output']>;
  geo?: Maybe<WebsiteDataBusinessDataGeo>;
  /** The likely logo for the business */
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumbers?: Maybe<Array<WebsiteDataPhoneNumber>>;
  serviceArea?: Maybe<WebsiteDataBusinessDataAreasServed>;
  services?: Maybe<Array<WebsiteDataBusinessDataService>>;
  /** How the business describes themselves */
  typeRaw?: Maybe<Scalars['String']['output']>;
};

export type WebsiteDataBusinessDataAddress = {
  country?: Maybe<Scalars['String']['output']>;
  formated?: Maybe<Scalars['String']['output']>;
  /** City, Town or Locality.  This is typically from the "city" of "city", "state" */
  locality?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Typically the state. */
  region?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
};

export type WebsiteDataBusinessDataAreasServed = {
  locality?: Maybe<Scalars['String']['output']>;
};

export type WebsiteDataBusinessDataGeo = {
  lat: Scalars['String']['output'];
  lon: Scalars['String']['output'];
};

export enum WebsiteDataBusinessDataService {
  HomeConstructionServices = 'HOME_CONSTRUCTION_SERVICES',
  HomeServices = 'HOME_SERVICES',
  ProfessionalServices = 'PROFESSIONAL_SERVICES'
}

export type WebsiteDataCallsToAction = {
  callToAction: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type WebsiteDataDescriptiveData = {
  /** Calls to action detected on the website such as "Free Quote" or "Schedule Consultation" */
  callsToAction?: Maybe<Array<WebsiteDataCallsToAction>>;
  /** A description of the organization found on the website */
  description?: Maybe<Scalars['String']['output']>;
  /** The likely logo for the website */
  logo?: Maybe<Scalars['String']['output']>;
  /** The phone numbers found on the website. */
  phoneNumbers?: Maybe<Array<WebsiteDataPhoneNumber>>;
  /** The primary color of the website */
  primaryColor?: Maybe<Scalars['String']['output']>;
  /** The secondary color of the website */
  secondaryColor?: Maybe<Scalars['String']['output']>;
};

export type WebsiteDataDetectedTechnology = {
  installed: Scalars['Boolean']['output'];
  technology: Scalars['String']['output'];
};

export type WebsiteDataPhoneNumber = {
  number?: Maybe<Scalars['String']['output']>;
  purpose?: Maybe<Scalars['String']['output']>;
};

export type WidgetAutoOpenOnPattern = {
  /** Minimum viewport width required for auto-opening */
  minimumWidth?: Maybe<Scalars['String']['output']>;
  /** URL patterns that trigger auto-opening */
  patterns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type WidgetAutoOpenOnPatternInput = {
  minimumWidth?: InputMaybe<Scalars['String']['input']>;
  patterns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Access statistics on the app's widgets. */
export type WidgetChannelAccess = {
  /** Number of times the widget was accessed. */
  total: Scalars['Int']['output'];
};

export type WidgetConfigurableMessageConfig = {
  /** Delay in milliseconds before showing the message */
  delay?: Maybe<Scalars['Int']['output']>;
  /** The message text to display */
  text?: Maybe<Scalars['String']['output']>;
};

export type WidgetConfigurableMessageConfigInput = {
  delay?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type WidgetConfigurableMessagesConfig = {
  /** List of configurable message items */
  items?: Maybe<Array<Maybe<WidgetConfigurableMessageConfig>>>;
};

export type WidgetConfigurableMessagesConfigInput = {
  items?: InputMaybe<Array<InputMaybe<WidgetConfigurableMessageConfigInput>>>;
};

export enum WithdrawFromAlexaCertReasons {
  DiscoveredIssue = 'DISCOVERED_ISSUE',
  MoreFeatures = 'MORE_FEATURES',
  NotIntendedToPublish = 'NOT_INTENDED_TO_PUBLISH',
  NotReceivedCertificationFeedback = 'NOT_RECEIVED_CERTIFICATION_FEEDBACK',
  Other = 'OTHER',
  TestSkill = 'TEST_SKILL'
}

/**
 * Zip code aggregation bucket for engagement analytics.
 * Shows lead metrics grouped by service zip code.
 */
export type ZipEngagementBucket = {
  /** High-value leads for this zip code */
  highValueLeadCount: Scalars['Int']['output'];
  /** Total leads for this zip code */
  leadCount: Scalars['Int']['output'];
  /**
   * Percentage of all leads (including those without a zip code).
   * Will not sum to 100% when some leads lack zip data.
   */
  percentage: Scalars['Float']['output'];
  /** Number of unique apps that contributed leads in this zip code */
  uniqueApps: Scalars['Int']['output'];
  /** The service zip code */
  zipCode: Scalars['String']['output'];
};

export type GetUserProfileQueryVariables = Exact<{
  jwt?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserProfileQuery = { profile?: { __typename: 'UserProfile', _id: string, email: string, userId: string, origin: AuthOrigin, isAdmin: boolean, emailVerified: boolean, icon?: string | null, roles: Array<{ __typename: 'UserProfileRole', organizationId: string, roles: Array<string | null> } | null>, identities: Array<{ __typename: 'UserProfileIdentity', userId: string, provider: string } | null> } | null };

export type GetAppListItemQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
}>;


export type GetAppListItemQuery = { app?: { __typename: 'App', appId: string, organizationId: string, name: string } | null };

export type GetTotalAppsForOrgQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GetTotalAppsForOrgQuery = { org?: { __typename: 'Organization', organizationId: string, apps?: { total: number } | null } | null };

export type GetAppStatusTotalsForOrgQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GetAppStatusTotalsForOrgQuery = { org?: { __typename: 'Organization', organizationId: string, name: string, notes?: string | null, website?: string | null, type: SubscriptionType, allApps?: { total: number } | null, submitted?: { total: number } | null, live?: { total: number } | null, readyForInstall?: { total: number } | null, requiresAttention?: { total: number } | null, inReview?: { total: number } | null, cancelled?: { total: number } | null, archived?: { total: number } | null, incomplete?: { total: number } | null } | null };

export type SearchAdminAppsQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  withIdOrName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  needsVerification?: InputMaybe<Scalars['Boolean']['input']>;
  byStatusType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  needsPlaces?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SearchAdminAppsQuery = { apps?: { total: number, apps?: Array<{ appId: string, organizationId: string, name: string, summary?: string | null, smallIcon?: string | null, largeIcon?: string | null, placeCount?: number | null, verifiedPlaceCount?: number | null, placesNeedingVerificationCount?: number | null, hasUnverifiedPlaceNotOptedOut?: boolean | null, allPlacesVerified?: boolean | null, status?: { type: string, timestamp: string } | null } | null> | null } | null };

export type GetAppsForOrgQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  byStatusType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  nuSortBy?: InputMaybe<Array<InputMaybe<OrgAppQuerySortByParameters>> | InputMaybe<OrgAppQuerySortByParameters>>;
}>;


export type GetAppsForOrgQuery = { org?: { __typename: 'Organization', organizationId: string, name: string, notes?: string | null, website?: string | null, type: SubscriptionType, allApps?: { total: number, apps: Array<{ appId: string, name: string } | null> } | null, apps?: { total: number, apps: Array<{ __typename: 'GetAppsListApp', _id: string, appId: string, organizationId: string, name: string, summary?: string | null, largeIcon?: string | null, smallIcon?: string | null, alexaSkillId?: string | null, alexaCategory?: string | null, actionsOnGoogleId?: string | null, invocationName?: string | null, description?: string | null, status?: { __typename: 'GetAppsListStatus', type: string, timestamp?: string | null } | null } | null> } | null } | null };

export type UpgradeOrgToPartnerMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type UpgradeOrgToPartnerMutation = { org: { org: { updateTier: string } } };

export type SearchAdminOrgsQueryVariables = Exact<{
  size: Scalars['Int']['input'];
  from: Scalars['Int']['input'];
  withIdOrName?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchAdminOrgsQuery = { orgs?: { total: number, orgs?: Array<{ __typename: 'SearchedOrg', name: string, organizationId: string, type: SubscriptionType, logoUrl?: string | null } | null> | null } | null };

export type AddFaqMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  faqs: Array<InputMaybe<AddFaq>> | InputMaybe<AddFaq>;
}>;


export type AddFaqMutation = { app: { update: { faq: { addFAQs: Array<{ __typename: 'AddedFAQ', _id: string, name: string, answer: string, questions: Array<string | null>, url?: string | null, raw?: string | null, created: string, wasAdded: boolean, reason?: FaqNotAddedReason | null } | null> } } } };

export type UpdateFaqItemMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  faqId: Scalars['ID']['input'];
  faq: UpdateFaq;
}>;


export type UpdateFaqItemMutation = { app: { update: { faq: { update: { updateFAQ: { __typename: 'WebFAQ', _id: string, name: string, answer: string, questions: Array<string | null>, url?: string | null, excludeFromAutoComplete?: boolean | null } } } } } };

export type DeleteFaqMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  faqId: Scalars['ID']['input'];
}>;


export type DeleteFaqMutation = { app: { update: { faq: { update: { deleteFAQ: string } } } } };

export type ExportFaqMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  includeUrl?: InputMaybe<Scalars['Boolean']['input']>;
  includeTitle?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ExportFaqMutation = { app: { update: { faq: { exportToCSV: { url: any } } } } };

export type ImportFaqMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  url: Scalars['URL']['input'];
  hasTitle?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ImportFaqMutation = { app: { update: { faq: { uploadCSV: { faqsAdded: number } } } } };

export type GetAnswersQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  size: Scalars['Int']['input'];
  from: Scalars['Int']['input'];
}>;


export type GetAnswersQuery = { app?: { _id: string, appId: string, faq?: { total: number, faq: Array<{ __typename: 'WebFAQ', _id: string, url?: string | null, questions: Array<string | null>, answer: string, name: string, created: string, excludeFromAutoComplete?: boolean | null } | null> } | null } | null };

export type GetAnswerQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  answerId: Scalars['ID']['input'];
}>;


export type GetAnswerQuery = { app?: { _id: string, appId: string, faq?: { faq: Array<{ __typename: 'WebFAQ', _id: string, url?: string | null, questions: Array<string | null>, answer: string, name: string, created: string, excludeFromAutoComplete?: boolean | null } | null> } | null } | null };

export type GetfaqQuestionsSuggestionsQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  answerId: Scalars['ID']['input'];
}>;


export type GetfaqQuestionsSuggestionsQuery = { app?: { _id: string, appId: string, faq?: { faq: Array<{ _id: string, faqQuestionsSuggestions: { suggestions: Array<{ question: string }> } } | null> } | null } | null };

export type GetAppAnalyticsQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
}>;


export type GetAppAnalyticsQuery = { app?: { __typename: 'App', _id: string, name: string, analytics?: { user: { newUsers: number, returningUsers: number, totalSessions: number, totalUsers: number } } | null } | null };

export type GetUserAnalyticsQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
}>;


export type GetUserAnalyticsQuery = { app?: { analytics?: { user: { newUsers: number, totalUsers: number, totalSessions: number, intervals: Array<{ isoDate: string, interval: AppUsageInterval, newUsers: number, returningUsers: number } | null> } } | null } | null };

export type ExportAnalyticsAsCsvQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  start: Scalars['DateTime']['input'];
  end: Scalars['DateTime']['input'];
}>;


export type ExportAnalyticsAsCsvQuery = { app?: { analytics?: { user: { csv: { file: any } } } | null } | null };

export type CreateAlexaSkillMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  channelId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateAlexaSkillMutation = { createSkill: { id: string, skillId?: string | null } };

export type UpdateAlexaSkillMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  channelId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateAlexaSkillMutation = { updateSkill: { id: string, skillId?: string | null } };

export type WithdrawFromAlexaCertMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  channelId?: InputMaybe<Scalars['ID']['input']>;
  reason?: InputMaybe<WithdrawFromAlexaCertReasons>;
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type WithdrawFromAlexaCertMutation = { withdrawFromAlexaCert: { id: string } };

export type AddAlexaCredentialsByCodeMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  channelId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
  redirectUri?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddAlexaCredentialsByCodeMutation = { addAlexaCredentialsByCode?: { __typename: 'App', appId: string, _id: string, channels?: Array<{ __typename: 'ActionsOnGoogleAppChannel', id: string } | { __typename: 'AlexaAppChannel', id: string, hasCredentials: boolean, vendorId?: string | null, vendors?: Array<{ __typename: 'SmapiVendor', id: string, name: string, roles: Array<string | null> } | null> | null } | { __typename: 'AppChannel', id: string } | { __typename: 'ChatWidgetAppChannel', id: string } | { __typename: 'DialogflowAppChannel', id: string } | { __typename: 'EmailAppChannel', id: string } | { __typename: 'FacebookMessengerAppChannel', id: string } | { __typename: 'FormWidgetAppChannel', id: string } | { __typename: 'GoogleBusinessMessagesAppChannel', id: string } | { __typename: 'IntelligentSearchAppChannel', id: string } | { __typename: 'LexConnectAppChannel', id: string } | { __typename: 'LexV2ConnectAppChannel', id: string } | null> | null } | null };

export type AddAlexaVendorToChannelMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  channelId: Scalars['ID']['input'];
  vendorId: Scalars['ID']['input'];
}>;


export type AddAlexaVendorToChannelMutation = { attachSmapiVendorToChannel?: { __typename: 'AlexaAppChannel', id: string, vendorId?: string | null, skillId?: string | null } | null };

export type GetAlexaChannelVendorsQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
}>;


export type GetAlexaChannelVendorsQuery = { app?: { __typename: 'App', appId: string, channels?: Array<{ __typename: 'ActionsOnGoogleAppChannel', id: string } | { __typename: 'AlexaAppChannel', vendorId?: string | null, id: string, vendors?: Array<{ id: string, name: string, roles: Array<string | null> } | null> | null } | { __typename: 'AppChannel', id: string } | { __typename: 'ChatWidgetAppChannel', id: string } | { __typename: 'DialogflowAppChannel', id: string } | { __typename: 'EmailAppChannel', id: string } | { __typename: 'FacebookMessengerAppChannel', id: string } | { __typename: 'FormWidgetAppChannel', id: string } | { __typename: 'GoogleBusinessMessagesAppChannel', id: string } | { __typename: 'IntelligentSearchAppChannel', id: string } | { __typename: 'LexConnectAppChannel', id: string } | { __typename: 'LexV2ConnectAppChannel', id: string } | null> | null } | null };

export type DeleteChannelMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  channelId?: InputMaybe<Scalars['ID']['input']>;
  channelType: Scalars['String']['input'];
}>;


export type DeleteChannelMutation = { deleteChannel: string };

export type AddDialogflowCredentialsMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  channelId?: InputMaybe<Scalars['ID']['input']>;
  credentials: DialogflowCredentialsInput;
}>;


export type AddDialogflowCredentialsMutation = { addDialogflowCredentials?: { name: string } | null };

export type ChatWidgetChannelFieldsFragment = { __typename: 'ChatWidgetAppChannel', id: string, type: string, name?: string | null, directoryListing?: string | null, endPoint?: string | null, useNLU?: string | null, direct?: boolean | null, disabled?: boolean | null, accountKey?: string | null, botName?: string | null, avatarUrl?: any | null, key?: string | null, serverUrl?: any | null, middlewareUrl?: string | null, autocompleteSuggestionsUrl?: any | null, autoOpenOnWidth?: string | null, status?: { type: string, email: string, timestamp: any } | null, cta?: { message?: string | null, timeout?: number | null, delay?: number | null, animation?: CtaAnimation | null, animationTimeout?: number | null, mobile?: { applyAtLessThanWidth?: string | null, message?: string | null, timeout?: number | null, delay?: number | null, animation?: CtaAnimation | null, animationTimeout?: number | null } | null } | null, menu?: { menuButtonLocation?: ChatWidgetMenuButtonLocation | null, itemsTabIndex?: string | null, items?: Array<{ label?: string | null, subtitle?: string | null } | { url: string, text: string, behavior?: { type: ChatWidgetAppChannelWidgetUrlBehaviorType } | { width?: number | null, height?: number | null, type: ChatWidgetAppChannelWidgetUrlBehaviorType } | { type: ChatWidgetAppChannelWidgetUrlBehaviorType } | null } | { imageUrl?: string | null } | { title?: string | null, body?: string | null } | null> | null, button?: { tabIndex?: string | null } | null } | null, configurableMessages?: { items?: Array<{ delay?: number | null, text?: string | null } | null> | null } | null, urls?: { policies: Array<{ pattern: string, behavior: { type: ChatWidgetAppChannelWidgetUrlBehaviorType } | { width?: number | null, height?: number | null, type: ChatWidgetAppChannelWidgetUrlBehaviorType } | { type: ChatWidgetAppChannelWidgetUrlBehaviorType } } | null>, defaultBehavior: { type: ChatWidgetAppChannelWidgetUrlBehaviorType } | { width?: number | null, height?: number | null, type: ChatWidgetAppChannelWidgetUrlBehaviorType } | { type: ChatWidgetAppChannelWidgetUrlBehaviorType } } | null, autoOpenOnPattern?: { minimumWidth?: string | null, patterns?: Array<string | null> | null } | null, chatButton?: { imageUrl?: string | null, tabIndex?: string | null } | null, actionBar?: { enabled: boolean, position?: ActionBarPosition | null, mobileBreakpoint?: number | null, buttons: Array<{ id: string, type: ActionBarButtonType, label?: string | null, icon?: ActionBarIconType | null, iconUrl?: string | null, visibility?: ActionBarButtonVisibility | null, tabIndex?: number | null } | { id: string, type: ActionBarButtonType, label?: string | null, icon?: ActionBarIconType | null, iconUrl?: string | null, visibility?: ActionBarButtonVisibility | null, tabIndex?: number | null, emailAddress: string, subject?: string | null, body?: string | null } | { id: string, type: ActionBarButtonType, label?: string | null, icon?: ActionBarIconType | null, iconUrl?: string | null, visibility?: ActionBarButtonVisibility | null, tabIndex?: number | null, intentId?: string | null, autoGreeting?: boolean | null, preselectChipLabel?: string | null } | { id: string, type: ActionBarButtonType, label?: string | null, icon?: ActionBarIconType | null, iconUrl?: string | null, visibility?: ActionBarButtonVisibility | null, tabIndex?: number | null, url: string, target?: ActionBarButtonTarget | null } | { id: string, type: ActionBarButtonType, label?: string | null, icon?: ActionBarIconType | null, iconUrl?: string | null, visibility?: ActionBarButtonVisibility | null, tabIndex?: number | null, url: string, target?: ActionBarButtonTarget | null } | { id: string, type: ActionBarButtonType, label?: string | null, icon?: ActionBarIconType | null, iconUrl?: string | null, visibility?: ActionBarButtonVisibility | null, tabIndex?: number | null, phoneNumber: string } | { id: string, type: ActionBarButtonType, label?: string | null, icon?: ActionBarIconType | null, iconUrl?: string | null, visibility?: ActionBarButtonVisibility | null, tabIndex?: number | null, intentId?: string | null, autoGreeting?: boolean | null, preselectChipLabel?: string | null } | { id: string, type: ActionBarButtonType, label?: string | null, icon?: ActionBarIconType | null, iconUrl?: string | null, visibility?: ActionBarButtonVisibility | null, tabIndex?: number | null, url: string, target?: ActionBarButtonTarget | null }> } | null, header?: { alignTextCenter?: boolean | null, status?: { online?: string | null, offline?: string | null, away?: string | null, connecting?: string | null } | null, subtitle?: { enabled?: boolean | null, text?: string | null } | null, actions?: { refresh?: boolean | null, refreshTabIndex?: string | null, minimize?: boolean | null, minimizeTabIndex?: string | null, cancel?: boolean | null, cancelTabIndex?: string | null } | null } | null, footer?: { branding?: { enabled?: boolean | null, text?: string | null } | null, sendButton?: { icon?: string | null, tabIndex?: string | null } | null, clearButton?: { tabIndex?: string | null } | null } | null, typingStatus?: { textTypingStatusEnabled?: boolean | null } | null, theme?: { primaryColor?: string | null, zIndex?: string | null, border?: { color?: string | null, width?: string | null, radius?: string | null } | null, carousel?: { button?: { color?: string | null } | null, subtitle?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null } | null, title?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null } | null } | null, chatButton?: { background?: string | null, border?: { color?: string | null, radius?: string | null, width?: string | null } | null, imageSize?: { width?: string | null, height?: string | null } | null, animation?: { primaryColor?: string | null, secondaryColor?: string | null, opacity?: number | null } | null, margin?: { top?: string | null, right?: string | null, bottom?: string | null, left?: string | null } | null } | null, content?: { background?: string | null } | null, cta?: { background?: string | null, text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null } | null } | null, footer?: { background?: string | null, border?: { color?: string | null, radius?: string | null, width?: string | null } | null, branding?: { text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null } | null } | null } | null, header?: { background?: string | null, avatarBackground?: string | null, border?: { color?: string | null, radius?: string | null, width?: string | null } | null, padding?: { left?: string | null, right?: string | null, top?: string | null, bottom?: string | null } | null, text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null } | null, subtitle?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null } | null } | null, input?: { background?: string | null, border?: { color?: string | null, width?: string | null, radius?: string | null } | null, text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null } | null, placeholder?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, fontStyle?: string | null } | null } | null, menu?: { item?: { height?: string | null, background?: string | null, text?: { color?: string | null, fontSize?: string | null, fontFamily?: string | null, fontWeight?: string | null, fontStyle?: string | null } | null } | null } | null, menuButton?: { color?: string | null } | null, messages?: { maxWidth?: string | null, mine?: { bubbleColor?: string | null, text?: { color?: string | null, fontSize?: string | null, fontFamily?: string | null, fontWeight?: string | null, fontStyle?: string | null } | null } | null, others?: { bubbleColor?: string | null, text?: { color?: string | null, fontSize?: string | null, fontFamily?: string | null, fontWeight?: string | null, fontStyle?: string | null } | null } | null, padding?: { left?: string | null, right?: string | null, bottom?: string | null, top?: string | null } | null } | null, minimizeButton?: { color?: string | null } | null, cancelButton?: { color?: string | null } | null, refreshButton?: { color?: string | null } | null, sendButton?: { color?: string | null, width?: string | null } | null, size?: { width?: string | null, height?: string | null } | null, textTypingStatus?: { text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null } | null } | null } | null, input?: { placeholder?: string | null } | null, connection?: { type?: ChatWidgetServerType | null, serverUrl?: any | null } | null };

export type IntelligentSearchChannelFieldsFragment = { __typename: 'IntelligentSearchAppChannel', id: string, type: string, name?: string | null, key?: string | null, autocompleteSuggestionsUrl?: any | null, connection?: { serverUrl?: any | null } | null, theme?: { accentColor?: string | null, border?: { color?: string | null, width?: string | null, radius?: string | null, style?: IntelligentSearchWidgetBorderStyle | null } | null, card?: { background?: string | null, border?: { color?: string | null, width?: string | null, radius?: string | null, style?: IntelligentSearchWidgetBorderStyle | null } | null, description?: { margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null, lineHeight?: any | null } | null } | null, link?: { margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, text?: { default?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null, lineHeight?: any | null } | null } | null } | null, margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, title?: { margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null, lineHeight?: any | null } | null } | null } | null, carousel?: { card?: { background?: string | null, border?: { color?: string | null, width?: string | null, radius?: string | null, style?: IntelligentSearchWidgetBorderStyle | null } | null, description?: { margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null, lineHeight?: any | null } | null } | null, link?: { margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, text?: { default?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null, lineHeight?: any | null } | null } | null } | null, margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, title?: { margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null, lineHeight?: any | null } | null } | null } | null } | null, list?: { card?: { background?: string | null, border?: { color?: string | null, width?: string | null, radius?: string | null, style?: IntelligentSearchWidgetBorderStyle | null } | null, description?: { margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null, lineHeight?: any | null } | null } | null, link?: { margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, text?: { default?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null, lineHeight?: any | null } | null } | null } | null, margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, title?: { margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null, lineHeight?: any | null } | null } | null } | null } | null, messages?: { others?: { bubble?: { background?: string | null } | null, text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null, lineHeight?: any | null } | null } | null } | null } | null };

export type FormWidgetChannelFieldsFragment = { __typename: 'FormWidgetAppChannel', id: string, type: string, name?: string | null, key?: string | null, autoGreeting?: string | null, intentId?: string | null, sideButtonLabel?: string | null, directoryListing?: string | null, useNLU?: string | null, businessName?: string | null, businessLogoUrl?: string | null, businessAddress?: string | null, businessWebsite?: string | null, chatWidgetKey?: string | null, metaPixelId?: string | null, trustedForm?: { scriptUrl: string } | null, autoOpen?: { enabled?: boolean | null } | null, connection?: { serverUrl?: any | null, accountKey?: string | null } | null, theme?: { accentColor?: string | null, backgroundColor?: string | null, headerBackgroundColor?: string | null, headerTextColor?: string | null, primaryButtonColor?: string | null, primaryButtonTextColor?: string | null, secondaryButtonColor?: string | null, secondaryButtonTextColor?: string | null, data?: any | null, card?: { backgroundColor?: string | null, color?: string | null, fontSize?: string | null } | null, checkbox?: { backgroundColor?: string | null, color?: string | null, fontSize?: string | null } | null, chips?: { backgroundColor?: string | null, backgroundColorSelected?: string | null, color?: string | null, colorSelected?: string | null, fontSize?: string | null } | null, date?: { backgroundColor?: string | null, backgroundColorSelected?: string | null, color?: string | null, fontSize?: string | null } | null, dropdown?: { backgroundColor?: string | null, color?: string | null, fontSize?: string | null } | null, sideButton?: { backgroundColor?: string | null, color?: string | null, top?: string | null, position?: string | null, minLength?: string | null, fontSize?: string | null } | null, text?: { backgroundColor?: string | null, color?: string | null, fontSize?: string | null } | null, standAlone?: { backgroundColor?: string | null, header?: { backgroundColor?: string | null, color?: string | null, fontSize?: string | null } | null } | null } | null };

export type AlexaChannelFieldsFragment = { __typename: 'AlexaAppChannel', id: string, type: string, name?: string | null, invocationName?: string | null, hasCredentials: boolean, skillId?: string | null, vendorId?: string | null, category?: AlexaSkillCategories | null, distributionMode?: AlexaDistributionMode | null, isAvailableWorldwide?: boolean | null, distributionCountries?: Array<AlexaDistrubutionCountry | null> | null, useManifest?: boolean | null, directoryListing?: string | null, endPoint?: string | null, useNLU?: string | null, permissions?: Array<{ name?: AlexaChannelPermissionType | null } | null> | null, vendors?: Array<{ id: string, name: string, roles: Array<string | null> } | null> | null, privacyAndCompliance?: { allowsPurchases?: boolean | null, containsAds?: boolean | null, isChildDirected?: boolean | null, isExportCompliant?: boolean | null, usesPersonalInfo?: boolean | null } | null, status?: { type: string, email: string, timestamp: any } | null };

export type DialogflowChannelFieldsFragment = { __typename: 'DialogflowAppChannel', id: string, type: string, name?: string | null, hasCredentials: boolean, directoryListing?: string | null, endPoint?: string | null, useNLU?: string | null, additionalInformationQuestions?: { intendedForUnderThirteen?: boolean | null, alcoholAndTobaccoRelatedContent?: boolean | null } | null, status?: { type: string, email: string, timestamp: any } | null };

export type ActionsOnGoogleChannelFieldsFragment = { __typename: 'ActionsOnGoogleAppChannel', id: string, type: string, name?: string | null, hasCredentials: boolean, directoryListing?: string | null, endPoint?: string | null, useNLU?: string | null, additionalInformationQuestions?: { intendedForUnderThirteen?: boolean | null, alcoholAndTobaccoRelatedContent?: boolean | null } | null, status?: { type: string, email: string, timestamp: any } | null };

export type LexConnectChannelFieldsFragment = { __typename: 'LexConnectAppChannel', id: string, type: string, name?: string | null, voiceId?: string | null, nluIntentConfidenceThreshold?: number | null, idleSessionTTLInSeconds?: number | null, detectSentiment?: boolean | null, isLinkedToKendra: boolean, lexPostTextUrl?: string | null, enableModelImprovements?: boolean | null, botName?: string | null, directoryListing?: string | null, endPoint?: string | null, useNLU?: string | null, status?: { type: string, email: string, timestamp: any } | null };

export type LexV2ConnectChannelFieldsFragment = { __typename: 'LexV2ConnectAppChannel', id: string, type: string, name?: string | null, voiceId?: string | null, idleSessionTTLInSeconds?: number | null, detectSentiment?: boolean | null, isLinkedToKendra: boolean, lexPostTextUrl?: string | null, enableModelImprovements?: boolean | null, botId?: string | null, botName?: string | null, botRegion?: string | null, lexFulfillmentLambdaARN?: string | null, managementRole?: string | null, managementRoleExternalId?: string | null, directoryListing?: string | null, endPoint?: string | null, useNLU?: string | null, status?: { type: string, email: string, timestamp: any } | null };

export type AddActionsOnGoogleChannelMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  channel: ActionsOnGoogleAppChannelInput;
}>;


export type AddActionsOnGoogleChannelMutation = { addActionsOnGoogleChannel: { __typename: 'ActionsOnGoogleAppChannel', credentialsURL?: string | null, id: string, type: string, name?: string | null, hasCredentials: boolean, directoryListing?: string | null, endPoint?: string | null, useNLU?: string | null, additionalInformationQuestions?: { intendedForUnderThirteen?: boolean | null, alcoholAndTobaccoRelatedContent?: boolean | null } | null, status?: { type: string, email: string, timestamp: any } | null } };

export type AddAlexaChannelMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  channel: AlexaAppChannelInput;
}>;


export type AddAlexaChannelMutation = { addAlexaChannel: { __typename: 'AlexaAppChannel', id: string, type: string, name?: string | null, invocationName?: string | null, hasCredentials: boolean, skillId?: string | null, vendorId?: string | null, category?: AlexaSkillCategories | null, distributionMode?: AlexaDistributionMode | null, isAvailableWorldwide?: boolean | null, distributionCountries?: Array<AlexaDistrubutionCountry | null> | null, useManifest?: boolean | null, directoryListing?: string | null, endPoint?: string | null, useNLU?: string | null, permissions?: Array<{ name?: AlexaChannelPermissionType | null } | null> | null, vendors?: Array<{ id: string, name: string, roles: Array<string | null> } | null> | null, privacyAndCompliance?: { allowsPurchases?: boolean | null, containsAds?: boolean | null, isChildDirected?: boolean | null, isExportCompliant?: boolean | null, usesPersonalInfo?: boolean | null } | null, status?: { type: string, email: string, timestamp: any } | null } };

export type AddAlexaCredentialsMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  channelId?: InputMaybe<Scalars['ID']['input']>;
  credentials: AlexaCredentialsInput;
}>;


export type AddAlexaCredentialsMutation = { addAlexaCredentials?: { appId: string } | null };

export type AddDialogflowChannelMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  channel: DialogflowAppChannelInput;
}>;


export type AddDialogflowChannelMutation = { addDialogflowChannel: { __typename: 'DialogflowAppChannel', id: string, type: string, name?: string | null, hasCredentials: boolean, directoryListing?: string | null, endPoint?: string | null, useNLU?: string | null, additionalInformationQuestions?: { intendedForUnderThirteen?: boolean | null, alcoholAndTobaccoRelatedContent?: boolean | null } | null, status?: { type: string, email: string, timestamp: any } | null } };

export type SubmitForAlexaCertMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  channelId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SubmitForAlexaCertMutation = { submitForAlexaCert: { id: string } };

export type SyncFaqToKendraMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  channelId: Scalars['ID']['input'];
}>;


export type SyncFaqToKendraMutation = { app: { update: { channel: { update: { syncFAQToKendra: { executionId: string } } } } } };

export type AddLexChannelMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  channel: LexConnectAppChannelInput;
}>;


export type AddLexChannelMutation = { addLexChannel: { __typename: 'LexConnectAppChannel', id: string, type: string, name?: string | null, voiceId?: string | null, nluIntentConfidenceThreshold?: number | null, idleSessionTTLInSeconds?: number | null, detectSentiment?: boolean | null, isLinkedToKendra: boolean, lexPostTextUrl?: string | null, enableModelImprovements?: boolean | null, botName?: string | null, directoryListing?: string | null, endPoint?: string | null, useNLU?: string | null, status?: { type: string, email: string, timestamp: any } | null } };

export type AddLexV2ChannelMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  channel: LexV2ConnectAppChannelInput;
}>;


export type AddLexV2ChannelMutation = { app: { update: { channel: { addLexV2Channel: { __typename: 'LexV2ConnectAppChannel', id: string, type: string, name?: string | null, voiceId?: string | null, idleSessionTTLInSeconds?: number | null, detectSentiment?: boolean | null, isLinkedToKendra: boolean, lexPostTextUrl?: string | null, enableModelImprovements?: boolean | null, botId?: string | null, botName?: string | null, botRegion?: string | null, lexFulfillmentLambdaARN?: string | null, managementRole?: string | null, managementRoleExternalId?: string | null, directoryListing?: string | null, endPoint?: string | null, useNLU?: string | null, status?: { type: string, email: string, timestamp: any } | null } } } } };

export type PushLexMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  channelId: Scalars['ID']['input'];
}>;


export type PushLexMutation = { pushLex: string };

export type PushLexV2MutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  channelId: Scalars['ID']['input'];
}>;


export type PushLexV2Mutation = { pushLex: string };

export type AddChatWidgetChannelMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  channel: ChatWidgetAppChannelInput;
}>;


export type AddChatWidgetChannelMutation = { addChatWidgetChannel: { __typename: 'ChatWidgetAppChannel', id: string, type: string, name?: string | null, directoryListing?: string | null, endPoint?: string | null, useNLU?: string | null, direct?: boolean | null, disabled?: boolean | null, accountKey?: string | null, botName?: string | null, avatarUrl?: any | null, key?: string | null, serverUrl?: any | null, middlewareUrl?: string | null, autocompleteSuggestionsUrl?: any | null, autoOpenOnWidth?: string | null, status?: { type: string, email: string, timestamp: any } | null, cta?: { message?: string | null, timeout?: number | null, delay?: number | null, animation?: CtaAnimation | null, animationTimeout?: number | null, mobile?: { applyAtLessThanWidth?: string | null, message?: string | null, timeout?: number | null, delay?: number | null, animation?: CtaAnimation | null, animationTimeout?: number | null } | null } | null, menu?: { menuButtonLocation?: ChatWidgetMenuButtonLocation | null, itemsTabIndex?: string | null, items?: Array<{ label?: string | null, subtitle?: string | null } | { url: string, text: string, behavior?: { type: ChatWidgetAppChannelWidgetUrlBehaviorType } | { width?: number | null, height?: number | null, type: ChatWidgetAppChannelWidgetUrlBehaviorType } | { type: ChatWidgetAppChannelWidgetUrlBehaviorType } | null } | { imageUrl?: string | null } | { title?: string | null, body?: string | null } | null> | null, button?: { tabIndex?: string | null } | null } | null, configurableMessages?: { items?: Array<{ delay?: number | null, text?: string | null } | null> | null } | null, urls?: { policies: Array<{ pattern: string, behavior: { type: ChatWidgetAppChannelWidgetUrlBehaviorType } | { width?: number | null, height?: number | null, type: ChatWidgetAppChannelWidgetUrlBehaviorType } | { type: ChatWidgetAppChannelWidgetUrlBehaviorType } } | null>, defaultBehavior: { type: ChatWidgetAppChannelWidgetUrlBehaviorType } | { width?: number | null, height?: number | null, type: ChatWidgetAppChannelWidgetUrlBehaviorType } | { type: ChatWidgetAppChannelWidgetUrlBehaviorType } } | null, autoOpenOnPattern?: { minimumWidth?: string | null, patterns?: Array<string | null> | null } | null, chatButton?: { imageUrl?: string | null, tabIndex?: string | null } | null, actionBar?: { enabled: boolean, position?: ActionBarPosition | null, mobileBreakpoint?: number | null, buttons: Array<{ id: string, type: ActionBarButtonType, label?: string | null, icon?: ActionBarIconType | null, iconUrl?: string | null, visibility?: ActionBarButtonVisibility | null, tabIndex?: number | null } | { id: string, type: ActionBarButtonType, label?: string | null, icon?: ActionBarIconType | null, iconUrl?: string | null, visibility?: ActionBarButtonVisibility | null, tabIndex?: number | null, emailAddress: string, subject?: string | null, body?: string | null } | { id: string, type: ActionBarButtonType, label?: string | null, icon?: ActionBarIconType | null, iconUrl?: string | null, visibility?: ActionBarButtonVisibility | null, tabIndex?: number | null, intentId?: string | null, autoGreeting?: boolean | null, preselectChipLabel?: string | null } | { id: string, type: ActionBarButtonType, label?: string | null, icon?: ActionBarIconType | null, iconUrl?: string | null, visibility?: ActionBarButtonVisibility | null, tabIndex?: number | null, url: string, target?: ActionBarButtonTarget | null } | { id: string, type: ActionBarButtonType, label?: string | null, icon?: ActionBarIconType | null, iconUrl?: string | null, visibility?: ActionBarButtonVisibility | null, tabIndex?: number | null, url: string, target?: ActionBarButtonTarget | null } | { id: string, type: ActionBarButtonType, label?: string | null, icon?: ActionBarIconType | null, iconUrl?: string | null, visibility?: ActionBarButtonVisibility | null, tabIndex?: number | null, phoneNumber: string } | { id: string, type: ActionBarButtonType, label?: string | null, icon?: ActionBarIconType | null, iconUrl?: string | null, visibility?: ActionBarButtonVisibility | null, tabIndex?: number | null, intentId?: string | null, autoGreeting?: boolean | null, preselectChipLabel?: string | null } | { id: string, type: ActionBarButtonType, label?: string | null, icon?: ActionBarIconType | null, iconUrl?: string | null, visibility?: ActionBarButtonVisibility | null, tabIndex?: number | null, url: string, target?: ActionBarButtonTarget | null }> } | null, header?: { alignTextCenter?: boolean | null, status?: { online?: string | null, offline?: string | null, away?: string | null, connecting?: string | null } | null, subtitle?: { enabled?: boolean | null, text?: string | null } | null, actions?: { refresh?: boolean | null, refreshTabIndex?: string | null, minimize?: boolean | null, minimizeTabIndex?: string | null, cancel?: boolean | null, cancelTabIndex?: string | null } | null } | null, footer?: { branding?: { enabled?: boolean | null, text?: string | null } | null, sendButton?: { icon?: string | null, tabIndex?: string | null } | null, clearButton?: { tabIndex?: string | null } | null } | null, typingStatus?: { textTypingStatusEnabled?: boolean | null } | null, theme?: { primaryColor?: string | null, zIndex?: string | null, border?: { color?: string | null, width?: string | null, radius?: string | null } | null, carousel?: { button?: { color?: string | null } | null, subtitle?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null } | null, title?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null } | null } | null, chatButton?: { background?: string | null, border?: { color?: string | null, radius?: string | null, width?: string | null } | null, imageSize?: { width?: string | null, height?: string | null } | null, animation?: { primaryColor?: string | null, secondaryColor?: string | null, opacity?: number | null } | null, margin?: { top?: string | null, right?: string | null, bottom?: string | null, left?: string | null } | null } | null, content?: { background?: string | null } | null, cta?: { background?: string | null, text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null } | null } | null, footer?: { background?: string | null, border?: { color?: string | null, radius?: string | null, width?: string | null } | null, branding?: { text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null } | null } | null } | null, header?: { background?: string | null, avatarBackground?: string | null, border?: { color?: string | null, radius?: string | null, width?: string | null } | null, padding?: { left?: string | null, right?: string | null, top?: string | null, bottom?: string | null } | null, text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null } | null, subtitle?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null } | null } | null, input?: { background?: string | null, border?: { color?: string | null, width?: string | null, radius?: string | null } | null, text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null } | null, placeholder?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, fontStyle?: string | null } | null } | null, menu?: { item?: { height?: string | null, background?: string | null, text?: { color?: string | null, fontSize?: string | null, fontFamily?: string | null, fontWeight?: string | null, fontStyle?: string | null } | null } | null } | null, menuButton?: { color?: string | null } | null, messages?: { maxWidth?: string | null, mine?: { bubbleColor?: string | null, text?: { color?: string | null, fontSize?: string | null, fontFamily?: string | null, fontWeight?: string | null, fontStyle?: string | null } | null } | null, others?: { bubbleColor?: string | null, text?: { color?: string | null, fontSize?: string | null, fontFamily?: string | null, fontWeight?: string | null, fontStyle?: string | null } | null } | null, padding?: { left?: string | null, right?: string | null, bottom?: string | null, top?: string | null } | null } | null, minimizeButton?: { color?: string | null } | null, cancelButton?: { color?: string | null } | null, refreshButton?: { color?: string | null } | null, sendButton?: { color?: string | null, width?: string | null } | null, size?: { width?: string | null, height?: string | null } | null, textTypingStatus?: { text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null } | null } | null } | null, input?: { placeholder?: string | null } | null, connection?: { type?: ChatWidgetServerType | null, serverUrl?: any | null } | null } };

export type AddChannelMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  channel: AppChannelInput;
}>;


export type AddChannelMutation = { addChannel: { __typename: 'AppChannel', id: string, type: string, name?: string | null } };

export type UpdateChannelMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  channel: AppChannelInput;
}>;


export type UpdateChannelMutation = { addChannel: { __typename: 'AppChannel', id: string, type: string, name?: string | null } };

export type UpdateSearchChannelMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  channel: IntelligentSearchAppChannelInput;
}>;


export type UpdateSearchChannelMutation = { app: { update: { channel: { addIntelligentSearchChannel: { __typename: 'IntelligentSearchAppChannel', endPoint?: string | null, directoryListing?: string | null, id: string, type: string, name?: string | null, key?: string | null, autocompleteSuggestionsUrl?: any | null, connection?: { serverUrl?: any | null } | null, theme?: { accentColor?: string | null, border?: { color?: string | null, width?: string | null, radius?: string | null, style?: IntelligentSearchWidgetBorderStyle | null } | null, card?: { background?: string | null, border?: { color?: string | null, width?: string | null, radius?: string | null, style?: IntelligentSearchWidgetBorderStyle | null } | null, description?: { margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null, lineHeight?: any | null } | null } | null, link?: { margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, text?: { default?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null, lineHeight?: any | null } | null } | null } | null, margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, title?: { margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null, lineHeight?: any | null } | null } | null } | null, carousel?: { card?: { background?: string | null, border?: { color?: string | null, width?: string | null, radius?: string | null, style?: IntelligentSearchWidgetBorderStyle | null } | null, description?: { margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null, lineHeight?: any | null } | null } | null, link?: { margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, text?: { default?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null, lineHeight?: any | null } | null } | null } | null, margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, title?: { margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null, lineHeight?: any | null } | null } | null } | null } | null, list?: { card?: { background?: string | null, border?: { color?: string | null, width?: string | null, radius?: string | null, style?: IntelligentSearchWidgetBorderStyle | null } | null, description?: { margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null, lineHeight?: any | null } | null } | null, link?: { margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, text?: { default?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null, lineHeight?: any | null } | null } | null } | null, margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, title?: { margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null, lineHeight?: any | null } | null } | null } | null } | null, messages?: { others?: { bubble?: { background?: string | null } | null, text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null, lineHeight?: any | null } | null } | null } | null } | null } } } } };

export type AddGoogleBusinessChannelMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  channel: GoogleBusinessMessagesAppChannelInput;
}>;


export type AddGoogleBusinessChannelMutation = { app: { update: { channel: { addGoogleBusinessMessageChannel: { __typename: 'GoogleBusinessMessagesAppChannel', id: string, type: string, name?: string | null, endPoint?: string | null } } } } };

export type AddFormWidgetChannelMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  channel: FormWidgetAppChannelInput;
}>;


export type AddFormWidgetChannelMutation = { app: { update: { channel: { addFormWidgetChannel: { __typename: 'FormWidgetAppChannel', endPoint?: string | null, autocompleteSuggestionsUrl?: any | null, attributes?: any | null, id: string, type: string, name?: string | null, key?: string | null, autoGreeting?: string | null, intentId?: string | null, sideButtonLabel?: string | null, directoryListing?: string | null, useNLU?: string | null, businessName?: string | null, businessLogoUrl?: string | null, businessAddress?: string | null, businessWebsite?: string | null, chatWidgetKey?: string | null, metaPixelId?: string | null, status?: { type: string } | null, trustedForm?: { scriptUrl: string } | null, autoOpen?: { enabled?: boolean | null } | null, connection?: { serverUrl?: any | null, accountKey?: string | null } | null, theme?: { accentColor?: string | null, backgroundColor?: string | null, headerBackgroundColor?: string | null, headerTextColor?: string | null, primaryButtonColor?: string | null, primaryButtonTextColor?: string | null, secondaryButtonColor?: string | null, secondaryButtonTextColor?: string | null, data?: any | null, card?: { backgroundColor?: string | null, color?: string | null, fontSize?: string | null } | null, checkbox?: { backgroundColor?: string | null, color?: string | null, fontSize?: string | null } | null, chips?: { backgroundColor?: string | null, backgroundColorSelected?: string | null, color?: string | null, colorSelected?: string | null, fontSize?: string | null } | null, date?: { backgroundColor?: string | null, backgroundColorSelected?: string | null, color?: string | null, fontSize?: string | null } | null, dropdown?: { backgroundColor?: string | null, color?: string | null, fontSize?: string | null } | null, sideButton?: { backgroundColor?: string | null, color?: string | null, top?: string | null, position?: string | null, minLength?: string | null, fontSize?: string | null } | null, text?: { backgroundColor?: string | null, color?: string | null, fontSize?: string | null } | null, standAlone?: { backgroundColor?: string | null, header?: { backgroundColor?: string | null, color?: string | null, fontSize?: string | null } | null } | null } | null } } } } };

export type GetAppWithChannelsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
}>;


export type GetAppWithChannelsQuery = { profile?: { __typename: 'UserProfile', _id: string, userId: string, fullName?: string | null, email: string } | null, org?: { __typename: 'Organization', _id: string, organizationId: string, type: SubscriptionType } | null, app?: { __typename: 'App', appId: string, organizationId: string, stripeProductId?: string | null, stripeSubscriptionId?: string | null, subscriptionPaymentStatus?: string | null, invocationName?: string | null, name: string, beta?: any | null, website?: string | null, templateType?: string | null, icon?: string | null, websiteData?: { primaryColor?: string | null, secondaryColor?: string | null, callsToAction?: Array<string> | null, crawlExecutionId?: string | null } | null, referenceId?: { id: string, service: string } | null, channels?: Array<{ __typename: 'ActionsOnGoogleAppChannel', type: string, id: string, name?: string | null } | { __typename: 'AlexaAppChannel', vendorId?: string | null, invocationName?: string | null, type: string, id: string, name?: string | null } | { __typename: 'AppChannel', type: string, id: string, name?: string | null } | { __typename: 'ChatWidgetAppChannel', key?: string | null, type: string, id: string, name?: string | null, theme?: { primaryColor?: string | null } | null } | { __typename: 'DialogflowAppChannel', type: string, id: string, name?: string | null } | { __typename: 'EmailAppChannel', type: string, id: string, name?: string | null } | { __typename: 'FacebookMessengerAppChannel', type: string, id: string, name?: string | null } | { __typename: 'FormWidgetAppChannel', id: string, key?: string | null, type: string, name?: string | null, theme?: { accentColor?: string | null } | null } | { __typename: 'GoogleBusinessMessagesAppChannel', type: string, id: string, name?: string | null } | { __typename: 'IntelligentSearchAppChannel', key?: string | null, type: string, id: string, name?: string | null, theme?: { accentColor?: string | null } | null } | { __typename: 'LexConnectAppChannel', isLinkedToKendra: boolean, lexPostTextUrl?: string | null, type: string, id: string, name?: string | null } | { __typename: 'LexV2ConnectAppChannel', botName?: string | null, isLinkedToKendra: boolean, lexPostTextUrl?: string | null, type: string, id: string, name?: string | null } | null> | null } | null };

export type GetAppWithChannelDataQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  channelId: Scalars['ID']['input'];
}>;


export type GetAppWithChannelDataQuery = { org?: { __typename: 'Organization', _id: string, organizationId: string, type: SubscriptionType } | null, app?: { __typename: 'App', appId: string, organizationId: string, stripeProductId?: string | null, stripeSubscriptionId?: string | null, subscriptionPaymentStatus?: string | null, invocationName?: string | null, privacyPolicyUrl?: string | null, termsOfUseUrl?: string | null, beta?: any | null, icon?: string | null, websiteData?: { primaryColor?: string | null, secondaryColor?: string | null, callsToAction?: Array<string> | null, crawlExecutionId?: string | null } | null, platformData?: { alexa?: { platform: string, privacyAndCompliance: { allowsPurchases?: boolean | null, usesPersonalInfo?: boolean | null, isChildDirected?: boolean | null, isExportCompliant?: boolean | null, containsAds?: boolean | null } } | null, google?: { platform: string, additionalInformationQuestions?: { alcoholAndTobaccoRelatedContent: boolean } | null } | null } | null, channel?: { __typename: 'ActionsOnGoogleAppChannel', type: string, name?: string | null, id: string, directoryListing?: string | null, endPoint?: string | null, useNLU?: string | null, hasCredentials: boolean, status?: { type: string, email: string, timestamp: any } | null, additionalInformationQuestions?: { intendedForUnderThirteen?: boolean | null, alcoholAndTobaccoRelatedContent?: boolean | null } | null } | { __typename: 'AlexaAppChannel', type: string, name?: string | null, id: string, directoryListing?: string | null, endPoint?: string | null, useNLU?: string | null, invocationName?: string | null, hasCredentials: boolean, skillId?: string | null, vendorId?: string | null, category?: AlexaSkillCategories | null, distributionMode?: AlexaDistributionMode | null, isAvailableWorldwide?: boolean | null, distributionCountries?: Array<AlexaDistrubutionCountry | null> | null, useManifest?: boolean | null, status?: { type: string, email: string, timestamp: any } | null, permissions?: Array<{ name?: AlexaChannelPermissionType | null } | null> | null, vendors?: Array<{ id: string, name: string, roles: Array<string | null> } | null> | null, privacyAndCompliance?: { allowsPurchases?: boolean | null, containsAds?: boolean | null, isChildDirected?: boolean | null, isExportCompliant?: boolean | null, usesPersonalInfo?: boolean | null } | null } | { __typename: 'AppChannel', id: string, type: string, name?: string | null, directoryListing?: string | null, endPoint?: string | null, useNLU?: string | null, status?: { type: string, email: string, timestamp: any } | null } | { __typename: 'ChatWidgetAppChannel', type: string, name?: string | null, id: string, directoryListing?: string | null, endPoint?: string | null, useNLU?: string | null, direct?: boolean | null, disabled?: boolean | null, accountKey?: string | null, botName?: string | null, avatarUrl?: any | null, key?: string | null, serverUrl?: any | null, middlewareUrl?: string | null, autocompleteSuggestionsUrl?: any | null, autoOpenOnWidth?: string | null, status?: { type: string, email: string, timestamp: any } | null, cta?: { message?: string | null, timeout?: number | null, delay?: number | null, animation?: CtaAnimation | null, animationTimeout?: number | null, mobile?: { applyAtLessThanWidth?: string | null, message?: string | null, timeout?: number | null, delay?: number | null, animation?: CtaAnimation | null, animationTimeout?: number | null } | null } | null, menu?: { menuButtonLocation?: ChatWidgetMenuButtonLocation | null, itemsTabIndex?: string | null, items?: Array<{ label?: string | null, subtitle?: string | null } | { url: string, text: string, behavior?: { type: ChatWidgetAppChannelWidgetUrlBehaviorType } | { width?: number | null, height?: number | null, type: ChatWidgetAppChannelWidgetUrlBehaviorType } | { type: ChatWidgetAppChannelWidgetUrlBehaviorType } | null } | { imageUrl?: string | null } | { title?: string | null, body?: string | null } | null> | null, button?: { tabIndex?: string | null } | null } | null, configurableMessages?: { items?: Array<{ delay?: number | null, text?: string | null } | null> | null } | null, urls?: { policies: Array<{ pattern: string, behavior: { type: ChatWidgetAppChannelWidgetUrlBehaviorType } | { width?: number | null, height?: number | null, type: ChatWidgetAppChannelWidgetUrlBehaviorType } | { type: ChatWidgetAppChannelWidgetUrlBehaviorType } } | null>, defaultBehavior: { type: ChatWidgetAppChannelWidgetUrlBehaviorType } | { width?: number | null, height?: number | null, type: ChatWidgetAppChannelWidgetUrlBehaviorType } | { type: ChatWidgetAppChannelWidgetUrlBehaviorType } } | null, autoOpenOnPattern?: { minimumWidth?: string | null, patterns?: Array<string | null> | null } | null, chatButton?: { imageUrl?: string | null, tabIndex?: string | null } | null, actionBar?: { enabled: boolean, position?: ActionBarPosition | null, mobileBreakpoint?: number | null, buttons: Array<{ id: string, type: ActionBarButtonType, label?: string | null, icon?: ActionBarIconType | null, iconUrl?: string | null, visibility?: ActionBarButtonVisibility | null, tabIndex?: number | null } | { id: string, type: ActionBarButtonType, label?: string | null, icon?: ActionBarIconType | null, iconUrl?: string | null, visibility?: ActionBarButtonVisibility | null, tabIndex?: number | null, emailAddress: string, subject?: string | null, body?: string | null } | { id: string, type: ActionBarButtonType, label?: string | null, icon?: ActionBarIconType | null, iconUrl?: string | null, visibility?: ActionBarButtonVisibility | null, tabIndex?: number | null, intentId?: string | null, autoGreeting?: boolean | null, preselectChipLabel?: string | null } | { id: string, type: ActionBarButtonType, label?: string | null, icon?: ActionBarIconType | null, iconUrl?: string | null, visibility?: ActionBarButtonVisibility | null, tabIndex?: number | null, url: string, target?: ActionBarButtonTarget | null } | { id: string, type: ActionBarButtonType, label?: string | null, icon?: ActionBarIconType | null, iconUrl?: string | null, visibility?: ActionBarButtonVisibility | null, tabIndex?: number | null, url: string, target?: ActionBarButtonTarget | null } | { id: string, type: ActionBarButtonType, label?: string | null, icon?: ActionBarIconType | null, iconUrl?: string | null, visibility?: ActionBarButtonVisibility | null, tabIndex?: number | null, phoneNumber: string } | { id: string, type: ActionBarButtonType, label?: string | null, icon?: ActionBarIconType | null, iconUrl?: string | null, visibility?: ActionBarButtonVisibility | null, tabIndex?: number | null, intentId?: string | null, autoGreeting?: boolean | null, preselectChipLabel?: string | null } | { id: string, type: ActionBarButtonType, label?: string | null, icon?: ActionBarIconType | null, iconUrl?: string | null, visibility?: ActionBarButtonVisibility | null, tabIndex?: number | null, url: string, target?: ActionBarButtonTarget | null }> } | null, header?: { alignTextCenter?: boolean | null, status?: { online?: string | null, offline?: string | null, away?: string | null, connecting?: string | null } | null, subtitle?: { enabled?: boolean | null, text?: string | null } | null, actions?: { refresh?: boolean | null, refreshTabIndex?: string | null, minimize?: boolean | null, minimizeTabIndex?: string | null, cancel?: boolean | null, cancelTabIndex?: string | null } | null } | null, footer?: { branding?: { enabled?: boolean | null, text?: string | null } | null, sendButton?: { icon?: string | null, tabIndex?: string | null } | null, clearButton?: { tabIndex?: string | null } | null } | null, typingStatus?: { textTypingStatusEnabled?: boolean | null } | null, theme?: { primaryColor?: string | null, zIndex?: string | null, border?: { color?: string | null, width?: string | null, radius?: string | null } | null, carousel?: { button?: { color?: string | null } | null, subtitle?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null } | null, title?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null } | null } | null, chatButton?: { background?: string | null, border?: { color?: string | null, radius?: string | null, width?: string | null } | null, imageSize?: { width?: string | null, height?: string | null } | null, animation?: { primaryColor?: string | null, secondaryColor?: string | null, opacity?: number | null } | null, margin?: { top?: string | null, right?: string | null, bottom?: string | null, left?: string | null } | null } | null, content?: { background?: string | null } | null, cta?: { background?: string | null, text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null } | null } | null, footer?: { background?: string | null, border?: { color?: string | null, radius?: string | null, width?: string | null } | null, branding?: { text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null } | null } | null } | null, header?: { background?: string | null, avatarBackground?: string | null, border?: { color?: string | null, radius?: string | null, width?: string | null } | null, padding?: { left?: string | null, right?: string | null, top?: string | null, bottom?: string | null } | null, text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null } | null, subtitle?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null } | null } | null, input?: { background?: string | null, border?: { color?: string | null, width?: string | null, radius?: string | null } | null, text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null } | null, placeholder?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, fontStyle?: string | null } | null } | null, menu?: { item?: { height?: string | null, background?: string | null, text?: { color?: string | null, fontSize?: string | null, fontFamily?: string | null, fontWeight?: string | null, fontStyle?: string | null } | null } | null } | null, menuButton?: { color?: string | null } | null, messages?: { maxWidth?: string | null, mine?: { bubbleColor?: string | null, text?: { color?: string | null, fontSize?: string | null, fontFamily?: string | null, fontWeight?: string | null, fontStyle?: string | null } | null } | null, others?: { bubbleColor?: string | null, text?: { color?: string | null, fontSize?: string | null, fontFamily?: string | null, fontWeight?: string | null, fontStyle?: string | null } | null } | null, padding?: { left?: string | null, right?: string | null, bottom?: string | null, top?: string | null } | null } | null, minimizeButton?: { color?: string | null } | null, cancelButton?: { color?: string | null } | null, refreshButton?: { color?: string | null } | null, sendButton?: { color?: string | null, width?: string | null } | null, size?: { width?: string | null, height?: string | null } | null, textTypingStatus?: { text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null } | null } | null } | null, input?: { placeholder?: string | null } | null, connection?: { type?: ChatWidgetServerType | null, serverUrl?: any | null } | null } | { __typename: 'DialogflowAppChannel', type: string, name?: string | null, id: string, directoryListing?: string | null, endPoint?: string | null, useNLU?: string | null, hasCredentials: boolean, status?: { type: string, email: string, timestamp: any } | null, additionalInformationQuestions?: { intendedForUnderThirteen?: boolean | null, alcoholAndTobaccoRelatedContent?: boolean | null } | null } | { __typename: 'EmailAppChannel', type: string, name?: string | null, id: string, directoryListing?: string | null, endPoint?: string | null, useNLU?: string | null, status?: { type: string, email: string, timestamp: any } | null } | { __typename: 'FacebookMessengerAppChannel', type: string, name?: string | null, id: string, directoryListing?: string | null, endPoint?: string | null, useNLU?: string | null, status?: { type: string, email: string, timestamp: any } | null } | { __typename: 'FormWidgetAppChannel', type: string, name?: string | null, id: string, directoryListing?: string | null, endPoint?: string | null, useNLU?: string | null, key?: string | null, autoGreeting?: string | null, intentId?: string | null, sideButtonLabel?: string | null, businessName?: string | null, businessLogoUrl?: string | null, businessAddress?: string | null, businessWebsite?: string | null, chatWidgetKey?: string | null, metaPixelId?: string | null, status?: { type: string, email: string, timestamp: any } | null, trustedForm?: { scriptUrl: string } | null, autoOpen?: { enabled?: boolean | null } | null, connection?: { serverUrl?: any | null, accountKey?: string | null } | null, theme?: { accentColor?: string | null, backgroundColor?: string | null, headerBackgroundColor?: string | null, headerTextColor?: string | null, primaryButtonColor?: string | null, primaryButtonTextColor?: string | null, secondaryButtonColor?: string | null, secondaryButtonTextColor?: string | null, data?: any | null, card?: { backgroundColor?: string | null, color?: string | null, fontSize?: string | null } | null, checkbox?: { backgroundColor?: string | null, color?: string | null, fontSize?: string | null } | null, chips?: { backgroundColor?: string | null, backgroundColorSelected?: string | null, color?: string | null, colorSelected?: string | null, fontSize?: string | null } | null, date?: { backgroundColor?: string | null, backgroundColorSelected?: string | null, color?: string | null, fontSize?: string | null } | null, dropdown?: { backgroundColor?: string | null, color?: string | null, fontSize?: string | null } | null, sideButton?: { backgroundColor?: string | null, color?: string | null, top?: string | null, position?: string | null, minLength?: string | null, fontSize?: string | null } | null, text?: { backgroundColor?: string | null, color?: string | null, fontSize?: string | null } | null, standAlone?: { backgroundColor?: string | null, header?: { backgroundColor?: string | null, color?: string | null, fontSize?: string | null } | null } | null } | null } | { __typename: 'GoogleBusinessMessagesAppChannel', type: string, name?: string | null, id: string, directoryListing?: string | null, endPoint?: string | null, useNLU?: string | null, status?: { type: string, email: string, timestamp: any } | null } | { __typename: 'IntelligentSearchAppChannel', type: string, name?: string | null, id: string, directoryListing?: string | null, endPoint?: string | null, useNLU?: string | null, key?: string | null, autocompleteSuggestionsUrl?: any | null, status?: { type: string, email: string, timestamp: any } | null, connection?: { serverUrl?: any | null } | null, theme?: { accentColor?: string | null, border?: { color?: string | null, width?: string | null, radius?: string | null, style?: IntelligentSearchWidgetBorderStyle | null } | null, card?: { background?: string | null, border?: { color?: string | null, width?: string | null, radius?: string | null, style?: IntelligentSearchWidgetBorderStyle | null } | null, description?: { margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null, lineHeight?: any | null } | null } | null, link?: { margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, text?: { default?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null, lineHeight?: any | null } | null } | null } | null, margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, title?: { margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null, lineHeight?: any | null } | null } | null } | null, carousel?: { card?: { background?: string | null, border?: { color?: string | null, width?: string | null, radius?: string | null, style?: IntelligentSearchWidgetBorderStyle | null } | null, description?: { margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null, lineHeight?: any | null } | null } | null, link?: { margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, text?: { default?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null, lineHeight?: any | null } | null } | null } | null, margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, title?: { margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null, lineHeight?: any | null } | null } | null } | null } | null, list?: { card?: { background?: string | null, border?: { color?: string | null, width?: string | null, radius?: string | null, style?: IntelligentSearchWidgetBorderStyle | null } | null, description?: { margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null, lineHeight?: any | null } | null } | null, link?: { margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, text?: { default?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null, lineHeight?: any | null } | null } | null } | null, margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, title?: { margin?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, padding?: { bottom?: string | null, left?: string | null, right?: string | null, top?: string | null } | null, text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null, lineHeight?: any | null } | null } | null } | null } | null, messages?: { others?: { bubble?: { background?: string | null } | null, text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null, fontStyle?: string | null, fontWeight?: string | null, lineHeight?: any | null } | null } | null } | null } | null } | { __typename: 'LexConnectAppChannel', type: string, name?: string | null, id: string, directoryListing?: string | null, endPoint?: string | null, useNLU?: string | null, voiceId?: string | null, nluIntentConfidenceThreshold?: number | null, idleSessionTTLInSeconds?: number | null, detectSentiment?: boolean | null, isLinkedToKendra: boolean, lexPostTextUrl?: string | null, enableModelImprovements?: boolean | null, botName?: string | null, status?: { type: string, email: string, timestamp: any } | null } | { __typename: 'LexV2ConnectAppChannel', type: string, name?: string | null, id: string, directoryListing?: string | null, endPoint?: string | null, useNLU?: string | null, voiceId?: string | null, idleSessionTTLInSeconds?: number | null, detectSentiment?: boolean | null, isLinkedToKendra: boolean, lexPostTextUrl?: string | null, enableModelImprovements?: boolean | null, botId?: string | null, botName?: string | null, botRegion?: string | null, lexFulfillmentLambdaARN?: string | null, managementRole?: string | null, managementRoleExternalId?: string | null, status?: { type: string, email: string, timestamp: any } | null } | null } | null };

export type AdminVerifyPlaceMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  placeId: Scalars['ID']['input'];
  verified: Scalars['Boolean']['input'];
}>;


export type AdminVerifyPlaceMutation = { admin?: { app: { update: { verifyGooglePlacesId: { __typename: 'App', appId: string, places?: Array<{ __typename: 'AppPlaceDescription', name?: string | null, placeId?: string | null, formattedAddress?: string | null, default?: boolean | null, website?: any | null, phone?: string | null, adminVerified?: boolean | null, bookingOptOut?: boolean | null, addressComponents?: Array<{ longName?: string | null, shortName?: string | null, types?: Array<string> | null }> | null }> | null } } } } | null };

export type CopyAppMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  toOrg: Scalars['ID']['input'];
  overrideApp?: InputMaybe<CopyAppOverrideAttributes>;
}>;


export type CopyAppMutation = { copyApp: { appId: string, organizationId: string, name: string, status?: { type: string } | null } };

export type GetAppLimitationsQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
}>;


export type GetAppLimitationsQuery = { app?: { __typename: 'App', _id: string, appId: string, organizationId: string, icon?: string | null, limitations: { actionBar: boolean, advancedAnalytics: boolean, excludedIntegrations?: Array<string> | null, maxHandlers: number, maxIntents: number, maxEntities: number, captureLead: boolean, schedule: boolean, preferredTime: boolean, aiLeadTagging: boolean, liveTakeover: boolean, transcriptAccess: boolean, maxKendraDocs: number, reserveWithGoogle: boolean } } | null };

export type GetAppInfoQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
}>;


export type GetAppInfoQuery = { app?: { __typename: 'App', _id: string, appId: string, banner?: string | null, beta?: any | null, businessDescription?: string | null, businessHighValueLeadDescription?: string | null, canCaptureLeads: boolean, description?: string | null, examplePhrases?: Array<string | null> | null, icon?: string | null, invocationName?: string | null, keywords?: Array<string | null> | null, largeBanner?: string | null, largeIcon?: string | null, leadsContact?: any | null, leadsContactPhone?: string | null, mediumIcon?: string | null, name: string, organizationId: string, privacyPolicyUrl?: string | null, smallIcon?: string | null, stripeProductId?: string | null, stripeSubscriptionId?: string | null, subscriptionPaymentStatus?: string | null, summary?: string | null, templateType?: string | null, termsOfUseUrl?: string | null, website?: string | null, referenceId?: { service: string, id: string } | null, availability?: { availableDays?: Array<CrmDayOfWeek | null> | null, maxTotalDailyAppointments?: number | null, delayedJobTypes?: Array<string | null> | null, defaultAvailabilityClass?: string | null, blockedDays?: Array<{ time?: string | null, date?: string | null } | null> | null, availabilityClasses?: Array<{ id: string, name: string, summary: string, numberOfDaysOut?: number | null, appointmentsPerDay?: number | null, leadOnly?: boolean | null } | null> | null, defaultBusyDays?: { availableDays?: Array<CrmDayOfWeek | null> | null, blockWeekends?: boolean | null, blockCurrentDay?: boolean | null, currentDayAvailableUntil?: string | null, blockNextBusinessDays?: number | null } | null } | null, subscription?: { __typename: 'SubscriptionDetails', summary?: { __typename: 'SubscriptionSummary', trialEndDate?: string | null, isCancelled: boolean, status: string, lastCharge?: { amount: number, currency: string, date: string, paid: boolean } | null, nextCharge?: { amountDue: number, currency: string, date: string } | null } | null } | null, status?: { __typename: 'Status', type: string, notes?: string | null, timestamp: any, email: string, statusHistory?: Array<{ type: string, notes?: string | null, timestamp: any, email: string } | null> | null } | null, location?: { streetAddress?: string | null, geocode?: { longitude?: number | null, latitude?: number | null } | null } | null, platformData?: { alexa?: { platform: string, privacyAndCompliance: { allowsPurchases?: boolean | null, usesPersonalInfo?: boolean | null, isChildDirected?: boolean | null, isExportCompliant?: boolean | null, containsAds?: boolean | null } } | null, google?: { platform: string, additionalInformationQuestions?: { alcoholAndTobaccoRelatedContent: boolean } | null } | null } | null, opportunityAlerts: Array<{ email: any, disabled?: boolean | null, placeId?: string | null, alerts: Array<{ duringBusinessHours?: boolean | null, outsideBusinessHours?: boolean | null, type: OpportunityAlertDetailType }> } | { phoneNumber: string, consented: boolean, disabled?: boolean | null, placeId?: string | null, alerts: Array<{ duringBusinessHours?: boolean | null, outsideBusinessHours?: boolean | null, type: OpportunityAlertDetailType }> } | { disabled?: boolean | null, placeId?: string | null, alerts: Array<{ duringBusinessHours?: boolean | null, outsideBusinessHours?: boolean | null, type: OpportunityAlertDetailType }> }>, places?: Array<{ __typename: 'AppPlaceDescription', name?: string | null, placeId?: string | null, formattedAddress?: string | null, default?: boolean | null, website?: any | null, phone?: string | null, adminVerified?: boolean | null, bookingOptOut?: boolean | null, lastRefreshedFromGoogle?: any | null, partnerId?: { service: string, id: string } | null, addressComponents?: Array<{ longName?: string | null, shortName?: string | null, types?: Array<string> | null }> | null, openingHours?: { weekdayText?: Array<string> | null, openNow?: boolean | null, periods?: Array<{ open: { day: number, time: string }, close?: { day: number, time: string } | null }> | null } | null }> | null, lacrm: { __typename: 'Integration', isAllowed: boolean, isLinked: boolean, isActive: boolean }, jobber: { __typename: 'Integration', isAllowed: boolean, isLinked: boolean, isActive: boolean }, servicetitan: { __typename: 'Integration', isAllowed: boolean, isLinked: boolean, isActive: boolean }, surefire: { __typename: 'Integration', isAllowed: boolean, isLinked: boolean, isActive: boolean }, housecallpro: { __typename: 'Integration', isAllowed: boolean, isLinked: boolean, isActive: boolean }, fieldpulse: { __typename: 'Integration', isAllowed: boolean, isLinked: boolean, isActive: boolean }, servicefusion: { __typename: 'Integration', isAllowed: boolean, isLinked: boolean, isActive: boolean }, zapier: { __typename: 'Integration', isAllowed: boolean, isLinked: boolean, isActive: boolean }, serviceminder: { __typename: 'Integration', isAllowed: boolean, isLinked: boolean, isActive: boolean }, contractor_appointments: { __typename: 'Integration', isAllowed: boolean, isLinked: boolean, isActive: boolean }, webhook: { __typename: 'Integration', isAllowed: boolean, isLinked: boolean, isActive: boolean }, boberdoo: { __typename: 'Integration', isAllowed: boolean, isLinked: boolean, isActive: boolean }, test: { __typename: 'Integration', isAllowed: boolean, isLinked: boolean, isActive: boolean }, organization?: { organizationId: string, name: string, type: SubscriptionType, limitations: { allowedChannels?: Array<string> | null, maxUniqueSessionsPerMonth: number, maxDocumentCrawls: number, maxTestsExecutedPerMonth: number }, manualOverrideAvailableFeatures?: { allowedChannels?: Array<string> | null, maxUniqueSessionsPerMonth?: number | null, maxDocumentCrawls?: number | null, maxTestsExecutedPerMonth?: number | null } | null } | null } | null };

export type GetAppNotificationsQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
}>;


export type GetAppNotificationsQuery = { app?: { systemNotifications?: Array<{ id: string, name: string, message: string, level: SystemNotificationLevel, created: any } | null> | null } | null };

export type UpdateApplicationMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  app: UpdateAppInput;
}>;


export type UpdateApplicationMutation = { updateApp?: { __typename: 'App', appId: string, banner?: string | null, beta?: any | null, businessDescription?: string | null, businessHighValueLeadDescription?: string | null, description?: string | null, examplePhrases?: Array<string | null> | null, icon?: string | null, invocationName?: string | null, keywords?: Array<string | null> | null, largeBanner?: string | null, largeIcon?: string | null, leadsContact?: any | null, leadsContactPhone?: string | null, mediumIcon?: string | null, name: string, organizationId: string, privacyPolicyUrl?: string | null, smallIcon?: string | null, summary?: string | null, templateType?: string | null, termsOfUseUrl?: string | null, website?: string | null, leadEmailRoutes?: Array<{ id: string, name: string, emails: Array<any>, priority?: number | null, continueOnMatch?: boolean | null, filters?: { contactType?: Array<string> | null, highValueLead?: boolean | null, jobType?: Array<string> | null, urgency?: Array<string> | null, serviceType?: Array<string> | null } | null }> | null, websiteData?: { crawlExecutionId?: string | null } | null, location?: { streetAddress?: string | null, geocode?: { longitude?: number | null, latitude?: number | null } | null } | null, platformData?: { alexa?: { platform: string, privacyAndCompliance: { allowsPurchases?: boolean | null, usesPersonalInfo?: boolean | null, isChildDirected?: boolean | null, isExportCompliant?: boolean | null, containsAds?: boolean | null } } | null, google?: { platform: string, additionalInformationQuestions?: { alcoholAndTobaccoRelatedContent: boolean } | null } | null } | null, opportunityAlerts: Array<{ disabled?: boolean | null, placeId?: string | null, alerts: Array<{ duringBusinessHours?: boolean | null, outsideBusinessHours?: boolean | null, type: OpportunityAlertDetailType }> } | { disabled?: boolean | null, placeId?: string | null, alerts: Array<{ duringBusinessHours?: boolean | null, outsideBusinessHours?: boolean | null, type: OpportunityAlertDetailType }> } | { disabled?: boolean | null, placeId?: string | null, alerts: Array<{ duringBusinessHours?: boolean | null, outsideBusinessHours?: boolean | null, type: OpportunityAlertDetailType }> }> } | null };

export type GetSubscriptionInfoQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
}>;


export type GetSubscriptionInfoQuery = { org?: { type: SubscriptionType, organizationId: string, name: string, contact?: string | null, acceptedLatestTermsOfService: boolean, billingContact?: { email?: string | null, phoneNumber?: string | null } | null, acceptedTermsOfService: Array<{ acceptedOn: any }>, paymentAccounts?: { stripe?: { customerId: string } | null, so?: { paymentType?: string | null, numberOfApps?: number | null, date?: string | null } | null, aws?: { customerId?: string | null, productCode?: string | null, dimension?: string | null, date?: string | null } | null } | null } | null, app?: { name: string, organizationId: string, appId: string, stripeProductId?: string | null, stripeSubscriptionId?: string | null, subscriptionPaymentStatus?: string | null, templateType?: string | null, status?: { type: string, email: string } | null, subscription?: { __typename: 'SubscriptionDetails', summary?: { __typename: 'SubscriptionSummary', trialEndDate?: string | null, isCancelled: boolean, status: string, lastCharge?: { amount: number, currency: string, date: string, paid: boolean } | null, nextCharge?: { amountDue: number, currency: string, date: string } | null } | null } | null } | null };

export type GetAppOverviewQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  start: Scalars['DateTime']['input'];
  end: Scalars['DateTime']['input'];
  environment?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetAppOverviewQuery = { handler?: { __typename: 'Handler', intentId: string, type: string, data?: any | null, name: string, content?: Array<{ key: string, handlerResponse: Array<{ name?: string | null, conditions?: any | null } | { name?: string | null, conditions?: any | null } | { name?: string | null, conditions?: any | null } | { name?: string | null, conditions?: any | null } | { name?: string | null, conditions?: any | null } | { name?: string | null, conditions?: any | null } | { name?: string | null, conditions?: any | null } | { name?: string | null, conditions?: any | null } | { name?: string | null, conditions?: any | null } | { name?: string | null, conditions?: any | null } | null> } | null> | null } | null, app?: { __typename: 'App', _id: string, appId: string, beta?: any | null, name: string, website?: string | null, description?: string | null, summary?: string | null, organizationId: string, invocationName?: string | null, templateType?: string | null, icon?: string | null, smallIcon?: string | null, largeIcon?: string | null, banner?: string | null, largeBanner?: string | null, leadsContact?: any | null, leadsContactPhone?: string | null, stripeProductId?: string | null, stripeSubscriptionId?: string | null, subscriptionPaymentStatus?: string | null, places?: Array<{ __typename: 'AppPlaceDescription', adminVerified?: boolean | null, bookingOptOut?: boolean | null, default?: boolean | null, formattedAddress?: string | null, name?: string | null, phone?: string | null, placeId?: string | null, website?: any | null, addressComponents?: Array<{ types?: Array<string> | null, longName?: string | null, shortName?: string | null }> | null, openingHours?: { weekdayText?: Array<string> | null, periods?: Array<{ open: { day: number, time: string }, close?: { day: number, time: string } | null }> | null } | null }> | null, systemNotifications?: Array<{ id: string, name: string, message: string, level: SystemNotificationLevel, created: any } | null> | null, platformData?: { alexa?: { platform: string, privacyAndCompliance: { allowsPurchases?: boolean | null, usesPersonalInfo?: boolean | null, isChildDirected?: boolean | null, isExportCompliant?: boolean | null, containsAds?: boolean | null } } | null } | null, status?: { __typename: 'Status', type: string, notes?: string | null, timestamp: any, email: string, statusHistory?: Array<{ type: string, notes?: string | null, timestamp: any, email: string } | null> | null } | null, handlers?: { _id: string, total: number, handlers?: Array<{ __typename: 'GetHandlersListHandler', _id: string, name?: string | null, intentId: string, type: string } | null> | null } | null, intents?: { _id: string, total: number, intents?: Array<{ __typename: 'GetIntentsListIntent', _id: string, name: string, intentId: string, utterancePatterns?: Array<string | null> | null } | null> | null } | null, entities?: { _id: string, total: number, entities?: Array<{ __typename: 'GetEntitiesListEntity', _id: string, entityId: string, displayName: string } | null> | null } | null, content?: { __typename: 'TotalWebContent', total: number, content: Array<{ __typename: 'WebContentWithHighlights', _id: string, name: string, url: string, lastUpdated: any } | null> } | null, contentSources?: { __typename: 'TotalWebContentSources', total: number, sources: Array<{ __typename: 'WebContentSources', webUrl: string, webUrlPatterns: Array<string | null> } | null> } | null, faq?: { total: number } | null, channels?: Array<{ __typename: 'ActionsOnGoogleAppChannel', type: string, id: string, name?: string | null } | { __typename: 'AlexaAppChannel', type: string, id: string, name?: string | null } | { __typename: 'AppChannel', type: string, id: string, name?: string | null } | { __typename: 'ChatWidgetAppChannel', key?: string | null, type: string, id: string, name?: string | null, theme?: { primaryColor?: string | null } | null } | { __typename: 'DialogflowAppChannel', type: string, id: string, name?: string | null } | { __typename: 'EmailAppChannel', type: string, id: string, name?: string | null } | { __typename: 'FacebookMessengerAppChannel', type: string, id: string, name?: string | null } | { __typename: 'FormWidgetAppChannel', key?: string | null, type: string, id: string, name?: string | null, theme?: { accentColor?: string | null } | null } | { __typename: 'GoogleBusinessMessagesAppChannel', type: string, id: string, name?: string | null } | { __typename: 'IntelligentSearchAppChannel', key?: string | null, type: string, id: string, name?: string | null, theme?: { accentColor?: string | null } | null } | { __typename: 'LexConnectAppChannel', type: string, id: string, name?: string | null } | { __typename: 'LexV2ConnectAppChannel', type: string, id: string, name?: string | null } | null> | null, organization?: { organizationId: string, name: string, type: SubscriptionType } | null, analytics?: { user: { totalUsers: number, totalSessions: number, returningUsers: number, newUsers: number } } | null } | null };

export type GetRecentActivityQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  start: Scalars['DateTime']['input'];
  environment?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetRecentActivityQuery = { app?: { __typename: 'App', appId: string, events?: { total: number } | null, formWidgetEvents?: { total: number } | null, chatWidgetEvents?: { total: number } | null, searchEvents?: { total: number } | null, gbmEvents?: { total: number } | null } | null };

export type GetTagAnalyticsQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  environment?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  kbListTag?: InputMaybe<Scalars['String']['input']>;
  kbFAQTag?: InputMaybe<Scalars['String']['input']>;
  kbTopTag?: InputMaybe<Scalars['String']['input']>;
  kbSuggestedTag?: InputMaybe<Scalars['String']['input']>;
  kbNoAnswerTag?: InputMaybe<Scalars['String']['input']>;
  leadStarted?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  leadEnded?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetTagAnalyticsQuery = { app?: { __typename: 'App', appId: string, kbList?: { total: number, events?: Array<{ rawQuery?: string | null } | null> | null } | null, kbFAQ?: { total: number, events?: Array<{ rawQuery?: string | null } | null> | null } | null, kbTop?: { total: number, events?: Array<{ rawQuery?: string | null } | null> | null } | null, kbSuggested?: { total: number, events?: Array<{ rawQuery?: string | null } | null> | null } | null, kbNoAnswer?: { total: number, events?: Array<{ rawQuery?: string | null } | null> | null } | null, leadsStarted?: { total: number, events?: Array<{ rawQuery?: string | null } | null> | null } | null, leadsEnded?: { total: number, events?: Array<{ rawQuery?: string | null } | null> | null } | null } | null };

export type UpdateAppPlatformMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  app: UpdateAppInput;
}>;


export type UpdateAppPlatformMutation = { updateApp?: { __typename: 'App', _id: string, appId: string, name: string, alexaSkillId?: string | null, endPoint?: { actionsOnGoogle?: { url: string } | null, alexa?: { url: string } | null, dialogFlow?: { url: string } | null, google?: { url: string } | null } | null, platformData?: { alexa?: { platform: string, privacyAndCompliance: { allowsPurchases?: boolean | null, usesPersonalInfo?: boolean | null, isChildDirected?: boolean | null, isExportCompliant?: boolean | null, containsAds?: boolean | null } } | null } | null, channels?: Array<{ __typename: 'ActionsOnGoogleAppChannel', id: string, type: string } | { __typename: 'AlexaAppChannel', id: string, type: string } | { __typename: 'AppChannel', id: string, type: string } | { __typename: 'ChatWidgetAppChannel', id: string, type: string } | { __typename: 'DialogflowAppChannel', id: string, type: string } | { __typename: 'EmailAppChannel', id: string, type: string } | { __typename: 'FacebookMessengerAppChannel', id: string, type: string } | { __typename: 'FormWidgetAppChannel', id: string, type: string } | { __typename: 'GoogleBusinessMessagesAppChannel', id: string, type: string } | { __typename: 'IntelligentSearchAppChannel', id: string, type: string } | { __typename: 'LexConnectAppChannel', id: string, type: string } | { __typename: 'LexV2ConnectAppChannel', id: string, type: string } | null> | null } | null };

export type GetAppPlatformsQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
}>;


export type GetAppPlatformsQuery = { app?: { __typename: 'App', _id: string, appId: string, name: string, alexaSkillId?: string | null, endPoint?: { actionsOnGoogle?: { url: string } | null, alexa?: { url: string } | null, dialogFlow?: { url: string } | null, google?: { url: string } | null } | null, platformData?: { alexa?: { platform: string, privacyAndCompliance: { allowsPurchases?: boolean | null, usesPersonalInfo?: boolean | null, isChildDirected?: boolean | null, isExportCompliant?: boolean | null, containsAds?: boolean | null } } | null } | null, channels?: Array<{ __typename: 'ActionsOnGoogleAppChannel', id: string, type: string } | { __typename: 'AlexaAppChannel', id: string, type: string } | { __typename: 'AppChannel', id: string, type: string } | { __typename: 'ChatWidgetAppChannel', id: string, type: string } | { __typename: 'DialogflowAppChannel', id: string, type: string } | { __typename: 'EmailAppChannel', id: string, type: string } | { __typename: 'FacebookMessengerAppChannel', id: string, type: string } | { __typename: 'FormWidgetAppChannel', id: string, type: string } | { __typename: 'GoogleBusinessMessagesAppChannel', id: string, type: string } | { __typename: 'IntelligentSearchAppChannel', id: string, type: string } | { __typename: 'LexConnectAppChannel', id: string, type: string } | { __typename: 'LexV2ConnectAppChannel', id: string, type: string } | null> | null } | null };

export type GetRequestResponseQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  responseOutputText?: InputMaybe<Scalars['String']['input']>;
  rawQueryText?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  byFlag?: InputMaybe<Array<InputMaybe<RawQueryEventFlag>> | InputMaybe<RawQueryEventFlag>>;
  noFlag?: InputMaybe<Scalars['Boolean']['input']>;
  byMatchConfidence?: InputMaybe<MatchConfidenceRange>;
  bySessionId?: InputMaybe<Scalars['String']['input']>;
  environment?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  channel?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetRequestResponseQuery = { app?: { __typename: 'App', name: string, appId: string, organizationId: string, events?: { __typename: 'TotalEvents', total: number, events?: Array<{ __typename: 'Events', environment?: string | null, currentHandler?: string | null, eventId: string, eventIndex: string, eventTime?: string | null, eventName?: string | null, userId?: string | null, request?: string | null, rawQuery?: string | null, platform?: string | null, channel?: string | null, sessionId?: string | null, selectedHandler?: string | null, payload?: string | null, response?: { displays?: any | null, outputSpeech?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title?: string | null, url?: string | null } | null> | null } | null, reprompt?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title?: string | null, url?: string | null } | null> | null } | null } | null, flags?: Array<{ __typename: 'EventFlag', flag: RawQueryEventFlag, flaggedOn: string, note?: string | null, userEmail: string } | null> | null, slots?: Array<{ __typename: 'EventSlots', name?: string | null, rawValue?: string | null, stringValue?: string | null, dateValue?: string | null, startDateValue?: string | null, endDateValue?: string | null, booleanValue?: boolean | null, integerValue?: number | null, stringArrayValue?: Array<string | null> | null, slotValue?: string | null } | null> | null, stentorRequest?: { platform?: string | null, type?: string | null, anonymous?: boolean | null, channel?: string | null, intentId?: string | null, isHealthCheck?: boolean | null, isNewSession?: boolean | null, rawQuery?: string | null, matchConfidence?: number | null, sessionId?: string | null, userId?: string | null, locale?: string | null, sessionAttributes?: { channel?: string | null, userId?: string | null, sessionId?: string | null } | null } | null } | null> | null, flagTotals: { OPTIMAL: number, CORRECT: number, NEEDS_HUMAN: number, INCORRECT: number, CONFIRMED_CORRECT: number, HELPFUL: number, FLAGGED: number } } | null } | null };

export type GetRawQueryQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  byName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  rawQueryText?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  byFlag?: InputMaybe<Array<InputMaybe<RawQueryEventFlag>> | InputMaybe<RawQueryEventFlag>>;
  noFlag?: InputMaybe<Scalars['Boolean']['input']>;
  byMatchConfidenceRange?: InputMaybe<MatchConfidenceRange>;
  environment?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetRawQueryQuery = { app?: { __typename: 'App', name: string, appId: string, organizationId: string, events?: { __typename: 'TotalEvents', total: number, events?: Array<{ __typename: 'Events', environment?: string | null, currentHandler?: string | null, eventId: string, eventIndex: string, eventTime?: string | null, request?: string | null, rawQuery?: string | null, channel?: string | null, platform?: string | null, selectedHandler?: string | null, sessionId?: string | null, flags?: Array<{ __typename: 'EventFlag', flag: RawQueryEventFlag, flaggedOn: string, note?: string | null, userEmail: string } | null> | null, slots?: Array<{ __typename: 'EventSlots', name?: string | null, rawValue?: string | null, stringValue?: string | null, dateValue?: string | null, startDateValue?: string | null, endDateValue?: string | null, booleanValue?: boolean | null, integerValue?: number | null, stringArrayValue?: Array<string | null> | null, slotValue?: string | null } | null> | null, stentorRequest?: { platform?: string | null, type?: string | null, anonymous?: boolean | null, channel?: string | null, intentId?: string | null, isHealthCheck?: boolean | null, isNewSession?: boolean | null, rawQuery?: string | null, matchConfidence?: number | null, sessionId?: string | null, userId?: string | null, locale?: string | null, sessionAttributes?: { channel?: string | null, userId?: string | null, sessionId?: string | null } | null } | null } | null> | null, flagTotals: { OPTIMAL: number, CORRECT: number, NEEDS_HUMAN: number, CONFIRMED_CORRECT: number, INCORRECT: number, HELPFUL: number, FLAGGED: number } } | null } | null };

export type GetSessionEventsQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  sessionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSessionEventsQuery = { app?: { appId: string, events?: { total: number, events?: Array<{ eventId: string, sessionId?: string | null, eventType?: string | null, eventName?: string | null, rawQuery?: string | null, stentorRequest?: { platform?: string | null, type?: string | null, anonymous?: boolean | null, channel?: string | null, intentId?: string | null, isHealthCheck?: boolean | null, isNewSession?: boolean | null, rawQuery?: string | null, matchConfidence?: number | null, sessionId?: string | null, userId?: string | null, locale?: string | null, sessionAttributes?: { channel?: string | null, userId?: string | null, sessionId?: string | null } | null } | null, response?: { displays?: any | null, reprompt?: { displayText?: string | null, ssml?: string | null } | null, outputSpeech?: { displayText?: string | null, ssml?: string | null } | null } | null } | null> | null } | null } | null };

export type ExportAppMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
}>;


export type ExportAppMutation = { app: { update: { exportApp: { url: any } } } };

export type UpdateStatusMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateStatusMutation = { app: { update: { changeStatus: { __typename: 'App', status?: { type: string, notes?: string | null, email: string, timestamp: any } | null } } } };

export type UpdateEmailOpportunityAlertsMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  alert: EmailOpportunityAlertInput;
}>;


export type UpdateEmailOpportunityAlertsMutation = { app: { update: { addEmailOpportunityAlert: { __typename: 'App', appId: string, opportunityAlerts: Array<{ email: any, disabled?: boolean | null, placeId?: string | null, alerts: Array<{ duringBusinessHours?: boolean | null, outsideBusinessHours?: boolean | null, type: OpportunityAlertDetailType }> } | { disabled?: boolean | null, placeId?: string | null, alerts: Array<{ duringBusinessHours?: boolean | null, outsideBusinessHours?: boolean | null, type: OpportunityAlertDetailType }> } | { disabled?: boolean | null, placeId?: string | null, alerts: Array<{ duringBusinessHours?: boolean | null, outsideBusinessHours?: boolean | null, type: OpportunityAlertDetailType }> }> } } } };

export type UpdateTextOpportunityAlertsMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  alert: TextOpportunityAlertInput;
}>;


export type UpdateTextOpportunityAlertsMutation = { app: { update: { addTextOpportunityAlert: { __typename: 'App', appId: string, opportunityAlerts: Array<{ disabled?: boolean | null, placeId?: string | null, alerts: Array<{ duringBusinessHours?: boolean | null, outsideBusinessHours?: boolean | null, type: OpportunityAlertDetailType }> } | { phoneNumber: string, consented: boolean, disabled?: boolean | null, placeId?: string | null, alerts: Array<{ duringBusinessHours?: boolean | null, outsideBusinessHours?: boolean | null, type: OpportunityAlertDetailType }> } | { disabled?: boolean | null, placeId?: string | null, alerts: Array<{ duringBusinessHours?: boolean | null, outsideBusinessHours?: boolean | null, type: OpportunityAlertDetailType }> }> } } } };

export type UpdatePlacesMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  input: UpdateAppInput;
}>;


export type UpdatePlacesMutation = { app: { update: { updateApp: { __typename: 'App', _id: string, appId: string, places?: Array<{ name?: string | null, placeId?: string | null, formattedAddress?: string | null, default?: boolean | null, website?: any | null, phone?: string | null, adminVerified?: boolean | null, bookingOptOut?: boolean | null, addressComponents?: Array<{ longName?: string | null, shortName?: string | null, types?: Array<string> | null }> | null, openingHours?: { weekdayText?: Array<string> | null, periods?: Array<{ open: { day: number, time: string }, close?: { day: number, time: string } | null }> | null } | null }> | null } } } };

export type RefreshPlaceFromGoogleMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  placeId: Scalars['ID']['input'];
}>;


export type RefreshPlaceFromGoogleMutation = { app: { update: { refreshPlaceFromGoogle: { __typename: 'App', appId: string, places?: Array<{ name?: string | null, placeId?: string | null, formattedAddress?: string | null, default?: boolean | null, website?: any | null, phone?: string | null, adminVerified?: boolean | null, bookingOptOut?: boolean | null, lastRefreshedFromGoogle?: any | null, addressComponents?: Array<{ longName?: string | null, shortName?: string | null, types?: Array<string> | null }> | null, openingHours?: { weekdayText?: Array<string> | null, openNow?: boolean | null, periods?: Array<{ open: { day: number, time: string }, close?: { day: number, time: string } | null }> | null } | null }> | null } } } };

export type GetAppStatusInfoQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
}>;


export type GetAppStatusInfoQuery = { app?: { __typename: 'App', appId: string, status?: { type: string, notes?: string | null, email: string } | null, opportunityAlerts: Array<{ disabled?: boolean | null, placeId?: string | null, alerts: Array<{ duringBusinessHours?: boolean | null, outsideBusinessHours?: boolean | null, type: OpportunityAlertDetailType }> } | { disabled?: boolean | null, placeId?: string | null, alerts: Array<{ duringBusinessHours?: boolean | null, outsideBusinessHours?: boolean | null, type: OpportunityAlertDetailType }> } | { disabled?: boolean | null, placeId?: string | null, alerts: Array<{ duringBusinessHours?: boolean | null, outsideBusinessHours?: boolean | null, type: OpportunityAlertDetailType }> }> } | null };

export type GetAppSettingsInfoQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
}>;


export type GetAppSettingsInfoQuery = { org?: { __typename: 'Organization', organizationId: string, type: SubscriptionType, beta?: any | null, apps?: { total: number } | null } | null, app?: { __typename: 'App', appId: string, organizationId: string, beta?: any | null, name: string, templateType?: string | null, website?: string | null, leadsContact?: any | null, leadsContactPhone?: string | null, stripeProductId?: string | null, stripeSubscriptionId?: string | null, subscriptionPaymentStatus?: string | null, icon?: string | null, leadEmailRoutes?: Array<{ id: string, name: string, emails: Array<any>, priority?: number | null, continueOnMatch?: boolean | null, filters?: { contactType?: Array<string> | null, highValueLead?: boolean | null, jobType?: Array<string> | null, urgency?: Array<string> | null, serviceType?: Array<string> | null } | null }> | null, status?: { type: string, notes?: string | null, timestamp: any, statusHistory?: Array<{ type: string, email: string, timestamp: any, notes?: string | null } | null> | null } | null } | null };

export type CreateTokenMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
}>;


export type CreateTokenMutation = { app: { update: { cms: { create: { appId?: string | null, token: string, tokenId: string, created: any, scope: Array<string | null>, mask: string } } } } };

export type DeleteTokenMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  tokenId: Scalars['ID']['input'];
}>;


export type DeleteTokenMutation = { app: { update: { cms: { update: { delete: string } } } } };

export type GetAppTokensQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
}>;


export type GetAppTokensQuery = { app?: { __typename: 'App', appId: string, cmsTokens: Array<{ __typename: 'CMSToken', tokenId: string, mask: string, appId?: string | null, created: any, scope: Array<string | null> } | null> } | null };

export type CreateCampaignMutationVariables = Exact<{
  campaign: CreateCampaignInput;
}>;


export type CreateCampaignMutation = { createCampaign: { campaignId: string, name: string, status: CampaignStatus, channelId: string, intentId: string, bookingUrl?: string | null } };

export type UpdateCampaignMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  campaign: UpdateCampaignInput;
}>;


export type UpdateCampaignMutation = { updateCampaign: { campaignId: string, name: string, offerTitle?: string | null, offerTerms?: string | null, jobTypePin?: string | null, startDate?: any | null, endDate?: any | null, status: CampaignStatus, canonicalSource: string } };

export type ArchiveCampaignMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type ArchiveCampaignMutation = { archiveCampaign: { campaignId: string, status: CampaignStatus } };

export type CampaignsQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
}>;


export type CampaignsQuery = { campaigns: Array<{ campaignId: string, appId: string, name: string, offerTitle?: string | null, offerTerms?: string | null, jobTypePin?: string | null, startDate?: any | null, endDate?: any | null, status: CampaignStatus, canonicalSource: string, channelId: string, intentId: string, bookingUrl?: string | null, createdAt: any, updatedAt: any }> };

export type CampaignQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignQuery = { campaign?: { campaignId: string, appId: string, name: string, offerTitle?: string | null, offerTerms?: string | null, jobTypePin?: string | null, startDate?: any | null, endDate?: any | null, status: CampaignStatus, canonicalSource: string, channelId: string, intentId: string, bookingUrl?: string | null, createdAt: any, updatedAt: any } | null };

export type DeleteAppMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
}>;


export type DeleteAppMutation = { app: { update: { deleteApp: string } } };

export type CrawlMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  webUrl: Scalars['URL']['input'];
  webUrlPatterns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  stealth?: InputMaybe<Scalars['Boolean']['input']>;
  settlingTimeSeconds?: InputMaybe<Scalars['settlingTimeSeconds_Int_max_5_exclusiveMin_0']['input']>;
}>;


export type CrawlMutation = { startWebsiteCrawling: string };

export type GetAppContentQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  size: Scalars['Int']['input'];
  from: Scalars['Int']['input'];
}>;


export type GetAppContentQuery = { app?: { appId: string, contentSources?: { __typename: 'TotalWebContentSources', total: number, sources: Array<{ __typename: 'WebContentSources', webUrl: string, webUrlPatterns: Array<string | null> } | null> } | null, content?: { total: number, content: Array<{ _id: string, name: string, url: string, type: WebContentType, lastUpdated: any, text: string } | null> } | null, faq?: { total: number } | null } | null };

export type GetContentSourcesQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
}>;


export type GetContentSourcesQuery = { app?: { __typename: 'App', appId: string, contentSources?: { __typename: 'TotalWebContentSources', sources: Array<{ __typename: 'WebContentSources', webUrl: string, webUrlPatterns: Array<string | null> } | null> } | null } | null };

export type CreateEntityMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  displayName: Scalars['String']['input'];
  values?: InputMaybe<Array<EntityValueInput> | EntityValueInput>;
}>;


export type CreateEntityMutation = { addEntity: { __typename: 'Entity', appId: string, entityId: string, displayName: string, type?: EntityType | null, validation: { isValid: boolean, errors: Array<{ errorMessage: string, propertyName?: string | null } | null> }, intents: { intents?: Array<{ intentId: string, appId: string, organizationId: string, name: string } | null> | null } } };

export type UpdateEntityMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
  entity: UpdateEntityInput;
}>;


export type UpdateEntityMutation = { updateEntity: { __typename: 'Entity', appId: string, entityId: string, displayName: string, dialogflowId?: string | null, type?: EntityType | null, values?: Array<{ name: string, synonyms?: Array<string> | null }> | null, validation: { isValid: boolean, errors: Array<{ errorMessage: string, propertyName?: string | null } | null> }, intents: { total: number, intents?: Array<{ __typename: 'Intent', _id: string, intentId: string, appId: string, organizationId: string, name: string } | null> | null } } };

export type DeleteEntityMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
}>;


export type DeleteEntityMutation = { deleteEntity: string };

export type GetEntitiesListQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  withIdOrDisplayName?: InputMaybe<Scalars['String']['input']>;
  withValueOrSynonym?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetEntitiesListQuery = { app?: { __typename: 'App', appId: string, entities?: { total: number, entities?: Array<{ entityId: string, displayName: string } | null> | null } | null } | null };

export type GetEntityQueryVariables = Exact<{
  appId: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
}>;


export type GetEntityQuery = { entity?: { __typename: 'Entity', appId: string, entityId: string, displayName: string, dialogflowId?: string | null, type?: EntityType | null, createdAt?: string | null, updatedAt?: string | null, values?: Array<{ name: string, synonyms?: Array<string> | null }> | null, validation: { isValid: boolean, errors: Array<{ errorMessage: string, propertyName?: string | null } | null> }, intents: { total: number, intents?: Array<{ __typename: 'Intent', _id: string, intentId: string, appId: string, organizationId: string, name: string } | null> | null } } | null };

export type FlagEventMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  eventId: Scalars['ID']['input'];
  flag: NewRawQueryFlag;
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type FlagEventMutation = { app: { update: { flagEvent: { message?: string | null } } } };

export type GetGlobalDashboardQueryVariables = Exact<{
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  urgency?: InputMaybe<Scalars['String']['input']>;
  highValueLead?: InputMaybe<Scalars['Boolean']['input']>;
  environment?: InputMaybe<Scalars['String']['input']>;
  referringSource?: InputMaybe<Scalars['String']['input']>;
  contactType?: InputMaybe<Scalars['String']['input']>;
  serviceType?: InputMaybe<Scalars['String']['input']>;
  jobType?: InputMaybe<Scalars['String']['input']>;
  businessHoursSource?: InputMaybe<BusinessHoursSource>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetGlobalDashboardQuery = { dashboard?: { leads?: { totalLeads: number, highValueLeadsPercentage: number, outsideBusinessHoursPercentage: number, businessHoursSource: BusinessHoursSource, businessHoursSummary?: Array<string> | null, leadsBySource: Array<{ key: string, count: number, percentage?: number | null }>, leadsByReferringSource: Array<{ key: string, count: number, percentage?: number | null }>, leadsByContactType: Array<{ key: string, count: number, percentage?: number | null }>, leadsByServiceType: Array<{ key: string, count: number, percentage?: number | null }>, leadsByJobType: Array<{ key: string, count: number, percentage?: number | null }>, leadsByUrgency: Array<{ key: string, count: number, percentage?: number | null }>, leadsByDayOfWeek: Array<{ dayOfWeek: number, dayName: string, totalCount: number, businessHoursCount: number, nonBusinessHoursCount: number, percentage?: number | null }>, topTerms: Array<{ term: string, count: number, score?: number | null }>, leadsByApp: Array<{ appId: string, name: string, leadCount: number, highValueLeadCount: number, organizationId?: string | null, organizationName?: string | null }>, leadsByOrganization: Array<{ organizationId: string, name: string, leadCount: number, highValueLeadCount: number }>, topEngagementsByZip: Array<{ zipCode: string, leadCount: number, highValueLeadCount: number, percentage: number, uniqueApps: number }> } | null } | null };

export type GlobalLeadsQueryVariables = Exact<{
  appId?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  nextKey?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  urgency?: InputMaybe<Scalars['String']['input']>;
  highValueLead?: InputMaybe<Scalars['Boolean']['input']>;
  referringSource?: InputMaybe<Scalars['String']['input']>;
  contactType?: InputMaybe<Scalars['String']['input']>;
  serviceType?: InputMaybe<Scalars['String']['input']>;
  jobType?: InputMaybe<Scalars['String']['input']>;
}>;


export type GlobalLeadsQuery = { leads?: { total: number, nextKey?: string | null, leads: Array<{ id?: string | null, appId?: string | null, company?: string | null, conciseSummary?: string | null, contactType?: string | null, date: any, highValueLead?: boolean | null, jobType?: string | null, serviceType?: string | null, source?: string | null, urgency?: string | null, lead?: { fields: Array<{ name: string, value?: string | null }> } | null }> } | null };

export type CreateHandlerMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  handler: AddHandlerInput;
}>;


export type CreateHandlerMutation = { addHandler: { __typename: 'Handler', appId: string, intentId: string, name: string, organizationId: string, type: string } };

export type UpdateHandlerMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  handlerId: Scalars['ID']['input'];
  handler: UpdateHandlerInput;
}>;


export type UpdateHandlerMutation = { updateHandler: { __typename: 'Handler', appId: string, intentId: string, organizationId: string, createdAt?: string | null, updatedAt?: string | null, name: string, langCode?: string | null, utterancePatterns?: Array<string | null> | null, dialogflowId?: string | null, type: string, defaultLocale?: string | null, permissions?: Array<HandlerPermissions | null> | null, data?: any | null, graphCoords?: { x?: number | null, y?: number | null } | null, slots?: Array<{ name: string, type?: string | null, isList?: any | null, nlu?: any | null, _id: string } | null> | null, validation: { isValid: boolean, errors: Array<{ errorMessage: string, propertyName?: string | null } | null> }, content?: Array<{ __typename: 'HandlerContent', key: string, handlerResponse: Array<{ __typename: 'JSONDependableHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'LastActiveActiveWithinHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'LastActiveFirstTimeHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'LastActiveHaveNotSeenWithinHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'RequestDependentHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'SchedulableDependentHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, schedule?: { start?: { format?: string | null, dayOfWeek?: string | null, time: string, timeZone?: string | null } | null, duration?: { format?: HandlerResponseDurationFormat | null, amount?: number | null } | null } | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'SimpleHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'SlotDependentHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'StorageDependentHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'SystemDependentHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | null> } | null> | null, forward?: Array<{ key: string, paths: Array<{ intentId: string, slots?: any | null, type?: string | null, actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | null> } | null> | null, redirect?: Array<{ key: string, paths: Array<{ intentId: string, slots?: any | null, type?: string | null, actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | null> } | null> | null } };

export type DeleteHandlerMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  handlerId: Scalars['ID']['input'];
}>;


export type DeleteHandlerMutation = { deleteHandler: Array<{ __typename: 'DeleteIntentIdKey', appId: string, intentId: string } | null> };

export type ChangeHandlerToIntentMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  handlerId: Scalars['ID']['input'];
}>;


export type ChangeHandlerToIntentMutation = { app: { update: { intent: { update: { changeHandlerToIntent: { name: string } } } } } };

export type HandlerPartsFragment = { __typename: 'Handler', appId: string, intentId: string, organizationId: string, createdAt?: string | null, updatedAt?: string | null, name: string, langCode?: string | null, utterancePatterns?: Array<string | null> | null, dialogflowId?: string | null, type: string, defaultLocale?: string | null, permissions?: Array<HandlerPermissions | null> | null, data?: any | null, graphCoords?: { x?: number | null, y?: number | null } | null, slots?: Array<{ name: string, type?: string | null, isList?: any | null, nlu?: any | null, _id: string } | null> | null, validation: { isValid: boolean, errors: Array<{ errorMessage: string, propertyName?: string | null } | null> }, content?: Array<{ __typename: 'HandlerContent', key: string, handlerResponse: Array<{ __typename: 'JSONDependableHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'LastActiveActiveWithinHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'LastActiveFirstTimeHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'LastActiveHaveNotSeenWithinHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'RequestDependentHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'SchedulableDependentHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, schedule?: { start?: { format?: string | null, dayOfWeek?: string | null, time: string, timeZone?: string | null } | null, duration?: { format?: HandlerResponseDurationFormat | null, amount?: number | null } | null } | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'SimpleHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'SlotDependentHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'StorageDependentHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'SystemDependentHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | null> } | null> | null, forward?: Array<{ key: string, paths: Array<{ intentId: string, slots?: any | null, type?: string | null, actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | null> } | null> | null, redirect?: Array<{ key: string, paths: Array<{ intentId: string, slots?: any | null, type?: string | null, actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | null> } | null> | null };

export type GetHandlerQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  intentId: Scalars['ID']['input'];
}>;


export type GetHandlerQuery = { handler?: { __typename: 'Handler', appId: string, intentId: string, organizationId: string, createdAt?: string | null, updatedAt?: string | null, name: string, langCode?: string | null, utterancePatterns?: Array<string | null> | null, dialogflowId?: string | null, type: string, defaultLocale?: string | null, permissions?: Array<HandlerPermissions | null> | null, data?: any | null, graphCoords?: { x?: number | null, y?: number | null } | null, slots?: Array<{ name: string, type?: string | null, isList?: any | null, nlu?: any | null, _id: string } | null> | null, validation: { isValid: boolean, errors: Array<{ errorMessage: string, propertyName?: string | null } | null> }, content?: Array<{ __typename: 'HandlerContent', key: string, handlerResponse: Array<{ __typename: 'JSONDependableHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'LastActiveActiveWithinHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'LastActiveFirstTimeHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'LastActiveHaveNotSeenWithinHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'RequestDependentHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'SchedulableDependentHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, schedule?: { start?: { format?: string | null, dayOfWeek?: string | null, time: string, timeZone?: string | null } | null, duration?: { format?: HandlerResponseDurationFormat | null, amount?: number | null } | null } | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'SimpleHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'SlotDependentHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'StorageDependentHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'SystemDependentHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | null> } | null> | null, forward?: Array<{ key: string, paths: Array<{ intentId: string, slots?: any | null, type?: string | null, actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | null> } | null> | null, redirect?: Array<{ key: string, paths: Array<{ intentId: string, slots?: any | null, type?: string | null, actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | null> } | null> | null } | null, app?: { __typename: 'App', _id: string, appId: string, organizationId: string, name: string, templateType?: string | null, status?: { type: string } | null, handlers?: { total: number, handlers?: Array<{ __typename: 'GetHandlersListHandler', _id: string, intentId: string, type: string, name?: string | null, appId: string, organizationId: string } | null> | null } | null, intents?: { _id: string, total: number, intents?: Array<{ _id: string, name: string, intentId: string, utterancePatterns?: Array<string | null> | null } | null> | null } | null } | null };

export type GetHandlersListQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  withIdOrName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetHandlersListQuery = { app?: { __typename: 'App', _id: string, appId: string, organizationId: string, name: string, handlers?: { total: number, handlers?: Array<{ __typename: 'GetHandlersListHandler', _id: string, intentId: string, type: string, name?: string | null } | null> | null } | null, intents?: { _id: string, total: number, intents?: Array<{ _id: string, name: string, intentId: string, utterancePatterns?: Array<string | null> | null } | null> | null } | null } | null };

export type GetExternalIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExternalIdQuery = { utils: { generateExternalID: string } };

export type AddBoberdooIntegrationMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  apiKey: Scalars['String']['input'];
  endpoint: Scalars['URLString']['input'];
  leadType: Scalars['String']['input'];
  source: Scalars['String']['input'];
  apiAction?: InputMaybe<Scalars['String']['input']>;
  defaultLandingPage?: InputMaybe<Scalars['String']['input']>;
  defaultProject?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  uniqueIdentifier?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddBoberdooIntegrationMutation = { app: { update: { integration: { addBoberdooIntegration: { isLinked: boolean, isActive: boolean, isAllowed: boolean } } } } };

export type DisconnectIntegrationMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  type: IntegrationType;
}>;


export type DisconnectIntegrationMutation = { app: { update: { integration: { disconnect: { isLinked: boolean, isActive: boolean } } } } };

export type ConnectSurefireMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
  endpoint: Scalars['URLString']['input'];
  dataMap: Scalars['String']['input'];
}>;


export type ConnectSurefireMutation = { app: { update: { integration: { addSurefireIntegration: { isLinked: boolean, isActive: boolean, isAllowed: boolean } } } } };

export type ConnectHousecallProMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
}>;


export type ConnectHousecallProMutation = { app: { update: { integration: { addHouseCallProIntegration: { isLinked: boolean, isActive: boolean, isAllowed: boolean } } } } };

export type ConnectFieldPulseMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
  defaultJobTypeId: Scalars['String']['input'];
  maxJobsPerDay: Scalars['Int']['input'];
  lookAheadDays: Scalars['Int']['input'];
}>;


export type ConnectFieldPulseMutation = { app: { update: { integration: { addFieldPulseIntegration: { isActive: boolean, isLinked: boolean, isAllowed: boolean } } } } };

export type AddFieldRoutesIntegrationMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  subdomain: Scalars['String']['input'];
  authenticationKey: Scalars['String']['input'];
  authenticationToken: Scalars['String']['input'];
  sourceID?: InputMaybe<Scalars['String']['input']>;
  defaultAppointmentType?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddFieldRoutesIntegrationMutation = { app: { update: { integration: { addFieldRoutesIntegration: { isActive: boolean, isLinked: boolean, isAllowed: boolean } } } } };

export type AddServiceMinderIntegrationMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  apiKey: Scalars['String']['input'];
}>;


export type AddServiceMinderIntegrationMutation = { app: { update: { integration: { addServiceMinderIntegration: { isActive: boolean, isLinked: boolean, isAllowed: boolean } } } } };

export type AddContractorAppointmentsIntegrationMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  campaignId: Scalars['String']['input'];
  campaignKey: Scalars['String']['input'];
  defaultTrade?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddContractorAppointmentsIntegrationMutation = { app: { update: { integration: { addContractorAppointmentsIntegration: { isLinked: boolean, isActive: boolean, isAllowed: boolean } } } } };

export type AddWebhookIntegrationMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  endpoint: Scalars['URLString']['input'];
  httpHeaders?: InputMaybe<Scalars['JSON']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddWebhookIntegrationMutation = { app: { update: { integration: { addWebhookIntegration: { isLinked: boolean, isActive: boolean, isAllowed: boolean } } } } };

export type AddFacebookCapiIntegrationMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  pixelId: Scalars['String']['input'];
  accessToken: Scalars['String']['input'];
  testEventCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddFacebookCapiIntegrationMutation = { app: { update: { integration: { addFacebookCapiIntegration: { isLinked: boolean, isActive: boolean, isAllowed: boolean } } } } };

export type IntegrationStatusQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
}>;


export type IntegrationStatusQuery = { org?: { __typename: 'Organization', _id: string, organizationId: string, type: SubscriptionType } | null, app?: { __typename: 'App', _id: string, templateType?: string | null, appId: string, leadsContact?: any | null, leadsContactPhone?: string | null, stripeProductId?: string | null, stripeSubscriptionId?: string | null, subscriptionPaymentStatus?: string | null, canCaptureLeads: boolean, limitations: { preferredTime: boolean, captureLead: boolean, schedule: boolean, aiLeadTagging: boolean, reserveWithGoogle: boolean, allowedIntegrations?: Array<string> | null }, boberdoo: { __typename: 'Integration', isAllowed: boolean, isLinked: boolean, isActive: boolean }, lacrm: { __typename: 'Integration', isAllowed: boolean, isLinked: boolean, isActive: boolean }, jobber: { __typename: 'Integration', isAllowed: boolean, isLinked: boolean, isActive: boolean }, servicetitan: { __typename: 'Integration', isAllowed: boolean, isLinked: boolean, isActive: boolean }, surefire: { __typename: 'Integration', isAllowed: boolean, isLinked: boolean, isActive: boolean }, housecallpro: { __typename: 'Integration', isAllowed: boolean, isLinked: boolean, isActive: boolean }, fieldpulse: { __typename: 'Integration', isAllowed: boolean, isLinked: boolean, isActive: boolean }, fieldroutes: { __typename: 'Integration', isAllowed: boolean, isLinked: boolean, isActive: boolean }, servicefusion: { __typename: 'Integration', isAllowed: boolean, isLinked: boolean, isActive: boolean }, zapier: { __typename: 'Integration', isAllowed: boolean, isLinked: boolean, isActive: boolean }, serviceminder: { __typename: 'Integration', isAllowed: boolean, isLinked: boolean, isActive: boolean }, contractor_appointments: { __typename: 'Integration', isAllowed: boolean, isLinked: boolean, isActive: boolean }, webhook: { __typename: 'Integration', isAllowed: boolean, isLinked: boolean, isActive: boolean }, facebook_capi: { __typename: 'Integration', isAllowed: boolean, isLinked: boolean, isActive: boolean }, test: { __typename: 'Integration', isAllowed: boolean, isLinked: boolean, isActive: boolean }, manualOverrideAvailableFeatures?: { aiLeadTagging?: boolean | null, reserveWithGoogle?: boolean | null, captureLead?: boolean | null, schedule?: boolean | null, preferredTime?: boolean | null, allowedIntegrations?: Array<string> | null } | null, referenceId?: { id: string, service: string } | null } | null };

export type CreateIntentMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  intent: AddIntentInput;
}>;


export type CreateIntentMutation = { addIntent: { appId: string, intentId: string, name: string, organizationId: string } };

export type UpdateIntentMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  intentId: Scalars['ID']['input'];
  intent: UpdateIntentInput;
}>;


export type UpdateIntentMutation = { updateIntent: { __typename: 'Intent', appId: string, intentId: string, organizationId: string, createdAt?: string | null, name: string, langCode?: string | null, utterancePatterns?: Array<string> | null, dialogflowId?: string | null, defaultLocale?: string | null, permissions?: Array<string | null> | null, slotTypes?: any | null, slots?: Array<{ __typename: 'Slot', name: string, type?: string | null, inputText?: string | null, isList?: any | null, nlu?: any | null } | null> | null, validation: { isValid: boolean, errors: Array<{ errorMessage: string, propertyName?: string | null } | null> }, contexts?: Array<{ name?: string | null } | null> | null } };

export type DeleteIntentMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  intentId: Scalars['ID']['input'];
}>;


export type DeleteIntentMutation = { deleteIntent: Array<{ appId: string, intentId: string } | null> };

export type ChangeIntentToHandlerMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  intentId: Scalars['ID']['input'];
}>;


export type ChangeIntentToHandlerMutation = { changeIntentToHandler: { __typename: 'Handler', type: string, intentId: string } };

export type GetIntentsListQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  withIdOrName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetIntentsListQuery = { app?: { __typename: 'App', appId: string, intents?: { total: number, intents?: Array<{ __typename: 'GetIntentsListIntent', appId: string, intentId: string, organizationId: string, name: string, langCode?: string | null, slots?: Array<{ __typename: 'Slot', name: string, type?: string | null, inputText?: string | null, isList?: any | null } | null> | null } | null> | null } | null } | null };

export type GetIntentQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  intentId: Scalars['ID']['input'];
}>;


export type GetIntentQuery = { intent?: { __typename: 'Intent', appId: string, intentId: string, organizationId: string, nlu?: any | null, createdAt?: string | null, updatedAt?: string | null, name: string, langCode?: string | null, utterancePatterns?: Array<string> | null, dialogflowId?: string | null, defaultLocale?: string | null, permissions?: Array<string | null> | null, slotTypes?: any | null, slots?: Array<{ __typename: 'Slot', name: string, type?: string | null, inputText?: string | null, isList?: any | null, nlu?: any | null } | null> | null, validation: { isValid: boolean, errors: Array<{ errorMessage: string, propertyName?: string | null } | null> }, contexts?: Array<{ name?: string | null } | null> | null } | null, handler?: { __typename: 'Handler', name: string, appId: string, intentId: string, type: string } | null, app?: { __typename: 'App', appId: string, entities?: { __typename: 'EntitiesQuery', total: number, entities?: Array<{ __typename: 'GetEntitiesListEntity', entityId: string, displayName: string } | null> | null } | null } | null };

export type GetUtteranceSuggestionsQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  intentId: Scalars['ID']['input'];
}>;


export type GetUtteranceSuggestionsQuery = { intent?: { __typename: 'Intent', appId: string, intentId: string, utteranceSuggestions: { suggestions: Array<{ utterance: string }> } } | null };

export type GetLeadCountByFiltersQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  contactTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  jobTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  serviceTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  urgencies?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  highValueLead?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetLeadCountByFiltersQuery = { dashboard?: { leads?: { totalLeads: number, leadsByContactType: Array<{ key: string, count: number }>, leadsByJobType: Array<{ key: string, count: number }>, leadsByServiceType: Array<{ key: string, count: number }>, leadsByUrgency: Array<{ key: string, count: number }> } | null } | null };

export type AuditTrailFieldsFragment = { auditTrail?: { summary: Array<{ method: string, statusCode: number, url: string, durationMs: number, timestamp: any, errorMessage?: string | null, wasError: boolean }>, details?: Array<{ sequence: number, method: string, url: string, statusCode: number, durationMs: number, timestamp: any, errorMessage?: string | null, wasError: boolean, stepDescription?: string | null, requestBody?: string | null, requestHeaders?: any | null, responseBody?: string | null, responseHeaders?: any | null }> | null } | null };

export type LeadsForAppQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  nextKey?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  urgency?: InputMaybe<Scalars['String']['input']>;
  highValueLead?: InputMaybe<Scalars['Boolean']['input']>;
  environment?: InputMaybe<Scalars['String']['input']>;
  referringSource?: InputMaybe<Scalars['String']['input']>;
  contactType?: InputMaybe<Scalars['String']['input']>;
  serviceType?: InputMaybe<Scalars['String']['input']>;
  jobType?: InputMaybe<Scalars['String']['input']>;
}>;


export type LeadsForAppQuery = { app?: { organizationId: string, appId: string, name: string, formLeads?: { total: number } | null, chatLeads?: { total: number } | null, leads?: { total: number, nextKey?: string | null, leads: Array<{ id?: string | null, company?: string | null, conciseSummary?: string | null, contactType?: string | null, date: any, highValueLead?: boolean | null, jobType?: string | null, serviceType?: string | null, source?: string | null, urgency?: string | null, lead?: { fields: Array<{ name: string, value?: string | null }> } | null }> } | null, leadsFilterMetadata?: { referringSources: Array<string>, jobTypes: Array<string>, contactTypes: Array<string>, serviceTypes: Array<string>, urgencies: Array<string> } | null } | null };

export type LeadByIdQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type LeadByIdQuery = { lead?: { id?: string | null, analysis?: string | null, channel?: string | null, company?: string | null, conciseSummary?: string | null, contactType?: string | null, date: any, environment?: string | null, formHelpType?: string | null, formMessage?: string | null, highValueLead?: boolean | null, jobType?: string | null, referringSource?: string | null, serviceType?: string | null, sessionId?: string | null, source?: string | null, summary?: string | null, urgency?: string | null, userId?: string | null, integrationSent?: Array<{ integrationId: string, date: any, refId?: string | null, wasError: boolean, errorName?: string | null, errorMessage?: string | null, auditTrail?: { summary: Array<{ method: string, statusCode: number, url: string, durationMs: number, timestamp: any, errorMessage?: string | null, wasError: boolean }>, details?: Array<{ sequence: number, method: string, url: string, statusCode: number, durationMs: number, timestamp: any, errorMessage?: string | null, wasError: boolean, stepDescription?: string | null, requestBody?: string | null, requestHeaders?: any | null, responseBody?: string | null, responseHeaders?: any | null }> | null } | null }> | null, emailThread?: { threadId: string, customerEmail?: string | null, customerName?: string | null, messages: Array<{ id: string, role: string, content: string, timestamp: any }> } | null, lead?: { fields: Array<{ name: string, value?: string | null }>, transcript?: Array<{ createdTime: string, message: string, from?: { id: string, email?: string | null, name?: string | null } | null, to?: Array<{ id: string, email?: string | null, name?: string | null }> | null }> | null } | null } | null };

export type LeadsFilterMetadataQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
}>;


export type LeadsFilterMetadataQuery = { app?: { leadsFilterMetadata?: { referringSources: Array<string>, jobTypes: Array<string>, contactTypes: Array<string>, serviceTypes: Array<string>, urgencies: Array<string> } | null } | null };

export type GetCodeChallengeMutationVariables = Exact<{ [key: string]: never; }>;


export type GetCodeChallengeMutation = { codeChallenge?: { codeChallenge: string, codeVerifier: string, codeChallengeMethod: string } | null };

export type CreateAlertSubscriptionMutationVariables = Exact<{
  input: CreateAlertSubscriptionInput;
}>;


export type CreateAlertSubscriptionMutation = { createAlertSubscription: { subscriptionId: string, alertType: AlertType, appIds: Array<string>, channel: NotificationChannel, enabled: boolean, filters?: { contactType?: Array<string> | null, highValueLead?: boolean | null, jobType?: Array<string> | null, urgency?: Array<string> | null, serviceType?: Array<string> | null } | null } };

export type UpdateAlertSubscriptionMutationVariables = Exact<{
  subscriptionId: Scalars['ID']['input'];
  input: UpdateAlertSubscriptionInput;
}>;


export type UpdateAlertSubscriptionMutation = { updateAlertSubscription: { subscriptionId: string, alertType: AlertType, appIds: Array<string>, channel: NotificationChannel, enabled: boolean, filters?: { contactType?: Array<string> | null, highValueLead?: boolean | null, jobType?: Array<string> | null, urgency?: Array<string> | null, serviceType?: Array<string> | null } | null } };

export type DeleteAlertSubscriptionMutationVariables = Exact<{
  subscriptionId: Scalars['ID']['input'];
}>;


export type DeleteAlertSubscriptionMutation = { deleteAlertSubscription: boolean };

export type CreateSummarySubscriptionMutationVariables = Exact<{
  input: CreateSummarySubscriptionInput;
}>;


export type CreateSummarySubscriptionMutation = { createSummarySubscription: { subscriptionId: string, appIds: Array<string>, frequency: SummaryFrequency, grouping: ReportGrouping, channel: NotificationChannel, enabled: boolean, lastSent?: string | null, nextScheduled?: string | null } };

export type UpdateSummarySubscriptionMutationVariables = Exact<{
  subscriptionId: Scalars['ID']['input'];
  input: UpdateSummarySubscriptionInput;
}>;


export type UpdateSummarySubscriptionMutation = { updateSummarySubscription: { subscriptionId: string, appIds: Array<string>, frequency: SummaryFrequency, grouping: ReportGrouping, channel: NotificationChannel, enabled: boolean, lastSent?: string | null, nextScheduled?: string | null } };

export type DeleteSummarySubscriptionMutationVariables = Exact<{
  subscriptionId: Scalars['ID']['input'];
}>;


export type DeleteSummarySubscriptionMutation = { deleteSummarySubscription: boolean };

export type UpdateNotificationPhoneMutationVariables = Exact<{
  phone?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateNotificationPhoneMutation = { updateNotificationPhone: { userId: string, phone?: string | null } };

export type GetMyNotificationPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyNotificationPreferencesQuery = { myNotificationPreferences?: { userId: string, email: string, phone?: string | null, createdAt: string, updatedAt: string, alertSubscriptions: Array<{ subscriptionId: string, alertType: AlertType, appIds: Array<string>, channel: NotificationChannel, enabled: boolean, filters?: { contactType?: Array<string> | null, highValueLead?: boolean | null, jobType?: Array<string> | null, urgency?: Array<string> | null, serviceType?: Array<string> | null } | null }>, summarySubscriptions: Array<{ subscriptionId: string, appIds: Array<string>, frequency: SummaryFrequency, grouping: ReportGrouping, channel: NotificationChannel, enabled: boolean, lastSent?: string | null, nextScheduled?: string | null }> } | null };

export type GetSubscribableAppsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubscribableAppsQuery = { subscribableApps: Array<{ appId: string, name: string, organizationId: string }> };

export type StartCrawlMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  url: Scalars['URL']['input'];
  pattern?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  channelId: Scalars['String']['input'];
}>;


export type StartCrawlMutation = { startWebsiteCrawling: string };

export type AnalyzeWebsiteMutationVariables = Exact<{
  url: Scalars['URL']['input'];
}>;


export type AnalyzeWebsiteMutation = { onboarding: { startRetrieveWebsiteDetails: { executionId: string } } };

export type CreateOrgAndAppMutationVariables = Exact<{
  org: CreateOrganizationInput;
  app?: InputMaybe<AppTemplateInput>;
}>;


export type CreateOrgAndAppMutation = { createOrg?: { org: { organizationId: string, name: string }, app?: { appId: string, organizationId: string, name: string, templateType?: string | null } | null } | null };

export type CreateOrgAndAppOnboardingMutationVariables = Exact<{
  org: CreateOrganizationInput;
  app?: InputMaybe<CreateOrgCreateAppInput>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateOrgAndAppOnboardingMutation = { org: { add: { org: { organizationId: string, name: string }, app?: { organizationId: string, appId: string, name: string, templateType?: string | null, website?: string | null, businessDescription?: string | null } | null } } };

export type AcceptTermsMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type AcceptTermsMutation = { org: { org: { acceptTos: { updatedOrg: { acceptedTermsOfService: Array<{ userId: string }> } } } } };

export type UpdateOrgTierMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  type: SubscriptionType;
}>;


export type UpdateOrgTierMutation = { org: { org: { updateTier: string } } };

export type CreateChannelsMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  search: IntelligentSearchAppChannelInput;
  form: FormWidgetAppChannelInput;
  chat: ChatWidgetAppChannelInput;
  lex: LexV2ConnectAppChannelInput;
}>;


export type CreateChannelsMutation = { app: { update: { channel: { addIntelligentSearchChannel: { __typename: 'IntelligentSearchAppChannel', id: string, name?: string | null }, addFormWidgetChannel: { __typename: 'FormWidgetAppChannel', id: string, name?: string | null }, addChatWidgetChannel: { __typename: 'ChatWidgetAppChannel', id: string, name?: string | null }, addLexV2Channel: { __typename: 'LexV2ConnectAppChannel', id: string, name?: string | null } } } } };

export type GetAppTotalsQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
}>;


export type GetAppTotalsQuery = { app?: { appId: string, intents?: { total: number } | null, handlers?: { total: number } | null, entities?: { total: number, entities?: Array<{ entityId: string } | null> | null } | null, content?: { total: number } | null, faq?: { total: number } | null } | null };

export type GetWebsiteAnalysisQueryVariables = Exact<{
  executionId: Scalars['ID']['input'];
}>;


export type GetWebsiteAnalysisQuery = { onboarding: { webDetailsExecution: { completed: boolean, siteCrawled: any, data: { schema: any, detectedTechnologies: Array<{ installed: boolean, technology: string }>, business?: { name?: string | null, typeRaw?: string | null, services?: Array<WebsiteDataBusinessDataService> | null, category?: string | null, phoneNumbers?: Array<{ number?: string | null, purpose?: string | null }> | null, address?: { region?: string | null, locality?: string | null, streetAddress?: string | null, postalCode?: string | null, formated?: string | null, country?: string | null } | null, geo?: { lat: string, lon: string } | null } | null, site?: { logo?: string | null, description?: string | null, primaryColor?: string | null, secondaryColor?: string | null, callsToAction?: Array<{ callToAction: string, url?: string | null }> | null, phoneNumbers?: Array<{ purpose?: string | null, number?: string | null }> | null } | null } } } };

export type TermsOfUseAcceptanceQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type TermsOfUseAcceptanceQuery = { org?: { acceptedLatestTermsOfService: boolean, acceptedTermsOfService: Array<{ acceptedOn: any, email: string, userId: string, url: any }> } | null };

export type OnboardingAppQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
}>;


export type OnboardingAppQuery = { app?: { __typename: 'App', _id: string, appId: string, organizationId: string, templateType?: string | null, name: string, website?: string | null, leadsContact?: any | null, leadsContactPhone?: string | null, stripeProductId?: string | null, stripeSubscriptionId?: string | null, subscriptionPaymentStatus?: string | null, businessDescription?: string | null, beta?: any | null, websiteData?: { crawlExecutionId?: string | null, crawlDate?: any | null, cms?: string | null, callsToAction?: Array<string> | null, primaryColor?: string | null, secondaryColor?: string | null } | null, places?: Array<{ name?: string | null, placeId?: string | null, website?: any | null, phone?: string | null, formattedAddress?: string | null }> | null, channels?: Array<{ id: string, type: string } | { id: string, type: string } | { id: string, type: string } | { id: string, type: string } | { id: string, type: string } | { id: string, type: string } | { id: string, type: string } | { id: string, type: string } | { id: string, type: string } | { id: string, type: string } | { id: string, type: string } | { id: string, type: string } | null> | null } | null };

export type ProspectorBusinessQueryVariables = Exact<{
  placeId?: InputMaybe<Scalars['ID']['input']>;
  businessId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ProspectorBusinessQuery = { public: { business?: { business: { businessId: string, name: string, phone?: string | null, websiteUrl?: string | null, city?: string | null, state?: string | null, vertical?: string | null, businessHours?: any | null, logoUrl?: string | null, reviewRating?: number | null, googlePlaceId?: string | null, primaryColor?: string | null, secondaryColor?: string | null, description?: string | null, cms?: string | null }, similarity?: { strategy: string, values: Array<string> } | null, peers?: { national: { count: number, bookOnlineRate: number }, state: { count: number, bookOnlineRate: number }, city: { count: number, bookOnlineRate: number }, topBookOnlineProviders: Array<{ name: string, share: number, count: number }> } | null, competitors: Array<{ businessId: string, name: string, city?: string | null, state?: string | null, hasBookOnline: boolean, bookOnlineProvider?: string | null, reviewRating?: number | null, distanceMiles: number }> } | null } };

export type GetOrgDashboardQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  appId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  urgency?: InputMaybe<Scalars['String']['input']>;
  highValueLead?: InputMaybe<Scalars['Boolean']['input']>;
  environment?: InputMaybe<Scalars['String']['input']>;
  referringSource?: InputMaybe<Scalars['String']['input']>;
  contactType?: InputMaybe<Scalars['String']['input']>;
  serviceType?: InputMaybe<Scalars['String']['input']>;
  jobType?: InputMaybe<Scalars['String']['input']>;
  businessHoursSource?: InputMaybe<BusinessHoursSource>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrgDashboardQuery = { dashboard?: { leads?: { totalLeads: number, highValueLeadsPercentage: number, outsideBusinessHoursPercentage: number, businessHoursSource: BusinessHoursSource, businessHoursSummary?: Array<string> | null, leadsBySource: Array<{ key: string, count: number, percentage?: number | null }>, leadsByReferringSource: Array<{ key: string, count: number, percentage?: number | null }>, leadsByContactType: Array<{ key: string, count: number, percentage?: number | null }>, leadsByServiceType: Array<{ key: string, count: number, percentage?: number | null }>, leadsByJobType: Array<{ key: string, count: number, percentage?: number | null }>, leadsByUrgency: Array<{ key: string, count: number, percentage?: number | null }>, leadsByDayOfWeek: Array<{ dayOfWeek: number, dayName: string, totalCount: number, businessHoursCount: number, nonBusinessHoursCount: number, percentage?: number | null }>, topTerms: Array<{ term: string, count: number, score?: number | null }>, leadsByApp: Array<{ appId: string, name: string, leadCount: number, highValueLeadCount: number }>, topEngagementsByZip: Array<{ zipCode: string, leadCount: number, highValueLeadCount: number, percentage: number, uniqueApps: number }> } | null } | null };

export type OrgLeadAuditTrailFieldsFragment = { auditTrail?: { summary: Array<{ method: string, statusCode: number, url: string, durationMs: number, timestamp: any, errorMessage?: string | null, wasError: boolean }>, details?: Array<{ sequence: number, method: string, url: string, statusCode: number, durationMs: number, timestamp: any, errorMessage?: string | null, wasError: boolean, stepDescription?: string | null, requestBody?: string | null, requestHeaders?: any | null, responseBody?: string | null, responseHeaders?: any | null }> | null } | null };

export type AppNamesForOrgQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type AppNamesForOrgQuery = { org?: { apps?: { apps: Array<{ appId: string, name: string } | null> } | null } | null };

export type LeadsForOrgQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  appId?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  nextKey?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  urgency?: InputMaybe<Scalars['String']['input']>;
  highValueLead?: InputMaybe<Scalars['Boolean']['input']>;
  referringSource?: InputMaybe<Scalars['String']['input']>;
  contactType?: InputMaybe<Scalars['String']['input']>;
  serviceType?: InputMaybe<Scalars['String']['input']>;
  jobType?: InputMaybe<Scalars['String']['input']>;
}>;


export type LeadsForOrgQuery = { leads?: { total: number, nextKey?: string | null, leads: Array<{ id?: string | null, appId?: string | null, company?: string | null, conciseSummary?: string | null, contactType?: string | null, date: any, highValueLead?: boolean | null, jobType?: string | null, serviceType?: string | null, source?: string | null, urgency?: string | null, lead?: { fields: Array<{ name: string, value?: string | null }> } | null }> } | null };

export type LeadByIdOnlyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LeadByIdOnlyQuery = { lead?: { id?: string | null, appId?: string | null, analysis?: string | null, channel?: string | null, company?: string | null, conciseSummary?: string | null, contactType?: string | null, date: any, environment?: string | null, formHelpType?: string | null, formMessage?: string | null, highValueLead?: boolean | null, jobType?: string | null, referringSource?: string | null, serviceType?: string | null, sessionId?: string | null, source?: string | null, summary?: string | null, urgency?: string | null, userId?: string | null, integrationSent?: Array<{ integrationId: string, date: any, refId?: string | null, wasError: boolean, errorName?: string | null, errorMessage?: string | null, auditTrail?: { summary: Array<{ method: string, statusCode: number, url: string, durationMs: number, timestamp: any, errorMessage?: string | null, wasError: boolean }>, details?: Array<{ sequence: number, method: string, url: string, statusCode: number, durationMs: number, timestamp: any, errorMessage?: string | null, wasError: boolean, stepDescription?: string | null, requestBody?: string | null, requestHeaders?: any | null, responseBody?: string | null, responseHeaders?: any | null }> | null } | null }> | null, emailThread?: { threadId: string, customerEmail?: string | null, customerName?: string | null, messages: Array<{ id: string, role: string, content: string, timestamp: any }> } | null, lead?: { fields: Array<{ name: string, value?: string | null }>, transcript?: Array<{ createdTime: string, message: string, from?: { id: string, email?: string | null, name?: string | null } | null, to?: Array<{ id: string, email?: string | null, name?: string | null }> | null }> | null } | null } | null };

export type GetOrgMapQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  appId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GetOrgMapQuery = { dashboard?: { map: { summary: { totalBusinessLocations: number, totalLeadsWithLocation: number, totalLeads: number, leadsWithLocationPercentage: number, bounds?: { topLeft: { lat: number, lon: number }, bottomRight: { lat: number, lon: number } } | null }, businessLocations: Array<{ appId: string, name: string, address?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, leadCount: number, highValueLeadCount: number, location: { lat: number, lon: number } }>, leadClusters: Array<{ geohash: string, count: number, highValueCount: number, location: { lat: number, lon: number }, bounds?: { topLeft: { lat: number, lon: number }, bottomRight: { lat: number, lon: number } } | null }> } } | null };

export type GetOrgAnalyticsQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
}>;


export type GetOrgAnalyticsQuery = { org?: { __typename: 'Organization', _id: string, organizationId: string, name: string, analytics?: { user: { organizationId: string, newUsers: number, returningUsers: number, totalSessions: number, totalUsers: number, intervals: Array<{ isoDate: string, interval: AppUsageInterval, newUsers: number, returningUsers: number } | null> } } | null } | null };

export type UpdateOrganizationMutationVariables = Exact<{
  orgId: Scalars['ID']['input'];
  org: UpdateOrganizationInput;
}>;


export type UpdateOrganizationMutation = { updateOrg?: { __typename: 'Organization', _id: string, organizationId: string, name: string } | null };

export type DeleteOrgMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type DeleteOrgMutation = { org: { org: { delete: string } } };

export type UpdateOrgMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  org: UpdateOrganizationInput;
}>;


export type UpdateOrgMutation = { org: { org: { update: { name: string, logoUrl?: string | null } } } };

export type SetUserAppAccessMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  appIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SetUserAppAccessMutation = { org: { org: { members: { setUserAppAccess: { userId: string, email: string, policy: { appIds?: Array<string | null> | null } } } } } };

export type SetInviteAppAccessMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  invitationId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  appIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SetInviteAppAccessMutation = { org: { org: { members: { setInviteAppAccess: { email: string, invitationId: string } } } } };

export type GetOrgMembersWithAppIdsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GetOrgMembersWithAppIdsQuery = { org?: { members: { members: Array<{ userId: string, email: string, policy: { appIds?: Array<string | null> | null } } | null> } } | null };

export type UpdatePartnerBrandingMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  org: UpdateOrganizationInput;
}>;


export type UpdatePartnerBrandingMutation = { org: { org: { update: { organizationId: string, partnerBranding?: { enabled?: boolean | null, logoUrl?: string | null, primaryColor?: string | null, backgroundColor?: string | null, companyName?: string | null, websiteUrl?: string | null, senderEmail?: string | null } | null } } } };

export type SendEmailVerificationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
}>;


export type SendEmailVerificationMutation = { org: { org: { partnerVerification: { sendEmailVerification: { email: string, status: string, requestedAt: any } } } } };

export type StartDomainVerificationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  domain: Scalars['String']['input'];
}>;


export type StartDomainVerificationMutation = { org: { org: { partnerVerification: { startDomainVerification: { domain: string, status: string, requestedAt: any, dnsRecords?: Array<{ type: string, name: string, value: string }> | null } } } } };

export type CheckVerificationStatusMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type CheckVerificationStatusMutation = { org: { org: { partnerVerification: { checkVerificationStatus: { email?: { email: string, status: string, verifiedAt?: any | null } | null, domain?: { domain: string, status: string, verifiedAt?: any | null } | null } } } } };

export type ResetEmailVerificationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type ResetEmailVerificationMutation = { org: { org: { partnerVerification: { resetEmailVerification: boolean } } } };

export type ResetDomainVerificationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type ResetDomainVerificationMutation = { org: { org: { partnerVerification: { resetDomainVerification: boolean } } } };

export type GetOrgBrandingQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GetOrgBrandingQuery = { org?: { __typename: 'Organization', _id: string, organizationId: string, name: string, description: string, type: SubscriptionType, usage: { testsExecuted: number, uniqueSessions: number }, partnerBranding?: { enabled?: boolean | null, logoUrl?: string | null, primaryColor?: string | null, backgroundColor?: string | null, companyName?: string | null, websiteUrl?: string | null, senderEmail?: string | null, emailVerification?: { email: string, status: string, requestedAt: any, verifiedAt?: any | null } | null, domainVerification?: { domain: string, status: string, requestedAt: any, verifiedAt?: any | null, dnsRecords?: Array<{ type: string, name: string, value: string }> | null } | null } | null } | null };

export type PushAlexaModelMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  channelId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PushAlexaModelMutation = { createInteractionModel: Array<{ locale: string, interactionModel: { languageModel?: { invocationName: string, intents: Array<{ name: string, samples?: Array<string | null> | null, slots?: Array<{ name: string, type: string, samples?: Array<string | null> | null } | null> | null } | null>, types?: Array<{ name: string, values: Array<{ id?: string | null, name?: { value: string, synonyms: Array<string | null> } | null } | null> } | null> | null } | null } } | null> };

export type PushDialogflowModelMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  channelId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PushDialogflowModelMutation = { updateDialogflowAgent: string };

export type PushLexModelMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  channelId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PushLexModelMutation = { pushLex: string };

export type GetChannelsForModelQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
}>;


export type GetChannelsForModelQuery = { app?: { __typename: 'App', appId: string, channels?: Array<{ __typename: 'ActionsOnGoogleAppChannel', id: string, useNLU?: string | null } | { __typename: 'AlexaAppChannel', vendorId?: string | null, hasCredentials: boolean, skillId?: string | null, isBuilding: boolean, id: string, useNLU?: string | null } | { __typename: 'AppChannel', id: string, useNLU?: string | null } | { __typename: 'ChatWidgetAppChannel', id: string, useNLU?: string | null } | { __typename: 'DialogflowAppChannel', hasCredentials: boolean, isBuilding: boolean, id: string, useNLU?: string | null } | { __typename: 'EmailAppChannel', id: string, useNLU?: string | null } | { __typename: 'FacebookMessengerAppChannel', id: string, useNLU?: string | null } | { __typename: 'FormWidgetAppChannel', id: string, useNLU?: string | null } | { __typename: 'GoogleBusinessMessagesAppChannel', id: string, useNLU?: string | null } | { __typename: 'IntelligentSearchAppChannel', id: string, useNLU?: string | null } | { __typename: 'LexConnectAppChannel', voiceId?: string | null, nluIntentConfidenceThreshold?: number | null, idleSessionTTLInSeconds?: number | null, detectSentiment?: boolean | null, isLinkedToKendra: boolean, lexPostTextUrl?: string | null, enableModelImprovements?: boolean | null, botName?: string | null, id: string, useNLU?: string | null } | { __typename: 'LexV2ConnectAppChannel', id: string, isLinkedToKendra: boolean, lexPostTextUrl?: string | null, botId?: string | null, botName?: string | null, managementRole?: string | null, managementRoleExternalId?: string | null, useNLU?: string | null } | null> | null } | null };

export type UpdateAvailabilityMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  app: UpdateAppInput;
  handlerId: Scalars['ID']['input'];
  handler: UpdateHandlerInput;
}>;


export type UpdateAvailabilityMutation = { updateHandler: { __typename: 'Handler', appId: string, intentId: string, organizationId: string, createdAt?: string | null, updatedAt?: string | null, name: string, langCode?: string | null, utterancePatterns?: Array<string | null> | null, dialogflowId?: string | null, type: string, defaultLocale?: string | null, permissions?: Array<HandlerPermissions | null> | null, data?: any | null, graphCoords?: { x?: number | null, y?: number | null } | null, slots?: Array<{ name: string, type?: string | null, isList?: any | null, nlu?: any | null, _id: string } | null> | null, validation: { isValid: boolean, errors: Array<{ errorMessage: string, propertyName?: string | null } | null> }, content?: Array<{ __typename: 'HandlerContent', key: string, handlerResponse: Array<{ __typename: 'JSONDependableHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'LastActiveActiveWithinHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'LastActiveFirstTimeHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'LastActiveHaveNotSeenWithinHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'RequestDependentHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'SchedulableDependentHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, schedule?: { start?: { format?: string | null, dayOfWeek?: string | null, time: string, timeZone?: string | null } | null, duration?: { format?: HandlerResponseDurationFormat | null, amount?: number | null } | null } | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'SimpleHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'SlotDependentHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'StorageDependentHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | { __typename: 'SystemDependentHandlerResponse', name?: string | null, tag?: string | null, system?: HandlerResponseSystem | null, data?: any | null, conditions?: any | null, displays?: Array<{ __typename: 'CardDisplay', content?: string | null, smallImageUrl?: string | null, largeImageUrl?: string | null, imageActionUrl?: string | null, accessibilityText?: string | null, type: string, token?: string | null, title?: string | null, buttons?: Array<{ title: string, openUrlAction: string } | null> | null } | { __typename: 'ListDisplay', itemsName?: string | null, itemsObject?: string | null, type: string, token?: string | null, title?: string | null, range?: { length: number, from: number } | null, items?: Array<{ token?: string | null, url?: string | null, synonyms?: Array<string | null> | null, title: string, description?: string | null, image?: { url: string, urlIcon?: any | null, imageActionUrl?: string | null, accessibilityText?: string | null, width?: number | null, height?: number | null } | null, buttons?: Array<{ title: string } | null> | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null, segments?: Array<{ key: string, segments: Array<{ segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | { segment: { ssml?: string | null, displayText?: string | null } } | null> } | null> | null, reprompt?: { ssml?: string | null, textToSpeech?: string | null, displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion' } | { __typename: 'SuggestionObject' } | null> | null } | null, context?: { active?: Array<{ name: string, parameters?: any | null, timeToLive?: { timeToLiveInSeconds?: number | null, turnsToLive?: number | null } | null } | null> | null } | null, channel?: { name?: string | null } | null } | null> } | null> | null, forward?: Array<{ key: string, paths: Array<{ intentId: string, slots?: any | null, type?: string | null, actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | null> } | null> | null, redirect?: Array<{ key: string, paths: Array<{ intentId: string, slots?: any | null, type?: string | null, actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | { actions?: Array<any | null> | null, conditions?: any | null, data?: any | null, platform?: string | null } | null> } | null> | null }, app: { update: { updateApp: { name: string, appId: string, availability?: { availableDays?: Array<CrmDayOfWeek | null> | null, maxTotalDailyAppointments?: number | null, delayedJobTypes?: Array<string | null> | null, defaultAvailabilityClass?: string | null, blockedDays?: Array<{ time?: string | null, date?: string | null, tz?: string | null } | null> | null, availabilityClasses?: Array<{ id: string, name: string, summary: string, numberOfDaysOut?: number | null, appointmentsPerDay?: number | null, leadOnly?: boolean | null } | null> | null, defaultBusyDays?: { blockCurrentDay?: boolean | null, blockNextBusinessDays?: number | null, blockWeekends?: boolean | null, currentDayAvailableUntil?: string | null, availableDays?: Array<CrmDayOfWeek | null> | null } | null } | null } } } };

export type UpdateAppReferenceIdMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  referenceId?: InputMaybe<AppReferenceIdInput>;
}>;


export type UpdateAppReferenceIdMutation = { app: { update: { updateApp: { appId: string, referenceId?: { id: string, service: string } | null } } } };

export type UpdateChatWidgetChannelMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  channel: ChatWidgetAppChannelInput;
}>;


export type UpdateChatWidgetChannelMutation = { addChatWidgetChannel: { id: string, type: string, avatarUrl?: any | null, autoOpenOnWidth?: string | null, chatButton?: { imageUrl?: string | null } | null, cta?: { message?: string | null } | null, theme?: { primaryColor?: string | null } | null, urls?: { defaultBehavior: { type: ChatWidgetAppChannelWidgetUrlBehaviorType } | { type: ChatWidgetAppChannelWidgetUrlBehaviorType } | { type: ChatWidgetAppChannelWidgetUrlBehaviorType } } | null } };

export type UpdateChatSettingsMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  handlerId: Scalars['ID']['input'];
  handler: UpdateHandlerInput;
  channel: ChatWidgetAppChannelInput;
}>;


export type UpdateChatSettingsMutation = { updateHandler: { intentId: string, name: string, content?: Array<{ key: string, handlerResponse: Array<{ name?: string | null, tag?: string | null, segments?: Array<{ key: string, segments: Array<{ segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | null> } | null> | null, displays?: Array<{ type: string, token?: string | null, title?: string | null } | { type: string, token?: string | null, title?: string | null, items?: Array<{ token?: string | null, url?: string | null, title: string, description?: string | null, image?: { url: string } | null } | null> | null } | { type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { displayText?: string | null, suggestions?: Array<{ title: string } | {} | null> | null } | null } | { name?: string | null, tag?: string | null, segments?: Array<{ key: string, segments: Array<{ segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | null> } | null> | null, displays?: Array<{ type: string, token?: string | null, title?: string | null } | { type: string, token?: string | null, title?: string | null, items?: Array<{ token?: string | null, url?: string | null, title: string, description?: string | null, image?: { url: string } | null } | null> | null } | { type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { displayText?: string | null, suggestions?: Array<{ title: string } | {} | null> | null } | null } | { name?: string | null, tag?: string | null, segments?: Array<{ key: string, segments: Array<{ segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | null> } | null> | null, displays?: Array<{ type: string, token?: string | null, title?: string | null } | { type: string, token?: string | null, title?: string | null, items?: Array<{ token?: string | null, url?: string | null, title: string, description?: string | null, image?: { url: string } | null } | null> | null } | { type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { displayText?: string | null, suggestions?: Array<{ title: string } | {} | null> | null } | null } | { name?: string | null, tag?: string | null, segments?: Array<{ key: string, segments: Array<{ segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | null> } | null> | null, displays?: Array<{ type: string, token?: string | null, title?: string | null } | { type: string, token?: string | null, title?: string | null, items?: Array<{ token?: string | null, url?: string | null, title: string, description?: string | null, image?: { url: string } | null } | null> | null } | { type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { displayText?: string | null, suggestions?: Array<{ title: string } | {} | null> | null } | null } | { name?: string | null, tag?: string | null, segments?: Array<{ key: string, segments: Array<{ segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | null> } | null> | null, displays?: Array<{ type: string, token?: string | null, title?: string | null } | { type: string, token?: string | null, title?: string | null, items?: Array<{ token?: string | null, url?: string | null, title: string, description?: string | null, image?: { url: string } | null } | null> | null } | { type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { displayText?: string | null, suggestions?: Array<{ title: string } | {} | null> | null } | null } | { name?: string | null, tag?: string | null, segments?: Array<{ key: string, segments: Array<{ segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | null> } | null> | null, displays?: Array<{ type: string, token?: string | null, title?: string | null } | { type: string, token?: string | null, title?: string | null, items?: Array<{ token?: string | null, url?: string | null, title: string, description?: string | null, image?: { url: string } | null } | null> | null } | { type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { displayText?: string | null, suggestions?: Array<{ title: string } | {} | null> | null } | null } | { name?: string | null, tag?: string | null, segments?: Array<{ key: string, segments: Array<{ segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | null> } | null> | null, displays?: Array<{ type: string, token?: string | null, title?: string | null } | { type: string, token?: string | null, title?: string | null, items?: Array<{ token?: string | null, url?: string | null, title: string, description?: string | null, image?: { url: string } | null } | null> | null } | { type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { displayText?: string | null, suggestions?: Array<{ title: string } | {} | null> | null } | null } | { name?: string | null, tag?: string | null, segments?: Array<{ key: string, segments: Array<{ segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | null> } | null> | null, displays?: Array<{ type: string, token?: string | null, title?: string | null } | { type: string, token?: string | null, title?: string | null, items?: Array<{ token?: string | null, url?: string | null, title: string, description?: string | null, image?: { url: string } | null } | null> | null } | { type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { displayText?: string | null, suggestions?: Array<{ title: string } | {} | null> | null } | null } | { name?: string | null, tag?: string | null, segments?: Array<{ key: string, segments: Array<{ segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | null> } | null> | null, displays?: Array<{ type: string, token?: string | null, title?: string | null } | { type: string, token?: string | null, title?: string | null, items?: Array<{ token?: string | null, url?: string | null, title: string, description?: string | null, image?: { url: string } | null } | null> | null } | { type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { displayText?: string | null, suggestions?: Array<{ title: string } | {} | null> | null } | null } | { name?: string | null, tag?: string | null, segments?: Array<{ key: string, segments: Array<{ segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | { segment: { displayText?: string | null } } | null> } | null> | null, displays?: Array<{ type: string, token?: string | null, title?: string | null } | { type: string, token?: string | null, title?: string | null, items?: Array<{ token?: string | null, url?: string | null, title: string, description?: string | null, image?: { url: string } | null } | null> | null } | { type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { displayText?: string | null, suggestions?: Array<{ title: string } | {} | null> | null } | null } | null> } | null> | null }, addChatWidgetChannel: { id: string, type: string, avatarUrl?: any | null, autoOpenOnWidth?: string | null, chatButton?: { imageUrl?: string | null } | null, cta?: { message?: string | null } | null, theme?: { primaryColor?: string | null } | null, urls?: { defaultBehavior: { type: ChatWidgetAppChannelWidgetUrlBehaviorType } | { type: ChatWidgetAppChannelWidgetUrlBehaviorType } | { type: ChatWidgetAppChannelWidgetUrlBehaviorType } } | null } };

type HandlerResponse_JsonDependableHandlerResponse_Fragment = { tag?: string | null, tags?: Array<string> | null, name?: string | null, conditions?: any | null, context?: { active?: Array<{ name: string, parameters?: any | null } | null> | null } | null, channel?: { name?: string | null } | null, displays?: Array<{ title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | null> | null, reprompt?: { displayText?: string | null, ssml?: string | null } | null, outputSpeech?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title: string, url: string } | { title: string } | null> | null } | null };

type HandlerResponse_LastActiveActiveWithinHandlerResponse_Fragment = { tag?: string | null, tags?: Array<string> | null, name?: string | null, conditions?: any | null, context?: { active?: Array<{ name: string, parameters?: any | null } | null> | null } | null, channel?: { name?: string | null } | null, displays?: Array<{ title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | null> | null, reprompt?: { displayText?: string | null, ssml?: string | null } | null, outputSpeech?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title: string, url: string } | { title: string } | null> | null } | null };

type HandlerResponse_LastActiveFirstTimeHandlerResponse_Fragment = { tag?: string | null, tags?: Array<string> | null, name?: string | null, conditions?: any | null, context?: { active?: Array<{ name: string, parameters?: any | null } | null> | null } | null, channel?: { name?: string | null } | null, displays?: Array<{ title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | null> | null, reprompt?: { displayText?: string | null, ssml?: string | null } | null, outputSpeech?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title: string, url: string } | { title: string } | null> | null } | null };

type HandlerResponse_LastActiveHaveNotSeenWithinHandlerResponse_Fragment = { tag?: string | null, tags?: Array<string> | null, name?: string | null, conditions?: any | null, context?: { active?: Array<{ name: string, parameters?: any | null } | null> | null } | null, channel?: { name?: string | null } | null, displays?: Array<{ title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | null> | null, reprompt?: { displayText?: string | null, ssml?: string | null } | null, outputSpeech?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title: string, url: string } | { title: string } | null> | null } | null };

type HandlerResponse_RequestDependentHandlerResponse_Fragment = { tag?: string | null, tags?: Array<string> | null, name?: string | null, conditions?: any | null, context?: { active?: Array<{ name: string, parameters?: any | null } | null> | null } | null, channel?: { name?: string | null } | null, displays?: Array<{ title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | null> | null, reprompt?: { displayText?: string | null, ssml?: string | null } | null, outputSpeech?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title: string, url: string } | { title: string } | null> | null } | null };

type HandlerResponse_SchedulableDependentHandlerResponse_Fragment = { tag?: string | null, tags?: Array<string> | null, name?: string | null, conditions?: any | null, context?: { active?: Array<{ name: string, parameters?: any | null } | null> | null } | null, channel?: { name?: string | null } | null, displays?: Array<{ title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | null> | null, reprompt?: { displayText?: string | null, ssml?: string | null } | null, outputSpeech?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title: string, url: string } | { title: string } | null> | null } | null };

type HandlerResponse_SimpleHandlerResponse_Fragment = { tag?: string | null, tags?: Array<string> | null, name?: string | null, conditions?: any | null, context?: { active?: Array<{ name: string, parameters?: any | null } | null> | null } | null, channel?: { name?: string | null } | null, displays?: Array<{ title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | null> | null, reprompt?: { displayText?: string | null, ssml?: string | null } | null, outputSpeech?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title: string, url: string } | { title: string } | null> | null } | null };

type HandlerResponse_SlotDependentHandlerResponse_Fragment = { tag?: string | null, tags?: Array<string> | null, name?: string | null, conditions?: any | null, context?: { active?: Array<{ name: string, parameters?: any | null } | null> | null } | null, channel?: { name?: string | null } | null, displays?: Array<{ title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | null> | null, reprompt?: { displayText?: string | null, ssml?: string | null } | null, outputSpeech?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title: string, url: string } | { title: string } | null> | null } | null };

type HandlerResponse_StorageDependentHandlerResponse_Fragment = { tag?: string | null, tags?: Array<string> | null, name?: string | null, conditions?: any | null, context?: { active?: Array<{ name: string, parameters?: any | null } | null> | null } | null, channel?: { name?: string | null } | null, displays?: Array<{ title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | null> | null, reprompt?: { displayText?: string | null, ssml?: string | null } | null, outputSpeech?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title: string, url: string } | { title: string } | null> | null } | null };

type HandlerResponse_SystemDependentHandlerResponse_Fragment = { tag?: string | null, tags?: Array<string> | null, name?: string | null, conditions?: any | null, context?: { active?: Array<{ name: string, parameters?: any | null } | null> | null } | null, channel?: { name?: string | null } | null, displays?: Array<{ title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | null> | null, reprompt?: { displayText?: string | null, ssml?: string | null } | null, outputSpeech?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title: string, url: string } | { title: string } | null> | null } | null };

export type HandlerResponseFragment = HandlerResponse_JsonDependableHandlerResponse_Fragment | HandlerResponse_LastActiveActiveWithinHandlerResponse_Fragment | HandlerResponse_LastActiveFirstTimeHandlerResponse_Fragment | HandlerResponse_LastActiveHaveNotSeenWithinHandlerResponse_Fragment | HandlerResponse_RequestDependentHandlerResponse_Fragment | HandlerResponse_SchedulableDependentHandlerResponse_Fragment | HandlerResponse_SimpleHandlerResponse_Fragment | HandlerResponse_SlotDependentHandlerResponse_Fragment | HandlerResponse_StorageDependentHandlerResponse_Fragment | HandlerResponse_SystemDependentHandlerResponse_Fragment;

export type GetAppSimpleSettingsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
}>;


export type GetAppSimpleSettingsQuery = { profile?: { __typename: 'UserProfile', _id: string, userId: string, fullName?: string | null, email: string } | null, org?: { __typename: 'Organization', _id: string, organizationId: string, type: SubscriptionType } | null, app?: { __typename: 'App', appId: string, organizationId: string, stripeProductId?: string | null, stripeSubscriptionId?: string | null, subscriptionPaymentStatus?: string | null, templateType?: string | null, icon?: string | null, name: string, beta?: any | null, website?: string | null, leadsContact?: any | null, leadsContactPhone?: string | null, canCaptureLeads: boolean, businessDescription?: string | null, businessHighValueLeadDescription?: string | null, status?: { type: string, email: string, notes?: string | null } | null, content?: { total: number, content: Array<{ lastUpdated: any, url: string } | null> } | null, contentSources?: { sources: Array<{ webUrl: string, webUrlPatterns: Array<string | null> } | null>, lastCrawl?: { started: any, ended: any, errors: Array<{ detail: string, executionId?: string | null } | null>, documents: Array<{ url: string, lastUpdated: any } | null> } | null } | null, contentErrors?: { total: number, errors: Array<{ name: string, url?: string | null } | null> } | null, referenceId?: { id: string, service: string } | null, channels?: Array<{ __typename: 'ActionsOnGoogleAppChannel', type: string, id: string, name?: string | null } | { __typename: 'AlexaAppChannel', vendorId?: string | null, invocationName?: string | null, type: string, id: string, name?: string | null } | { __typename: 'AppChannel', type: string, id: string, name?: string | null } | { __typename: 'ChatWidgetAppChannel', key?: string | null, type: string, id: string, name?: string | null, theme?: { primaryColor?: string | null } | null } | { __typename: 'DialogflowAppChannel', type: string, id: string, name?: string | null } | { __typename: 'EmailAppChannel', type: string, id: string, name?: string | null } | { __typename: 'FacebookMessengerAppChannel', type: string, id: string, name?: string | null } | { __typename: 'FormWidgetAppChannel', id: string, key?: string | null, type: string, name?: string | null, theme?: { accentColor?: string | null } | null } | { __typename: 'GoogleBusinessMessagesAppChannel', type: string, id: string, name?: string | null } | { __typename: 'IntelligentSearchAppChannel', key?: string | null, type: string, id: string, name?: string | null, theme?: { accentColor?: string | null } | null } | { __typename: 'LexConnectAppChannel', isLinkedToKendra: boolean, lexPostTextUrl?: string | null, type: string, id: string, name?: string | null } | { __typename: 'LexV2ConnectAppChannel', botName?: string | null, isLinkedToKendra: boolean, lexPostTextUrl?: string | null, type: string, id: string, name?: string | null } | null> | null } | null, launchReqest?: { appId: string, intentId: string, name: string, data?: any | null, content?: Array<{ handlerResponse: Array<{ tag?: string | null, tags?: Array<string> | null, name?: string | null, conditions?: any | null, context?: { active?: Array<{ name: string, parameters?: any | null } | null> | null } | null, channel?: { name?: string | null } | null, displays?: Array<{ title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | null> | null, reprompt?: { displayText?: string | null, ssml?: string | null } | null, outputSpeech?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title: string, url: string } | { title: string } | null> | null } | null } | { tag?: string | null, tags?: Array<string> | null, name?: string | null, conditions?: any | null, context?: { active?: Array<{ name: string, parameters?: any | null } | null> | null } | null, channel?: { name?: string | null } | null, displays?: Array<{ title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | null> | null, reprompt?: { displayText?: string | null, ssml?: string | null } | null, outputSpeech?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title: string, url: string } | { title: string } | null> | null } | null } | { tag?: string | null, tags?: Array<string> | null, name?: string | null, conditions?: any | null, context?: { active?: Array<{ name: string, parameters?: any | null } | null> | null } | null, channel?: { name?: string | null } | null, displays?: Array<{ title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | null> | null, reprompt?: { displayText?: string | null, ssml?: string | null } | null, outputSpeech?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title: string, url: string } | { title: string } | null> | null } | null } | { tag?: string | null, tags?: Array<string> | null, name?: string | null, conditions?: any | null, context?: { active?: Array<{ name: string, parameters?: any | null } | null> | null } | null, channel?: { name?: string | null } | null, displays?: Array<{ title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | null> | null, reprompt?: { displayText?: string | null, ssml?: string | null } | null, outputSpeech?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title: string, url: string } | { title: string } | null> | null } | null } | { tag?: string | null, tags?: Array<string> | null, name?: string | null, conditions?: any | null, context?: { active?: Array<{ name: string, parameters?: any | null } | null> | null } | null, channel?: { name?: string | null } | null, displays?: Array<{ title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | null> | null, reprompt?: { displayText?: string | null, ssml?: string | null } | null, outputSpeech?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title: string, url: string } | { title: string } | null> | null } | null } | { tag?: string | null, tags?: Array<string> | null, name?: string | null, conditions?: any | null, context?: { active?: Array<{ name: string, parameters?: any | null } | null> | null } | null, channel?: { name?: string | null } | null, displays?: Array<{ title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | null> | null, reprompt?: { displayText?: string | null, ssml?: string | null } | null, outputSpeech?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title: string, url: string } | { title: string } | null> | null } | null } | { tag?: string | null, tags?: Array<string> | null, name?: string | null, conditions?: any | null, context?: { active?: Array<{ name: string, parameters?: any | null } | null> | null } | null, channel?: { name?: string | null } | null, displays?: Array<{ title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | null> | null, reprompt?: { displayText?: string | null, ssml?: string | null } | null, outputSpeech?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title: string, url: string } | { title: string } | null> | null } | null } | { tag?: string | null, tags?: Array<string> | null, name?: string | null, conditions?: any | null, context?: { active?: Array<{ name: string, parameters?: any | null } | null> | null } | null, channel?: { name?: string | null } | null, displays?: Array<{ title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | null> | null, reprompt?: { displayText?: string | null, ssml?: string | null } | null, outputSpeech?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title: string, url: string } | { title: string } | null> | null } | null } | { tag?: string | null, tags?: Array<string> | null, name?: string | null, conditions?: any | null, context?: { active?: Array<{ name: string, parameters?: any | null } | null> | null } | null, channel?: { name?: string | null } | null, displays?: Array<{ title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | null> | null, reprompt?: { displayText?: string | null, ssml?: string | null } | null, outputSpeech?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title: string, url: string } | { title: string } | null> | null } | null } | { tag?: string | null, tags?: Array<string> | null, name?: string | null, conditions?: any | null, context?: { active?: Array<{ name: string, parameters?: any | null } | null> | null } | null, channel?: { name?: string | null } | null, displays?: Array<{ title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | null> | null, reprompt?: { displayText?: string | null, ssml?: string | null } | null, outputSpeech?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title: string, url: string } | { title: string } | null> | null } | null } | null> } | null> | null } | null, leadGeneration?: { appId: string, intentId: string, name: string, data?: any | null, content?: Array<{ handlerResponse: Array<{ tag?: string | null, tags?: Array<string> | null, name?: string | null, conditions?: any | null, context?: { active?: Array<{ name: string, parameters?: any | null } | null> | null } | null, channel?: { name?: string | null } | null, displays?: Array<{ title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | null> | null, reprompt?: { displayText?: string | null, ssml?: string | null } | null, outputSpeech?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title: string, url: string } | { title: string } | null> | null } | null } | { tag?: string | null, tags?: Array<string> | null, name?: string | null, conditions?: any | null, context?: { active?: Array<{ name: string, parameters?: any | null } | null> | null } | null, channel?: { name?: string | null } | null, displays?: Array<{ title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | null> | null, reprompt?: { displayText?: string | null, ssml?: string | null } | null, outputSpeech?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title: string, url: string } | { title: string } | null> | null } | null } | { tag?: string | null, tags?: Array<string> | null, name?: string | null, conditions?: any | null, context?: { active?: Array<{ name: string, parameters?: any | null } | null> | null } | null, channel?: { name?: string | null } | null, displays?: Array<{ title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | null> | null, reprompt?: { displayText?: string | null, ssml?: string | null } | null, outputSpeech?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title: string, url: string } | { title: string } | null> | null } | null } | { tag?: string | null, tags?: Array<string> | null, name?: string | null, conditions?: any | null, context?: { active?: Array<{ name: string, parameters?: any | null } | null> | null } | null, channel?: { name?: string | null } | null, displays?: Array<{ title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | null> | null, reprompt?: { displayText?: string | null, ssml?: string | null } | null, outputSpeech?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title: string, url: string } | { title: string } | null> | null } | null } | { tag?: string | null, tags?: Array<string> | null, name?: string | null, conditions?: any | null, context?: { active?: Array<{ name: string, parameters?: any | null } | null> | null } | null, channel?: { name?: string | null } | null, displays?: Array<{ title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | null> | null, reprompt?: { displayText?: string | null, ssml?: string | null } | null, outputSpeech?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title: string, url: string } | { title: string } | null> | null } | null } | { tag?: string | null, tags?: Array<string> | null, name?: string | null, conditions?: any | null, context?: { active?: Array<{ name: string, parameters?: any | null } | null> | null } | null, channel?: { name?: string | null } | null, displays?: Array<{ title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | null> | null, reprompt?: { displayText?: string | null, ssml?: string | null } | null, outputSpeech?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title: string, url: string } | { title: string } | null> | null } | null } | { tag?: string | null, tags?: Array<string> | null, name?: string | null, conditions?: any | null, context?: { active?: Array<{ name: string, parameters?: any | null } | null> | null } | null, channel?: { name?: string | null } | null, displays?: Array<{ title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | null> | null, reprompt?: { displayText?: string | null, ssml?: string | null } | null, outputSpeech?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title: string, url: string } | { title: string } | null> | null } | null } | { tag?: string | null, tags?: Array<string> | null, name?: string | null, conditions?: any | null, context?: { active?: Array<{ name: string, parameters?: any | null } | null> | null } | null, channel?: { name?: string | null } | null, displays?: Array<{ title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | null> | null, reprompt?: { displayText?: string | null, ssml?: string | null } | null, outputSpeech?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title: string, url: string } | { title: string } | null> | null } | null } | { tag?: string | null, tags?: Array<string> | null, name?: string | null, conditions?: any | null, context?: { active?: Array<{ name: string, parameters?: any | null } | null> | null } | null, channel?: { name?: string | null } | null, displays?: Array<{ title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | null> | null, reprompt?: { displayText?: string | null, ssml?: string | null } | null, outputSpeech?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title: string, url: string } | { title: string } | null> | null } | null } | { tag?: string | null, tags?: Array<string> | null, name?: string | null, conditions?: any | null, context?: { active?: Array<{ name: string, parameters?: any | null } | null> | null } | null, channel?: { name?: string | null } | null, displays?: Array<{ title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | { title?: string | null, type: string, token?: string | null, payload?: any | null } | null> | null, reprompt?: { displayText?: string | null, ssml?: string | null } | null, outputSpeech?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title: string, url: string } | { title: string } | null> | null } | null } | null> } | null> | null } | null };

export type GetAppChannelsThemeDataQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
}>;


export type GetAppChannelsThemeDataQuery = { app?: { __typename: 'App', appId: string, organizationId: string, beta?: any | null, icon?: string | null, channels?: Array<{ __typename: 'ActionsOnGoogleAppChannel', type: string, name?: string | null, id: string, status?: { type: string, email: string, timestamp: any } | null } | { __typename: 'AlexaAppChannel', type: string, name?: string | null, id: string, status?: { type: string, email: string, timestamp: any } | null } | { __typename: 'AppChannel', id: string, type: string, name?: string | null, status?: { type: string, email: string, timestamp: any } | null } | { __typename: 'ChatWidgetAppChannel', name?: string | null, disabled?: boolean | null, botName?: string | null, avatarUrl?: any | null, key?: string | null, type: string, id: string, cta?: { message?: string | null, timeout?: number | null, delay?: number | null, animation?: CtaAnimation | null, animationTimeout?: number | null, mobile?: { applyAtLessThanWidth?: string | null, message?: string | null, timeout?: number | null, delay?: number | null, animation?: CtaAnimation | null, animationTimeout?: number | null } | null } | null, theme?: { primaryColor?: string | null } | null, status?: { type: string, email: string, timestamp: any } | null } | { __typename: 'DialogflowAppChannel', type: string, name?: string | null, id: string, status?: { type: string, email: string, timestamp: any } | null } | { __typename: 'EmailAppChannel', type: string, name?: string | null, id: string, status?: { type: string, email: string, timestamp: any } | null } | { __typename: 'FacebookMessengerAppChannel', type: string, name?: string | null, id: string, status?: { type: string, email: string, timestamp: any } | null } | { __typename: 'FormWidgetAppChannel', type: string, name?: string | null, id: string, key?: string | null, autoGreeting?: string | null, intentId?: string | null, sideButtonLabel?: string | null, directoryListing?: string | null, useNLU?: string | null, businessName?: string | null, businessLogoUrl?: string | null, businessAddress?: string | null, businessWebsite?: string | null, chatWidgetKey?: string | null, theme?: { accentColor?: string | null, backgroundColor?: string | null, headerBackgroundColor?: string | null, headerTextColor?: string | null, primaryButtonColor?: string | null, primaryButtonTextColor?: string | null, secondaryButtonColor?: string | null, secondaryButtonTextColor?: string | null, data?: any | null, standAlone?: { backgroundColor?: string | null, header?: { backgroundColor?: string | null, color?: string | null, fontSize?: string | null } | null } | null } | null, status?: { type: string, email: string, timestamp: any } | null } | { __typename: 'GoogleBusinessMessagesAppChannel', type: string, name?: string | null, id: string, status?: { type: string, email: string, timestamp: any } | null } | { __typename: 'IntelligentSearchAppChannel', type: string, name?: string | null, key?: string | null, id: string, theme?: { accentColor?: string | null } | null, status?: { type: string, email: string, timestamp: any } | null } | { __typename: 'LexConnectAppChannel', type: string, name?: string | null, id: string, status?: { type: string, email: string, timestamp: any } | null } | { __typename: 'LexV2ConnectAppChannel', type: string, name?: string | null, id: string, status?: { type: string, email: string, timestamp: any } | null } | null> | null } | null };

export type GetBookingPageSettingsQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
}>;


export type GetBookingPageSettingsQuery = { app?: { __typename: 'App', _id: string, appId: string, organizationId: string, name: string, website?: string | null, icon?: string | null, places?: Array<{ __typename: 'AppPlaceDescription', adminVerified?: boolean | null, bookingOptOut?: boolean | null, default?: boolean | null, formattedAddress?: string | null, name?: string | null, phone?: string | null, placeId?: string | null, website?: any | null, addressComponents?: Array<{ longName?: string | null, shortName?: string | null, types?: Array<string> | null }> | null }> | null, channels?: Array<{ __typename: 'ActionsOnGoogleAppChannel', id: string, type: string } | { __typename: 'AlexaAppChannel', id: string, type: string } | { __typename: 'AppChannel', id: string, type: string } | { __typename: 'ChatWidgetAppChannel', key?: string | null, disabled?: boolean | null, name?: string | null, id: string, type: string } | { __typename: 'DialogflowAppChannel', id: string, type: string } | { __typename: 'EmailAppChannel', id: string, type: string } | { __typename: 'FacebookMessengerAppChannel', id: string, type: string } | { __typename: 'FormWidgetAppChannel', name?: string | null, key?: string | null, businessName?: string | null, businessLogoUrl?: string | null, businessAddress?: string | null, businessWebsite?: string | null, autoGreeting?: string | null, chatWidgetKey?: string | null, id: string, type: string, theme?: { accentColor?: string | null, standAlone?: { backgroundColor?: string | null, header?: { color?: string | null, backgroundColor?: string | null, fontSize?: string | null } | null } | null } | null } | { __typename: 'GoogleBusinessMessagesAppChannel', id: string, type: string } | { __typename: 'IntelligentSearchAppChannel', id: string, type: string } | { __typename: 'LexConnectAppChannel', id: string, type: string } | { __typename: 'LexV2ConnectAppChannel', id: string, type: string } | null> | null } | null };

export type GetAvailabilityPageSettingsQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
}>;


export type GetAvailabilityPageSettingsQuery = { app?: { __typename: 'App', _id: string, appId: string, organizationId: string, name: string, website?: string | null, icon?: string | null, places?: Array<{ __typename: 'AppPlaceDescription', name?: string | null, placeId?: string | null, formattedAddress?: string | null, default?: boolean | null, website?: any | null, phone?: string | null, adminVerified?: boolean | null, bookingOptOut?: boolean | null, addressComponents?: Array<{ longName?: string | null, shortName?: string | null, types?: Array<string> | null }> | null }> | null, availability?: { availableDays?: Array<CrmDayOfWeek | null> | null, maxTotalDailyAppointments?: number | null, delayedJobTypes?: Array<string | null> | null, defaultAvailabilityClass?: string | null, blockedDays?: Array<{ time?: string | null, date?: string | null, tz?: string | null } | null> | null, availabilityClasses?: Array<{ id: string, name: string, summary: string, numberOfDaysOut?: number | null, appointmentsPerDay?: number | null, leadOnly?: boolean | null } | null> | null, defaultBusyDays?: { blockCurrentDay?: boolean | null, blockNextBusinessDays?: number | null, blockWeekends?: boolean | null, currentDayAvailableUntil?: string | null, availableDays?: Array<CrmDayOfWeek | null> | null } | null } | null, channels?: Array<{ __typename: 'ActionsOnGoogleAppChannel', id: string, type: string } | { __typename: 'AlexaAppChannel', id: string, type: string } | { __typename: 'AppChannel', id: string, type: string } | { __typename: 'ChatWidgetAppChannel', key?: string | null, disabled?: boolean | null, name?: string | null, id: string, type: string } | { __typename: 'DialogflowAppChannel', id: string, type: string } | { __typename: 'EmailAppChannel', id: string, type: string } | { __typename: 'FacebookMessengerAppChannel', id: string, type: string } | { __typename: 'FormWidgetAppChannel', name?: string | null, key?: string | null, businessName?: string | null, businessLogoUrl?: string | null, businessAddress?: string | null, businessWebsite?: string | null, chatWidgetKey?: string | null, autoGreeting?: string | null, intentId?: string | null, id: string, type: string, theme?: { accentColor?: string | null, standAlone?: { backgroundColor?: string | null, header?: { color?: string | null, backgroundColor?: string | null, fontSize?: string | null } | null } | null } | null } | { __typename: 'GoogleBusinessMessagesAppChannel', id: string, type: string } | { __typename: 'IntelligentSearchAppChannel', id: string, type: string } | { __typename: 'LexConnectAppChannel', id: string, type: string } | { __typename: 'LexV2ConnectAppChannel', id: string, type: string } | null> | null } | null };

export type GetAiSettingsQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
}>;


export type GetAiSettingsQuery = { app?: { __typename: 'App', _id: string, appId: string, organizationId: string, name: string, businessDescription?: string | null, businessHighValueLeadDescription?: string | null, canCaptureLeads: boolean, templateType?: string | null, places?: Array<{ __typename: 'AppPlaceDescription', placeId?: string | null, name?: string | null, formattedAddress?: string | null }> | null } | null };

export type GetChatSettingsQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
}>;


export type GetChatSettingsQuery = { app?: { __typename: 'App', _id: string, appId: string, organizationId: string, name: string, icon?: string | null, website?: string | null, channels?: Array<{ __typename: 'ActionsOnGoogleAppChannel', type: string, id: string } | { __typename: 'AlexaAppChannel', type: string, id: string } | { __typename: 'AppChannel', type: string, id: string } | { __typename: 'ChatWidgetAppChannel', id: string, key?: string | null, botName?: string | null, avatarUrl?: any | null, autoOpenOnWidth?: string | null, type: string, cta?: { message?: string | null, timeout?: number | null, delay?: number | null, animation?: CtaAnimation | null, animationTimeout?: number | null } | null, urls?: { policies: Array<{ pattern: string, behavior: { type: ChatWidgetAppChannelWidgetUrlBehaviorType } | { width?: number | null, height?: number | null, type: ChatWidgetAppChannelWidgetUrlBehaviorType } | { type: ChatWidgetAppChannelWidgetUrlBehaviorType } } | null>, defaultBehavior: { type: ChatWidgetAppChannelWidgetUrlBehaviorType } | { width?: number | null, height?: number | null, type: ChatWidgetAppChannelWidgetUrlBehaviorType } | { type: ChatWidgetAppChannelWidgetUrlBehaviorType } } | null, chatButton?: { imageUrl?: string | null } | null, actionBar?: { enabled: boolean, position?: ActionBarPosition | null, mobileBreakpoint?: number | null, buttons: Array<{ id: string, type: ActionBarButtonType, label?: string | null, icon?: ActionBarIconType | null, iconUrl?: string | null, visibility?: ActionBarButtonVisibility | null, tabIndex?: number | null } | { id: string, type: ActionBarButtonType, label?: string | null, icon?: ActionBarIconType | null, iconUrl?: string | null, visibility?: ActionBarButtonVisibility | null, tabIndex?: number | null, emailAddress: string, subject?: string | null, body?: string | null } | { id: string, type: ActionBarButtonType, label?: string | null, icon?: ActionBarIconType | null, iconUrl?: string | null, visibility?: ActionBarButtonVisibility | null, tabIndex?: number | null, intentId?: string | null, autoGreeting?: boolean | null, preselectChipLabel?: string | null } | { id: string, type: ActionBarButtonType, label?: string | null, icon?: ActionBarIconType | null, iconUrl?: string | null, visibility?: ActionBarButtonVisibility | null, tabIndex?: number | null, url: string, target?: ActionBarButtonTarget | null } | { id: string, type: ActionBarButtonType, label?: string | null, icon?: ActionBarIconType | null, iconUrl?: string | null, visibility?: ActionBarButtonVisibility | null, tabIndex?: number | null, url: string, target?: ActionBarButtonTarget | null } | { id: string, type: ActionBarButtonType, label?: string | null, icon?: ActionBarIconType | null, iconUrl?: string | null, visibility?: ActionBarButtonVisibility | null, tabIndex?: number | null, phoneNumber: string } | { id: string, type: ActionBarButtonType, label?: string | null, icon?: ActionBarIconType | null, iconUrl?: string | null, visibility?: ActionBarButtonVisibility | null, tabIndex?: number | null, intentId?: string | null, autoGreeting?: boolean | null, preselectChipLabel?: string | null } | { id: string, type: ActionBarButtonType, label?: string | null, icon?: ActionBarIconType | null, iconUrl?: string | null, visibility?: ActionBarButtonVisibility | null, tabIndex?: number | null, url: string, target?: ActionBarButtonTarget | null }> } | null, header?: { alignTextCenter?: boolean | null, status?: { online?: string | null, offline?: string | null, away?: string | null, connecting?: string | null } | null, subtitle?: { enabled?: boolean | null, text?: string | null } | null } | null, footer?: { branding?: { enabled?: boolean | null, text?: string | null } | null } | null, theme?: { primaryColor?: string | null, border?: { color?: string | null, width?: string | null, radius?: string | null } | null, chatButton?: { background?: string | null } | null, content?: { background?: string | null } | null, cta?: { background?: string | null, text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null } | null } | null, header?: { background?: string | null, avatarBackground?: string | null, text?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null } | null, subtitle?: { color?: string | null, fontFamily?: string | null, fontSize?: string | null } | null } | null, messages?: { mine?: { bubbleColor?: string | null, text?: { color?: string | null, fontSize?: string | null, fontFamily?: string | null } | null } | null, others?: { bubbleColor?: string | null, text?: { color?: string | null, fontSize?: string | null, fontFamily?: string | null } | null } | null } | null, size?: { width?: string | null, height?: string | null } | null } | null } | { __typename: 'DialogflowAppChannel', type: string, id: string } | { __typename: 'EmailAppChannel', type: string, id: string } | { __typename: 'FacebookMessengerAppChannel', type: string, id: string } | { __typename: 'FormWidgetAppChannel', id: string, key?: string | null, name?: string | null, intentId?: string | null, autoGreeting?: string | null, type: string } | { __typename: 'GoogleBusinessMessagesAppChannel', type: string, id: string } | { __typename: 'IntelligentSearchAppChannel', type: string, id: string } | { __typename: 'LexConnectAppChannel', type: string, id: string } | { __typename: 'LexV2ConnectAppChannel', type: string, id: string } | null> | null } | null, launchRequest?: { __typename: 'Handler', appId: string, intentId: string, organizationId: string, name: string, content?: Array<{ __typename: 'HandlerContent', key: string, handlerResponse: Array<{ __typename: 'JSONDependableHandlerResponse', name?: string | null, tag?: string | null, conditions?: any | null, segments?: Array<{ key: string, segments: Array<{ segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | null> } | null> | null, displays?: Array<{ __typename: 'CardDisplay', type: string, token?: string | null, title?: string | null } | { __typename: 'ListDisplay', type: string, token?: string | null, title?: string | null, items?: Array<{ token?: string | null, url?: string | null, title: string, description?: string | null, hideUrl?: boolean | null, image?: { url: string } | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null } | { __typename: 'LastActiveActiveWithinHandlerResponse', name?: string | null, tag?: string | null, conditions?: any | null, segments?: Array<{ key: string, segments: Array<{ segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | null> } | null> | null, displays?: Array<{ __typename: 'CardDisplay', type: string, token?: string | null, title?: string | null } | { __typename: 'ListDisplay', type: string, token?: string | null, title?: string | null, items?: Array<{ token?: string | null, url?: string | null, title: string, description?: string | null, hideUrl?: boolean | null, image?: { url: string } | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null } | { __typename: 'LastActiveFirstTimeHandlerResponse', name?: string | null, tag?: string | null, conditions?: any | null, segments?: Array<{ key: string, segments: Array<{ segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | null> } | null> | null, displays?: Array<{ __typename: 'CardDisplay', type: string, token?: string | null, title?: string | null } | { __typename: 'ListDisplay', type: string, token?: string | null, title?: string | null, items?: Array<{ token?: string | null, url?: string | null, title: string, description?: string | null, hideUrl?: boolean | null, image?: { url: string } | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null } | { __typename: 'LastActiveHaveNotSeenWithinHandlerResponse', name?: string | null, tag?: string | null, conditions?: any | null, segments?: Array<{ key: string, segments: Array<{ segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | null> } | null> | null, displays?: Array<{ __typename: 'CardDisplay', type: string, token?: string | null, title?: string | null } | { __typename: 'ListDisplay', type: string, token?: string | null, title?: string | null, items?: Array<{ token?: string | null, url?: string | null, title: string, description?: string | null, hideUrl?: boolean | null, image?: { url: string } | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null } | { __typename: 'RequestDependentHandlerResponse', name?: string | null, tag?: string | null, conditions?: any | null, segments?: Array<{ key: string, segments: Array<{ segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | null> } | null> | null, displays?: Array<{ __typename: 'CardDisplay', type: string, token?: string | null, title?: string | null } | { __typename: 'ListDisplay', type: string, token?: string | null, title?: string | null, items?: Array<{ token?: string | null, url?: string | null, title: string, description?: string | null, hideUrl?: boolean | null, image?: { url: string } | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null } | { __typename: 'SchedulableDependentHandlerResponse', name?: string | null, tag?: string | null, conditions?: any | null, segments?: Array<{ key: string, segments: Array<{ segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | null> } | null> | null, displays?: Array<{ __typename: 'CardDisplay', type: string, token?: string | null, title?: string | null } | { __typename: 'ListDisplay', type: string, token?: string | null, title?: string | null, items?: Array<{ token?: string | null, url?: string | null, title: string, description?: string | null, hideUrl?: boolean | null, image?: { url: string } | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null } | { __typename: 'SimpleHandlerResponse', name?: string | null, tag?: string | null, conditions?: any | null, segments?: Array<{ key: string, segments: Array<{ segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | null> } | null> | null, displays?: Array<{ __typename: 'CardDisplay', type: string, token?: string | null, title?: string | null } | { __typename: 'ListDisplay', type: string, token?: string | null, title?: string | null, items?: Array<{ token?: string | null, url?: string | null, title: string, description?: string | null, hideUrl?: boolean | null, image?: { url: string } | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null } | { __typename: 'SlotDependentHandlerResponse', name?: string | null, tag?: string | null, conditions?: any | null, segments?: Array<{ key: string, segments: Array<{ segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | null> } | null> | null, displays?: Array<{ __typename: 'CardDisplay', type: string, token?: string | null, title?: string | null } | { __typename: 'ListDisplay', type: string, token?: string | null, title?: string | null, items?: Array<{ token?: string | null, url?: string | null, title: string, description?: string | null, hideUrl?: boolean | null, image?: { url: string } | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null } | { __typename: 'StorageDependentHandlerResponse', name?: string | null, tag?: string | null, conditions?: any | null, segments?: Array<{ key: string, segments: Array<{ segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | null> } | null> | null, displays?: Array<{ __typename: 'CardDisplay', type: string, token?: string | null, title?: string | null } | { __typename: 'ListDisplay', type: string, token?: string | null, title?: string | null, items?: Array<{ token?: string | null, url?: string | null, title: string, description?: string | null, hideUrl?: boolean | null, image?: { url: string } | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null } | { __typename: 'SystemDependentHandlerResponse', name?: string | null, tag?: string | null, conditions?: any | null, segments?: Array<{ key: string, segments: Array<{ segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | { segment: { displayText?: string | null, ssml?: string | null } } | null> } | null> | null, displays?: Array<{ __typename: 'CardDisplay', type: string, token?: string | null, title?: string | null } | { __typename: 'ListDisplay', type: string, token?: string | null, title?: string | null, items?: Array<{ token?: string | null, url?: string | null, title: string, description?: string | null, hideUrl?: boolean | null, image?: { url: string } | null } | null> | null } | { __typename: 'SimpleDisplay', type: string, token?: string | null, title?: string | null } | null> | null, outputSpeech?: { displayText?: string | null, suggestions?: Array<{ __typename: 'LinkOutSuggestion', title: string, url: string } | { __typename: 'SuggestionObject', title: string } | null> | null } | null } | null> } | null> | null } | null };

export type GetEventsQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  rawQueryText?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  byFlag?: InputMaybe<Array<InputMaybe<RawQueryEventFlag>> | InputMaybe<RawQueryEventFlag>>;
  byTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  byName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  noFlag?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetEventsQuery = { app?: { __typename: 'App', appId: string, organizationId: string, events?: { __typename: 'TotalEvents', total: number, events?: Array<{ __typename: 'Events', currentHandler?: string | null, channel?: string | null, environment?: string | null, eventId: string, eventIndex: string, eventTime?: string | null, eventType?: string | null, eventName?: string | null, errorCode?: number | null, errorMessage?: string | null, request?: string | null, rawQuery?: string | null, platform?: string | null, selectedHandler?: string | null, sessionId?: string | null, stentorRequest?: { platform?: string | null, type?: string | null, anonymous?: boolean | null, channel?: string | null, intentId?: string | null, isHealthCheck?: boolean | null, isNewSession?: boolean | null, rawQuery?: string | null, matchConfidence?: number | null, sessionId?: string | null, userId?: string | null, locale?: string | null, sessionAttributes?: { channel?: string | null, userId?: string | null, sessionId?: string | null } | null } | null, response?: { displays?: any | null, outputSpeech?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title?: string | null, url?: string | null } | null> | null } | null, reprompt?: { displayText?: string | null, ssml?: string | null, suggestions?: Array<{ title?: string | null, url?: string | null } | null> | null } | null } | null, flags?: Array<{ __typename: 'EventFlag', flag: RawQueryEventFlag, flaggedOn: string, note?: string | null, userEmail: string } | null> | null, slots?: Array<{ __typename: 'EventSlots', name?: string | null, rawValue?: string | null, stringValue?: string | null, dateValue?: string | null, startDateValue?: string | null, endDateValue?: string | null, booleanValue?: boolean | null, integerValue?: number | null, stringArrayValue?: Array<string | null> | null, slotValue?: string | null } | null> | null } | null> | null, flagTotals: { OPTIMAL: number, CORRECT: number, NEEDS_HUMAN: number, INCORRECT: number, CONFIRMED_CORRECT: number, HELPFUL: number, FLAGGED: number } } | null } | null };

export type CancelMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
}>;


export type CancelMutation = { app: { update: { subscriptions: { update: { cancel: { appId: string } } } } } };

export type GetAppUpgradeQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
}>;


export type GetAppUpgradeQuery = { org?: { __typename: 'Organization', organizationId: string, type: SubscriptionType, creationDate?: any | null, paymentAccounts?: { stripe?: { customerId: string } | null, so?: { paymentType?: string | null } | null, aws?: { productCode?: string | null, dimension?: string | null, customerId?: string | null } | null } | null } | null, app?: { __typename: 'App', appId: string, organizationId: string, beta?: any | null, name: string, templateType?: string | null, website?: string | null, stripeProductId?: string | null, stripeSubscriptionId?: string | null, subscriptionPaymentStatus?: string | null, subscription?: { __typename: 'SubscriptionDetails', summary?: { __typename: 'SubscriptionSummary', trialEndDate?: string | null, isCancelled: boolean, status: string, lastCharge?: { amount: number, currency: string, date: string, paid: boolean } | null, nextCharge?: { amountDue: number, currency: string, date: string } | null } | null } | null, referenceId?: { id: string, service: string } | null, status?: { type: string, notes?: string | null } | null, limitations: { actionBar: boolean, advancedAnalytics: boolean, excludedIntegrations?: Array<string> | null, maxHandlers: number, maxIntents: number, maxEntities: number, captureLead: boolean, schedule: boolean, preferredTime: boolean, aiLeadTagging: boolean, liveTakeover: boolean, transcriptAccess: boolean, maxKendraDocs: number, reserveWithGoogle: boolean } } | null };

export type StartTestsMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  testType: Scalars['String']['input'];
}>;


export type StartTestsMutation = { startTests: string };

export type AddUtteranceTestMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  testString: Scalars['String']['input'];
}>;


export type AddUtteranceTestMutation = { addUtteranceTestByString?: Array<{ testId: string, utterance?: string | null, createdOn: string, expectedResult?: { type?: string | null, intentId: string, matchedSlots?: Array<{ name: string, stringValue?: string | null } | null> | null } | null } | null> | null };

export type ReplaceUtteranceTestMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  testId: Scalars['ID']['input'];
  createdOn: Scalars['String']['input'];
  testString: Scalars['String']['input'];
}>;


export type ReplaceUtteranceTestMutation = { deleteTest: string, addUtteranceTestByString?: Array<{ testId: string, utterance?: string | null, createdOn: string, expectedResult?: { type?: string | null, intentId: string, matchedSlots?: Array<{ name: string, stringValue?: string | null } | null> | null } | null } | null> | null };

export type DeleteTestMutationVariables = Exact<{
  testId: Scalars['ID']['input'];
  createdOn: Scalars['String']['input'];
}>;


export type DeleteTestMutation = { deleteTest: string };

export type GetAppTestsQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  testType?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetAppTestsQuery = { app?: { appId: string, organizationId: string, channels?: Array<{ __typename: 'ActionsOnGoogleAppChannel', type: string, id: string } | { __typename: 'AlexaAppChannel', type: string, id: string } | { __typename: 'AppChannel', type: string, id: string } | { __typename: 'ChatWidgetAppChannel', type: string, id: string } | { __typename: 'DialogflowAppChannel', type: string, id: string } | { __typename: 'EmailAppChannel', type: string, id: string } | { __typename: 'FacebookMessengerAppChannel', type: string, id: string } | { __typename: 'FormWidgetAppChannel', type: string, id: string } | { __typename: 'GoogleBusinessMessagesAppChannel', type: string, id: string } | { __typename: 'IntelligentSearchAppChannel', type: string, id: string } | { __typename: 'LexConnectAppChannel', type: string, id: string } | { __typename: 'LexV2ConnectAppChannel', type: string, id: string } | null> | null, intents?: { total: number, intents?: Array<{ intentId: string, name: string, slots?: Array<{ isList?: any | null, name: string, type?: string | null } | null> | null } | null> | null } | null } | null, tests?: { total: number, tests?: Array<{ testId: string, utterance?: string | null, createdOn: string, expectedResult?: { type?: string | null, intentId: string, matchedSlots?: Array<{ name: string, stringValue?: string | null } | null> | null } | null } | null> | null } | null };

export type GetAvailableTestTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableTestTypesQuery = { availableTestTypes?: Array<string | null> | null };

export type GetEntitySuggestionsQueryVariables = Exact<{
  appId: Scalars['String']['input'];
  text: Scalars['String']['input'];
}>;


export type GetEntitySuggestionsQuery = { entitySuggestions?: { text: string, entities: Array<{ ner: string, entityId: string, end: number, start: number, rawValue: string, value: string } | null>, tokens: Array<{ id: number, start: number, end: number, pos: string, tag: string, dep: string, head: number } | null>, sentences: Array<{ start: number, end: number } | null> } | null };

export type GetOrgsQueryVariables = Exact<{
  size: Scalars['Int']['input'];
  from: Scalars['Int']['input'];
  withIdOrName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrgsQuery = { orgs?: { total: number, orgs?: Array<{ __typename: 'SearchedOrg', name: string, organizationId: string, type: SubscriptionType, logoUrl?: string | null, paymentAccounts?: { stripe?: { customerId: string } | null, so?: { paymentType?: string | null } | null, aws?: { productCode?: string | null, dimension?: string | null, customerId?: string | null } | null } | null } | null> | null } | null, profile?: { __typename: 'UserProfile', _id: string, entitlements?: { __typename: 'UserEntitlements', availablePro: number } | null } | null };

export type GetOrgListItemQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
}>;


export type GetOrgListItemQuery = { org?: { __typename: 'Organization', _id: string, name: string, organizationId: string, logoUrl?: string | null, usage: { testsExecuted: number, uniqueSessions: number }, apps?: { total: number } | null } | null };

export type GetOrgQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
}>;


export type GetOrgQuery = { org?: { __typename: 'Organization', _id: string, organizationId: string, name: string, type: SubscriptionType, beta?: any | null, description: string, creationDate?: any | null, auth0GroupId?: string | null, contact?: string | null, contactName?: string | null, contactPhone?: string | null, contractDate?: string | null, logoUrl?: string | null, acceptedLatestTermsOfService: boolean, notes?: string | null, website?: string | null, ipRights?: { alexa?: string | null } | null, acceptedTermsOfService: Array<{ email: string, userId: string, acceptedOn: any, url: any }>, paymentAccounts?: { _id: string, stripe?: { customerId: string } | null, so?: { paymentType?: string | null, numberOfApps?: number | null, date?: string | null } | null, aws?: { customerId?: string | null, productCode?: string | null, dimension?: string | null, date?: string | null, currentUsage: { handlers: number, intents: number, entities: number, uniqueSessions: number, testsExecuted: number, docsCrawled: number, totalDocs: number } } | null } | null, usage: { testsExecuted: number, uniqueSessions: number }, apps?: { _id: string, total: number, apps: Array<{ appId: string, name: string } | null> } | null } | null };

export const ChatWidgetChannelFieldsFragmentDoc = gql`
    fragment ChatWidgetChannelFields on ChatWidgetAppChannel {
  __typename
  id
  type
  name
  directoryListing
  endPoint
  status {
    type
    email
    timestamp
  }
  useNLU
  cta {
    message
    timeout
    delay
    animation
    animationTimeout
    mobile {
      applyAtLessThanWidth
      message
      timeout
      delay
      animation
      animationTimeout
    }
  }
  direct
  disabled
  accountKey
  botName
  avatarUrl
  key
  menu {
    menuButtonLocation
    items {
      ... on ChatWidgetMenuItemConfig {
        label
        subtitle
      }
      ... on ChatWidgetMenuItemStaticText {
        title
        body
      }
      ... on ChatWidgetMenuItemStaticImage {
        imageUrl
      }
      ... on ChatWidgetMenuItemOpenURL {
        url
        text
        behavior {
          type
          ... on ChatWidgetAppChannelUrlBehaviorNewWindow {
            width
            height
          }
        }
      }
    }
    itemsTabIndex
    button {
      tabIndex
    }
  }
  serverUrl
  middlewareUrl
  autocompleteSuggestionsUrl
  configurableMessages {
    items {
      delay
      text
    }
  }
  urls {
    policies {
      pattern
      behavior {
        type
        ... on ChatWidgetAppChannelUrlBehaviorNewWindow {
          width
          height
        }
      }
    }
    defaultBehavior {
      type
      ... on ChatWidgetAppChannelUrlBehaviorNewWindow {
        width
        height
      }
    }
  }
  autoOpenOnWidth
  autoOpenOnPattern {
    minimumWidth
    patterns
  }
  chatButton {
    imageUrl
    tabIndex
  }
  actionBar {
    enabled
    position
    mobileBreakpoint
    buttons {
      ... on ActionBarChatButton {
        id
        type
        label
        icon
        iconUrl
        visibility
        tabIndex
      }
      ... on ActionBarEmailButton {
        id
        type
        label
        icon
        iconUrl
        visibility
        tabIndex
        emailAddress
        subject
        body
      }
      ... on ActionBarPhoneButton {
        id
        type
        label
        icon
        iconUrl
        visibility
        tabIndex
        phoneNumber
      }
      ... on ActionBarUrlButton {
        id
        type
        label
        icon
        iconUrl
        visibility
        tabIndex
        url
        target
      }
      ... on ActionBarHelpButton {
        id
        type
        label
        icon
        iconUrl
        visibility
        tabIndex
        url
        target
      }
      ... on ActionBarPaymentButton {
        id
        type
        label
        icon
        iconUrl
        visibility
        tabIndex
        url
        target
      }
      ... on ActionBarFormButton {
        id
        type
        label
        icon
        iconUrl
        visibility
        tabIndex
        intentId
        autoGreeting
        preselectChipLabel
      }
      ... on ActionBarScheduleButton {
        id
        type
        label
        icon
        iconUrl
        visibility
        tabIndex
        intentId
        autoGreeting
        preselectChipLabel
      }
    }
  }
  header {
    status {
      online
      offline
      away
      connecting
    }
    subtitle {
      enabled
      text
    }
    actions {
      refresh
      refreshTabIndex
      minimize
      minimizeTabIndex
      cancel
      cancelTabIndex
    }
    alignTextCenter
  }
  footer {
    branding {
      enabled
      text
    }
    sendButton {
      icon
      tabIndex
    }
    clearButton {
      tabIndex
    }
  }
  typingStatus {
    textTypingStatusEnabled
  }
  theme {
    border {
      color
      width
      radius
    }
    carousel {
      button {
        color
      }
      subtitle {
        color
        fontFamily
        fontSize
        fontWeight
      }
      title {
        color
        fontFamily
        fontSize
        fontWeight
      }
    }
    chatButton {
      background
      border {
        color
        radius
        width
      }
      imageSize {
        width
        height
      }
      animation {
        primaryColor
        secondaryColor
        opacity
      }
      margin {
        top
        right
        bottom
        left
      }
    }
    content {
      background
    }
    cta {
      background
      text {
        color
        fontFamily
        fontSize
      }
    }
    footer {
      background
      border {
        color
        radius
        width
      }
      branding {
        text {
          color
          fontFamily
          fontSize
          fontStyle
          fontWeight
        }
      }
    }
    header {
      background
      avatarBackground
      border {
        color
        radius
        width
      }
      padding {
        left
        right
        top
        bottom
      }
      text {
        color
        fontFamily
        fontSize
        fontStyle
        fontWeight
      }
      subtitle {
        color
        fontFamily
        fontSize
        fontStyle
        fontWeight
      }
    }
    input {
      background
      border {
        color
        width
        radius
      }
      text {
        color
        fontFamily
        fontSize
      }
      placeholder {
        color
        fontFamily
        fontSize
        fontWeight
        fontStyle
      }
    }
    menu {
      item {
        height
        background
        text {
          color
          fontSize
          fontFamily
          fontWeight
          fontStyle
        }
      }
    }
    menuButton {
      color
    }
    messages {
      mine {
        bubbleColor
        text {
          color
          fontSize
          fontFamily
          fontWeight
          fontStyle
        }
      }
      others {
        bubbleColor
        text {
          color
          fontSize
          fontFamily
          fontWeight
          fontStyle
        }
      }
      padding {
        left
        right
        bottom
        top
      }
      maxWidth
    }
    minimizeButton {
      color
    }
    cancelButton {
      color
    }
    refreshButton {
      color
    }
    primaryColor
    zIndex
    sendButton {
      color
      width
    }
    size {
      width
      height
    }
    textTypingStatus {
      text {
        color
        fontFamily
        fontSize
        fontStyle
        fontWeight
      }
    }
  }
  input {
    placeholder
  }
  connection {
    type
    serverUrl
  }
}
    `;
export const IntelligentSearchChannelFieldsFragmentDoc = gql`
    fragment IntelligentSearchChannelFields on IntelligentSearchAppChannel {
  __typename
  id
  type
  name
  key
  autocompleteSuggestionsUrl
  connection {
    serverUrl
  }
  theme {
    accentColor
    border {
      color
      width
      radius
      style
    }
    card {
      background
      border {
        color
        width
        radius
        style
      }
      description {
        margin {
          bottom
          left
          right
          top
        }
        padding {
          bottom
          left
          right
          top
        }
        text {
          color
          fontFamily
          fontSize
          fontStyle
          fontWeight
          lineHeight
        }
      }
      link {
        margin {
          bottom
          left
          right
          top
        }
        padding {
          bottom
          left
          right
          top
        }
        text {
          default {
            color
            fontFamily
            fontSize
            fontStyle
            fontWeight
            lineHeight
          }
        }
      }
      margin {
        bottom
        left
        right
        top
      }
      padding {
        bottom
        left
        right
        top
      }
      title {
        margin {
          bottom
          left
          right
          top
        }
        padding {
          bottom
          left
          right
          top
        }
        text {
          color
          fontFamily
          fontSize
          fontStyle
          fontWeight
          lineHeight
        }
      }
    }
    carousel {
      card {
        background
        border {
          color
          width
          radius
          style
        }
        description {
          margin {
            bottom
            left
            right
            top
          }
          padding {
            bottom
            left
            right
            top
          }
          text {
            color
            fontFamily
            fontSize
            fontStyle
            fontWeight
            lineHeight
          }
        }
        link {
          margin {
            bottom
            left
            right
            top
          }
          padding {
            bottom
            left
            right
            top
          }
          text {
            default {
              color
              fontFamily
              fontSize
              fontStyle
              fontWeight
              lineHeight
            }
          }
        }
        margin {
          bottom
          left
          right
          top
        }
        padding {
          bottom
          left
          right
          top
        }
        title {
          margin {
            bottom
            left
            right
            top
          }
          padding {
            bottom
            left
            right
            top
          }
          text {
            color
            fontFamily
            fontSize
            fontStyle
            fontWeight
            lineHeight
          }
        }
      }
    }
    list {
      card {
        background
        border {
          color
          width
          radius
          style
        }
        description {
          margin {
            bottom
            left
            right
            top
          }
          padding {
            bottom
            left
            right
            top
          }
          text {
            color
            fontFamily
            fontSize
            fontStyle
            fontWeight
            lineHeight
          }
        }
        link {
          margin {
            bottom
            left
            right
            top
          }
          padding {
            bottom
            left
            right
            top
          }
          text {
            default {
              color
              fontFamily
              fontSize
              fontStyle
              fontWeight
              lineHeight
            }
          }
        }
        margin {
          bottom
          left
          right
          top
        }
        padding {
          bottom
          left
          right
          top
        }
        title {
          margin {
            bottom
            left
            right
            top
          }
          padding {
            bottom
            left
            right
            top
          }
          text {
            color
            fontFamily
            fontSize
            fontStyle
            fontWeight
            lineHeight
          }
        }
      }
    }
    messages {
      others {
        bubble {
          background
        }
        text {
          color
          fontFamily
          fontSize
          fontStyle
          fontWeight
          lineHeight
        }
      }
    }
  }
}
    `;
export const FormWidgetChannelFieldsFragmentDoc = gql`
    fragment FormWidgetChannelFields on FormWidgetAppChannel {
  __typename
  id
  type
  name
  key
  autoGreeting
  intentId
  sideButtonLabel
  directoryListing
  useNLU
  businessName
  businessLogoUrl
  businessAddress
  businessWebsite
  chatWidgetKey
  trustedForm {
    scriptUrl
  }
  metaPixelId
  autoOpen {
    enabled
  }
  connection {
    serverUrl
    accountKey
  }
  theme {
    accentColor
    backgroundColor
    headerBackgroundColor
    headerTextColor
    primaryButtonColor
    primaryButtonTextColor
    secondaryButtonColor
    secondaryButtonTextColor
    card {
      backgroundColor
      color
      fontSize
    }
    checkbox {
      backgroundColor
      color
      fontSize
    }
    chips {
      backgroundColor
      backgroundColorSelected
      color
      colorSelected
      fontSize
    }
    date {
      backgroundColor
      backgroundColorSelected
      color
      fontSize
    }
    dropdown {
      backgroundColor
      color
      fontSize
    }
    sideButton {
      backgroundColor
      color
      top
      position
      minLength
      fontSize
    }
    text {
      backgroundColor
      color
      fontSize
    }
    standAlone {
      backgroundColor
      header {
        backgroundColor
        color
        fontSize
      }
    }
    data
  }
}
    `;
export const AlexaChannelFieldsFragmentDoc = gql`
    fragment AlexaChannelFields on AlexaAppChannel {
  __typename
  id
  type
  name
  invocationName
  hasCredentials
  skillId
  vendorId
  category
  distributionMode
  isAvailableWorldwide
  distributionCountries
  permissions {
    name
  }
  vendors {
    id
    name
    roles
  }
  useManifest
  privacyAndCompliance {
    allowsPurchases
    containsAds
    isChildDirected
    isExportCompliant
    usesPersonalInfo
  }
  directoryListing
  endPoint
  status {
    type
    email
    timestamp
  }
  useNLU
}
    `;
export const DialogflowChannelFieldsFragmentDoc = gql`
    fragment DialogflowChannelFields on DialogflowAppChannel {
  __typename
  id
  type
  name
  hasCredentials
  additionalInformationQuestions {
    intendedForUnderThirteen
    alcoholAndTobaccoRelatedContent
  }
  directoryListing
  endPoint
  status {
    type
    email
    timestamp
  }
  useNLU
}
    `;
export const ActionsOnGoogleChannelFieldsFragmentDoc = gql`
    fragment ActionsOnGoogleChannelFields on ActionsOnGoogleAppChannel {
  __typename
  id
  type
  name
  hasCredentials
  additionalInformationQuestions {
    intendedForUnderThirteen
    alcoholAndTobaccoRelatedContent
  }
  directoryListing
  endPoint
  status {
    type
    email
    timestamp
  }
  useNLU
}
    `;
export const LexConnectChannelFieldsFragmentDoc = gql`
    fragment LexConnectChannelFields on LexConnectAppChannel {
  __typename
  id
  type
  name
  voiceId
  nluIntentConfidenceThreshold
  idleSessionTTLInSeconds
  detectSentiment
  isLinkedToKendra
  lexPostTextUrl
  enableModelImprovements
  botName
  directoryListing
  endPoint
  status {
    type
    email
    timestamp
  }
  useNLU
}
    `;
export const LexV2ConnectChannelFieldsFragmentDoc = gql`
    fragment LexV2ConnectChannelFields on LexV2ConnectAppChannel {
  __typename
  id
  type
  name
  voiceId
  idleSessionTTLInSeconds
  detectSentiment
  isLinkedToKendra
  lexPostTextUrl
  enableModelImprovements
  botId
  botName
  botRegion
  lexFulfillmentLambdaARN
  managementRole
  managementRoleExternalId
  directoryListing
  endPoint
  status {
    type
    email
    timestamp
  }
  useNLU
}
    `;
export const HandlerPartsFragmentDoc = gql`
    fragment HandlerParts on Handler {
  __typename
  appId
  intentId
  organizationId
  createdAt
  updatedAt
  name
  langCode
  utterancePatterns
  dialogflowId
  type
  defaultLocale
  graphCoords {
    x
    y
  }
  permissions
  slots {
    name
    type
    isList
    nlu
    _id
  }
  validation {
    isValid
    errors {
      errorMessage
      propertyName
    }
  }
  content {
    __typename
    key
    handlerResponse {
      __typename
      displays {
        __typename
        type
        token
        title
        ... on ListDisplay {
          itemsName
          itemsObject
          range {
            length
            from
          }
          items {
            token
            url
            synonyms
            image {
              url
              urlIcon
              imageActionUrl
              accessibilityText
              width
              height
            }
            title
            description
            buttons {
              title
            }
          }
        }
        ... on CardDisplay {
          content
          smallImageUrl
          largeImageUrl
          imageActionUrl
          accessibilityText
          buttons {
            title
            openUrlAction
          }
        }
      }
      outputSpeech {
        ssml
        textToSpeech
        displayText
        suggestions {
          __typename
          ... on SuggestionObject {
            title
          }
          ... on LinkOutSuggestion {
            title
            url
          }
        }
      }
      segments {
        key
        segments {
          segment {
            ssml
            displayText
          }
        }
      }
      reprompt {
        ssml
        textToSpeech
        displayText
        suggestions {
          __typename
        }
      }
      context {
        active {
          name
          parameters
          timeToLive {
            timeToLiveInSeconds
            turnsToLive
          }
        }
      }
      ... on SchedulableDependentHandlerResponse {
        schedule {
          start {
            format
            dayOfWeek
            time
            timeZone
          }
          duration {
            format
            amount
          }
        }
      }
      name
      tag
      system
      data
      channel {
        name
      }
      conditions
      ... on SchedulableDependentHandlerResponse {
        schedule {
          start {
            time
            format
            dayOfWeek
            timeZone
          }
          duration {
            format
            amount
          }
        }
      }
    }
  }
  data
  forward {
    key
    paths {
      actions
      conditions
      data
      platform
      ... on ExecutableHandlerPath {
        intentId
        slots
        type
      }
    }
  }
  redirect {
    key
    paths {
      actions
      conditions
      data
      platform
      ... on ExecutableHandlerPath {
        intentId
        slots
        type
      }
    }
  }
}
    `;
export const AuditTrailFieldsFragmentDoc = gql`
    fragment AuditTrailFields on LeadSentToIntegration {
  auditTrail {
    summary {
      method
      statusCode
      url
      durationMs
      timestamp
      errorMessage
      wasError
    }
    details {
      sequence
      method
      url
      statusCode
      durationMs
      timestamp
      errorMessage
      wasError
      stepDescription
      requestBody
      requestHeaders
      responseBody
      responseHeaders
    }
  }
}
    `;
export const OrgLeadAuditTrailFieldsFragmentDoc = gql`
    fragment OrgLeadAuditTrailFields on LeadSentToIntegration {
  auditTrail {
    summary {
      method
      statusCode
      url
      durationMs
      timestamp
      errorMessage
      wasError
    }
    details {
      sequence
      method
      url
      statusCode
      durationMs
      timestamp
      errorMessage
      wasError
      stepDescription
      requestBody
      requestHeaders
      responseBody
      responseHeaders
    }
  }
}
    `;
export const HandlerResponseFragmentDoc = gql`
    fragment HandlerResponse on HandlerResponse {
  tag
  tags
  name
  conditions
  context {
    active {
      name
      parameters
    }
  }
  channel {
    name
  }
  displays {
    title
    type
    token
    payload
  }
  reprompt {
    displayText
    ssml
  }
  outputSpeech {
    displayText
    ssml
    suggestions {
      ... on LinkOutSuggestion {
        title
        url
      }
      ... on SuggestionObject {
        title
      }
    }
  }
}
    `;
export const GetUserProfileDocument = gql`
    query getUserProfile($jwt: String) {
  profile(jwt: $jwt) {
    _id
    __typename
    email
    userId
    origin
    isAdmin
    emailVerified
    icon
    roles {
      __typename
      organizationId
      roles
    }
    identities {
      __typename
      userId
      provider
    }
    roles {
      organizationId
    }
  }
}
    `;

export function useGetUserProfileQuery(options?: Omit<Urql.UseQueryArgs<GetUserProfileQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUserProfileQuery, GetUserProfileQueryVariables>({ query: GetUserProfileDocument, ...options });
};
export const GetAppListItemDocument = gql`
    query getAppListItem($appId: ID!) {
  app(appId: $appId) {
    __typename
    appId
    organizationId
    name
  }
}
    `;

export function useGetAppListItemQuery(options: Omit<Urql.UseQueryArgs<GetAppListItemQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAppListItemQuery, GetAppListItemQueryVariables>({ query: GetAppListItemDocument, ...options });
};
export const GetTotalAppsForOrgDocument = gql`
    query getTotalAppsForOrg($organizationId: ID!) {
  org(organizationId: $organizationId) {
    __typename
    organizationId
    apps {
      total
    }
  }
}
    `;

export function useGetTotalAppsForOrgQuery(options: Omit<Urql.UseQueryArgs<GetTotalAppsForOrgQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTotalAppsForOrgQuery, GetTotalAppsForOrgQueryVariables>({ query: GetTotalAppsForOrgDocument, ...options });
};
export const GetAppStatusTotalsForOrgDocument = gql`
    query getAppStatusTotalsForOrg($organizationId: ID!) {
  org(organizationId: $organizationId) {
    __typename
    organizationId
    name
    notes
    website
    type
    allApps: apps {
      total
    }
    submitted: apps(byStatusType: ["Submitted For Review", "Submitted for Review"]) {
      total
    }
    live: apps(byStatusType: ["Live"]) {
      total
    }
    readyForInstall: apps(byStatusType: ["Ready for Install", "Ready For Install"]) {
      total
    }
    requiresAttention: apps(byStatusType: ["Requires Attention"]) {
      total
    }
    inReview: apps(byStatusType: ["In Review", "Under Review"]) {
      total
    }
    cancelled: apps(byStatusType: ["Cancelled"]) {
      total
    }
    archived: apps(byStatusType: ["Archived"]) {
      total
    }
    incomplete: apps(byStatusType: ["Incomplete"]) {
      total
    }
  }
}
    `;

export function useGetAppStatusTotalsForOrgQuery(options: Omit<Urql.UseQueryArgs<GetAppStatusTotalsForOrgQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAppStatusTotalsForOrgQuery, GetAppStatusTotalsForOrgQueryVariables>({ query: GetAppStatusTotalsForOrgDocument, ...options });
};
export const SearchAdminAppsDocument = gql`
    query searchAdminApps($from: Int, $size: Int, $withIdOrName: String, $organizationId: String, $needsVerification: Boolean, $byStatusType: [String], $needsPlaces: Boolean) {
  apps(
    from: $from
    size: $size
    withIdOrName: $withIdOrName
    organizationId: $organizationId
    needsVerification: $needsVerification
    byStatusType: $byStatusType
    needsPlaces: $needsPlaces
  ) {
    total
    apps {
      appId
      organizationId
      name
      summary
      smallIcon
      largeIcon
      status {
        type
        timestamp
      }
      placeCount
      verifiedPlaceCount
      placesNeedingVerificationCount
      hasUnverifiedPlaceNotOptedOut
      allPlacesVerified
    }
  }
}
    `;

export function useSearchAdminAppsQuery(options?: Omit<Urql.UseQueryArgs<SearchAdminAppsQueryVariables>, 'query'>) {
  return Urql.useQuery<SearchAdminAppsQuery, SearchAdminAppsQueryVariables>({ query: SearchAdminAppsDocument, ...options });
};
export const GetAppsForOrgDocument = gql`
    query getAppsForOrg($organizationId: ID!, $from: Int, $size: Int, $name: String, $byStatusType: [String], $nuSortBy: [OrgAppQuerySortByParameters]) {
  org(organizationId: $organizationId) {
    __typename
    organizationId
    name
    notes
    website
    type
    allApps: apps(size: 1) {
      total
      apps {
        appId
        name
      }
    }
    apps(
      from: $from
      size: $size
      byName: $name
      byStatusType: $byStatusType
      nuSortBy: $nuSortBy
    ) {
      total
      apps {
        _id
        __typename
        appId
        organizationId
        name
        summary
        status {
          type
          timestamp
          __typename
        }
        largeIcon
        smallIcon
        alexaSkillId
        alexaCategory
        actionsOnGoogleId
        invocationName
        description
      }
    }
  }
}
    `;

export function useGetAppsForOrgQuery(options: Omit<Urql.UseQueryArgs<GetAppsForOrgQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAppsForOrgQuery, GetAppsForOrgQueryVariables>({ query: GetAppsForOrgDocument, ...options });
};
export const UpgradeOrgToPartnerDocument = gql`
    mutation upgradeOrgToPartner($organizationId: ID!) {
  org {
    org(organizationId: $organizationId) {
      updateTier(type: PARTNER)
    }
  }
}
    `;

export function useUpgradeOrgToPartnerMutation() {
  return Urql.useMutation<UpgradeOrgToPartnerMutation, UpgradeOrgToPartnerMutationVariables>(UpgradeOrgToPartnerDocument);
};
export const SearchAdminOrgsDocument = gql`
    query searchAdminOrgs($size: Int!, $from: Int!, $withIdOrName: String) {
  orgs(size: $size, from: $from, withIdOrName: $withIdOrName) {
    total
    orgs {
      __typename
      name
      organizationId
      type
      logoUrl
    }
  }
}
    `;

export function useSearchAdminOrgsQuery(options: Omit<Urql.UseQueryArgs<SearchAdminOrgsQueryVariables>, 'query'>) {
  return Urql.useQuery<SearchAdminOrgsQuery, SearchAdminOrgsQueryVariables>({ query: SearchAdminOrgsDocument, ...options });
};
export const AddFaqDocument = gql`
    mutation addFAQ($appId: ID!, $faqs: [AddFAQ]!) {
  app {
    update(appId: $appId) {
      faq {
        addFAQs(faqs: $faqs) {
          __typename
          _id
          name
          answer
          questions
          url
          raw
          created
          wasAdded
          reason
        }
      }
    }
  }
}
    `;

export function useAddFaqMutation() {
  return Urql.useMutation<AddFaqMutation, AddFaqMutationVariables>(AddFaqDocument);
};
export const UpdateFaqItemDocument = gql`
    mutation updateFAQItem($appId: ID!, $faqId: ID!, $faq: UpdateFAQ!) {
  app {
    update(appId: $appId) {
      faq {
        update(id: $faqId) {
          updateFAQ(faq: $faq) {
            __typename
            _id
            name
            answer
            questions
            url
            excludeFromAutoComplete
          }
        }
      }
    }
  }
}
    `;

export function useUpdateFaqItemMutation() {
  return Urql.useMutation<UpdateFaqItemMutation, UpdateFaqItemMutationVariables>(UpdateFaqItemDocument);
};
export const DeleteFaqDocument = gql`
    mutation deleteFAQ($appId: ID!, $faqId: ID!) {
  app {
    update(appId: $appId) {
      faq {
        update(id: $faqId) {
          deleteFAQ
        }
      }
    }
  }
}
    `;

export function useDeleteFaqMutation() {
  return Urql.useMutation<DeleteFaqMutation, DeleteFaqMutationVariables>(DeleteFaqDocument);
};
export const ExportFaqDocument = gql`
    mutation exportFAQ($appId: ID!, $includeUrl: Boolean, $includeTitle: Boolean) {
  app {
    update(appId: $appId) {
      faq {
        exportToCSV(includeUrl: $includeUrl, includeTitle: $includeTitle) {
          url
        }
      }
    }
  }
}
    `;

export function useExportFaqMutation() {
  return Urql.useMutation<ExportFaqMutation, ExportFaqMutationVariables>(ExportFaqDocument);
};
export const ImportFaqDocument = gql`
    mutation importFAQ($appId: ID!, $url: URL!, $hasTitle: Boolean) {
  app {
    update(appId: $appId) {
      faq {
        uploadCSV(file: $url, hasTitle: $hasTitle) {
          faqsAdded
        }
      }
    }
  }
}
    `;

export function useImportFaqMutation() {
  return Urql.useMutation<ImportFaqMutation, ImportFaqMutationVariables>(ImportFaqDocument);
};
export const GetAnswersDocument = gql`
    query getAnswers($appId: ID!, $text: String, $size: Int!, $from: Int!) {
  app(appId: $appId) {
    _id
    appId
    faq(text: $text, size: $size, from: $from) {
      total
      faq {
        __typename
        _id
        url
        questions
        answer
        name
        created
        excludeFromAutoComplete
      }
    }
  }
}
    `;

export function useGetAnswersQuery(options: Omit<Urql.UseQueryArgs<GetAnswersQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAnswersQuery, GetAnswersQueryVariables>({ query: GetAnswersDocument, ...options });
};
export const GetAnswerDocument = gql`
    query getAnswer($appId: ID!, $answerId: ID!) {
  app(appId: $appId) {
    _id
    appId
    faq(id: $answerId) {
      faq {
        __typename
        _id
        url
        questions
        answer
        name
        created
        excludeFromAutoComplete
      }
    }
  }
}
    `;

export function useGetAnswerQuery(options: Omit<Urql.UseQueryArgs<GetAnswerQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAnswerQuery, GetAnswerQueryVariables>({ query: GetAnswerDocument, ...options });
};
export const GetfaqQuestionsSuggestionsDocument = gql`
    query getfaqQuestionsSuggestions($appId: ID!, $answerId: ID!) {
  app(appId: $appId) {
    _id
    appId
    faq(id: $answerId) {
      faq {
        _id
        faqQuestionsSuggestions {
          suggestions {
            question
          }
        }
      }
    }
  }
}
    `;

export function useGetfaqQuestionsSuggestionsQuery(options: Omit<Urql.UseQueryArgs<GetfaqQuestionsSuggestionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetfaqQuestionsSuggestionsQuery, GetfaqQuestionsSuggestionsQueryVariables>({ query: GetfaqQuestionsSuggestionsDocument, ...options });
};
export const GetAppAnalyticsDocument = gql`
    query getAppAnalytics($appId: ID!, $startDate: DateTime!, $endDate: DateTime!) {
  app(appId: $appId) {
    _id
    __typename
    name
    analytics {
      user(start: $startDate, end: $endDate) {
        newUsers
        returningUsers
        totalSessions
        totalUsers
      }
    }
  }
}
    `;

export function useGetAppAnalyticsQuery(options: Omit<Urql.UseQueryArgs<GetAppAnalyticsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAppAnalyticsQuery, GetAppAnalyticsQueryVariables>({ query: GetAppAnalyticsDocument, ...options });
};
export const GetUserAnalyticsDocument = gql`
    query getUserAnalytics($appId: ID!, $startDate: DateTime!, $endDate: DateTime!) {
  app(appId: $appId) {
    analytics {
      user(start: $startDate, end: $endDate) {
        newUsers
        totalUsers
        totalSessions
        intervals {
          isoDate
          interval
          newUsers
          returningUsers
        }
      }
    }
  }
}
    `;

export function useGetUserAnalyticsQuery(options: Omit<Urql.UseQueryArgs<GetUserAnalyticsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUserAnalyticsQuery, GetUserAnalyticsQueryVariables>({ query: GetUserAnalyticsDocument, ...options });
};
export const ExportAnalyticsAsCsvDocument = gql`
    query exportAnalyticsAsCSV($appId: ID!, $start: DateTime!, $end: DateTime!) {
  app(appId: $appId) {
    analytics {
      user(start: $start, end: $end) {
        csv {
          file
        }
      }
    }
  }
}
    `;

export function useExportAnalyticsAsCsvQuery(options: Omit<Urql.UseQueryArgs<ExportAnalyticsAsCsvQueryVariables>, 'query'>) {
  return Urql.useQuery<ExportAnalyticsAsCsvQuery, ExportAnalyticsAsCsvQueryVariables>({ query: ExportAnalyticsAsCsvDocument, ...options });
};
export const CreateAlexaSkillDocument = gql`
    mutation createAlexaSkill($appId: ID!, $channelId: ID) {
  createSkill(appId: $appId, channelId: $channelId) {
    id
    skillId
  }
}
    `;

export function useCreateAlexaSkillMutation() {
  return Urql.useMutation<CreateAlexaSkillMutation, CreateAlexaSkillMutationVariables>(CreateAlexaSkillDocument);
};
export const UpdateAlexaSkillDocument = gql`
    mutation updateAlexaSkill($appId: ID!, $channelId: ID) {
  updateSkill(appId: $appId, channelId: $channelId) {
    id
    skillId
  }
}
    `;

export function useUpdateAlexaSkillMutation() {
  return Urql.useMutation<UpdateAlexaSkillMutation, UpdateAlexaSkillMutationVariables>(UpdateAlexaSkillDocument);
};
export const WithdrawFromAlexaCertDocument = gql`
    mutation withdrawFromAlexaCert($appId: ID!, $channelId: ID, $reason: WithdrawFromAlexaCertReasons, $note: String) {
  withdrawFromAlexaCert(
    appId: $appId
    channelId: $channelId
    reason: $reason
    note: $note
  ) {
    id
  }
}
    `;

export function useWithdrawFromAlexaCertMutation() {
  return Urql.useMutation<WithdrawFromAlexaCertMutation, WithdrawFromAlexaCertMutationVariables>(WithdrawFromAlexaCertDocument);
};
export const AddAlexaCredentialsByCodeDocument = gql`
    mutation addAlexaCredentialsByCode($appId: ID!, $channelId: ID!, $code: String!, $redirectUri: String) {
  addAlexaCredentialsByCode(
    appId: $appId
    channelId: $channelId
    code: $code
    redirectUri: $redirectUri
  ) {
    appId
    _id
    __typename
    channels {
      __typename
      id
      ... on AlexaAppChannel {
        __typename
        id
        hasCredentials
        vendorId
        vendors {
          id
          __typename
          name
          roles
        }
      }
    }
  }
}
    `;

export function useAddAlexaCredentialsByCodeMutation() {
  return Urql.useMutation<AddAlexaCredentialsByCodeMutation, AddAlexaCredentialsByCodeMutationVariables>(AddAlexaCredentialsByCodeDocument);
};
export const AddAlexaVendorToChannelDocument = gql`
    mutation addAlexaVendorToChannel($appId: ID!, $channelId: ID!, $vendorId: ID!) {
  attachSmapiVendorToChannel(
    appId: $appId
    channelId: $channelId
    vendorId: $vendorId
  ) {
    __typename
    id
    vendorId
    skillId
  }
}
    `;

export function useAddAlexaVendorToChannelMutation() {
  return Urql.useMutation<AddAlexaVendorToChannelMutation, AddAlexaVendorToChannelMutationVariables>(AddAlexaVendorToChannelDocument);
};
export const GetAlexaChannelVendorsDocument = gql`
    query getAlexaChannelVendors($appId: ID!) {
  app(appId: $appId) {
    __typename
    appId
    channels {
      __typename
      id
      ... on AlexaAppChannel {
        vendorId
        vendors {
          id
          name
          roles
        }
      }
    }
  }
}
    `;

export function useGetAlexaChannelVendorsQuery(options: Omit<Urql.UseQueryArgs<GetAlexaChannelVendorsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAlexaChannelVendorsQuery, GetAlexaChannelVendorsQueryVariables>({ query: GetAlexaChannelVendorsDocument, ...options });
};
export const DeleteChannelDocument = gql`
    mutation DeleteChannel($appId: ID!, $channelId: ID, $channelType: String!) {
  deleteChannel(appId: $appId, channelType: $channelType, channelId: $channelId)
}
    `;

export function useDeleteChannelMutation() {
  return Urql.useMutation<DeleteChannelMutation, DeleteChannelMutationVariables>(DeleteChannelDocument);
};
export const AddDialogflowCredentialsDocument = gql`
    mutation addDialogflowCredentials($appId: ID!, $channelId: ID, $credentials: DialogflowCredentialsInput!) {
  addDialogflowCredentials(
    appId: $appId
    channelId: $channelId
    credentials: $credentials
  ) {
    name
  }
}
    `;

export function useAddDialogflowCredentialsMutation() {
  return Urql.useMutation<AddDialogflowCredentialsMutation, AddDialogflowCredentialsMutationVariables>(AddDialogflowCredentialsDocument);
};
export const AddActionsOnGoogleChannelDocument = gql`
    mutation addActionsOnGoogleChannel($appId: ID!, $channel: ActionsOnGoogleAppChannelInput!) {
  addActionsOnGoogleChannel(appId: $appId, channel: $channel) {
    ...ActionsOnGoogleChannelFields
    credentialsURL
  }
}
    ${ActionsOnGoogleChannelFieldsFragmentDoc}`;

export function useAddActionsOnGoogleChannelMutation() {
  return Urql.useMutation<AddActionsOnGoogleChannelMutation, AddActionsOnGoogleChannelMutationVariables>(AddActionsOnGoogleChannelDocument);
};
export const AddAlexaChannelDocument = gql`
    mutation addAlexaChannel($appId: ID!, $channel: AlexaAppChannelInput!) {
  addAlexaChannel(appId: $appId, channel: $channel) {
    ...AlexaChannelFields
  }
}
    ${AlexaChannelFieldsFragmentDoc}`;

export function useAddAlexaChannelMutation() {
  return Urql.useMutation<AddAlexaChannelMutation, AddAlexaChannelMutationVariables>(AddAlexaChannelDocument);
};
export const AddAlexaCredentialsDocument = gql`
    mutation addAlexaCredentials($appId: ID!, $channelId: ID, $credentials: AlexaCredentialsInput!) {
  addAlexaCredentials(
    appId: $appId
    channelId: $channelId
    credentials: $credentials
  ) {
    appId
  }
}
    `;

export function useAddAlexaCredentialsMutation() {
  return Urql.useMutation<AddAlexaCredentialsMutation, AddAlexaCredentialsMutationVariables>(AddAlexaCredentialsDocument);
};
export const AddDialogflowChannelDocument = gql`
    mutation addDialogflowChannel($appId: ID!, $channel: DialogflowAppChannelInput!) {
  addDialogflowChannel(appId: $appId, channel: $channel) {
    ...DialogflowChannelFields
  }
}
    ${DialogflowChannelFieldsFragmentDoc}`;

export function useAddDialogflowChannelMutation() {
  return Urql.useMutation<AddDialogflowChannelMutation, AddDialogflowChannelMutationVariables>(AddDialogflowChannelDocument);
};
export const SubmitForAlexaCertDocument = gql`
    mutation submitForAlexaCert($appId: ID!, $channelId: ID) {
  submitForAlexaCert(appId: $appId, channelId: $channelId) {
    id
  }
}
    `;

export function useSubmitForAlexaCertMutation() {
  return Urql.useMutation<SubmitForAlexaCertMutation, SubmitForAlexaCertMutationVariables>(SubmitForAlexaCertDocument);
};
export const SyncFaqToKendraDocument = gql`
    mutation syncFAQToKendra($organizationId: ID!, $appId: ID!, $channelId: ID!) {
  app(organizationId: $organizationId) {
    update(appId: $appId) {
      channel {
        update(channelId: $channelId) {
          syncFAQToKendra {
            executionId
          }
        }
      }
    }
  }
}
    `;

export function useSyncFaqToKendraMutation() {
  return Urql.useMutation<SyncFaqToKendraMutation, SyncFaqToKendraMutationVariables>(SyncFaqToKendraDocument);
};
export const AddLexChannelDocument = gql`
    mutation addLexChannel($appId: ID!, $channel: LexConnectAppChannelInput!) {
  addLexChannel(appId: $appId, channel: $channel) {
    ...LexConnectChannelFields
  }
}
    ${LexConnectChannelFieldsFragmentDoc}`;

export function useAddLexChannelMutation() {
  return Urql.useMutation<AddLexChannelMutation, AddLexChannelMutationVariables>(AddLexChannelDocument);
};
export const AddLexV2ChannelDocument = gql`
    mutation addLexV2Channel($appId: ID!, $channel: LexV2ConnectAppChannelInput!) {
  app {
    update(appId: $appId) {
      channel {
        addLexV2Channel(channel: $channel) {
          ...LexV2ConnectChannelFields
        }
      }
    }
  }
}
    ${LexV2ConnectChannelFieldsFragmentDoc}`;

export function useAddLexV2ChannelMutation() {
  return Urql.useMutation<AddLexV2ChannelMutation, AddLexV2ChannelMutationVariables>(AddLexV2ChannelDocument);
};
export const PushLexDocument = gql`
    mutation pushLex($appId: ID!, $channelId: ID!) {
  pushLex(appId: $appId, channelId: $channelId)
}
    `;

export function usePushLexMutation() {
  return Urql.useMutation<PushLexMutation, PushLexMutationVariables>(PushLexDocument);
};
export const PushLexV2Document = gql`
    mutation pushLexV2($appId: ID!, $channelId: ID!) {
  pushLex(appId: $appId, channelId: $channelId)
}
    `;

export function usePushLexV2Mutation() {
  return Urql.useMutation<PushLexV2Mutation, PushLexV2MutationVariables>(PushLexV2Document);
};
export const AddChatWidgetChannelDocument = gql`
    mutation addChatWidgetChannel($appId: ID!, $channel: ChatWidgetAppChannelInput!) {
  addChatWidgetChannel(appId: $appId, channel: $channel) {
    ...ChatWidgetChannelFields
  }
}
    ${ChatWidgetChannelFieldsFragmentDoc}`;

export function useAddChatWidgetChannelMutation() {
  return Urql.useMutation<AddChatWidgetChannelMutation, AddChatWidgetChannelMutationVariables>(AddChatWidgetChannelDocument);
};
export const AddChannelDocument = gql`
    mutation addChannel($appId: ID!, $channel: AppChannelInput!) {
  addChannel(appId: $appId, channel: $channel) {
    id
    type
    name
    __typename
  }
}
    `;

export function useAddChannelMutation() {
  return Urql.useMutation<AddChannelMutation, AddChannelMutationVariables>(AddChannelDocument);
};
export const UpdateChannelDocument = gql`
    mutation updateChannel($appId: ID!, $channel: AppChannelInput!) {
  addChannel(appId: $appId, channel: $channel) {
    id
    type
    name
    __typename
  }
}
    `;

export function useUpdateChannelMutation() {
  return Urql.useMutation<UpdateChannelMutation, UpdateChannelMutationVariables>(UpdateChannelDocument);
};
export const UpdateSearchChannelDocument = gql`
    mutation updateSearchChannel($appId: ID!, $channel: IntelligentSearchAppChannelInput!) {
  app {
    update(appId: $appId) {
      channel {
        addIntelligentSearchChannel(channel: $channel) {
          ...IntelligentSearchChannelFields
          endPoint
          directoryListing
        }
      }
    }
  }
}
    ${IntelligentSearchChannelFieldsFragmentDoc}`;

export function useUpdateSearchChannelMutation() {
  return Urql.useMutation<UpdateSearchChannelMutation, UpdateSearchChannelMutationVariables>(UpdateSearchChannelDocument);
};
export const AddGoogleBusinessChannelDocument = gql`
    mutation addGoogleBusinessChannel($appId: ID!, $channel: GoogleBusinessMessagesAppChannelInput!) {
  app {
    update(appId: $appId) {
      channel {
        addGoogleBusinessMessageChannel(channel: $channel) {
          __typename
          id
          type
          name
          endPoint
        }
      }
    }
  }
}
    `;

export function useAddGoogleBusinessChannelMutation() {
  return Urql.useMutation<AddGoogleBusinessChannelMutation, AddGoogleBusinessChannelMutationVariables>(AddGoogleBusinessChannelDocument);
};
export const AddFormWidgetChannelDocument = gql`
    mutation addFormWidgetChannel($appId: ID!, $channel: FormWidgetAppChannelInput!) {
  app {
    update(appId: $appId) {
      channel {
        addFormWidgetChannel(channel: $channel) {
          ...FormWidgetChannelFields
          endPoint
          status {
            type
          }
          autocompleteSuggestionsUrl
          attributes
        }
      }
    }
  }
}
    ${FormWidgetChannelFieldsFragmentDoc}`;

export function useAddFormWidgetChannelMutation() {
  return Urql.useMutation<AddFormWidgetChannelMutation, AddFormWidgetChannelMutationVariables>(AddFormWidgetChannelDocument);
};
export const GetAppWithChannelsDocument = gql`
    query getAppWithChannels($organizationId: ID!, $appId: ID!) {
  profile {
    __typename
    _id
    userId
    fullName
    email
  }
  org(organizationId: $organizationId) {
    __typename
    _id
    organizationId
    type
  }
  app(appId: $appId) {
    __typename
    appId
    organizationId
    stripeProductId
    stripeSubscriptionId
    subscriptionPaymentStatus
    invocationName
    name
    beta
    website
    templateType
    icon
    websiteData {
      primaryColor
      secondaryColor
      callsToAction
      crawlExecutionId
    }
    referenceId {
      id
      service
    }
    channels {
      __typename
      type
      id
      type
      name
      ... on AlexaAppChannel {
        vendorId
        invocationName
      }
      ... on LexConnectAppChannel {
        isLinkedToKendra
        lexPostTextUrl
      }
      ... on LexV2ConnectAppChannel {
        botName
        isLinkedToKendra
        lexPostTextUrl
      }
      ... on ChatWidgetAppChannel {
        key
        theme {
          primaryColor
        }
      }
      ... on IntelligentSearchAppChannel {
        key
        theme {
          accentColor
        }
      }
      ... on FormWidgetAppChannel {
        id
        key
        theme {
          accentColor
        }
      }
    }
  }
}
    `;

export function useGetAppWithChannelsQuery(options: Omit<Urql.UseQueryArgs<GetAppWithChannelsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAppWithChannelsQuery, GetAppWithChannelsQueryVariables>({ query: GetAppWithChannelsDocument, ...options });
};
export const GetAppWithChannelDataDocument = gql`
    query getAppWithChannelData($organizationId: ID!, $appId: ID!, $channelId: ID!) {
  org(organizationId: $organizationId) {
    __typename
    _id
    organizationId
    type
  }
  app(appId: $appId) {
    __typename
    appId
    organizationId
    stripeProductId
    stripeSubscriptionId
    subscriptionPaymentStatus
    invocationName
    privacyPolicyUrl
    termsOfUseUrl
    beta
    icon
    websiteData {
      primaryColor
      secondaryColor
      callsToAction
      crawlExecutionId
    }
    platformData {
      alexa {
        ... on AlexaPlatformData {
          platform
          privacyAndCompliance {
            allowsPurchases
            usesPersonalInfo
            isChildDirected
            isExportCompliant
            containsAds
          }
        }
      }
      google {
        ... on GooglePlatformData {
          platform
          additionalInformationQuestions {
            alcoholAndTobaccoRelatedContent
          }
        }
      }
    }
    channel(id: $channelId) {
      __typename
      type
      name
      id
      directoryListing
      endPoint
      status {
        type
        email
        timestamp
      }
      useNLU
      ... on DialogflowAppChannel {
        ...DialogflowChannelFields
      }
      ... on AlexaAppChannel {
        ...AlexaChannelFields
      }
      ... on ActionsOnGoogleAppChannel {
        ...ActionsOnGoogleChannelFields
      }
      ... on LexConnectAppChannel {
        ...LexConnectChannelFields
      }
      ... on LexV2ConnectAppChannel {
        ...LexV2ConnectChannelFields
      }
      ... on ChatWidgetAppChannel {
        ...ChatWidgetChannelFields
      }
      ... on IntelligentSearchAppChannel {
        ...IntelligentSearchChannelFields
      }
      ... on AppChannel {
        id
        type
      }
      ... on FormWidgetAppChannel {
        ...FormWidgetChannelFields
      }
    }
  }
}
    ${DialogflowChannelFieldsFragmentDoc}
${AlexaChannelFieldsFragmentDoc}
${ActionsOnGoogleChannelFieldsFragmentDoc}
${LexConnectChannelFieldsFragmentDoc}
${LexV2ConnectChannelFieldsFragmentDoc}
${ChatWidgetChannelFieldsFragmentDoc}
${IntelligentSearchChannelFieldsFragmentDoc}
${FormWidgetChannelFieldsFragmentDoc}`;

export function useGetAppWithChannelDataQuery(options: Omit<Urql.UseQueryArgs<GetAppWithChannelDataQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAppWithChannelDataQuery, GetAppWithChannelDataQueryVariables>({ query: GetAppWithChannelDataDocument, ...options });
};
export const AdminVerifyPlaceDocument = gql`
    mutation adminVerifyPlace($appId: ID!, $placeId: ID!, $verified: Boolean!) {
  admin {
    app {
      update(appId: $appId) {
        verifyGooglePlacesId(googlePlacesId: $placeId, verified: $verified) {
          __typename
          appId
          places {
            __typename
            name
            placeId
            formattedAddress
            default
            website
            phone
            adminVerified
            bookingOptOut
            addressComponents {
              longName
              shortName
              types
            }
          }
        }
      }
    }
  }
}
    `;

export function useAdminVerifyPlaceMutation() {
  return Urql.useMutation<AdminVerifyPlaceMutation, AdminVerifyPlaceMutationVariables>(AdminVerifyPlaceDocument);
};
export const CopyAppDocument = gql`
    mutation copyApp($appId: ID!, $toOrg: ID!, $overrideApp: CopyAppOverrideAttributes) {
  copyApp(appId: $appId, toOrg: $toOrg, overrideApp: $overrideApp) {
    appId
    organizationId
    name
    status {
      type
    }
  }
}
    `;

export function useCopyAppMutation() {
  return Urql.useMutation<CopyAppMutation, CopyAppMutationVariables>(CopyAppDocument);
};
export const GetAppLimitationsDocument = gql`
    query getAppLimitations($appId: ID!) {
  app(appId: $appId) {
    _id
    __typename
    appId
    organizationId
    icon
    limitations {
      actionBar
      advancedAnalytics
      excludedIntegrations
      maxHandlers
      maxIntents
      maxEntities
      captureLead
      schedule
      preferredTime
      aiLeadTagging
      liveTakeover
      transcriptAccess
      maxKendraDocs
      reserveWithGoogle
    }
  }
}
    `;

export function useGetAppLimitationsQuery(options: Omit<Urql.UseQueryArgs<GetAppLimitationsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAppLimitationsQuery, GetAppLimitationsQueryVariables>({ query: GetAppLimitationsDocument, ...options });
};
export const GetAppInfoDocument = gql`
    query getAppInfo($appId: ID!) {
  app(appId: $appId) {
    _id
    __typename
    appId
    banner
    beta
    businessDescription
    businessHighValueLeadDescription
    canCaptureLeads
    description
    examplePhrases
    icon
    invocationName
    keywords
    largeBanner
    largeIcon
    largeIcon
    leadsContact
    leadsContactPhone
    mediumIcon
    name
    organizationId
    privacyPolicyUrl
    referenceId {
      service
      id
    }
    smallIcon
    stripeProductId
    stripeSubscriptionId
    subscriptionPaymentStatus
    summary
    availability {
      availableDays
      blockedDays {
        time
        date
      }
      maxTotalDailyAppointments
      delayedJobTypes
      availabilityClasses {
        id
        name
        summary
        numberOfDaysOut
        appointmentsPerDay
        leadOnly
      }
      defaultAvailabilityClass
      defaultBusyDays {
        availableDays
        blockWeekends
        blockCurrentDay
        currentDayAvailableUntil
        blockNextBusinessDays
      }
    }
    subscription {
      __typename
      summary {
        __typename
        lastCharge {
          amount
          currency
          date
          paid
        }
        nextCharge {
          amountDue
          currency
          date
        }
        trialEndDate
        isCancelled
        status
      }
    }
    templateType
    termsOfUseUrl
    website
    status {
      __typename
      type
      notes
      timestamp
      email
      statusHistory {
        type
        notes
        timestamp
        email
      }
    }
    location {
      geocode {
        longitude
        latitude
      }
      streetAddress
    }
    platformData {
      alexa {
        ... on AlexaPlatformData {
          platform
          privacyAndCompliance {
            allowsPurchases
            usesPersonalInfo
            isChildDirected
            isExportCompliant
            containsAds
          }
        }
      }
      google {
        ... on GooglePlatformData {
          platform
          additionalInformationQuestions {
            alcoholAndTobaccoRelatedContent
          }
        }
      }
    }
    opportunityAlerts {
      alerts {
        duringBusinessHours
        outsideBusinessHours
        type
      }
      ... on EmailOpportunityAlert {
        email
      }
      ... on TextOpportunityAlert {
        phoneNumber
        consented
      }
      disabled
      placeId
    }
    places {
      __typename
      name
      placeId
      formattedAddress
      default
      website
      phone
      adminVerified
      bookingOptOut
      lastRefreshedFromGoogle
      partnerId {
        service
        id
      }
      addressComponents {
        longName
        shortName
        types
      }
      openingHours {
        weekdayText
        openNow
        periods {
          open {
            day
            time
          }
          close {
            day
            time
          }
        }
      }
    }
    lacrm: integration(type: lacrm) {
      __typename
      isAllowed
      isLinked
      isActive
    }
    jobber: integration(type: jobber) {
      __typename
      isAllowed
      isLinked
      isActive
    }
    servicetitan: integration(type: servicetitan) {
      __typename
      isAllowed
      isLinked
      isActive
    }
    surefire: integration(type: surefire) {
      __typename
      isAllowed
      isLinked
      isActive
    }
    housecallpro: integration(type: housecallpro) {
      __typename
      isAllowed
      isLinked
      isActive
    }
    fieldpulse: integration(type: fieldpulse) {
      __typename
      isAllowed
      isLinked
      isActive
    }
    servicefusion: integration(type: servicefusion) {
      __typename
      isAllowed
      isLinked
      isActive
    }
    zapier: integration(type: zapier) {
      __typename
      isAllowed
      isLinked
      isActive
    }
    serviceminder: integration(type: serviceminder) {
      __typename
      isAllowed
      isLinked
      isActive
    }
    contractor_appointments: integration(type: contractor_appointments) {
      __typename
      isAllowed
      isLinked
      isActive
    }
    webhook: integration(type: webhook) {
      __typename
      isAllowed
      isLinked
      isActive
    }
    boberdoo: integration(type: boberdoo) {
      __typename
      isAllowed
      isLinked
      isActive
    }
    test: integration(type: test_cognito) {
      __typename
      isAllowed
      isLinked
      isActive
    }
    organization {
      organizationId
      name
      type
      limitations {
        allowedChannels
        maxUniqueSessionsPerMonth
        maxDocumentCrawls
        maxTestsExecutedPerMonth
      }
      manualOverrideAvailableFeatures {
        allowedChannels
        maxUniqueSessionsPerMonth
        maxDocumentCrawls
        maxTestsExecutedPerMonth
      }
    }
  }
}
    `;

export function useGetAppInfoQuery(options: Omit<Urql.UseQueryArgs<GetAppInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAppInfoQuery, GetAppInfoQueryVariables>({ query: GetAppInfoDocument, ...options });
};
export const GetAppNotificationsDocument = gql`
    query getAppNotifications($appId: ID!) {
  app(appId: $appId) {
    systemNotifications {
      id
      name
      message
      level
      created
    }
  }
}
    `;

export function useGetAppNotificationsQuery(options: Omit<Urql.UseQueryArgs<GetAppNotificationsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAppNotificationsQuery, GetAppNotificationsQueryVariables>({ query: GetAppNotificationsDocument, ...options });
};
export const UpdateApplicationDocument = gql`
    mutation updateApplication($appId: ID!, $app: UpdateAppInput!) {
  updateApp(appId: $appId, app: $app) {
    __typename
    appId
    banner
    beta
    businessDescription
    businessHighValueLeadDescription
    description
    examplePhrases
    icon
    invocationName
    keywords
    largeBanner
    largeIcon
    leadsContact
    leadsContactPhone
    leadEmailRoutes {
      id
      name
      emails
      priority
      continueOnMatch
      filters {
        contactType
        highValueLead
        jobType
        urgency
        serviceType
      }
    }
    mediumIcon
    name
    organizationId
    privacyPolicyUrl
    smallIcon
    summary
    templateType
    termsOfUseUrl
    website
    websiteData {
      crawlExecutionId
    }
    location {
      geocode {
        longitude
        latitude
      }
      streetAddress
    }
    platformData {
      alexa {
        ... on AlexaPlatformData {
          platform
          privacyAndCompliance {
            allowsPurchases
            usesPersonalInfo
            isChildDirected
            isExportCompliant
            containsAds
          }
        }
      }
      google {
        ... on GooglePlatformData {
          platform
          additionalInformationQuestions {
            alcoholAndTobaccoRelatedContent
          }
        }
      }
    }
    opportunityAlerts {
      alerts {
        duringBusinessHours
        outsideBusinessHours
        type
      }
      disabled
      placeId
    }
  }
}
    `;

export function useUpdateApplicationMutation() {
  return Urql.useMutation<UpdateApplicationMutation, UpdateApplicationMutationVariables>(UpdateApplicationDocument);
};
export const GetSubscriptionInfoDocument = gql`
    query getSubscriptionInfo($organizationId: ID!, $appId: ID!) {
  org(organizationId: $organizationId) {
    type
    organizationId
    name
    contact
    billingContact {
      email
      phoneNumber
    }
    acceptedTermsOfService {
      acceptedOn
    }
    acceptedLatestTermsOfService
    paymentAccounts {
      stripe {
        customerId
      }
      so {
        paymentType
        numberOfApps
        date
      }
      aws {
        customerId
        productCode
        dimension
        date
      }
    }
  }
  app(appId: $appId) {
    name
    organizationId
    appId
    stripeProductId
    stripeSubscriptionId
    subscriptionPaymentStatus
    templateType
    status {
      type
      email
    }
    subscription {
      __typename
      summary {
        __typename
        lastCharge {
          amount
          currency
          date
          paid
        }
        nextCharge {
          amountDue
          currency
          date
        }
        trialEndDate
        isCancelled
        status
      }
    }
  }
}
    `;

export function useGetSubscriptionInfoQuery(options: Omit<Urql.UseQueryArgs<GetSubscriptionInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSubscriptionInfoQuery, GetSubscriptionInfoQueryVariables>({ query: GetSubscriptionInfoDocument, ...options });
};
export const GetAppOverviewDocument = gql`
    query getAppOverview($appId: ID!, $start: DateTime!, $end: DateTime!, $environment: [String] = ["production", "prod"]) {
  handler(appId: $appId, intentId: "LaunchRequest") {
    __typename
    intentId
    type
    data
    name
    content {
      key
      handlerResponse {
        name
        conditions
      }
    }
  }
  app(appId: $appId) {
    __typename
    _id
    appId
    beta
    name
    website
    description
    summary
    organizationId
    invocationName
    templateType
    icon
    smallIcon
    largeIcon
    banner
    beta
    largeBanner
    leadsContact
    leadsContactPhone
    stripeProductId
    stripeSubscriptionId
    subscriptionPaymentStatus
    places {
      __typename
      adminVerified
      bookingOptOut
      default
      formattedAddress
      name
      phone
      placeId
      website
      addressComponents {
        types
        longName
        shortName
      }
      openingHours {
        weekdayText
        periods {
          open {
            day
            time
          }
          close {
            day
            time
          }
        }
      }
    }
    systemNotifications {
      id
      name
      message
      level
      created
    }
    platformData {
      alexa {
        ... on AlexaPlatformData {
          platform
          privacyAndCompliance {
            allowsPurchases
            usesPersonalInfo
            isChildDirected
            isExportCompliant
            containsAds
          }
        }
      }
    }
    status {
      __typename
      type
      notes
      timestamp
      email
      statusHistory {
        type
        notes
        timestamp
        email
      }
    }
    handlers(size: 100) {
      _id
      total
      handlers {
        _id
        __typename
        name
        intentId
        type
      }
    }
    intents {
      _id
      total
      intents {
        _id
        __typename
        name
        intentId
        utterancePatterns
      }
    }
    entities(size: 100) {
      _id
      total
      entities {
        _id
        __typename
        entityId
        displayName
      }
    }
    content {
      __typename
      total
      content {
        __typename
        _id
        name
        url
        lastUpdated
      }
    }
    contentSources {
      __typename
      total
      sources {
        __typename
        webUrl
        webUrlPatterns
      }
    }
    faq {
      total
    }
    channels {
      __typename
      type
      id
      name
      ... on ChatWidgetAppChannel {
        key
        theme {
          primaryColor
        }
      }
      ... on IntelligentSearchAppChannel {
        key
        theme {
          accentColor
        }
      }
      ... on FormWidgetAppChannel {
        key
        theme {
          accentColor
        }
      }
    }
    organization {
      organizationId
      name
      type
    }
    analytics {
      user(start: $start, end: $end, byEnvironment: $environment) {
        totalUsers
        totalSessions
        returningUsers
        newUsers
      }
    }
  }
}
    `;

export function useGetAppOverviewQuery(options: Omit<Urql.UseQueryArgs<GetAppOverviewQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAppOverviewQuery, GetAppOverviewQueryVariables>({ query: GetAppOverviewDocument, ...options });
};
export const GetRecentActivityDocument = gql`
    query getRecentActivity($appId: ID!, $start: DateTime!, $environment: [String] = ["production", "prod"]) {
  app(appId: $appId) {
    __typename
    appId
    events(byEnvironment: $environment, startDate: $start) {
      total
    }
    formWidgetEvents: events(
      byEnvironment: $environment
      startDate: $start
      byChannel: ["form-widget"]
      byName: ["REQUEST_RESPONSE"]
    ) {
      total
    }
    chatWidgetEvents: events(
      byEnvironment: $environment
      startDate: $start
      byChannel: ["widget"]
      byName: ["REQUEST_RESPONSE"]
    ) {
      total
    }
    searchEvents: events(
      byEnvironment: $environment
      startDate: $start
      byChannel: ["intelligent-search"]
      byName: ["REQUEST_RESPONSE"]
    ) {
      total
    }
    gbmEvents: events(
      byEnvironment: $environment
      startDate: $start
      byChannel: ["google-business-messages"]
      byName: ["REQUEST_RESPONSE"]
    ) {
      total
    }
  }
}
    `;

export function useGetRecentActivityQuery(options: Omit<Urql.UseQueryArgs<GetRecentActivityQueryVariables>, 'query'>) {
  return Urql.useQuery<GetRecentActivityQuery, GetRecentActivityQueryVariables>({ query: GetRecentActivityDocument, ...options });
};
export const GetTagAnalyticsDocument = gql`
    query getTagAnalytics($appId: ID!, $from: Int, $size: Int, $startDate: DateTime, $endDate: DateTime, $environment: [String] = ["production", "prod"], $kbListTag: String = "KB_LIST_OF_RESULTS", $kbFAQTag: String = "KB_TOP_FAQ", $kbTopTag: String = "KB_TOP_ANSWER", $kbSuggestedTag: String = "KB_SUGGESTED_ANSWER", $kbNoAnswerTag: String = "KB_NO_ANSWER", $leadStarted: [String] = ["ContactCaptureHelpStart", "ContactCaptureStart"], $leadEnded: [String] = ["ContactCaptureEnd"]) {
  app(appId: $appId) {
    __typename
    appId
    kbList: events(
      byEnvironment: $environment
      from: $from
      size: $size
      startDate: $startDate
      endDate: $endDate
      byTag: [$kbListTag]
      byName: ["REQUEST_RESPONSE"]
    ) {
      total
      events {
        rawQuery
      }
    }
    kbFAQ: events(
      byEnvironment: $environment
      from: $from
      size: $size
      startDate: $startDate
      endDate: $endDate
      byTag: [$kbFAQTag]
      byName: ["REQUEST_RESPONSE"]
    ) {
      total
      events {
        rawQuery
      }
    }
    kbTop: events(
      byEnvironment: $environment
      from: $from
      size: $size
      startDate: $startDate
      endDate: $endDate
      byTag: [$kbTopTag]
      byName: ["REQUEST_RESPONSE"]
    ) {
      total
      events {
        rawQuery
      }
    }
    kbSuggested: events(
      byEnvironment: $environment
      from: $from
      size: $size
      startDate: $startDate
      endDate: $endDate
      byTag: [$kbSuggestedTag]
      byName: ["REQUEST_RESPONSE"]
    ) {
      total
      events {
        rawQuery
      }
    }
    kbNoAnswer: events(
      byEnvironment: $environment
      from: $from
      size: $size
      startDate: $startDate
      endDate: $endDate
      byTag: [$kbNoAnswerTag]
      byName: ["REQUEST_RESPONSE"]
    ) {
      total
      events {
        rawQuery
      }
    }
    leadsStarted: events(
      byEnvironment: $environment
      from: $from
      size: $size
      startDate: $startDate
      endDate: $endDate
      byTag: $leadStarted
      byName: ["REQUEST_RESPONSE"]
    ) {
      total
      events {
        rawQuery
      }
    }
    leadsEnded: events(
      byEnvironment: $environment
      from: $from
      size: $size
      startDate: $startDate
      endDate: $endDate
      byTag: $leadEnded
      byName: ["REQUEST_RESPONSE"]
    ) {
      total
      events {
        rawQuery
      }
    }
  }
}
    `;

export function useGetTagAnalyticsQuery(options: Omit<Urql.UseQueryArgs<GetTagAnalyticsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTagAnalyticsQuery, GetTagAnalyticsQueryVariables>({ query: GetTagAnalyticsDocument, ...options });
};
export const UpdateAppPlatformDocument = gql`
    mutation updateAppPlatform($appId: ID!, $app: UpdateAppInput!) {
  updateApp(appId: $appId, app: $app) {
    __typename
    _id
    appId
    name
    alexaSkillId
    endPoint {
      actionsOnGoogle {
        url
      }
      alexa {
        url
      }
      dialogFlow {
        url
      }
      google {
        url
      }
    }
    platformData {
      alexa {
        ... on AlexaPlatformData {
          platform
          privacyAndCompliance {
            allowsPurchases
            usesPersonalInfo
            isChildDirected
            isExportCompliant
            containsAds
          }
        }
      }
    }
    channels {
      __typename
      id
      type
    }
  }
}
    `;

export function useUpdateAppPlatformMutation() {
  return Urql.useMutation<UpdateAppPlatformMutation, UpdateAppPlatformMutationVariables>(UpdateAppPlatformDocument);
};
export const GetAppPlatformsDocument = gql`
    query getAppPlatforms($appId: ID!) {
  app(appId: $appId) {
    __typename
    _id
    appId
    name
    alexaSkillId
    endPoint {
      actionsOnGoogle {
        url
      }
      alexa {
        url
      }
      dialogFlow {
        url
      }
      google {
        url
      }
    }
    platformData {
      alexa {
        ... on AlexaPlatformData {
          platform
          privacyAndCompliance {
            allowsPurchases
            usesPersonalInfo
            isChildDirected
            isExportCompliant
            containsAds
          }
        }
      }
    }
    channels {
      __typename
      id
      type
    }
  }
}
    `;

export function useGetAppPlatformsQuery(options: Omit<Urql.UseQueryArgs<GetAppPlatformsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAppPlatformsQuery, GetAppPlatformsQueryVariables>({ query: GetAppPlatformsDocument, ...options });
};
export const GetRequestResponseDocument = gql`
    query getRequestResponse($appId: ID!, $responseOutputText: String, $rawQueryText: String, $from: Int, $size: Int, $endDate: DateTime, $byFlag: [RawQueryEventFlag], $noFlag: Boolean, $byMatchConfidence: MatchConfidenceRange, $bySessionId: String, $environment: [String] = ["production", "prod"], $channel: [String]) {
  app(appId: $appId) {
    __typename
    name
    appId
    organizationId
    events(
      byName: "REQUEST_RESPONSE"
      responseOutputText: $responseOutputText
      rawQueryText: $rawQueryText
      from: $from
      size: $size
      endDate: $endDate
      byFlag: $byFlag
      noFlag: $noFlag
      byMatchConfidenceRange: $byMatchConfidence
      sessionId: $bySessionId
      byEnvironment: $environment
      byChannel: $channel
    ) {
      __typename
      events {
        __typename
        environment
        currentHandler
        eventId
        eventIndex
        eventTime
        eventName
        userId
        request
        rawQuery
        platform
        channel
        sessionId
        selectedHandler
        payload
        response {
          outputSpeech {
            displayText
            ssml
            suggestions {
              title
              url
            }
          }
          reprompt {
            displayText
            ssml
            suggestions {
              title
              url
            }
          }
          displays
        }
        flags {
          __typename
          flag
          flaggedOn
          note
          userEmail
        }
        slots {
          __typename
          name
          rawValue
          stringValue
          dateValue
          startDateValue
          endDateValue
          booleanValue
          integerValue
          stringArrayValue
          slotValue
        }
        stentorRequest {
          platform
          type
          anonymous
          channel
          intentId
          isHealthCheck
          isNewSession
          rawQuery
          sessionAttributes {
            channel
            userId
            sessionId
          }
          matchConfidence
          sessionId
          userId
          locale
        }
      }
      flagTotals {
        OPTIMAL
        CORRECT
        NEEDS_HUMAN
        INCORRECT
        CONFIRMED_CORRECT
        HELPFUL
        FLAGGED
      }
      total
    }
  }
}
    `;

export function useGetRequestResponseQuery(options: Omit<Urql.UseQueryArgs<GetRequestResponseQueryVariables>, 'query'>) {
  return Urql.useQuery<GetRequestResponseQuery, GetRequestResponseQueryVariables>({ query: GetRequestResponseDocument, ...options });
};
export const GetRawQueryDocument = gql`
    query getRawQuery($appId: ID!, $byName: [String], $rawQueryText: String, $from: Int, $size: Int, $endDate: DateTime, $byFlag: [RawQueryEventFlag], $noFlag: Boolean, $byMatchConfidenceRange: MatchConfidenceRange, $environment: [String] = ["production", "prod"]) {
  app(appId: $appId) {
    __typename
    name
    appId
    organizationId
    events(
      byName: $byName
      rawQueryOrSlotsOnly: true
      rawQueryText: $rawQueryText
      from: $from
      size: $size
      endDate: $endDate
      byFlag: $byFlag
      noFlag: $noFlag
      byMatchConfidenceRange: $byMatchConfidenceRange
      byEnvironment: $environment
    ) {
      __typename
      events {
        __typename
        environment
        currentHandler
        eventId
        eventIndex
        eventTime
        flags {
          __typename
          flag
          flaggedOn
          note
          userEmail
        }
        request
        rawQuery
        channel
        platform
        selectedHandler
        slots {
          __typename
          name
          rawValue
          stringValue
          dateValue
          startDateValue
          endDateValue
          booleanValue
          integerValue
          stringArrayValue
          slotValue
        }
        sessionId
        stentorRequest {
          platform
          type
          anonymous
          channel
          intentId
          isHealthCheck
          isNewSession
          rawQuery
          sessionAttributes {
            channel
            userId
            sessionId
          }
          matchConfidence
          sessionId
          userId
          locale
        }
      }
      flagTotals {
        OPTIMAL
        CORRECT
        NEEDS_HUMAN
        CONFIRMED_CORRECT
        INCORRECT
        HELPFUL
        FLAGGED
      }
      total
    }
  }
}
    `;

export function useGetRawQueryQuery(options: Omit<Urql.UseQueryArgs<GetRawQueryQueryVariables>, 'query'>) {
  return Urql.useQuery<GetRawQueryQuery, GetRawQueryQueryVariables>({ query: GetRawQueryDocument, ...options });
};
export const GetSessionEventsDocument = gql`
    query getSessionEvents($appId: ID!, $sessionId: String) {
  app(appId: $appId) {
    appId
    events(byName: ["REQUEST_RESPONSE"], sessionId: $sessionId) {
      total
      events {
        eventId
        sessionId
        eventType
        eventName
        rawQuery
        stentorRequest {
          platform
          type
          anonymous
          channel
          intentId
          isHealthCheck
          isNewSession
          rawQuery
          sessionAttributes {
            channel
            userId
            sessionId
          }
          matchConfidence
          sessionId
          userId
          locale
        }
        response {
          reprompt {
            displayText
            ssml
          }
          outputSpeech {
            displayText
            ssml
          }
          displays
        }
      }
    }
  }
}
    `;

export function useGetSessionEventsQuery(options: Omit<Urql.UseQueryArgs<GetSessionEventsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSessionEventsQuery, GetSessionEventsQueryVariables>({ query: GetSessionEventsDocument, ...options });
};
export const ExportAppDocument = gql`
    mutation exportApp($appId: ID!, $organizationId: ID!) {
  app(organizationId: $organizationId) {
    update(appId: $appId) {
      exportApp {
        url
      }
    }
  }
}
    `;

export function useExportAppMutation() {
  return Urql.useMutation<ExportAppMutation, ExportAppMutationVariables>(ExportAppDocument);
};
export const UpdateStatusDocument = gql`
    mutation updateStatus($appId: ID!, $type: String!, $notes: String) {
  app {
    update(appId: $appId) {
      changeStatus(type: $type, note: $notes) {
        __typename
        status {
          type
          notes
          email
          timestamp
        }
      }
    }
  }
}
    `;

export function useUpdateStatusMutation() {
  return Urql.useMutation<UpdateStatusMutation, UpdateStatusMutationVariables>(UpdateStatusDocument);
};
export const UpdateEmailOpportunityAlertsDocument = gql`
    mutation updateEmailOpportunityAlerts($appId: ID!, $alert: EmailOpportunityAlertInput!) {
  app {
    update(appId: $appId) {
      addEmailOpportunityAlert(alert: $alert) {
        __typename
        appId
        opportunityAlerts {
          alerts {
            duringBusinessHours
            outsideBusinessHours
            type
          }
          ... on EmailOpportunityAlert {
            email
          }
          disabled
          placeId
        }
      }
    }
  }
}
    `;

export function useUpdateEmailOpportunityAlertsMutation() {
  return Urql.useMutation<UpdateEmailOpportunityAlertsMutation, UpdateEmailOpportunityAlertsMutationVariables>(UpdateEmailOpportunityAlertsDocument);
};
export const UpdateTextOpportunityAlertsDocument = gql`
    mutation updateTextOpportunityAlerts($appId: ID!, $alert: TextOpportunityAlertInput!) {
  app {
    update(appId: $appId) {
      addTextOpportunityAlert(alert: $alert) {
        __typename
        appId
        opportunityAlerts {
          alerts {
            duringBusinessHours
            outsideBusinessHours
            type
          }
          ... on TextOpportunityAlert {
            phoneNumber
            consented
          }
          disabled
          placeId
        }
      }
    }
  }
}
    `;

export function useUpdateTextOpportunityAlertsMutation() {
  return Urql.useMutation<UpdateTextOpportunityAlertsMutation, UpdateTextOpportunityAlertsMutationVariables>(UpdateTextOpportunityAlertsDocument);
};
export const UpdatePlacesDocument = gql`
    mutation updatePlaces($appId: ID!, $input: UpdateAppInput!) {
  app {
    update(appId: $appId) {
      updateApp(app: $input) {
        __typename
        _id
        appId
        places {
          name
          placeId
          formattedAddress
          default
          website
          phone
          adminVerified
          bookingOptOut
          addressComponents {
            longName
            shortName
            types
          }
          openingHours {
            weekdayText
            periods {
              open {
                day
                time
              }
              close {
                day
                time
              }
            }
          }
        }
      }
    }
  }
}
    `;

export function useUpdatePlacesMutation() {
  return Urql.useMutation<UpdatePlacesMutation, UpdatePlacesMutationVariables>(UpdatePlacesDocument);
};
export const RefreshPlaceFromGoogleDocument = gql`
    mutation refreshPlaceFromGoogle($appId: ID!, $placeId: ID!) {
  app {
    update(appId: $appId) {
      refreshPlaceFromGoogle(placeId: $placeId) {
        __typename
        appId
        places {
          name
          placeId
          formattedAddress
          default
          website
          phone
          adminVerified
          bookingOptOut
          lastRefreshedFromGoogle
          addressComponents {
            longName
            shortName
            types
          }
          openingHours {
            weekdayText
            openNow
            periods {
              open {
                day
                time
              }
              close {
                day
                time
              }
            }
          }
        }
      }
    }
  }
}
    `;

export function useRefreshPlaceFromGoogleMutation() {
  return Urql.useMutation<RefreshPlaceFromGoogleMutation, RefreshPlaceFromGoogleMutationVariables>(RefreshPlaceFromGoogleDocument);
};
export const GetAppStatusInfoDocument = gql`
    query getAppStatusInfo($appId: ID!) {
  app(appId: $appId) {
    __typename
    appId
    status {
      type
      notes
      email
    }
    opportunityAlerts {
      alerts {
        duringBusinessHours
        outsideBusinessHours
        type
      }
      disabled
      placeId
    }
  }
}
    `;

export function useGetAppStatusInfoQuery(options: Omit<Urql.UseQueryArgs<GetAppStatusInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAppStatusInfoQuery, GetAppStatusInfoQueryVariables>({ query: GetAppStatusInfoDocument, ...options });
};
export const GetAppSettingsInfoDocument = gql`
    query getAppSettingsInfo($organizationId: ID!, $appId: ID!) {
  org(organizationId: $organizationId) {
    __typename
    organizationId
    type
    beta
    apps {
      total
    }
  }
  app(appId: $appId) {
    __typename
    appId
    organizationId
    beta
    name
    templateType
    website
    leadsContact
    leadsContactPhone
    leadEmailRoutes {
      id
      name
      emails
      priority
      continueOnMatch
      filters {
        contactType
        highValueLead
        jobType
        urgency
        serviceType
      }
    }
    stripeProductId
    stripeSubscriptionId
    subscriptionPaymentStatus
    icon
    status {
      type
      notes
      timestamp
      statusHistory {
        type
        email
        timestamp
        notes
      }
    }
  }
}
    `;

export function useGetAppSettingsInfoQuery(options: Omit<Urql.UseQueryArgs<GetAppSettingsInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAppSettingsInfoQuery, GetAppSettingsInfoQueryVariables>({ query: GetAppSettingsInfoDocument, ...options });
};
export const CreateTokenDocument = gql`
    mutation createToken($organizationId: ID!, $appId: ID!) {
  app(organizationId: $organizationId) {
    update(appId: $appId) {
      cms {
        create {
          appId
          token
          tokenId
          created
          scope
          mask
        }
      }
    }
  }
}
    `;

export function useCreateTokenMutation() {
  return Urql.useMutation<CreateTokenMutation, CreateTokenMutationVariables>(CreateTokenDocument);
};
export const DeleteTokenDocument = gql`
    mutation deleteToken($organizationId: ID!, $appId: ID!, $tokenId: ID!) {
  app(organizationId: $organizationId) {
    update(appId: $appId) {
      cms {
        update(tokenId: $tokenId) {
          delete
        }
      }
    }
  }
}
    `;

export function useDeleteTokenMutation() {
  return Urql.useMutation<DeleteTokenMutation, DeleteTokenMutationVariables>(DeleteTokenDocument);
};
export const GetAppTokensDocument = gql`
    query getAppTokens($appId: ID!) {
  app(appId: $appId) {
    __typename
    appId
    cmsTokens {
      __typename
      tokenId
      mask
      appId
      created
      scope
    }
  }
}
    `;

export function useGetAppTokensQuery(options: Omit<Urql.UseQueryArgs<GetAppTokensQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAppTokensQuery, GetAppTokensQueryVariables>({ query: GetAppTokensDocument, ...options });
};
export const CreateCampaignDocument = gql`
    mutation createCampaign($campaign: CreateCampaignInput!) {
  createCampaign(campaign: $campaign) {
    campaignId
    name
    status
    channelId
    intentId
    bookingUrl
  }
}
    `;

export function useCreateCampaignMutation() {
  return Urql.useMutation<CreateCampaignMutation, CreateCampaignMutationVariables>(CreateCampaignDocument);
};
export const UpdateCampaignDocument = gql`
    mutation updateCampaign($campaignId: ID!, $campaign: UpdateCampaignInput!) {
  updateCampaign(campaignId: $campaignId, campaign: $campaign) {
    campaignId
    name
    offerTitle
    offerTerms
    jobTypePin
    startDate
    endDate
    status
    canonicalSource
  }
}
    `;

export function useUpdateCampaignMutation() {
  return Urql.useMutation<UpdateCampaignMutation, UpdateCampaignMutationVariables>(UpdateCampaignDocument);
};
export const ArchiveCampaignDocument = gql`
    mutation archiveCampaign($campaignId: ID!) {
  archiveCampaign(campaignId: $campaignId) {
    campaignId
    status
  }
}
    `;

export function useArchiveCampaignMutation() {
  return Urql.useMutation<ArchiveCampaignMutation, ArchiveCampaignMutationVariables>(ArchiveCampaignDocument);
};
export const CampaignsDocument = gql`
    query campaigns($appId: ID!) {
  campaigns(appId: $appId) {
    campaignId
    appId
    name
    offerTitle
    offerTerms
    jobTypePin
    startDate
    endDate
    status
    canonicalSource
    channelId
    intentId
    bookingUrl
    createdAt
    updatedAt
  }
}
    `;

export function useCampaignsQuery(options: Omit<Urql.UseQueryArgs<CampaignsQueryVariables>, 'query'>) {
  return Urql.useQuery<CampaignsQuery, CampaignsQueryVariables>({ query: CampaignsDocument, ...options });
};
export const CampaignDocument = gql`
    query campaign($campaignId: ID!) {
  campaign(campaignId: $campaignId) {
    campaignId
    appId
    name
    offerTitle
    offerTerms
    jobTypePin
    startDate
    endDate
    status
    canonicalSource
    channelId
    intentId
    bookingUrl
    createdAt
    updatedAt
  }
}
    `;

export function useCampaignQuery(options: Omit<Urql.UseQueryArgs<CampaignQueryVariables>, 'query'>) {
  return Urql.useQuery<CampaignQuery, CampaignQueryVariables>({ query: CampaignDocument, ...options });
};
export const DeleteAppDocument = gql`
    mutation deleteApp($appId: ID!, $organizationId: ID!) {
  app(organizationId: $organizationId) {
    update(appId: $appId) {
      deleteApp
    }
  }
}
    `;

export function useDeleteAppMutation() {
  return Urql.useMutation<DeleteAppMutation, DeleteAppMutationVariables>(DeleteAppDocument);
};
export const CrawlDocument = gql`
    mutation crawl($appId: ID!, $webUrl: URL!, $webUrlPatterns: [String], $stealth: Boolean = false, $settlingTimeSeconds: settlingTimeSeconds_Int_max_5_exclusiveMin_0) {
  startWebsiteCrawling(
    appId: $appId
    webUrl: $webUrl
    webUrlPatterns: $webUrlPatterns
    stealth: $stealth
    settlingTimeSeconds: $settlingTimeSeconds
    channelId: "studio-cf-channel"
  )
}
    `;

export function useCrawlMutation() {
  return Urql.useMutation<CrawlMutation, CrawlMutationVariables>(CrawlDocument);
};
export const GetAppContentDocument = gql`
    query getAppContent($appId: ID!, $size: Int!, $from: Int!) {
  app(appId: $appId) {
    appId
    contentSources {
      __typename
      total
      sources {
        __typename
        webUrl
        webUrlPatterns
      }
    }
    content(size: $size, from: $from) {
      total
      content {
        _id
        name
        url
        type
        lastUpdated
        text
      }
    }
    faq {
      total
    }
  }
}
    `;

export function useGetAppContentQuery(options: Omit<Urql.UseQueryArgs<GetAppContentQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAppContentQuery, GetAppContentQueryVariables>({ query: GetAppContentDocument, ...options });
};
export const GetContentSourcesDocument = gql`
    query getContentSources($appId: ID!) {
  app(appId: $appId) {
    __typename
    appId
    contentSources {
      __typename
      sources {
        webUrl
        webUrlPatterns
        __typename
      }
    }
  }
}
    `;

export function useGetContentSourcesQuery(options: Omit<Urql.UseQueryArgs<GetContentSourcesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetContentSourcesQuery, GetContentSourcesQueryVariables>({ query: GetContentSourcesDocument, ...options });
};
export const CreateEntityDocument = gql`
    mutation createEntity($appId: ID!, $displayName: String!, $values: [EntityValueInput!]) {
  addEntity(entity: {appId: $appId, displayName: $displayName, values: $values}) {
    __typename
    appId
    entityId
    displayName
    type
    validation {
      isValid
      errors {
        errorMessage
        propertyName
      }
    }
    intents(from: 0, size: 100) {
      intents {
        intentId
        appId
        organizationId
        name
      }
    }
  }
}
    `;

export function useCreateEntityMutation() {
  return Urql.useMutation<CreateEntityMutation, CreateEntityMutationVariables>(CreateEntityDocument);
};
export const UpdateEntityDocument = gql`
    mutation updateEntity($appId: ID!, $entityId: ID!, $entity: UpdateEntityInput!) {
  updateEntity(appId: $appId, entityId: $entityId, entity: $entity) {
    __typename
    appId
    entityId
    displayName
    dialogflowId
    type
    values {
      name
      synonyms
    }
    validation {
      isValid
      errors {
        errorMessage
        propertyName
      }
    }
    intents(from: 0, size: 100) {
      total
      intents {
        __typename
        _id
        intentId
        appId
        organizationId
        name
      }
    }
  }
}
    `;

export function useUpdateEntityMutation() {
  return Urql.useMutation<UpdateEntityMutation, UpdateEntityMutationVariables>(UpdateEntityDocument);
};
export const DeleteEntityDocument = gql`
    mutation deleteEntity($appId: ID!, $entityId: ID!) {
  deleteEntity(appId: $appId, entityId: $entityId)
}
    `;

export function useDeleteEntityMutation() {
  return Urql.useMutation<DeleteEntityMutation, DeleteEntityMutationVariables>(DeleteEntityDocument);
};
export const GetEntitiesListDocument = gql`
    query getEntitiesList($appId: ID!, $withIdOrDisplayName: String, $withValueOrSynonym: String) {
  app(appId: $appId) {
    __typename
    appId
    entities(
      size: 100
      withIdOrDisplayName: $withIdOrDisplayName
      withValueOrSynonym: $withValueOrSynonym
    ) {
      total
      entities {
        entityId
        displayName
      }
    }
  }
}
    `;

export function useGetEntitiesListQuery(options: Omit<Urql.UseQueryArgs<GetEntitiesListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetEntitiesListQuery, GetEntitiesListQueryVariables>({ query: GetEntitiesListDocument, ...options });
};
export const GetEntityDocument = gql`
    query getEntity($appId: String!, $entityId: String!) {
  entity(appId: $appId, entityId: $entityId) {
    __typename
    appId
    entityId
    displayName
    dialogflowId
    type
    createdAt
    updatedAt
    values {
      name
      synonyms
    }
    validation {
      isValid
      errors {
        errorMessage
        propertyName
      }
    }
    intents(from: 0, size: 100) {
      total
      intents {
        __typename
        _id
        intentId
        appId
        organizationId
        name
      }
    }
  }
}
    `;

export function useGetEntityQuery(options: Omit<Urql.UseQueryArgs<GetEntityQueryVariables>, 'query'>) {
  return Urql.useQuery<GetEntityQuery, GetEntityQueryVariables>({ query: GetEntityDocument, ...options });
};
export const FlagEventDocument = gql`
    mutation FlagEvent($organizationId: ID!, $appId: ID!, $eventId: ID!, $flag: NewRawQueryFlag!, $note: String) {
  app(organizationId: $organizationId) {
    update(appId: $appId) {
      flagEvent(eventId: $eventId, flag: $flag, note: $note) {
        message
      }
    }
  }
}
    `;

export function useFlagEventMutation() {
  return Urql.useMutation<FlagEventMutation, FlagEventMutationVariables>(FlagEventDocument);
};
export const GetGlobalDashboardDocument = gql`
    query getGlobalDashboard($organizationIds: [ID!], $startDate: DateTime, $endDate: DateTime, $source: String, $urgency: String, $highValueLead: Boolean, $environment: String, $referringSource: String, $contactType: String, $serviceType: String, $jobType: String, $businessHoursSource: BusinessHoursSource, $zipCode: String) {
  dashboard(
    organizationIds: $organizationIds
    startDate: $startDate
    endDate: $endDate
    source: $source
    urgency: $urgency
    highValueLead: $highValueLead
    environment: $environment
    referringSource: $referringSource
    contactType: $contactType
    serviceType: $serviceType
    jobType: $jobType
    zipCode: $zipCode
  ) {
    leads(businessHoursSource: $businessHoursSource) {
      totalLeads
      highValueLeadsPercentage
      leadsBySource {
        key
        count
        percentage
      }
      leadsByReferringSource {
        key
        count
        percentage
      }
      leadsByContactType {
        key
        count
        percentage
      }
      leadsByServiceType {
        key
        count
        percentage
      }
      leadsByJobType {
        key
        count
        percentage
      }
      leadsByUrgency {
        key
        count
        percentage
      }
      leadsByDayOfWeek {
        dayOfWeek
        dayName
        totalCount
        businessHoursCount
        nonBusinessHoursCount
        percentage
      }
      outsideBusinessHoursPercentage
      businessHoursSource
      businessHoursSummary
      topTerms(size: 20) {
        term
        count
        score
      }
      leadsByApp(limit: 10, sortBy: LEAD_COUNT) {
        appId
        name
        leadCount
        highValueLeadCount
        organizationId
        organizationName
      }
      leadsByOrganization(limit: 10, sortBy: LEAD_COUNT) {
        organizationId
        name
        leadCount
        highValueLeadCount
      }
      topEngagementsByZip(limit: 10, sortBy: LEAD_COUNT) {
        zipCode
        leadCount
        highValueLeadCount
        percentage
        uniqueApps
      }
    }
  }
}
    `;

export function useGetGlobalDashboardQuery(options?: Omit<Urql.UseQueryArgs<GetGlobalDashboardQueryVariables>, 'query'>) {
  return Urql.useQuery<GetGlobalDashboardQuery, GetGlobalDashboardQueryVariables>({ query: GetGlobalDashboardDocument, ...options });
};
export const GlobalLeadsDocument = gql`
    query globalLeads($appId: ID, $source: String, $searchText: String, $size: Int, $nextKey: String, $startDate: DateTime, $endDate: DateTime, $urgency: String, $highValueLead: Boolean, $referringSource: String, $contactType: String, $serviceType: String, $jobType: String) {
  leads(
    appId: $appId
    source: $source
    searchText: $searchText
    size: $size
    nextKey: $nextKey
    startDate: $startDate
    endDate: $endDate
    urgency: $urgency
    highValueLead: $highValueLead
    referringSource: $referringSource
    contactType: $contactType
    serviceType: $serviceType
    jobType: $jobType
  ) {
    total
    nextKey
    leads {
      id
      appId
      company
      conciseSummary
      contactType
      date
      highValueLead
      jobType
      serviceType
      source
      urgency
      lead {
        fields {
          name
          value
        }
      }
    }
  }
}
    `;

export function useGlobalLeadsQuery(options?: Omit<Urql.UseQueryArgs<GlobalLeadsQueryVariables>, 'query'>) {
  return Urql.useQuery<GlobalLeadsQuery, GlobalLeadsQueryVariables>({ query: GlobalLeadsDocument, ...options });
};
export const CreateHandlerDocument = gql`
    mutation createHandler($appId: ID!, $handler: AddHandlerInput!) {
  addHandler(appId: $appId, handler: $handler) {
    __typename
    appId
    intentId
    name
    organizationId
    type
  }
}
    `;

export function useCreateHandlerMutation() {
  return Urql.useMutation<CreateHandlerMutation, CreateHandlerMutationVariables>(CreateHandlerDocument);
};
export const UpdateHandlerDocument = gql`
    mutation updateHandler($appId: ID!, $handlerId: ID!, $handler: UpdateHandlerInput!) {
  updateHandler(appId: $appId, handlerId: $handlerId, handler: $handler) {
    ...HandlerParts
  }
}
    ${HandlerPartsFragmentDoc}`;

export function useUpdateHandlerMutation() {
  return Urql.useMutation<UpdateHandlerMutation, UpdateHandlerMutationVariables>(UpdateHandlerDocument);
};
export const DeleteHandlerDocument = gql`
    mutation deleteHandler($appId: ID!, $handlerId: ID!) {
  deleteHandler(appId: $appId, handlerId: $handlerId) {
    __typename
    appId
    intentId
  }
}
    `;

export function useDeleteHandlerMutation() {
  return Urql.useMutation<DeleteHandlerMutation, DeleteHandlerMutationVariables>(DeleteHandlerDocument);
};
export const ChangeHandlerToIntentDocument = gql`
    mutation changeHandlerToIntent($organizationId: ID!, $appId: ID!, $handlerId: ID!) {
  app(organizationId: $organizationId) {
    update(appId: $appId) {
      intent {
        update(intentId: $handlerId) {
          changeHandlerToIntent {
            name
          }
        }
      }
    }
  }
}
    `;

export function useChangeHandlerToIntentMutation() {
  return Urql.useMutation<ChangeHandlerToIntentMutation, ChangeHandlerToIntentMutationVariables>(ChangeHandlerToIntentDocument);
};
export const GetHandlerDocument = gql`
    query getHandler($appId: ID!, $intentId: ID!) {
  handler(appId: $appId, intentId: $intentId) {
    ...HandlerParts
  }
  app(appId: $appId) {
    __typename
    _id
    appId
    organizationId
    name
    templateType
    status {
      type
    }
    handlers(size: 100) {
      total
      handlers {
        __typename
        _id
        intentId
        type
        name
        appId
        organizationId
      }
    }
    intents(size: 100) {
      _id
      total
      intents {
        _id
        name
        intentId
        utterancePatterns
      }
    }
  }
}
    ${HandlerPartsFragmentDoc}`;

export function useGetHandlerQuery(options: Omit<Urql.UseQueryArgs<GetHandlerQueryVariables>, 'query'>) {
  return Urql.useQuery<GetHandlerQuery, GetHandlerQueryVariables>({ query: GetHandlerDocument, ...options });
};
export const GetHandlersListDocument = gql`
    query getHandlersList($appId: ID!, $withIdOrName: String) {
  app(appId: $appId) {
    __typename
    _id
    appId
    organizationId
    name
    handlers(size: 100, withIdOrName: $withIdOrName) {
      total
      handlers {
        __typename
        _id
        intentId
        type
        name
      }
    }
    intents {
      _id
      total
      intents {
        _id
        name
        intentId
        utterancePatterns
      }
    }
  }
}
    `;

export function useGetHandlersListQuery(options: Omit<Urql.UseQueryArgs<GetHandlersListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetHandlersListQuery, GetHandlersListQueryVariables>({ query: GetHandlersListDocument, ...options });
};
export const GetExternalIdDocument = gql`
    query getExternalId {
  utils {
    generateExternalID
  }
}
    `;

export function useGetExternalIdQuery(options?: Omit<Urql.UseQueryArgs<GetExternalIdQueryVariables>, 'query'>) {
  return Urql.useQuery<GetExternalIdQuery, GetExternalIdQueryVariables>({ query: GetExternalIdDocument, ...options });
};
export const AddBoberdooIntegrationDocument = gql`
    mutation addBoberdooIntegration($appId: ID!, $apiKey: String!, $endpoint: URLString!, $leadType: String!, $source: String!, $apiAction: String, $defaultLandingPage: String, $defaultProject: String, $mode: String, $uniqueIdentifier: String) {
  app {
    update(appId: $appId) {
      integration {
        addBoberdooIntegration(
          apiKey: $apiKey
          endpoint: $endpoint
          leadType: $leadType
          source: $source
          apiAction: $apiAction
          defaultLandingPage: $defaultLandingPage
          defaultProject: $defaultProject
          mode: $mode
          uniqueIdentifier: $uniqueIdentifier
        ) {
          isLinked
          isActive
          isAllowed
        }
      }
    }
  }
}
    `;

export function useAddBoberdooIntegrationMutation() {
  return Urql.useMutation<AddBoberdooIntegrationMutation, AddBoberdooIntegrationMutationVariables>(AddBoberdooIntegrationDocument);
};
export const DisconnectIntegrationDocument = gql`
    mutation disconnectIntegration($appId: ID!, $type: IntegrationType!) {
  app {
    update(appId: $appId) {
      integration {
        disconnect(type: $type) {
          isLinked
          isActive
        }
      }
    }
  }
}
    `;

export function useDisconnectIntegrationMutation() {
  return Urql.useMutation<DisconnectIntegrationMutation, DisconnectIntegrationMutationVariables>(DisconnectIntegrationDocument);
};
export const ConnectSurefireDocument = gql`
    mutation connectSurefire($appId: ID!, $token: String!, $endpoint: URLString!, $dataMap: String!) {
  app {
    update(appId: $appId) {
      integration {
        addSurefireIntegration(token: $token, endpoint: $endpoint, dataMap: $dataMap) {
          isLinked
          isActive
          isAllowed
        }
      }
    }
  }
}
    `;

export function useConnectSurefireMutation() {
  return Urql.useMutation<ConnectSurefireMutation, ConnectSurefireMutationVariables>(ConnectSurefireDocument);
};
export const ConnectHousecallProDocument = gql`
    mutation connectHousecallPro($appId: ID!, $token: String!) {
  app {
    update(appId: $appId) {
      integration {
        addHouseCallProIntegration(token: $token) {
          isLinked
          isActive
          isAllowed
        }
      }
    }
  }
}
    `;

export function useConnectHousecallProMutation() {
  return Urql.useMutation<ConnectHousecallProMutation, ConnectHousecallProMutationVariables>(ConnectHousecallProDocument);
};
export const ConnectFieldPulseDocument = gql`
    mutation connectFieldPulse($appId: ID!, $token: String!, $defaultJobTypeId: String!, $maxJobsPerDay: Int!, $lookAheadDays: Int!) {
  app {
    update(appId: $appId) {
      integration {
        addFieldPulseIntegration(
          token: $token
          defaultJobTypeId: $defaultJobTypeId
          maxJobsPerDay: $maxJobsPerDay
          lookAheadDays: $lookAheadDays
        ) {
          isActive
          isLinked
          isAllowed
        }
      }
    }
  }
}
    `;

export function useConnectFieldPulseMutation() {
  return Urql.useMutation<ConnectFieldPulseMutation, ConnectFieldPulseMutationVariables>(ConnectFieldPulseDocument);
};
export const AddFieldRoutesIntegrationDocument = gql`
    mutation addFieldRoutesIntegration($appId: ID!, $subdomain: String!, $authenticationKey: String!, $authenticationToken: String!, $sourceID: String, $defaultAppointmentType: String) {
  app {
    update(appId: $appId) {
      integration {
        addFieldRoutesIntegration(
          subdomain: $subdomain
          authenticationKey: $authenticationKey
          authenticationToken: $authenticationToken
          sourceID: $sourceID
          defaultAppointmentType: $defaultAppointmentType
        ) {
          isActive
          isLinked
          isAllowed
        }
      }
    }
  }
}
    `;

export function useAddFieldRoutesIntegrationMutation() {
  return Urql.useMutation<AddFieldRoutesIntegrationMutation, AddFieldRoutesIntegrationMutationVariables>(AddFieldRoutesIntegrationDocument);
};
export const AddServiceMinderIntegrationDocument = gql`
    mutation addServiceMinderIntegration($appId: ID!, $apiKey: String!) {
  app {
    update(appId: $appId) {
      integration {
        addServiceMinderIntegration(apiKey: $apiKey) {
          isActive
          isLinked
          isAllowed
        }
      }
    }
  }
}
    `;

export function useAddServiceMinderIntegrationMutation() {
  return Urql.useMutation<AddServiceMinderIntegrationMutation, AddServiceMinderIntegrationMutationVariables>(AddServiceMinderIntegrationDocument);
};
export const AddContractorAppointmentsIntegrationDocument = gql`
    mutation addContractorAppointmentsIntegration($appId: ID!, $campaignId: String!, $campaignKey: String!, $defaultTrade: String) {
  app {
    update(appId: $appId) {
      integration {
        addContractorAppointmentsIntegration(
          campaignId: $campaignId
          campaignKey: $campaignKey
          defaultTrade: $defaultTrade
        ) {
          isLinked
          isActive
          isAllowed
        }
      }
    }
  }
}
    `;

export function useAddContractorAppointmentsIntegrationMutation() {
  return Urql.useMutation<AddContractorAppointmentsIntegrationMutation, AddContractorAppointmentsIntegrationMutationVariables>(AddContractorAppointmentsIntegrationDocument);
};
export const AddWebhookIntegrationDocument = gql`
    mutation addWebhookIntegration($appId: ID!, $endpoint: URLString!, $httpHeaders: JSON, $service: String) {
  app {
    update(appId: $appId) {
      integration {
        addWebhookIntegration(
          endpoint: $endpoint
          httpHeaders: $httpHeaders
          service: $service
        ) {
          isLinked
          isActive
          isAllowed
        }
      }
    }
  }
}
    `;

export function useAddWebhookIntegrationMutation() {
  return Urql.useMutation<AddWebhookIntegrationMutation, AddWebhookIntegrationMutationVariables>(AddWebhookIntegrationDocument);
};
export const AddFacebookCapiIntegrationDocument = gql`
    mutation addFacebookCapiIntegration($appId: ID!, $pixelId: String!, $accessToken: String!, $testEventCode: String) {
  app {
    update(appId: $appId) {
      integration {
        addFacebookCapiIntegration(
          pixelId: $pixelId
          accessToken: $accessToken
          testEventCode: $testEventCode
        ) {
          isLinked
          isActive
          isAllowed
        }
      }
    }
  }
}
    `;

export function useAddFacebookCapiIntegrationMutation() {
  return Urql.useMutation<AddFacebookCapiIntegrationMutation, AddFacebookCapiIntegrationMutationVariables>(AddFacebookCapiIntegrationDocument);
};
export const IntegrationStatusDocument = gql`
    query integrationStatus($organizationId: ID!, $appId: ID!) {
  org(organizationId: $organizationId) {
    _id
    __typename
    organizationId
    type
  }
  app(appId: $appId) {
    _id
    __typename
    templateType
    appId
    leadsContact
    leadsContactPhone
    stripeProductId
    stripeSubscriptionId
    subscriptionPaymentStatus
    canCaptureLeads
    limitations {
      preferredTime
      captureLead
      schedule
    }
    boberdoo: integration(type: boberdoo) {
      __typename
      isAllowed
      isLinked
      isActive
    }
    lacrm: integration(type: lacrm) {
      __typename
      isAllowed
      isLinked
      isActive
    }
    jobber: integration(type: jobber) {
      __typename
      isAllowed
      isLinked
      isActive
    }
    servicetitan: integration(type: servicetitan) {
      __typename
      isAllowed
      isLinked
      isActive
    }
    surefire: integration(type: surefire) {
      __typename
      isAllowed
      isLinked
      isActive
    }
    housecallpro: integration(type: housecallpro) {
      __typename
      isAllowed
      isLinked
      isActive
    }
    fieldpulse: integration(type: fieldpulse) {
      __typename
      isAllowed
      isLinked
      isActive
    }
    fieldroutes: integration(type: fieldroutes) {
      __typename
      isAllowed
      isLinked
      isActive
    }
    servicefusion: integration(type: servicefusion) {
      __typename
      isAllowed
      isLinked
      isActive
    }
    zapier: integration(type: zapier) {
      __typename
      isAllowed
      isLinked
      isActive
    }
    serviceminder: integration(type: serviceminder) {
      __typename
      isAllowed
      isLinked
      isActive
    }
    contractor_appointments: integration(type: contractor_appointments) {
      __typename
      isAllowed
      isLinked
      isActive
    }
    webhook: integration(type: webhook) {
      __typename
      isAllowed
      isLinked
      isActive
    }
    facebook_capi: integration(type: facebook_capi) {
      __typename
      isAllowed
      isLinked
      isActive
    }
    test: integration(type: test_cognito) {
      __typename
      isAllowed
      isLinked
      isActive
    }
    limitations {
      aiLeadTagging
      reserveWithGoogle
      captureLead
      schedule
      preferredTime
      allowedIntegrations
    }
    manualOverrideAvailableFeatures {
      aiLeadTagging
      reserveWithGoogle
      captureLead
      schedule
      preferredTime
      allowedIntegrations
    }
    referenceId {
      id
      service
    }
  }
}
    `;

export function useIntegrationStatusQuery(options: Omit<Urql.UseQueryArgs<IntegrationStatusQueryVariables>, 'query'>) {
  return Urql.useQuery<IntegrationStatusQuery, IntegrationStatusQueryVariables>({ query: IntegrationStatusDocument, ...options });
};
export const CreateIntentDocument = gql`
    mutation createIntent($appId: ID!, $intent: AddIntentInput!) {
  addIntent(appId: $appId, intent: $intent) {
    appId
    intentId
    name
    organizationId
  }
}
    `;

export function useCreateIntentMutation() {
  return Urql.useMutation<CreateIntentMutation, CreateIntentMutationVariables>(CreateIntentDocument);
};
export const UpdateIntentDocument = gql`
    mutation updateIntent($appId: ID!, $intentId: ID!, $intent: UpdateIntentInput!) {
  updateIntent(appId: $appId, intentId: $intentId, intent: $intent) {
    __typename
    appId
    intentId
    organizationId
    createdAt
    name
    langCode
    utterancePatterns
    dialogflowId
    defaultLocale
    permissions
    slotTypes
    slots {
      __typename
      name
      type
      inputText
      isList
      nlu
    }
    validation {
      isValid
      errors {
        errorMessage
        propertyName
      }
    }
    contexts {
      name
    }
  }
}
    `;

export function useUpdateIntentMutation() {
  return Urql.useMutation<UpdateIntentMutation, UpdateIntentMutationVariables>(UpdateIntentDocument);
};
export const DeleteIntentDocument = gql`
    mutation deleteIntent($appId: ID!, $intentId: ID!) {
  deleteIntent(appId: $appId, intentId: $intentId) {
    appId
    intentId
  }
}
    `;

export function useDeleteIntentMutation() {
  return Urql.useMutation<DeleteIntentMutation, DeleteIntentMutationVariables>(DeleteIntentDocument);
};
export const ChangeIntentToHandlerDocument = gql`
    mutation changeIntentToHandler($appId: ID!, $intentId: ID!) {
  changeIntentToHandler(
    appId: $appId
    intentId: $intentId
    handlerProps: {type: "ConversationHandler"}
  ) {
    type
    __typename
    intentId
  }
}
    `;

export function useChangeIntentToHandlerMutation() {
  return Urql.useMutation<ChangeIntentToHandlerMutation, ChangeIntentToHandlerMutationVariables>(ChangeIntentToHandlerDocument);
};
export const GetIntentsListDocument = gql`
    query getIntentsList($appId: ID!, $withIdOrName: String) {
  app(appId: $appId) {
    __typename
    appId
    intents(size: 100, withIdOrName: $withIdOrName) {
      total
      intents {
        __typename
        appId
        intentId
        organizationId
        name
        langCode
        slots {
          __typename
          name
          type
          inputText
          isList
        }
      }
    }
  }
}
    `;

export function useGetIntentsListQuery(options: Omit<Urql.UseQueryArgs<GetIntentsListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetIntentsListQuery, GetIntentsListQueryVariables>({ query: GetIntentsListDocument, ...options });
};
export const GetIntentDocument = gql`
    query getIntent($appId: ID!, $intentId: ID!) {
  intent(appId: $appId, intentId: $intentId) {
    __typename
    appId
    intentId
    organizationId
    nlu
    createdAt
    updatedAt
    name
    langCode
    utterancePatterns
    dialogflowId
    defaultLocale
    permissions
    slotTypes
    slots {
      __typename
      name
      type
      inputText
      isList
      nlu
    }
    validation {
      isValid
      errors {
        errorMessage
        propertyName
      }
    }
    contexts {
      name
    }
  }
  handler(appId: $appId, intentId: $intentId) {
    __typename
    name
    appId
    intentId
    type
  }
  app(appId: $appId) {
    appId
    __typename
    entities(size: 100) {
      __typename
      total
      entities {
        __typename
        entityId
        displayName
      }
    }
  }
}
    `;

export function useGetIntentQuery(options: Omit<Urql.UseQueryArgs<GetIntentQueryVariables>, 'query'>) {
  return Urql.useQuery<GetIntentQuery, GetIntentQueryVariables>({ query: GetIntentDocument, ...options });
};
export const GetUtteranceSuggestionsDocument = gql`
    query getUtteranceSuggestions($appId: ID!, $intentId: ID!) {
  intent(appId: $appId, intentId: $intentId) {
    __typename
    appId
    intentId
    utteranceSuggestions {
      suggestions {
        utterance
      }
    }
  }
}
    `;

export function useGetUtteranceSuggestionsQuery(options: Omit<Urql.UseQueryArgs<GetUtteranceSuggestionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUtteranceSuggestionsQuery, GetUtteranceSuggestionsQueryVariables>({ query: GetUtteranceSuggestionsDocument, ...options });
};
export const GetLeadCountByFiltersDocument = gql`
    query getLeadCountByFilters($appId: ID!, $contactTypes: [String!], $jobTypes: [String!], $serviceTypes: [String!], $urgencies: [String!], $highValueLead: Boolean) {
  dashboard(
    appId: $appId
    contactTypes: $contactTypes
    jobTypes: $jobTypes
    serviceTypes: $serviceTypes
    urgencies: $urgencies
    highValueLead: $highValueLead
  ) {
    leads {
      totalLeads
      leadsByContactType {
        key
        count
      }
      leadsByJobType {
        key
        count
      }
      leadsByServiceType {
        key
        count
      }
      leadsByUrgency {
        key
        count
      }
    }
  }
}
    `;

export function useGetLeadCountByFiltersQuery(options: Omit<Urql.UseQueryArgs<GetLeadCountByFiltersQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLeadCountByFiltersQuery, GetLeadCountByFiltersQueryVariables>({ query: GetLeadCountByFiltersDocument, ...options });
};
export const LeadsForAppDocument = gql`
    query leadsForApp($appId: ID!, $source: String, $searchText: String, $size: Int, $nextKey: String, $startDate: DateTime, $endDate: DateTime, $urgency: String, $highValueLead: Boolean, $environment: String, $referringSource: String, $contactType: String, $serviceType: String, $jobType: String) {
  app(appId: $appId) {
    organizationId
    appId
    name
    formLeads: leads(source: "form-widget") {
      total
    }
    chatLeads: leads(source: "widget") {
      total
    }
    leads(
      source: $source
      searchText: $searchText
      size: $size
      nextKey: $nextKey
      startDate: $startDate
      endDate: $endDate
      urgency: $urgency
      highValueLead: $highValueLead
      environment: $environment
      referringSource: $referringSource
      contactType: $contactType
      serviceType: $serviceType
      jobType: $jobType
    ) {
      total
      nextKey
      leads {
        id
        company
        conciseSummary
        contactType
        date
        highValueLead
        jobType
        serviceType
        source
        urgency
        lead {
          fields {
            name
            value
          }
        }
      }
    }
    leadsFilterMetadata {
      referringSources
      jobTypes
      contactTypes
      serviceTypes
      urgencies
    }
  }
}
    `;

export function useLeadsForAppQuery(options: Omit<Urql.UseQueryArgs<LeadsForAppQueryVariables>, 'query'>) {
  return Urql.useQuery<LeadsForAppQuery, LeadsForAppQueryVariables>({ query: LeadsForAppDocument, ...options });
};
export const LeadByIdDocument = gql`
    query leadById($appId: ID!, $id: ID!) {
  lead(appId: $appId, id: $id) {
    id
    analysis
    channel
    company
    conciseSummary
    contactType
    date
    environment
    formHelpType
    formMessage
    highValueLead
    jobType
    referringSource
    serviceType
    sessionId
    source
    summary
    urgency
    userId
    integrationSent {
      integrationId
      date
      refId
      wasError
      errorName
      errorMessage
      ...AuditTrailFields
    }
    emailThread {
      threadId
      customerEmail
      customerName
      messages {
        id
        role
        content
        timestamp
      }
    }
    lead {
      fields {
        name
        value
      }
      transcript {
        createdTime
        from {
          id
          email
          name
        }
        to {
          id
          email
          name
        }
        message
      }
    }
  }
}
    ${AuditTrailFieldsFragmentDoc}`;

export function useLeadByIdQuery(options: Omit<Urql.UseQueryArgs<LeadByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<LeadByIdQuery, LeadByIdQueryVariables>({ query: LeadByIdDocument, ...options });
};
export const LeadsFilterMetadataDocument = gql`
    query leadsFilterMetadata($appId: ID!) {
  app(appId: $appId) {
    leadsFilterMetadata {
      referringSources
      jobTypes
      contactTypes
      serviceTypes
      urgencies
    }
  }
}
    `;

export function useLeadsFilterMetadataQuery(options: Omit<Urql.UseQueryArgs<LeadsFilterMetadataQueryVariables>, 'query'>) {
  return Urql.useQuery<LeadsFilterMetadataQuery, LeadsFilterMetadataQueryVariables>({ query: LeadsFilterMetadataDocument, ...options });
};
export const GetCodeChallengeDocument = gql`
    mutation getCodeChallenge {
  codeChallenge {
    codeChallenge
    codeVerifier
    codeChallengeMethod
  }
}
    `;

export function useGetCodeChallengeMutation() {
  return Urql.useMutation<GetCodeChallengeMutation, GetCodeChallengeMutationVariables>(GetCodeChallengeDocument);
};
export const CreateAlertSubscriptionDocument = gql`
    mutation createAlertSubscription($input: CreateAlertSubscriptionInput!) {
  createAlertSubscription(input: $input) {
    subscriptionId
    alertType
    appIds
    channel
    enabled
    filters {
      contactType
      highValueLead
      jobType
      urgency
      serviceType
    }
  }
}
    `;

export function useCreateAlertSubscriptionMutation() {
  return Urql.useMutation<CreateAlertSubscriptionMutation, CreateAlertSubscriptionMutationVariables>(CreateAlertSubscriptionDocument);
};
export const UpdateAlertSubscriptionDocument = gql`
    mutation updateAlertSubscription($subscriptionId: ID!, $input: UpdateAlertSubscriptionInput!) {
  updateAlertSubscription(subscriptionId: $subscriptionId, input: $input) {
    subscriptionId
    alertType
    appIds
    channel
    enabled
    filters {
      contactType
      highValueLead
      jobType
      urgency
      serviceType
    }
  }
}
    `;

export function useUpdateAlertSubscriptionMutation() {
  return Urql.useMutation<UpdateAlertSubscriptionMutation, UpdateAlertSubscriptionMutationVariables>(UpdateAlertSubscriptionDocument);
};
export const DeleteAlertSubscriptionDocument = gql`
    mutation deleteAlertSubscription($subscriptionId: ID!) {
  deleteAlertSubscription(subscriptionId: $subscriptionId)
}
    `;

export function useDeleteAlertSubscriptionMutation() {
  return Urql.useMutation<DeleteAlertSubscriptionMutation, DeleteAlertSubscriptionMutationVariables>(DeleteAlertSubscriptionDocument);
};
export const CreateSummarySubscriptionDocument = gql`
    mutation createSummarySubscription($input: CreateSummarySubscriptionInput!) {
  createSummarySubscription(input: $input) {
    subscriptionId
    appIds
    frequency
    grouping
    channel
    enabled
    lastSent
    nextScheduled
  }
}
    `;

export function useCreateSummarySubscriptionMutation() {
  return Urql.useMutation<CreateSummarySubscriptionMutation, CreateSummarySubscriptionMutationVariables>(CreateSummarySubscriptionDocument);
};
export const UpdateSummarySubscriptionDocument = gql`
    mutation updateSummarySubscription($subscriptionId: ID!, $input: UpdateSummarySubscriptionInput!) {
  updateSummarySubscription(subscriptionId: $subscriptionId, input: $input) {
    subscriptionId
    appIds
    frequency
    grouping
    channel
    enabled
    lastSent
    nextScheduled
  }
}
    `;

export function useUpdateSummarySubscriptionMutation() {
  return Urql.useMutation<UpdateSummarySubscriptionMutation, UpdateSummarySubscriptionMutationVariables>(UpdateSummarySubscriptionDocument);
};
export const DeleteSummarySubscriptionDocument = gql`
    mutation deleteSummarySubscription($subscriptionId: ID!) {
  deleteSummarySubscription(subscriptionId: $subscriptionId)
}
    `;

export function useDeleteSummarySubscriptionMutation() {
  return Urql.useMutation<DeleteSummarySubscriptionMutation, DeleteSummarySubscriptionMutationVariables>(DeleteSummarySubscriptionDocument);
};
export const UpdateNotificationPhoneDocument = gql`
    mutation updateNotificationPhone($phone: String) {
  updateNotificationPhone(phone: $phone) {
    userId
    phone
  }
}
    `;

export function useUpdateNotificationPhoneMutation() {
  return Urql.useMutation<UpdateNotificationPhoneMutation, UpdateNotificationPhoneMutationVariables>(UpdateNotificationPhoneDocument);
};
export const GetMyNotificationPreferencesDocument = gql`
    query getMyNotificationPreferences {
  myNotificationPreferences {
    userId
    email
    phone
    alertSubscriptions {
      subscriptionId
      alertType
      appIds
      channel
      enabled
      filters {
        contactType
        highValueLead
        jobType
        urgency
        serviceType
      }
    }
    summarySubscriptions {
      subscriptionId
      appIds
      frequency
      grouping
      channel
      enabled
      lastSent
      nextScheduled
    }
    createdAt
    updatedAt
  }
}
    `;

export function useGetMyNotificationPreferencesQuery(options?: Omit<Urql.UseQueryArgs<GetMyNotificationPreferencesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetMyNotificationPreferencesQuery, GetMyNotificationPreferencesQueryVariables>({ query: GetMyNotificationPreferencesDocument, ...options });
};
export const GetSubscribableAppsDocument = gql`
    query getSubscribableApps {
  subscribableApps {
    appId
    name
    organizationId
  }
}
    `;

export function useGetSubscribableAppsQuery(options?: Omit<Urql.UseQueryArgs<GetSubscribableAppsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSubscribableAppsQuery, GetSubscribableAppsQueryVariables>({ query: GetSubscribableAppsDocument, ...options });
};
export const StartCrawlDocument = gql`
    mutation startCrawl($appId: ID!, $url: URL!, $pattern: [String], $channelId: String!) {
  startWebsiteCrawling(
    appId: $appId
    webUrl: $url
    webUrlPatterns: $pattern
    channelId: $channelId
  )
}
    `;

export function useStartCrawlMutation() {
  return Urql.useMutation<StartCrawlMutation, StartCrawlMutationVariables>(StartCrawlDocument);
};
export const AnalyzeWebsiteDocument = gql`
    mutation analyzeWebsite($url: URL!) {
  onboarding {
    startRetrieveWebsiteDetails(webUrl: $url) {
      executionId
    }
  }
}
    `;

export function useAnalyzeWebsiteMutation() {
  return Urql.useMutation<AnalyzeWebsiteMutation, AnalyzeWebsiteMutationVariables>(AnalyzeWebsiteDocument);
};
export const CreateOrgAndAppDocument = gql`
    mutation createOrgAndApp($org: CreateOrganizationInput!, $app: AppTemplateInput) {
  createOrg(org: $org, appTemplate: $app) {
    org {
      organizationId
      name
    }
    app {
      appId
      organizationId
      name
      templateType
    }
  }
}
    `;

export function useCreateOrgAndAppMutation() {
  return Urql.useMutation<CreateOrgAndAppMutation, CreateOrgAndAppMutationVariables>(CreateOrgAndAppDocument);
};
export const CreateOrgAndAppOnboardingDocument = gql`
    mutation createOrgAndAppOnboarding($org: CreateOrganizationInput!, $app: CreateOrgCreateAppInput, $organizationId: ID) {
  org {
    add(org: $org, app: $app, organizationId: $organizationId) {
      org {
        organizationId
        name
      }
      app {
        organizationId
        appId
        name
        templateType
        website
        businessDescription
      }
    }
  }
}
    `;

export function useCreateOrgAndAppOnboardingMutation() {
  return Urql.useMutation<CreateOrgAndAppOnboardingMutation, CreateOrgAndAppOnboardingMutationVariables>(CreateOrgAndAppOnboardingDocument);
};
export const AcceptTermsDocument = gql`
    mutation acceptTerms($organizationId: ID!) {
  org {
    org(organizationId: $organizationId) {
      acceptTos {
        updatedOrg {
          acceptedTermsOfService {
            userId
          }
        }
      }
    }
  }
}
    `;

export function useAcceptTermsMutation() {
  return Urql.useMutation<AcceptTermsMutation, AcceptTermsMutationVariables>(AcceptTermsDocument);
};
export const UpdateOrgTierDocument = gql`
    mutation updateOrgTier($organizationId: ID!, $type: SubscriptionType!) {
  org {
    org(organizationId: $organizationId) {
      updateTier(type: $type)
    }
  }
}
    `;

export function useUpdateOrgTierMutation() {
  return Urql.useMutation<UpdateOrgTierMutation, UpdateOrgTierMutationVariables>(UpdateOrgTierDocument);
};
export const CreateChannelsDocument = gql`
    mutation createChannels($appId: ID!, $search: IntelligentSearchAppChannelInput!, $form: FormWidgetAppChannelInput!, $chat: ChatWidgetAppChannelInput!, $lex: LexV2ConnectAppChannelInput!) {
  app {
    update(appId: $appId) {
      channel {
        addIntelligentSearchChannel(channel: $search) {
          __typename
          id
          name
        }
        addFormWidgetChannel(channel: $form) {
          __typename
          id
          name
        }
        addChatWidgetChannel(channel: $chat) {
          __typename
          id
          name
        }
        addLexV2Channel(channel: $lex) {
          __typename
          id
          name
        }
      }
    }
  }
}
    `;

export function useCreateChannelsMutation() {
  return Urql.useMutation<CreateChannelsMutation, CreateChannelsMutationVariables>(CreateChannelsDocument);
};
export const GetAppTotalsDocument = gql`
    query getAppTotals($appId: ID!) {
  app(appId: $appId) {
    appId
    intents {
      total
    }
    handlers {
      total
    }
    entities(size: 100) {
      total
      entities {
        entityId
      }
    }
    content {
      total
    }
    faq {
      total
    }
  }
}
    `;

export function useGetAppTotalsQuery(options: Omit<Urql.UseQueryArgs<GetAppTotalsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAppTotalsQuery, GetAppTotalsQueryVariables>({ query: GetAppTotalsDocument, ...options });
};
export const GetWebsiteAnalysisDocument = gql`
    query getWebsiteAnalysis($executionId: ID!) {
  onboarding {
    webDetailsExecution(executionId: $executionId) {
      completed
      siteCrawled
      data {
        detectedTechnologies {
          installed
          technology
        }
        schema
        business {
          name
          typeRaw
          services
          category
          phoneNumbers {
            number
            purpose
          }
          address {
            region
            locality
            streetAddress
            postalCode
            formated
            country
          }
          geo {
            lat
            lon
          }
        }
        site {
          logo
          description
          primaryColor
          secondaryColor
          callsToAction {
            callToAction
            url
          }
          phoneNumbers {
            purpose
            number
          }
        }
      }
    }
  }
}
    `;

export function useGetWebsiteAnalysisQuery(options: Omit<Urql.UseQueryArgs<GetWebsiteAnalysisQueryVariables>, 'query'>) {
  return Urql.useQuery<GetWebsiteAnalysisQuery, GetWebsiteAnalysisQueryVariables>({ query: GetWebsiteAnalysisDocument, ...options });
};
export const TermsOfUseAcceptanceDocument = gql`
    query termsOfUseAcceptance($organizationId: ID!) {
  org(organizationId: $organizationId) {
    acceptedTermsOfService {
      acceptedOn
      email
      userId
      url
    }
    acceptedLatestTermsOfService
  }
}
    `;

export function useTermsOfUseAcceptanceQuery(options: Omit<Urql.UseQueryArgs<TermsOfUseAcceptanceQueryVariables>, 'query'>) {
  return Urql.useQuery<TermsOfUseAcceptanceQuery, TermsOfUseAcceptanceQueryVariables>({ query: TermsOfUseAcceptanceDocument, ...options });
};
export const OnboardingAppDocument = gql`
    query onboardingApp($appId: ID!) {
  app(appId: $appId) {
    _id
    __typename
    appId
    organizationId
    templateType
    name
    website
    websiteData {
      crawlExecutionId
      crawlDate
      cms
      callsToAction
      primaryColor
      secondaryColor
    }
    places {
      name
      placeId
      website
      phone
      formattedAddress
    }
    channels {
      id
      type
    }
    leadsContact
    leadsContactPhone
    stripeProductId
    stripeSubscriptionId
    subscriptionPaymentStatus
    businessDescription
    beta
  }
}
    `;

export function useOnboardingAppQuery(options: Omit<Urql.UseQueryArgs<OnboardingAppQueryVariables>, 'query'>) {
  return Urql.useQuery<OnboardingAppQuery, OnboardingAppQueryVariables>({ query: OnboardingAppDocument, ...options });
};
export const ProspectorBusinessDocument = gql`
    query prospectorBusiness($placeId: ID, $businessId: ID) {
  public {
    business(placeId: $placeId, businessId: $businessId) {
      business {
        businessId
        name
        phone
        websiteUrl
        city
        state
        vertical
        businessHours
        logoUrl
        reviewRating
        googlePlaceId
        primaryColor
        secondaryColor
        description
        cms
      }
      similarity {
        strategy
        values
      }
      peers {
        national {
          count
          bookOnlineRate
        }
        state {
          count
          bookOnlineRate
        }
        city {
          count
          bookOnlineRate
        }
        topBookOnlineProviders {
          name
          share
          count
        }
      }
      competitors {
        businessId
        name
        city
        state
        hasBookOnline
        bookOnlineProvider
        reviewRating
        distanceMiles
      }
    }
  }
}
    `;

export function useProspectorBusinessQuery(options?: Omit<Urql.UseQueryArgs<ProspectorBusinessQueryVariables>, 'query'>) {
  return Urql.useQuery<ProspectorBusinessQuery, ProspectorBusinessQueryVariables>({ query: ProspectorBusinessDocument, ...options });
};
export const GetOrgDashboardDocument = gql`
    query getOrgDashboard($organizationId: ID!, $appId: ID, $startDate: DateTime, $endDate: DateTime, $source: String, $urgency: String, $highValueLead: Boolean, $environment: String, $referringSource: String, $contactType: String, $serviceType: String, $jobType: String, $businessHoursSource: BusinessHoursSource, $zipCode: String) {
  dashboard(
    organizationId: $organizationId
    appId: $appId
    startDate: $startDate
    endDate: $endDate
    source: $source
    urgency: $urgency
    highValueLead: $highValueLead
    environment: $environment
    referringSource: $referringSource
    contactType: $contactType
    serviceType: $serviceType
    jobType: $jobType
    zipCode: $zipCode
  ) {
    leads(businessHoursSource: $businessHoursSource) {
      totalLeads
      highValueLeadsPercentage
      leadsBySource {
        key
        count
        percentage
      }
      leadsByReferringSource {
        key
        count
        percentage
      }
      leadsByContactType {
        key
        count
        percentage
      }
      leadsByServiceType {
        key
        count
        percentage
      }
      leadsByJobType {
        key
        count
        percentage
      }
      leadsByUrgency {
        key
        count
        percentage
      }
      leadsByDayOfWeek {
        dayOfWeek
        dayName
        totalCount
        businessHoursCount
        nonBusinessHoursCount
        percentage
      }
      outsideBusinessHoursPercentage
      businessHoursSource
      businessHoursSummary
      topTerms(size: 20) {
        term
        count
        score
      }
      leadsByApp(limit: 10, sortBy: LEAD_COUNT) {
        appId
        name
        leadCount
        highValueLeadCount
      }
      topEngagementsByZip(limit: 10, sortBy: LEAD_COUNT) {
        zipCode
        leadCount
        highValueLeadCount
        percentage
        uniqueApps
      }
    }
  }
}
    `;

export function useGetOrgDashboardQuery(options: Omit<Urql.UseQueryArgs<GetOrgDashboardQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOrgDashboardQuery, GetOrgDashboardQueryVariables>({ query: GetOrgDashboardDocument, ...options });
};
export const AppNamesForOrgDocument = gql`
    query appNamesForOrg($organizationId: ID!) {
  org(organizationId: $organizationId) {
    apps(size: 100) {
      apps {
        appId
        name
      }
    }
  }
}
    `;

export function useAppNamesForOrgQuery(options: Omit<Urql.UseQueryArgs<AppNamesForOrgQueryVariables>, 'query'>) {
  return Urql.useQuery<AppNamesForOrgQuery, AppNamesForOrgQueryVariables>({ query: AppNamesForOrgDocument, ...options });
};
export const LeadsForOrgDocument = gql`
    query leadsForOrg($organizationId: ID!, $appId: ID, $source: String, $searchText: String, $size: Int, $nextKey: String, $startDate: DateTime, $endDate: DateTime, $urgency: String, $highValueLead: Boolean, $referringSource: String, $contactType: String, $serviceType: String, $jobType: String) {
  leads(
    organizationId: $organizationId
    appId: $appId
    source: $source
    searchText: $searchText
    size: $size
    nextKey: $nextKey
    startDate: $startDate
    endDate: $endDate
    urgency: $urgency
    highValueLead: $highValueLead
    referringSource: $referringSource
    contactType: $contactType
    serviceType: $serviceType
    jobType: $jobType
  ) {
    total
    nextKey
    leads {
      id
      appId
      company
      conciseSummary
      contactType
      date
      highValueLead
      jobType
      serviceType
      source
      urgency
      lead {
        fields {
          name
          value
        }
      }
    }
  }
}
    `;

export function useLeadsForOrgQuery(options: Omit<Urql.UseQueryArgs<LeadsForOrgQueryVariables>, 'query'>) {
  return Urql.useQuery<LeadsForOrgQuery, LeadsForOrgQueryVariables>({ query: LeadsForOrgDocument, ...options });
};
export const LeadByIdOnlyDocument = gql`
    query leadByIdOnly($id: ID!) {
  lead(id: $id) {
    id
    appId
    analysis
    channel
    company
    conciseSummary
    contactType
    date
    environment
    formHelpType
    formMessage
    highValueLead
    jobType
    referringSource
    serviceType
    sessionId
    source
    summary
    urgency
    userId
    integrationSent {
      integrationId
      date
      refId
      wasError
      errorName
      errorMessage
      ...OrgLeadAuditTrailFields
    }
    emailThread {
      threadId
      customerEmail
      customerName
      messages {
        id
        role
        content
        timestamp
      }
    }
    lead {
      fields {
        name
        value
      }
      transcript {
        createdTime
        from {
          id
          email
          name
        }
        to {
          id
          email
          name
        }
        message
      }
    }
  }
}
    ${OrgLeadAuditTrailFieldsFragmentDoc}`;

export function useLeadByIdOnlyQuery(options: Omit<Urql.UseQueryArgs<LeadByIdOnlyQueryVariables>, 'query'>) {
  return Urql.useQuery<LeadByIdOnlyQuery, LeadByIdOnlyQueryVariables>({ query: LeadByIdOnlyDocument, ...options });
};
export const GetOrgMapDocument = gql`
    query getOrgMap($organizationId: ID!, $appId: ID, $startDate: DateTime, $endDate: DateTime) {
  dashboard(
    organizationId: $organizationId
    appId: $appId
    startDate: $startDate
    endDate: $endDate
  ) {
    map {
      summary {
        totalBusinessLocations
        totalLeadsWithLocation
        totalLeads
        leadsWithLocationPercentage
        bounds {
          topLeft {
            lat
            lon
          }
          bottomRight {
            lat
            lon
          }
        }
      }
      businessLocations(limit: 100) {
        appId
        name
        location {
          lat
          lon
        }
        address
        city
        state
        zipCode
        leadCount
        highValueLeadCount
      }
      leadClusters(precision: 5, limit: 200) {
        geohash
        location {
          lat
          lon
        }
        count
        highValueCount
        bounds {
          topLeft {
            lat
            lon
          }
          bottomRight {
            lat
            lon
          }
        }
      }
    }
  }
}
    `;

export function useGetOrgMapQuery(options: Omit<Urql.UseQueryArgs<GetOrgMapQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOrgMapQuery, GetOrgMapQueryVariables>({ query: GetOrgMapDocument, ...options });
};
export const GetOrgAnalyticsDocument = gql`
    query getOrgAnalytics($orgId: ID!, $startDate: DateTime!, $endDate: DateTime!) {
  org(organizationId: $orgId) {
    _id
    __typename
    organizationId
    name
    analytics {
      user(start: $startDate, end: $endDate) {
        organizationId
        newUsers
        returningUsers
        totalSessions
        totalUsers
        intervals {
          isoDate
          interval
          newUsers
          returningUsers
        }
      }
    }
  }
}
    `;

export function useGetOrgAnalyticsQuery(options: Omit<Urql.UseQueryArgs<GetOrgAnalyticsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOrgAnalyticsQuery, GetOrgAnalyticsQueryVariables>({ query: GetOrgAnalyticsDocument, ...options });
};
export const UpdateOrganizationDocument = gql`
    mutation updateOrganization($orgId: ID!, $org: UpdateOrganizationInput!) {
  updateOrg(organizationId: $orgId, org: $org) {
    _id
    __typename
    organizationId
    name
  }
}
    `;

export function useUpdateOrganizationMutation() {
  return Urql.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(UpdateOrganizationDocument);
};
export const DeleteOrgDocument = gql`
    mutation deleteOrg($organizationId: ID!) {
  org {
    org(organizationId: $organizationId) {
      delete
    }
  }
}
    `;

export function useDeleteOrgMutation() {
  return Urql.useMutation<DeleteOrgMutation, DeleteOrgMutationVariables>(DeleteOrgDocument);
};
export const UpdateOrgDocument = gql`
    mutation updateOrg($organizationId: ID!, $org: UpdateOrganizationInput!) {
  org {
    org(organizationId: $organizationId) {
      update(org: $org) {
        name
        logoUrl
      }
    }
  }
}
    `;

export function useUpdateOrgMutation() {
  return Urql.useMutation<UpdateOrgMutation, UpdateOrgMutationVariables>(UpdateOrgDocument);
};
export const SetUserAppAccessDocument = gql`
    mutation SetUserAppAccess($organizationId: ID!, $userId: ID!, $appIds: [ID!]!) {
  org {
    org(organizationId: $organizationId) {
      members {
        setUserAppAccess(userId: $userId, appIds: $appIds) {
          userId
          email
          policy {
            appIds
          }
        }
      }
    }
  }
}
    `;

export function useSetUserAppAccessMutation() {
  return Urql.useMutation<SetUserAppAccessMutation, SetUserAppAccessMutationVariables>(SetUserAppAccessDocument);
};
export const SetInviteAppAccessDocument = gql`
    mutation SetInviteAppAccess($organizationId: ID!, $invitationId: ID!, $email: String!, $appIds: [ID!]!) {
  org {
    org(organizationId: $organizationId) {
      members {
        setInviteAppAccess(invitationId: $invitationId, email: $email, appIds: $appIds) {
          email
          invitationId
        }
      }
    }
  }
}
    `;

export function useSetInviteAppAccessMutation() {
  return Urql.useMutation<SetInviteAppAccessMutation, SetInviteAppAccessMutationVariables>(SetInviteAppAccessDocument);
};
export const GetOrgMembersWithAppIdsDocument = gql`
    query GetOrgMembersWithAppIds($organizationId: ID!) {
  org(organizationId: $organizationId) {
    members {
      members {
        userId
        email
        policy {
          appIds
        }
      }
    }
  }
}
    `;

export function useGetOrgMembersWithAppIdsQuery(options: Omit<Urql.UseQueryArgs<GetOrgMembersWithAppIdsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOrgMembersWithAppIdsQuery, GetOrgMembersWithAppIdsQueryVariables>({ query: GetOrgMembersWithAppIdsDocument, ...options });
};
export const UpdatePartnerBrandingDocument = gql`
    mutation updatePartnerBranding($organizationId: ID!, $org: UpdateOrganizationInput!) {
  org {
    org(organizationId: $organizationId) {
      update(org: $org) {
        organizationId
        partnerBranding {
          enabled
          logoUrl
          primaryColor
          backgroundColor
          companyName
          websiteUrl
          senderEmail
        }
      }
    }
  }
}
    `;

export function useUpdatePartnerBrandingMutation() {
  return Urql.useMutation<UpdatePartnerBrandingMutation, UpdatePartnerBrandingMutationVariables>(UpdatePartnerBrandingDocument);
};
export const SendEmailVerificationDocument = gql`
    mutation sendEmailVerification($organizationId: ID!, $email: String!) {
  org {
    org(organizationId: $organizationId) {
      partnerVerification {
        sendEmailVerification(email: $email) {
          email
          status
          requestedAt
        }
      }
    }
  }
}
    `;

export function useSendEmailVerificationMutation() {
  return Urql.useMutation<SendEmailVerificationMutation, SendEmailVerificationMutationVariables>(SendEmailVerificationDocument);
};
export const StartDomainVerificationDocument = gql`
    mutation startDomainVerification($organizationId: ID!, $domain: String!) {
  org {
    org(organizationId: $organizationId) {
      partnerVerification {
        startDomainVerification(domain: $domain) {
          domain
          status
          requestedAt
          dnsRecords {
            type
            name
            value
          }
        }
      }
    }
  }
}
    `;

export function useStartDomainVerificationMutation() {
  return Urql.useMutation<StartDomainVerificationMutation, StartDomainVerificationMutationVariables>(StartDomainVerificationDocument);
};
export const CheckVerificationStatusDocument = gql`
    mutation checkVerificationStatus($organizationId: ID!) {
  org {
    org(organizationId: $organizationId) {
      partnerVerification {
        checkVerificationStatus {
          email {
            email
            status
            verifiedAt
          }
          domain {
            domain
            status
            verifiedAt
          }
        }
      }
    }
  }
}
    `;

export function useCheckVerificationStatusMutation() {
  return Urql.useMutation<CheckVerificationStatusMutation, CheckVerificationStatusMutationVariables>(CheckVerificationStatusDocument);
};
export const ResetEmailVerificationDocument = gql`
    mutation resetEmailVerification($organizationId: ID!) {
  org {
    org(organizationId: $organizationId) {
      partnerVerification {
        resetEmailVerification
      }
    }
  }
}
    `;

export function useResetEmailVerificationMutation() {
  return Urql.useMutation<ResetEmailVerificationMutation, ResetEmailVerificationMutationVariables>(ResetEmailVerificationDocument);
};
export const ResetDomainVerificationDocument = gql`
    mutation resetDomainVerification($organizationId: ID!) {
  org {
    org(organizationId: $organizationId) {
      partnerVerification {
        resetDomainVerification
      }
    }
  }
}
    `;

export function useResetDomainVerificationMutation() {
  return Urql.useMutation<ResetDomainVerificationMutation, ResetDomainVerificationMutationVariables>(ResetDomainVerificationDocument);
};
export const GetOrgBrandingDocument = gql`
    query getOrgBranding($organizationId: ID!) {
  org(organizationId: $organizationId) {
    _id
    __typename
    organizationId
    name
    description
    type
    usage {
      testsExecuted
      uniqueSessions
    }
    partnerBranding {
      enabled
      logoUrl
      primaryColor
      backgroundColor
      companyName
      websiteUrl
      senderEmail
      emailVerification {
        email
        status
        requestedAt
        verifiedAt
      }
      domainVerification {
        domain
        status
        requestedAt
        verifiedAt
        dnsRecords {
          type
          name
          value
        }
      }
    }
  }
}
    `;

export function useGetOrgBrandingQuery(options: Omit<Urql.UseQueryArgs<GetOrgBrandingQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOrgBrandingQuery, GetOrgBrandingQueryVariables>({ query: GetOrgBrandingDocument, ...options });
};
export const PushAlexaModelDocument = gql`
    mutation pushAlexaModel($appId: ID!, $channelId: ID) {
  createInteractionModel(appId: $appId, channelId: $channelId) {
    locale
    interactionModel {
      languageModel {
        invocationName
        intents {
          name
          slots {
            name
            type
            samples
          }
          samples
        }
        types {
          name
          values {
            id
            name {
              value
              synonyms
            }
          }
        }
      }
    }
  }
}
    `;

export function usePushAlexaModelMutation() {
  return Urql.useMutation<PushAlexaModelMutation, PushAlexaModelMutationVariables>(PushAlexaModelDocument);
};
export const PushDialogflowModelDocument = gql`
    mutation pushDialogflowModel($appId: ID!, $channelId: ID) {
  updateDialogflowAgent(appId: $appId, channelId: $channelId)
}
    `;

export function usePushDialogflowModelMutation() {
  return Urql.useMutation<PushDialogflowModelMutation, PushDialogflowModelMutationVariables>(PushDialogflowModelDocument);
};
export const PushLexModelDocument = gql`
    mutation pushLexModel($appId: ID!, $channelId: ID) {
  pushLex(appId: $appId, channelId: $channelId)
}
    `;

export function usePushLexModelMutation() {
  return Urql.useMutation<PushLexModelMutation, PushLexModelMutationVariables>(PushLexModelDocument);
};
export const GetChannelsForModelDocument = gql`
    query getChannelsForModel($appId: ID!) {
  app(appId: $appId) {
    __typename
    appId
    channels {
      id
      useNLU
      __typename
      ... on AlexaAppChannel {
        vendorId
        hasCredentials
        skillId
        isBuilding
      }
      ... on DialogflowAppChannel {
        hasCredentials
        isBuilding
      }
      ... on LexConnectAppChannel {
        voiceId
        nluIntentConfidenceThreshold
        idleSessionTTLInSeconds
        detectSentiment
        isLinkedToKendra
        lexPostTextUrl
        enableModelImprovements
        botName
      }
      ... on LexV2ConnectAppChannel {
        __typename
        id
        isLinkedToKendra
        lexPostTextUrl
        botId
        botName
        managementRole
        managementRoleExternalId
      }
    }
  }
}
    `;

export function useGetChannelsForModelQuery(options: Omit<Urql.UseQueryArgs<GetChannelsForModelQueryVariables>, 'query'>) {
  return Urql.useQuery<GetChannelsForModelQuery, GetChannelsForModelQueryVariables>({ query: GetChannelsForModelDocument, ...options });
};
export const UpdateAvailabilityDocument = gql`
    mutation updateAvailability($appId: ID!, $app: UpdateAppInput!, $handlerId: ID!, $handler: UpdateHandlerInput!) {
  updateHandler(appId: $appId, handlerId: $handlerId, handler: $handler) {
    ...HandlerParts
  }
  app {
    update(appId: $appId) {
      updateApp(app: $app) {
        name
        appId
        availability {
          availableDays
          blockedDays {
            time
            date
            tz
          }
          maxTotalDailyAppointments
          delayedJobTypes
          availabilityClasses {
            id
            name
            summary
            numberOfDaysOut
            appointmentsPerDay
            leadOnly
          }
          defaultAvailabilityClass
          defaultBusyDays {
            blockCurrentDay
            blockNextBusinessDays
            blockWeekends
            currentDayAvailableUntil
            availableDays
          }
        }
      }
    }
  }
}
    ${HandlerPartsFragmentDoc}`;

export function useUpdateAvailabilityMutation() {
  return Urql.useMutation<UpdateAvailabilityMutation, UpdateAvailabilityMutationVariables>(UpdateAvailabilityDocument);
};
export const UpdateAppReferenceIdDocument = gql`
    mutation updateAppReferenceId($appId: ID!, $referenceId: AppReferenceIdInput) {
  app {
    update(appId: $appId) {
      updateApp(app: {referenceId: $referenceId}) {
        appId
        referenceId {
          id
          service
        }
      }
    }
  }
}
    `;

export function useUpdateAppReferenceIdMutation() {
  return Urql.useMutation<UpdateAppReferenceIdMutation, UpdateAppReferenceIdMutationVariables>(UpdateAppReferenceIdDocument);
};
export const UpdateChatWidgetChannelDocument = gql`
    mutation updateChatWidgetChannel($appId: ID!, $channel: ChatWidgetAppChannelInput!) {
  addChatWidgetChannel(appId: $appId, channel: $channel) {
    id
    type
    avatarUrl
    autoOpenOnWidth
    chatButton {
      imageUrl
    }
    cta {
      message
    }
    theme {
      primaryColor
    }
    urls {
      defaultBehavior {
        type
      }
    }
  }
}
    `;

export function useUpdateChatWidgetChannelMutation() {
  return Urql.useMutation<UpdateChatWidgetChannelMutation, UpdateChatWidgetChannelMutationVariables>(UpdateChatWidgetChannelDocument);
};
export const UpdateChatSettingsDocument = gql`
    mutation updateChatSettings($appId: ID!, $handlerId: ID!, $handler: UpdateHandlerInput!, $channel: ChatWidgetAppChannelInput!) {
  updateHandler(appId: $appId, handlerId: $handlerId, handler: $handler) {
    intentId
    name
    content {
      key
      handlerResponse {
        name
        tag
        segments {
          key
          segments {
            segment {
              displayText
            }
          }
        }
        displays {
          type
          token
          title
          ... on ListDisplay {
            items {
              token
              url
              title
              description
              image {
                url
              }
            }
          }
        }
        outputSpeech {
          displayText
          suggestions {
            ... on SuggestionObject {
              title
            }
          }
        }
      }
    }
  }
  addChatWidgetChannel(appId: $appId, channel: $channel) {
    id
    type
    avatarUrl
    autoOpenOnWidth
    chatButton {
      imageUrl
    }
    cta {
      message
    }
    theme {
      primaryColor
    }
    urls {
      defaultBehavior {
        type
      }
    }
  }
}
    `;

export function useUpdateChatSettingsMutation() {
  return Urql.useMutation<UpdateChatSettingsMutation, UpdateChatSettingsMutationVariables>(UpdateChatSettingsDocument);
};
export const GetAppSimpleSettingsDocument = gql`
    query getAppSimpleSettings($organizationId: ID!, $appId: ID!) {
  profile {
    __typename
    _id
    userId
    fullName
    email
  }
  org(organizationId: $organizationId) {
    __typename
    _id
    organizationId
    type
  }
  app(appId: $appId) {
    __typename
    appId
    organizationId
    stripeProductId
    stripeSubscriptionId
    subscriptionPaymentStatus
    templateType
    icon
    name
    beta
    website
    leadsContact
    leadsContactPhone
    canCaptureLeads
    businessDescription
    businessHighValueLeadDescription
    status {
      type
      email
      notes
    }
    content(size: 1) {
      total
      content {
        lastUpdated
        url
      }
    }
    contentSources(size: 1) {
      sources {
        webUrl
        webUrlPatterns
      }
      lastCrawl {
        started
        ended
        errors {
          detail
          executionId
        }
        documents {
          url
          lastUpdated
        }
      }
    }
    contentErrors(size: 3) {
      total
      errors {
        name
        url
      }
    }
    referenceId {
      id
      service
    }
    channels {
      __typename
      type
      id
      type
      name
      ... on AlexaAppChannel {
        vendorId
        invocationName
      }
      ... on LexConnectAppChannel {
        isLinkedToKendra
        lexPostTextUrl
      }
      ... on LexV2ConnectAppChannel {
        botName
        isLinkedToKendra
        lexPostTextUrl
      }
      ... on ChatWidgetAppChannel {
        key
        theme {
          primaryColor
        }
      }
      ... on IntelligentSearchAppChannel {
        key
        theme {
          accentColor
        }
      }
      ... on FormWidgetAppChannel {
        id
        key
        theme {
          accentColor
        }
      }
    }
  }
  launchReqest: handler(appId: $appId, intentId: "LaunchRequest") {
    appId
    intentId
    name
    data
    content {
      handlerResponse {
        ...HandlerResponse
      }
    }
  }
  leadGeneration: handler(appId: $appId, intentId: "LeadGeneration") {
    appId
    intentId
    name
    data
    content {
      handlerResponse {
        ...HandlerResponse
      }
    }
  }
}
    ${HandlerResponseFragmentDoc}`;

export function useGetAppSimpleSettingsQuery(options: Omit<Urql.UseQueryArgs<GetAppSimpleSettingsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAppSimpleSettingsQuery, GetAppSimpleSettingsQueryVariables>({ query: GetAppSimpleSettingsDocument, ...options });
};
export const GetAppChannelsThemeDataDocument = gql`
    query getAppChannelsThemeData($appId: ID!) {
  app(appId: $appId) {
    __typename
    appId
    organizationId
    beta
    icon
    channels {
      __typename
      type
      name
      id
      status {
        type
        email
        timestamp
      }
      ... on ChatWidgetAppChannel {
        cta {
          message
          timeout
          delay
          animation
          animationTimeout
          mobile {
            applyAtLessThanWidth
            message
            timeout
            delay
            animation
            animationTimeout
          }
        }
        name
        disabled
        botName
        avatarUrl
        key
        theme {
          primaryColor
        }
      }
      ... on IntelligentSearchAppChannel {
        type
        name
        key
        theme {
          accentColor
        }
      }
      ... on FormWidgetAppChannel {
        type
        name
        id
        key
        autoGreeting
        intentId
        sideButtonLabel
        directoryListing
        useNLU
        businessName
        businessLogoUrl
        businessAddress
        businessWebsite
        chatWidgetKey
        theme {
          accentColor
          backgroundColor
          headerBackgroundColor
          headerTextColor
          primaryButtonColor
          primaryButtonTextColor
          secondaryButtonColor
          secondaryButtonTextColor
          standAlone {
            backgroundColor
            header {
              backgroundColor
              color
              fontSize
            }
          }
          data
        }
      }
      ... on AppChannel {
        id
        type
      }
    }
  }
}
    `;

export function useGetAppChannelsThemeDataQuery(options: Omit<Urql.UseQueryArgs<GetAppChannelsThemeDataQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAppChannelsThemeDataQuery, GetAppChannelsThemeDataQueryVariables>({ query: GetAppChannelsThemeDataDocument, ...options });
};
export const GetBookingPageSettingsDocument = gql`
    query getBookingPageSettings($appId: ID!) {
  app(appId: $appId) {
    __typename
    _id
    appId
    organizationId
    name
    website
    icon
    places {
      __typename
      adminVerified
      bookingOptOut
      default
      formattedAddress
      name
      phone
      placeId
      website
      addressComponents {
        longName
        shortName
        types
      }
    }
    channels {
      __typename
      id
      type
      ... on ChatWidgetAppChannel {
        key
        disabled
        name
      }
      ... on FormWidgetAppChannel {
        name
        key
        businessName
        businessLogoUrl
        businessAddress
        businessWebsite
        autoGreeting
        chatWidgetKey
        theme {
          accentColor
          standAlone {
            backgroundColor
            header {
              color
              backgroundColor
              fontSize
            }
          }
        }
      }
    }
  }
}
    `;

export function useGetBookingPageSettingsQuery(options: Omit<Urql.UseQueryArgs<GetBookingPageSettingsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetBookingPageSettingsQuery, GetBookingPageSettingsQueryVariables>({ query: GetBookingPageSettingsDocument, ...options });
};
export const GetAvailabilityPageSettingsDocument = gql`
    query getAvailabilityPageSettings($appId: ID!) {
  app(appId: $appId) {
    __typename
    _id
    appId
    organizationId
    name
    website
    icon
    places {
      __typename
      name
      placeId
      formattedAddress
      default
      website
      phone
      adminVerified
      bookingOptOut
      addressComponents {
        longName
        shortName
        types
      }
    }
    availability {
      availableDays
      blockedDays {
        time
        date
        tz
      }
      maxTotalDailyAppointments
      delayedJobTypes
      availabilityClasses {
        id
        name
        summary
        numberOfDaysOut
        appointmentsPerDay
        leadOnly
      }
      defaultAvailabilityClass
      defaultBusyDays {
        blockCurrentDay
        blockNextBusinessDays
        blockWeekends
        currentDayAvailableUntil
        availableDays
      }
    }
    channels {
      __typename
      id
      type
      ... on ChatWidgetAppChannel {
        key
        disabled
        name
      }
      ... on FormWidgetAppChannel {
        name
        key
        businessName
        businessLogoUrl
        businessAddress
        businessWebsite
        chatWidgetKey
        autoGreeting
        intentId
        theme {
          accentColor
          standAlone {
            backgroundColor
            header {
              color
              backgroundColor
              fontSize
            }
          }
        }
      }
    }
  }
}
    `;

export function useGetAvailabilityPageSettingsQuery(options: Omit<Urql.UseQueryArgs<GetAvailabilityPageSettingsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAvailabilityPageSettingsQuery, GetAvailabilityPageSettingsQueryVariables>({ query: GetAvailabilityPageSettingsDocument, ...options });
};
export const GetAiSettingsDocument = gql`
    query getAISettings($appId: ID!) {
  app(appId: $appId) {
    __typename
    _id
    appId
    organizationId
    name
    businessDescription
    businessHighValueLeadDescription
    canCaptureLeads
    templateType
    places {
      __typename
      placeId
      name
      formattedAddress
    }
  }
}
    `;

export function useGetAiSettingsQuery(options: Omit<Urql.UseQueryArgs<GetAiSettingsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAiSettingsQuery, GetAiSettingsQueryVariables>({ query: GetAiSettingsDocument, ...options });
};
export const GetChatSettingsDocument = gql`
    query getChatSettings($appId: ID!) {
  app(appId: $appId) {
    __typename
    _id
    appId
    organizationId
    name
    icon
    website
    channels {
      __typename
      type
      id
      ... on FormWidgetAppChannel {
        id
        key
        name
        intentId
        autoGreeting
      }
      ... on ChatWidgetAppChannel {
        id
        key
        botName
        avatarUrl
        autoOpenOnWidth
        cta {
          message
          timeout
          delay
          animation
          animationTimeout
        }
        urls {
          policies {
            pattern
            behavior {
              type
              ... on ChatWidgetAppChannelUrlBehaviorNewWindow {
                width
                height
              }
            }
          }
          defaultBehavior {
            type
            ... on ChatWidgetAppChannelUrlBehaviorNewWindow {
              width
              height
            }
          }
        }
        chatButton {
          imageUrl
        }
        actionBar {
          enabled
          position
          mobileBreakpoint
          buttons {
            ... on ActionBarChatButton {
              id
              type
              label
              icon
              iconUrl
              visibility
              tabIndex
            }
            ... on ActionBarEmailButton {
              id
              type
              label
              icon
              iconUrl
              visibility
              tabIndex
              emailAddress
              subject
              body
            }
            ... on ActionBarPhoneButton {
              id
              type
              label
              icon
              iconUrl
              visibility
              tabIndex
              phoneNumber
            }
            ... on ActionBarUrlButton {
              id
              type
              label
              icon
              iconUrl
              visibility
              tabIndex
              url
              target
            }
            ... on ActionBarHelpButton {
              id
              type
              label
              icon
              iconUrl
              visibility
              tabIndex
              url
              target
            }
            ... on ActionBarPaymentButton {
              id
              type
              label
              icon
              iconUrl
              visibility
              tabIndex
              url
              target
            }
            ... on ActionBarFormButton {
              id
              type
              label
              icon
              iconUrl
              visibility
              tabIndex
              intentId
              autoGreeting
              preselectChipLabel
            }
            ... on ActionBarScheduleButton {
              id
              type
              label
              icon
              iconUrl
              visibility
              tabIndex
              intentId
              autoGreeting
              preselectChipLabel
            }
          }
        }
        header {
          status {
            online
            offline
            away
            connecting
          }
          subtitle {
            enabled
            text
          }
          alignTextCenter
        }
        footer {
          branding {
            enabled
            text
          }
        }
        theme {
          primaryColor
          border {
            color
            width
            radius
          }
          chatButton {
            background
          }
          content {
            background
          }
          cta {
            background
            text {
              color
              fontFamily
              fontSize
            }
          }
          header {
            background
            avatarBackground
            text {
              color
              fontFamily
              fontSize
            }
            subtitle {
              color
              fontFamily
              fontSize
            }
          }
          messages {
            mine {
              bubbleColor
              text {
                color
                fontSize
                fontFamily
              }
            }
            others {
              bubbleColor
              text {
                color
                fontSize
                fontFamily
              }
            }
          }
          size {
            width
            height
          }
        }
      }
    }
  }
  launchRequest: handler(appId: $appId, intentId: "LaunchRequest") {
    __typename
    appId
    intentId
    organizationId
    name
    content {
      __typename
      key
      handlerResponse {
        __typename
        name
        tag
        conditions
        segments {
          key
          segments {
            segment {
              displayText
              ssml
            }
          }
        }
        displays {
          __typename
          type
          token
          title
          ... on ListDisplay {
            items {
              token
              url
              title
              description
              hideUrl
              image {
                url
              }
            }
          }
        }
        outputSpeech {
          displayText
          suggestions {
            __typename
            ... on SuggestionObject {
              title
            }
            ... on LinkOutSuggestion {
              title
              url
            }
          }
        }
      }
    }
  }
}
    `;

export function useGetChatSettingsQuery(options: Omit<Urql.UseQueryArgs<GetChatSettingsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetChatSettingsQuery, GetChatSettingsQueryVariables>({ query: GetChatSettingsDocument, ...options });
};
export const GetEventsDocument = gql`
    query getEvents($appId: ID!, $rawQueryText: String, $from: Int, $size: Int, $startDate: DateTime, $endDate: DateTime, $byFlag: [RawQueryEventFlag], $byTag: [String], $byName: [String], $noFlag: Boolean) {
  app(appId: $appId) {
    __typename
    appId
    events(
      rawQueryText: $rawQueryText
      from: $from
      size: $size
      startDate: $startDate
      endDate: $endDate
      byFlag: $byFlag
      byName: $byName
      noFlag: $noFlag
      byTag: $byTag
    ) {
      __typename
      total
      events {
        __typename
        currentHandler
        channel
        environment
        eventId
        eventIndex
        eventTime
        eventType
        eventName
        errorCode
        errorMessage
        request
        rawQuery
        platform
        selectedHandler
        sessionId
        stentorRequest {
          platform
          type
          anonymous
          channel
          intentId
          isHealthCheck
          isNewSession
          rawQuery
          sessionAttributes {
            channel
            userId
            sessionId
          }
          matchConfidence
          sessionId
          userId
          locale
        }
        response {
          outputSpeech {
            displayText
            ssml
            suggestions {
              title
              url
            }
          }
          reprompt {
            displayText
            ssml
            suggestions {
              title
              url
            }
          }
          displays
        }
        flags {
          __typename
          flag
          flaggedOn
          note
          userEmail
        }
        slots {
          __typename
          name
          rawValue
          stringValue
          dateValue
          startDateValue
          endDateValue
          booleanValue
          integerValue
          stringArrayValue
          slotValue
        }
      }
      flagTotals {
        OPTIMAL
        CORRECT
        NEEDS_HUMAN
        INCORRECT
        CONFIRMED_CORRECT
        HELPFUL
        FLAGGED
      }
    }
    organizationId
  }
}
    `;

export function useGetEventsQuery(options: Omit<Urql.UseQueryArgs<GetEventsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetEventsQuery, GetEventsQueryVariables>({ query: GetEventsDocument, ...options });
};
export const CancelDocument = gql`
    mutation cancel($appId: ID!) {
  app {
    update(appId: $appId) {
      subscriptions {
        update {
          cancel {
            appId
          }
        }
      }
    }
  }
}
    `;

export function useCancelMutation() {
  return Urql.useMutation<CancelMutation, CancelMutationVariables>(CancelDocument);
};
export const GetAppUpgradeDocument = gql`
    query getAppUpgrade($organizationId: ID!, $appId: ID!) {
  org(organizationId: $organizationId) {
    __typename
    organizationId
    type
    creationDate
    paymentAccounts {
      stripe {
        customerId
      }
      so {
        paymentType
      }
      aws {
        productCode
        dimension
        customerId
      }
    }
  }
  app(appId: $appId) {
    __typename
    appId
    organizationId
    beta
    name
    templateType
    website
    stripeProductId
    stripeSubscriptionId
    subscriptionPaymentStatus
    subscription {
      __typename
      summary {
        __typename
        lastCharge {
          amount
          currency
          date
          paid
        }
        nextCharge {
          amountDue
          currency
          date
        }
        trialEndDate
        isCancelled
        status
      }
    }
    referenceId {
      id
      service
    }
    status {
      type
      notes
    }
    limitations {
      actionBar
      advancedAnalytics
      excludedIntegrations
      maxHandlers
      maxIntents
      maxEntities
      captureLead
      schedule
      preferredTime
      aiLeadTagging
      liveTakeover
      transcriptAccess
      maxKendraDocs
      reserveWithGoogle
    }
  }
}
    `;

export function useGetAppUpgradeQuery(options: Omit<Urql.UseQueryArgs<GetAppUpgradeQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAppUpgradeQuery, GetAppUpgradeQueryVariables>({ query: GetAppUpgradeDocument, ...options });
};
export const StartTestsDocument = gql`
    mutation StartTests($appId: ID!, $testType: String!) {
  startTests(appId: $appId, testType: $testType)
}
    `;

export function useStartTestsMutation() {
  return Urql.useMutation<StartTestsMutation, StartTestsMutationVariables>(StartTestsDocument);
};
export const AddUtteranceTestDocument = gql`
    mutation AddUtteranceTest($appId: ID!, $testString: String!) {
  addUtteranceTestByString(appId: $appId, testString: $testString) {
    testId
    utterance
    createdOn
    expectedResult {
      type
      intentId
      matchedSlots {
        name
        stringValue
      }
    }
  }
}
    `;

export function useAddUtteranceTestMutation() {
  return Urql.useMutation<AddUtteranceTestMutation, AddUtteranceTestMutationVariables>(AddUtteranceTestDocument);
};
export const ReplaceUtteranceTestDocument = gql`
    mutation ReplaceUtteranceTest($appId: ID!, $testId: ID!, $createdOn: String!, $testString: String!) {
  deleteTest(testId: $testId, createdOn: $createdOn)
  addUtteranceTestByString(appId: $appId, testString: $testString) {
    testId
    utterance
    createdOn
    expectedResult {
      type
      intentId
      matchedSlots {
        name
        stringValue
      }
    }
  }
}
    `;

export function useReplaceUtteranceTestMutation() {
  return Urql.useMutation<ReplaceUtteranceTestMutation, ReplaceUtteranceTestMutationVariables>(ReplaceUtteranceTestDocument);
};
export const DeleteTestDocument = gql`
    mutation DeleteTest($testId: ID!, $createdOn: String!) {
  deleteTest(testId: $testId, createdOn: $createdOn)
}
    `;

export function useDeleteTestMutation() {
  return Urql.useMutation<DeleteTestMutation, DeleteTestMutationVariables>(DeleteTestDocument);
};
export const GetAppTestsDocument = gql`
    query GetAppTests($appId: ID!, $size: Int, $from: Int, $testType: String, $sortBy: [String]) {
  app(appId: $appId) {
    appId
    channels {
      type
      __typename
      id
    }
    organizationId
    intents(size: 50) {
      total
      intents {
        intentId
        name
        slots {
          isList
          name
          type
        }
      }
    }
  }
  tests(
    appId: $appId
    size: $size
    from: $from
    testType: $testType
    sortBy: $sortBy
  ) {
    total
    tests {
      testId
      utterance
      createdOn
      expectedResult {
        type
        intentId
        matchedSlots {
          name
          stringValue
        }
      }
    }
  }
}
    `;

export function useGetAppTestsQuery(options: Omit<Urql.UseQueryArgs<GetAppTestsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAppTestsQuery, GetAppTestsQueryVariables>({ query: GetAppTestsDocument, ...options });
};
export const GetAvailableTestTypesDocument = gql`
    query GetAvailableTestTypes {
  availableTestTypes
}
    `;

export function useGetAvailableTestTypesQuery(options?: Omit<Urql.UseQueryArgs<GetAvailableTestTypesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAvailableTestTypesQuery, GetAvailableTestTypesQueryVariables>({ query: GetAvailableTestTypesDocument, ...options });
};
export const GetEntitySuggestionsDocument = gql`
    query getEntitySuggestions($appId: String!, $text: String!) {
  entitySuggestions(appId: $appId, text: $text) {
    text
    entities {
      ner
      entityId
      end
      start
      rawValue
      value
    }
    tokens {
      id
      start
      end
      pos
      tag
      dep
      head
    }
    sentences {
      start
      end
    }
  }
}
    `;

export function useGetEntitySuggestionsQuery(options: Omit<Urql.UseQueryArgs<GetEntitySuggestionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetEntitySuggestionsQuery, GetEntitySuggestionsQueryVariables>({ query: GetEntitySuggestionsDocument, ...options });
};
export const GetOrgsDocument = gql`
    query getOrgs($size: Int!, $from: Int!, $withIdOrName: String) {
  orgs(size: $size, from: $from, withIdOrName: $withIdOrName) {
    total
    orgs {
      __typename
      name
      organizationId
      type
      logoUrl
      paymentAccounts {
        stripe {
          customerId
        }
        so {
          paymentType
        }
        aws {
          productCode
          dimension
          customerId
        }
      }
    }
  }
  profile {
    _id
    __typename
    entitlements {
      __typename
      availablePro
    }
  }
}
    `;

export function useGetOrgsQuery(options: Omit<Urql.UseQueryArgs<GetOrgsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOrgsQuery, GetOrgsQueryVariables>({ query: GetOrgsDocument, ...options });
};
export const GetOrgListItemDocument = gql`
    query getOrgListItem($orgId: ID!) {
  org(organizationId: $orgId) {
    _id
    __typename
    name
    organizationId
    logoUrl
    usage {
      testsExecuted
      uniqueSessions
    }
    apps {
      total
    }
  }
}
    `;

export function useGetOrgListItemQuery(options: Omit<Urql.UseQueryArgs<GetOrgListItemQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOrgListItemQuery, GetOrgListItemQueryVariables>({ query: GetOrgListItemDocument, ...options });
};
export const GetOrgDocument = gql`
    query getOrg($orgId: ID!) {
  org(organizationId: $orgId) {
    _id
    __typename
    organizationId
    name
    type
    beta
    description
    creationDate
    auth0GroupId
    contact
    contactName
    contactPhone
    contractDate
    logoUrl
    ipRights {
      alexa
    }
    acceptedTermsOfService {
      email
      userId
      acceptedOn
      url
    }
    acceptedLatestTermsOfService
    paymentAccounts {
      _id
      stripe {
        customerId
      }
      so {
        paymentType
        numberOfApps
        date
      }
      aws {
        customerId
        productCode
        dimension
        date
        currentUsage {
          handlers
          intents
          entities
          uniqueSessions
          testsExecuted
          docsCrawled
          totalDocs
        }
      }
    }
    notes
    website
    type
    usage {
      testsExecuted
      uniqueSessions
    }
    apps(size: 1) {
      _id
      total
      apps {
        appId
        name
      }
    }
  }
}
    `;

export function useGetOrgQuery(options: Omit<Urql.UseQueryArgs<GetOrgQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOrgQuery, GetOrgQueryVariables>({ query: GetOrgDocument, ...options });
};

export type GetFormAnalyticsQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  start: Scalars['DateTime']['input'];
  end: Scalars['DateTime']['input'];
  byHost?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetFormAnalyticsQuery = { app?: { formAnalytics?: { overall: { openSessions: number, engagedSessions: number, submitSessions: number, conversionRate: number, bounceRate: number, completionRate: number }, byHost?: Array<{ segment: string, funnel: { openSessions: number, engagedSessions: number, submitSessions: number, conversionRate: number, bounceRate: number, completionRate: number } }> | null, stepDropoff: Array<{ stepIndex: number, sessions: number }>, abandonReasons: Array<{ reason: string, sessions: number }> } | null } | null };


export const GetFormAnalyticsDocument = gql`
    query getFormAnalytics($appId: ID!, $start: DateTime!, $end: DateTime!, $byHost: Boolean) {
  app(appId: $appId) {
    formAnalytics(start: $start, end: $end, byHost: $byHost) {
      overall {
        openSessions
        engagedSessions
        submitSessions
        conversionRate
        bounceRate
        completionRate
      }
      byHost {
        segment
        funnel {
          openSessions
          engagedSessions
          submitSessions
          conversionRate
          bounceRate
          completionRate
        }
      }
      stepDropoff {
        stepIndex
        sessions
      }
      abandonReasons {
        reason
        sessions
      }
    }
  }
}
    `;

export function useGetFormAnalyticsQuery(options: Omit<Urql.UseQueryArgs<GetFormAnalyticsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetFormAnalyticsQuery, GetFormAnalyticsQueryVariables>({ query: GetFormAnalyticsDocument, ...options });
};